
  let dbar = [
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1190. هل يُسمح للمركبة العمومية السير في جميع المسالك الموسومة (المعلمة) في الطريق؟",
      numQues: "1190",
      correctAnswer: "نعم، حتى في المسالك التي لم توسم (تُعلم) كمسالك للمركبات العمومية.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "كلا، عليه السير فقط في المسلك الأيمن.",
        "كلا، فقط في الجهة اليسرى من الشارع.",
        "كلا، يُسمح له بالسير فقط في مسلك المواصلات العمومية.",
        "نعم، حتى في المسالك التي لم توسم (تُعلم) كمسالك للمركبات العمومية."
      ],
      id: 1
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1575. ما هي السرعة القصوى المسموح بها في طريق بلدية عند سياقة دراجة نارية سعة محركها لغاية 125سم3 وقوة المحرك لغاية 14.6 حصان (11 كيلو واط)، إذا لم تدل شاخصة على غير ذلك؟",
      numQues: "1575",
      correctAnswer: "60كم/ساعة.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "50كم/ساعة.",
        "30كم/ساعة.",
        "40كم/ساعة.",
        "60كم/ساعة."
      ],
      id: 2
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1477. أية إشارة تسمح بدخول الدراجة الهوائية؟",
      numQues: "1477",
      correctAnswer: "412",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31477.jpg",
      choices: [
        "414",
        "219",
        "227",
        "412"
      ],
      id: 3
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0152. ما هي السرعة القصوى المسموح بها لسياقة مركبة ركاب خصوصية (إذا لم تنصب إشارة تأمر بغير ذلك)؟",
      numQues: "0152",
      correctAnswer: "في طريق داخل المدن لغاية - 50كم/ساعة وفي طريق خارج المدن- لغاية 70كم/ساعة/ساعة.",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3139.jpg",
      choices: [
        "في طريق داخل المدن- حسب وضع المنطقة وفي طريق خارج لغاية - المدن لغاية 100كم/ساعة.",
        "في طريق داخل المدن لغاية- 40كم/ساعة وفي طريق خارج المدن- لغاية 80كم/ساعة.",
        "في طريق داخل المدن لغاية- 50كم/ساعة وفي طريق خارج المدن لغاية- لغاية 80كم/ساعة.",
        "في طريق داخل المدن لغاية - 50كم/ساعة وفي طريق خارج المدن- لغاية 70كم/ساعة/ساعة."
      ],
      id: 4
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1159. أي أنواع سفرات مسموح القيام بها في الصالون العمومي بموجب رخصة من مراقب السير على الطرق؟",
      numQues: "1159",
      correctAnswer: "سفرة بلدية وسفرة خارج المدن وسفرة 'سياحية'.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "سفرة 'خاصة'، وسفرة 'نقل أولاد' خاصة.",
        "سفرة 'خدمة' وسفرة 'خاصة' وسفرة 'سياحية'.",
        "سفرة 'سياحية' وسفرة 'عمل' وسفرة 'خدمة'.",
        "سفرة بلدية وسفرة خارج المدن وسفرة 'سياحية'."
      ],
      id: 5
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0403. أية إشارة تُنصب قبل المفترق وتُلزم بإعطاء حق الأولوية؟",
      numQues: "0403",
      correctAnswer: "308",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3403.jpg",
      choices: [
        "504",
        "310",
        "301",
        "308"
      ],
      id: 6
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0653. لا ينقل 'سائق جديد' لم يتم 21 سنة من عمره في مركبة ركاب خصوصية:",
      numQues: "0653",
      correctAnswer: "أكثر من راكب واحد إضافةً إليه، إلا إذا كان يجلس بجانبه مرافق.",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31688.jpg",
      choices: [
        "حتى ولو راكب واحد طالما هو 'سائق جديد'.",
        "أكثر من أربعة ركاب إضافةً إليه، إلا إذا كان يجلس بجانبه مرافق.",
        "أكثر من راكبين إضافةً إليه، إلا إذا كان يجلس بجانبه مرافق.",
        "أكثر من راكب واحد إضافةً إليه، إلا إذا كان يجلس بجانبه مرافق."
      ],
      id: 7
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0031. عرِّف 'خفت الأضواء' :",
      numQues: "0031",
      correctAnswer: "تبديل الضوء العالي وإضاءة ضوء الضباب.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "تغيير ارتفاع شعاع نور الوقوف.",
        "تبديل الضوء العالي في المصابيح الأمامية وإضاءة الضوء الواطئ.",
        "إطفاء الضوء الواطئ في المصابيح الأمامية وإضاءة الضوء العالي.",
        "تبديل الضوء العالي وإضاءة ضوء الضباب."
      ],
      id: 8
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0454. كيف تتصرف حسب الإشارة؟",
      numQues: "0454",
      correctAnswer: "الاقتراب من ملتقى سكة حديد حوالي 250م قبل الملتقى.",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3453.jpg",
      choices: [
        "تمهل واستعد للتوقف قبل ملتقى سكة الحديد إذا تطلب الأمر ذلك.",
        "يجب التوقف دائماً - على مسافة متر واحد قبل ملتقى سكة الحديد.",
        "تمهل وقف، سكة حديد أمامك على بعد 50م.",
        "الاقتراب من ملتقى سكة حديد حوالي 250م قبل الملتقى."
      ],
      id: 9
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0907. كيف تتعامل مع الوضع الذي أمامك؟",
      numQues: "0907",
      correctAnswer: "نبه راكب الدراجة الهوائية بواسطة الزامور إلى أن يخلي مسلك سيرك واعبر عنه بسرعتك العادية.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "تمهل وتجاوز عن راكب الدراجة الهوائية مع المحافظة على مسافة ملائمة من الجانب وتتبع تحركاته.",
        "زد من السرعة وتجاوز عن راكب الدراجة الهوائية قبل دخولك إلى المفترق.",
        "سر خلف راكب الدراجة الهوائية إلى ما بعد المفترق واستعمل الزامور واعبر عنه على وجه السرعة.",
        "نبه راكب الدراجة الهوائية بواسطة الزامور إلى أن يخلي مسلك سيرك واعبر عنه بسرعتك العادية."
      ],
      id: 10
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0205. في أية حدود من مكان عبور المشاة يُمنع إيقاف مركبة؟",
      numQues: "0205",
      correctAnswer: "على مكان عبور المشاة وفي حدود 12م بعده.",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3205.jpg",
      choices: [
        "في حدود 20م قبل وبعد مكان عبور المشاة.",
        "على مكان عبور المشاة وفي حدود 12م قبله.",
        "في حدود 12م قبل مكان عبور المشاة و 12م بعده.",
        "على مكان عبور المشاة وفي حدود 12م بعده."
      ],
      id: 11
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0874. ما هو ترتيب العمليات الصحيح عند تخفيف سرعة المركبة؟",
      numQues: "0874",
      correctAnswer: "لا توجد أهمية لترتيب العمليات أثناء تخفيف سرعة المركبة.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "الانتقال إلى غيار واطئ والضغط على دعسة الكلاتش.",
        "التمهل وتعشيق غيار واطئ.",
        "التمهل بواسطة الضغط على دعسة الكلاتش وتعشيق غيار أعلى.",
        "لا توجد أهمية لترتيب العمليات أثناء تخفيف سرعة المركبة."
      ],
      id: 12
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1624. لماذا يجب الحفاظ على مسافة من الأمام ومن الخلف ومن الجوانب عند الركوب على الدراجة النارية؟",
      numQues: "1624",
      correctAnswer: "لأن ذلك يمكن من منع تنشق الدخان والأوساخ المنفوثة من المركبات الأخرى في الطريق.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "لأننا بذلك نقلص مدى الرؤية والقدرة على استعمال حاشية الطريق. ",
        "لكي نتمكن من الانحراف من مسلك إلى آخر كثيراُ وبسهولة.",
        "لأننا بذلك نضمن زمن وحيز لرد يكفيان للأخطار والتهديدات الناتجة عن المركبات الأخرى.",
        "لأن ذلك يمكن من منع تنشق الدخان والأوساخ المنفوثة من المركبات الأخرى في الطريق."
      ],
      id: 13
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1702. في مركبة فيها جهاز فرامل سليم يشمل ABS :",
      numQues: "1702",
      correctAnswer: "الضغط بشدة على دعسة الفرامل يؤدي إلى توقف المركبة 'في المكان'.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "الضغط بشدة على دعسة الفرامل يؤدي إلى اهتزازات الدعسة وضجيج. ",
        "الضغط بشدة على دعسة الفرامل يلغي عمل ال- ABS:",
        "الضغط بشدة على دعسة الفرامل يؤدي إلى إطفاء المحرك فوراً.",
        "الضغط بشدة على دعسة الفرامل يؤدي إلى توقف المركبة 'في المكان'."
      ],
      id: 14
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1015. ما هي التأثيرات الجانبية من استعمال ماسحات زجاج غير صالحة؟",
      numQues: "1015",
      correctAnswer: "التسبب بضرر في إحكام سد الزجاج.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "المس بالرؤية عبر الزجاج الأمامي والتسبب بضرر للزجاج الأمامي.",
        "تبذير طاقة محرك المركبة عند تشغيلها.",
        "إحداث ضجة في النظام السمعي في كابينة السائق.",
        "التسبب بضرر في إحكام سد الزجاج."
      ],
      id: 15
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0920. أية عملية يمكن للسائق المقترب عملها من اجل تجنب إصابة حسب الدلائل الظاهرة في الصورة:",
      numQues: "0920",
      correctAnswer: "استعمال الزامور بشدة وبشكلٍ متواصل.",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3919.jpg",
      choices: [
        "إعطاء ضوء عالي متقطع.",
        "الاستمرار بالسير كالمعتاد، سوف يُغلق الباب حالاً.",
        "التمهل والمحافظة على مسافة جانبية ملائمة (الانحراف إلى اليسار).",
        "استعمال الزامور بشدة وبشكلٍ متواصل."
      ],
      id: 16
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0846. ما هي العوامل التي تؤثر على تزحلق المركبة؟",
      numQues: "0846",
      correctAnswer: "أي عامل يؤثر على يقظة السائق.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "وضع الرؤية في الطريق.",
        "جميع العوامل التي تمنع الاتصال المباشر بين الإطار والشارع مثل: المياه والزيوت والوحل والحصى وغير ذلك.",
        "عمر المركبة القديم.",
        "أي عامل يؤثر على يقظة السائق."
      ],
      id: 17
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0126. أكمل الجملة - عندما توجد مركبة في مسلك الاستدارة إلى اليسار فقط:",
      numQues: "0126",
      correctAnswer: "مسموح عبورها من الجهة اليمنى فقط بمركبة ركاب خصوصية.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "ممنوع عبورها من جهتها اليمنى.",
        "مسموح عبورها من جهتها اليمنى إذا كانت مركبة بطيئة فقط.",
        "مسموح عبورها من جهتها اليمنى.",
        "مسموح عبورها من الجهة اليمنى فقط بمركبة ركاب خصوصية."
      ],
      id: 18
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0092. لا تُجدد رخصة سياقة انتهى سريان مفعولها لمدة تزيد عن:",
      numQues: "0092",
      correctAnswer: "أربعة أشهر، إلا إذا اجتاز صاحبها الفحوصات والامتحانات التي تأمر بها سلطة الترخيص.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "تسعة أشهر، إلا إذا اجتاز صاحبها الفحوصات والامتحانات التي تأمر بها سلطة الترخيص.",
        "سنة واحدة، إلا إذا اجتاز صاحبها الفحوصات والامتحانات التي تأمر بها سلطة الترخيص.",
        "ستة أشهر، إلا إذا اجتاز صاحبها الفحوصات والامتحانات التي تأمر بها سلطة الترخيص.",
        "أربعة أشهر، إلا إذا اجتاز صاحبها الفحوصات والامتحانات التي تأمر بها سلطة الترخيص."
      ],
      id: 19
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0916. أية إجراءات تتخذ في الحالة التي أمامك؟",
      numQues: "0916",
      correctAnswer: "تمهل واستعد للتوقف ودع الماشي يخلي الشارع.",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3915.jpg",
      choices: [
        "تمهل واستعمل الزامور لكي يتوقف الماشي.",
        "اسرع واجتز الماشي.",
        "لا توجد ضرورة بالقيام بإجراء استثنائي لأن الماشي بعيد عنك وكل شيء على ما يرام.",
        "تمهل واستعد للتوقف ودع الماشي يخلي الشارع."
      ],
      id: 20
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1137. هل يجوز لسائق الباص التحدث مع الركاب أثناء السير؟",
      numQues: "1137",
      correctAnswer: "مسموح فقط مع بائع التذاكر أو مع مفتش التذاكر.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "ممنوع لسائق الباص التحدث مع الركاب.",
        "مسموح فقط مع أصحاب وظائف الأمن عندما يكونوا في مهمة.",
        "مسموح فقط في أمور السفرة، وبدون إدارة الرأس عن الطريق.",
        "مسموح فقط مع بائع التذاكر أو مع مفتش التذاكر."
      ],
      id: 21
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0188. كيف تتصرف إذا كنت تنوي البدء بالسير بعد التوقف أو الوقوف بجانب الطريق؟",
      numQues: "0188",
      correctAnswer: "أعطِ الإشارة إلى اليسار وسر. لأن على المركبة الأخرى إعطاؤك حق الأولوية.",
      pubDate: "10-11-2011 08:22:35",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3188.jpg",
      choices: [
        "عليك إعطاء الإشارة قبل البدء بالسير والخروج من مكانك إلى الشارع بسرعة.",
        "عليك إعطاء الإشارة باليد اليسرى والاندماج بسرعة بحركة السير المتدفقة.",
        "عليك إعطاء الإشارة والتأكد من أنك تستطيع الاندماج في حركة السير بدون التسبب في خطر أو إعاقة لعابري الطريق الآخرين.",
        "أعطِ الإشارة إلى اليسار وسر. لأن على المركبة الأخرى إعطاؤك حق الأولوية."
      ],
      id: 22
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1657. كيف يمكن تحسين الرؤية عند ركوب دراجة نارية في المطر؟",
      numQues: "1657",
      correctAnswer: "بواسطة الركوب بشكلٍ حذر واستعمال مصابيح الضباب.",
      pubDate: "10-11-2011 08:22:35",
      img: "",
      choices: [
        "بواسطة إضافة وتركيب إضاءة قوية على الدراجة النارية واستعمال الضوء العالي بشكلٍ دائم.",
        "بواسطة استعمال الواقي الأمامي الشفاف في الخوذة (ألقبعة) بدون خدوش والقيام بدهن مادة ضد البخار والرطوبة.",
        "بواسطة الركوب مع خوذة شتاء خاصة بدون واقي أمامي شفاف واستعمال نظارات واقية بشكلٍ مكثف.",
        "بواسطة الركوب بشكلٍ حذر واستعمال مصابيح الضباب."
      ],
      id: 23
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0015. في شارع باتجاهين خارج المدن وعلى جانبه الأيمن نُصبت إشارة تمنع التوقف (433):",
      numQues: "0015",
      correctAnswer: "يسري المنع الذي في الإشارة فقط على التوقف في الشارع.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3015.jpg",
      choices: [
        "حسب الإشارة ممنوع التوقف على يمين الشارع وأيضاً على الحاشية.",
        "يسري المنع فقط على التوقف على حاشية الطريق.",
        "تمنع الإشارة التوقف على جانبي الشارع. ",
        "يسري المنع الذي في الإشارة فقط على التوقف في الشارع."
      ],
      id: 24
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1511. ما هو الخطر المتوقع من سياقة مركبة شاحنة طويلة؟",
      numQues: "1511",
      correctAnswer: "عدم التمكن من تنفيذ استدارة إلى اليسار بأمان.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "تواجد مركبات صغيرة في 'المساحات الميتة' والصعوبة في الاستدارات الحادة.",
        "زمن رد الفعل عند السائق أطول.",
        "لا يوجد أي خطر معين من سياقة مركبة طويلة مقارنة بمركبة ركاب خصوصية.",
        "عدم التمكن من تنفيذ استدارة إلى اليسار بأمان."
      ],
      id: 25
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0360. إذا نُصبت في المفترق إشارة رقم: 118، فأية إشارة تُنصب من مسافةٍ معقولة عن المفترق؟",
      numQues: "0360",
      correctAnswer: "117",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3360.jpg",
      choices: [
        "208",
        "207",
        "205",
        "117"
      ],
      id: 26
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "0245. بأية مركبة يُسمح بجر مجرورة زراعية معفاة من واجب التسجيل والترخيص؟",
      numQues: "0245",
      correctAnswer: "بتراكتور.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "بمركبة تجارية يزيد وزنها الإجمالي المسموح به عن 12000كغم.",
        "بتراكتور حمولة فقط.",
        "بتراكتورون فقط.",
        "بتراكتور."
      ],
      id: 27
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1661. ما هي الفرملة الصحيحة أثناء ركوب الدراجة النارية؟",
      numQues: "1661",
      correctAnswer: "يجب تشغيل الفرملة الخلفية فقط وبالتناوب، لا يجب تشغيل الفرملة الأمامية.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "يجب تشغيل الفرملة الخلفية والتمهل بمساعدة المحرك.",
        "يجب تشغيل الفرملة الأمامية والفرملة الخلفية بالتناوب.",
        "يجب تشغيل الفرملة الأمامية والفرملة الخلفية مع بعض من اجل التمهل أو الفرملة.",
        "يجب تشغيل الفرملة الخلفية فقط وبالتناوب، لا يجب تشغيل الفرملة الأمامية."
      ],
      id: 28
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0848. ما هو الخطر الدائم المتسبب عن تزحلق المركبة أثناء السياقة؟",
      numQues: "0848",
      correctAnswer: "فقدان السيطرة على المقود وفقدان السيطرة على المركبة.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "سخونة إطارات المركبة واهترائها.",
        "توقف عمل الكلاتش والعجلات التي تحرك المركبة.",
        "سخونة فرامل المركبة واهترائها.",
        "فقدان السيطرة على المقود وفقدان السيطرة على المركبة."
      ],
      id: 29
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1104. أية ضغط (إضافي ) يزوده التراكتور يُشغل أجهزة ومعدات إضافية؟",
      numQues: "1104",
      correctAnswer: "ضغط الزيت الهيدراولي.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "ضغط الهواء المضغوط.",
        "ضغط زيت المحرك.",
        "ضغط بخار الماء.",
        "ضغط الزيت الهيدراولي."
      ],
      id: 30
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0272. في أي قسم من الشارع يجب أن يسوق راكب الدراجة الهوائية؟",
      numQues: "0272",
      correctAnswer: "في أي مكان تسير فيه المركبات الأخرى.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "قريب على قدر الإمكان من حافته اليسرى ووجهه مقابل حركة السير.",
        "لا يسوق في أي قسمٍ كان، لا يُسمح على الإطلاق بركوب الدراجة الهوائية على الشارع. ",
        "قريب على قدر الإمكان من حافته اليمنى.",
        "في أي مكان تسير فيه المركبات الأخرى."
      ],
      id: 31
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1614. أين يجب تركيز النظر عند الدخول في استدارة أثناء ركوب الدراجة النارية؟",
      numQues: "1614",
      correctAnswer: "بعيداً إلى الأمام.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "قريباً من الدراجة النارية على قدر الإمكان.",
        "بعيداً إلى الأمام والتركيز على الشاخصات (الإشارات) وعلى ما حول الاستدارة.",
        "باتجاه الاستدارة وباتجاه الخروج منها.",
        "بعيداً إلى الأمام."
      ],
      id: 32
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1452. أية مركبة تُعتبر 'مركبة تجارية'؟",
      numQues: "1452",
      correctAnswer: "كل مركبة ليست مركبة خصوصية أو مركبة ركاب.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "المركبة المستعملة أو المعدة للاستعمال في نقل البضائع بأجرة أو لعمل وتجارة صاحب المركبة.",
        "كل مركبة مستعملة لإعالة صاحبها أو لإعالة من يسوقها.",
        "المركبة المستعملة في نقل البضائع بأجرة فقط.",
        "كل مركبة ليست مركبة خصوصية أو مركبة ركاب."
      ],
      id: 33
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0018. في الصورة التي أمامك نرى أيضاً الرصيف، ما هي الجملة الصحيحة؟",
      numQues: "0018",
      correctAnswer: "الرصيف مُعد للمشاة فقط.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3018.jpg",
      choices: [
        "مسموح لراكبي الدراجات الهوائية ركوبها على الرصيف.",
        "مسموح لمركبة ركاب خصوصية الوقوف للحظة على الرصيف، إذا لم يكن هناك مكان للوقوف على الشارع.",
        "مسموح أيضاً للدراجة النارية استعمال الرصيف.",
        "الرصيف مُعد للمشاة فقط."
      ],
      id: 34
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0354. استعمال شاشات العرض (تلفزيون وما شابه ذلك) الظاهرة لعيني السائق، ما عدا شاشة عرض المراقبة والتوجيه في المركبة (G.P.S):",
      numQues: "0354",
      correctAnswer: "ممنوع وحتى إذا كانت المركبة واقفة.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "مسموح لطمأنة السائق والركاب. ",
        "ممنوع ما دامت المركبة في حالة سير.",
        "مسموح إذا كان السائق يضع نظارات واقية فقط.",
        "ممنوع وحتى إذا كانت المركبة واقفة."
      ],
      id: 35
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0111. المفترق الذي أمامك عليه إشارات تماماً كما في الصورة، ما هي الطريقة الصحيحة للاستدارة من الشارع 'أ' (A) إلى الشارع 'ج' (C)؟",
      numQues: "0111",
      correctAnswer: "من المسلك '1' إلى المسلك '3'.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3111.jpg",
      choices: [
        "من المسلك '2' إلى المسلك '4'.",
        "من المسلك '2' إلى المسلك '3'.",
        "من المسلك '2' أو من المسلك '1' إلى المسلك '4'.",
        "من المسلك '1' إلى المسلك '3'."
      ],
      id: 36
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0689. الوظيفة الأساسية لفرامل الوقوف (الهاندبريك) في المركبة هي:",
      numQues: "0689",
      correctAnswer: "لمنع تحرك المركبة عند الوقوف. ",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "لمساعدة السائقين الجدد على الفرملة في المنحدرات.",
        "لزيادة قوة التوقف لفرملة الخدمة (بريك الرجل).",
        "لا توجد أية وظيفة للفرملة المساعدة ولا توجد ضرورة باستعمالها على الإطلاق.",
        "لمنع تحرك المركبة عند الوقوف. "
      ],
      id: 37
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1615. لماذا نقوم بتمييل الدراجة النارية أثناء الاستدارة؟",
      numQues: "1615",
      correctAnswer: "من اجل تحسين مدى الرؤية والقدرة على رد الفعل عند حدوث المفاجآت في الطريق.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "من اجل تقليل تأثير القوة الطاردة عن المركز (القوة التي تعمل على الدراجة النارية في المنعطف).",
        "من اجل إلغاء القوة الطاردة عن المركز تماماً.",
        "من اجل تحسين تماسك الإطارات بالشارع الجاف أو الرطب.",
        "من اجل تحسين مدى الرؤية والقدرة على رد الفعل عند حدوث المفاجآت في الطريق."
      ],
      id: 38
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0634. ما معنى الإشارة على سطح الطريق (خط متقطع باللون الأبيض)؟",
      numQues: "0634",
      correctAnswer: "محور الشارع أو خط مسلك. ",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3634.jpg",
      choices: [
        "لا يجوز على الإطلاق السير على يسار الخط.",
        "مسموح التجاوز في أي وقت.",
        "شارع باتجاهين.",
        "محور الشارع أو خط مسلك. "
      ],
      id: 39
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0551. كيف تتصرف حسب الإشارة؟",
      numQues: "0551",
      correctAnswer: "أعطِ حق الأولوية لحركة السير القاطعة طريقك حول الدوار واعبر الدوار من الجهة اليمنى.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3550.jpg",
      choices: [
        "اعبر المكان الموسوم (المؤشر) بالإشارة من اليسار فقط.",
        "عند سيرك حول الدوار عليك إعطاء حق الأولوية للمقتربين من الدوار من اذرع المفترق المختلفة.",
        "سر إلى اليمين أو إلى اليسار، السهم باللون الأصفر يشير إلى اتجاه السير للمواصلات العمومية فقط.",
        "أعطِ حق الأولوية لحركة السير القاطعة طريقك حول الدوار واعبر الدوار من الجهة اليمنى."
      ],
      id: 40
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1155. هل يوجد واجب بإضاءة أنوار مصابيح مقدمة الباص في النهار أيضاً؟",
      numQues: "1155",
      correctAnswer: "كلا، ما عدا في الخطوط بين المدن.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "نعم، فقط في الطرق بين المدن من الأول من تشرين الثاني ولغاية 31 آذار من السنة التي تليها. ",
        "نعم، في خطوط الخدمة داخل المدن، عندما يكون هناك ركاب في المركبة.",
        "نعم، من الأول من تشرين الثاني ولغاية 31 آذار من كل سنة.",
        "كلا، ما عدا في الخطوط بين المدن."
      ],
      id: 41
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1256. من هي الجهة التي تسمح وتقوم بنقل ملكية رخصة تشغيل صالون عمومي؟",
      numQues: "1256",
      correctAnswer: "سلطة المواصلات العمومية والقطارات.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "لا توجد ضرورة بإذن لنقل ملكية رخصة خدمة، لأن ذلك يتنافى مع حرية العمل.",
        "مراقب السير على الطرق.",
        "سلطة الترخيص.",
        "سلطة المواصلات العمومية والقطارات."
      ],
      id: 42
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1645. ما هي الاعتبارات عند اختيار خوذة (قبعة واقية) للدراجة النارية؟",
      numQues: "1645",
      correctAnswer: "خوذة (قبعة واقيه) حسب المواصفات توفر الحماية الأفضل (حتى للذقن) وتتناسب مع حجم ومبنى رأس راكب الدراجة النارية.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "لا توجد أهمية لخوذة حسب المواصفات، لكن من المهم أن يكون مبناها ديناميكي هوائي من اجل تقليل استهلاك الوقود. ",
        "يجب أن يكون في الخوذة نظام تهوية واكبر عدد ممكن من أحزمة الربط.",
        "المهم أن تناسب حجم ومبنى رأس راكب الدراجة النارية ولا توجد أهمية لقوة الخوذة.",
        "خوذة (قبعة واقيه) حسب المواصفات توفر الحماية الأفضل (حتى للذقن) وتتناسب مع حجم ومبنى رأس راكب الدراجة النارية."
      ],
      id: 43
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1388. اشرح المصطلح ' الوزن الكلي للمحور':",
      numQues: "1388",
      correctAnswer: "الضغط الذي يُقاس في أطراف الزنبركات المثبتة في الشاصي.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "الوزن الذاتي لكل محور مثبت في المركبة بما في ذلك العجلات المثبتة عليه.",
        "الوزن الذي تشغله على الطريق جميع العجلات المثبتة على محور واحد.",
        "الوزن الذاتي للمحور الخلفي بما في ذلك جهاز الباككس.",
        "الضغط الذي يُقاس في أطراف الزنبركات المثبتة في الشاصي."
      ],
      id: 44
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0545. ما معنى الإشارة؟",
      numQues: "0545",
      correctAnswer: "حركة السير باتجاهين أمامك.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3545.jpg",
      choices: [
        "سر بشكلٍ مستقيم إلى الأمام فقط.",
        "اعبر المكان الموسوم (المؤشر) بالإشارة من جهته اليمنى.",
        "الدخول إلى شارع باتجاه واحد.",
        "حركة السير باتجاهين أمامك."
      ],
      id: 45
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0236. في أية حالة يُعفى سائق المركبة الخصوصية من استعمال حزام الأمان؟",
      numQues: "0236",
      correctAnswer: "أثناء الرجوع إلى الخلف.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "أثناء المناورة في المركبة إلى الأمام في الموقف.",
        "أثناء الخروج من موقف مسقوف.",
        "عند الخروج من الساحات.",
        "أثناء الرجوع إلى الخلف."
      ],
      id: 46
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0107. ما هي الطريقة الصحيحة لتنفيذ استدارة إلى اليمين؟",
      numQues: "0107",
      correctAnswer: "بقوس عريض من يمين الشارع إلى أي مسلك في الشارع الذي ندخله. ",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "بأية طريقة كانت بعد إعطاء الإشارة المناسبة.",
        "من كل مسلك في الشارع إلى المسلك الأيمن الأقصى في الشارع الذي ندخله.",
        "السياقة بسرعة معقولة وآمنة وبدون عرقلة أو خطر من المسلك الأيمن إلى المسلك الأيمن في الشارع الذي ندخله.",
        "بقوس عريض من يمين الشارع إلى أي مسلك في الشارع الذي ندخله. "
      ],
      id: 47
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1002. ما هي وظيفة جهاز مراقبة الثبات الالكتروني في المركبة، 'إي.إس.بي' (E.S.P)؟",
      numQues: "1002",
      correctAnswer: "جهاز يقلل من خطر تزحلق المركبة.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "السيطرة على استهلاك وقود المحرك.",
        "منع إقفال العجلات.",
        "التقليل من كمية الغازات المحترقة والمنبعثة من المحرك.",
        "جهاز يقلل من خطر تزحلق المركبة."
      ],
      id: 48
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "0650. أية إشارة تظهر بعد الإشارة 708؟",
      numQues: "0650",
      correctAnswer: "716",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3650.jpg",
      choices: [
        "712",
        "710",
        "709",
        "716"
      ],
      id: 49
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0748. ما هي الميزة عندما تسير على يمين الشارع؟",
      numQues: "0748",
      correctAnswer: "لا تعرقل المركبة التي تتجاوزك من المجاوزة بأمان.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "لا توجد أية ميزة للمحافظة على الجهة اليمنى أثناء السياقة.",
        "رؤية حركة السير القادمة من الجهة المقابلة بشكلٍ أسهل.",
        "ذلك يُمكن من زيادة زمن رد الفعل أثناء التجاوز.",
        "لا تعرقل المركبة التي تتجاوزك من المجاوزة بأمان."
      ],
      id: 50
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1567. هل يُسمح بسياقة مركبة ثقيلة عندما يكون ضغط الهواء في جهاز الفرامل اقل من الحد الأدنى المطلوب؟",
      numQues: "1567",
      correctAnswer: "مسموح، فقط إذا كانت قدرة المركبة على التوقف جيدة.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "ممنوع.",
        "مسموح إذا لم يكن هناك وجود تهريب بشكلٍ أكيد.",
        "مسموح، فقط بإذن من شرطي أو ضابط.",
        "مسموح، فقط إذا كانت قدرة المركبة على التوقف جيدة."
      ],
      id: 51
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1299. لغاية أي عرض إجمالي مسموح بروز الحمولة في مركبة تجارية وزنها الإجمالي المسموح به أكثر من 15000كغم.",
      numQues: "1299",
      correctAnswer: "بروز الحمولة لغاية عرض مقداره 2.60م، إذا كانت الحمولة وحدة واحدة.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "بروز الحمولة لغاية عرض مقداره 2.10م، إذا كانت الحمولة وحدة واحدة.",
        "بروز الحمولة لغاية عرض مقداره 2.50م، إذا كانت الحمولة وحدة واحدة.",
        "بروز الحمولة لغاية عرض مقداره 3.40م، إذا كانت الحمولة وحدة واحدة.",
        "بروز الحمولة لغاية عرض مقداره 2.60م، إذا كانت الحمولة وحدة واحدة."
      ],
      id: 52
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0998. ماذا يجب على السائق أن يعمل إذا كان احد ضوئي المقدمة غير صالح؟",
      numQues: "0998",
      correctAnswer: "مسموح الاستمرار بالسير البطيء لغاية الكراج القريب.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "ممنوع الاستمرار بالسير ويجب الاهتمام بتصليح الخلل قبل أن يستمر بسيره.",
        "ممنوع الاستمرار بالسير إذا تعطل الضوء العالي فقط.",
        "ممنوع الاستمرار بالسير إذا تعطل الضوء الواطئ فقط.",
        "مسموح الاستمرار بالسير البطيء لغاية الكراج القريب."
      ],
      id: 53
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1717. مسموح إنزال يد واحدة عن المقود أثناء السواقة ، من اجل:",
      numQues: "1717",
      correctAnswer: "توجيه مقعد الراكب الذي بجانب السائق.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "استلام مكالمة في الهاتف النقال.",
        "قراءة أو إرسال رسالة قصيرة (SMS).",
        "تغيير الغيارات.",
        "توجيه مقعد الراكب الذي بجانب السائق."
      ],
      id: 54
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0905. كيف تتصرف حسب ما هو ظاهر في الصورة؟",
      numQues: "0905",
      correctAnswer: "تمهل وانحرف إلى اليسار، إذا أمكن، واعبر عن المشاة بحذر.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3905.jpg",
      choices: [
        "استعمل الزامور من اجل التنبيه واستمر بسرعة عادية وفي مسلك سيرك الأصلي.",
        "استعمل الزامور بشدة من اجل تجنب الخطر من المشاة.",
        "زد من سرعة السير واستعمل الزامور بشكلٍ خفيف.",
        "تمهل وانحرف إلى اليسار، إذا أمكن، واعبر عن المشاة بحذر."
      ],
      id: 55
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "0271. لا تُجدد رخصة سياقة 'لسائق جديد' كرخصة سواقة عادية إذ أدين في المحكمة بمخالفة:",
      numQues: "0271",
      correctAnswer: "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "عدم وضع مثلث تحذير عند إيقاف مركبة أصابها خلل في الطريق.",
        "سياقة مركبة ميكانيكية تحت تأثير الكحول أو المخدرات المسكرة.",
        "عدم التوقف في مفترق نُصبت فيه شاخصة 'أعط حق الأولوية لحركة السير في الطريق القاطعة'.",
        "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول."
      ],
      id: 56
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0524. يسري مفعول الإشارة لغاية:",
      numQues: "0524",
      correctAnswer: "الإشارة التي تسمح بالسير بسرعة محدودة.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3524.jpg",
      choices: [
        "المفترق القريب أو الإشارة التي تنهيها أو لغاية الإشارة 'موقف مركبات'.",
        "المفترق القريب فقط والذي نُصبت فيه إشارة ضوئية (رمزور).",
        "الإشارة التي تعني طريق خارج المدن.",
        "الإشارة التي تسمح بالسير بسرعة محدودة."
      ],
      id: 57
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1626. على من تقع مسؤولية الحفاظ على حيز أمان من الأمام ومن الخلف ومن الجوانب، عند ركوب الدراجة النارية ؟",
      numQues: "1626",
      correctAnswer: "على الشرطة وعلى شرطة المرور.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "على السلطات التي تصمم البنية التحتية.",
        "على السائقين الآخرين في الشارع والقريبين من الدراجة النارية.",
        "على سائق الدراجة النارية فقط.",
        "على الشرطة وعلى شرطة المرور."
      ],
      id: 58
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0045. عرِّف 'مساحة فاصلة مبنية' :",
      numQues: "0045",
      correctAnswer: "مساحة فاصلة تقسم الطريق على امتداد طولها وتُمكن عابري الطريق من الوقوف أو إيقاف مركباتهم عليها أو الوقوف عليها لغرض الانتعاش. ",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "كل مساحة موسومة (مؤشرة) على الشارع ويُمنع السير عليها.",
        "مساحة فاصلة تقسم الطريق على امتداد طولها وتكون مبنية و مرتفعة عن الشارع.",
        "كل جزء من الطريق (رصيف، حاشية، جزيرة سير ، الخ..) والمرتفع عن الشارع.",
        "مساحة فاصلة تقسم الطريق على امتداد طولها وتُمكن عابري الطريق من الوقوف أو إيقاف مركباتهم عليها أو الوقوف عليها لغرض الانتعاش. "
      ],
      id: 59
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0347. بأية شروط يُسمح بتركيب مصابيح إضافية زيادة عن المصابيح المُركبة في المركبة؟",
      numQues: "0347",
      correctAnswer: "مسموح، بشرط تركيبها من قِبل كهربائي معتمد.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "بإذن من سلطة الترخيص فقط.",
        "مسموح، بشرط أن تتوفر فيها المواصفات الأوروبية الحديثة.",
        "مسموح تركيب مصابيح متناظرة (متناسقة) إضافية.",
        "مسموح، بشرط تركيبها من قِبل كهربائي معتمد."
      ],
      id: 60
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1371. يجب تركيب مصابيح العرض (مصابيح الجناح):",
      numQues: "1371",
      correctAnswer: "فقط في المركبة الموصولة أو المستندة. ",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "في كل مركبة شاحنة.",
        "في المركبة التي يبلغ عرضها 210سم أو أكثر.",
        "في مركبة عرضها الإجمالي المسموح به 180سم أو اقل.",
        "فقط في المركبة الموصولة أو المستندة. "
      ],
      id: 61
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1214. أين تُثبت المرآة العاكسة بداخل الباص؟",
      numQues: "1214",
      correctAnswer: "في القسم الأمامي، بحيث يستطيع السائق رؤية جميع الركاب في الباص.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "في القسم الأوسط، بحيث يستطيع السائق رؤية جميع الركاب في الباص.",
        "في القسم الخلفي، بحيث يستطيع السائق رؤية جميع الركاب في الباص.",
        "لا توجد ضرورة لمرآة عاكسة، هناك مرايا زيادة عن اللازم في الباص.",
        "في القسم الأمامي، بحيث يستطيع السائق رؤية جميع الركاب في الباص."
      ],
      id: 62
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0936. ماذا يتوجب على السائق عمله حسب ما نراه في الصورة؟",
      numQues: "0936",
      correctAnswer: "لا يوجد أي واجب خاص.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3936.jpg",
      choices: [
        "النزول إلى حاشية الطريق والتمهل.",
        "التمهل والسير على اليمين على قدر الإمكان.",
        "استعمال الزامور وإعطاء ضوء عالي متقطع.",
        "لا يوجد أي واجب خاص."
      ],
      id: 63
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0358. أية إشارة سير منصوبة في الطريق تعلمنا عن تغيير في عدد المسالك في الشارع؟",
      numQues: "0358",
      correctAnswer: "308",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3358.jpg",
      choices: [
        "145",
        "622",
        "109",
        "308"
      ],
      id: 64
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0207. أين يُمنع إيقاف أو وقوف مركبة حسب ما هو ظاهر في الصورة؟",
      numQues: "0207",
      correctAnswer: "في حدود 20م بعد خط التوقف.",
      pubDate: "10-11-2011 08:22:36",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3207.jpg",
      choices: [
        "في حدود 15م بعد خط التوقف.",
        "في حدود 12م قبل خط التوقف.",
        "في حدود 20م قبل خط التوقف.",
        "في حدود 20م بعد خط التوقف."
      ],
      id: 65
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1453. على سائق الصالون العمومي الملزم باستعمال نظارات أو أدوات بصرية:",
      numQues: "1453",
      correctAnswer: "أن تكون بحوزته في المركبة أثناء السياقة نظارات أو عدسات لاصقة إضافية.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "أن يتأكد في ساعات السياقة أثناء النهار أن في جيبه نظارات أو عدسات لاصقة ملائمة. ",
        "أن يتأكد في ساعات السياقة في الليل أن في جيبه نظارات أو عدسات لاصقة ملائمة.",
        "أن تكون لديه في محطة الصالون العمومي نظارات أو عدسات لاصقة إضافية. ",
        "أن تكون بحوزته في المركبة أثناء السياقة نظارات أو عدسات لاصقة إضافية."
      ],
      id: 66
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1117. ما هي 'المركبة السياحية' (تنزه)؟",
      numQues: "1117",
      correctAnswer: "المركبة المستعملة كمركبة 'امن' للقرى الحدودية ومعدة للسياحة على طول جدران القرية.",
      pubDate: "10-11-2011 08:22:36",
      img: "",
      choices: [
        "المركبة التي تخدم قوات الأمن المختلفة أثناء عملياتهم العادية.",
        "المركبة العمومية المعدة لنقل ما لا يزيد عن ثمانية ركاب ما عدا السائق وذُكر في رخصة المركبة الخاصة بها بأنها مركبة سياحية.",
        "مركبة الأمن المستخدمة في السياحة على طول الحدود والمزودة بأجهزة تناسب ذلك.",
        "المركبة المستعملة كمركبة 'امن' للقرى الحدودية ومعدة للسياحة على طول جدران القرية."
      ],
      id: 67
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0034. عرِّف 'شارع مختلط' (موحد) :",
      numQues: "0034",
      correctAnswer: "طريق معدة لألعاب الأولاد وللمشاة وللمركبات ونُصِبت على مدخلها شاخصة تدل على أنها 'شارع مختلط' (موحد).",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "سبيل مُعد لألعاب الأولاد ويُسمح الدخول فيه للمشاة وللمركبات التي تسير على عجلتين فقط.",
        "شارع رئيسي تندمج فيه المركبات القادمة من شوارع جانبية.",
        "شارع تُمكن فيه حركة السير اندماج مركبات من أنواع مختلفة.",
        "طريق معدة لألعاب الأولاد وللمشاة وللمركبات ونُصِبت على مدخلها شاخصة تدل على أنها 'شارع مختلط' (موحد)."
      ],
      id: 68
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0560. من يُتوقع وصوله من الجهة المقابلة إذا كان السهم في الإشارة اصفر؟",
      numQues: "0560",
      correctAnswer: "قطار فقط.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3560.jpg",
      choices: [
        "مركبة مستخدمة في المواصلات العمومية أو مركبة أخرى سمح لها بواسطة إشارة.",
        "مركبة تنقل أكثر من راكبين.",
        "باص سياحي فقط.",
        "قطار فقط."
      ],
      id: 69
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1195. ما هي فترة الوقت التي يجب على الباص التوقف فيها في المحطة؟",
      numQues: "1195",
      correctAnswer: "مسموح التوقف لفترة وقت غير محدودة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "فترة الوقت اللازمة لإنزال أو لاصعاد الركاب.",
        "فقط الوقت اللازم لاصعاد ثلاثة ركاب مع حمولتهم.",
        "فقط فترة الوقت اللازمة لاصعاد الركاب.",
        "مسموح التوقف لفترة وقت غير محدودة."
      ],
      id: 70
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1560. متى يُسمح بالرجوع إلى الخلف؟",
      numQues: "1560",
      correctAnswer: "مسموح في جميع الأحوال، المهم أن يُشاهد السائقون الآخرون السائق الذي يرجع إلى الخلف.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "عندما تكون هناك ضرورة شخصية للرجوع إلى الخلف، حتى إذا لم يكن الرجوع إلى الخلف ضرورياً.",
        "عندما تكون هناك ضرورة مرورية في تلك السفرة، ولا توجد أية طريقة أخرى لتنفيذ السفرة.",
        "فقط إذا كان عرض الشارع يزيد عن 4م.",
        "مسموح في جميع الأحوال، المهم أن يُشاهد السائقون الآخرون السائق الذي يرجع إلى الخلف."
      ],
      id: 71
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1031. قياس الإطارات الصحيح في المركبة هو:",
      numQues: "1031",
      correctAnswer: "القياس الذي حدده منتج الإطارات.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "القياس الذي يوصي به صاحب مهنة مختص بالإطارات (بنشرجي).",
        "القياس الذي نراه مناسباً للمركبة.",
        "القياس الذي حدده منتج المركبة.",
        "القياس الذي حدده منتج الإطارات."
      ],
      id: 72
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0308. هل يُعتبر السائق ثملاً (سكران) عندما يكون تركيز الكحول في دمه أعلى من النسبة المحددة في القانون:",
      numQues: "0308",
      correctAnswer: "كلا، يُعتبر ثملاً (سكران) من يتصرف كثمل.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "نعم، يُعتبر السائق ثملاً (سكران) حتى ولو لم يرتكب أية مخالفة أخرى.",
        "كلا، لم يحدد القانون المصطلح 'ثمل'.",
        "كلا، الشخص الذي لا يتأثر من كمية قليلة من الكحول لا يُعتبر ثملاً (سكران)، دون أية علاقة بكمية الكحول.",
        "كلا، يُعتبر ثملاً (سكران) من يتصرف كثمل."
      ],
      id: 73
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0809. ما هي العلاقة بين سرعة السير وبين مسافة التوقف للمركبة؟",
      numQues: "0809",
      correctAnswer: "كلما زادت سرعة المركبة تزيد مسافة توقف المركبة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "كلما قلت سرعة المركبة تزيد مسافة التوقف.",
        "لا توجد أية علاقة، مسافة التوقف ثابتة ولا تعتمد على سرعة المركبة.",
        "كلما زادت سرعة المركبة تقل مسافة التوقف.",
        "كلما زادت سرعة المركبة تزيد مسافة توقف المركبة."
      ],
      id: 74
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1227. أين يجوز لسائق صالون عمومي التوقف من اجل اصعاد وإنزال الركاب في طريق بلدية؟",
      numQues: "1227",
      correctAnswer: "في كل مكان مسموح الوقوف فيه وأيضاً بجانب أحجار الحافة المدهونة بالأحمر والأبيض، بشرط أن لا يُعرقل الصالون العمومي حركة السير .",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "في كل مكان بما في ذلك محطة باص.",
        "فقط في الأماكن المعدة لذلك والموسومة (المؤشرة) للغاية المذكورة.",
        "في كل محطة صالون عمومي فقط.",
        "في كل مكان مسموح الوقوف فيه وأيضاً بجانب أحجار الحافة المدهونة بالأحمر والأبيض، بشرط أن لا يُعرقل الصالون العمومي حركة السير ."
      ],
      id: 75
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0147. لأية مركبات يسمح بدخول الطريق السريعة؟",
      numQues: "0147",
      correctAnswer: "لجميع المركبات الميكانيكية وغير الميكانيكية.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3567.jpg",
      choices: [
        "لكل مركبة ميكانيكية ما عدا الشاحنات الثقيلة والتي من شأن سرعتها أن تعيق حركة السير.",
        "للمركبات الميكانيكية الخصوصية فقط.",
        "للمركبات الميكانيكية التي يجوز لها وتستطيع السير بسرعة لا تقل بالكم/ساعة عن المسجل في الإشارة .",
        "لجميع المركبات الميكانيكية وغير الميكانيكية."
      ],
      id: 76
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0115. المفترق الذي أمامك عليه إشارات تماماً كما في الصورة، ما هي الطريقة الصحيحة للاستدارة من الشارع 'أ' (A) إلى الشارع 'ب' (B)؟",
      numQues: "0115",
      correctAnswer: "من المسلك '2' إلى المسلك '3' أو إلى المسلك '4'.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3115.jpg",
      choices: [
        "من المسلك '2' إلى المسلك '4'.",
        "من المسلك '1' إلى المسلك '4'.",
        "من المسلك '1' إلى المسلك '3' أو إلى المسلك '4'.",
        "من المسلك '2' إلى المسلك '3' أو إلى المسلك '4'."
      ],
      id: 77
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1123. ما معنى الإشارة؟",
      numQues: "1123",
      correctAnswer: "توجيه لأهداف في طرق سريعة.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31123.jpg",
      choices: [
        "توجيه للخروج من طريق سريعة.",
        "توجيه لأهداف في طريق ليست بلدية.",
        "توجيه لأهداف في طريق بلدية.",
        "توجيه لأهداف في طرق سريعة."
      ],
      id: 78
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1224. أين يتوقف سائق الباص الذي يسير على خط خدمة؟",
      numQues: "1224",
      correctAnswer: "في جميع المحطات المتواجدة في الطريق بشرط أن تكون لصاحب الخدمة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "في كل مكان قريب لهدف المسافر الذي طلب ذلك، ولكن فقط على حاشية الطريق.",
        "في المحطات التي صادق عليها مراقب السير على الطرق في رخصة الخط.",
        "في كل مكان يطلب منه احد الركاب بأن يتوقف.",
        "في جميع المحطات المتواجدة في الطريق بشرط أن تكون لصاحب الخدمة."
      ],
      id: 79
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1113. عرف 'الباص':",
      numQues: "1113",
      correctAnswer: "مركبة تجارية معدة لنقل ركاب مقابل أجرة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "مركبة تجارية معدة لنقل أكثر من 15 راكب وذُكر في رخصتها بأنها باص.",
        "مركبة ميكانيكية معدة لنقل 8 ركاب أو أكثر إضافة إلى السائق، والتي ذُكر في رخصة المركبة بأنها باص.",
        "مركبة ميكانيكية تجارية معدة لنقل ثمانية ركاب أو أكثر والتي ذُكر في رخصة المركبة بأنها باص.",
        "مركبة تجارية معدة لنقل ركاب مقابل أجرة."
      ],
      id: 80
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0706. هل يجب علي (مركبة رقم 3) إعطاء حق الأولوية لراكب الدراجة الهوائية (2) في الدوار؟",
      numQues: "0706",
      correctAnswer: "كلا ، لا يجب، هذا يعتمد على نيتي الحسنة.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3706.jpg",
      choices: [
        "كلا، لأن على راكب الدراجة الهوائية أن يعطي دائماً حق الأولوية للمركبات الأخرى.",
        "نعم، دائماً.",
        "كلا، لا تسري قواعد حق الأولوية على راكب الدراجة الهوائية في دوار حركة السير.",
        "كلا ، لا يجب، هذا يعتمد على نيتي الحسنة."
      ],
      id: 81
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0062. هل يجب إطاعة أوامر وإشارات مفتش بلدية في لباسه الرسمي ؟",
      numQues: "0062",
      correctAnswer: "بشكلٍ عام، كلا.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "كلا، يجب فقط إطاعة الأوامر التي تختص بالوقوف في حدود البلدية.",
        "نعم، إذا كان للأوامر صلة في ترتيبات حركة السير.",
        "كلا، يجب فقط إطاعة ما يتعلق في إبراز رخصة السياقة.",
        "بشكلٍ عام، كلا."
      ],
      id: 82
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0660. اشر إلى الجملة الصحيحة:",
      numQues: "0660",
      correctAnswer: "مسافة الفرملة تساوي دائماً مسافة رد الفعل.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "مسافة التوقف اكبر من مسافة الفرملة دائماً.",
        "مسافة رد الفعل أطول من مسافة الفرملة دائماً.",
        "مسافة الفرملة اكبر من مسافة التوقف دائماً.",
        "مسافة الفرملة تساوي دائماً مسافة رد الفعل."
      ],
      id: 83
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1804. أي إشارة معناها موقع تعبئة ( شحن بطارية) مركبة كهربائية؟",
      numQues: "804 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [],
      id: 84
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0535. أين يجب عليك التوقف إذا نُصبت أمامك الإشارة؟",
      numQues: "0535",
      correctAnswer: "إذا رُسم خط توقف، توقف بعد الخط مباشرةً.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3184.jpg",
      choices: [
        "إذا رُسم خط توقف، توقف قبل الخط وقريب منه، وإذا لم يوجد خط توقف ، توقف في مكان تستطيع منه رؤية حركة السير.",
        "في وسط المفترق، في مكان فيه أحسن مدى للرؤية.",
        "توقف قبل المفترق في أي مكان ترغب فيه.",
        "إذا رُسم خط توقف، توقف بعد الخط مباشرةً."
      ],
      id: 85
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0887. عند رؤيتك أن في نية المركبة الفضية التي تتجاوز الانحراف إلى المسلك الأيمن:",
      numQues: "0887",
      correctAnswer: "قم بالانحراف إلى المسلك الأيسر وتجاوز المركبة التي في الأمام.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3887.jpg",
      choices: [
        "استعمل الزامور للسائق الذي ينحرف إلى اليمين لتنبهه وردعه.",
        "زد من سرعة سيرك في المسلك الأيمن وتجاوز السائق قبل أن ينحرف إلى اليمين.",
        "عليك تمكينها من الانحراف بأمان وبدون إعاقة.",
        "قم بالانحراف إلى المسلك الأيسر وتجاوز المركبة التي في الأمام."
      ],
      id: 86
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0379. حسب القانون، لأية مدة تبقى النقاط المسجلة بحق السائق؟",
      numQues: "0379",
      correctAnswer: "سنتين من تاريخ ارتكاب المخالفة عندما تتجمع بحق السائق لغاية 20 نقطة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "لا توجد فترة محددة، ولا يوجد أي ذكر في الأنظمة بالنسبة لمدة تجميع النقاط.",
        "فترة غير محددة، بموجب خطة النقاط الجديدة لا تُشطب النقاط على الإطلاق.",
        "ست سنوات من تاريخ ارتكاب المخالفة عندما تتجمع بحق السائق 12 نقطة على الأقل.",
        "سنتين من تاريخ ارتكاب المخالفة عندما تتجمع بحق السائق لغاية 20 نقطة."
      ],
      id: 87
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0958. هناك قيود في الشارع الذي أمامك، ما هي هذه القيود؟",
      numQues: "0958",
      correctAnswer: "حسب الإشارات هناك أشغال تجري في الشارع الذي أمامك، هناك تحديد سرعة ومنع تجاوز للشاحنات.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3958.jpg",
      choices: [
        "هناك ضغط حركة سير في الشارع.",
        "هناك مجال رؤية محدود.",
        "السير في طريق بلدية.",
        "حسب الإشارات هناك أشغال تجري في الشارع الذي أمامك، هناك تحديد سرعة ومنع تجاوز للشاحنات."
      ],
      id: 88
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1295. يجوز لشرطي إعطاء إشعار بعدم استعمال المركبة (تنزيل عن الشارع) :",
      numQues: "1295",
      correctAnswer: "إذا كان هناك استهلاك زيت زائد في المركبة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "إذا كان استهلاك الوقود في المركبة أكثر من القدر المحدد من قِبل منتج المركبة.",
        "إذا كان ضغط الهواء في الإطارات اقل من نصف الضغط المطلوب.",
        "إذا كانت المركبة تلوث الهواء بقدر أكثر من المسموح.",
        "إذا كان هناك استهلاك زيت زائد في المركبة."
      ],
      id: 89
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1095. هل يُمكن فرملة عجل واحد فقط في التراكتور؟",
      numQues: "1095",
      correctAnswer: "يُمكن فقط في المحور الخلفي.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "لا توجد إمكانية.",
        "يُمكن فقط في المحور الأمامي.",
        "يُمكن في المحورين، الأمامي والخلفي.",
        "يُمكن فقط في المحور الخلفي."
      ],
      id: 90
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0787. ما هو الطول الإجمالي المسموح به في القانون للباص الذي في الصورة؟",
      numQues: "0787",
      correctAnswer: "13.75م",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3787.jpg",
      choices: [
        "18.75م.",
        "15.50م",
        "14.10م",
        "13.75م"
      ],
      id: 91
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0493. ما معنى الإشارة؟",
      numQues: "0493",
      correctAnswer: "ممنوع التجاوز للمركبات العمومية فقط.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3493.jpg",
      choices: [
        "نهاية المقطع الذي يُسمح فيه التجاوز.",
        "نهاية المقطع الذي يسري فيه منع التجاوز.",
        "نهاية مقطع الطريق البلدية.",
        "ممنوع التجاوز للمركبات العمومية فقط."
      ],
      id: 92
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0110. المفترق الذي أمامك عليه إشارات تماماً كما في الصورة، ما هي الطريقة الصحيحة للاستدارة من الشارع 'أ' (A) إلى الشارع 'ج' (C)؟",
      numQues: "0110",
      correctAnswer: "من المسلك '2' أو من المسلك '1' إلى المسلك '3' أو إلى المسلك '4'.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3110.jpg",
      choices: [
        "من المسلك '2' إلى المسلك '3' أو المسلك '4'.",
        "من المسلك '2' إلى المسلك '3'.",
        "من المسلك '2' أو من المسلك '1' إلى المسلك '3'.",
        "من المسلك '2' أو من المسلك '1' إلى المسلك '3' أو إلى المسلك '4'."
      ],
      id: 93
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "0088. كيف يتصرف سائق التراكتور في الطريق إذا كان يُعرقل أثناء سياقته عبور حركة السير من خلفه ؟",
      numQues: "0088",
      correctAnswer: "مسموح أن يسوق فقط في المسلك الأيسر أو على الحاشية اليمنى.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3085.jpg",
      choices: [
        "يسوق دائماً على حاشية الطريق.",
        "يسوق فقط على المسلك الأيمن في الشارع.",
        "يسير على يمين الشارع وحتى على حاشية الطريق إذا كان الأمر ضرورياً وممكنا ",
        "مسموح أن يسوق فقط في المسلك الأيسر أو على الحاشية اليمنى."
      ],
      id: 94
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0047. ما هو 'المقعد المرتفع' ؟",
      numQues: "0047",
      correctAnswer: "مقعد معد لنقل الأولاد في الدراجة الهوائية فقط بحيث يكون الولد الجالس عليه مربوطاً بحزام أمان المركبة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "مقعد حسب المواصفات مُعد لنقل الأولاد الذين لا تزيد أعمارهم عن 18 سنة.",
        "مقعد مُعد لسائق طوله يقل عن 160سم وعمره أكثر من 18سنة.",
        "مقعد حسب المواصفات معد لنقل الأولاد في المركبة بحيث يكون الولد الجالس عليه مربوطاً بحزام أمان المركبة.",
        "مقعد معد لنقل الأولاد في الدراجة الهوائية فقط بحيث يكون الولد الجالس عليه مربوطاً بحزام أمان المركبة."
      ],
      id: 95
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0398. لا تُجدد رخصة السياقة لسائق جديد كرخصة سياقة عادية وإنما تُمدد لمدة سنتين كرخصة سياقة لسائق جديد إذا أُدين السائق بمخالفة:",
      numQues: "0398",
      correctAnswer: "عدم التوقف في مكان نُصبت فيه الإشارة 'أعطِ حق الأولوية'.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "عدم التوقف قبل ملتقى سكة حديد عندما تُلزم الظروف ذلك.",
        "عدم وضع لافتة 'سائق جديد' على الزجاج الخلفي للمركبة.",
        "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول.",
        "عدم التوقف في مكان نُصبت فيه الإشارة 'أعطِ حق الأولوية'."
      ],
      id: 96
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0844. أية قوة من قوى الطبيعة تعمل على المركبة أثناء الفرملة أو التمهل؟",
      numQues: "0844",
      correctAnswer: "لا تعمل أية قوة من قوى الطبيعة على المركبة أثناء الفرملة أو التمهل.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "القصور الذاتي: القوة التي تتسبب في استمرار المركبة لسيرها.",
        "قوة الجذب إلى الأعلى: القوة التي تجذب المركبة إلى الأعلى.",
        "القوة الطاردة المركزية: القوة التي تعمل على المركبة في المنعطفات.",
        "لا تعمل أية قوة من قوى الطبيعة على المركبة أثناء الفرملة أو التمهل."
      ],
      id: 97
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1497. المسافة التي تقطعها المركبة من لحظة الضغط على دعسة الفرامل ولغاية توقف المركبة، تزداد:",
      numQues: "1497",
      correctAnswer: "كلما نسير بسرعة اكبر.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "كلما كان زمن رد الفعل أطول.",
        "كلما نسير بسرعة أبطأ.",
        "كلما كانت المركبة احدث.",
        "كلما نسير بسرعة اكبر."
      ],
      id: 98
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0791. متى يُسمح بالاستدارة إلى اليسار من شارع باتجاه واحد ليس من المسلك الأيسر؟",
      numQues: "0791",
      correctAnswer: "الاستدارة ممنوعة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "مثل هذه الاستدارة ممكنة في مفترق فيه إشارات ضوئية (رمزورات) فقط. ",
        "يُسمح بمثل هذه الاستدارة فقط من شارع باتجاه إلى شارع باتجاه واحد.",
        "يُسمح بمثل هذه الاستدارة عندما يكون في الشارع مسلكان أو أكثر موسومان (مؤشران) للاستدارة إلى اليسار. ",
        "الاستدارة ممنوعة."
      ],
      id: 99
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1005. لماذا تكون أهمية في سلامة مصدات (طمبونات) المركبة؟",
      numQues: "1005",
      correctAnswer: "من اجل المحافظة على شكل لائق للمركبة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "من اجل الامتناع عن حادث بسيط نسبياً.",
        "من اجل منع الضرر في الحوادث الصعبة.",
        "من اجل تقليل مدى الضرر للمركبة ولركابها عند وقوع حادث.",
        "من اجل المحافظة على شكل لائق للمركبة."
      ],
      id: 100
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1414. كيف يجب نقل حمولة في مركبة لا توجد فيها كابينة سائق منفردة؟",
      numQues: "1414",
      correctAnswer: "مسموح نقل حمولة فيها على مسطحات فقط.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "مسموح نقل حمولة سائبة فيها فقط.",
        "يجب أن يكون هناك قاطع (فاصل) في المركبة يفصل ويحمي الركاب من الإصابة من قِبل الحمولة.",
        "ممنوع نقل حمولة في مركبة لا يوجد فيها كابينة سائق منفردة.",
        "مسموح نقل حمولة فيها على مسطحات فقط."
      ],
      id: 101
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0602. ما معنى الإشارة؟",
      numQues: "0602",
      correctAnswer: "فندق قروي أمامك.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3602.jpg",
      choices: [
        "نزل للشباب.",
        "حماية الطبيعة.",
        "موقف مرخص للوقوف الليلي.",
        "فندق قروي أمامك."
      ],
      id: 102
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0730. ما هي ميزات النظر بعيداً إلى الأمام ؟",
      numQues: "0730",
      correctAnswer: "ذلك يمكن من التخطيط للسير حسب وضع الطريق والامتناع عن المفاجآت من قِبل عابري الطريق الآخرين.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3730.jpg",
      choices: [
        "ذلك يمكن السائق من القيام بعمليات إضافية في آنٍ واحد عند السير إلى الأمام.",
        "لا توجد أية ميزات للنظر بعيداً إلى الأمام، ما يجري بالقرب من المركبة هو الأمر المهم والمحدِد.",
        "لا توجد لك أية ميزات، النظر إلى الجوانب فقط هو الذي يساعد السائق.",
        "ذلك يمكن من التخطيط للسير حسب وضع الطريق والامتناع عن المفاجآت من قِبل عابري الطريق الآخرين."
      ],
      id: 103
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1531. عندما تسير خلف مركبة كبيرة:",
      numQues: "1531",
      correctAnswer: "حافظ على مسافة اكبر من المعتاد من هذه المركبة، لكي تمنع وقوع حادث. ",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "في الصعود – حافظ على مسافة صغيرة، في المنحدر – حافظ على مسافة مضاعفة.",
        "حافظ على مسافة اكبر من المركبة التي أمامك فقط إذا نُصبت إشارة 'خطر شامل'.",
        "حافظ على اصغر مسافة من المركبة التي أمامك.",
        "حافظ على مسافة اكبر من المعتاد من هذه المركبة، لكي تمنع وقوع حادث. "
      ],
      id: 104
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1801. أي إشارة معناها موقع تعبئة ( شحن بطارية) مركبة كهربائية؟",
      numQues: "1801",
      correctAnswer: "ס-55",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31801.jpg",
      choices: [
        "ס-130",
        "ס-31",
        "ס-131",
        "ס-55"
      ],
      id: 105
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1487. هل يجوز لسائق مركبة تجاوز السرعة القصوى المسموح بها أثناء التجاوز؟",
      numQues: "1487",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "نعم، فقط في طريق ليست بلدية.",
        "نعم، إذا كان ذلك ضرورياً لتقصير زمن التجاوز.",
        "نعم، فقط في طريق عديدة المسالك ولوقت قصير.",
        "كلا."
      ],
      id: 106
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1263. هل يُسمح لمركبة غير الصالون العمومي إصعاد ركاب في حدود هذه الإشارة؟",
      numQues: "1263",
      correctAnswer: "كلا، المكان موسوم (مؤشر) بإشارة لغرض إصعاد وإنزال ركاب الصالون العمومي.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3572.jpg",
      choices: [
        "نعم، المكان موسوم (مؤشر) بإشارة لغرض إصعاد وإنزال ركاب الصالون العمومي والباص في خط خدمة.",
        "نعم، في أيام السبت فقط.",
        "نعم، التوقف مسموح للصالون العمومي والباصات ولكن ليس لأية مركبة أخرى.",
        "كلا، المكان موسوم (مؤشر) بإشارة لغرض إصعاد وإنزال ركاب الصالون العمومي."
      ],
      id: 107
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0639. أنت تسير باتجاه السهم، ما معنى الوسم (التأشير) على الشارع من يسارك؟",
      numQues: "0639",
      correctAnswer: "بداية طريق مشوشة أمامك.",
      pubDate: "10-11-2011 08:22:37",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3639.jpg",
      choices: [
        "خط حدود المساحة الفاصلة في طريق ليست بلدية.",
        "سوف يؤشر عن قريب خط فاصل متواصل مزدوج...",
        "شارع باتجاه واحد أمامك.",
        "بداية طريق مشوشة أمامك."
      ],
      id: 108
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1699. المرآة البانورامية (المحدبة):",
      numQues: "1699",
      correctAnswer: "تتسبب في أن تظهر الأجسام التي تنعكس فيها اصغر وبعيدة. ",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "تعكس بدقة (لا تُكبر ولا تُصغر) الأجسام التي تنعكس فيها.",
        "غالية جداً، لذلك تُستعمل في الباصات فقط.",
        "تُضخم الأجسام التي تنعكس فيها. ",
        "تتسبب في أن تظهر الأجسام التي تنعكس فيها اصغر وبعيدة. "
      ],
      id: 109
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1703. أية قدرة متعلقة بالسائق أو بالمركبة تتضرر عندما يكون هناك ضباب؟",
      numQues: "1703",
      correctAnswer: "الرؤية.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "جميع الإجابات صحيحة.",
        "الفرملة.",
        "التوجيه (بواسطة المقود).",
        "الرؤية."
      ],
      id: 110
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1779. عندما تريد الاستدارة إلى اليسار في مفترق بدون إشارات، عليك إعطاء حق الأولوية للمركبة القادمة من الجهة المقابلة:",
      numQues: "1779",
      correctAnswer: "فقط عندما تستدير المركبة القادمة من الجهة المقابلة إلى اليسار.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "فقط عندما تستدير المركبة القادمة من الجهة المقابلة إلى اليمين.",
        "دائماً.",
        "فقط عندما تستمر المركبة القادمة من الجهة المقابلة بالسير إلى الأمام. .",
        "فقط عندما تستدير المركبة القادمة من الجهة المقابلة إلى اليسار."
      ],
      id: 111
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1425. أين تسير المركبة المرافقة لمركبة تنقل حمولة بارزة؟",
      numQues: "1425",
      correctAnswer: "تسير المركبة المرافقة دائماً أمام المركبة التي تنقل حمولة بارزة.",
      pubDate: "10-11-2011 08:22:37",
      img: "",
      choices: [
        "في شارع باتجاهين - أمام المركبة التي تنقل حمولة بارزة، وفي شارع باتجاه واحد - خلفها.",
        "يعتمد موقع المركبة المرافقة على عرض الحمولة ولا يعتمد على نوع الطريق.",
        "في شارع باتجاه واحد - تسير المركبة المرافقة من الأمام ، وفي طريق باتجاهين - من الخلف.",
        "تسير المركبة المرافقة دائماً أمام المركبة التي تنقل حمولة بارزة."
      ],
      id: 112
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0224. هل يجوز لنا السير أو سياقة مركبة عندما يكون قسم من جسمنا خارج المركبة؟",
      numQues: "0224",
      correctAnswer: "ممنوع ، ما عدا في الدراجة النارية.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "مسموح عند السير في طرق ترابية.",
        "مسموح في مركبة هواية الجمع فقط.",
        "مسموح للركاب البالغين فقط.",
        "ممنوع ، ما عدا في الدراجة النارية."
      ],
      id: 113
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0391. أية إشارة ممكن أن ترى قبل أن تظهر الإشارة رقم: 305 ؟",
      numQues: "0391",
      correctAnswer: "402",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3391.jpg",
      choices: [
        "302",
        "304",
        "438",
        "402"
      ],
      id: 114
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1364. من أية مسافة يجب رؤية الضوء المتقطع للمصباح الأصفر في 'وقت الإنارة' وفي حاله الجو الصافي؟",
      numQues: "1364",
      correctAnswer: "100م.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "150م.",
        "75م.",
        "30م.",
        "100م."
      ],
      id: 115
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0116. المفترق الذي أمامك عليه إشارات تماماً كما في الصورة، ما هي الطريقة الصحيحة للاستدارة من الشارع 'ج' (C) إلى الشارع 'أ' (A)؟",
      numQues: "0116",
      correctAnswer: "من المسلك '5' إلى المسلك '3'.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3116.jpg",
      choices: [
        "من المسلك '5' إلى المسلك '4'.",
        "من المسلك '7' إلى المسلك '3'.",
        "من المسلك '5' إلى المسلك '3' أو إلى المسلك '4'.",
        "من المسلك '5' إلى المسلك '3'."
      ],
      id: 116
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1359. أية مركبة تجارية تستوجب الحصول على 'إذن للجر' لجر مجرور؟",
      numQues: "1359",
      correctAnswer: "مركبة وزنها الإجمالي المسموح به أكثر من 8000كغم.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "مركبة وزنها الإجمالي المسموح به أكثر من 6000كغم.",
        "مركبة وزنها الإجمالي المسموح به أكثر من 3500كغم.",
        "مركبة وزنها الإجمالي المسموح به أكثر من 10000كغم.",
        "مركبة وزنها الإجمالي المسموح به أكثر من 8000كغم."
      ],
      id: 117
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0142. عندما تصل بمركبتك إلى المكان الذي يظهر في الصورة، عليك واجب:",
      numQues: "0142",
      correctAnswer: "التمهل.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3132.jpg",
      choices: [
        "استعمال الزامور.",
        "التوقف.",
        "الإسراع.",
        "التمهل."
      ],
      id: 118
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1054. ماذا يجب على السائق أن يفحص قبل البدء بالسير؟",
      numQues: "1054",
      correctAnswer: "مستوى سائل تنظيف الزجاج وسلامة جهاز الإنارة فقط.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "على السائق سياقة المركبة فقط، يجب أن تتم جميع الفحوصات في الكراج.",
        "ضغط الهواء في المحرك ونظافة الزجاج وسلامة جهاز تكييف الهواء.",
        "أن لا تكون إحدى لامبات التحذير في لوحة الساعات مضاءة.",
        "مستوى سائل تنظيف الزجاج وسلامة جهاز الإنارة فقط."
      ],
      id: 119
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0671. يكون خطر التزحلق في شارع رطب (مبلول) أكثر:",
      numQues: "0671",
      correctAnswer: "كلما كانت المركبة أثقل.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "كلما كانت الإطارات بالية (ممسوحة) أكثر .",
        "كلما كانت أخاديد (فرزات) الإطارات أعمق.",
        "كلما كان ضغط الهواء في الإطارات أكثر.",
        "كلما كانت المركبة أثقل."
      ],
      id: 120
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0156. أي واجب مفروض على السائق الذي يقترب من ملتقى سكة حديد مجهز بحاجز ومؤشر بواسطة إشارة ضوئية (رمزور) :",
      numQues: "0156",
      correctAnswer: "التصرف بشكلٍ عادي، في ملتقى مع حاجز بالإمكان أن نكون اقل حذراً.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3155.jpg",
      choices: [
        "فقط إطفاء الراديو المُركب في المركبة.",
        "التصرف بشكلٍ عادي، واجب السياقة بحذر فقط عند رؤية أو سماع قطار يقترب.",
        "عليه واجب التمهل دائماً.",
        "التصرف بشكلٍ عادي، في ملتقى مع حاجز بالإمكان أن نكون اقل حذراً."
      ],
      id: 121
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1700. مصباح الرجوع إلى الخلف:",
      numQues: "1700",
      correctAnswer: "يعمل بواسطة مفتاح منفصل وعند تشغيله يجب أن يُسمع طنان (مزمزم) تحذير.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "يعمل فقط بواسطة تعشيق الغيار الخلفي (ريفرس) وفقط عندما يكون الغيار الخلفي معشقاً.",
        "يُمنع تركيب مصباح الرجوع إلى الخلف في كل مركبة ليست مركبة ركاب خصوصية.",
        "يُستعمل في ساعات الإنارة فقط.",
        "يعمل بواسطة مفتاح منفصل وعند تشغيله يجب أن يُسمع طنان (مزمزم) تحذير."
      ],
      id: 122
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0759. ما معنى الإشارة؟",
      numQues: "0759",
      correctAnswer: "الشارع يضيق.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3759.jpg",
      choices: [
        "مخروط للتوجيه أو وسم (تأشير) عائق في مكان فيه أشغال في الطريق.",
        "نهاية مقطع طريق جبلية.",
        "تشير إلى مكان توقف للسائقين لغرض الانتعاش، يجب إضاءة نور اصفر أو احمر متقطع.",
        "الشارع يضيق."
      ],
      id: 123
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1297. كيف يتصرف سائق يسير على الشارع إذا قدمت فجأة مركبة مقابله وتسير في مسلك سيره؟",
      numQues: "1297",
      correctAnswer: "ينحرف إلى اليسار ويسير في المسلك المعاكس الخالي حينها.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "يتمهل وينحرف على قدر الإمكان إلى اليمين وأيضاً ينزل على حاشية الطريق إذا لزم الأمر.",
        "يستعمل الزامور ويؤشر للسائق المقابل بأن يعود إلى مسلكه. ",
        "يضيء الضوء العالي لكي يؤشر للسائق المقابل بأن يعود إلى مسلكه.",
        "ينحرف إلى اليسار ويسير في المسلك المعاكس الخالي حينها."
      ],
      id: 124
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0415. كيف تتصرف حسب الإشارة ؟",
      numQues: "0415",
      correctAnswer: "أعطِ حق الأولوية في الطريق الضيقة.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3415.jpg",
      choices: [
        "تابع سيرك كالمعتاد، لك حق الأولوية بالنسبة لحركة السير المقابلة، استمر بالسير كالمعتاد.",
        "أعطِ غماز إلى اليسار واعبر بحذر إلى المسلك الأيسر مع النظر في المرايا.",
        "تمهل وسر إلى اليمين وانتبه لحركة السير القادمة من الاتجاه المعاكس.",
        "أعطِ حق الأولوية في الطريق الضيقة."
      ],
      id: 125
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0889. كيف يجب أن يكون رد فعل سائق المركبة الفضية عندما يريد سائق المركبة الغامقة اللون إيقاف مركبته بين المركبتين بجانب الرصيف بالرجوع إلى الخلف؟",
      numQues: "0889",
      correctAnswer: "يقترب من المركبة الغامقة اللون ويستعمل الزامور ويتجاوزه بحذر.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3889.jpg",
      choices: [
        "يدخل إلى الموقف بنفسه ولا يدع سائق المركبة الغامقة اللون يقف.",
        "يتابع سيره كالمعتاد وكأنه لم يدرك نية سائق المركبة الغامقة اللون.",
        "يتمهل وحتى يتوقف ويُمكِن سائق المركبة الغامقة اللون من إكمال الوقوف.",
        "يقترب من المركبة الغامقة اللون ويستعمل الزامور ويتجاوزه بحذر."
      ],
      id: 126
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0176. أي شارع من الشوارع الظاهرة في الصورة هو شارع باتجاه واحد؟",
      numQues: "0176",
      correctAnswer: "الشارع 'أ' (A) والشارع 'ج' (C). ",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3176.jpg",
      choices: [
        "الشارع 'ب' (B) والشارع 'ج' (C). ",
        "الشارع 'ج' (C) فقط.",
        "الشارع 'أ' (A).",
        "الشارع 'أ' (A) والشارع 'ج' (C). "
      ],
      id: 127
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "0328. ما هي درجة الرخصة المطلوبة لسياقة تراكتور؟",
      numQues: "0328",
      correctAnswer: "درجة B.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "درجة C.",
        "درجة 1.",
        "درجة D.",
        "درجة B."
      ],
      id: 128
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1182. ما هي أجرة نقل عربة معاق في الصالون العمومي؟",
      numQues: "1182",
      correctAnswer: "نصف أجرة تعرفة '1'.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "نصف أجرة السفر في خط خدمة.",
        "ممنوع جباية أجرة إضافية عن نقل عربة معاق – فقط أجرة نقل المعاق نفسه.",
        "ممنوع جباية أجرة عندما لا يسافر المعاق في الصالون العمومي.",
        "نصف أجرة تعرفة '1'."
      ],
      id: 129
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0628. إلى ماذا تشير الإشارة؟",
      numQues: "0628",
      correctAnswer: "منطقة يُمنع الأولاد من اللعب فيها.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3628.jpg",
      choices: [
        "نهاية الشارع المختلط (الموحد).",
        "منطقة ممنوع الوقوف فيها.",
        "شارع مختلط (موحد).",
        "منطقة يُمنع الأولاد من اللعب فيها."
      ],
      id: 130
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0086. في شارع باتجاه واحد، لمن يُسمح بالسياقة بعكس اتجاه السير ؟",
      numQues: "0086",
      correctAnswer: "ممنوع السياقة بهذا الشكل في أي ظرف حتى لو أمر الشرطي بغير ذلك.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "ممنوع، إلا إذا كانت المركبة مركبة امن أثناء الوظيفة أو بناءً على أوامر شرطي.",
        "مسموح السياقة بهذا الشكل لراكبي الدراجات النارية فقط.",
        "مسموح السياقة بهذا الشكل في أيام الأعياد عندما تكون حركة السير خفيفة ولا يؤدي ذلك إلى إعاقة حركة السير.",
        "ممنوع السياقة بهذا الشكل في أي ظرف حتى لو أمر الشرطي بغير ذلك."
      ],
      id: 131
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0807. ما هو القصد من المصطلح 'السياقة بسرعة معقولة'؟",
      numQues: "0807",
      correctAnswer: "السياقة بسرعة حسب رغبة السائق، بشرط أن لا تزيد عن السرعة القصوى المسموح بها المحددة في القانون.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "السياقة بسرعة مشابهة لسرعة السائقين الآخرين الذين حولك. ",
        "السياقة التي تمكن السائق أيضاَ من تنفيذ عمليات أخرى غير حيوية للسياقة.",
        "مراعاة السائق وضع الطريق وحركة السير فيها يمكنه من السيطرة التامة على المركبة في كل وقت.",
        "السياقة بسرعة حسب رغبة السائق، بشرط أن لا تزيد عن السرعة القصوى المسموح بها المحددة في القانون."
      ],
      id: 132
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1659. ما هي الأمور المهمة التي يجب التركيز عليها عند ركوب اثنين على الدراجة النارية؟",
      numQues: "1659",
      correctAnswer: "يجب إرشاد الراكب بخصوص الصعود الصحيح على الدراجة النارية، أما باقي الأمور فهي ثانوية. ",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "يجب إرشاد الراكب قبل السفر في كل ما يتعلق بالصعود والنزول والجلوس بصورة صحيحة وكيفية تصرف الجسم.",
        "يجب تحديد رموز اتصال بين الراكب والسائق، وكل ما تبقى لا أهمية له.",
        "يجب التأكد بأن لا يزيد وزن الراكب عن وزن سائق الدراجة النارية.",
        "يجب إرشاد الراكب بخصوص الصعود الصحيح على الدراجة النارية، أما باقي الأمور فهي ثانوية. "
      ],
      id: 133
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1273. ما هي العمليات، حسب القانون، التي على السائق القيام بها قبل صعوده إلى الباص؟",
      numQues: "1273",
      correctAnswer: "فقط فحص وجود عابري طريق في الجوار القريب.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "تنظيف المرايا والزجاج الخلفي والأمامي.",
        "تنظيف المرايا والزجاج الخلفي.",
        "فحص امني وفحص السلامة.",
        "فقط فحص وجود عابري طريق في الجوار القريب."
      ],
      id: 134
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1229. أين تخصص الأماكن لأفراد الأمن في باص يعمل على خط خدمة؟",
      numQues: "1229",
      correctAnswer: "المقعد المزدوج بعد القاطع الذي خلف السائق. ",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "عند السفر في طريق ليست بلدية - المقعدين الأماميين على جانبي الممر.",
        "في باص داخل المدن - مقابل الباب الخلفي.",
        "المقعد الذي خلف الباب الأمامي والمقعد الذي خلف الباب الخلفي.",
        "المقعد المزدوج بعد القاطع الذي خلف السائق. "
      ],
      id: 135
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0239. هل يجوز نقل ركاب بالأجرة في مركبة ركاب خصوصية ؟",
      numQues: "0239",
      correctAnswer: "ممنوع.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "مسموح، فقط في السفريات خارج المدن",
        "مسموح إذا دفع الركاب أجرة كما في الباص.",
        "مسموح في حالة إضراب في المواصلات العمومية.",
        "ممنوع."
      ],
      id: 136
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0522. يسري مفعول الإشارة 424 لغاية:",
      numQues: "0522",
      correctAnswer: "432",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3522.jpg",
      choices: [
        "220",
        "425",
        "301",
        "432"
      ],
      id: 137
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0949. ما هو الشيء غير الصحيح في تصرف سائق المركبة الزرقاء (1)؟",
      numQues: "0949",
      correctAnswer: "سائق المركبة الزرقاء (1) يسير في المسلك الأيسر بدلاً عن المسلك الأيمن. ",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3949.jpg",
      choices: [
        "سائق المركبة الزرقاء (1) لا يُشغل جهاز إعطاء الإشارة (الغماز) الكهربائي.",
        "بالرغم من أن الجو غائم، إلا أن أضواء المركبة الزرقاء (1) غير مضاءة.",
        "سائق المركبة الزرقاء (1) لا يحافظ على مسافة كبيرة كافية من المركبة التي أمامه.",
        "سائق المركبة الزرقاء (1) يسير في المسلك الأيسر بدلاً عن المسلك الأيمن. "
      ],
      id: 138
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1233. أي باص ملزم بمخفف السرعة؟",
      numQues: "1233",
      correctAnswer: "كل باص مرخص لنقل 20 راكباً أو أكثر.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "كل باص مثبت فيه مخفف سرعة عند إنتاجه.",
        "كل باص مثبت فيه جهاز تاكوغراف.",
        "الباص الذي وزنه الإجمالي 10000كغم أو أكثر.",
        "كل باص مرخص لنقل 20 راكباً أو أكثر."
      ],
      id: 139
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1000. كيف يكون وضع صندوق الغيارات عند السير المتواصل في منحدر ؟",
      numQues: "1000",
      correctAnswer: "تكون عصا صندوق الغيارات معشقة بالغيار النيوترال.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "لا توجد أهمية بأي غيار معشق صندوق الغيارات عند السير المتواصل في منحدر طويل، المهم أن تكون الفرامل سليمة.",
        "تكون عصا صندوق الغيارات معشقة بغيار واطئ.",
        "تكون عصا صندوق الغيارات معشقة بغيار عالي.",
        "تكون عصا صندوق الغيارات معشقة بالغيار النيوترال."
      ],
      id: 140
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0220. حسب طريقة النقاط:",
      numQues: "0220",
      correctAnswer: "سلطة الترخيص غير مخولة بسحب رخصة سياقة.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "يجوز لسلطة الترخيص إلزام سائق، تم تجميع نقاط بحقه، بامتحانات ويجوز لها أيضاً سحب رخصته. ",
        "يجوز فقط لضابط الشرطة سحب رخصة السياقة. ",
        "يجوز فقط لمحكمة السير سحب رخصة السياقة.",
        "سلطة الترخيص غير مخولة بسحب رخصة سياقة."
      ],
      id: 141
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0526. يسري مفعول الإشارة:",
      numQues: "0526",
      correctAnswer: "لغاية الإشارة التي تعني محطة باص.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3015.jpg",
      choices: [
        "لغاية المفترق القريب فقط والذي نُصبت فيه إشارة ضوئية (رمزور).",
        "لغاية المفترق القريب أو لغاية الإشارة التي تنهيها أو لغاية الإشارة 'موقف مركبات'.",
        "لغاية الإشارة التي تعني سرعة خاصة.",
        "لغاية الإشارة التي تعني محطة باص."
      ],
      id: 142
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1285. أي نوع من مركبات 'شرطة البلدية' يجوز لها بعث نور ازرق مع نور اصفر؟",
      numQues: "1285",
      correctAnswer: "مركبة مشتركة من السلطة المحلية والشرطة.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "مركبة إطفاء حريق.",
        "مركبة تخليص.",
        "مركبة إسعاف.",
        "مركبة مشتركة من السلطة المحلية والشرطة."
      ],
      id: 143
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1492. أنت تسير في شارع باتجاهين وأمامك تسير مركبة تؤشر بغمازها الأيسر:",
      numQues: "1492",
      correctAnswer: "مسموح تجاوزها من اليمين بواسطة النزول على حاشية الطريق.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "مسموح تجاوزها إذا استعملت الزامور لتحذيره، وإشارته لا تلزمك.",
        "ممنوع تجاوزها في شارع ضيق، مسموح تجاوزها من اليسار في شارع عريض.",
        "يجب الأخذ بعين الاعتبار بأن من شأن المركبة التي في الأمام الانحراف إلى اليسار، لذلك مكنه من فعل ذلك.",
        "مسموح تجاوزها من اليمين بواسطة النزول على حاشية الطريق."
      ],
      id: 144
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0776. ما هي الأخطار والمشاكل المميزة عند عبور المفترقات؟",
      numQues: "0776",
      correctAnswer: "عبور المفترق يستغرق وقتاً طويلاً حيث يغضب السائقون.",
      pubDate: "10-11-2011 08:22:38",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3776.jpg",
      choices: [
        "لا تُشكل المركبات التي تصل إلى المفترق من اتجاهات مختلقة أية مشكلة، وإنما المشاة فقط.",
        "نقاط الالتقاء الكثيرة بين المركبات من حركات السير المختلفة عن طريق المفترق.",
        "الأخطار والمشاكل المميزة قائمة في المفترقات التي فيها إشارات ضوئية (رمزورات) فقط.",
        "عبور المفترق يستغرق وقتاً طويلاً حيث يغضب السائقون."
      ],
      id: 145
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1474. الوزن الأقصى للحمولة التي يجوز لمركبة شاحنة بنقلها؟",
      numQues: "1474",
      correctAnswer: "لا يجب أن يزيد عن وزن الحمولة المسجل في رخصة المركبة.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "يجب أن يكون وزن الحمولة الوزن الذي حدده منتج المركبة بإضافة 50% على الأكثر.",
        "لا يجب أن يزيد عن الوزن الذي حدده منتج المركبة.",
        "يكون فقط حسب إنتاج إطارات المركبة.",
        "لا يجب أن يزيد عن وزن الحمولة المسجل في رخصة المركبة."
      ],
      id: 146
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1627. على ماذا يجب أن نحرص عند ركوب دراجة نارية بجانب مركبات أو بالقرب منها ؟",
      numQues: "1627",
      correctAnswer: "على مشاهدة المركبات الأخرى أبكر ما يمكن.",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "على تقليص المسافة والحيز اللذان يمكنان من رد الفعل.",
        "على ملاءمة السرعة لسرعة المركبات التي حولنا – حتى ولو كانت أسرع من السرعة القصوى المسموح بها.",
        "على الركوب والقدمين على الأرض لتحسين التوازن.",
        "على مشاهدة المركبات الأخرى أبكر ما يمكن."
      ],
      id: 147
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1524. أية مركبة شاحنة مُلزمة بتركيب فرملة محرك (طفاية اكزوست)؟",
      numQues: "1524",
      correctAnswer: "المركبة التي تسير بمحرك ديزل ووزنها الإجمالي المسموح به 8000كغم أو أكثر. ",
      pubDate: "10-11-2011 08:22:38",
      img: "",
      choices: [
        "مركبة شاحنة وزنها الإجمالي المسموح به 6000كغم أو أكثر.",
        "مركبة شاحنة وزنها الإجمالي المسموح به 5000كغم أو أكثر.",
        "مركبة شاحنة وزنها الإجمالي المسموح به 4000كغم أو أكثر.",
        "المركبة التي تسير بمحرك ديزل ووزنها الإجمالي المسموح به 8000كغم أو أكثر. "
      ],
      id: 148
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0938. كيف تتصرف حسب ما يظهر في الصورة عندما تسوق على الشارع؟",
      numQues: "0938",
      correctAnswer: "تابع سيرك دون أي تغيير في التصرف.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3938.jpg",
      choices: [
        "تجاهل المركبة التي تخرج من الطريق الترابية، لك حق الأولوية.",
        "تمهل وانتبه للمركبة التي تخرج من الطريق الترابية.",
        "أعطِ حق الأولوية للمركبة الخارجة من الطريق الترابية – تقع المسؤولية على السائق ولك حق الأولوية.",
        "تابع سيرك دون أي تغيير في التصرف."
      ],
      id: 149
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0104. لمن يُسمح بالسير بعكس اتجاه السير في شارع باتجاه واحد؟",
      numQues: "0104",
      correctAnswer: "فقط للذين يسوقون مركبات خصوصية.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "فقط للدراجات النارية والدراجات الهوائية.",
        "فقط للمركبة التي تنقل أربعة ركاب على الأقل.",
        "لمركبة امن فقط.",
        "فقط للذين يسوقون مركبات خصوصية."
      ],
      id: 150
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1771. ما هو ارتفاع الحمولة الأقصى المسموح تحميلها على مركبة لنقل المركبات ذات ثلاث مسطحات فوق بعضها البعض؟",
      numQues: "1771",
      correctAnswer: "5.20م.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "5.00م.",
        "4.80م.",
        "4.20م.",
        "5.20م."
      ],
      id: 151
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1066. أين تُثبت الجاك عندما تريد تغيير عجل في المركبة؟",
      numQues: "1066",
      correctAnswer: "في المكان الأكثر راحة لسائق المركبة.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "في المكان الذي وسمه (علمه) المنتج أو في مكان آمن آخر بالقرب من العجل الذي نريد تغييره.",
        "لا توجد أهمية للمكان.",
        "قريب على قدر الإمكان من القسم الخلفي للمركبة.",
        "في المكان الأكثر راحة لسائق المركبة."
      ],
      id: 152
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0215. هل يجوز إيقاف مركبة غير الصالون العمومي (التاكسي) في المكان الذي نُصبت فيه الإشارة؟",
      numQues: "0215",
      correctAnswer: "ممنوع ما عدا التوقف من اجل إنزال الركاب.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3215.jpg",
      choices: [
        "مسموح إذا لم تكن هناك مركبات صالون عمومي واقفة في المكان.",
        "مسموح فقط من اجل إصعاد الركاب.",
        "ممنوع في أية حالة من الأحوال.",
        "ممنوع ما عدا التوقف من اجل إنزال الركاب."
      ],
      id: 153
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0719. كيف تتصرف (المركبة رقم 3) في المفترق الذي أمامك- حسب القانون طبعاً؟",
      numQues: "0719",
      correctAnswer: "أعطِ حق الأولوية للمركبة الصفراء (2).",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3719.jpg",
      choices: [
        "اعبر بحذر، على السائقين الاثنين إعطاؤك (3) حق الأولوية. ",
        "أعطِ حق الأولوية للمركبة الزرقاء (1).",
        "أعطِ حق الأولوية للمركبتين (2+1).",
        "أعطِ حق الأولوية للمركبة الصفراء (2)."
      ],
      id: 154
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0361. أية إشارة تُحذر من اندماج طريق أخرى مع الشارع الذي تسير فيه ؟",
      numQues: "0361",
      correctAnswer: "307",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3361.jpg",
      choices: [
        "620",
        "124",
        "145",
        "307"
      ],
      id: 155
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0407. ما معنى الإشارة؟",
      numQues: "0407",
      correctAnswer: "خطوط تباطؤ (مطبات) أمامك.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3407.jpg",
      choices: [
        "شارع مشوش.",
        "طريق جبلية.",
        "أشغال في الشارع.",
        "خطوط تباطؤ (مطبات) أمامك."
      ],
      id: 156
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1405. هل يُشكل ما هو مسجل في سند الحمولة إثباتاً على وزن الحمولة؟",
      numQues: "1405",
      correctAnswer: "كلا، الوزن المسجل في سند الحمولة لا يشكل أمراً واقعاً موثوقاً ومقبولاً.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "نعم، فقط لحمولات وزنها 10000كغم على الأكثر.",
        "نعم.",
        "نعم، يُشكل تسجيل وزن الحمولة في سند الحمولة إثباتاً على صحة الوزن بحدود 20% أكثر أو اقل من المسجل في سند الحمولة.",
        "كلا، الوزن المسجل في سند الحمولة لا يشكل أمراً واقعاً موثوقاً ومقبولاً."
      ],
      id: 157
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1240. كيف يتصرف سائق الباص عندما يندلع شجار في مركبته بين الركاب؟",
      numQues: "1240",
      correctAnswer: "يوقف المركبة ويبتعد عن الباص.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "يتجاهل الأمر ويواصل سيره.",
        "يسير بالباص إلى مركز الشرطة القريب أو يتوجه إلى شرطي صادف وجوده في الطريق.",
        "يعود أدراجه إلى محطة الانطلاق.",
        "يوقف المركبة ويبتعد عن الباص."
      ],
      id: 158
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0263. في مركبة عرضها الإجمالي 210سم أو أكثر ومثبت فيها حسب القانون مصابيح عرض:",
      numQues: "0263",
      correctAnswer: "يجب على السائق إضاءة مصابيح العرض في 'وقت الإنارة'.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "يجب على السائق إضاءة مصابيح العرض فقط في طريق ليست بلدية.",
        "مسموح سياقة المركبة في أي وقت حتى وإن لم تعمل فيها مصابيح العرض.",
        "لا يجب على السائق إنارة مصابيح العرض في 'وقت الإنارة'.",
        "يجب على السائق إضاءة مصابيح العرض في 'وقت الإنارة'."
      ],
      id: 159
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0103. في الرسم الذي أمامك نرى طريق عريضة، بأي رقم موسومة (مؤشرة) حاشية الطريق في الرسم؟",
      numQues: "0103",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3082.jpg",
      choices: [
        "6",
        "7",
        "3",
        "1"
      ],
      id: 160
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1749. من هي 'السلطة' المختصة بإصدار رخصة تشغيل باص؟",
      numQues: "1749",
      correctAnswer: "مراقب السير على الطرق.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "المفتش العام لشرطة إسرائيل.",
        "مدير قسم المركبات في وزارة المواصلات.",
        "سلطة الترخيص الإقليمية.",
        "مراقب السير على الطرق."
      ],
      id: 161
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1669. كيف نوجه المرايا في الدراجة النارية؟",
      numQues: "1669",
      correctAnswer: "بواسطة قياس زاوية المرآة ومكانها في الحيز.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "بواسطة السفر البطيء والاستدارات إلى اليمين والى اليسار.",
        "فقط في مؤسسة ترخيص وبواسطة جهاز خاص.",
        "في وضع وقوف عندما تكون الزاوية بين الدراجة النارية ومقودها 90 درجة.",
        "بواسطة قياس زاوية المرآة ومكانها في الحيز."
      ],
      id: 162
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0369. أمامك الإشارة رقم: 303، أية إشارة تُنصب قبلها في بعض الأحيان؟",
      numQues: "0369",
      correctAnswer: "145",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3369.jpg",
      choices: [
        "122",
        "121",
        "114",
        "145"
      ],
      id: 163
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1383. على السائق الذي يقترب بمركبته من قمة (مرتفع) أو من مكان فيه مدى الرؤية محدود:",
      numQues: "1383",
      correctAnswer: "أن يخفف من سرعة سيره ويسير بسرعة معقولة تلائم مدى الرؤية.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "أن يُشغل الأربعة غمازات (مصابيح الطوارئ) من اجل تنبيه السائقين الآخرين.",
        "يستمر بسرعة السير العادية.",
        "أن يزيد من السرعة ويسير على حاشية الطريق.",
        "أن يخفف من سرعة سيره ويسير بسرعة معقولة تلائم مدى الرؤية."
      ],
      id: 164
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1445. هل يجوز لتراكتور الدخول إلى طريق سريعة؟",
      numQues: "1445",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "كلا.",
        "يجوز في ساعات النهار فقط.",
        "يجوز ، بشرط أن لا يجر مقطورة.",
        "نعم."
      ],
      id: 165
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1108. يجري تحرير (فك ) الأدوات والمجرور من التراكتور:",
      numQues: "1108",
      correctAnswer: "على سطح من الباطون أو الاسلفت فقط.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "في سهل منحدر للتسهيل على الأشياء المربوطة.",
        "في مكان أفقي (مستوي)، لمنع التحرك صدفة.",
        "في أي مكان كان، لا توجد أهمية لوضع السطح.",
        "على سطح من الباطون أو الاسلفت فقط."
      ],
      id: 166
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1443. عرف 'مركبة موصولة':",
      numQues: "1443",
      correctAnswer: "مركبة لنقل الحمولات الطويلة.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "مركبة ميكانيكية أُلحقت بها قاطرة من الخلف.",
        "مركبة ميكانيكية تجر مركبة ميكانيكية.",
        "ساندة موصول بها مستندة.",
        "مركبة لنقل الحمولات الطويلة."
      ],
      id: 167
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0463. كيف تتصرف حسب الإشارة؟",
      numQues: "0463",
      correctAnswer: "قف قبل الإشارة.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3461.jpg",
      choices: [
        "استعد لإيقاف مركبتك بعد حوالي 300م.",
        "أعطِ حق الأولوية للمركبة الموجود حول الدوار.",
        "استعد لإيقاف المركبة في المفترق القريب، التوقف هناك إلزامي.",
        "قف قبل الإشارة."
      ],
      id: 168
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0158. عند اقترابك من ملتقى سكة حديد وهناك قطار يقترب يُرى أو يُسمع أو يُطلق إشارة تنبيه:",
      numQues: "0158",
      correctAnswer: "توقف قبل الملتقى إلى أن يمر القطار.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3158.jpg",
      choices: [
        "اعبر الملتقى بحذر بأية سرعة ملائمة.",
        "زد من سرعتك واعبر الملتقى قبل القطار بحذر وبيقظة.",
        "إذا كان القطار بعيداً، اعبر الملتقى بسرعة.",
        "توقف قبل الملتقى إلى أن يمر القطار."
      ],
      id: 169
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1151. هل يجب تركيب تاكوغراف في الباص الذي يعمل على خط خدمة؟",
      numQues: "1151",
      correctAnswer: "كلا، الإلزام فقط في المركبة التجارية.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "كلا.",
        "يجب فقط في الزوتوبوس (الصالون العمومي الكبير).",
        "نعم.",
        "كلا، الإلزام فقط في المركبة التجارية."
      ],
      id: 170
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0925. مَن مِن بين الظاهرين في الصورة عليه اتخاذ خطوات لتجنب حادث ؟",
      numQues: "0925",
      correctAnswer: "الماشي، عليه زيادة سرعة سيره لإكمال العبور.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3925.jpg",
      choices: [
        "المركبة والماشي بعيدين عن بعضهم البعض ولا توجد ضرورة لأية خطوات.",
        "الماشي، القانون يلزمه بأن يتوقف ويدع المركبة تواصل سيرها.",
        "السائق، عليه أن يتمهل ويستعد للتوقف.",
        "الماشي، عليه زيادة سرعة سيره لإكمال العبور."
      ],
      id: 171
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0525. ماذا تعني الإشارة:",
      numQues: "0525",
      correctAnswer: "مسموح التوقف والوقوف ما عدا أيام السبت والأعياد.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3015.jpg",
      choices: [
        "مسموح التوقف لكن ممنوع الوقوف.",
        "ممنوع توقف مركبة على جانبي الطريق. ",
        "ممنوع وقوف أو توقف مركبة في الطريق وفي الجانب الذي نُصبت فيه الإشارة.",
        "مسموح التوقف والوقوف ما عدا أيام السبت والأعياد."
      ],
      id: 172
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1324. أية مركبة تحتاج إلى سلاسل وأعلام (إنارة محيطة)؟",
      numQues: "1324",
      correctAnswer: "المقطورة وكذلك المستندة اللتان لا يوجد لهما أرضية وجوانب.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "المركبة التي تنقل مواد خطرة.",
        "المركبة التي تنقل لفائف (رولات) من الفولاذ.",
        "المركبة التي تنقل مادة يتصاعد منها الغبار.",
        "المقطورة وكذلك المستندة اللتان لا يوجد لهما أرضية وجوانب."
      ],
      id: 173
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0577. ما معنى الإشارة؟",
      numQues: "0577",
      correctAnswer: "سبيل للدراجات الهوائية فقط.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3577.jpg",
      choices: [
        "سبيل مشترك للدراجات الهوائية والمشاة.",
        "مكان عبور راكبي الدراجات الهوائية.",
        "سبل منفصلة للدراجات الهوائية في الطريق السريعة.",
        "سبيل للدراجات الهوائية فقط."
      ],
      id: 174
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1217. لمن يجب تسليم المفقودات التي وُجدت في المركبة العمومية؟",
      numQues: "1217",
      correctAnswer: "للشرطة أو لأي جهة أخرى حسب النظام المحدد سلفاً مع صاحب خط الخدمة.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "لمنظم الحركة في محطة الباص لنفس خط الخدمة.",
        "لمنظم الحركة في محطة الصالون العمومي لنفس خط الخدمة.",
        "لا يجب تسليمها لأي شخص، يجب العثور على صاحب المفقودات وإعادتها إليه.",
        "للشرطة أو لأي جهة أخرى حسب النظام المحدد سلفاً مع صاحب خط الخدمة."
      ],
      id: 175
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0775. كيف يؤثر تصرف الماشي على السائق في منطقة 'المفترق'؟",
      numQues: "0775",
      correctAnswer: "يُشغل الماشي ممر المشاة لفترة طويلة ويُسبب في عرقلة لحركة السير.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "على السائق أن يتوقع سلفاً إمكانية تصرفات خطرة من الماشي في منطقة المفترق.",
        "الماشي ليس عنصراً ذو أهمية بالنسبة للتأثير على السائق",
        "الارتباك الأساسي في المفترق ينتج عن احتشاد المشاة على الرصيف.",
        "يُشغل الماشي ممر المشاة لفترة طويلة ويُسبب في عرقلة لحركة السير."
      ],
      id: 176
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0708. كيف تتصرف (مركبة رقم 3) عند اقترابك من المفترق (المركبة الحمراء ليست مركبة أمن)؟",
      numQues: "0708",
      correctAnswer: "لك (3) حق الأولوية لأنك تقطع بخط مستقيم. ",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3708.jpg",
      choices: [
        "تدخل إلى المفترق قبل شاحنة القمامة (2) لأن عليها إعطاؤك حق الأولوية (أنت 3 قادم من اليمين).",
        "أعطِ حق الأولوية فقط للتراكتور القادم من اليمين (1).",
        "أعطِ حق الأولوية للتراكتور (1) وللشاحنة (2) اللذان يقطعان الطريق.",
        "لك (3) حق الأولوية لأنك تقطع بخط مستقيم. "
      ],
      id: 177
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1282. يُمنع نقل تلاميذ في مركبة معدة لنقل التلاميذ:",
      numQues: "1282",
      correctAnswer: "وهم واقفون.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "وهم جالسون.",
        "إلا إذا كانوا برفقة دليل.",
        "إلا إذا كانوا جميعهم جالسين ووجوههم نحو السائق. ",
        "وهم واقفون."
      ],
      id: 178
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0766. ما هو ترتيب العمليات للتوقف أو الوقوف؟",
      numQues: "0766",
      correctAnswer: "لا توجد أهمية لترتيب العمليات قبل الوقوف. ",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "التمهل، الانحراف، التوقف، إعطاء الإشارة.",
        "التأكد إذا كان ذلك مسموحاً وإجراء فحص لما يجري حولنا والتمهل بحذر.",
        "الترتيب غير مهم – المهم الانتباه.",
        "لا توجد أهمية لترتيب العمليات قبل الوقوف. "
      ],
      id: 179
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1320. أي سائق عليه أن يستريح 7 ساعات متواصلة على الأقل قبل البدء بيوم عمله؟",
      numQues: "1320",
      correctAnswer: "كل صاحب رخصة من الدرجة 1 .",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "السائقين الذين ينقلون مادة خطرة.",
        "سائق المركبة العمومية والمركبة التجارية التي يزيد وزنها الإجمالي عن 6000كغم والمركبة التي تنقل 11 راكب أو أكثر.",
        "كل صاحب رخصة سياقة من الدرجة B .",
        "كل صاحب رخصة من الدرجة 1 ."
      ],
      id: 180
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1192. هل يُعفى الركاب في المقعد الخلفي للصالون العمومي من واجب استعمال حزام الأمان في طريق بلدية؟",
      numQues: "1192",
      correctAnswer: "نعم، هم معفيون فقط في طريق بلدية فيها مساحة فاصلة.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "كلا.",
        "نعم.",
        "فقط عندما يسافروا في الطرق الترابية.",
        "نعم، هم معفيون فقط في طريق بلدية فيها مساحة فاصلة."
      ],
      id: 181
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0778. أشر إلى الجملة الصحيحة بالنسبة لتصرف المشاة بالقرب من المفترق؟",
      numQues: "0778",
      correctAnswer: "لا يجب على الماشي عند عبوره ممر المشاة الأخذ بعين الاعتبار السائقين المقتربين من المفترق.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "لا يوجد خطر على المشاة بالقرب من المفترق.",
        "مكان العبور الأكثر أمانا نسبياً للماشي هو ممر المشاة المجاور للمفترق لأن على سائق المركبة أن يتمهل في منطقة المفترق.",
        "المفترق هو المكان الأشد خطراً في الشارع لأن السائقين لا يعيرون الانتباه بما فيه الكفاية للمشاة وإنما للإشارات الضوئية (الرمزورات) فقط.",
        "لا يجب على الماشي عند عبوره ممر المشاة الأخذ بعين الاعتبار السائقين المقتربين من المفترق."
      ],
      id: 182
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1739. عندما تعطي المركبة التي أمامك إشارة بأنها تريد الاستدارة إلى اليسار:",
      numQues: "1739",
      correctAnswer: "التجاوز يكون من الجهة اليسرى فقط.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "ممنوع العبور عن المركبة من جهتها اليمنى.",
        "مسموح العبور عنها من جهتها اليمنى.",
        "ممنوع عبورها من أية جهة.",
        "التجاوز يكون من الجهة اليسرى فقط."
      ],
      id: 183
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0482. ما معنى الإشارة؟",
      numQues: "0482",
      correctAnswer: " لافتة الإعلام التي فوق الإشارة أو تحتها مُعده لمن يستدير باتجاه السهم.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3482.jpg",
      choices: [
        "ممنوع الاستدارة إلى اليمين.",
        "الاستدارة إلى اليمين إلى شارع باتجاه واحد.",
        "يُسمح بالاستدارة إلى اليمين للمركبات البطيئة فقط.",
        " لافتة الإعلام التي فوق الإشارة أو تحتها مُعده لمن يستدير باتجاه السهم."
      ],
      id: 184
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "1539. يجب وسم (تأشير) حمولة بارزة من خلف المركبة:",
      numQues: "1539",
      correctAnswer: "بعلم احمر مربوط على طرف الحمولة البارزة.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "بعلم ابيض مربوط على طرف الحمولة البارزة.",
        "بمثلث ابيض عاكس طول كل ضلع من أضلاعه 60سم.",
        "بمثلث احمر عاكس طول كل ضلع من أضلاعه 60سم.",
        "بعلم احمر مربوط على طرف الحمولة البارزة."
      ],
      id: 185
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0105. بأية شروط يُسمح بالانحراف عن مسلك السير؟",
      numQues: "0105",
      correctAnswer: "عند السير بسرعة بطيئة وتنفيذ انحراف حاد.",
      pubDate: "10-11-2011 08:22:39",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3105.jpg",
      choices: [
        "ممنوع الانحراف منعاً باتاً عن مسلك السير.",
        "بعد إعطاء الإشارة والنظر في المرايا فقط..",
        "بشرط أن لا يُسبب ذلك خطر أو عرقلة لعابري الطريق.",
        "عند السير بسرعة بطيئة وتنفيذ انحراف حاد."
      ],
      id: 186
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1058. ما هو التواتر الصحيح (الفترات الصحيحة) لإجراء الصيانة للمركبة؟",
      numQues: "1058",
      correctAnswer: "التواتر الذي يوصي به صاحب الكراج المعتمد الذي يعتني بالمركبة.",
      pubDate: "10-11-2011 08:22:39",
      img: "",
      choices: [
        "التواتر (الفترة) التي يوصي به منتج المركبة.",
        "التواتر الذي توصي به شركة التأمين.",
        "التواتر يُحدد حسب الحاجة وفترات اكتشاف الأعطال في المركبة.",
        "التواتر الذي يوصي به صاحب الكراج المعتمد الذي يعتني بالمركبة."
      ],
      id: 187
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1057. ما هي 'الصيانة الواقية' للمركبة؟",
      numQues: "1057",
      correctAnswer: "الصيانة المنتظمة والمخطط لها والتي تحافظ على سلامة المركبة وأجهزتها.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "الصيانة التي تمنع إمكانية السياقة بسرعة مبالغ فيها.",
        "الصيانة التي تمنع المركبة من السير بصورة سليمة.",
        "الصيانة حسب تقدير السائق فقط والتي تهدف إلى منع وقوع حادث.",
        "الصيانة المنتظمة والمخطط لها والتي تحافظ على سلامة المركبة وأجهزتها."
      ],
      id: 188
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0681. كيف يجب عليك أن تتصرف عند اقترابك من الحاجز عندما يكون نازلاً (أي أفقي)؟",
      numQues: "0681",
      correctAnswer: "ممنوع الوقوف والتوقف، عليك عبور الحاجز من يمينه.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3680.jpg",
      choices: [
        "عليك التوقف قبله وعدم متابعة السير طالما كان الحاجز في حالة حركة أو نازلاً (بشكلٍ أفقي).",
        "عليك التوقف وإطفاء محرك المركبة.",
        "عليك متابعة سيرك بحذر حول الحاجز أو من تحته.",
        "ممنوع الوقوف والتوقف، عليك عبور الحاجز من يمينه."
      ],
      id: 189
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0559. مسموح الاستدارة إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس) :",
      numQues: "0559",
      correctAnswer: "فقط من المسلك الأيسر الأقصى الذي يُسمح لك السير فيه.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "من كل مسلك في الشارع مؤشر بأسهم للاستدارة إلى اليسار أو إلى اليمين.",
        "من مسلك الاستدارة إلى اليسار ومن كل مسلك آخر لا توجد فيه إشارة أو علامة تمنع مثل هذه الاستدارة.",
        "من مسلك الاستدارة إلى اليسار فقط.",
        "فقط من المسلك الأيسر الأقصى الذي يُسمح لك السير فيه."
      ],
      id: 190
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1508. ما هي الأخطار المتوقعة من السياقة المتواصلة لساعات عديدة؟",
      numQues: "1508",
      correctAnswer: "مخالفة قانون التأمين.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "سخونة واهتراء سريع لإطارات المركبة.",
        "سخونة زائدة لمحرك المركبة.",
        "التعب وخطر إغفاء السائق.",
        "مخالفة قانون التأمين."
      ],
      id: 191
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0049. أية شهادات يجب أن تكون مع السائق عند السياقة ؟",
      numQues: "0049",
      correctAnswer: "الهوية الشخصية ورخصة السياقة وشهادة على صلاحية المركبة موقعة من قبل مدير كراج.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "الهوية الشخصية ورخصة السياقة وشهادة التأمين الشامل وشهادة بشأن ترتيبات الجر عند حدوث خلل.",
        "رخصة السياقة ورخصة المركبة فقط.",
        "رخصة السياقة ورخصة المركبة وشهادة التأمين الإلزامي وأيضاً كل شهادة أخرى صدرت بموجب أي قانون بحيث تكون جميعها سارية المفعول.",
        "الهوية الشخصية ورخصة السياقة وشهادة على صلاحية المركبة موقعة من قبل مدير كراج."
      ],
      id: 192
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0575. ما معنى الإشارة؟",
      numQues: "0575",
      correctAnswer: "ممنوع دخول المركبات بما في ذلك عربة اليد.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3575.jpg",
      choices: [
        "ممنوع الدخول للعربات المربوطة بالحيوانات وأيضاً للحيوانات غير المربوطة.",
        "ممنوع دخول المركبات التي تنقل مركبات.",
        "مسموح الدخول للخيالة فقط.",
        "ممنوع دخول المركبات بما في ذلك عربة اليد."
      ],
      id: 193
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1485. ما هي 'مصابيح الطوارئ' في المركبة؟",
      numQues: "1485",
      correctAnswer: "مصابيح التحذير المثبتة على سطح المركبة.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "جميع الغمازات عندما تضيء معاً بضوء متقطع.",
        "مثلث تحذير مُركب عليه مصابيح.",
        "مصباح فرملة إضافي بارتفاع النافذة.",
        "مصابيح التحذير المثبتة على سطح المركبة."
      ],
      id: 194
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1673. على ماذا يجب أن نحرص عند شراء إطار مستعمل وصالح للمركبة؟",
      numQues: "1673",
      correctAnswer: "فقط إذا كان قياس الإطار الجديد مشابه لقياس الإطار القديم.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "على تاريخ إنتاج الإطار من اجل التأكد بأن عمر الإطار ليس أقدم من اللازم (عمره أكثر من سنتين).",
        "فقط إذا كان قياس ضغط الهواء في الإطار الجديد مشابه لقياس ضغط الهواء في الإطار القديم.",
        "فقط إذا كان شكل نعل الإطار (وجه الإطار) الجديد مشابه لنعل الإطار القديم.",
        "فقط إذا كان قياس الإطار الجديد مشابه لقياس الإطار القديم."
      ],
      id: 195
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1711. ما معنى الإشارة؟",
      numQues: "1711",
      correctAnswer: "لوحة متنقلة تضيء بضوء متقطع: قبل معبر من طريق ليست بلدية إلى طريق سريعة.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31711.jpg",
      choices: [
        "لوحة متنقلة تضيء بضوء متقطع: إشارة تحذير وتوجيه قبل الدخول لمنطقة مطار.",
        "لوحة متنقلة تضيء بضوء متقطع: إشارة تحذير وتوجيه في المكان وتنصب في موقع عمل في الطريق.",
        "لوحة متنقلة تضيء بضوء متقطع: لغرض الدعاية لسائقي المركبات.",
        "لوحة متنقلة تضيء بضوء متقطع: قبل معبر من طريق ليست بلدية إلى طريق سريعة."
      ],
      id: 196
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1792. يسمح القانون بالسير في ساعات النهار في الصيف:",
      numQues: "1792",
      correctAnswer: "بدون ماسحات زجاج على الإطلاق.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "إذا كانت الاضوء في المركبة غير سليمة.",
        "جميع الإجابات غير صحيحة.",
        "بإطارات عمق أخاديدها (فرزاتها) اقل من مليمتر واحد.",
        "بدون ماسحات زجاج على الإطلاق."
      ],
      id: 197
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1221. أين توضع سلال القمامة (الزبالة) في الصالون العمومي؟",
      numQues: "1221",
      correctAnswer: "بجانب كل نافذة في الصالون العمومي.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "بجانب الأبواب من الجهة اليسرى.",
        "على جانبي المقاعد الخلفية.",
        "بجانب مقعد السائق وبجانب المقعد الخلفي.",
        "بجانب كل نافذة في الصالون العمومي."
      ],
      id: 198
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1047. ما هو الخطر الكامن من ضغط هواء منخفض في احد العجلات الأمامية للمركبة:",
      numQues: "1047",
      correctAnswer: "لا يوجد أي خطر طالما كانت نسبة الضغط في الإطارات تساوي ",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "من شأنه أن يؤدي إلى انحراف المركبة للجهة التي فيها ضغط الهواء اقل.",
        "من شأنه أن يؤدي إلى شد المقود للجهة التي فيها ضغط الهواء أكثر.",
        "لا يوجد أي خطر ولا توجد أية أهمية لمقدار ضغط الهواء في الإطارات الأمامية.",
        "لا يوجد أي خطر طالما كانت نسبة الضغط في الإطارات تساوي "
      ],
      id: 199
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0999. كيف يجب عليك التصرف إذا اكتشفت خللاً في جهاز الفرامل أثناء سياقتك المركبة؟",
      numQues: "0999",
      correctAnswer: "التوقف حالاً عن سياقة المركبة، والاهتمام بجرها إلى الكراج للفحص.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "تخفيف سرعة السير، والاعتماد على جهاز ال- 'أي.بي.أس' (ABS).",
        "تخفيف سرعة السير، ومحاولة التعود على الوضع وإنهاء السير بأمان.",
        "مواصلة السير بحذر شديد واستعمال الفرملة المساعدة (الهاندبريك).",
        "التوقف حالاً عن سياقة المركبة، والاهتمام بجرها إلى الكراج للفحص."
      ],
      id: 200
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1269. هل يُسمح لصالون عمومي بدون ركاب السير في المسلك الموسوم (المؤشر) كمسلك للمواصلات العمومية؟",
      numQues: "1269",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31269.jpg",
      choices: [
        "نعم ، في طريق بلدية وبشرط عدم عرقلة حركة السير.",
        "نعم.",
        "نعم، أيام السبت والأعياد فقط.",
        "كلا."
      ],
      id: 201
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1208. على من يقع واجب تنظيف الباص من الداخل؟",
      numQues: "1208",
      correctAnswer: "على منظم الحركة في شركة الباص.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "على من بحوزته المركبة.",
        "على صاحب المركبة.",
        "على سائق الباص.",
        "على منظم الحركة في شركة الباص."
      ],
      id: 202
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0041. إذا صدر إشعار بعدم استعمال المركبة (تنزيل عن الشارع) :",
      numQues: "0041",
      correctAnswer: "يجوز السير بالمركبة بدون أي تحديد إذا كانت لا تُشكل خطراً على السلامة المرورية.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "يُمنع السير بها على الطريق إلا إذا سُمح بذلك على نموذج التنزيل.",
        "يجوز السير بالمركبة لمدة لا تزيد عن أسبوع من تاريخ التنزيل.",
        "يُمنع السير بالمركبة دون إذن من شركة التأمين.",
        "يجوز السير بالمركبة بدون أي تحديد إذا كانت لا تُشكل خطراً على السلامة المرورية."
      ],
      id: 203
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0182. أين يجب التوقف حسب الظاهر في الصورة؟",
      numQues: "0182",
      correctAnswer: "قبل العامود التي نُصبت عليه الإشارة.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3182.jpg",
      choices: [
        "قبل خط التوقف وبالقرب منه.",
        "بعد مكان عبور المشاة ولكن قبل المفترق.",
        "لا توجد أهمية لمكان التوقف، لكن يجب التوقف قبل الدخول إلى المفترق.",
        "قبل العامود التي نُصبت عليه الإشارة."
      ],
      id: 204
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0659. ما معنى الوسم (التأشير) على سطح الشارع؟",
      numQues: "0659",
      correctAnswer: "مكان يُسمح فيه بالوقوف لفترة قصيرة فقط.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3659.jpg",
      choices: [
        "مكان يُمنع فيه الوقوف.",
        "جزيرة سير مرسومة في وسط الشارع.",
        "منطقة وقوف للمركبات العمومية.",
        "مكان يُسمح فيه بالوقوف لفترة قصيرة فقط."
      ],
      id: 205
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0329. ما هي درجة الرخصة المطلوبة لسياقة مركبة ميكانيكية وزنها الإجمالي لغاية عن 3500كغم؟",
      numQues: "0329",
      correctAnswer: "A.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "B.",
        "A1.",
        "1",
        "A."
      ],
      id: 206
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1517. رخصة سياقة من الدرجة 'B' تسمح بسياقة:",
      numQues: "1517",
      correctAnswer: "مركبة عمومية بما في ذلك الباص الصغير العمومي.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3091.jpg",
      choices: [
        "دراجة نارية قوة محركها لغاية 14.6 حصان.",
        "مركبة ركاب خصوصية ومركبة تجارية وزنها الإجمالي المسموح به لغاية 4500كغم.",
        "مركبة ركاب خصوصية ومركبة تجارية وزنها الإجمالي المسموح به لغاية 3500كغم.",
        "مركبة عمومية بما في ذلك الباص الصغير العمومي."
      ],
      id: 207
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0128. في أية حالات يُسمح لك بعبور مركبة أخرى من جهتها اليمنى؟",
      numQues: "0128",
      correctAnswer: "فقط عندما تسوق دراجة نارية.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "عند تسير مركبة أمامك في المسلك الأيسر بسرعة أقل سرعتك.",
        "عندما تسوق في المسلك المُعد فقط للاستدارة إلى اليسار.",
        "عندما تسوق في المسلك المُعد فقط للاستدارة إلى اليمين.",
        "فقط عندما تسوق دراجة نارية."
      ],
      id: 208
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0980. هل حسب رأيك، مكان المركبة البيضاء صحيح داخل المنعطف؟",
      numQues: "0980",
      correctAnswer: "نعم، عند السير في منعطف حاد، يجب تقصير مدة البقاء في المنعطف، لذلك مكانها صحيح.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3980.jpg",
      choices: [
        "كلا، المركبة قريبة لوسط الطريق وتشكل خطراً للمركبات القادمة مقابلها.",
        "نعم، في المنعطفات الحادة، ولكي نقلل من القوة الطاردة عن المركز، يجب قطع (قص) المنعطف، لذلك المكان صحيح.",
        "نعم، عند عدم وجود مركبة أخرى في داخل المنعطف، يُمكن أن تتواجد في أي مكان عند السير فيه.",
        "نعم، عند السير في منعطف حاد، يجب تقصير مدة البقاء في المنعطف، لذلك مكانها صحيح."
      ],
      id: 209
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0864. كيف نمنع الخطر عند البدء بالسير؟",
      numQues: "0864",
      correctAnswer: "بواسطة إعطاء الإشارة مع البدء بالسير.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "بواسطة النظر الصحيح إلى الطريق وحركة السير فيها وذلك قبل بدء التحرك من المكان.",
        "بواسطة الخروج بسرعة سير سريعة والاندماج السريع مع حركة السير.",
        "بواسطة السير السريع إلى الخلف.",
        "بواسطة إعطاء الإشارة مع البدء بالسير."
      ],
      id: 210
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0979. هل مكان المركبتين داخل المنعطف الحاد صحيح؟",
      numQues: "0979",
      correctAnswer: "صحيح، لأن المركبتين يحرصان على البقاء على يمين الشارع حسب المطلوب في هذا الوضع.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3979.jpg",
      choices: [
        "كلا، يجب الدخول إلى المنعطف الحاد بوضعٍ تكون فيه قريب من وسط الشارع.",
        "كلا، المسافة الجانبية الكبيرة تُمكن مركبة ثالثة من الدخول بينهما.",
        "كلا، المركبتان غير محافظتين على اتصال بصري حسب المطلوب.",
        "صحيح، لأن المركبتين يحرصان على البقاء على يمين الشارع حسب المطلوب في هذا الوضع."
      ],
      id: 211
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0281. من أية مسافة من نفق يُمنع التجاوز؟",
      numQues: "0281",
      correctAnswer: "من مسافة 100م قبل الدخول إلى النفق ولغاية 100م بعد الخروج منه.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "من لحظة دخول النفق وحتى الخروج منه.",
        "لا يوجد تحديد بالتجاوز في محيط النفق.",
        "من مسافة 50م قبل الدخول إلى النفق ولغاية 50م بعد الخروج منه.",
        "من مسافة 100م قبل الدخول إلى النفق ولغاية 100م بعد الخروج منه."
      ],
      id: 212
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0707. كيف تتصرف (مركبة رقم 3) في الاستدارة التي أمامك؟",
      numQues: "0707",
      correctAnswer: "سر، لك حق الأولوية في المفترق (3)",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3707.jpg",
      choices: [
        "أعطِ حق الأولوية للمركبة الحمراء (2).",
        "أعطِ حق الأولوية للمركبة الخضراء (1)",
        "أعطِ حق الأولوية للمركبتين (2+1).",
        "سر، لك حق الأولوية في المفترق (3)"
      ],
      id: 213
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1592. ما هي درجة الرخصة المطلوبة لسياقة دراجة نارية قوة محركها لغاية 33 حصان (25 كيلو واط)؟",
      numQues: "1592",
      correctAnswer: "A1",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "A2",
        "C",
        "D",
        "A1"
      ],
      id: 214
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0163. في أية حالة عليك إعطاء الإشارة بواسطة الغماز؟",
      numQues: "0163",
      correctAnswer: "فقط عند الاستدارة إلى اليسار في المفترقات.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "فقط قبل التواء حاد.",
        "عند اقترابك من ملتقى سكة حديد أو من ممر مشاة.",
        "إذا كنت تنوي البدء بالسير أو الاستدارة بمركبتك أو الانحراف عن مسلكك.",
        "فقط عند الاستدارة إلى اليسار في المفترقات."
      ],
      id: 215
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0486. ما معنى الإشارة؟",
      numQues: "0486",
      correctAnswer: "أعطِِ حق الأولوية للتراكتورات التي تسير في مقطع الطريق. ",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3486.jpg",
      choices: [
        "انتبه! مركبة عمل أو تراكتور(يقطع) في الطريق التي أمامك.",
        "قف! السير مسموح للمركبات الزراعية فقط.",
        "ممنوع دخول التراكتورات.",
        "أعطِِ حق الأولوية للتراكتورات التي تسير في مقطع الطريق. "
      ],
      id: 216
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1099. بأية سرعة دوران في الدقيقة يجب تشغيل ناقل القوة (PTO )؟",
      numQues: "1099",
      correctAnswer: "تُحدد سرعة الدوران بشكلٍ أوتوماتيكي عند تشغيل ناقل القوة.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "دائماً بسرعة الدوران التي يوصي بها منتج التراكتور.",
        "بأية سرعة دوران يمكن فيها تشغيل الجهاز المُشغل.",
        "بسرعة دوران سليمة، إلا إذا ذُكر غير ذلك على الجهاز المُشَغَل.",
        "تُحدد سرعة الدوران بشكلٍ أوتوماتيكي عند تشغيل ناقل القوة."
      ],
      id: 217
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1529. كيف تسوق مركبة في شارع رطب؟",
      numQues: "1529",
      correctAnswer: "اضغط على دعسة الكلاتش بالتناوب.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "كما هو الحال في طريق جافة، لا يوجد فرق.",
        "تمهل وسر بسرعة مناسبة حسب الظروف.",
        "زد من السرعة حتى نهاية المقطع الرطب – لزيادة الأمان.",
        "اضغط على دعسة الكلاتش بالتناوب."
      ],
      id: 218
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0491. ما معنى الإشارة؟",
      numQues: "0491",
      correctAnswer: "إشارة تحذير: ممنوع دخول المركبات الميكانيكية من الاتجاهين.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3491.jpg",
      choices: [
        "ممنوع الدخول لجميع المركبات (شارع باتجاه واحد).",
        "أمامك شارع باتجاهين.",
        "إشارة استعلامات: ممنوع دخول المركبات غير الميكانيكية فقط.",
        "إشارة تحذير: ممنوع دخول المركبات الميكانيكية من الاتجاهين."
      ],
      id: 219
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1593. درجة الرخصة المطلوبة لسياقة دراجة نارية قوة محركها أكثر من 33 حصان (25 كيلو واط)، هي؟",
      numQues: "1593",
      correctAnswer: "A1",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "B",
        "A",
        "A2",
        "A1"
      ],
      id: 220
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1489. تعتمد مسافة رد الفعل على:",
      numQues: "1489",
      correctAnswer: "سلامة الفرامل في المركبة.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "زمن رد فعل السائق وسرعة المركبة.",
        "زمن رد فعل السائق فقط.",
        "سرعة المركبة فقط.",
        "سلامة الفرامل في المركبة."
      ],
      id: 221
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0937. ما هي السرعة القصوى المسموح بها بالكم/ساعة لمركبة خصوصية في مقطع الطريق التي أمامك؟",
      numQues: "0937",
      correctAnswer: "اقل من 50.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3937.jpg",
      choices: [
        "80",
        "90",
        "50",
        "اقل من 50."
      ],
      id: 222
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0342. من هو المسؤول حسب القانون عن تسجيل نقل ملكية المركبة؟",
      numQues: "0342",
      correctAnswer: "شاري المركبة فقط.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "صاحب المركبة المسجل وشاري المركبة.",
        "البائع فقط.",
        "صاحب مؤسسة الفحص.",
        "شاري المركبة فقط."
      ],
      id: 223
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0962. كيف تتصرف في باقي الطريق حسب الإشارة المنصوبة على اليمين؟",
      numQues: "0962",
      correctAnswer: "أعطِ انتباهاً خاصاً للمركبات التي تندمج من اليمين، عليها إعطاؤك حق الأولوية.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3962.jpg",
      choices: [
        "اندمج بانتباه مع المركبات التي تسير من يسارك.",
        "أعطِ حق الأولوية للمركبات عند تستدير إلى اليمين.",
        "أعطِ حق الأولوية للمركبات المندمجة من اليمين.",
        "أعطِ انتباهاً خاصاً للمركبات التي تندمج من اليمين، عليها إعطاؤك حق الأولوية."
      ],
      id: 224
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0296. هل يجوز لمرافق 'سائق جديد' أن يكون تحت تأثير الكحول؟",
      numQues: "0296",
      correctAnswer: "كلا، لا يجوز للشخص الذي يكون تحت تأثير الكحول بأن يكون مرافقاً لسائق جديد.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "يجوز بشرط أن تكون قد انقضت ساعة منذ انتهائه شرب الكحول.",
        "يجوز، لأن مرافق السائق الجديد لا يسوق المركبة ، لذلك لا توجد أهمية إذا كان ثملاً (سكران).",
        "نعم، إذا كان عمره أكثر من 26 سنة.",
        "كلا، لا يجوز للشخص الذي يكون تحت تأثير الكحول بأن يكون مرافقاً لسائق جديد."
      ],
      id: 225
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»"
      ],
      title: "1340. عرِّف 'الوزن الذاتي' (الوزن الفارغ):",
      numQues: "1340",
      correctAnswer: "وزن المركبة مع الحمولة ومع السائق بما في ذلك وزن جميع ملحقات المركبة ووزن الوقود فيها. ",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "سعة المركبة دون الحمولة ودون السائق ويشمل وزن جميع ملحقات المركبة ووزن الوقود والماء والزيت فيها.",
        "وزن المركبة والحمولة دون السائق، ووزن ملحقات المركبة ووزن الوقود والماء والزيت فيها.",
        "وزن المركبة دون الحمولة ودون السائق، ويشمل وزن جميع ملحقات المركبة ووزن الوقود والماء والزيت فيها.",
        "وزن المركبة مع الحمولة ومع السائق بما في ذلك وزن جميع ملحقات المركبة ووزن الوقود فيها. "
      ],
      id: 226
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0098. بأية شروط يُسمح لسائق تراكتور حمولة نقل راكب؟",
      numQues: "0098",
      correctAnswer: "مسموح بدون شروط.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "مسموح في تراكتور حمولة زراعي فقط.. ",
        "إذا كان هناك إذن بذلك من سلطة الترخيص.",
        "مسموح بشرط أن يكون عمر السائق 21 سنة أو أكثر.",
        "مسموح بدون شروط."
      ],
      id: 227
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0858. من أية جهة يقترب السائق قبل الدخول إلى مركبته قبل الدخول في المركبة؟",
      numQues: "0858",
      correctAnswer: "لا توجد أهمية في وجهة السائق للمركبة، حيث يُمنع السائقون الآخرون من تعريض سائق يدخل إلى مركبته للخطر.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "من خلف المركبة وظهر السائق يقابل حركة السير ومن الباب الأيمن – حيث لا يوجد هناك خطر من حركة السير في الشارع.",
        "من خلف المركبة وظهر السائق يقابل حركة السير.",
        "من مقدمة المركبة ووجه السائق يقابل حركة السير.",
        "لا توجد أهمية في وجهة السائق للمركبة، حيث يُمنع السائقون الآخرون من تعريض سائق يدخل إلى مركبته للخطر."
      ],
      id: 228
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0705. أنا أقود المركبة رقم (3)،ما هو ترتيب دخول المركبات إلى المفترق الذي اقترب منه، حسب قواعد إعطاء حق الأولوية (المركبة الحمراء ليست مركبة أمن)؟",
      numQues: "0705",
      correctAnswer: "المركبة التي أسوقها أنا (3)، راكب الدراجة الهوائية (1)، المركبة الحمراء (2).",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3705.jpg",
      choices: [
        "المركبة الحمراء (2)، المركبة التي أسوقها أنا (3)، راكب الدراجة الهوائية (1).",
        "راكب الدراجة الهوائية (1)، المركبة الحمراء (2)، المركبة التي أسوقها أنا (3).",
        "المركبة التي أسوقها أنا (3)، المركبة الحمراء (2)، راكب الدراجة الهوائية (1).",
        "المركبة التي أسوقها أنا (3)، راكب الدراجة الهوائية (1)، المركبة الحمراء (2)."
      ],
      id: 229
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1431. ما هو عدد الركاب الأقصى المسموح بنقله في مركبة تجارية وزنها الإجمالي المسموح به أكثر من 3,500كغم ولا يوجد لها صندوق حسب المواصفات لنقل الركاب؟",
      numQues: "1431",
      correctAnswer: "ثمانية ركاب بالإضافة للركاب بجانب السائق.",
      pubDate: "10-11-2011 08:22:40",
      img: "",
      choices: [
        "11 راكباً بما فيهم السائق.",
        "ستة ركاب ما عدا الجالسين بجانب السائق.",
        "ستة ركاب بما فيهم الركاب الذين بجانب السائق.",
        "ثمانية ركاب بالإضافة للركاب بجانب السائق."
      ],
      id: 230
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0982. ما هي الجملة الأصح بالنسبة لما نراه في الصورة؟",
      numQues: "0982",
      correctAnswer: "يسير سائق المركبة البيضاء بصورة صحيحة في وسط الشارع.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3982.jpg",
      choices: [
        "يسير سائق المركبة بعيداً عن الحواشي وبذلك يتجنب خطراً لا لزوم له وقت الضيق. ",
        "سائق المركبة لا يحافظ على يمين الشارع وهو معرض لحادث جبهي (وجهاً لوجه).",
        "الوسم (التأشير) على سطح الشارع ليس واضحاً بما فيه الكفاية.",
        "يسير سائق المركبة البيضاء بصورة صحيحة في وسط الشارع."
      ],
      id: 231
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0113. المفترق الذي أمامك عليه إشارات تماماً كما في الصورة، ما هي الطريقة الصحيحة للاستدارة من الشارع 'أ' (A) إلى الشارع 'ج' (C)؟",
      numQues: "0113",
      correctAnswer: "من المسلك '1' إلى المسلك '4'.",
      pubDate: "10-11-2011 08:22:40",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3113.jpg",
      choices: [
        "من المسلك '2' إلى المسلك '3'.",
        "من المسلك '2' إلى المسلك '4'.",
        "من المسلك '1' أو من المسلك '2' إلى المسلك '4'.",
        "من المسلك '1' إلى المسلك '4'."
      ],
      id: 232
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0939. ما هو المطلوب من سائق المركبة الذي يقترب من الإشارات الظاهرة في الصورة؟",
      numQues: "0939",
      correctAnswer: "على سائق المركبة مواصلة السير العادي، تقع المسؤولية بكاملها على سائق المركبة المقتربة من اليمين.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3939.jpg",
      choices: [
        "ملاءمة سرعة السير للطريق البلدية وإعطاء حق الأولوية للمركبة التي على اليمين والانتباه للمشاة.",
        "ملاءمة سرعة السير لِ- 90كم/ساعة كما نستخلص من الإشارة.",
        "اهتمام خاص لتواجد مسنين في الطريق.",
        "على سائق المركبة مواصلة السير العادي، تقع المسؤولية بكاملها على سائق المركبة المقتربة من اليمين."
      ],
      id: 233
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1121. في أية مركبات يجب أن توجد 'أحذية الأمان'؟",
      numQues: "1121",
      correctAnswer: "في كل مركبة وزنها الإجمالي المسموح به لغاية 3500كغم أو اقل، ما عدا الباص. ",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "في كل مركبة تجارية مهما كان وزنها، ما عدا الباص.",
        "في كل مركبة وزنها الإجمالي المسموح به لغاية 4000كغم أو اقل، بما في ذلك الباص. ",
        "في كل مركبة آلية يزيد وزنها الإجمالي المسموح به عن 5000كغم، ما عدا الباص.",
        "في كل مركبة وزنها الإجمالي المسموح به لغاية 3500كغم أو اقل، ما عدا الباص. "
      ],
      id: 234
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1317. لا تصدر ولا تُجدد رخصة مركبة لباص:",
      numQues: "1317",
      correctAnswer: "بعد مرور 8 سنوات على سنة إنتاجه.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "بعد مرور 15 سنة على سنة إنتاجه.",
        "بعد مرور 20 سنة على سنة إنتاجه.",
        "بعد مرور 10 سنوات على سنة إنتاجه.",
        "بعد مرور 8 سنوات على سنة إنتاجه."
      ],
      id: 235
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0230. ما هي أجهزة التثبيت في المركبة، والتي يجب استعمالها عند نقل أولاد عمرهم لغاية 8 سنوات؟",
      numQues: "0230",
      correctAnswer: "حزام خصر فقط.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "حزام أمان له ثلاث نقاط فقط.",
        "مقعد أمان أو مقعد مرتفع مربوطان في المركبة.",
        "حزام أمان فقط.",
        "حزام خصر فقط."
      ],
      id: 236
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1112. كيف تضمن سرعة بطيئة للتراكتور والمجرور في منحدر شديد وطويل؟",
      numQues: "1112",
      correctAnswer: "بواسطة فرامل المجرور وإقفال الباككس.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "بواسطة تشغيل فرملة المحرك واختيار غيار واطئ.",
        "من خلال ملاءمة السرعة بواسطة الفرامل.",
        "بمساعدة دورات المحرك واختيار غيار واطئ.",
        "بواسطة فرامل المجرور وإقفال الباككس."
      ],
      id: 237
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1734. كيف تتصرف بالدراجة النارية في شارع مشوش وفي طريق ليست بلدية؟",
      numQues: "1734",
      correctAnswer: "زد من سرعة سيرك من اجل تقليص فترة بقائك في المقطع المشوش.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "إذا كانت إطارات الدراجة النارية جديدة، تستطيع الاستمرار بأمان بنفس السرعة بأمان.",
        "خفف من سرعة سيرك لأن هناك خطر فقدان السيطرة على الدراجة النارية.",
        "استمر بنفس السرعة ، لكن تجنب التجاوز.",
        "زد من سرعة سيرك من اجل تقليص فترة بقائك في المقطع المشوش."
      ],
      id: 238
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0208. في أية حدود قبل ملتقى سكة حديد وبعدها ، مسموح إيقاف أو وقوف مركبة؟",
      numQues: "0208",
      correctAnswer: "مسموح، 20م على الأقل من الملتقى.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3208.jpg",
      choices: [
        "مسموح، 6م على الأقل من الملتقى.",
        "مسموح، 12م على الأقل من الملتقى.",
        "مسموح، 4م على الأقل من الملتقى.",
        "مسموح، 20م على الأقل من الملتقى."
      ],
      id: 239
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0277. كيف يتصرف من لهم دخل في حادث طرق أسفر عن ضرر فقط؟",
      numQues: "0277",
      correctAnswer: "يستدعوا فرق الإنقاذ وينتظروا في مكان الحادث دون تحريك المركبات.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "يقوموا بإخلاء الشارع من مركباتهم فوراً ويتبادلوا فيما بينهم التفاصيل الشخصية.",
        "يتبادلوا التفاصيل الشخصية وينتظروا فرق الإنقاذ دون تحريك المركبات.",
        "يقوموا بتبليغ الشرطة وينتظروا تعليماتها.",
        "يستدعوا فرق الإنقاذ وينتظروا في مكان الحادث دون تحريك المركبات."
      ],
      id: 240
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0102. في الرسم الذي أمامك نرى طريق عريضة، بأي رقم موسومة (مؤشرة) المساحة الفاصلة في الرسم؟",
      numQues: "0102",
      correctAnswer: "2",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3082.jpg",
      choices: [
        "4",
        "1",
        "8",
        "2"
      ],
      id: 241
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0381. كيف تتصرف عندما ترى الإشارة؟",
      numQues: "0381",
      correctAnswer: "ممنوع الرجوع إلى الخلف في مقطع الطريق الذي أمامك.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3381.jpg",
      choices: [
        "عليك إعطاء حق الأولوية لحركة السير المقابلة في الطريق السريعة.",
        "عليك الانتباه والسير على اليمين لأن حركة السير تصبح باتجاهين أمامك.",
        "لك حق الأولوية بالنسبة لحركة السير المقابلة في الطريق.",
        "ممنوع الرجوع إلى الخلف في مقطع الطريق الذي أمامك."
      ],
      id: 242
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0260. متى يجوز إضاءة 'مصابيح الضباب'؟",
      numQues: "0260",
      correctAnswer: "فقط عند الرجوع إلى الخلف.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "فقط عند هطول الأمطار.",
        "فقط عند السير في طريق سريعة.",
        "فقط في حالة الضباب وهطول الأمطار الغزيرة وتساقط الثلوج.",
        "فقط عند الرجوع إلى الخلف."
      ],
      id: 243
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»"
      ],
      title: "0996. كيف يتأكد السائق من صلاحية الفرامل الهيدروليكية؟",
      numQues: "0996",
      correctAnswer: "بواسطة فحص مستوى سائل الفرامل وفحص نجاعة الفرملة وتتبع الاهتزازات والضجيج أثناء الفرملة.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "لا توجد ضرورة لتدخل السائق بالنسبة لصلاحية جهاز الفرامل.",
        "يفحص الجهاز كل 24 شهراً في كراج معتمد.",
        "بواسطة الفحص الشامل لجهاز الفرامل كل خمس سنوات.",
        "بواسطة فحص مستوى سائل الفرامل وفحص نجاعة الفرملة وتتبع الاهتزازات والضجيج أثناء الفرملة."
      ],
      id: 244
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1786. حسب القانون، الباص المفصلي الطويل:",
      numQues: "1786",
      correctAnswer: "ملزم بلاصقات وأيضاً بشريطين على الجانب الخلفي للباص.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "ملزم بشريطين على الجانب الخلفي للباص بحجم 4×100سم.",
        "ملزم بشريطين عاكسين سُجل عليهما 'حافظ على مسافة'.",
        "ملزم بلاصقات مستطيلة على الجانب الخلفي للباص.",
        "ملزم بلاصقات وأيضاً بشريطين على الجانب الخلفي للباص."
      ],
      id: 245
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1586. هل يُسمح لمركبة تسير على عجلتين بالسير بجانب مركبة أخرى تسير على عجلتين؟",
      numQues: "1586",
      correctAnswer: "مسموح في طريق بلدية فقط.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "ممنوع، إلا من اجل التجاوز أو المرور عن المركبة الأخرى فقط.",
        "مسموح دائماً.",
        "ممنوع منعاً باتاً.",
        "مسموح في طريق بلدية فقط."
      ],
      id: 246
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1163. ماذا يجب أن يكون في المركبة التي تنقل تلاميذ؟",
      numQues: "1163",
      correctAnswer: "فقط لافتة 'نقل أولاد' من الأمام ومن الخلف.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "فقط مصابيح تضيء بضوء متقطع وإذن من سلطة الترخيص في رخصة المركبة.",
        "مصابيح تضيء بضوء متقطع ولافتة 'أولاد' وإذن من سلطة الترخيص مذكور في رخصة المركبة.",
        "أحزمة خصر ولافتتان مناسبتان من الأمام ومن الخلف، ليس أكثر.",
        "فقط لافتة 'نقل أولاد' من الأمام ومن الخلف."
      ],
      id: 247
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0332. متى يجب على السائق، حسب القانون، 'تخفيف سرعة المركبة'؟",
      numQues: "0332",
      correctAnswer: "في كل حالة متوقع فيها خطر على عابري الطريق أو على الممتلكات.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "قبل الانتهاء من التجاوز في شارع باتجاهين.",
        "عندما يقترب من السرعة القصوى المسموح بها.",
        "عندما يشعر بالتعب.",
        "في كل حالة متوقع فيها خطر على عابري الطريق أو على الممتلكات."
      ],
      id: 248
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0727. أي مسلك هو المسلك الصحيح من اجل الاستدارة إلى اليسار؟",
      numQues: "0727",
      correctAnswer: "المسلك الأيمن - دائماً.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3727.jpg",
      choices: [
        "أكثر مسلك خالي.",
        "لا توجد أهمية بالنسبة للمسلك.",
        "المسلك الأيسر.",
        "المسلك الأيمن - دائماً."
      ],
      id: 249
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1143. هل سائق باص يسير على خط خدمة مُلزم بالإعلان عن المحطات في الخط؟",
      numQues: "1143",
      correctAnswer: "نعم، فقط في السفرات داخل المدن.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "نعم، فقط عند الدخول إلى القرى المعزولة.",
        "كلا، على السائق الإعلان عن الوصول إلى المحطة النهائية.",
        "نعم، عند عدم وجود خارطة في الباص تدل على مجرى خط الخدمة.",
        "نعم، فقط في السفرات داخل المدن."
      ],
      id: 250
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0779. ما هي العملية الأولى التي يقوم بها السائقون في ترتيب العمليات لعبور المفترقات؟",
      numQues: "0779",
      correctAnswer: "يفحصوا ويميزوا المسالك بعد عبور المفترق وبالأخص في الاتجاه الذي سنسير إليه.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "يتأكدوا من أن المفترق خالي ويُمكن إكمال عبور المفترق بأمان.",
        "يدخلوا الى المفترق.",
        "ينظروا إلى ما بعد المفترق من اجل مشاهدة مسالك الدخول للاتجاهات المعاكسة وحركة السير فيها.",
        "يفحصوا ويميزوا المسالك بعد عبور المفترق وبالأخص في الاتجاه الذي سنسير إليه."
      ],
      id: 251
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0507. ما معنى الإشارة؟",
      numQues: "0507",
      correctAnswer: "ممنوع دخول أية مركبة يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3507.jpg",
      choices: [
        "ممنوع دخول مركبة ميكانيكية تجارية يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة.",
        "مسموح دخول مركبة ميكانيكية تجارية يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة.",
        "مسموح دخول جميع المركبات الميكانيكية.",
        "ممنوع دخول أية مركبة يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة."
      ],
      id: 252
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0891. مسموح الاستدارة للسير في الاتجاه المعاكس (حذوة فرس):",
      numQues: "0891",
      correctAnswer: "فقط في مفترق مع إشارة ضوئية (رمزور) إذا كانت الاستدارة إلى اليسار مسموحة.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "عندما يكون هناك خط فاصل متواصل.",
        "فقط في مفترق بدون إشارة ضوئية (رمزور) يُسمح فيه الاستدارة إلى اليسار.",
        "من أي مسلك إلا إذا كانت هناك إشارة تمنع ذلك.",
        "فقط في مفترق مع إشارة ضوئية (رمزور) إذا كانت الاستدارة إلى اليسار مسموحة."
      ],
      id: 253
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0399. هل يجوز لسائق إرسال رسالة (S.M.S) بواسطة الهاتف أثناء السياقة؟",
      numQues: "0399",
      correctAnswer: "هذا الأمر ممنوع منعاً باتاً وهو مرفوض وخطر.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "مسموح القراءة لكن يُمنع إرسال رسالة بواسطة الهاتف. ",
        "يجوز للسائق الإرسال والقراءة،بشرط أن يتم ذلك بحذر.",
        "مسموح إرسال هذه الرسالة غير انه ممنوع قراءتها بواسطة الهاتف.",
        "هذا الأمر ممنوع منعاً باتاً وهو مرفوض وخطر."
      ],
      id: 254
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0234. حسب الإشارة المنصوبة في محطة الباص، مسموح الوقوف في محطة الباص أيام السبت والأعياد:",
      numQues: "0234",
      correctAnswer: "للمركبات البطيئة فقط.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "للدراجات النارية فقط.",
        "للمركبات التجارية فقط.",
        "للمركبات الخصوصية فقط.",
        "للمركبات البطيئة فقط."
      ],
      id: 255
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1170. هل يُعتبر 'الزوتوبوس' (الصالون العمومي الكبير) صالون عمومي؟",
      numQues: "1170",
      correctAnswer: "الزوتوبوس هو صالون عمومي بكل معنى الكلمة.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "يُعتبر الزوتوبوس كصالون عمومي فقط إذا رُكب فيه عداد.",
        "لا يُعتبر الزوتوبوس كصالون عمومي.",
        "يُعتبر الزوتوبوس كصالون عمومي، فقط إذا وُجد فيه مكان لراكبين بجانب السائق.",
        "الزوتوبوس هو صالون عمومي بكل معنى الكلمة."
      ],
      id: 256
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0404. أية إشارة تلزم بالتوقف وإعطاء حق الأولوية للمركبات المقتربة من أي اتجاه كان؟",
      numQues: "0404",
      correctAnswer: "302",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3404.jpg",
      choices: [
        "308",
        "303",
        "309",
        "302"
      ],
      id: 257
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1483. لماذا نُعشق غيار واطئ عند السير في منحدر شديد؟",
      numQues: "1483",
      correctAnswer: "للتوفير في الوقود ولتقليل اهتراء المحرك.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "لكي نستعين بالمحرك في المحافظة على سرعة سير بطيئة وثابتة بدون استعمال زائد للفرامل.",
        "لمنع اهتراء الإطارات عند السير في منحدر فقط.",
        "لمنع سخونة زائدة عن الحد لمحرك المركبة.",
        "للتوفير في الوقود ولتقليل اهتراء المحرك."
      ],
      id: 258
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1304. ما هو الطول الأقصى المسموح به لمركبة موصولة؟",
      numQues: "1304",
      correctAnswer: "25.00م.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "18.75م.",
        "20.00م.",
        "15. 65م.",
        "25.00م."
      ],
      id: 259
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1386. اشرح المصطلح 'محور' في المركبة:",
      numQues: "1386",
      correctAnswer: "الدعامة الخلفية في الشاصي والموصول بها مسمار جر المقطورة.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "مدار أو مجموعة مدارات مُرَكبة على عرض المركبة ومُركب عليها عجلات.",
        "خط على طول المركبة من الطمبون إلى الطمبون وموازي للمحور الطولي للمركبة.",
        "الدراي شافط الذي ينقل الحركة الدائرية من صندوق الغيارات إلى الباككس.",
        "الدعامة الخلفية في الشاصي والموصول بها مسمار جر المقطورة."
      ],
      id: 260
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1083. على أي محور تعمل فرامل الخدمة في التراكتور؟",
      numQues: "1083",
      correctAnswer: "لا توجد فرامل خدمة في التراكتور.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "على المحور الخلفي.",
        "على المحور الأمامي.",
        "على جميع المحاور.",
        "لا توجد فرامل خدمة في التراكتور."
      ],
      id: 261
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1803. أي إشارة معناها حادث في الطريق التي أمامك؟",
      numQues: "1803",
      correctAnswer: "127",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31803.jpg",
      choices: [
        "151",
        "150",
        "107",
        "127"
      ],
      id: 262
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0604. ما معنى الإشارة؟",
      numQues: "0604",
      correctAnswer: "تمهل، أمامك مكان خطر لم تُحدد له إشارة خاصة.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3490.jpg",
      choices: [
        "مغلق أمام جميع المركبات في الاتجاهين.",
        "انتبه! عليك أنت تدخل إلى منطقة فيها تحديد للسرعة.",
        "أمامك شارع باتجاه واحد.",
        "تمهل، أمامك مكان خطر لم تُحدد له إشارة خاصة."
      ],
      id: 263
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1597. ما هي السرعة المعقولة والآمنة في ركوب الدراجة النارية؟",
      numQues: "1597",
      correctAnswer: "السرعة القصوى التي حددها مشرع القانون.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "أية سرعة لا تصعب على السائق السيطرة على الدراجة النارية.",
        "السرعة التي يستطيع فيها راكب الدراجة تشخيص جميع التفاصيل التي في طريقه ويضمن السيطرة التامة على الدراجة النارية وليست أكثر من السرعة القصوى المسموح بها.",
        "السرعة التي يتجاوز فيها راكب الدراجة النارية السرعة القصوى المسموح بها في ذلك المكان وليس أكثر من 50%.",
        "السرعة القصوى التي حددها مشرع القانون."
      ],
      id: 264
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»"
      ],
      title: "1402. هل يُسمح بجر أكثر من مقطورة واحدة؟",
      numQues: "1402",
      correctAnswer: "نعم، لكن من الضروري الحصول على إذن بذلك من مراقب السير على الطرق.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "نعم، لكن من الضروري الحصول على إذن بذلك من شرطي.",
        "نعم، لكن من الضروري الحصول على إذن بذلك من سلطة الترخيص.",
        "نعم، عند نقل حمولات طويلة، مسموح جر أكثر من مقطورة واحدة ، لكن ذلك يستوجب بإذن من ضابط الشرطة.",
        "نعم، لكن من الضروري الحصول على إذن بذلك من مراقب السير على الطرق."
      ],
      id: 265
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0915. ماذا على السائق عمله لتجنب إصابة الماشي؟",
      numQues: "0915",
      correctAnswer: "في هذه الحالة لا توجد أية إمكانية لتجنب إصابة الماشي.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3915.jpg",
      choices: [
        "على السائق تنبيه الماشي بواسطة استعمال الزامور بشكلٍ متواصل وشديد ومتابعة السير كالمعتاد.",
        "التمهل واكتشاف وجود الماشي مبكراً على الشارع.",
        "الفرملة القوية واستعمال الزامور بشكلٍ متكرر يجعلوا الماشي يهرب إلى الرصيف وبهذا تُحل المشكلة.",
        "في هذه الحالة لا توجد أية إمكانية لتجنب إصابة الماشي."
      ],
      id: 266
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0284. ماذا يتوجب عليك عمله إذا أصدرت مركبتك ضوضاء غير اعتيادية؟",
      numQues: "0284",
      correctAnswer: "مسموح سياقة مركبة تصدر عنها ضوضاء غير اعتيادية في طريق ليست بلدية.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "لا يجوز سياقة مركبة تصدر عنها ضوضاء غير اعتيادية.",
        "مسموح سياقة مركبة تصدر عنها ضوضاء غير اعتيادية وبدون أي قيد.",
        "مسموح سياقة مركبة تصدر عنها ضوضاء غير اعتيادية بإذن من السلطة المحلية.",
        "مسموح سياقة مركبة تصدر عنها ضوضاء غير اعتيادية في طريق ليست بلدية."
      ],
      id: 267
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0866. هل يمكن الاكتفاء بإعطاء الإشارة (الغماز) فقط عند البدء بالسير؟",
      numQues: "0866",
      correctAnswer: "نعم، العمليات الزائدة إضافة إلى إعطاء الإشارة المطلوب ، تأخذ وقتاً ثميناً من مستعمل المركبة وتؤدي إلى توترات لا داعي لها.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "كلا، إعطاء الإشارة لا يعطي أي حق، يجب التأكد بواسطة النظر الصحيح بالإضافة إلى إعطاء الإشارة.",
        "نعم، عند البدء بالسير نكتفي بإعطاء الإشارة فقط، وعند الاندماج في حركة السير هناك وقت للنظر.",
        "نعم، يُلزمنا القانون بإعطاء الإشارة قبل البدء بالسير، وواجب الحذر يسري على عابري الطريق الآخرين.",
        "نعم، العمليات الزائدة إضافة إلى إعطاء الإشارة المطلوب ، تأخذ وقتاً ثميناً من مستعمل المركبة وتؤدي إلى توترات لا داعي لها."
      ],
      id: 268
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1409. هل هناك واجب بوسم (تأشير) الحمولة البارزة من المركبة؟",
      numQues: "1409",
      correctAnswer: "كلا، يجب وسمها (تأشيرها) فقط إذا كان البروز من قسمها الخلفي فقط.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "كلا،في المركبة الواقفة في الطريق، لا تُشكل الحمولة البارزة خطراً ، لذلك لا يوجد واجب بوسمها.",
        "نعم، هناك واجب بوسم (تأشير) الحمولة البارزة دائماً.",
        "نعم، هناك واجب بوسم (بتأشير) الحمولة البارزة فقط في وقت الإنارة.",
        "كلا، يجب وسمها (تأشيرها) فقط إذا كان البروز من قسمها الخلفي فقط."
      ],
      id: 269
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0286. كيف يجب علينا التصرف في منحدر؟",
      numQues: "0286",
      correctAnswer: "بغيار النيوترال من اجل التوفير في الوقود.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "بغيار عالي مع الضغط المتواصل على دعسة الفرامل لزيادة الأمان.",
        "علينا التأكد من أن احد الغيارات معشقاً ويعمل. ",
        "بغيار معشق مع الضغط المتواصل على دعسة الكلاتش.",
        "بغيار النيوترال من اجل التوفير في الوقود."
      ],
      id: 270
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1234. ما هي قبعة التشخيص (الطربوش) في الصالون العمومي؟",
      numQues: "1234",
      correctAnswer: "علبة تُستعمل لتخزين حقيبة الإسعاف الأولي.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "جهاز (طربوش) على سطح الصالون العمومي لتشخيص الصالون العمومي وفيه إضاءة.",
        "علبه مثبت فيها العداد في الصالون العمومي ويجب أن تكون مضاءة عند سير الصالون العمومي.",
        "جهاز يُسجل على قرص تفاصيل السفرة في الباص.",
        "علبة تُستعمل لتخزين حقيبة الإسعاف الأولي."
      ],
      id: 271
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0190. كيف تعتبر مكان عبور مشاة مقسم بواسطة مساحة فاصلة؟",
      numQues: "0190",
      correctAnswer: "لا يوجد فرق بين مكان عبور مشاة مُقسم وبين مكان عبور مشاة غير مُقسم، كلاهما يعتبران ممر واحد.",
      pubDate: "10-11-2011 08:22:41",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3190.jpg",
      choices: [
        "يجب النظر إلى ممر المشاة كما إلى ممرين فقط إذا كان هناك بستان يفصل بينهما.",
        "يُعتبر مكان عبور المشاة المقسم بواسطة مساحة فاصلة كمكانين منفصلين لعبور المشاة.",
        "مكان عبور المشاة المُقسم بواسطة مساحة فاصلة هو مكان عبور مشاة واحد طويل.",
        "لا يوجد فرق بين مكان عبور مشاة مُقسم وبين مكان عبور مشاة غير مُقسم، كلاهما يعتبران ممر واحد."
      ],
      id: 272
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1403. الوقوف في محطة باص:",
      numQues: "1403",
      correctAnswer: "مسموح أيام السبت والأعياد للمركبات التجارية فقط وحسب المسجل في الشاخصة المنصوبة في محطة الباص.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "مسموح أيام السبت والأعياد للدراجات النارية فقط وحسب المسجل في الشاخصة المنصوبة في محطة الباص.",
        "مسموح أيام السبت والأعياد لجميع أنواع المركبات.",
        "مسموح أيام السبت والأعياد للمركبات الخصوصية فقط وحسب المسجل في الشاخصة المنصوبة في محطة الباص.",
        "مسموح أيام السبت والأعياد للمركبات التجارية فقط وحسب المسجل في الشاخصة المنصوبة في محطة الباص."
      ],
      id: 273
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1772. هل الوسم (التأشير) على سطح الشارع الذي تم عمله بموجب القانون يُعتبر كإشارة؟",
      numQues: "1772",
      correctAnswer: "فقط إذا كان لونه ابيض.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "فقط في حدود طريق بلدية.",
        "فقط إذا نُصبت بجانبه إشارة أخرى.",
        "دائماً.",
        "فقط إذا كان لونه ابيض."
      ],
      id: 274
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0019. ما هو 'محول الطرق' :",
      numQues: "0019",
      correctAnswer: "التقاء شارعين أو أكثر على نفس المستوى في طريق غير بلدية.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "التقاء طرق على مستويات مختلفة (جسر) وتُمكن العبور عند السفر من طريق إلى أخرى.",
        "التقاء طرق على نفس المستوى والموجود في طريق داخل المدن فقط. ",
        "المساحة المتكونة من التقاء ثلاثة شوارع على نفس المستوى. ",
        "التقاء شارعين أو أكثر على نفس المستوى في طريق غير بلدية."
      ],
      id: 275
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0301. هل تأثير علبة (طاسة) بيرة على السائق اقل من تأثير كأس ويسكي؟",
      numQues: "0301",
      correctAnswer: "كلاهما يؤثران بنفس المقدار تقريباً على مقدرة السائق في السياقة.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "صحيح، لأن البيرة هي مشروب ليس من شأنه أن يؤثر على السياقة.",
        "غير صحيح، كمية البيرة أكثر لذلك يكون تأثيرها أكثر.",
        "صحيح، البيرة لها تأثير أكثر من الويسكي.",
        "كلاهما يؤثران بنفس المقدار تقريباً على مقدرة السائق في السياقة."
      ],
      id: 276
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1510. هل التوقف للانتعاش أثناء السواقة خارج المركبة يمكنه أن يزيل التعب أثناء السياقة؟",
      numQues: "1510",
      correctAnswer: "يمكنه لوقت قصير.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "طبعاً، ولوقت طويل – وهو أفضل من الاستراحة خارج المركبة.",
        "يمكنه إزالة التعب تماماً.",
        "يمكنه لوقت طويل.",
        "يمكنه لوقت قصير."
      ],
      id: 277
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0752. في أية حالات لا نسير على يمين الشارع؟",
      numQues: "0752",
      correctAnswer: "عند الاستدارات يميناً.",
      pubDate: "10-11-2011 08:22:41",
      img: "",
      choices: [
        "عند تجاوز مركبة.",
        "قبل دوار حركة سير.",
        "عند الاقتراب من مفترق.",
        "عند الاستدارات يميناً."
      ],
      id: 278
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1186. ما هي التعرفة '2' ؟",
      numQues: "1186",
      correctAnswer: "التعرفة عن السفرة من الساعة 21:01 ولغاية الساعة 05:29 ولا تشمل أيام الاستراحة.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "التعرفة في أيام السبت وعطل الأعياد من الساعة 07:00 ولغاية الساعة 21:00.",
        "تعرفة عطل الأعياد والأعياد فقط.",
        "التعرفة عن السفرة من الساعة 21:01 ولغاية الساعة 05:29 والتعرفة في أيام الاستراحة.",
        "التعرفة عن السفرة من الساعة 21:01 ولغاية الساعة 05:29 ولا تشمل أيام الاستراحة."
      ],
      id: 279
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0716. ما هو ترتيب دخول المركبات إلى المفترق حسب القانون؟",
      numQues: "0716",
      correctAnswer: "المركبة التي تستدير إلى اليسار (3)، المركبة الزرقاء (1)، التراكتور (2).",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3716.jpg",
      choices: [
        "يدخل التراكتور (2) في النهاية دائماً إلى.",
        "أنت الذي تستدير إلى اليسار (3)، وبعدك التراكتور (2)، وبعده المركبة الزرقاء (1).",
        "التراكتور (2)، أنت المركبة التي تستدير إلى اليسار (3)، المركبة الزرقاء (1).",
        "المركبة التي تستدير إلى اليسار (3)، المركبة الزرقاء (1)، التراكتور (2)."
      ],
      id: 280
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1202. هل يجوز لسائق الباص رفض إدخال عربة أطفال في الباص؟",
      numQues: "1202",
      correctAnswer: "نعم، عندما لا يكون هناك مكان في صندوق حمولة الباص.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "على السائق إدخال عربة أطفال في الباص دائماً.",
        "لا يجوز له أن يرفض.",
        "نعم، إذا لم يكن هناك مكان للعربة بسبب ازدحام الركاب.",
        "نعم، عندما لا يكون هناك مكان في صندوق حمولة الباص."
      ],
      id: 281
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0574. ما معنى الإشارة؟",
      numQues: "0574",
      correctAnswer: "انتبه! أشغال في الشارع.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "ممنوع دخول التراكتور ومركبة العمل.",
        "ممنوع دخول مركبة غير ميكانيكية فقط.",
        "مسموح دخول التراكتور ومركبة العمل.",
        "انتبه! أشغال في الشارع."
      ],
      id: 282
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1180. ما هي 'السفرة الخاصة' في الصالون العمومي؟",
      numQues: "1180",
      correctAnswer: "سفرة تكون بكاملها تحت تصرف طالبها.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "سفرة بموجب التعرفة '2' – الأعياد والعطل بإضافة 25%.",
        "كل سفرة على خط خدمة.",
        "سفرة بموجب التعرفة '1' .",
        "سفرة تكون بكاملها تحت تصرف طالبها."
      ],
      id: 283
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0610. ما معنى الإشارة؟",
      numQues: "0610",
      correctAnswer: "ممنوع التجاوز للباصات.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3386.jpg",
      choices: [
        "نهاية مقطع الطريق الذي يسري عليه منع التجاوز.",
        "ممنوع تجاوز المركبات الخصوصية.",
        "ممنوع التجاوز للمركبات التجارية.",
        "ممنوع التجاوز للباصات."
      ],
      id: 284
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0057. أية تغييرات في صحة السائق يجب إبلاغ سلطة الترخيص عنها؟",
      numQues: "0057",
      correctAnswer: "لا يجب على السائق تبليغ أي شيء لسلطة الترخيص وإنما لدائرة الصحة فقط.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "لا يجب على السائق تبليغ أي شيء لسلطة الترخيص، إنما الطبيب الشخصي هو الذي يقوم بالتبليغ.",
        "لا يجب على السائق بالتبليغ عن أي تغيير كان في صحته ما عدا المشاكل في الجهاز العصبي.",
        "إذا تبين أن هناك مرض في القلب أو خلل في جهاز الأعصاب أو في العظام أو في النظر أو في السمع .",
        "لا يجب على السائق تبليغ أي شيء لسلطة الترخيص وإنما لدائرة الصحة فقط."
      ],
      id: 285
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0187. بأية شروط يجوز عبور خط سكة حديد؟",
      numQues: "0187",
      correctAnswer: "عندما يبدأ الحاجز بالارتفاع.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3155.jpg",
      choices: [
        "مسموح العبور بعد إعطاء حق الأولوية للمركبات المبتعدة عن الملتقى بدون إعاقتهم.",
        "إذا نُصبت إشارة 'قف' أو إشارة ضوئية (رمزور) تضيء 'بالضوء الأحمر' باتجاه سيرك.",
        "عندما يكون الملتقى خالي والحاجز مرفوع وبالإمكان إكمال العبور بأمان.",
        "عندما يبدأ الحاجز بالارتفاع."
      ],
      id: 286
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0640. ما معنى الوسم (التأشير) على سطح الطريق؟",
      numQues: "0640",
      correctAnswer: "مسموح اختراق الخطوط فقط إذا كان الخط المتقطع موسوم( مرسوم) على يمين الخط الفاصل المتواصل.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3640.jpg",
      choices: [
        "تجربة الدهان في الشارع.",
        "مسموح الوقوف في الشارع في الجهة التي فيها الخط المتقطع.",
        "سوف يبدأ عن قريب خط فاصل متواصل.",
        "مسموح اختراق الخطوط فقط إذا كان الخط المتقطع موسوم( مرسوم) على يمين الخط الفاصل المتواصل."
      ],
      id: 287
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0966. ما هي اتجاهات السير المسموحة حسب الإشارات التي في المفترق الذي أمامك؟",
      numQues: "0966",
      correctAnswer: "إلى الأمام باتجاه السهم فقط للمركبات غير العمومية.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3966.jpg",
      choices: [
        "على جميع المركبات التي تقترب مواصلة سيرها باتجاه السهم.",
        "إلى الأمام، للمواصلات العمومية فقط.",
        "إلى الأمام والى اليسار للباصات فقط.",
        "إلى الأمام باتجاه السهم فقط للمركبات غير العمومية."
      ],
      id: 288
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0395. أية إشارة من الإشارات التالية تمنع الاستدارة إلى اليسار للدخول إلى محطة وقود؟",
      numQues: "0395",
      correctAnswer: "205",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3395.jpg",
      choices: [
        "428",
        "429",
        "431",
        "205"
      ],
      id: 289
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1238. تعريف 'الباص' هو:",
      numQues: "1238",
      correctAnswer: "مركبة ميكانيكية معدة لنقل ثمانية ركاب أو أكثر ما عدا السائق وذُكر في رخصة المركبة بأنها باص.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "مركبة ميكانيكية معدة لنقل ركاب بالأجرة في خطوط الخدمة المذكورة في رخصة المركبة فقط.",
        "كل مركبة مرخصة لنقل أكثر من 10 ركاب.",
        "مركبة ميكانيكية معدة لنقل ثمانية ركاب ما عدا السائق ولها رخصة سارية المفعول. ",
        "مركبة ميكانيكية معدة لنقل ثمانية ركاب أو أكثر ما عدا السائق وذُكر في رخصة المركبة بأنها باص."
      ],
      id: 290
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0200. هل يُسمح بإيقاف مركبة في الجهة اليسرى لشارع باتجاهين؟",
      numQues: "0200",
      correctAnswer: "مسموح - في شارع يزيد عرضه عن 8م.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "مسموح، بشرط إيقاف المركبة بجوار الرصيف. ",
        "مسموح - في شارع فيه ثلاثة مسالك أو أكثر.",
        "ممنوع.",
        "مسموح - في شارع يزيد عرضه عن 8م."
      ],
      id: 291
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0615. في مركبة مُعدة لنقل التلاميذ، ممنوع:",
      numQues: "0615",
      correctAnswer: "نقل بالغين وقوفاً (واقفين).",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "نقل تلاميذ إلا بحضور معلم واحد أو أكثر.",
        "نقل تلاميذ إلا بحضور مرافق بالغ.",
        "نقل تلاميذ وقوفاً (واقفين).",
        "نقل بالغين وقوفاً (واقفين)."
      ],
      id: 292
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1347. درجة الرخصة المطلوبة لسياقة مركبة تجارية وزنها الإجمالي أكثر من 3500كغم وأُلحقت بها مقطورة أو مستندة وزنها 4000 كغم هي:",
      numQues: "1347",
      correctAnswer: "C+E",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "D",
        "B",
        "C1",
        "C+E"
      ],
      id: 293
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1591. ما هي درجة الرخصة الجديدة المطلوبة لسياقة دراجة نارية حجم محركها لغاية 125سم3 وقوته 14.6 حصان (11 كيلو واط)؟",
      numQues: "1591",
      correctAnswer: "A2 ",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "B",
        "D",
        "C1",
        "A2 "
      ],
      id: 294
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1430. كيف توسم (تؤشر) مركبة تجارية وزنها الإجمالي المسموح به أكثر من 3500كغم والتي تنقل 11 راكباً أو أكثر؟",
      numQues: "1430",
      correctAnswer: "لا تحتاج مركبة تجارية كالمذكورة بلافتات خاصة.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "بلافتة 'ركاب' من الأمام ومن الخلف.",
        "بلافتة 'انتبه أولاد'.",
        "بلافتة 'ركاب' من الأمام فقط.",
        "لا تحتاج مركبة تجارية كالمذكورة بلافتات خاصة."
      ],
      id: 295
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1633. العوامل الرئيسية التي تؤثر على مقدرة راكب الدراجة النارية من تشخيص العوائق في الطريق هي:",
      numQues: "1633",
      correctAnswer: "وضع الدراجة النارية الميكانيكي.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "صلاحية الفرامل وصلاحية والإطارات.",
        "موقع الدراجة النارية في الطريق وفي حركة السير.",
        "حجم الدراجة النارية.",
        "وضع الدراجة النارية الميكانيكي."
      ],
      id: 296
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1358. في مركبة موصولة، لا يجب أن تكون المسافة بين القسم الخلفي للقاطرة وبين القسم الأمامي للمقطورة أكثر من:",
      numQues: "1358",
      correctAnswer: "لا يوجد أي تحديد للمسافة بين القاطرة والمقطورة.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "400سم.",
        "250سم.",
        "150سم.",
        "لا يوجد أي تحديد للمسافة بين القاطرة والمقطورة."
      ],
      id: 297
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1265. هل يُسمح لزوتوبوس الوقوف في حدود هذه الإشارة؟",
      numQues: "1265",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3627.jpg",
      choices: [
        "نعم، فقط في نهاية كل أسبوع.",
        "كلا.",
        "نعم بين الساعات 21:00 لغاية 05:30 أيام عُطَل الأعياد فقط.",
        "نعم."
      ],
      id: 298
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0154. ما هي السرعة القصوى المسموح بها في شارع مختلط (موحد)؟",
      numQues: "0154",
      correctAnswer: "20كم/ساعة.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3154.jpg",
      choices: [
        "30كم/ساعة.",
        "40كم/ساعة.",
        "10كم/ساعة.",
        "20كم/ساعة."
      ],
      id: 299
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0960. حسب الإشارات الظاهرة في الصورة، الطريق التي تستدير إلى اليمين هي:",
      numQues: "0960",
      correctAnswer: "شارع بدون مخرج.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3960.jpg",
      choices: [
        "طريق بلدية.",
        "طريق ليست بلدية وليست سريعة.",
        "طريق سريعة.",
        "شارع بدون مخرج."
      ],
      id: 300
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0703. أنت تقود المركبة رقم (3)،ما هو ترتيب دخول المركبات إلى المفترق حسب قواعد إعطاء حق الأولوية؟",
      numQues: "0703",
      correctAnswer: "تدخل المركبة التي تسوقها أولاً (3) وبعدها المركبة الخصوصية الحمراء (1).",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3703.jpg",
      choices: [
        "يدخل راكب الدراجة الهوائية أولاً (2) وبعدها المركبة التي تسوقها (3).",
        "يدخل راكب الدراجة الهوائية أولاً (2) وبعده المركبة الخصوصية الحمراء (1).",
        "تدخل المركبة الخصوصية الحمراء (1) أولاً وبعدها الدراجة الهوائية (2) .",
        "تدخل المركبة التي تسوقها أولاً (3) وبعدها المركبة الخصوصية الحمراء (1)."
      ],
      id: 301
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1595. عندما ينقل سائق الدراجة النارية راكباً عليها، يُلزم القانون:",
      numQues: "1595",
      correctAnswer: "أن تكون رجلا الراكب ترتكزان على ساندات الرجلين التي في الدراجة النارية.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "أن يمسك الراكب بخصر السائق في كل وقت.",
        "أن تكون رجلي الراكب دائماً من الجهة اليمنى للدراجة النارية.",
        "أن يكون عمر الراكب ثماني سنوات على الأقل.",
        "أن تكون رجلا الراكب ترتكزان على ساندات الرجلين التي في الدراجة النارية."
      ],
      id: 302
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0257. إذا بدأت بالتجاوز في شارع باتجاهين طويل ومستقيم، وفي منتصف التجاوز تماماً ظهرت أمامك مركبة في نفس المسلك:",
      numQues: "0257",
      correctAnswer: "تمهل وتراجع عن التجاوز وعُد بسرعة إلى المسلك الأيمن.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "استعمل الضوء المتقطع للسائق الذي يقابلك وأكمل التجاوز كما خططت له.",
        "انحرف إلى اليسار وأخلي المسلك وسر على الحاشية اليسرى.",
        "استعمل الزامور وأكمل التجاوز كالمعتاد، لأنك كنت هناك قبلها.",
        "تمهل وتراجع عن التجاوز وعُد بسرعة إلى المسلك الأيمن."
      ],
      id: 303
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1600. ما هو العامل الذي يحدد قدرة راكب الدراجة النارية على الفرملة أو على الميلان أو على التسارع بالدراجة النارية؟",
      numQues: "1600",
      correctAnswer: "تماسك الدراجة النارية مع الشارع.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "مبنى مقعد الدراجة النارية.",
        "وزن راكبها.",
        "لباس راكبها حسب المواصفات.",
        "تماسك الدراجة النارية مع الشارع."
      ],
      id: 304
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1637. بأي رقم مؤشر على 'الامتداد الخلفي' للمركبة؟",
      numQues: "1637",
      correctAnswer: "23",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31637.jpg",
      choices: [
        "7",
        "27",
        "22",
        "23"
      ],
      id: 305
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0074. هل يجوز سياقة مركبة فيها مدى الرؤية إلى الأمام محدود؟",
      numQues: "0074",
      correctAnswer: "مسموح، فقط عند السياقة في ساعات النهار فقط.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "ممنوع عندما يكون الطقس ماطراً، ومسموح في أي وقتٍ آخر.",
        "ممنوع، إلا إذا مدى الرؤية محدوداً بشكلٍ قليل جداً فقط. ",
        "مسموح، إذا كان مدى الرؤية محدوداً من الأمام فقط.",
        "مسموح، فقط عند السياقة في ساعات النهار فقط."
      ],
      id: 306
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1018. متى يُستحسن فحص ضغط الهواء في الإطارات؟",
      numQues: "1018",
      correctAnswer: "لا توجد أهمية لوقت فحص ضغط الهواء ولكيفية الفحص.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "بعد السفر عندما تكون الإطارات ساخنة.",
        "فقط قبل الفحص السنوي للمركبة (التست).",
        "قبل السفر عندما تكون الإطارات باردة.",
        "لا توجد أهمية لوقت فحص ضغط الهواء ولكيفية الفحص."
      ],
      id: 307
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1168. من يجب أن يصادق على صلاحية العداد إذا نُزع عنه الختم (الرصاصة)؟",
      numQues: "1168",
      correctAnswer: "مقدم خدمة معتمد فقط.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "صاحب الصالون العمومي الذي يجب أن يوقع على المصادقة.",
        "سلطة الترخيص في مكان سكن السائق.",
        "مراقب السير على الطرق.",
        "مقدم خدمة معتمد فقط."
      ],
      id: 308
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1641. إذا سُجلت تحديدات (شروط ) في رخصة السياقة:",
      numQues: "1641",
      correctAnswer: "على سائق المركبة السياقة وفقاً للتحديدات (الشروط)المسجلة.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "تتعلق بصلاحية الدراجة النارية ولا تمت بصلة للدراجة النارية أو سياقتها.",
        "التحديد هو توصية ولا تُلزم سائق المركبة.",
        "على سائق المركبة أن يُقدر كيف يتصرف وبأي تحديد يهتمd .",
        "على سائق المركبة السياقة وفقاً للتحديدات (الشروط)المسجلة."
      ],
      id: 309
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1319. ما هو عدد أيام الاستراحة في السنة التي يستحقها سائق مركبة تجارية وزنها الإجمالي أكثر من 6000كغم؟",
      numQues: "1319",
      correctAnswer: "52 يوم على الأقل.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "حسب اتفاق العمل الجماعي.",
        "يومين في الشهر على الأقل.",
        "31 يوماً على الأقل.",
        "52 يوم على الأقل."
      ],
      id: 310
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0511. ما معنى الإشارة؟",
      numQues: "0511",
      correctAnswer: "لا توجد ضرورة بالتوقف للتفتيش الجمركي (هذا مكان للبيع بدون جمارك).",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3511.jpg",
      choices: [
        "يجب التوقف للتفتيش الجمركي.",
        "تمهل للتفتيش الجمركي.",
        "يجب التوقف فقط إذا كان لديك ما تصرح به.",
        "لا توجد ضرورة بالتوقف للتفتيش الجمركي (هذا مكان للبيع بدون جمارك)."
      ],
      id: 311
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0573. إذا نُصبت هذه الإشارة:",
      numQues: "0573",
      correctAnswer: "مسموح التوقف للباص فقط.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3572.jpg",
      choices: [
        "التوقف مسموح للصالون العمومي (التاكسيات) فقط.",
        "مسموح إصعاد الركاب في الأعياد فقط.",
        "مسموح إنزال الموظفين فقط.",
        "مسموح التوقف للباص فقط."
      ],
      id: 312
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1676. ما هي وظيفة مخفف السرعة في المركبة؟",
      numQues: "1676",
      correctAnswer: "لمساعدة الفرامل المساعدة (الهاندبريك) عند الوقوف في منحدر شديد.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "ليوازن عمل المحرك وتنظيم سرعة دوران المحرك.",
        "لاستعماله كبديل عن فرامل الخدمة (فرملة الرجل) من اجل توقف المركبة في حالة الخطر الفوري في حالة الطوارئ.",
        "لتخفيف سرعة المركبة أثناء السير ليس بواسطة جهاز الفرامل، على سبيل المثال في منحدر طويل.",
        "لمساعدة الفرامل المساعدة (الهاندبريك) عند الوقوف في منحدر شديد."
      ],
      id: 313
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0876. كيف يجب أن تكون سرعة السير عند الرجوع إلى الخلف؟",
      numQues: "0876",
      correctAnswer: "المركبة الثقيلة – بطيئة، المركبة الخفيفة- سريعة.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "بطيئة دائماً.",
        "في النهار – سريعة، في الليل – بطيئة.",
        "في المنحدر على مهل وفي الصعود بسرعة.",
        "المركبة الثقيلة – بطيئة، المركبة الخفيفة- سريعة."
      ],
      id: 314
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0424. كيف تتصرف في مقطع طريق وفي المكان الذي نُصبت فيه الإشارة؟",
      numQues: "0424",
      correctAnswer: "يجب التوقف دائماً قبل المفترق وإعطاء حق الأولوية للمركبات القادمة من اليمين والتي وتنوي الاستدارة إلى اليسار.",
      pubDate: "10-11-2011 08:22:42",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3423.jpg",
      choices: [
        "يجب التمهل وإعطاء حق الأولوية للمركبات المقتربة من المفترق من الجهة المقابلة.",
        "يجب التصرف حسب قواعد إعطاء حق الأولوية وحسب الإشارات المنصوبة في المفترق.",
        "على من يسير إلى الأمام أن يواصل سيره ويتأكد بأن المركبات المقتربة من الشارع المستقيم تعطيه حق الأولوية.",
        "يجب التوقف دائماً قبل المفترق وإعطاء حق الأولوية للمركبات القادمة من اليمين والتي وتنوي الاستدارة إلى اليسار."
      ],
      id: 315
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0838. ما هو الخطر عند الفرملة في نزول غير مخطط له من الشارع إلى حاشية الطريق؟",
      numQues: "0838",
      correctAnswer: "عدم القدرة على توجيه المقود نتيجة لاستعمال الفرامل المفرط.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "دوران المركبة نتيجة الفرملة على أنواع أسطح الطرق ذوات مُعامل احتكاك مختلفة.",
        "عدم القدرة على توجيه المقود نتيجة لزيادة ضغط الهواء في الإطارات.",
        "دوران المركبة على الشارع نتيجة إقفال العجلات الأمامية للمركبة.",
        "عدم القدرة على توجيه المقود نتيجة لاستعمال الفرامل المفرط."
      ],
      id: 316
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1292. كيف يتصرف سائق مركبة عند الاقتراب من مقطع شارع عليه زيت؟",
      numQues: "1292",
      correctAnswer: "يزيد من سرعة السير ولا يضغط على دعسة الفرامل.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "يدير المقود يمنةً ويسرى بالتناوب أثناء سيره على الزيت.",
        "يتمهل باعتدال على قدر الإمكان ولا يفرمل بشدة.",
        "يستمر بالسير العادي، لأن الزيت يساعد في زيادة الاحتكاك بين الإطارات وبين الشارع.",
        "يزيد من سرعة السير ولا يضغط على دعسة الفرامل."
      ],
      id: 317
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0122. كيف يتصرف سائقو المركبات في طريق ضيقة ومنحدرة (صعود شديد)؟",
      numQues: "0122",
      correctAnswer: "يكفي أن يتجه كلاهما إلى اليمين قريب إلى حافة الشارع لتفادي الاصطدام. ",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "إذا اقتضت الضرورة،على سائق المركبة الصاعدة إيقاف مركبته لكي يمكن المركبة النازلة من مواصلة سيرها.",
        "من يصل أولاً يدخل أولاً للمقطع الضيق.",
        "إذا اقتضت الضرورة، على سائق المركبة النازلة إيقاف مركبته عند الضرورة لكي يُمكِن المركبة الصاعدة من مواصلة سيرها.",
        "يكفي أن يتجه كلاهما إلى اليمين قريب إلى حافة الشارع لتفادي الاصطدام. "
      ],
      id: 318
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1033. ما هي العملية التي يجب تنفيذها بعد تغيير عجل؟",
      numQues: "1033",
      correctAnswer: "لا توجد ضرورة لأية عملية خاصة.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "شد براغي العجل بعد إنزال المركبة عن الرافعة (الجاك)، وإعادة هذه العملية بعد سير مسافة 50كم.",
        "فحص سخونة الإطار قبل السفرة المقبلة.",
        "ركل الإطار قليلاً كفحصٍ عام( لسلامة الإطار وصلاحية الركلة) .",
        "لا توجد ضرورة لأية عملية خاصة."
      ],
      id: 319
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0935. كيف يجب عليك التصرف عندما تضيء لمبة التحذير للفرامل أثناء السفر؟",
      numQues: "0935",
      correctAnswer: "مواصلة السير العادي لغاية الصيانة الدورية للمركبة.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "مواصلة السير البطيء لغاية الكراج، على يمين الشارع.",
        "مواصلة السير العادي لغاية الكراج، مع أضواء صفراء متقطعة.",
        "إيقاف المركبة وعدم مواصلة السير.",
        "مواصلة السير العادي لغاية الصيانة الدورية للمركبة."
      ],
      id: 320
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1236. هل يوجد واجب على الراكب بإخلاء المكان المُعد للمعاق في الباص الذي تم وسم (ترقيم) المقاعد فيه وتم حجزهم سلفاً (المقصود في سفرة خاصة مثل التجوال)؟",
      numQues: "1236",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "مكان المعاق مضمون دائماً.",
        "نعم، في سفرة خاصة فقط.",
        "كلا.",
        "نعم."
      ],
      id: 321
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1733. عند الضغط على دعسة الفرامل في الدراجة النارية تبين أن فرملة الرجل لا تُفرمل، ماذا يتوجب على السائق عمله؟",
      numQues: "1733",
      correctAnswer: "محاولة الفرملة بواسطة الضغط بشدة على مقبض الكلاتش.",
      pubDate: "10-11-2011 08:22:42",
      img: "",
      choices: [
        "محاولة الفرملة بمساعدة الفرملة المساعدة (فرملة اليد) وتعشيق غيار واطئ.",
        "إدارة مقود الدراجة (الكيدون) من اجل الفرملة بواسطة تغيير اتجاه العجلة الأمامية.",
        "الفرملة بواسطة خفض الغيارات فقط.",
        "محاولة الفرملة بواسطة الضغط بشدة على مقبض الكلاتش."
      ],
      id: 322
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0957. من يجب عليه أن يطيع إشارة 'قف' الظاهرة في الصورة؟",
      numQues: "0957",
      correctAnswer: "سائق المركبة الذي ينوي مواصلة السير إلى الأمام.",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3957.jpg",
      choices: [
        "سائق المركبة الذي ينوي الاستدارة يساراً وأيضاً سائق المركبة الذي يستمر بالسير إلى الأمام. ",
        "سائق المركبة الذي ينوي الاستدارة يساراً.",
        "كل سائق مركبة يقترب من المفترق.",
        "سائق المركبة الذي ينوي مواصلة السير إلى الأمام."
      ],
      id: 323
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0696. أية ملحقات تخفف من خطورة إصابة الركاب عند وقوع حادث طرق؟",
      numQues: "0696",
      correctAnswer: "ماسحات الزجاج الخلفية وساندات الرأس.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "مصابيح الضباب والمقاعد الطبية.",
        "أحزمة الأمان وساندات الرأس ووسائد الهواء.",
        "دعسات الفرامل والكلاتش.",
        "ماسحات الزجاج الخلفية وساندات الرأس."
      ],
      id: 324
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1116. لا يجب أن يزيد الوزن الإجمالي المسموح به للباص الصغير (أوتوبوس زعير ) عن:",
      numQues: "1116",
      correctAnswer: "3500كغم.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "4000كغم.",
        "6000كغم.",
        "5000كغم.",
        "3500كغم."
      ],
      id: 325
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1375. هناك واجب بتركيب بفرملة محرك (طفاية أكزوست) في المركبة التجارية وفي مركبة العمل التي يبلغ وزنهما الإجمالي:",
      numQues: "1375",
      correctAnswer: "12000كغم على الأقل.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "أي وزن إجمالي مسموح به.",
        "8000كغم أو أكثر.",
        "4500كغم أو أكثر.",
        "12000كغم على الأقل."
      ],
      id: 326
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0921. ماذا يميز الطريق التي أمامك؟",
      numQues: "0921",
      correctAnswer: "أنت تسير في شارع مختلط (موحد)، لائم السرعة حسب المطلوب وليس أكثر من 40كم/ساعة.",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3921.jpg",
      choices: [
        "لا يوجد مشاة في الشارع ولا يوجد أي خوف من المفاجآت من قِبلهم، كل شيء على ما يرام.",
        "طريق بلدية ومركبات واقفة ومشاة من شأنهم الظهور من بين المركبات الواقفة.",
        "يبدو الشارع عريضاً ومريحاً ومن غير المتوقع أية مفاجآت.",
        "أنت تسير في شارع مختلط (موحد)، لائم السرعة حسب المطلوب وليس أكثر من 40كم/ساعة."
      ],
      id: 327
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1395. كيف يجب التصرف في منحدر؟",
      numQues: "1395",
      correctAnswer: "بالغيار العالي وبالضغط المستمر على دعسة الفرامل.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "بغيار موحد وبالضغط المستمر على دعسة الكلاتش.",
        "بالغيار النيوترال للتوفير في الوقود.",
        "يجب أن يكون احد الغيارات معشقاً ويعمل.",
        "بالغيار العالي وبالضغط المستمر على دعسة الفرامل."
      ],
      id: 328
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1802. أي إشارة معناها محطة لتغيير بطارية لمركبة كهربائية؟",
      numQues: "1802",
      correctAnswer: "פ-151",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31802.jpg",
      choices: [
        "ס-131",
        "ס-31",
        "ס-130",
        "פ-151"
      ],
      id: 329
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1397. هل هناك واجب بالسير بغيار واطئ مناسب في كل منحدر شديد؟",
      numQues: "1397",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "كلا.",
        "يسري هذا الواجب فقط في المنحدرات التي نُصبت في بدايتها إشارة استعلامات تشير إلى منحدر.",
        "يسري الواجب فقط على المنحدرات الشديدة والتي يبلغ طولها كيلومتر واحد أو أكثر.",
        "نعم."
      ],
      id: 330
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0590. ما معنى الإشارة؟",
      numQues: "0590",
      correctAnswer: "شارع سريع أمامك.",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3590.jpg",
      choices: [
        "الدخول إلى شارع باتجاه واحد.",
        "سر باتجاه السهم، ممنوع دخول الدراجات الهوائية.",
        "هناك مسلك واحد فقط في الشارع الذي أمامك.",
        "شارع سريع أمامك."
      ],
      id: 331
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0256. في أية حالات يجب على سائق المركبة الميكانيكية 'خفت' أضواء مركبته؟",
      numQues: "0256",
      correctAnswer: "عند البحث عن مكان للوقوف.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "عند الرجوع إلى الخلف.",
        "عند الدخول إلى ساحات.",
        "عندما تكون المركبة واقفة.",
        "عند البحث عن مكان للوقوف."
      ],
      id: 332
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0008. متى يقوم ضابط الشرطة بسحب رخصة سياقة سائق لمدة 90 يوماً؟",
      numQues: "0008",
      correctAnswer: "إذا كان للسائق دخل في حادث طرق أسفر عن ضرر بمال فقط.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "إذا لم يمتثل السائق لإشارة 'قف'.",
        "إذا لم يقم السائق بإعطاء حق الأولوية.",
        "إذا كان للسائق دخل في حادث طرق أسفر عن مقتل شخص وهناك اعتقاد بتوجيه تهمة إليه.",
        "إذا كان للسائق دخل في حادث طرق أسفر عن ضرر بمال فقط."
      ],
      id: 333
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»"
      ],
      title: "0489. كيف تتصرف حسب الإشارة؟",
      numQues: "0489",
      correctAnswer: "سر على يسار الشارع كي لا تُعرض أحداً للخطر.",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3419.jpg",
      choices: [
        "تمهل واستعد لإمكانية الالتقاء مع راكبي دراجات هوائية في الطريق أمامك.",
        "لك حق الأولوية، تابع السير بسرعة.",
        "ابتعد عن حافة الشارع اليمنى.",
        "سر على يسار الشارع كي لا تُعرض أحداً للخطر."
      ],
      id: 334
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1148. هل يجوز لسائق باص أن يمنع دخول راكب من شأن ملابسه أن تلوث المقاعد في الباص؟",
      numQues: "1148",
      correctAnswer: "كلا، يجوز فقط لمنظم العمل أن يتصرف بهذا الشكل.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "كلا، أي منع لدخول راكب إلى الباص يتطلب إذن من الشرطة.",
        "نعم.",
        "كلا، فقط مدير الشركة يُحدد من لا يجوز له الصعود إلى الباص.",
        "كلا، يجوز فقط لمنظم العمل أن يتصرف بهذا الشكل."
      ],
      id: 335
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0767. كيف يتصرف سائق المركبة إذا ظهرت مركبة امن في مهمة من خلفه؟",
      numQues: "0767",
      correctAnswer: "لا توجد ضرورة لأية عملية إذا كانت مركبة الأمن تقترب من خلفه.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يتمهل وينحرف إلى اليمين إذا كان في الشارع مسلك واحد فقط.",
        "يتمهل ويدع مركبة الأمن تمر.",
        "يتوقف على يمين الشارع بعيداً عن المفترق ويدع مركبة الأمن تمر.",
        "لا توجد ضرورة لأية عملية إذا كانت مركبة الأمن تقترب من خلفه."
      ],
      id: 336
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0829. متى يجوز العبور عن مركبة أخرى من جهتها اليمنى؟",
      numQues: "0829",
      correctAnswer: "إذا كان هناك عدة مسالك في اتجاهك سيرك.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "عندما تسير المركبة الأخرى في المسلك المُعد للاستدارة إلى اليسار وتعطي إشارة (غماز) إلى اليسار.",
        "إذا كنت تستطيع إكمال التجاوز بحذر.",
        "إذا كان المسلك الأيمن خالياً وأنت في عجلة من أمرك، والمركبة التي تتجاوزها تسير ببطء.",
        "إذا كان هناك عدة مسالك في اتجاهك سيرك."
      ],
      id: 337
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0467. كيف تتصرف حسب الإشارة؟",
      numQues: "0467",
      correctAnswer: "سر بسرعة في المسلك الأيمن. ",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3466.jpg",
      choices: [
        "انتقل إلى الغيار العالي.",
        "سر على اليمين وتجاوز بسرعة.",
        "تمهل وامتنع عن الفرملة الفجائية أو الاستدارة الحادة.",
        "سر بسرعة في المسلك الأيمن. "
      ],
      id: 338
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1249. ما هي أجرة نقل عربة معاق في الصالون العمومي?",
      numQues: "1249",
      correctAnswer: "يجوز لكل سائق صالون عمومي نقل ركاب من مطار بن غوريون.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يمكن فقط لصالون عمومي له تصريح من السلطة أن يعمل في المطار وفقط حسب شروط التصريح، بما في ذلك وقوف وإيقاف الصالون العمومي.",
        "يعمل الصالون العمومي فقط بالتنسيق مع المسافر المضطر للنقل، بما في ذلك أوقات الإقلاع والهبوط المتعلقة فيه.",
        "لا يوجد تصريح بنقل الركاب من مطار بن غوريون، إلا بتنسيق الأوقات بدقة معهم.",
        "يجوز لكل سائق صالون عمومي نقل ركاب من مطار بن غوريون."
      ],
      id: 339
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0837. ما هو السبب في النزول غير المخطط له من الشارع إلى حاشية الطريق هو:",
      numQues: "0837",
      correctAnswer: "رنين الهاتف المتنقل في المركبة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "ظهور عامل مفاجئ ومعيق في مسلك سير السائق.",
        "توقف مركبة أخرى في المسلك المعاكس دون إعطاء إشارة مناسبة.",
        "خلل فني في جهاز تكييف الهواء في المركبة.",
        "رنين الهاتف المتنقل في المركبة."
      ],
      id: 340
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«D»"
      ],
      title: "0860. ماذا يجب أن نرى في المرآة الداخلية للمركبة؟",
      numQues: "0860",
      correctAnswer: "المحيط الذي نراه ما بعد النافذة الخلفية على قدر الإمكان – وعلى جانبيها.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "المنظر المرئي من يمين المركبة ومن يسارها.",
        "المنظر المرئي من الخلف 'والمساحات الميتة' فيه.",
        "الجالسين في المقاعد الخلفية.",
        "المحيط الذي نراه ما بعد النافذة الخلفية على قدر الإمكان – وعلى جانبيها."
      ],
      id: 341
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1790. هل توجد علاقة بين القدرة على تقدير الأمور لدى السائق وبين تعاطي المخدرات والكحول؟",
      numQues: "1790",
      correctAnswer: "نعم، كلاهما يضران بالقدرة على التحكم لدى السائق.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "كلا، كلاهما لا يضران بالقدرة على تقدير الأمور لدى السائق.",
        "المخدرات تضر بالقدرة على تقدير الأمور لدى السائق أما الكحول فلا.",
        "الكحول تضر بالقدرة على تقدير الأمور لدى السائق أما المخدرات فلا تضر.",
        "نعم، كلاهما يضران بالقدرة على التحكم لدى السائق."
      ],
      id: 342
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1068. من اجل فحص ضغط الهواء في الإطارات إذا كان الضغط صحيح:",
      numQues: "1068",
      correctAnswer: "يجب التوجه إلى صاحب مهنة في الإطارات مرخص، لأنه هو المعتمد فقط بفحص ضغط الهواء.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يكفي أن ننظر إليها ونقرر.",
        "يجب التوجه إلى كراج مرخص لأنه هو المعتمد بفحص ضغط الهواء في الإطارات. ",
        "نفحص الضغط بواسطة مقياس ضغط هواء.",
        "يجب التوجه إلى صاحب مهنة في الإطارات مرخص، لأنه هو المعتمد فقط بفحص ضغط الهواء."
      ],
      id: 343
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0623. ما معنى الإشارة؟",
      numQues: "0623",
      correctAnswer: "انتبه! حركة سير باتجاه واحد أمامك.",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3623.jpg",
      choices: [
        "أعطِ حق الأولوية في الطريق الضيقة.",
        "عدد المسالك في الشارع آخذ في التناقص.",
        "الدخول إلى شارع باتجاه واحد فيه مسلك واحد.",
        "انتبه! حركة سير باتجاه واحد أمامك."
      ],
      id: 344
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0058. هل يجب على كل عابر طريق إطاعة إشارات السير؟",
      numQues: "0058",
      correctAnswer: "نعم، عندما يكون في الشارع فقط.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "نعم، عندما يكون على الرصيف فقط.",
        "نعم، على كل عابر طريق أن يطيع إشارات السير.",
        "كلا، يجب على سائقي المركبات فقط إطاعة أحكام الإشارات.",
        "نعم، عندما يكون في الشارع فقط."
      ],
      id: 345
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0856. كيف نتغلب على مشكلة التعب أثناء السياقة؟",
      numQues: "0856",
      correctAnswer: "باستراحة كافية قبل البدء بالسياقة وتوقف للاستراحة وفترات للاستراحة وللانتعاش خلال السياقة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "بواسطة القهوة السمراء التي تحل كل المشاكل.",
        "نزيد من السرعة لتقصير زمن السفر وللوصول إلى البيت باكراً.",
        "استراحة قصيرة ووجبة ثقيلة تبددان التعب لفترة طويلة.",
        "باستراحة كافية قبل البدء بالسياقة وتوقف للاستراحة وفترات للاستراحة وللانتعاش خلال السياقة."
      ],
      id: 346
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1448. أي نوع مركبات يجب عليها الدخول إلى المفترق من المسلك الأيمن، في شارع فيه مسلكان أو أكثر في نفس اتجاه السير؟",
      numQues: "1448",
      correctAnswer: "مركبة تجارية ومركبة عمل وزنهما الإجمالي المسموح به أكثر من 10000كغم. ",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "مركبة تجارية وزنها الإجمالي 10000كغم أو اقل.",
        "مركبة تجارية وزنها الإجمالي المسموح به أكثر من 4000كغم.",
        "مركبة ميكانيكية تجارية وزنها الإجمالي المسموح به 6000كغم أو أكثر.",
        "مركبة تجارية ومركبة عمل وزنهما الإجمالي المسموح به أكثر من 10000كغم. "
      ],
      id: 347
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1072. من اجل ضمان وضع جلوس مريح وآمن في المركبة، يجب ضبط:",
      numQues: "1072",
      correctAnswer: "مكان المقعد وتوجيه مخارج الهواء من فتحات التهوية.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "ساندات الرأس ومكان الدعسات.",
        "مكان المقعد وزاوية ظهر المقعد ووضع عجلة المقود.",
        "المرايا العاكسة ومحطة الإذاعة.",
        "مكان المقعد وتوجيه مخارج الهواء من فتحات التهوية."
      ],
      id: 348
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1582. درجة الرخصة المطلوبة لسياقة مركبة عمل تجر مجرورة وزنها الإجمالي أكثر من 3500كغم، هي؟",
      numQues: "1582",
      correctAnswer: "D.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "B.",
        "A.",
        "C+E.",
        "D."
      ],
      id: 349
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1698. متى يُسمح باستعمال الضوء العالي في 'وقت الإنارة':",
      numQues: "1698",
      correctAnswer: "في طريق ليست بلدية عند السفر في قافلة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "في طريق ليست بلدية عندما تسمح ظروف حركة السير بذلك ولا توجد مركبة قادمة من الجهة المقابلة.",
        "فقط في طريق سريعة.",
        "في طريق بلدية مع إضاءة في الشوارع وفي طريق ليست بلدية.",
        "في طريق ليست بلدية عند السفر في قافلة."
      ],
      id: 350
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1253. من يحدد أجرة السفر في الصالون العمومي؟",
      numQues: "1253",
      correctAnswer: "مراقب السير على الطرق – بأمرٍ خاص.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "مدير سلطة الترخيص.",
        "وزير المواصلات – في الأمر بشأن الحاجيات والخدمات.",
        "النقابة القطرية لسائقي الصالون العمومي.",
        "مراقب السير على الطرق – بأمرٍ خاص."
      ],
      id: 351
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0189. كيف تتصرف عند اقترابك من مكان عبور المشاة وهناك مشاة يعبرونه؟",
      numQues: "0189",
      correctAnswer: "زد من سرعتك واعبر قبلهم أو خلفهم دون تعريضهم للخطر.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "خفف من سرعة سيرك واستعمل الزامور ونبه المشاة عن نيتك مواصلة سيرك.",
        "قف وأعطِ حق الأولوية للمشاة الذين يعبرون الشارع من اليسار إلى اليمين فقط.",
        "خفف دائماً من سرعة سيرك وحتى قف، عند الضرورة، لتمكن المشاة من إكمال عبورهم بأمان.",
        "زد من سرعتك واعبر قبلهم أو خلفهم دون تعريضهم للخطر."
      ],
      id: 352
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1350. ما هي 'مركبة العمل':",
      numQues: "1350",
      correctAnswer: "مركبة لا تزيد سرعة سيرها عن 40كم/ساعة والمستعملة للأشغال في الطريق.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "المركبة المثبت عليها أجهزة للاستعمال في تنفيذ أعمال وغير معدة لنقل البضائع ولنقل الركاب.",
        "مركبة معدة لنقل الركاب ويجوز أن تُستخدم في تنفيذ أعمال في الشارع.",
        "مركبة مستعملة في نقل البضائع مقابل أجرة.",
        "مركبة لا تزيد سرعة سيرها عن 40كم/ساعة والمستعملة للأشغال في الطريق."
      ],
      id: 353
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0872. ما هي أهمية مسك المقود بصورة صحيحة للسيطرة على المركبة ولثباتها؟",
      numQues: "0872",
      correctAnswer: "كيفية مسك المقود مهمة فقط في الاستدارات والالتواءات الحادة عندما تسير المركبة بسرعة عالية.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يمكن مسك المقود بصورة صحيحة من إدارة دقيقة لعجلة المقود (الستيرينج) والضرورية للتوجيه الدقيق في كل لحظة.",
        "في المركبات الحديثة هناك أهمية لكيفية مسك المقود فقط أثناء السير في التواءات حادة.",
        "مسك المقود بصورة صحيحة مهم فقط في المركبات الكبيرة والثقيلة، مثل الشاحنات والباصات.",
        "كيفية مسك المقود مهمة فقط في الاستدارات والالتواءات الحادة عندما تسير المركبة بسرعة عالية."
      ],
      id: 354
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1373. من أي وزن للمقطورة وللمستندة هناك واجب بتركيب فرملة مستقلة (منفردة) ؟",
      numQues: "1373",
      correctAnswer: "في المقطورة والمستندة اللتان يبلغ وزنهما الإجمالي المسموح به 3000كغم على الأقل.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "في المقطورة والمستندة اللتان وزنهما الإجمالي المسموح به 8000كغم أو أكثر.",
        "هناك واجب بتركيب فرملة مستقلة في كل مستندة وفي كل مقطورة بدون أية علاقة بالوزن. ",
        "في المقطورة والمستندة اللتان وزنهما الإجمالي المسموح به عن 19000كغم على الأقل.",
        "في المقطورة والمستندة اللتان يبلغ وزنهما الإجمالي المسموح به 3000كغم على الأقل."
      ],
      id: 355
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0123. من أية جهة يجوز لنا تجاوز مركبة أخرى؟",
      numQues: "0123",
      correctAnswer: "من جهتها اليسرى فقط.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "مسموح من اليمين وأيضاً من اليسار.",
        "من جهتها اليمنى فقط.",
        "من اليمين وبشرط المحافظة على سرعة معقولة.",
        "من جهتها اليسرى فقط."
      ],
      id: 356
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1046. متى يجب إجراء فحص تلوث الهواء المنبعث من المركبة؟",
      numQues: "1046",
      correctAnswer: "مرة كل نصف سنة في كراج الصيانة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "مرة في الشهر، في كل كراج مختص في كهرباء المركبات فقط.",
        "المركبات لا تلوث الهواء، لذلك لا توجد ضرورة للفحص على الإطلاق.",
        "عند فحص الترخيص السنوي (التست) في مؤسسة للترخيص (دينامومتر).",
        "مرة كل نصف سنة في كراج الصيانة."
      ],
      id: 357
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0538. ما معنى الإشارة؟",
      numQues: "0538",
      correctAnswer: "سر بشكلٍ متواصل، ممنوع التوقف.",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3538.jpg",
      choices: [
        "تقدم بحذر (إشارة متنقلة).",
        "سر بسرعة.",
        "توقف وانتظر تعليمات الموجه.",
        "سر بشكلٍ متواصل، ممنوع التوقف."
      ],
      id: 358
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1668. ما هي السرعة القصوى المسموح بها لدراجة نارية من درجة A (إذا لم تُنصب إشارة تشير إلى غير ذلك)؟",
      numQues: "1668",
      correctAnswer: "50 كم/ساعة في طريق بلدية و 80 كم/ساعة في طريق ليست بلدية.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "80 كم/ساعة في طريق بلدية و 100 كم/ساعة في طريق سريعة.",
        "40 كم/ساعة في طريق بلدية و 70 كم/ساعة في طريق ليست بلدية.",
        "40 كم/ساعة في طريق بلدية و 90 كم/ساعة في طريق ليست بلدية.",
        "50 كم/ساعة في طريق بلدية و 80 كم/ساعة في طريق ليست بلدية."
      ],
      id: 359
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1674. أُدين 'سائق جديد' في المحكمة بتهمة السياقة بسرعة زائدة خلال السنتين التي يُعتبر فيهما 'سائق جديد'، لذلك:",
      numQues: "1674",
      correctAnswer: "تقوم سلطة الترخيص بتجديد رخصته كأي سائق ، ولا يجوز للسلطة اشتراط أية شروط من اجل تجديد رخصة السواقة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يجوز لسلطة الترخيص دعوته لامتحانات في السياقة وإذا اجتازها بنجاح، يُعتبر مرة أخرى كسائق جديد لمدة سنتين.",
        "على سلطة الترخيص تجديد رخصته كأي سائق عادي بشرط أن لا يكون قد أُدين بأكثر من مخالفة واحدة 'كسائق جديد'.",
        "على سلطة الترخيص تجديد رخصته كأي سائق عادي بدون القيد 'سائق جديد'.",
        "تقوم سلطة الترخيص بتجديد رخصته كأي سائق ، ولا يجوز للسلطة اشتراط أية شروط من اجل تجديد رخصة السواقة."
      ],
      id: 360
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0085. أين تسير المركبات في طريق مقسمة بواسطة خط فاصل متواصل ؟",
      numQues: "0085",
      correctAnswer: "يجب أن تكون اغلب مساحة المركبة على يمين الخط.",
      pubDate: "10-11-2011 08:22:43",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3085.jpg",
      choices: [
        "على يسار الخط الفاصل.",
        "على يمين الخط ، غير أنه يُسمح بالسير عن يساره من اجل التجاوز.",
        "على يمين الخط.",
        "يجب أن تكون اغلب مساحة المركبة على يمين الخط."
      ],
      id: 361
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0282. ماذا ينص القانون بالنسبة لوضع أمتعة أو تركها على الطريق؟",
      numQues: "0282",
      correctAnswer: "ممنوع وضع أو ترك أي متاع من شأنه تشكيل عرقلة لعابري الطريق أو لمركباتهم أو تعريضهم للخطر.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يجب إزالة الأمتعة التي تُركت في الطريق خلال 12 ساعة من لحظة تركها هناك.",
        "مسموح ترك أي متاع على الطريق بشرط أن يتم تأشيره بواسطة عاكس في 'وقت الإنارة'.",
        "مسموح تركها، لكن يجب تبليغ وزارة جودة البيئة عن كل متاع تم وضعه على سطح الطريق.",
        "ممنوع وضع أو ترك أي متاع من شأنه تشكيل عرقلة لعابري الطريق أو لمركباتهم أو تعريضهم للخطر."
      ],
      id: 362
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1649. عند سياقة دراجة نارية في شارع رطب، فمن المتوقع وجود خطر:",
      numQues: "1649",
      correctAnswer: "تزحلق وانقلاب الدراجة النارية كلما خفت السرعة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "تزحلق وانقلاب الدراجة النارية كلما زادت السرعة.",
        "انقلاب الدراجة النارية إذا ضغط السائق بشكلٍ فجائي على مقبض الكلاتش.",
        "تسرب ماء إلى داخل المحرك وذلك يسبب الصدأ.",
        "تزحلق وانقلاب الدراجة النارية كلما خفت السرعة."
      ],
      id: 363
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0869. معرفة الأجهزة المختلفة في كابينة السائق تمكن السائق أثناء السياقة من:",
      numQues: "0869",
      correctAnswer: "أجهزة المركبة أوتوماتيكية، بدون التفكير على الإطلاق.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "التركيز الأقصى على حركة السير في الطريق.",
        "تشغيل أجهزة المركبة بشكلٍ عادي.",
        "لا تُمكن من أي شيء ولا توجد فيها أية ميزة غير معرفة الأجهزة.",
        "أجهزة المركبة أوتوماتيكية، بدون التفكير على الإطلاق."
      ],
      id: 364
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1782. تقترب مركبتان من الشمال ومن الجنوب إلى مقطع طريق ضيق ومنحدر والذي يتسع لمرور مركبة واحدة فقط:",
      numQues: "1782",
      correctAnswer: "المركبة النازلة تقف وتمكن المركبة الصاعدة من المرور.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يجب إعطاء حق الأولوية للمركبة التجارية التي يزيد وزنها عن 4 طن.",
        "على المركبتين النزول إلى حاشية الطريق.",
        "المركبة الصاعدة تقف.",
        "المركبة النازلة تقف وتمكن المركبة الصاعدة من المرور."
      ],
      id: 365
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "1538. كيف يجب وسم (تأشير) حمولة بارزة من القسم الخلفي للمركبة؟",
      numQues: "1538",
      correctAnswer: "بمصباح ابيض أو اصفر على طرف الحمولة البارزة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "بمصباح احمر على طرف الحمولة البارزة.",
        "بمثلث عاكس احمر على طرف الحمولة البارزة.",
        "بمثلث عاكس ابيض على طرف الحمولة البارزة.",
        "بمصباح ابيض أو اصفر على طرف الحمولة البارزة."
      ],
      id: 366
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0988. كيف تتصرف للتأكد من سير آمن في منحدر شديد وطويل؟",
      numQues: "0988",
      correctAnswer: "يجب استغلال فرملة المحرك فقط.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "يجب استغلال فرملة المحرك بواسطة تعشيق غيار واطئ والاستعانة جزئياً بالفرامل.",
        "لا يوصى بالسياقة المتواصلة في المنحدرات الحادة.",
        "يجب الضغط على دعسة الفرامل بقوة وبشكلٍ متواصل للمحافظة على السرعة المرجوة.",
        "يجب استغلال فرملة المحرك فقط."
      ],
      id: 367
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1091. لماذا نملأ عجلات التراكتور بالماء؟",
      numQues: "1091",
      correctAnswer: "من اجل منع سخونة الإطارات وخصوصاً في الأعمال الصعبة.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "من اجل إضافة وزن وبذلك نحسن تماسك العجلات بالأرض.",
        "من اجل تحسين جودة وسهولة السير بالتراكتور في الطرق الترابية.",
        "هذه طريقة مريحة لنقل الماء للميدان من اجل غايات مختلفة أثناء العمل.",
        "من اجل منع سخونة الإطارات وخصوصاً في الأعمال الصعبة."
      ],
      id: 368
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1590. ما هي أقل فتره زمنيه التي يجب أن يكون لدى السائق فيها رخصة سواقة من اجل أن يسمح له بسياقة تراكتور وزنه أكثر من 3,200كغم أو إذا ألحقت به مجرورة وزنها الإجمالي أكثر من 4,000كغم؟",
      numQues: "1590",
      correctAnswer: "سنة من تاريخ حصوله على رخصة السياقة للتراكتور.",
      pubDate: "10-11-2011 08:22:43",
      img: "",
      choices: [
        "سنتين من تاريخ حصوله على رخصة السياقة للتراكتور.",
        "3 أشهر من تاريخ حصوله على رخصة السياقة للتراكتور.",
        "6 أشهر من تاريخ حصوله على رخصة السياقة للتراكتور.",
        "سنة من تاريخ حصوله على رخصة السياقة للتراكتور."
      ],
      id: 369
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0063. هل هناك واجب بإطاعة أوامر عامل قسم الأشغال العامة بلباسه الرسمي؟",
      numQues: "0063",
      correctAnswer: "نعم، في طريق بلدية فقط.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "كلا، يجب إطاعة شرطي بلباسه الرسمي.",
        "نعم في المكان الذي تجري فيه أعمال التزفيت أو صيانة الشارع.",
        "كلا، إلا انه يجب إطاعته من اجل التوقف على حاشية الطريق فقط.",
        "نعم، في طريق بلدية فقط."
      ],
      id: 370
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1030. يُسبب ضغط هواء اقل من اللازم في الإطارات في:",
      numQues: "1030",
      correctAnswer: "لا يتسبب في أي شيء: لا يوجد أي تأثير لضغط هواء منخفض في الإطارات على السفر.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "لسفر أكثر هدوءا.",
        "زيادة في استهلاك الوقود وزيادة في تلوث الهواء.",
        "مقود سهل التشغيل.",
        "لا يتسبب في أي شيء: لا يوجد أي تأثير لضغط هواء منخفض في الإطارات على السفر."
      ],
      id: 371
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1096. متى يستوجب فرملة عجل واحد في التراكتور (فصل الفرامل)؟",
      numQues: "1096",
      correctAnswer: "عندما يريد سائق التراكتور تنفيذ استدارة حادة في المكان بسرعة بطيئة جداً.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "عندما يريد سائق التراكتور تنفيذ استدارة حادة في المكان بسرعة عالية.",
        "عندما يتزحلق عجل واحد على سطح الطريق ولا يتقدم التراكتور.",
        "عندما يريد سائق التراكتور تنفيذ مناورة بنصف قطر كبير بشكلٍ خاص بين مبانٍ أو محصول.",
        "عندما يريد سائق التراكتور تنفيذ استدارة حادة في المكان بسرعة بطيئة جداً."
      ],
      id: 372
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0076. كيف يُسمح باستعمال جهاز الهاتف النقال (البلفون) أثناء السياقة؟",
      numQues: "0076",
      correctAnswer: "فقط بواسطة جهاز تلفون موصول مع الأذنين.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "ممنوع استعمال الهاتف أثناء السياقة على الإطلاق.",
        "إذا كان السائق يمسك بالجهاز في اليد اليمنى.",
        "فقط بواسطة ميكروفون وسماعة (ديبوريت) والتي تمكن من إستعمال جهاز الهاتف النقال بدون مسك الجهاز.",
        "فقط بواسطة جهاز تلفون موصول مع الأذنين."
      ],
      id: 373
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0805. ما هي الميزة للسائق عند السير بسرعة بطيئة في الأوضاع الخطرة؟",
      numQues: "0805",
      correctAnswer: "تكون كل من مسافة رد الفعل ومسافة الفرملة ومسافة التوقف قصيرة.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "يكون زمن رد الفعل أطول بحيث يكفي للتوقف.",
        "تكون مسافة رد الفعل والفرملة والتوقف أطول ، لذلك تتحسن السلامة.",
        "يكون زمن رد الفعل أطول بحيث يكفي للسائق بأن يقرر بشكلٍ صحيح.",
        "تكون كل من مسافة رد الفعل ومسافة الفرملة ومسافة التوقف قصيرة."
      ],
      id: 374
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1250. هل يجوز للسلطة تعليق رخصة السفرة للصالون العمومي؟",
      numQues: "1250",
      correctAnswer: "نعم، يجوز للسلطة فعل ذلك، لكن بناءً على قرار المحكمة فقط.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "نعم، يجوز لها إذا لم يحضر صاحب الرخصة في المكان والزمان الذي استدعته السلطة فيهما.",
        "كلا، لا يجوز للسلطة تعليق أية رخصة.",
        "كلا، يجوز للمحكمة فقط تعليق رخصة الصالون العمومي.",
        "نعم، يجوز للسلطة فعل ذلك، لكن بناءً على قرار المحكمة فقط."
      ],
      id: 375
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1556. ما هو الفرق بين الإشارتين؟",
      numQues: "1556",
      correctAnswer: "الإشارتان تنتميان لمجموعة إشارات الإرشاد وتُحذران السائق من الحيوانات في الطريق.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31556.jpg",
      choices: [
        "الإشارة 146 تمنع دخول الحيوانات ، الإشارة 411 تُحذر من حيوانات برية.",
        "الإشارتان تنتميان لمجموعة إشارات الاستعلامات وتُحذران السائق من الحيوانات في الطريق.",
        "الإشارة 146 تُحذر من حيوانات برية في الطريق، الإشارة 411 تمنع دخول الحيوانات.",
        "الإشارتان تنتميان لمجموعة إشارات الإرشاد وتُحذران السائق من الحيوانات في الطريق."
      ],
      id: 376
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1103. ماذا لا يجوز لك عمله إذا قمت بإقفال الباككس في التراكتور؟",
      numQues: "1103",
      correctAnswer: "تغيير غيارات أثناء السير.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "إدارة المقود والعجلات إلى الجوانب.",
        "توصيل الفرملة اليمنى بالفرملة اليسرى.",
        "تشغيل ناقل القوة 'بي.تي.أو' (PTO).",
        "تغيير غيارات أثناء السير."
      ],
      id: 377
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1768. ما هي الجملة الصحيحة؟",
      numQues: "1768",
      correctAnswer: "واجب الحذر يُلزم بالسياقة البطيئة في جميع الأحوال.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "على سائق المركبة التصرف بشكلٍ لا يُجحف معه بحق أي شخص آخر من استعمال الطريق استعمالاً تاماً.",
        "سائق المركبة الذي يقترب من ممر المشاة غير ملزم بالتمهل في جميع الأحوال.",
        "يُسمح لصاحب المركبة بأن يحجز له مكان وقوف مجاوراً لمكان عمله.",
        "واجب الحذر يُلزم بالسياقة البطيئة في جميع الأحوال."
      ],
      id: 378
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1390. ما هو الفرق بين الإشارتين؟",
      numQues: "1390",
      correctAnswer: "الإشارة 505 تشير إلى محطة باصات خصوصية، الإشارة 506 تشير إلى محطة قطار خفيف.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31390.jpg",
      choices: [
        "الإشارة 505 تشير إلى محطة باصات عمومية، الإشارة 506 تشير إلى محطة قطار خفيف.",
        "الإشارة 505 تشير إلى محطة قطار خفيف، الإشارة 506 تشير إلى محطة باصات عمومية.",
        "الإشارة 505 تشير إلى محطة باصات في طريق سريعة، الإشارة 506 تشير إلى محطة باصات عمومية في طريق بلدية فقط.",
        "الإشارة 505 تشير إلى محطة باصات خصوصية، الإشارة 506 تشير إلى محطة قطار خفيف."
      ],
      id: 379
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1610. يُمنع نقل راكب أضافي على الدراجة النارية:",
      numQues: "1610",
      correctAnswer: "إلا إذا كان بحوزة الراكب رخصة سياقة سارية المفعول لدراجة نارية.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "إلا إذا كان الراكب يرتدي خوذة واقية ومزود بواقيات الركبتين وبواقيات المفاصل.",
        "إلا إذا كان السائق والراكب يرتديان خوذة ( قبعة ) واقية.",
        "إلا إذا كان السائق يرتدي خوذة واقية أما الراكب فغير مُلزَم.",
        "إلا إذا كان بحوزة الراكب رخصة سياقة سارية المفعول لدراجة نارية."
      ],
      id: 380
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0918. هناك حدث ظاهر في الصورة التي أمامك، كيف تتصرف؟",
      numQues: "0918",
      correctAnswer: "انتقل إلى المسلك الأيسر وتجاوز الماشي.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3917.jpg",
      choices: [
        "توقف بجانب الماشي واشرح له بأن المكان الصحيح للمشاة هو ممر المشاة الموجود خلفه.",
        "تمهل وانتبه واستعد للتوقف ولا تقم بعمل أي شيء من شأنه تعريض الماشي للخطر أو إخافته.",
        "توقف قبل الماشي وأشر له بأية طريقة ممكنة بأنه يوجد ممر للمشاة خلفه.",
        "انتقل إلى المسلك الأيسر وتجاوز الماشي."
      ],
      id: 381
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0140. في أية ظروف وفي أية حالة عليك تخفيف سرعة سيرك؟",
      numQues: "0140",
      correctAnswer: "عند الدخول إلى مسلك التسارع.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "في شارع باتجاهين فيه 4 مسالك.",
        "عند مرورك من تحت جسر.",
        "عند توقع حدوث خطر على مركبتك أو على عابري الطريق أو الممتلكات.",
        "عند الدخول إلى مسلك التسارع."
      ],
      id: 382
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0127. وسائل الإصلاح الإدارية من قِبل سلطة الترخيص حسب طريقة النقاط:",
      numQues: "0127",
      correctAnswer: "تُفرض فقط من قِبل المحكمة.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "تُفرض بالإضافة إلى كل عقوبة أخرى تفرضها المحكمة على السائق بسبب مخالفة سير",
        "تُمكن ضابط الشرطة من سحب رخصة السياقة على كل مخالفة مرور. ",
        "تُفرض فقط إذا لم تفرض المحكمة أية عقوبة على السائق.",
        "تُفرض فقط من قِبل المحكمة."
      ],
      id: 383
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1747. ممنوع التجاوز قبل ممر المشاة:",
      numQues: "1747",
      correctAnswer: "فقط في طريق ليست بلدية.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "في جميع الحالات.",
        "فقط في شارع داخل المدن باتجاهين فقط.",
        "فقط عندما تكون هناك إشارة 'ممر مشاة' أمامك.",
        "فقط في طريق ليست بلدية."
      ],
      id: 384
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "0334. ما هو العمر الأدنى (اقل عمر) المطلوب للحصول على رخصة سياقة من الدرجة 1 ؟",
      numQues: "0334",
      correctAnswer: "16 سنة.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "17 سنة.",
        "19 سنة.",
        "18 سنة.",
        "16 سنة."
      ],
      id: 385
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1549. على من تقع مسؤولية فحص وجود الأجهزة الكاملة للإسعاف الأولي في الباص؟",
      numQues: "1549",
      correctAnswer: "سائق الباص هو الذي يجب أن يتأكد من وجود الأجهزة في الباص في كل وقت.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "مدير كراج الشركة هو الذي يجب أن يتأكد من وجود الأجهزة في الباص في كل وقت.",
        "على سائق الباص التأكد إذا كانت الأجهزة موجودة، فقط عندما يخرج الباص للمرة الأولى من الكراج بعد التصليح.",
        "صاحب الباص.",
        "سائق الباص هو الذي يجب أن يتأكد من وجود الأجهزة في الباص في كل وقت."
      ],
      id: 386
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1449. على سائق المركبة الذي ينقل أكثر من 8 ركاب والملزم باستعمال أدوات بصرية:",
      numQues: "1449",
      correctAnswer: "أن يجري فحص نظر مرة كل ستة أشهر حسب المطلوب.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "أن يفحص ويتأكد من سلامة ونظافة الأدوات البصرية قبل البدء بالسير.",
        "أن يكون بحوزته في المركبة زوج أدوات بصرية إضافة إلى الأدوات التي يستعملها.",
        "أن يكون بحوزته زوج نظارات شمسية إضافة إلى الأدوات البصرية التي يستعملها.",
        "أن يجري فحص نظر مرة كل ستة أشهر حسب المطلوب."
      ],
      id: 387
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1491. ما هي الجملة الصحيحة؟",
      numQues: "1491",
      correctAnswer: "مسافة رد الفعل اكبر من مسافة الفرملة دائماً.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "مسافة التوقف تكون دائماً اكبر من مسافة الفرملة.",
        "مسافة الفرملة اكبر من مسافة رد الفعل دائماً.",
        "مسافة الفرملة اكبر من مسافة التوقف دائماً.",
        "مسافة رد الفعل اكبر من مسافة الفرملة دائماً."
      ],
      id: 388
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1206. كيف تتم الإشارة إلى الباص الذي توجد ضرورة بإيقافه في الليل في طريق ليست بلدية؟",
      numQues: "1206",
      correctAnswer: "بواسطة مثلث تحذير يمكن رؤيته من قِبل القادمين من خلفه من مسافة 100م على الأقل وأيضاً بتشغيل أضواء الطوارئ (الأربعة غمازات) في الباص.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "تتم الإشارة إليه كأية مركبة أخرى.",
        "بواسطة مثلث تحذير يمكن رؤيته من قِبل القادمين من خلفه من مسافة 50م وأيضاً بنور اصفر متقطع يمكن رؤيته من مسافة 100م.",
        "لا يوجد واجب بالتأشير، لكن سحبه فوراً من المكان.",
        "بواسطة مثلث تحذير يمكن رؤيته من قِبل القادمين من خلفه من مسافة 100م على الأقل وأيضاً بتشغيل أضواء الطوارئ (الأربعة غمازات) في الباص."
      ],
      id: 389
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1738. عند اقترابك من مركبة تقوم بإنزال أولاد:",
      numQues: "1738",
      correctAnswer: "انزل إلى حاشية الطريق واعبر عن المركبة من يمينها.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "خفف من سرعة سيرك وسر بسرعة معقولة واستعد لإمكانية التوقف.",
        "عليك استعمال الزامور وتجاوز المركبة من يسارها.",
        "عليك تجاوزها بسرعة كي تقلل من الخطر.",
        "انزل إلى حاشية الطريق واعبر عن المركبة من يمينها."
      ],
      id: 390
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0633. ما معنى الإشارة الموسومة (المؤشرة) على سطح الطريق (خط متقطع بلون اصفر)؟",
      numQues: "0633",
      correctAnswer: "مكان تجري فيه أشغال في الشارع.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3633.jpg",
      choices: [
        "فصل بين حاشية الطريق وبين الشارع.",
        "وسم (تأشير) مسلك سير الدراجات النارية.",
        "مسلك المواصلات العمومية.",
        "مكان تجري فيه أشغال في الشارع."
      ],
      id: 391
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0961. حسب الإشارات الظاهرة في الصورة، الطريق التي تستدير إلى اليسار هي:",
      numQues: "0961",
      correctAnswer: "طريق ليست بلدية.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3960.jpg",
      choices: [
        "طريق سريعة.",
        "شارع بدون مخرج.",
        "طريق رئيسية ليست بلدية.",
        "طريق ليست بلدية."
      ],
      id: 392
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1314. ما هو الارتفاع الأقصى للحمولة التي هي وحدة واحدة والمسموح بنقلها في مركبة تجارية وزنها الإجمالي أكثر من 15000كغم (بدون إذن من ضابط الشرطة)؟",
      numQues: "1314",
      correctAnswer: "4.80م. ",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "4.20م. ",
        "3.50م. ",
        "3.80م. ",
        "4.80م. "
      ],
      id: 393
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0447. أنت تسير في شارع، وعلى يسارك خط فاصل متواصل موسوم (مؤشر)وعلى يساره خط متقطع؟",
      numQues: "0447",
      correctAnswer: "مسموح اختراق الخطوط لكن لا يجوز اختراقها من قِبل المركبة القادمة من الاتجاه المعاكس.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3447.jpg",
      choices: [
        "ممنوع اختراق الخط الفاصل المتواصل.",
        "مسموح اختراق الخطوط بعجلتين فقط.",
        "مسموح اختراق الخطوط بحذر.",
        "مسموح اختراق الخطوط لكن لا يجوز اختراقها من قِبل المركبة القادمة من الاتجاه المعاكس."
      ],
      id: 394
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»"
      ],
      title: "1040. على ماذا يجب الحرص عند إيقاف مركبة في موقف مغلق؟",
      numQues: "1040",
      correctAnswer: "يجب الحرص على أن يستمر المحرك في العمل لمدة 20 دقيقة على الأقل بعد توقف المركبة من اجل تبريده.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "لا توجد ضرورة للحرص على أي شيء، لا توجد أية تحديدات بالنسبة لإيقاف مركبة في موقف مغلق.",
        "لا يجب ترك محرك المركبة يعمل أكثر من مدة نصف ساعة متواصلة.",
        "يجب الامتناع من ترك المحرك يعمل لوقت طويل بسبب عدم وجود تهوية في الموقف.",
        "يجب الحرص على أن يستمر المحرك في العمل لمدة 20 دقيقة على الأقل بعد توقف المركبة من اجل تبريده."
      ],
      id: 395
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0509. ماذا تعني الإشارة؟",
      numQues: "0509",
      correctAnswer: "ممنوع دخول أية مركبة يزيد عرضها أو عرض حمولتها بالأمتار عن العرض المذكور في الإشارة.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3509.jpg",
      choices: [
        "الدخول ممنوع فقط لمركبة تجارية لا يزيد عرضها بالأمتار عن الرقم المسجل في الإشارة.",
        "ممنوع دخول أية مركبة يقل عرضها بالأمتار عن العرض المذكور في الإشارة.",
        "ممنوع دخول المركبات غير الميكانيكية فقط.",
        "ممنوع دخول أية مركبة يزيد عرضها أو عرض حمولتها بالأمتار عن العرض المذكور في الإشارة."
      ],
      id: 396
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1542. من شأن السياقة في الظلام وبالضوء العالي أن تسبب:",
      numQues: "1542",
      correctAnswer: "في التبذير في استهلاك الكهرباء.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "في بهر نظر السائقين الآخرين.",
        "في ضرر بمقدرة السائق على الرؤية.",
        "في إصابة البطارية بخلل.",
        "في التبذير في استهلاك الكهرباء."
      ],
      id: 397
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0731. كيف نمنع الأوضاع الخطرة عند بدء السير والاندماج في حركة السير؟",
      numQues: "0731",
      correctAnswer: "ندخل إلى المسلك الذي تنساب فيه حركة السير وبذلك نمنع أوضاع خطرة.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "نعطي الإشارة المناسبة بواسطة جهاز إعطاء الإشارة وننظر نحو جميع الاتجاهات قبل البدء بالسفر وننتظر لغاية اللحظة التي لا نعرقل فيها أحداً.",
        "نسير بشكلٍ مائل وبسرعة أكثر، بهذا نمنع الخطر حين الاندماج.",
        "نُشغل جميع غمازات الطوارئ، وبذلك نحذر السائقين الآخرين ونمنع أوضاع خطرة عند الاندماج.",
        "ندخل إلى المسلك الذي تنساب فيه حركة السير وبذلك نمنع أوضاع خطرة."
      ],
      id: 398
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1416. 'الرافعة المتحركة' هي:",
      numQues: "1416",
      correctAnswer: "جهاز حديث مُعد لرفع المحور عند تغيير عجل من جراء ثقب (بنشر).",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "جهاز مُركب بشكلٍ ثابت في المركبة ومُعد لرفع أو إنزال صندوق متغير.",
        "جهاز موصول بشكل ثابت في المركبة ومُعد لرفع جهة واحدة من مسطح التحميل الجانبي.",
        "جهاز مثبت في المركبة لمنع انقلابها عند تنزيل أو تحميل صندوق متغير.",
        "جهاز حديث مُعد لرفع المحور عند تغيير عجل من جراء ثقب (بنشر)."
      ],
      id: 399
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0933. كيف تتصرف في مقطع الطريق الذي أمامك؟",
      numQues: "0933",
      correctAnswer: "سر بغيار واطئ، أمامك صعود شديد.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3933.jpg",
      choices: [
        "سر بغيار عالي لتجنب سخونة المحرك.",
        "تمهل وسر بغيار واطئ واحرص على سخونة محرك صحيحة.",
        "تمهل وابقَ على يمين الشارع بسبب مدى الرؤية المحدود.",
        "سر بغيار واطئ، أمامك صعود شديد."
      ],
      id: 400
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0890. لأية غاية تستخدم حاشية الطريق في طريق سريعة؟",
      numQues: "0890",
      correctAnswer: "هذا مكان للوقوف والتوقف من اجل انتعاش سائق تعب.",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3079.jpg",
      choices: [
        "هذا مسلك يُستخدم لمجاوزة مركبة بطيئة والتي تسير خلافاً للقانون في المسلك الأيمن.",
        "مكان للتوقف من اجل التكلم في الهاتف النقال.",
        "مكان للهرب في حالة الخطر.",
        "هذا مكان للوقوف والتوقف من اجل انتعاش سائق تعب."
      ],
      id: 401
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0504. أية إشارة تُنصب في الطريق للدلالة على تغيير في عدد المسالك في الطريق؟",
      numQues: "0504",
      correctAnswer: "622",
      pubDate: "10-11-2011 08:22:44",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3504.jpg",
      choices: [
        "111",
        "109",
        "145",
        "622"
      ],
      id: 402
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1518. ما هو الحل الناجع لمشكلة التعب لدى السائق؟",
      numQues: "1518",
      correctAnswer: "ملاءمة السرعة لوضع التعب (السير ببطء أكثر كلما كان السائق تعباً أكثر).",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "التوقف والاستراحة.",
        "تشغيل المساحات وحل الكلمات المتقاطعة.",
        "تشغيل مصابيح الضباب.",
        "ملاءمة السرعة لوضع التعب (السير ببطء أكثر كلما كان السائق تعباً أكثر)."
      ],
      id: 403
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1704. وقوع حادث بسبب تعب السائق من شأنه أن يحدث:",
      numQues: "1704",
      correctAnswer: "فقط في الطرق الصاعدة بشكلٍ حاد والطويلة.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "في الطرق الضيقة والملتوية فقط، وليس في مقاطع الطرق المستقيمة والعريضة والمريحة.",
        "عندما يتدنى (ينخفض) مستوى يقظة السائق.",
        "فقط في الطرق التي فيها منحدرات شديدة وطويلة.",
        "فقط في الطرق الصاعدة بشكلٍ حاد والطويلة."
      ],
      id: 404
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»"
      ],
      title: "1469. كيف يتم توصيل الساندة مع المستندة؟",
      numQues: "1469",
      correctAnswer: "بواسطة الرجوع إلى الخلف وبزاوية لا تزيد عن 15 درجة.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "بواسطة الرجوع إلى الخلف عندما تكون الساندة بشكل زاوية مائلة أو أية زاوية مريحة أخرى.",
        "بواسطة دفع المستندة إلى الأمام لغاية الساندة.",
        "يقوم سائق الساندة بالرجوع إلى الخلف عندما تكون الساندة والمستندة بخط مستقيم.",
        "بواسطة الرجوع إلى الخلف وبزاوية لا تزيد عن 15 درجة."
      ],
      id: 405
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0202. هل يجوز إيقاف مركبة داخل حدود المفترق؟",
      numQues: "0202",
      correctAnswer: "مسموح لخمس دقائق على الأكثر.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "مسموح وقوف المركبات التي تسير على عجلتين فقط.",
        "ممنوع، إلا إذا سُمح بالوقوف بواسطة إشارة.",
        "مسموح، في مفترق فيه مسلكان أو أكثر.",
        "مسموح لخمس دقائق على الأكثر."
      ],
      id: 406
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0175. لمن عليك إعطاء حق الأولوية عندما تستدير يساراً في مفترق لم تُنصب فيه إشارات؟",
      numQues: "0175",
      correctAnswer: "للمركبة القادمة من الأمام وللمركبة القادمة من اليمين.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "للمركبة الأسرع.",
        "فقط للمركبة القادمة من اليسار فقط.",
        "فقط للمركبة القادمة من الأمام فقط.",
        "للمركبة القادمة من الأمام وللمركبة القادمة من اليمين."
      ],
      id: 407
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0295. هل يجوز سياقة مركبة، عندما يكون السائق تحت تأثير المخدرات أو الكحول؟",
      numQues: "0295",
      correctAnswer: "ممنوع منعاً باتاً.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "مسموح لمسافة سفر قصيرة لغاية البيت.",
        "مسموح في حسب تعليمات طبيب فقط.",
        "مسموح من اجل السفر لتلقي العلاج الطبي فقط.",
        "ممنوع منعاً باتاً."
      ],
      id: 408
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0346. يجوز لفاحص مركبات أو شرطي يحمل هوية فاحص إذا وجد خلل فني في المركبة أن:",
      numQues: "0346",
      correctAnswer: "لا يجوز له عمل أي شيء ولا توجد أية صلاحية للفاحص أو للشرطي بفحص المركبة في الطريق.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "يستدعي صاحب المركبة للاستفسار لدى اتحاد الكراجات.",
        "يُسلم السائق إشعار بالتوقف عن استعمال المركبة ويأخذ منه رخصة المركبة.",
        "إرسال المركبة لمؤسسة ترخيص لعمل فحص نصف سنوي إضافي.",
        "لا يجوز له عمل أي شيء ولا توجد أية صلاحية للفاحص أو للشرطي بفحص المركبة في الطريق."
      ],
      id: 409
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0989. ماذا يمكن أن يحدث نتيجة لسخونة الفرامل؟",
      numQues: "0989",
      correctAnswer: "تفقد المركبة خاصية التوجيه فيها.",
      pubDate: "10-11-2011 08:22:44",
      img: "",
      choices: [
        "تقل نجاعة الفرامل بشكلٍ كبير.",
        "تسخن الإطارات وتهترئ بشكلٍ أسرع.",
        "يسخن المحرك أكثر من اللازم.",
        "تفقد المركبة خاصية التوجيه فيها."
      ],
      id: 410
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1741. في مفترق بدون إشارات، يجب إعطاء حق الأولوية:",
      numQues: "1741",
      correctAnswer: "للمركبة القادمة من اليمين.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "للمركبة القادمة من اليسار.",
        "للمركبات العمومية.",
        "للمركبة التي تستدير يميناً أو يساراً.",
        "للمركبة القادمة من اليمين."
      ],
      id: 411
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1064. ما هي الخطورة من استعمال جهاز التوجيه ( شاشه التوجيه لأماكن ) (GPS) أثناء السياقة ؟",
      numQues: "1064",
      correctAnswer: "لا توجد أية خطورة من استعمال جهاز التوجيه 'جي.بي.أس' (GPS) أثناء السياقة فهو مفيد فقط. ",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "تفريغ سريع لبطارية المركبة.",
        "تشتيت انتباه السائق عن الطريق.",
        "تشويش نظم إدارة المحرك. ",
        "لا توجد أية خطورة من استعمال جهاز التوجيه 'جي.بي.أس' (GPS) أثناء السياقة فهو مفيد فقط. "
      ],
      id: 412
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0630. ما معنى الإشارة؟",
      numQues: "0630",
      correctAnswer: "نهاية الشارع المختلط (الموحد).",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3630.jpg",
      choices: [
        "منطقة مسموح للأولاد اللعب فيها برفقة بالغين فقط.",
        "شارع مختلط (موحد) ممنوع وقوف المركبات فيه.",
        "السرعة القصوى المسموح بها في هذا المكان وما بعده هي 30كم/ساعة.",
        "نهاية الشارع المختلط (الموحد)."
      ],
      id: 413
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1753. لا يوقف احد مركبة ولا يتوقف في طريق قبل ملتقى سكة حديد وبعدها على مسافة:",
      numQues: "1753",
      correctAnswer: "20م على الأقل.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "50م على الأقل.",
        "30م على الأقل.",
        "25م على الأقل.",
        "20م على الأقل."
      ],
      id: 414
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0667. ما هو مفهوم الضوء الظاهر في الإشارة الضوئية (الرمزور) (اصفر غير متقطع)؟",
      numQues: "0667",
      correctAnswer: "استعد للسير حالاً عندما يتغير الضوء إلى اخضر.",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3667.jpg",
      choices: [
        "مسموح السير إلى الأمام والى اليمين والى اليسار.",
        "توقف قبل المفترق، إلا إذا لم تستطع التوقف بأمان.",
        "استمر بالسير، سوف يتغير الضوء حالاً في الإشارة الضوئية إلى اخضر. ",
        "استعد للسير حالاً عندما يتغير الضوء إلى اخضر."
      ],
      id: 415
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0025. ما هو 'الوزن الإجمالي المسموح به'؟",
      numQues: "0025",
      correctAnswer: "السعة الذاتية للمركبة بالإضافة إلى وزن الأشخاص الذين سمحت سلطة الترخيص بنقلهم ووزن الحمولة التي سمحت بتحميلها في المركبة.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "فقط الوزن الذاتي للمركبة، الذي سمحت سلطة الترخيص بنقله أو بتحميله.",
        "الوزن الفارغ للمركبة بالإضافة إلى وزن الأشخاص الذين سمحت سلطة الترخيص بنقلهم ووزن الحمولة التي سمحت بتحميلها في المركبة.",
        "السعة الذاتية للمركبة والحمولة التي سمحت سلطة الترخيص بنقلها أو بتحميلها.",
        "السعة الذاتية للمركبة بالإضافة إلى وزن الأشخاص الذين سمحت سلطة الترخيص بنقلهم ووزن الحمولة التي سمحت بتحميلها في المركبة."
      ],
      id: 416
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1438. أية مركبة تجارية لا يجوز لها السير في طريق ليست بلدية بسرعة تزيد عن 80كم/ساعة؟",
      numQues: "1438",
      correctAnswer: "مركبة تجارية وزنها الإجمالي المسموح به يزيد عن 12000كغم.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "مركبة تجارية وزنها الإجمالي المسموح به 10000كغم أو اقل.",
        "باص وزنه الإجمالي عن 10000كغم أو أكثر.",
        "مركبة تجارية وزنها الحقيقي يصل إلى 'الوزن الإجمالي المسموح به'.",
        "مركبة تجارية وزنها الإجمالي المسموح به يزيد عن 12000كغم."
      ],
      id: 417
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0800. ما هي 'المساحة الميتة'؟",
      numQues: "0800",
      correctAnswer: "مساحة حول المركبة لا يستطيع منها السائق مشاهدتها ومشاهدة من فيها. ",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "المسافة التي يتوجب على سائق المركبة المحافظة عليها من المركبة الأخرى عند الرجوع إلى الخلف.",
        "المساحة التي حول المركبة التي يراها السائق فقط في المرايا. ",
        "المساحة التي حول المركبة وغير المعبدة.",
        "مساحة حول المركبة لا يستطيع منها السائق مشاهدتها ومشاهدة من فيها. "
      ],
      id: 418
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1462. عندما تسوق شاحنة في منحدر شديد:",
      numQues: "1462",
      correctAnswer: "لا توجد أهمية لاستعمال الغيارات من اجل فرملة المركبة.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "سر بالغيار العالي وأوقف المركبة كل بضعة كيلومترات.",
        "سر بالغيار النيوترال واستعمل الفرامل حسب الحاجة.",
        "سر بالغيار الواطئ المناسب وتأكد أيضاً من تشغيل أجهزة خاصة للتخفيف من السرعة والمُرَكبة في المركبة.",
        "لا توجد أهمية لاستعمال الغيارات من اجل فرملة المركبة."
      ],
      id: 419
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1398. هل مسموح إيقاف مركبة في طريق سريعة؟",
      numQues: "1398",
      correctAnswer: "كلا، ممنوع إيقاف مركبة في طريق سريعة، ما عدا الوقوف على حاشية الطريق عندما تصاب المركبة بخلل ولا يمكن الاستمرار بالسير.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "نعم، فقط من اجل إصعاد الركاب فقط.",
        "نعم، فقط بجانب الطريق من اجل انتعاش السائق فقط.",
        "نعم، فقط من اجل إنزال الركاب.",
        "كلا، ممنوع إيقاف مركبة في طريق سريعة، ما عدا الوقوف على حاشية الطريق عندما تصاب المركبة بخلل ولا يمكن الاستمرار بالسير."
      ],
      id: 420
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1172. هل يجوز لسائق صالون عمومي إصعاد ركاب في حدود الإشارات التي تمنع الوقوف والتوقف؟",
      numQues: "1172",
      correctAnswer: "مسموح التوقف فقط حسب تعليمات شرطي.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "يجوز لسائق الصالون العمومي أن يتوقف في أية طريق.",
        "تم منح هذا الإذن لصالون عمومي يعمل على خط خدمة فقط.",
        "نعم، في طريق بلدية فقط.",
        "مسموح التوقف فقط حسب تعليمات شرطي."
      ],
      id: 421
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1496. كيف يتصرف سائق مركبة إذا صدم أثناء سيره مركبة لم يتواجد صاحبها في المكان؟",
      numQues: "1496",
      correctAnswer: "يبلغ مركز الشرطة عن وقوع الحادث، خلال سبعة أيام.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "ينتظر لغاية قدوم مندوب شركة التأمين المؤمن لديها ويبلغ الشرطة خلال 48 ساعة.",
        "يترك إشعارا خطياً على المركبة التي أصابها بضرر، وفيه تفاصيله وتفاصيل مركبته وتفاصيل شهادة تأمين المركبة ويبلغ الشرطة خلال 24 ساعة.",
        "ينتظر في المكان لغاية وصول صاحب المركبة المتضررة.",
        "يبلغ مركز الشرطة عن وقوع الحادث، خلال سبعة أيام."
      ],
      id: 422
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0027. عندما 'يُعطي السائق حق الأولوية' المقصود بذلك هو :",
      numQues: "0027",
      correctAnswer: "أنه يندفع إلى حركة السير المتدفقة داخل مكان يكاد يكفي لدخوله. ",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "أنه يدخل إلى حركة السير المتدفقة بنفس سرعة المركبات الأخرى. ",
        "أنه يُمكن السائقين الآخرين من مواصلة سيرهم دون تغيير سرعتهم ودون الانحراف عن مسلك سيرهم. ",
        "أنه يندمج في حركة السير دون التسبب في حادث. ",
        "أنه يندفع إلى حركة السير المتدفقة داخل مكان يكاد يكفي لدخوله. "
      ],
      id: 423
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1300. متى يجب التزود بتصريح من ضابط الشرطة من اجل نقل حمولة طويلة؟",
      numQues: "1300",
      correctAnswer: "واجب التزود بتصريح كهذا فقط عند نقل حمولة من المواد الخطرة.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "إذا كان طول المركبة مع الحمولة أكثر من 20م.",
        "لا يوجد واجب بالتزود بتصريح من ضابط الشرطة لمثل هذا النقل.",
        "إذا زاد طول الحمولة عن 15م. ",
        "واجب التزود بتصريح كهذا فقط عند نقل حمولة من المواد الخطرة."
      ],
      id: 424
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0266. فترة المرافقة 'لسائق جديد' في مركبة ركاب خصوصية هي؟",
      numQues: "0266",
      correctAnswer: "لا يوجد تحديد بالنسبة لفترة المرافقة لسائق جديد.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "3 أشهر من تاريخ الحصول على رخصة السياقة لأول مرة.",
        "شهرين من تاريخ الحصول رخصة السياقة لأول مرة.",
        "سنتين من تاريخ الحصول رخصة السياقة لأول مرة.",
        "لا يوجد تحديد بالنسبة لفترة المرافقة لسائق جديد."
      ],
      id: 425
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»",
        "«D»"
      ],
      title: "0739. ما هي العمليات التي يجب على السائق إجراءها قبل تنزيل فرامل اليد (الهاندبريك) في مركبة ذات صندوق غيارات أوتوماتيكية من اجل البدء بالسير؟",
      numQues: "0739",
      correctAnswer: "الانتقال بعصا الغيارات من غيار الوقوف (P) إلى غيار النيوترال (N). ",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "الانتقال بعصا الغيارات إلى غيار النيوترال (N). ",
        "الضغط على مفتاح (زر) إقفال عصا الغيارات في وضع الوقوف(P).",
        "الضغط على دعسة فرامل الرجل من اجل منع تحرك المركبة.",
        "الانتقال بعصا الغيارات من غيار الوقوف (P) إلى غيار النيوترال (N). "
      ],
      id: 426
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0964. هل الرقم في الإشارة الصفراء قانوني؟",
      numQues: "0964",
      correctAnswer: "اللافتة الصفراء هي لافتة إعلانات لصاحب العلاقة.",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3963.jpg",
      choices: [
        "الرقم الذي في الإشارة محدد لطريق بلدية فقط.",
        "الإشارة هي إشارة قانونية لجميع الغايات.",
        "اللافتة ليست إشارة، لذلك الرقم ليس قانونياً.",
        "اللافتة الصفراء هي لافتة إعلانات لصاحب العلاقة."
      ],
      id: 427
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1332. عندما نضغط على دعسة الفرامل عند الفرملة الفجائية:",
      numQues: "1332",
      correctAnswer: "تستمر المركبة بالسير لمسافة معينة لغاية التوقف التام.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "مسافة التوقف في المركبة ثابتة ولا تعتمد على سرعة السير.",
        "تتوقف المركبة في مكانها فقط إذا كانت السرعة 50كم/ساعة أو اقل.",
        "المركبة تتوقف في مكانها.",
        "تستمر المركبة بالسير لمسافة معينة لغاية التوقف التام."
      ],
      id: 428
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1594. العمر الأدنى المطلوب للحصول على رخصة سياقة من الدرجة A2 هي:",
      numQues: "1594",
      correctAnswer: "18 سنة، بشرط أن يكون طالب الرخصة قد حصل على موافقة خطية من احد الوالدين أو الوصي عنه.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "16 سنة، بشرط أن يكون طالب الرخصة قد حصل على موافقة خطية بذلك من احد الوالدين أو الوصي عنه.",
        "14 سنة، بشرط أن يكون طالب الرخصة قد حصل على موافقة خطية من احد الوالدين أو الوصي عنه.",
        "20 سنة، بشرط أن يكون طالب الرخصة قد حصل على موافقة خطية من احد الوالدين أو الوصي عنه.",
        "18 سنة، بشرط أن يكون طالب الرخصة قد حصل على موافقة خطية من احد الوالدين أو الوصي عنه."
      ],
      id: 429
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0675. ماذا تعني الإشارة؟",
      numQues: "0675",
      correctAnswer: "شارع باتجاه واحد أمامك.",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3675.jpg",
      choices: [
        "لك حق الأولوية في الطريق التي أمامك.",
        "ممنوع السير في هذا المسلك.",
        "مسموح السير في هذا المسلك.",
        "شارع باتجاه واحد أمامك."
      ],
      id: 430
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1384. يجب أن تكون في المركبة التجارية التي يزيد وزنها عن 10000كغم، من الأول من تشرين ثاني من كل سنة:",
      numQues: "1384",
      correctAnswer: "شهادة على أن المركبة اجتازت الفحص الشتوي أو امتحان الترخيص السنوي (التست) والذي جرى في شهر آب أو بعده.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "شهادة بأن جهاز الإنارة يعمل بشكلٍ سليم.",
        "شهادة على معايرة مقياس السرعة (السبيدومتر).",
        "شهادة بأن جهاز المقود يعمل بشكلٍ سليم.",
        "شهادة على أن المركبة اجتازت الفحص الشتوي أو امتحان الترخيص السنوي (التست) والذي جرى في شهر آب أو بعده."
      ],
      id: 431
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1571. 'العربة الجانبية' هي:",
      numQues: "1571",
      correctAnswer: "مركبة موصولة بجانب مركبة أخرى بواسطة قضيب لا يزيد طوله عن 2.5م.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "منشأة لنقل شخص أو حمولة، مُرَكبة على عجل وموصولة بالدراجة النارية من جانبها.",
        "مركبة تسير بجانب مركبة أخرى وسرعتها مساوية لسرعة المركبة الأخرى.",
        "دراجة نارية مُركب فيها ثلاث عجلات واحدة خلف الأخرى.",
        "مركبة موصولة بجانب مركبة أخرى بواسطة قضيب لا يزيد طوله عن 2.5م."
      ],
      id: 432
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1731. أية إشارة تظهر بعد الإشارة 710 ؟",
      numQues: "1731",
      correctAnswer: "709",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31731.jpg",
      choices: [
        "711",
        "716",
        "708",
        "709"
      ],
      id: 433
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1107. متى يجب تركيب ممتص الشرار في التراكتور؟",
      numQues: "1107",
      correctAnswer: "إذا رُكِب في التراكتور أنبوب عادم (أكزوست) سفلي.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "إذا رُكِب في التراكتور أنبوب عادم علوي.",
        "إذا كان الوضع الميكانيكي للمحرك رديء نسبياً.",
        "إذا رُكِب في التراكتور أنبوب عادم مفتوح.",
        "إذا رُكِب في التراكتور أنبوب عادم (أكزوست) سفلي."
      ],
      id: 434
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1439. إذا نُصبت إشارة تمنع السير بسرعة تزيد عن 70كم/ساعة في طريق بلدية، فأية مركبة تُمنع من السير بالسرعة المذكورة في الإشارة؟",
      numQues: "1439",
      correctAnswer: "مركبة تجارية ومركبة عمل وزنهما الإجمالي المسموح لغاية 10000كغم محددتان بِ- 50كم/ساعة.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "المركبة التجارية المستعملة في نقل البضائع وغير مجهزة بأحزمة أمان وسرعتها محددتان بِ- 50كم/ساعة.",
        "مركبة سنة إنتاجها قبل 1969 وغير مجهزة بأحزمة أمان وسرعتها محددة بِ- 50كم/ساعة. ",
        "المركبة التجارية أو مركبة العمل ووزنهما الإجمالي المسموح به 12000كغم، محددتان بِ- 50كم/ساعة.",
        "مركبة تجارية ومركبة عمل وزنهما الإجمالي المسموح لغاية 10000كغم محددتان بِ- 50كم/ساعة."
      ],
      id: 435
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0037. أية مركبة تُعتبر 'مركبة أمن' ؟",
      numQues: "0037",
      correctAnswer: "مركبة تابعة لشرطة إسرائيل أو لجيش الدفاع الإسرائيلي ومركبة لإطفاء الحريق فقط.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "مركبة إسعاف تابعة لنجمة داود الحمراء أو مركبة تابعة لشرطة إسرائيل أو لجيش الدفاع الإسرائيلي أو مركبة إطفاء حريق أو مركبة مشتركة من السلطة المحلية والشرطة أو كل مركبة أخرى صادقت عليها سلطة الترخيص عندما تبعث بإشارة بواسطة ضوء وتطلق صافرة إنذار.",
        "كل مركبة إسعاف أو مركبة تابعة لجيش الدفاع الإسرائيلي أو مركبة لإطفاء الحريق وكل مركبة تجارية أخرى صادقت سلطة الترخيص على أنها مركبة امن.",
        "كل مركبة تابعة لشرطة إسرائيل أو لجيش الدفاع الإسرائيلي والمركبة المستخدمة لأغراض الأمن في القرى الحدودية.",
        "مركبة تابعة لشرطة إسرائيل أو لجيش الدفاع الإسرائيلي ومركبة لإطفاء الحريق فقط."
      ],
      id: 436
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0451. ما معنى الإشارة؟",
      numQues: "0451",
      correctAnswer: "الاقتراب من ملتقى سكة حديد حوالي 70م قبل الملتقى.",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3451.jpg",
      choices: [
        "ممنوع التوقف في حدود 120م قبل سكة الحديد.",
        "الاقتراب من ملتقى سكة حديد - حوالي 200م قبل الملتقى.",
        "الاقتراب من ملتقى سكة حديد حوالي 250م قبل الملتقى.",
        "الاقتراب من ملتقى سكة حديد حوالي 70م قبل الملتقى."
      ],
      id: 437
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0802. ما هي السرعة المعقولة أثناء السياقة؟",
      numQues: "0802",
      correctAnswer: "سرعة حسب القانون تلائم أوضاع الطريق وما يحيط بنا وحركة السير، وتكون للسائق فيها السيطرة الكاملة على مركبته.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "كل سرعة يسيطر فيها السائق على المركبة سيطرة تامة. ",
        "كل سرعة تُحدد حسب التقدير المقبول للسائق. ",
        "كل سرعة يسوق فيها السائق المقبول.",
        "سرعة حسب القانون تلائم أوضاع الطريق وما يحيط بنا وحركة السير، وتكون للسائق فيها السيطرة الكاملة على مركبته."
      ],
      id: 438
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0121. ما هو واجب سائقي المركبات عندما يلتقوا مقابل بعضهم البعض في طريق ضيقة ومستوية؟",
      numQues: "0121",
      correctAnswer: "على سائق المركبة الكبيرة أن يزيد من سرعة سيره ويعبر الأول في المقطع الضيق. ",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "يتمهلوا ويتجهوا بمركباتهم إلى حافة الشارع، وحتى إلى ما بعدها، كي يتفادوا الاصطدام. ",
        "على سائق المركبة الكبيرة أن يتوقف لكي يُمكِن المركبة الأخرى من مواصلة سيرها في المقطع الضيق.",
        "يتصرفوا حسب ما هو مقبول في تلك الطريق.",
        "على سائق المركبة الكبيرة أن يزيد من سرعة سيره ويعبر الأول في المقطع الضيق. "
      ],
      id: 439
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1619. كيف يجب أن تتصرف عندما تكتشف فجأةً في الشارع منطقة عليها زيوت وملسة أثناء تنفيذ الانعطاف؟",
      numQues: "1619",
      correctAnswer: "يجب زيادة سرعة السير لتحسين تماسك الإطارات مع الشارع.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "يجب الفرملة بشدة بالفرملتين لمنع إقفال الفرامل.",
        "يجب الفرملة بشدة حتى بعد الدخول إلى المنطقة الملسة، في هذه الحالة لا يوجد ما نخسره.",
        "يجب دائماً محاولة تعديل وضع الدراجة إلى وضع سير بخط مستقيم على قدر الإمكان حتى ولو أدى ذلك إلى الانحراف عن مسلك السير المخطط له في تلك اللحظة.",
        "يجب زيادة سرعة السير لتحسين تماسك الإطارات مع الشارع."
      ],
      id: 440
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1389. هل الأدوية الطبية التي يمكن شراؤها بدون وصفة طبية (روشيته) من طبيب يمكن أن تؤثر سلبياً على السائق؟",
      numQues: "1389",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "نعم، فقط في الصيف.",
        "كلا.",
        "نعم، فقط في الشتاء.",
        "نعم."
      ],
      id: 441
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1092. لماذا تُثبت أثقال في مقدمة التراكتور؟",
      numQues: "1092",
      correctAnswer: "من اجل تحسين جودة وسهولة السير بالتراكتور في الطرق الترابية.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "من اجل تحسين تماسك العجلات الأمامية بالأرض.",
        "من اجل منع قفز القسم الخلفي للتراكتور أثناء السير السريع.",
        "من اجل التخفيف قليلاً من الثقل على المحور الخلفي عند رفع الحمولات.",
        "من اجل تحسين جودة وسهولة السير بالتراكتور في الطرق الترابية."
      ],
      id: 442
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1687. ما هي السرعة القصوى المسموح بها بالكم/ساعة لباص صغير خصوصي في طريق سريعة (إذا لمن تُنصب إشارة تدل على غير ذلك)؟",
      numQues: "1687",
      correctAnswer: "80",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "100",
        "110",
        "90",
        "80"
      ],
      id: 443
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1038. يجب فحص ضغط الهواء في الإطارات:",
      numQues: "1038",
      correctAnswer: "عندما تكون الإطارات باردة.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "عندما تكون الإطارات ساخنة.",
        "فقط قبل كل صيانة دورية.",
        "مرة في السنة.",
        "عندما تكون الإطارات باردة."
      ],
      id: 444
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1635. هل يجوز لسائق الدراجة النارية السير على الرصيف؟",
      numQues: "1635",
      correctAnswer: "نعم، عندما تكون حركة السير مكتظة ومزدحمة.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "نعم، من اجل عبور الرصيف للدخول إلى ساحة.",
        "لا يجوز له قط.",
        "نعم، إذا لا يتسبب ذلك في إزعاج للمشاة.",
        "نعم، عندما تكون حركة السير مكتظة ومزدحمة."
      ],
      id: 445
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1554. قبل الترويح عن النفس في نادي (حانة) وما شابه ذلك:",
      numQues: "1554",
      correctAnswer: "يجب التحديد بأنه بعد الترويح عن النفس، يسوق من شرب اقل كمية من الكحول بين الجميع. ",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "يجب التحديد سلفاً من الشخص الذي سيقوم بسياقة المركبة ولا يقوم بشرب المشروبات الروحية.",
        "يجب التحديد بأنه بعد الترويح عن النفس يسوق المركبة السائق ذو الخبرة الأكثر، سواء شرب أم لا.",
        "يجب التخطيط للانتظار ساعة بعد الترويح عن النفس، وبعدها يكون بالإمكان السياقة بدون أية ريبة. ",
        "يجب التحديد بأنه بعد الترويح عن النفس، يسوق من شرب اقل كمية من الكحول بين الجميع. "
      ],
      id: 446
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0402. أية إشارة تسمح بالوقوف بشكلٍ غير موازي لحافة الرصيف؟",
      numQues: "0402",
      correctAnswer: "815",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3402.jpg",
      choices: [
        "819",
        "513",
        "512",
        "815"
      ],
      id: 447
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1290. احد الفروقات بين مركبة ذات صندوق غيارات يدوي (جير) وبين مركبة أوتوماتيكية ينعكس في:",
      numQues: "1290",
      correctAnswer: "لا توجد دعسة كلاتش في المركبة ذات صندوق الغيارات اليدوي (جير).",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "في المركبة ذات صندوق غيار يدوي (جير) تكون إمكانية الإسراع اقل. ",
        "استهلاك وقود اقل في المركبة ذات صندوق الغيارات اليدوي (جير) بوجهٍ عام.",
        "المركبة ذات صندوق غيار يدوي (جير) تصدر ضوضاء أكثر. ",
        "لا توجد دعسة كلاتش في المركبة ذات صندوق الغيارات اليدوي (جير)."
      ],
      id: 448
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0090. أنت تسير في شارع باتجاه واحد وأمامك يوجد مبنى أو عمود أو مساحة مغلقة، كيف تتصرف؟",
      numQues: "0090",
      correctAnswer: "في طريق بلدية يجوز عبور المكان من اليمين أو من اليسار، وفي طريق ليست بلدية من اليمين دائماً.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "يجب عبور المكان من جهته اليمنى فقط.",
        "مسموح عبور المكان من جهته اليمنى أو من جهته اليسرى إلا إذا دلت إشارة على غير ذلك.",
        "يجب عبور المكان من جهته اليسرى.",
        "في طريق بلدية يجوز عبور المكان من اليمين أو من اليسار، وفي طريق ليست بلدية من اليمين دائماً."
      ],
      id: 449
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0531. ما معنى الإشارة؟",
      numQues: "0531",
      correctAnswer: "مسلك للقطار الخفيف وللباص وللصالون العمومي (التاكسي) وللمركبة التي فيها عدد الأشخاص المسجل في الإشارة أو أكثر.",
      pubDate: "10-11-2011 08:22:45",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3531.jpg",
      choices: [
        "مسلك في شارع يُمنع فيه سير المواصلات العمومية فقط.",
        "مسموح السير في الشارع أو في المسلك لكل مركبة ما عدا القطار الخفيف والباص الكهربائي.",
        "مسموح السير في الشارع أو في المسلك لكل مركبة تسير على 4 عجلات .",
        "مسلك للقطار الخفيف وللباص وللصالون العمومي (التاكسي) وللمركبة التي فيها عدد الأشخاص المسجل في الإشارة أو أكثر."
      ],
      id: 450
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1244. هل يجوز لسائق الباص التدخين أثناء السير؟",
      numQues: "1244",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:22:45",
      img: "",
      choices: [
        "نعم، السائق معزول عن باقي الركاب ، لذلك يجوز له التدخين في أي وقت.",
        "كلا، ما عدا في سفرة سياحية إذا كان الركاب من غير مواطني الدولة وبموافقتهم.",
        "كلا، إلا في سفرة سياحية فقط.",
        "كلا."
      ],
      id: 451
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0501. ما معنى الإشارة؟",
      numQues: "0501",
      correctAnswer: "ممنوع دخول المركبات الخصوصية.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3501.jpg",
      choices: [
        "ممنوع دخول جميع المركبات الميكانيكية ما عدا الدراجة النارية بدون عربة جانبية.",
        "ممنوع وقوف جميع المركبات.",
        "ممنوع دخول جميع المركبات ما عدا مركبات الركاب الخصوصية.",
        "ممنوع دخول المركبات الخصوصية."
      ],
      id: 452
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1653. ما هو الخطر الأساسي المتوقع من ركوب الدراجة النارية في الظلام؟",
      numQues: "1653",
      correctAnswer: "درجة الحرارة المنخفضة التي تتعرض لها الدراجة النارية.",
      pubDate: "10-11-2011 08:22:46",
      img: "",
      choices: [
        "الصعوبة في مشاهدة المركبات الأخرى التي تسير من الخلف.",
        "درجة الحرارة المنخفضة التي يتعرض لها راكب الدراجة النارية.",
        "الصعوبة في تحليل جودة الطريق بشكلٍ متواصل وفي اكتشاف العوائق مقدماً.",
        "درجة الحرارة المنخفضة التي تتعرض لها الدراجة النارية."
      ],
      id: 453
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0549. ما معنى الإشارة؟",
      numQues: "0549",
      correctAnswer: "اعبر المكان الموسوم (المؤشر) بالإشارة من جهته اليمنى فقط.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3549.jpg",
      choices: [
        "سر إلى اليمين أو إلى اليسار.",
        "طريق ملتوية باتجاهي السير في المفترق القريب.",
        "ممنو الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار.",
        "اعبر المكان الموسوم (المؤشر) بالإشارة من جهته اليمنى فقط."
      ],
      id: 454
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0376. أية إشارة تُنصب في الطريق وتدل على مكان عبور المشاة موسوم ( مؤشر )؟",
      numQues: "0376",
      correctAnswer: "220",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3376.jpg",
      choices: [
        "136",
        "226",
        "306",
        "220"
      ],
      id: 455
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0069. أية أوامر مُفضلة في مفترق نُصبت فيه إشارات ضوئية (رمزورات) وإشارات سير؟",
      numQues: "0069",
      correctAnswer: "أوامر الإشارة 'أعط حق الأولوية' مفضلة على أوامر الإشارة الضوئية (الرمزور) غير المتقطعة.",
      pubDate: "10-11-2011 08:22:46",
      img: "",
      choices: [
        "أوامر الإشارة الضوئية (الرمزور) (ما عدا الضوء الأصفر المتقطع) مفضلة على أوامر الإشارة التي تعني إعطاء حق الأولوية.",
        "أوامر الإشارة 'قف' مفضلة على أوامر الإشارة الضوئية (الرمزور) غير المتقطعة.",
        "أوامر إشارة السير مفضلة دائماً (لأن الإشارة الضوئية (الرمزور) ممكن أن تصاب بخلل).",
        "أوامر الإشارة 'أعط حق الأولوية' مفضلة على أوامر الإشارة الضوئية (الرمزور) غير المتقطعة."
      ],
      id: 456
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0343. ماذا يتوجب على صاحب المركبة عمله بالنسبة للتوقف عن استعمال المركبة لمدة تزيد عن شهر واحد؟",
      numQues: "0343",
      correctAnswer: "تبليغ الشرطة عن ذلك.",
      pubDate: "10-11-2011 08:22:46",
      img: "",
      choices: [
        "تبليغ السلطة المحلية عن ذلك.",
        "إيقاف المركبة في كراج مرخص.",
        "تبليغ سلطة الترخيص عن ذلك.",
        "تبليغ الشرطة عن ذلك."
      ],
      id: 457
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1266. هل يُسمح لباص صغير عمومي وزنه الإجمالي 3300كغم بالوقوف في حدود هذه الإشارة؟",
      numQues: "1266",
      correctAnswer: "فقط في نهاية كل أسبوع.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3627.jpg",
      choices: [
        "كلا.",
        "نعم.",
        "نعم بين الساعات 21:00 لغاية 05:30 أيام عُطَل الأعياد فقط.",
        "فقط في نهاية كل أسبوع."
      ],
      id: 458
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0586. ما معنى الإشارة؟",
      numQues: "0586",
      correctAnswer: "لك حق الأولوية في الطريق الضيقة.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3586.jpg",
      choices: [
        "ممنوع الاستدارة في آخر المقطع.",
        "أعطِ حق الأولوية للمركبة القادمة من الجهة المقابلة في الطريق الضيقة.",
        "شارع بدون مخرج.",
        "لك حق الأولوية في الطريق الضيقة."
      ],
      id: 459
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0474. كيف تتصرف حسب الإشارة؟",
      numQues: "0474",
      correctAnswer: "ابقَ على يمين الطريق وانتبه لحركة السير القادمة من الجهة المقابلة.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3473.jpg",
      choices: [
        "سر كالمعتاد، على السائقين في الجهة المقابلة إعطاؤك حق الأولوية. ",
        "إبقَ في المسلك الأيمن لأن التجاوز ممنوع.",
        "زد من سرعة سيرك، في مقطع الطريق الضيقة.",
        "ابقَ على يمين الطريق وانتبه لحركة السير القادمة من الجهة المقابلة."
      ],
      id: 460
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0875. ما هي التحديدات التي يواجهها السائق عند الرجوع إلى الخلف؟",
      numQues: "0875",
      correctAnswer: "مدى رؤية محدود وسياقة المركبة بشكلٍ غير مريح.",
      pubDate: "10-11-2011 08:22:46",
      img: "",
      choices: [
        "سرعة السير العالية والحاجة إلى تشغيل أجهزة كثيرة تسبب في صعوبة السيطرة على جهاز الفرامل.",
        "لا يوجد أي تحديد لسائق ذو خبرة أثناء الرجوع إلى الخلف.",
        "الرجوع إلى الخلف أطول.",
        "مدى رؤية محدود وسياقة المركبة بشكلٍ غير مريح."
      ],
      id: 461
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0452. كيف تتصرف حسب الإشارة؟",
      numQues: "0452",
      correctAnswer: "زد السرعة واعبر بسرعة خط القطار.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3451.jpg",
      choices: [
        "تمهل واستعد لإمكانية التوقف قبل الملتقى.",
        "توقف على مسافة 12م من خط السكة لكي تفحص إذا كان هناك قطار يقترب.",
        "عندما ترى أضواء القطار، توقف على مسافة 20م قبل الملتقى.",
        "زد السرعة واعبر بسرعة خط القطار."
      ],
      id: 462
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0252. هل يجوز سياقة مركبة فيها جهاز الإنارة غير سليم؟",
      numQues: "0252",
      correctAnswer: "مسموح إذا كان مصباح واحد لا يعمل.",
      pubDate: "10-11-2011 08:22:46",
      img: "",
      choices: [
        "مسموح إذا كان الخلل في مصابيح الوقوف.",
        "ممنوع.",
        "مسموح في ساعات النهار فقط.",
        "مسموح إذا كان مصباح واحد لا يعمل."
      ],
      id: 463
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0012. عرِّف 'الوقوف' :",
      numQues: "0012",
      correctAnswer: "توقف المركبة لمدة تزيد عن 30 ثانية.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3012.jpg",
      choices: [
        "إيقاف المركبة لأي وقت كان ليس لغرض إصعاد أو إنزال الركاب أو تحميل حمولة أو إنزالها الفوري، وبدون انقطاع.",
        "توقف المركبة لفترة زمنية محددة لغرض تنزيل حمولة وليس بشكلٍ مستمر.",
        "إيقاف المركبة لغرض تحميل حمولة فقط وليس بشكلٍ مستمر.",
        "توقف المركبة لمدة تزيد عن 30 ثانية."
      ],
      id: 464
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0428. ما معنى الإشارة؟",
      numQues: "0428",
      correctAnswer: "ملتقى تفرع طرق إلى اليمين أولاً ثم إلى اليسار.",
      pubDate: "10-11-2011 08:22:46",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3428.jpg",
      choices: [
        "إشارة تحذير قبل منعطف حاد إلى اليمين وبعده منعطف حاد إلى اليسار.",
        "أمامك مفترق تفرع طرق إلى اليسار وبعده مفترق تفرع طرق إلى اليمين.",
        "أعطِ حق الأولوية للمركبات القادمة من اليمين وثم للمركبات القادمة من اليسار.",
        "ملتقى تفرع طرق إلى اليمين أولاً ثم إلى اليسار."
      ],
      id: 465
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0411. ما معنى الإشارة؟",
      numQues: "0411",
      correctAnswer: "التواء حاد أمامك.",
      pubDate: "10-11-2011 08:22:47",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3411.jpg",
      choices: [
        "طريق ضيقة وملتوية أمامك.",
        "طريق ملتوية أمامك.",
        "منعطف إلى اليمين وثم إلى اليسار.",
        "التواء حاد أمامك."
      ],
      id: 466
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1001. ما هي وظيفة جهاز ال- 'أي.بي.أس' (ABS)؟",
      numQues: "1001",
      correctAnswer: "المحافظة على قدرة توجيه المقود والمناورة بالمركبة أثناء فرملة الطوارئ أيضاً.",
      pubDate: "10-11-2011 08:22:47",
      img: "",
      choices: [
        "المساعدة على فرملة سلسة وأكثر اعتدالاً على الشارع الرطب (المبلول).",
        "المساعدة على فرملة سلسة وأكثر اعتدالاً على الشارع الجاف.",
        "تقصير عمر الإطارات.",
        "المحافظة على قدرة توجيه المقود والمناورة بالمركبة أثناء فرملة الطوارئ أيضاً."
      ],
      id: 467
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1323. متى ينبغي مرافقة مركبة تنقل حمولة بارزة؟",
      numQues: "1323",
      correctAnswer: "إذا كانت المركبة مرخصة لنقل حمولة ثقيلة.",
      pubDate: "10-11-2011 08:22:47",
      img: "",
      choices: [
        "إذا كانت المركبة تنقل مواد خطرة.",
        "إذا كان عرض الحمولة البارزة أكثر من 3.00م وطولها أكثر من 20م.",
        "إذا كان عرض الحمولة أكثر من 3.40م.",
        "إذا كانت المركبة مرخصة لنقل حمولة ثقيلة."
      ],
      id: 468
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0265. إذا اضطر شخص للمشي في الشارع، في أية جهة من الشارع يجب على الماشي أن يسير؟",
      numQues: "0265",
      correctAnswer: "قريب من الحافة اليسرى للشارع ووجهه مقابل حركة السير.",
      pubDate: "10-11-2011 08:22:47",
      img: "",
      choices: [
        "قريب من الرصيف الأيسر.",
        "قريب من حاشية الطريق اليمنى.",
        "قريب من الحافة اليمنى للشارع.",
        "قريب من الحافة اليسرى للشارع ووجهه مقابل حركة السير."
      ],
      id: 469
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1607. بأي رقم مؤشر طول 'الامتداد الخلفي' للباص في الصورة؟",
      numQues: "1607",
      correctAnswer: "75",
      pubDate: "10-11-2011 08:22:47",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31607.jpg",
      choices: [
        "82",
        "78",
        "93",
        "75"
      ],
      id: 470
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0591. كيف تستدير إلى اليسار من الشارع الذي نُصبت فيه الإشارة؟",
      numQues: "0591",
      correctAnswer: "تبدأ الاستدارة من المسلك المركزي.",
      pubDate: "10-11-2011 08:22:47",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3590.jpg",
      choices: [
        "ممنوع الاستدارة إلى اليسار منعاً باتاً ومسموح السير فقط إلى الأمام. ",
        "تُنفذ الاستدارة من المسلك الأيمن الأقصى.",
        "من الجهة اليسرى للشارع إلا إذا كانت هناك إشارة تدل على غير ذلك.",
        "تبدأ الاستدارة من المسلك المركزي."
      ],
      id: 471
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1149. هل يُسمح، حسب رخصة سياحية صدرت لباص، بنقل اسطوانات غاز كربوني؟",
      numQues: "1149",
      correctAnswer: "نعم، مسموح نقل اسطوانات غاز في كل باص وزنه الإجمالي المسموح به أكثر من 12000كغم.",
      pubDate: "10-11-2011 08:22:47",
      img: "",
      choices: [
        "نعم، مسموح أثناء التجوال – على سطح الباص أو في صندوق الحمولة من الخلف - نقل اسطوانتي غاز للطبخ وزن كل اسطوانة لغاية 12كغم. ",
        "كلا، ممنوع نقل أي غاز كان في الباص.",
        "نعم، مسموح نقل وقود داخل الباص في خزانات صغيرة تتوفر فيها مواصفات - ASR-23 .",
        "نعم، مسموح نقل اسطوانات غاز في كل باص وزنه الإجمالي المسموح به أكثر من 12000كغم."
      ],
      id: 472
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1601. ما هي المشكلة التي تنشأ عند اكتشاف عائق أمام الدراجة النارية 'في اللحظة الأخيرة'؟",
      numQues: "1601",
      correctAnswer: "لا توجد مشكلة باكتشاف المشكلة في وقت متأخر.",
      pubDate: "10-11-2011 08:22:47",
      img: "",
      choices: [
        "لا يوجد وقت كافي لتغيير الغيارات. ",
        "الوقت المتبقي لرد الفعل الصحيح قصير جداً.",
        "لا يمكن تقدير حجم الخطر بدقة.",
        "لا توجد مشكلة باكتشاف المشكلة في وقت متأخر."
      ],
      id: 473
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0558. ما معنى الإشارة؟",
      numQues: "0558",
      correctAnswer: "عدد المسالك في الشارع آخذ في الازدياد.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3473.jpg",
      choices: [
        "مسموح لك السير في أي مسلك في الشارع.",
        "لك حق الأولوية بالنسبة للمركبات المقتربة من الجهة المقابلة.",
        "حركة سير باتجاهين أمامك",
        "عدد المسالك في الشارع آخذ في الازدياد."
      ],
      id: 474
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0833. ما هي الطريقة الصحيحة للنزول المخطط له إلى حاشية الطريق المنخفضة أكثر من الشارع؟",
      numQues: "0833",
      correctAnswer: "نزول سريع إلى حاشية الطريق وبعد ذلك تخفيف السرعة تدريجياً بعدها.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "لا توجد 'طريقة صحيحة': ممنوع النزول من الشارع إلى حاشية منخفضة.",
        "تخفيف سرعة المركبة إلى سرعة بطيئة والنزول تدريجياً إلى الحاشية.",
        "نزول سريع إلى حاشية الطريق وتوقف سريع في اصغر مسافة.",
        "نزول سريع إلى حاشية الطريق وبعد ذلك تخفيف السرعة تدريجياً بعدها."
      ],
      id: 475
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0888. حسب الصورة، كيف يجب على سائق المركبة الفضية أن يتصرف؟",
      numQues: "0888",
      correctAnswer: "يتمهل ويُمكِن المركبة الخارجة من الموقف الاندماج في حركة السير.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3888.jpg",
      choices: [
        "يزيد من سرعة سيره وينتقل إلى المسلك الأيسر.",
        "يستعمل الزامور ويتابع السير بدون تغيير موقعه وسرعته.",
        "يستعمل الزامور بشدة ويتابع سيره في المسلك الأيمن، لأن سائق المركبة الذي يخرج من الموقف هو المخالف.",
        "يتمهل ويُمكِن المركبة الخارجة من الموقف الاندماج في حركة السير."
      ],
      id: 476
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1251. في أية حالة يسمح لسائق الباص بنقل حمولة فيه؟",
      numQues: "1251",
      correctAnswer: "إذا كانت الحمولة لها دخل بمصدر رزق الراكب.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "إذا كانت الحمولة وحدة واحدة ولغاية طول 3م.",
        "إذا كانت الحمولة مغلفة بغلاف أمان.",
        "عندما لا تعرقل الحمولة الركاب ولا تسبب لهم ضرراً.",
        "إذا كانت الحمولة لها دخل بمصدر رزق الراكب."
      ],
      id: 477
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1089. لماذا يجب تركيب إطار أمان في التراكتور؟",
      numQues: "1089",
      correctAnswer: "لحماية السائق عند العمل بين الأشجار والأغصان.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "لحماية السائق من المطر.",
        "لحماية السائق عند انقلاب التراكتور.",
        "لحماية السائق عند وقوع حادث اصطدام.",
        "لحماية السائق عند العمل بين الأشجار والأغصان."
      ],
      id: 478
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0146. هل يجوز تنفيذ فرملة فجائية ليس من اجل منع وقوع حادث طرق؟",
      numQues: "0146",
      correctAnswer: "نعم، بعد إعطاء إشارة استغاثة للمركبة التي خلفك.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "نعم، في طريق معبدة فقط ومن مسافة 200م من المباني.",
        "نعم ، في طريق ترابية فقط ومن مسافة 200م من المباني.",
        "نعم، من اجل تجربة الفرامل بشرط أن لا يعيق ذلك أو يعرض عابري الطريق الآخرين للخطر.",
        "نعم، بعد إعطاء إشارة استغاثة للمركبة التي خلفك."
      ],
      id: 479
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0769. ما هي المشكلة الأساسية التي تواجه السائق عند اقترابه من مفترق؟",
      numQues: "0769",
      correctAnswer: "المشكلة الرئيسية هي عبور المفترق بسرعة.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3769.jpg",
      choices: [
        "قسم من مساحة المفترق معد دائماً للمواصلات العمومية.",
        "كثرة المهام التي يجب عليه القيام بها في وقتٍ قصير وفي آنٍ واحد.",
        "السرعة القصوى المسموح بها تختلف في المفترق.",
        "المشكلة الرئيسية هي عبور المفترق بسرعة."
      ],
      id: 480
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0192. كيف تتصرف إذا أُغلق مسلك سيرك؟",
      numQues: "0192",
      correctAnswer: " سر! لك حق الأولوية لك في الطريق التي أمامك.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "يجب استغلال الرصيف للعبور إذا كان خالياً.",
        "يجب استعمال الزامور واعبر العائق الذي أمامك.",
        "يجب إعطاء حق الأولوية للمركبة القادمة من الجهة المعاكسة.",
        " سر! لك حق الأولوية لك في الطريق التي أمامك."
      ],
      id: 481
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0429. هل الإشارة المنصوبة في الطريق التي أمامك توضح قواعد حق الأولوية؟",
      numQues: "0429",
      correctAnswer: "نعم، لك حق الأولوية لأنك تسير في طريق رئيسية.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3428.jpg",
      choices: [
        "نعم، يجب إعطاء حق الأولوية للمركبات القادمة من اليمين ومن اليسار.",
        "نعم، حسب الإشارة يجب إعطاء حق الأولوية للمركبات القادمة من اليمين فقط.",
        "كلا، فقط قواعد إعطاء حق الأولوية المنصوص عليها في القانون أو الشاخصات المنصوبة في المفترق هي التي تحدد إعطاء حق الأولوية.",
        "نعم، لك حق الأولوية لأنك تسير في طريق رئيسية."
      ],
      id: 482
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1789. ما هو الوقت الصحيح لفحص زيت المحرك؟",
      numQues: "1789",
      correctAnswer: "بعد تشغيل المحرك وعلى سطح مستوي.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "قبل تشغيل المحرك وعلى سطح أفقي.",
        "بعد إنهاء السفرة وعلى سطح مستوي.",
        "بعد تشغيل المحرك في الصباح.",
        "بعد تشغيل المحرك وعلى سطح مستوي."
      ],
      id: 483
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1758. كيف يجب على سائق المركبة التصرف عند اقترابه من مدارس أو ملاعب؟",
      numQues: "1758",
      correctAnswer: "يستعمل الزامور طيلة الوقت من اجل تنبيه الأولاد بأن لا يقفزوا إلى الشارع. ",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "يخفف من سرعة السير ويزيد من اليقظة.",
        "يستمر بالسير العادي ولكن ينتبه لممرات المشاة فقط.",
        "يمتنع من الدخول إلى الشارع ما عدا في ساعات الليل.",
        "يستعمل الزامور طيلة الوقت من اجل تنبيه الأولاد بأن لا يقفزوا إلى الشارع. "
      ],
      id: 484
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0654. مسافة الفرملة هي المسافة التي تقطعها المركبة:",
      numQues: "0654",
      correctAnswer: "من اللحظة التي يُشاهد فيها السائق الخطر ولغاية بداية الفرملة.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "خلال زمن رد فعل السائق.",
        "من اللحظة التي يُشاهد فيها السائق الخطر ولغاية توقف المركبة النهائي. ",
        "من لحظة تشغيل الفرامل ولغاية توقف المركبة النهائي.",
        "من اللحظة التي يُشاهد فيها السائق الخطر ولغاية بداية الفرملة."
      ],
      id: 485
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1074. عند وجود ضباب، بالإضافة إلى مصابيح الضباب:",
      numQues: "1074",
      correctAnswer: "من المستحسن السير ببطء، حسب مدى الرؤية في الضباب.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "من المستحسن السير بالأضواء العالية.",
        "من المستحسن السير بسرعة، بالأضواء العالية.",
        "يجب السير بأضواء الطوارئ المتقطعة.",
        "من المستحسن السير ببطء، حسب مدى الرؤية في الضباب."
      ],
      id: 486
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»"
      ],
      title: "0036. عرِّف 'المركبة البطيئة':",
      numQues: "0036",
      correctAnswer: "المركبة الميكانيكية التي حُددت لها سرعة سير قصوى مسموح بها لا تزيد عن 55كم/ساعة .",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "المركبة الميكانيكية التي حُددت لها سرعة سير قصوى مسموح بها تزيد عن 55كم/ساعة .",
        "المركبة الميكانيكية التي حُددت لها سرعة سير قصوى مسموح بها لا تزيد عن 40كم/ساعة .",
        "المركبة الميكانيكية التي حُددت لها سرعة سير قصوى مسموح بها لا تزيد عن 50كم/ساعة.",
        "المركبة الميكانيكية التي حُددت لها سرعة سير قصوى مسموح بها لا تزيد عن 55كم/ساعة ."
      ],
      id: 487
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0353. هل يجب وضع سلال قمامة (سلال زبالة) في مركبة ركاب خصوصية؟",
      numQues: "0353",
      correctAnswer: "كلا ، لا يوجد واجب كهذا.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "نعم يجب وضع سلة قمامة (سلة زبالة) من النوع الذي صادقت عليه سلطة الترخيص.",
        "كلا، يجب وضعها فقط في المركبة العمومية.",
        "نعم ، يجب وضعها فقط في المركبة التجارية.",
        "كلا ، لا يوجد واجب كهذا."
      ],
      id: 488
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0427. أين تُنصب الإشارة ؟",
      numQues: "0427",
      correctAnswer: "لا توجد أهمية لمكان نصب الإشارة.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3426.jpg",
      choices: [
        "على مسافة معقولة من المفترق.",
        "داخل المفترق.",
        "بعد المفترق.",
        "لا توجد أهمية لمكان نصب الإشارة."
      ],
      id: 489
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0458. كيف يجب التصرف من مكان نصب الإشارة ولغاية ما بعد خط السكة؟",
      numQues: "0458",
      correctAnswer: "تمهل واعبر السكة بسير متواصل وبدون تأخير، لا تتوقف على السكة.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3456.jpg",
      choices: [
        "أعطِ حق الأولوية لحركة السير المقابلة.",
        "قف بعد الإشارة وانظر يساراً ويميناً.",
        "اعبر خط السكة بسرعة.",
        "تمهل واعبر السكة بسير متواصل وبدون تأخير، لا تتوقف على السكة."
      ],
      id: 490
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0473. ما معنى الإشارة؟",
      numQues: "0473",
      correctAnswer: "لك حق الأولوية بالنسبة لحركة السير المقابلة.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3473.jpg",
      choices: [
        "عليك إعطاء حق الأولوية لحركة السير المقابلة.",
        "حركة السير باتجاهين في الطريق التي أمامك.",
        "الدخول إلى حدود طريق أو طرق بلدية.",
        "لك حق الأولوية بالنسبة لحركة السير المقابلة."
      ],
      id: 491
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1580. قبل تعشيق الغيار من الغيار P إلى غيار آخر في صندوق الغيارات الأوتوماتيكي، على السائق:",
      numQues: "1580",
      correctAnswer: "الضغط بقوة على دعسة الفرامل.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "الضغط بقوة على دعسة الكلاتش.",
        "الضغط بقوة على دعسة الوقود.",
        "الضغط في آنٍ واحد على دعسة الفرامل وعلى دعسة الكلاتش وحينها يقوم بتعشيق الغيار المطلوب.",
        "الضغط بقوة على دعسة الفرامل."
      ],
      id: 492
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1525. هل يُسمح بالسياقة تحت تأثير العقاقير (الأدوية) المهدئة؟",
      numQues: "1525",
      correctAnswer: "ممنوع، إذا ذُكر ذلك في الوصفة الطبية (الروشيته) للدواء أو من قِبل الطبيب.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "نعم، العقاقير المهدئة لا تؤثر على السياقة.",
        "مسموح تناول أقراص (حبوب) مهدئة قبل السياقة بنصف ساعة.",
        "ممنوع، إذا كان السائق قابلاً للتأثر من دواء معين: ومسموح إذا لم تكن لديه قابلية كهذه.",
        "ممنوع، إذا ذُكر ذلك في الوصفة الطبية (الروشيته) للدواء أو من قِبل الطبيب."
      ],
      id: 493
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1541. بعد كم سنة من سنة الإنتاج، لا تجدد رخصة مركبة جر وتخليص (ونش) وزنها الإجمالي المسموح به ليس أكثر من 16000كغم؟",
      numQues: "1541",
      correctAnswer: "19 سنة.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "23 سنة.",
        "15 سنة.",
        "11سنة.",
        "19 سنة."
      ],
      id: 494
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1423. كيف توسم (تؤشر) المركبة المرافقة لمركبة تنقل حمولة بارزة؟",
      numQues: "1423",
      correctAnswer: "بلافتة'انتبه حمولة بارزة' في مقدمة المركبة المرافقة. ",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "تسير المر كبة المرافقة وتُشغل الأربعة غمازات فيها وعلى سطحها لافتة 'انتبه حمولة بارزة'.",
        "بلافتات 'انتبه حمولة بارزة' مثبتة في مقدمة المركبة المرافقة وعلى الجهة الخلفية للمركبة التي تنقل الحمولة، وبتشغيل مصباح يضيء بلون اصفر متقطع فوق كابينة السائق.",
        "بمصباح يضيء بنور متقطع وبلافتة 'انتبه حمولة بارزة' في مقدمة المركبة المرافقة. ",
        "بلافتة'انتبه حمولة بارزة' في مقدمة المركبة المرافقة. "
      ],
      id: 495
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0819. ماذا ينبغي على سائق المركبة أن يفعل دائماً عندما تلتصق به مركبة أخرى من الخلف؟",
      numQues: "0819",
      correctAnswer: "الإسراع فوراً والهروب إلى الأمام من اجل زيادة المسافة من الخلف.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "لا يوجد ما يمكن عمله، السائق الذي في الخلف هو المذنب دائماً إذا وقع حادث.",
        "التأكد من أن المسافة التي يحافظ عليها من الأمام تُمكن من فرملة معتدلة لمنع خطر التصادم من الخلف.",
        "الضغط بشكلٍ فجائي ومتواصل على دعسة الفرامل.",
        "الإسراع فوراً والهروب إلى الأمام من اجل زيادة المسافة من الخلف."
      ],
      id: 496
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0702. أنت تقود المركبة رقم (3)، من يدخل المفترق أولاً حسب قواعد إعطاء حق الأولوية؟ (لا يوجد إشارات في المفترق).",
      numQues: "0702",
      correctAnswer: "راكب الدراجة النارية (2).",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3702.jpg",
      choices: [
        "المركبة التي تسوقها (3).",
        "لا يوجد حل في القانون للوضع القائم.",
        "راكب الدراجة الهوائية (1).",
        "راكب الدراجة النارية (2)."
      ],
      id: 497
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0729. كيف يجب عليك التصرف في بقية الطريق؟",
      numQues: "0729",
      correctAnswer: "استمر بالسير في مسلك سيرك.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3729.jpg",
      choices: [
        "انتقل إلى المسلك الأيمن المجاور.",
        "استعمل المسلك الأسرع.",
        "توقف إلى أن يتغير السهم إلى اخضر.",
        "استمر بالسير في مسلك سيرك."
      ],
      id: 498
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1647. أية أحذية مناسبة تختار لركوب الدراجة النارية؟",
      numQues: "1647",
      correctAnswer: "يجب اختيار أحذية عالية عازلة من الحرارة والبرد.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "لا توجد قواعد لذلك، أي حذاء أو صندل مريح ويصلح لتشغيل الدراجة النارية بصورة آمنة.",
        "يجب اختيار أحذية عالية مصنوعة من مادة ممتلئة تقاوم الاحتكاك. ",
        "يجب اختيار أحذية خفيفة ومريحة تمكن من المرونة في الركوب.",
        "يجب اختيار أحذية عالية عازلة من الحرارة والبرد."
      ],
      id: 499
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0601. ما هو الطول الإجمالي المسموح به في القانون للباص الظاهر في الصورة؟",
      numQues: "0601",
      correctAnswer: "12م",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3601.jpg",
      choices: [
        "18.5م",
        "15م",
        "13.5م",
        "12م"
      ],
      id: 500
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1797. واجب تخفيف سرعة المركبة:",
      numQues: "1797",
      correctAnswer: "عند الدخول في نفق وعند السير فيه.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "عند السير في طريق ليست بلدية.",
        "عند السير في طريق ليست بلدية فيها مساحة فاصلة مرسومة على الطريق.",
        "عند السير في طريق ليست بلدية مع مساحة فاصلة مبنية.",
        "عند الدخول في نفق وعند السير فيه."
      ],
      id: 501
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0134. في أية حالات لا يُسمح لك بتجاوز مركبة أخرى:",
      numQues: "0134",
      correctAnswer: "عندما تتوقف المركبة الأخرى قبل مفترق أو قبل مكان عبور المشاة أو قبل ملتقى سكة حديد.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "عندما تسير المركبة التي على يمينك ببطء.",
        "إذا كنت تسير في مسلك الاستدارة إلى اليسار.",
        "في شارع بين المدن باتجاهين.",
        "عندما تتوقف المركبة الأخرى قبل مفترق أو قبل مكان عبور المشاة أو قبل ملتقى سكة حديد."
      ],
      id: 502
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0724. أنت تقود المركبة رقم (3)/ ما هو ترتيب دخول المركبات إلى المفترق الذي أمامك؟",
      numQues: "0724",
      correctAnswer: "أنت أولاً (3)، بعدك المركبة التي على اليسار (2) وفي النهاية المركبة التي على اليمين (1).",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3724.jpg",
      choices: [
        "المركبة التي على اليسار تسير أولاً (2)، بعدها المركبة التي على اليمين (1)، وفي النهاية أنت (3).",
        "المركبة التي على اليمين (1)، أنت بعدها (3)، وفي النهاية المركبة التي على اليسار (2).",
        "أنت أولاً (3)، بعدك المركبة التي على اليمين (1)، وفي النهاية المركبة التي على اليسار (2).",
        "أنت أولاً (3)، بعدك المركبة التي على اليسار (2) وفي النهاية المركبة التي على اليمين (1)."
      ],
      id: 503
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0901. أنت تسوق في طريق فيها حركة سير كثيفة، كيف تضمن سيراً آمناً؟",
      numQues: "0901",
      correctAnswer: "من اجل السير الآمن في هذه الظروف، تكفي المحافظة على مسافة مناسبة من الأمام فقط.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3901.jpg",
      choices: [
        "احرص على إلقاء نظرة على ما يجري من حولك وحافظ على مسافة من جميع الجوانب وسر بسرعة معقولة.",
        "من اجل السير الآمن في هذه الظروف، من المستحسن الالتصاق بالمركبة التي أمامك.",
        "سر كالمعتاد، لا توجد ضرورة لاهتمام خاص بالأمان في السير في وضع الازدحام. ",
        "من اجل السير الآمن في هذه الظروف، تكفي المحافظة على مسافة مناسبة من الأمام فقط."
      ],
      id: 504
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0596. كيف تتصرف بعد أن عبرت الإشارة المنصوبة على اليسار؟",
      numQues: "0596",
      correctAnswer: "نهاية الشارع الذي فيه حق الأولوية.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3595.jpg",
      choices: [
        "سر كالمعتاد، أنت في شارع فيه حق الأولوية.",
        "توقف قبل ملتقى سكة الحديد.",
        "أعطِ حق الأولوية لحركة السير القاطعة.",
        "نهاية الشارع الذي فيه حق الأولوية."
      ],
      id: 505
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0711. أنت تقود مركبة رقم (3) لمن تعطي حق الأولوية؟?",
      numQues: "0711",
      correctAnswer: "لراكب الدراجة النارية (1) وللباص (2).",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3711.jpg",
      choices: [
        "للباص فقط (2).",
        "ليس لأحد، لك (3) حق الأولوية.",
        "للمركبة الأقرب إلى المفترق.",
        "لراكب الدراجة النارية (1) وللباص (2)."
      ],
      id: 506
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0661. ما هو مفهوم الوسم (التأشير) على سطح الشارع؟",
      numQues: "0661",
      correctAnswer: "مكان توقف لنوع معين من المركبات في المكان الذي لا يوجد فيه خليج.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3661.jpg",
      choices: [
        "منطقة وقوف لمركبات الركاب الخصوصية.",
        "تحذير ! أشغال في الشارع.",
        "انتبه! شارع مشوش أمامك.",
        "مكان توقف لنوع معين من المركبات في المكان الذي لا يوجد فيه خليج."
      ],
      id: 507
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1457. ما هي المركبة التجارية بموجب قانون خدمات النقل؟",
      numQues: "1457",
      correctAnswer: "المركبة المستعملة في نقل الركاب فقط.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "مركبة وزنها الإجمالي المسموح به 10000كغم أو أكثر أو المركبة التي تنقل مواد خطرة من أي وزنٍ كان.",
        "المركبة التجارية المستعملة بالنقل مقابل أجرة فقط.",
        "مركبة تجارية حسب مدلولها في القانون وصدر لها تصريح بنقل البضائع والركاب.",
        "المركبة المستعملة في نقل الركاب فقط."
      ],
      id: 508
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1616. كيف يكون رد فعلنا للقوة الطاردة عن المركز والتي تولدت أثناء الانعطاف في الدراجة النارية؟",
      numQues: "1616",
      correctAnswer: "نقوم بتنفيذ الفرملة بالتناوب.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "نزيد من السرعة عند الدخول في المنعطف ونتمهل عند الخروج.",
        "نقوم بتمييل الدراجة النارية إلى داخل المنعطف.",
        "نزيد السرعة بشدة قبل الانعطاف لإلغاء القوة الطاردة المركزية.",
        "نقوم بتنفيذ الفرملة بالتناوب."
      ],
      id: 509
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1468. تاريخ إنتاج الإطار في المركبة:",
      numQues: "1468",
      correctAnswer: "مُسجل في دفتر المركبة.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "مطبوع على الإطار.",
        "مُسجل في شهادة تأمين المركبة.",
        "مُسجل في رخصة المركبة.",
        "مُسجل في دفتر المركبة."
      ],
      id: 510
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0955. هناك تغييرات في ترتيبات السير في تكملة الطريق، كيف تستعد لهذه التغييرات عندما تسوق في المسلك الأيمن؟",
      numQues: "0955",
      correctAnswer: "عدد المسالك آخذ في التناقص، انتقل إلى المسلك الأيسر دون إعاقة المركبات في هذا المسلك.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3955.jpg",
      choices: [
        "عدد المسالك آخذ في الازدياد، ابقَ في المسلك الأيمن وتابع سيرك على يمين الشارع.",
        "أنت تسير في المسلك الأيمن، انتبه للمركبات التي تندمج مع مسلكك من اليمين فقط.",
        "أنت تسير في المسلك الأيمن، انتبه للمركبات التي تندمج مع مسلكك من اليسار ومن اليمين.",
        "عدد المسالك آخذ في التناقص، انتقل إلى المسلك الأيسر دون إعاقة المركبات في هذا المسلك."
      ],
      id: 511
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1392. ما هي 'المركبة الشاحنة'؟",
      numQues: "1392",
      correctAnswer: "المركبة التي يُمنع نقل ركاب فيها ما عدا السائق.",
      pubDate: "10-11-2011 08:22:48",
      img: "",
      choices: [
        "كل مركبة ليست بمركبة تجارية.",
        "المركبة المعدة حسب مبناها لنقل مواد سائبة.",
        "المركبة الميكانيكية المستعملة أو المعدة حسب مبناها للاستعمال في نقل البضائع. ",
        "المركبة التي يُمنع نقل ركاب فيها ما عدا السائق."
      ],
      id: 512
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0372. أية إشارة هي التحذير الأخير قبل ملتقى سكة حديد؟",
      numQues: "0372",
      correctAnswer: "133",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3372.jpg",
      choices: [
        "131",
        "128",
        "132",
        "133"
      ],
      id: 513
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0616. عندما تسير في داخل نفق والمؤشر بالإشارة 633:",
      numQues: "0616",
      correctAnswer: "يُسمح لك بتجاوز مركبة أخرى.",
      pubDate: "10-11-2011 08:22:48",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3616.jpg",
      choices: [
        "عليك إضاءة مصابيح المقدمة.",
        "عليك إضاءة مصابيح الضباب.",
        "يُسمح لك بتغيير المسلك.",
        "يُسمح لك بتجاوز مركبة أخرى."
      ],
      id: 514
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0546. الاشارة التي في الصورة منصوبة في المفترق بدون أية إشارة إضافية، هل يُسمح بالاستدارة إلى اليسار؟",
      numQues: "0546",
      correctAnswer: "مسموح في مفترق فيه إشارات ضوئية (رمزورات).",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3545.jpg",
      choices: [
        "مسموح فقط في ساعات النهار.",
        "مسموح فقط في المفترق.",
        "ممنوع.",
        "مسموح في مفترق فيه إشارات ضوئية (رمزورات)."
      ],
      id: 515
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0240. هل يجوز نقل حمولة في مركبة خصوصية؟",
      numQues: "0240",
      correctAnswer: "مسموح فقط على سطح المركبة.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "مسموح، داخل المركبة أو في صندوق الحمولة أو على سطح المركبة.",
        "ممنوع منعاً باتاً.",
        "مسموح نقل حمولة لا يزيد وزنها عن 1000كغم.",
        "مسموح فقط على سطح المركبة."
      ],
      id: 516
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1075. كيف يؤثر زجاج غير نظيف في المركبة من ناحية السلامة؟",
      numQues: "1075",
      correctAnswer: "الأوساخ من شأنها الضرر في أجهزة السلامة في المركبة.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "الزجاج غير النظيف يعيق النظر الحر لدى السائق.",
        "المركبة النظيفة تساعد في تحسين التركيز لدى السائق وإحساسه بشكلٍ عام.",
        "المركبة الوسخة تعرض للخطر وتلوث البيئة المجاورة لها.",
        "الأوساخ من شأنها الضرر في أجهزة السلامة في المركبة."
      ],
      id: 517
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0368. أية إشارة تعني 'مشاة بالقرب من المكان'؟",
      numQues: "0368",
      correctAnswer: "306",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3368.jpg",
      choices: [
        "226",
        "136",
        "135",
        "306"
      ],
      id: 518
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0056. هل يجوز إجراء تغييرات في شهادات المركبة أو في شهادات السائق؟",
      numQues: "0056",
      correctAnswer: "يُسمح فقط بإضافة الرمز البريدي لعنوان السكن في فرع البريد المركزي.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "يُمنع تغيير أي بيان في الشهادات، سلطة الترخيص فقط هي المخولة لهذا الغرض.",
        "يُسمح فقط بإضافة العنوان أو تغييره في فرع البريد المركزي.",
        "يُسمح فقط بالإعادة على البيانات التي مُحيت أو شُوهت مع الزمن.",
        "يُسمح فقط بإضافة الرمز البريدي لعنوان السكن في فرع البريد المركزي."
      ],
      id: 519
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1171. هل يجوز لسائق صالون عمومي إنزال ركاب في مكان نُصبت في إشارة أو علامة تمنع الوقوف والتوقف؟",
      numQues: "1171",
      correctAnswer: "تم منح هذا الإذن لصالون عمومي يعمل على خط خدمة فقط.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "نعم، في طريق بلدية فقط، وليس على ممرات المشاة أو قبلها وليس بداخل مفترق.",
        "نعم، فقط إذا صدرت تعليمات من شرطي.",
        "نعم، في كل طريق.",
        "تم منح هذا الإذن لصالون عمومي يعمل على خط خدمة فقط."
      ],
      id: 520
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0051. هل يجب على السائق إبراز وثائق المركبة الأصلية للشرطي؟",
      numQues: "0051",
      correctAnswer: "نعم، في المكان والزمان اللذين يحددهما الشرطي.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "كلا، يُمكن الاكتفاء بصور مطابقة للأصل.",
        "كلا، يُمكن الاكتفاء بصور مُوَقَعة من صاحب المركبة.",
        "نعم، في المكان الذي يحدده سائق المركبة.",
        "نعم، في المكان والزمان اللذين يحددهما الشرطي."
      ],
      id: 521
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1303. متى يجب على سائق مركبة وزنها الإجمالي أكثر من 6000كغم أن يستريح لمدة نصف ساعة؟",
      numQues: "1303",
      correctAnswer: "بعد سياقتها 6 ساعات متواصلة.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "بعد سياقتها 4,5 ساعة بشكلِِ متواصل.",
        "بعد سياقتها 5 ساعة بشكلِِ متواصل.",
        "بعد سياقتها 4 ساعات متواصلة.",
        "بعد سياقتها 6 ساعات متواصلة."
      ],
      id: 522
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0389. هل يُسمح بإيقاف مركبة بجانب حاجز لوقاية المارة؟",
      numQues: "0389",
      correctAnswer: "مسموح فقط من اجل إصعاد أو إنزال الركاب من المركبة.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3389.jpg",
      choices: [
        "مسموح لوقتٍ قصير فقط.",
        "ممنوع إلا إذا وُجدت إشارة تدل على غير ذلك.",
        "مسموح إذا لم يكن هناك عابري طريق من جهة حاجز الوقاية.",
        "مسموح فقط من اجل إصعاد أو إنزال الركاب من المركبة."
      ],
      id: 523
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0798. على من تقع مسؤولية السلامة عند الرجوع إلى الخلف؟",
      numQues: "0798",
      correctAnswer: "على صاحب المركبة حتى ولم يكن سائق المركبة آنذاك.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "على كل من يتواجد بالقرب من المركبة التي ترجع إلى الخلف.",
        "على الشخص الذي يوجه السائق عند الرجوع إلى الخلف.",
        "على سائق المركبة فقط.",
        "على صاحب المركبة حتى ولم يكن سائق المركبة آنذاك."
      ],
      id: 524
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1223. من هو المسؤول عن عرض تعليمات تعرفة السفر في الصالون العمومي؟",
      numQues: "1223",
      correctAnswer: "أصحابه والسائق مسؤولون عن جدول سير الخط والدليل والأجرة التي اقرها مراقب السير على الطرق.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "على أصحاب الصالون العمومي أن يعرضوا جدول سير الخط والدليل والأجرة التي أقرتها سلطة الترخيص. ",
        "على السائق أن يعرض جدول سير الخط والدليل والأجرة التي أقرتها سلطة الترخيص.",
        "منظم الحركة والسائق.",
        "أصحابه والسائق مسؤولون عن جدول سير الخط والدليل والأجرة التي اقرها مراقب السير على الطرق."
      ],
      id: 525
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0618. لغاية أي مكان يسري مفعول الشاخصة المنصوبة أمامك؟",
      numQues: "0618",
      correctAnswer: "لغاية 150م من مكان نصب الإشارة.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3618.jpg",
      choices: [
        "لغاية الإشارة التي تشير إلى الدخول إلى حدود طريق داخل المدن.",
        "لغاية المفترق القادم.",
        "لغاية مكان عبور المشاة القريب.",
        "لغاية 150م من مكان نصب الإشارة."
      ],
      id: 526
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "0340. كيف يتم وسم (تأشير) ماكنة زراعية يزيد عرضها عن 340سم؟",
      numQues: "0340",
      correctAnswer: "بوضع لافتة على مقدمة الماكنة كُتب فيها 'انتبه مركبة عريضة' ، وتُثبت فيها وقت الإنارة مصابيح عرض.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "بوضع لافتة على مؤخرة الماكنة كُتب فيها 'انتبه حمولة بارزة'، وفي وقت الإنارة توضع مثلثات عاكسة.",
        "توسم (تؤشر) الماكنة بمصابيح عرض تضيء بنور اصفر متقطع يُمكن رؤيته من مسافة 150م في النهار وفي الليل.",
        "توسم (تؤشر) الماكنة بمثلث ابيض من الأمام وبمثلث ابيض له أضلاع حمراء من الخلف.",
        "بوضع لافتة على مقدمة الماكنة كُتب فيها 'انتبه مركبة عريضة' ، وتُثبت فيها وقت الإنارة مصابيح عرض."
      ],
      id: 527
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0275. ما هي الإجراءات التي يجب أن يقوم بها سائق مركبة له دخل في حادث طرق أسفر عن إصابة أشخاص؟",
      numQues: "0275",
      correctAnswer: "يتوجه بالمركبة إلى مركز الشرطة ويُعطي تفاصيله الشخصية.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "يُقدم للمصاب الإسعاف الأولي المناسب حسب مقدرته ومؤهلاته ويستدعي فرق الإنقاذ وينتظر في المكان لحين وصولهم.",
        "يقوم بتبليغ الشرطة عن الحادث في خلال 72 ساعة.",
        "يتبادل التفاصيل مع باقي المشتركين في الحادث، وحينها لا توجد ضرورة بتبليغ الشرطة.",
        "يتوجه بالمركبة إلى مركز الشرطة ويُعطي تفاصيله الشخصية."
      ],
      id: 528
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1059. بماذا تساهم السياقة المعتدلة لسائق المركبة بدون التسريع الشديد للمحرك؟",
      numQues: "1059",
      correctAnswer: "بتوفير في استهلاك زيت المحرك.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "بتوفير في استهلاك الكهرباء في المركبة.",
        "بتوفير في استهلاك وقود المحرك.",
        "باستمرار السفرة وقت أطول من اللازم.",
        "بتوفير في استهلاك زيت المحرك."
      ],
      id: 529
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "0995. ما هي وظيفة بادئ الحركة (الستارتر) في المركبة؟",
      numQues: "0995",
      correctAnswer: "تشغيل المحرك.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "السيطرة على عمل المحرك.",
        "فصل الحركة من المحرك عن العجلات.",
        "توصيل الحركة من المحرك للعجلات.",
        "تشغيل المحرك."
      ],
      id: 530
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0664. ما هو مفهوم الضوء الظاهر في الإشارة الضوئية (الرمزور)؟",
      numQues: "0664",
      correctAnswer: "إذا كان المفترق خالي فيُسمح بعبوره بحذر بدون التوقف.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3664.jpg",
      choices: [
        "ضوء احمر: توقف.",
        "ضوء احمر: توقف، إلا إذا لم تكن هناك إمكانية للتوقف بأمان.",
        "توقف للحظة وأعطِ حق الأولوية واستمر في السير بحذر.",
        "إذا كان المفترق خالي فيُسمح بعبوره بحذر بدون التوقف."
      ],
      id: 531
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0461. ما معنى الإشارة؟",
      numQues: "0461",
      correctAnswer: "تأتي إشارة 'قف' بعدها في الطريق.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3461.jpg",
      choices: [
        "إعطاء حق الأولوية في دوار حركة السير الذي أمامك.",
        "إشارة 'أعطِ حق الأولوية' بعدها في بقية الطريق.",
        "أمامك دوار حركة سير ، 150م قبل الدوار.",
        "تأتي إشارة 'قف' بعدها في الطريق."
      ],
      id: 532
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0466. ما معنى الإشارة؟",
      numQues: "0466",
      correctAnswer: "شارع مشوش.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3466.jpg",
      choices: [
        "منعطف إلى اليسار ثم إلى اليمن.",
        "خطر التزحلق.",
        "حافظ على السير في وسط الشارع.",
        "شارع مشوش."
      ],
      id: 533
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0827. كيف تلفت انتباه سائق المركبة المنوي تجاوزها عندما تجتازها في طريق ليست بلدية؟",
      numQues: "0827",
      correctAnswer: "أضئ مصابيح الوقوف في المركبة في وضح النهار، إذا كان ذلك ضرورياً.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "استعمل الزامور طيلة وقت المرور عنه، المهم أن لا يتجاهلك.",
        "أعطه إشارة بواسطة الأربعة غمازات في المركبة إذا كان ذلك ضرورياً.",
        "يُسمح لك باستعمال الزامور قليلاً قبل عبوره ، إذا كان ذلك ضرورياً.",
        "أضئ مصابيح الوقوف في المركبة في وضح النهار، إذا كان ذلك ضرورياً."
      ],
      id: 534
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1570. أية إشارة تأتي بعد الإشارة 135 التي في الصورة؟",
      numQues: "1570",
      correctAnswer: "220",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31570.jpg",
      choices: [
        "149",
        "306",
        "136",
        "220"
      ],
      id: 535
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0040. ما هي 'مركبة الركاب الخصوصية'؟",
      numQues: "0040",
      correctAnswer: "مركبة ميكانيكية خصوصية معدة لنقل ما لا يزيد عن 8 ركاب بالإضافة إلى السائق. وذُكر في رخصتها بأنها مركبة خصوصية.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "مركبة ميكانيكية خصوصية معدة لنقل 12 راكب على الأقل وذُكر في رخصتها بأنها مركبة خصوصية.",
        "مركبة ميكانيكية عمومية مُعدة لنقل 8 ركاب وذُكر في رخصتها بأنها مركبة عمومية.",
        "مركبة ميكانيكية مُعدة لنقل 10 ركاب وذُكر في رخصتها بأنها مركبة خصوصية.",
        "مركبة ميكانيكية خصوصية معدة لنقل ما لا يزيد عن 8 ركاب بالإضافة إلى السائق. وذُكر في رخصتها بأنها مركبة خصوصية."
      ],
      id: 536
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0478. من المسؤول في أي وقت عن صلاحية المركبة ؟",
      numQues: "0478",
      correctAnswer: "صاحب المركبة المسجلة على اسمه والسائق.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3478.jpg",
      choices: [
        "مُنتج المركبة أو مستوردها.",
        "سلطة الترخيص.",
        "شركة التأمين.",
        "صاحب المركبة المسجلة على اسمه والسائق."
      ],
      id: 537
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1682. في أية مركبات يجب أن توجد السترة العاكسة؟",
      numQues: "1682",
      correctAnswer: "القانون لا يتطرق إلى مكان حيازتها.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "في كل مركبة ميكانيكية وأيضاً في كل مركبة غير ميكانيكية.",
        "في كل مركبة ميكانيكية.",
        "في كل مركبة ميكانيكية ما عدا التراكتور.",
        "القانون لا يتطرق إلى مكان حيازتها."
      ],
      id: 538
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1654. ما هي العلاقة بين زاوية الميلان والانعطاف بالدراجة النارية في منعطف وبين إضاءة مقدمة الدراجة النارية؟",
      numQues: "1654",
      correctAnswer: "في اللحظة التي يتم فيها انعطاف أو انبطاح الدراجة النارية، تضعف قوة الضوء بسبب ارتفاع السائل في البطارية. ",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "كلما زاد الميلان أو الانعطاف في الدراجة النارية، يُبهَر نظر راكب الدراجة النارية التي يركبها.",
        "لا يوجد أية علاقة، إلا إذا كانت صيانة الدراجة النارية رديئة وهناك خلل في تعيير الأضواء. ",
        "كلما زاد الميلان أو الانعطاف بالدراجة النارية كلما زاد انحراف شعاع الضوء عن اتجاه السير المطلوب. ",
        "في اللحظة التي يتم فيها انعطاف أو انبطاح الدراجة النارية، تضعف قوة الضوء بسبب ارتفاع السائل في البطارية. "
      ],
      id: 539
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»",
        "«D»"
      ],
      title: "1210. يُسمح أيضاً بالسير في المسلك المعد للمواصلات العمومية لمركبة:",
      numQues: "1210",
      correctAnswer: "معاق بحوزته لاصقة (إشارة) معاق أصدرها منتج المركبة.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "معاق بحوزته لاصقة (إشارة) معاق مشلول الأرجل (كرسي العجزة).",
        "أي معاق بحيازته لاصقة (إشارة) معاق عادية. ",
        "معاق، حتى وإن ولم يكن المعاق في المركبة.",
        "معاق بحوزته لاصقة (إشارة) معاق أصدرها منتج المركبة."
      ],
      id: 540
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1535. أية إشارة تمنع دخول المشاة؟",
      numQues: "1535",
      correctAnswer: "216",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31535.jpg",
      choices: [
        "901",
        "221",
        "815",
        "216"
      ],
      id: 541
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0173. كيف تتصرف عند خروجك من ساحات أو من طريق وصول إلى بيت وتنوي الصعود على الرصيف؟",
      numQues: "0173",
      correctAnswer: "عند الخروج من ساحات أو من طريق وصول إلى بيت يجب تطبيق القاعدة 'من يصل أولاً يخرج أولاً'، وعلى المشاة الانتظار.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "قف دائماً وأعطِ حق الأولوية للمشاة الذين يعبرون الشارع.",
        "تمهل وحتى توقف عند الحاجة من اجل تمكين المشاة من العبور بأمان.",
        "قف دائماً وأعطِ حق الأولوية للمركبات الآتية من اليسار وتقترب من المخرج.",
        "عند الخروج من ساحات أو من طريق وصول إلى بيت يجب تطبيق القاعدة 'من يصل أولاً يخرج أولاً'، وعلى المشاة الانتظار."
      ],
      id: 542
    },
    {
      category: "معرفة المركبة",
      type: [
        "«A»"
      ],
      title: "1670. كيف نعرف بأن بطانة الفرامل متآكلة ويجب تغييرها:",
      numQues: "1670",
      correctAnswer: "فقط بعد الفحص في مؤسسة ترخيص يمكن معرفة قياس تآكل البطانة.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "حسب سرعة برودة الفرامل عند الفرملة القوية.",
        "هناك علامة على بطانة الفرامل عند تآكلها من الممكن تمييزها.",
        "لا يمكن أن نعرف، إلا إذا تآكلت البطانة كاملةً – عندها يجب تغيرها.",
        "فقط بعد الفحص في مؤسسة ترخيص يمكن معرفة قياس تآكل البطانة."
      ],
      id: 543
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1203. هل هناك واجب بتركيب زامور للرجوع إلى الخلف في الباص؟",
      numQues: "1203",
      correctAnswer: "كلا، لا يوجد واجب.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "نعم، الواجب فقط في الباص الصغير",
        "الواجب فقط في مركبة من نوع صالون عمومي.",
        "نعم، هناك واجب بتركيب زامور يعمل بصورة أوتوماتيكية عند تعشيق الغيار الخلفي.",
        "كلا، لا يوجد واجب."
      ],
      id: 544
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0401. الهدف من إشارة الاستعلامات:",
      numQues: "0401",
      correctAnswer: "تحذير عابري الطريق من خطر قريب في الطريق.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "إرشاد سائقي المركبات على كيفية التصرف.",
        "إعطاء معلومات عن أمكنة وعن اتجاهات.",
        "تحديد الممنوعات.",
        "تحذير عابري الطريق من خطر قريب في الطريق."
      ],
      id: 545
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1025. ما هو مقدار ضغط الهواء اللازم لنفخ عجلات المركبة؟",
      numQues: "1025",
      correctAnswer: "المقدار الذي يُمكن من السفر بأعلى درجة من الراحة. ",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "مقدار الضغط يكون حسب تعليمات منتج المركبة.",
        "لا توجد أهمية كبيرة لمقدار ضغط الهواء في الإطارات.",
        "يكون الضغط حسب تعليمات الكراج أو مؤسسة الترخيص.",
        "المقدار الذي يُمكن من السفر بأعلى درجة من الراحة. "
      ],
      id: 546
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0186. كيف تتصرف عند اقترابك من مفترق نُصبت فيه إشارة ضوئية (رمزور) يضيء فيها الضوء الأصفر المتقطع؟",
      numQues: "0186",
      correctAnswer: "خفف من سرعة سيرك وأعطِ حق الأولوية للمركبة القادمة من اليسار فقط.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3186.jpg",
      choices: [
        "زد من سرعة سيرك قبل أن يتغير الضوء إلى احمر في الإشارة الضوئية (الرمزور).",
        "خفف من سرعة سيرك وحتى قف إذا اقتضت الضرورة - حسب حركة السير من حولك.",
        "قف في جميع الأحوال قبل مكان عبور المشاة.",
        "خفف من سرعة سيرك وأعطِ حق الأولوية للمركبة القادمة من اليسار فقط."
      ],
      id: 547
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0624. إلى ماذا تشير الإشارة؟",
      numQues: "0624",
      correctAnswer: "مطعم.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3624.jpg",
      choices: [
        "فندق أمامك.",
        "محطة لانتعاش السائقين.",
        "مخيم طرق.",
        "مطعم."
      ],
      id: 548
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1345. درجة الرخصة المطلوبة لسياقة مركبة ميكانيكية تجارية وزنها الإجمالي المسموح به لا يزيد عن 12000كغم هي:",
      numQues: "1345",
      correctAnswer: "A1",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "C1",
        "B",
        "D",
        "A1"
      ],
      id: 549
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1563. عندما تُبهر الشمس نظر سائق المركبة، عليه:",
      numQues: "1563",
      correctAnswer: "تجاوز المركبة التي في الأمام، لأنه يُستحسن السير في شارع خالي.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "تحويل نظره إلى الجانب وعدم النظر إلى الأمام. ",
        "زيادة سرعة سيره حتى يصل إلى مكان فيه ظل.",
        "التخفيف من سرعته وملاءمة سرعته لمدى الرؤية القائم. ",
        "تجاوز المركبة التي في الأمام، لأنه يُستحسن السير في شارع خالي."
      ],
      id: 550
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1566. ما هو الضغط السليم في جهاز فرامل هوائي (هواء مضغوط) في المركبة؟",
      numQues: "1566",
      correctAnswer: "أقصى قدر من الضغط الذي تُنتجه المركبة. ",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "الضغط الذي حدده منتج المركبة.",
        "الضغط الذي تفرمل فيه المركبة بنجاعة.",
        "الضغط الذي حدده القانون المحلي.",
        "أقصى قدر من الضغط الذي تُنتجه المركبة. "
      ],
      id: 551
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0690. ما معنى الإشارة المنصوبة أمامك؟",
      numQues: "0690",
      correctAnswer: "حاجز قطار أمامك في موقع أشغال.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3690.jpg",
      choices: [
        "أعمدة توجيه وتحذير على طرف الطريق.",
        "ملتقى سكة حديد أمامك بعد 300م.",
        "وسم (تأشير) حاجز وقاية.",
        "حاجز قطار أمامك في موقع أشغال."
      ],
      id: 552
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0657. ما هو مفهوم أحجار الحافة المدهونة على التناوب باللون الأزرق؟",
      numQues: "0657",
      correctAnswer: "مكان وقوف حسب الترتيبات المحددة من قِبل السلطة المحلية.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3657.jpg",
      choices: [
        "مكان وقوف منظم للمركبات العمومية فقط.",
        "يُمنع أي وقوف أو توقف بجانب أحجار الحافة ما عدا الصالون العمومي (التاكسيات) في طريق داخل المدن.",
        "للتأكيد وإظهار الأرصفة الفاصلة وجزر السير المبنية.",
        "مكان وقوف حسب الترتيبات المحددة من قِبل السلطة المحلية."
      ],
      id: 553
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0141. في أية حالات يُلزم القانون بالتمهل؟",
      numQues: "0141",
      correctAnswer: "في مكان فيه ظل أشجار عالية.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "في طريق ليست خالية أو أن الرؤية فيها محدودة أو أن فيها التواءات حادة.",
        "قبل تجاوز مركبة وأثناء التجاوز من اجل الزيادة في الأمان. ",
        "عند اقترابك من مكان يُخشى فيه من نشاط إجرامي.",
        "في مكان فيه ظل أشجار عالية."
      ],
      id: 554
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1408. هل يجوز للشرطي وقف سير مركبة تنقل حمولة مخالفة للقانون؟",
      numQues: "1408",
      correctAnswer: "نعم، يجوز للشرطي وقف سير المركبة حتى يتم تنزيل الحمولة أو حتى يتم ترتيبها حسب أحكام القانون.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "كلا، لا يجوز للشرطي وقف سير المركبة إلا إذا كانت الحمولة تشكل خطراً على عابري الطريق الآخرين.",
        "كلا، يجوز فقط لضابط شرطة برتبة مفتش أو أعلى أن يوقف سير المركبة.",
        "نعم، فقط إذا كان الوزن الإجمالي للمركبة أكثر من 20% من الوزن الإجمالي المسموح به حسب القانون.",
        "نعم، يجوز للشرطي وقف سير المركبة حتى يتم تنزيل الحمولة أو حتى يتم ترتيبها حسب أحكام القانون."
      ],
      id: 555
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0808. أية مشكلة يواجهها سائق المركبة والذي يسوق بسرعة عالية؟",
      numQues: "0808",
      correctAnswer: "يقل زمن رد الفعل لديه وذلك يشكل خطورة على سيره.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "الوقت الذي لدى السائق لرد الفعل الصحيح على الأحداث في الطريق يكون قليلاً جداً.",
        "لا توجد أية مشكلة على الإطلاق: أثبتت الأبحاث بأن السياقة بسرعة عالية جداً تساهم في سياقة هادئة وسلسة.",
        "زمن رد فعله يكون يطول كثيراً.",
        "يقل زمن رد الفعل لديه وذلك يشكل خطورة على سيره."
      ],
      id: 556
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0622. ما معنى الإشارة؟",
      numQues: "0622",
      correctAnswer: "مسموح التوقف في الجهة اليسرى من الشارع.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3622.jpg",
      choices: [
        "الشارع يزداد في العرض.",
        "عدد المسالك في الشارع آخذ في الازدياد.",
        "استدارة إلى اليسار أو إلى اليمين أمامك.",
        "مسموح التوقف في الجهة اليسرى من الشارع."
      ],
      id: 557
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0317. 'شرب الكحول يمس بالقدرة على تقدير المسافات والسرعات'، صحيح أم غير صحيح؟",
      numQues: "0317",
      correctAnswer: "هذا صحيح بالنسبة لمن يستعمل النظارات فقط.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "صحيح.",
        "صحيح بالنسبة للنساء فقط.",
        "شرب الكحول يمس بالقدرة على التقدير عند السائقين الشبان فقط.",
        "هذا صحيح بالنسبة لمن يستعمل النظارات فقط."
      ],
      id: 558
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1178. ما هو تواتر (فترات) تعقيم الباص الذي يعمل على خط خدمة؟",
      numQues: "1178",
      correctAnswer: "مرة كل سنتين بعد الترخيص السنوي.",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "مرة كل سنتين، في أي وقت مريح لصاحب الباص.",
        "على الأقل مرة كل سنة.",
        "مرة كل سنتين قبيل موعد الترخيص السنوي.",
        "مرة كل سنتين بعد الترخيص السنوي."
      ],
      id: 559
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0280. كيف يجب أن يتصرف سائق مركبة يمر عن مكان وقع فيه حادث طرق أسفر عن مصابين؟",
      numQues: "0280",
      correctAnswer: "عليه التوقف على جانب الطريق ويساعد في إخلاء المركبات من الشارع ويُمكن حركة السير من الانسياب بحرية ودون إعاقة.",
      pubDate: "10-11-2011 08:22:49",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3280.jpg",
      choices: [
        "عليه التوقف في مكان الحادث وتقديم المساعدة التي يمكنه تقديمها للمصابين حسب مقدرته واستدعاء فرق الإنقاذ.",
        "عليه التوقف على جانب الطريق وتأشير مكان الحادث بواسطة مثلث تحذير يُمكن رؤيته من مسافة 50م.",
        "يتابع سيره ولا يتأخر إذا لم يكن له دخل في الحادث.",
        "عليه التوقف على جانب الطريق ويساعد في إخلاء المركبات من الشارع ويُمكن حركة السير من الانسياب بحرية ودون إعاقة."
      ],
      id: 560
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1016. هل لمحرك المركبة تأثير على سلامة السير؟",
      numQues: "1016",
      correctAnswer: "كلا، يظهر تأثير المحرك فقط في الصعود الشديد. ",
      pubDate: "10-11-2011 08:22:49",
      img: "",
      choices: [
        "نعم، وبالأخص في المساعدة عند الهروب من حالات الطوارئ.",
        "نعم، يظهر تأثير المحرك فقط في التسارع عند بداية السير. ",
        "كلا، لا يوجد أي تأثير للمحرك على سلامة السير.",
        "كلا، يظهر تأثير المحرك فقط في الصعود الشديد. "
      ],
      id: 561
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0852. كيف تتصرف عند السياقة في الليل وعندما تُبهر نظرك المركبة القادمة من الجهة المقابلة؟",
      numQues: "0852",
      correctAnswer: "أضئ الضوء العالي من اجل تحسين مدى رؤيتك.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "تمهل وابقَ على اليمين وانظر إلى الخط الأصفر أو إلى حافة الشارع اليمنى.",
        "استعمل الزامور بشدة من اجل تنبيه السائق القادم من الجهة المقابلة بأنه يُبهر نظرك. ",
        "توقف على يمين الطريق وشَغل أضواء الوقوف إلى أن تعبر المركبة القادمة من الجهة المقابلة.",
        "أضئ الضوء العالي من اجل تحسين مدى رؤيتك."
      ],
      id: 562
    },
    {
      category: "معرفة المركبة",
      type: [
        "«A»"
      ],
      title: "1621. ما هي عمليات الصيانة التي يجب إجراؤها للدراجة النارية؟",
      numQues: "1621",
      correctAnswer: "لا توجد ضرورة بإجراء العناية والصيانة للدراجة النارية الحديثة.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "يجب إجراء الصيانة الدورية للدراجة النارية فقط قبل فحص الترخيص السنوي (التست).",
        "الصيانة الدورية حسب تعليمات الكراج لأنه يعرف الدراجة النارية أحسن من الجميع.",
        "الصيانة الدورية حسب تعليمات منتج الدراجة النارية.",
        "لا توجد ضرورة بإجراء العناية والصيانة للدراجة النارية الحديثة."
      ],
      id: 563
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1714. من هو المسؤول عن مركبة تنفث دخان أكثر من المقدار المحدد في القانون؟",
      numQues: "1714",
      correctAnswer: "سائق المركبة ومنتج المركبة.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "الكراج الذي يعتني بالمركبة.",
        "سائق المركبة.",
        "صاحب محطة الوقود الذي باع الوقود.",
        "سائق المركبة ومنتج المركبة."
      ],
      id: 564
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1620. كيف تتجنب عائق، مثل جسم ملقى على الطريق والذي ظهر فجأة أثناء السير في الدراجة النارية؟",
      numQues: "1620",
      correctAnswer: "تزيد من السرعة وتعبر العائق بدون أي تأخير.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "تزيد من سرعة الدراجة النارية إلى حد كبير من اجل المحافظة على التوازن.",
        "تفرمل قبل العائق وأثناء المرور عليه وبذلك تضمن وقت فرملة أقصى.",
        "تفرمل قبل العائق، وتتأنى لحظة قبل مواجهته وتتجنبه من يمينه أو من يساره.",
        "تزيد من السرعة وتعبر العائق بدون أي تأخير."
      ],
      id: 565
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0855. ما هي أخطار السياقة المتواصلة لساعات كثيرة؟",
      numQues: "0855",
      correctAnswer: "سخونة وتآكل سريع للإطارات الأمامية.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "التعب وميل السائق للنوم.",
        "تنخفض قوة المحرك ومعها تنخفض قدرة الفرملة.",
        "لا يوجد أي خطر لسائق يتمتع بصحة جيدة من السياقة المتواصلة لساعات كثيرة. ",
        "سخونة وتآكل سريع للإطارات الأمامية."
      ],
      id: 566
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1372. هل يوجد واجب بتركيب مصابيح وقوف حتى في المركبة المُركب فيها مصابيح عرض (مصابيح جناح)؟",
      numQues: "1372",
      correctAnswer: "نعم هذا واجب – للحالات التي تتعطل فيها أضواء العرض.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "نعم، مصابيح العرض لها لون مختلف ولا يمكن أن تكون بديلاً عن مصابيح الوقوف.",
        "نعم، هناك واجب بتركيب مصابيح وقوف في كل مركبة بدون أية علاقة بمصابيح العرض.",
        "كلا، لا يوجد واجب بتركيب مصابيح وقوف في المركبة المُركب فيها مصابيح عرض.",
        "نعم هذا واجب – للحالات التي تتعطل فيها أضواء العرض."
      ],
      id: 567
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0970. السير خلف المركبة الثقيلة في أوضاع الطريق الراهنة، تُلزم سائق المركبة:",
      numQues: "0970",
      correctAnswer: "مواصلة السير كالمعتاد، لا توجد ضرورة بالمحافظة على مسافة لأن السرعة منخفضة على أية حال.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3970.jpg",
      choices: [
        "الالتصاق بالمركبة الثقيلة التي تسير في الأمام.",
        "بالمحافظة على مسافة وبالسير البطيء وبالصبر.",
        "مواصلة السير كالمعتاد، لا تتطلب أوضاع الطريق تصرفات خاصة.",
        "مواصلة السير كالمعتاد، لا توجد ضرورة بالمحافظة على مسافة لأن السرعة منخفضة على أية حال."
      ],
      id: 568
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0322. ما هو عدد الركاب، ما عدا السائق، الذين يُسمح بنقلهم في مركبة تجارية يزيد وزنها الإجمالي المسموح به عن 3500كغم؟",
      numQues: "0322",
      correctAnswer: "لغاية 6 ركاب ما عدا الجالسين بجانب السائق.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "راكب واحد فقط يجلس بجانب السائق.",
        "بعدد مقاعد الجلوس في كابينة السائق فقط.",
        "العدد المذكور في رخصة المركبة.",
        "لغاية 6 ركاب ما عدا الجالسين بجانب السائق."
      ],
      id: 569
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1675. إذا أضاءت لمبة ضغط الزيت أثناء السير، عليك:",
      numQues: "1675",
      correctAnswer: "إيقاف المركبة فوراً وأطفئ المحرك.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "الاستمرار بالسير بشرط أن يكون هناك كمية كافية في حوض زيت المحرك.",
        "الاستمرار بالسير بغيار واطئ لغاية الكراج (ولكن ليس أكثر من نصف ساعة سفر).",
        "الاستمرار بالسير إذا أشار مقياس حرارة المحرك بأن حرارة المحرك عادية.",
        "إيقاف المركبة فوراً وأطفئ المحرك."
      ],
      id: 570
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1342. عرف 'مركبة شاحنة':",
      numQues: "1342",
      correctAnswer: "مركبة ميكانيكية تُستخدم أو معدة حسب مبناها للاستعمال في نقل الركاب والبضائع.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "مركبة ميكانيكية تجارية معدة للنقل مقابل أجرة وذُكر ذلك في رخصة المركبة.",
        "مركبة ميكانيكية تُستخدم أو معدة حسب مبناها للاستعمال في نقل البضائع.",
        "مركبة ميكانيكية تُستخدم أو معدة حسب مبناها للاستعمال في نقل البضائع ووزنها يزيد عن 8000كغم.",
        "مركبة ميكانيكية تُستخدم أو معدة حسب مبناها للاستعمال في نقل الركاب والبضائع."
      ],
      id: 571
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0677. ما معنى الإشارة؟",
      numQues: "0677",
      correctAnswer: "مفترق تقاطع طرق أمامك.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3677.jpg",
      choices: [
        "ممنوع السير في هذا المسلك.",
        "مسموح السير في هذا المسلك للمركبات التي تسير على عجلتين فقط.",
        "ممنوع الانتقال إلى المسلك المجاور من اليمين أو من اليسار، عليك الاستمرار في هذا المسلك.",
        "مفترق تقاطع طرق أمامك."
      ],
      id: 572
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1681. لا ينقل 'سائق جديد'، لم يتم 21 سنة من عمره، في مركبة ركاب خصوصية:",
      numQues: "1681",
      correctAnswer: "أكثر من أربعة ركاب إضافة إليه إلا إذا جلس بجانبه مرافق.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "أكثر من راكبين إضافة إليه إلا إذا جلس بجانبه مرافق.",
        "أكثر من راكب واحد إضافة إليه إلا إذا جلس بجانبه مرافق.",
        "أكثر من أربعة ركاب بشرط أن يكونوا جميعهم أصحاب رخص سواقة لمركبة خصوصية.",
        "أكثر من أربعة ركاب إضافة إليه إلا إذا جلس بجانبه مرافق."
      ],
      id: 573
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1131. ما هو عدد الركاب الأقصى الذي يجوز نقله في باص صغير (أوتوبوس زعير) إذا كان السائق بحوزته رخصة سياقة لصالون عمومي؟",
      numQues: "1131",
      correctAnswer: "كعدد مقاعد الجلوس في الصالون العمومي.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "لغاية 16 راكباً ما عدا السائق.",
        "لغاية سبعة ركاب وأيضاً ولدين لغاية عمر 5 سنوات.",
        "لغاية ثمانية ركاب وأيضاً ولدين لغاية عمر 5 سنوات.",
        "كعدد مقاعد الجلوس في الصالون العمومي."
      ],
      id: 574
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0692. ضغطت على دعسة الفرامل وشعرت أن فرامل الخدمة (فرامل الرجل) لا تعمل، كيف تتصرف؟",
      numQues: "0692",
      correctAnswer: "حاول الفرملة بمساعدة فرامل اليد (الهاندبريك).",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "ادر المقود بسرعة إلى اليمين لكي تفرمل المركبة بواسطة تغيير اتجاه العجلات.",
        "استعمل الزامور وأضيء الأضواء لكي تنبه السائق الموجود أمامك.",
        "حاول الفرملة بواسطة ضغط خفيف على دعسة الكلاتش.",
        "حاول الفرملة بمساعدة فرامل اليد (الهاندبريك)."
      ],
      id: 575
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0720. كيف تتصرف في المفترق الذي أمامك؟",
      numQues: "0720",
      correctAnswer: "استمر في السير، على راكب الدراجة النارية إعطاؤك حق الأولوية.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3720.jpg",
      choices: [
        "استعمل الزامور لراكب الدراجة النارية لكي تنبهه وتستمر بالسير.",
        "استمر بالسير إلى الأمام وتعطي ضوء متقطع بالضوء العالي لراكب الدراجة النارية.",
        "أعطِ حق الأولوية لراكب الدراجة النارية.",
        "استمر في السير، على راكب الدراجة النارية إعطاؤك حق الأولوية."
      ],
      id: 576
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1605. كيف يجب أن تسوق الدراجة النارية عند عبور بقعة من الزيوت على الشارع؟",
      numQues: "1605",
      correctAnswer: "تفرمل بشدة باستعمال الفرملتين.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "بشكلٍ مستقيم بدون الإسراع وبدون فرملة.",
        "تسير بشكلٍ مستقيم، وتزيد من سرعتك وتعبر البقعة بسرعة.",
        "تستمر بالسير وتسرع، مثل السير قبل البقعة.",
        "تفرمل بشدة باستعمال الفرملتين."
      ],
      id: 577
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1440. متى يجب على سائق المركبة السير على حاشية الطريق من اجل تمكين المركبات الأخرى من تجاوزه ، إذا كانت حاشية الطريق معبدة بالإسفلت وخالية ؟",
      numQues: "1440",
      correctAnswer: "إذا اضطر سائق المركبة الميكانيكية السير بسرعة بطيئة تعيق حركة السير من خلفه، بسبب حمولتها أو بسبب انحدار الطريق.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "عندما يسير السائق ببطء شديد – لأي سبب كان.",
        "فقط عندما تسير المركبة في طريق شديدة الصعود وتضطر للسير على مهل وتعرقل حركة السير الحرة.",
        "لا يجب في أية حالة، ممنوع السير على حاشية الطريق، لذلك على المركبة التي تعيق حركة السير من خلفها الانحراف إلى حاشية الطريق والتوقف من اجل إخلاء حركة السير من خلفه.",
        "إذا اضطر سائق المركبة الميكانيكية السير بسرعة بطيئة تعيق حركة السير من خلفه، بسبب حمولتها أو بسبب انحدار الطريق."
      ],
      id: 578
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0191. كيف تتصرف إذا أُغلق مسلك سيرك في الشارع؟",
      numQues: "0191",
      correctAnswer: "سر بحذر دون أن تعير انتباهك للإشارات المنصوبة في المكان.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "اعبر بسرعة مكان الانسداد من اليمين أو من اليسار.",
        "امتثل للإشارة الصادرة عن الشرطي أو عن جهاز (أو شخص) يُعطي إشارة أو لإشارة سير.",
        "اعبر مكان الانسداد من الجهة اليمنى فقط، وعلى المركبة القادمة من أمامك أن تعطيك حق الأولوية.",
        "سر بحذر دون أن تعير انتباهك للإشارات المنصوبة في المكان."
      ],
      id: 579
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1755. السرعة القصوى المسموح بها في طريق بلدية لمركبة ركاب خصوصية (إذا لم يُذكر غير ذلك في إشارة) هي:",
      numQues: "1755",
      correctAnswer: "50كم/ساعة.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "لغاية 40كم/ساعة.",
        "50كم/ساعة في طريق باتجاه واحد، ولغاية 60كم/ساعة في طريق باتجاهين.",
        "80كم/ساعة.",
        "50كم/ساعة."
      ],
      id: 580
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1813. 123",
      numQues: "813 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [],
      id: 581
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0745. لماذا من المهم الحرص على السواقة على يمين الشارع؟",
      numQues: "0745",
      correctAnswer: "لا توجد أهمية للسياقة على يمين الشارع إلا في شارع باتجاه واحد فقط.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3745.jpg",
      choices: [
        "ذلك يُمكن من الاستعانة بالخط الأصفر للسير بخط مستقيم.",
        "من اجل إحداث مسافة من حركة السير التي من الجهة المعاكسة وتقليل خطر الاصطدام وجهاً لوجه.",
        "منح إمكانية سهلة للركاب في المركبة للخروج من المركبة بسهولة.",
        "لا توجد أهمية للسياقة على يمين الشارع إلا في شارع باتجاه واحد فقط."
      ],
      id: 582
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0680. ماذا تعني الإشارة؟",
      numQues: "0680",
      correctAnswer: "مسموح الوقوف بواسطة بطاقات وقوف. ",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3680.jpg",
      choices: [
        "حاجز قبل ملتقى سكة حديد.",
        "ممنوع التوقف والوقوف ما عدا الباصات.",
        "مسموح التوقف للحظة لكن الوقوف ممنوع.",
        "مسموح الوقوف بواسطة بطاقات وقوف. "
      ],
      id: 583
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0863. ما هو الشيء الذي يجب علينا التأكد منه قبل تشغيل محرك المركبة؟",
      numQues: "0863",
      correctAnswer: "الهاندبريك مسحوب وعصا الغيارات في الغيار الأول(وفي المركبة الأوتوماتيكية- (D) ) والكلاتش مضغوط.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "فرامل الرجل مضغوطة والهاندبريك مسحوب وعصا الغيارات في وضع نيوترال (N) والكلاتش مضغوط (وفي المركبة الأوتوماتيكية – غيار الوقوف (P) ).",
        "الهاندبريك محلول وعصا الغيارات في الغيار الأول والكلاتش مضغوط.",
        "الهاندبريك محلول وعصا الغيارات في وضع نيوترال (N) (وفي المركبة الأوتوماتيكية –(N) ) والكلاتش مضغوط.",
        "الهاندبريك مسحوب وعصا الغيارات في الغيار الأول(وفي المركبة الأوتوماتيكية- (D) ) والكلاتش مضغوط."
      ],
      id: 584
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0465. كيف تتصرف حسب الإشارة؟",
      numQues: "0465",
      correctAnswer: "تمهل وانتقل إلى غيار واطئ وامتنع عن الاستعمال المتواصل للفرامل.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3464.jpg",
      choices: [
        "زد السرعة في الصعود بواسطة تعشيق غيار عالي.",
        "استعمل الفرامل فقط.",
        "زد السرعة وانتقل إلى غيار عالي.",
        "تمهل وانتقل إلى غيار واطئ وامتنع عن الاستعمال المتواصل للفرامل."
      ],
      id: 585
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0527. ماذا تعني الإشارة:",
      numQues: "0527",
      correctAnswer: "ممنوع الوقوف من هذا المكان وما بعده.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3527.jpg",
      choices: [
        "نهاية حدود الطرق البلدية.",
        "مسموح الوقوف من هذا المكان وما بعده.",
        "نهاية منع التجاوز.",
        "ممنوع الوقوف من هذا المكان وما بعده."
      ],
      id: 586
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1022. ما معنى الإشارة؟",
      numQues: "1022",
      correctAnswer: "لافتة تُستخدم لجميع أنواع الإشعارات غير الملزمة. ",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31022.jpg",
      choices: [
        "إشارة للتحذير وللإرشاد وللمنع مُعدة للمركبات العمومية فقط.",
        "إشارة استعلامات على شكل مربع.",
        "إشارة إعلام ملزمة لا توجد لها إشارة في لوحة الإشارات. ",
        "لافتة تُستخدم لجميع أنواع الإشعارات غير الملزمة. "
      ],
      id: 587
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0655. مصباح الضباب الخلفي:",
      numQues: "0655",
      correctAnswer: "يعمل فقط عند الرجوع إلى الخلف.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "واجب تركيبه في الباصات فقط.",
        "يعمل بشكلٍِ أوتوماتيكي وقت الضباب.",
        "يمكن إضاءته فقط عندما تكون مصابيح المقدمة مضاءة.",
        "يعمل فقط عند الرجوع إلى الخلف."
      ],
      id: 588
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0323. على صاحب رخصة سياقة أو رخصة مركبة الذي جرى تغيير في عنوان سكنه أن يُبلغ عن التغيير خلال 15 يوماً:",
      numQues: "0323",
      correctAnswer: "لشرطة إسرائيل.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "لوزارة المواصلات.",
        "لوزارة الداخلية.",
        "للمحكمة.",
        "لشرطة إسرائيل."
      ],
      id: 589
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0203. هل يجوز إيقاف مركبة في حدود 12م من المفترق؟",
      numQues: "0203",
      correctAnswer: "مسموح بشرط أن تقف المركبة بعكس اتجاه السير.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "مسموح في شارع فيه مسلكان.",
        "مسموح إلا إذا دلت إشارة على غير ذلك.",
        "ممنوع إلا إذا سمحت بذلك سلطة الشاخصات بواسطة إشارة أو علامة مناسبة.",
        "مسموح بشرط أن تقف المركبة بعكس اتجاه السير."
      ],
      id: 590
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0821. في أية حالة علينا المحافظة على مسافة اكبر من المعتاد من المركبة التي تسير أمامنا؟",
      numQues: "0821",
      correctAnswer: "في حالة فيها مدى الرؤية مشوش أو عند السياقة في شارع ملس أو عندما نكون تعبانين.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "لا توجد حالة كهذه: مسافة الثانيتين تكفي دائماً. ",
        "عند السياقة بسرعة منخفضة في طريق بلدية.",
        "إذا كان أمامنا شاحنات ومركبات ثقيلة أخرى.",
        "في حالة فيها مدى الرؤية مشوش أو عند السياقة في شارع ملس أو عندما نكون تعبانين."
      ],
      id: 591
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0016. عرِّف 'شارع باتجاه واحد' :",
      numQues: "0016",
      correctAnswer: "كل شارع تجوز فيه حركة المركبات غير الميكانيكية باتجاه واحد فقط.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "كل شارع تجوز فيه حركة المركبات باتجاه واحد فقط.",
        "كل سبيل تجوز فيه حركة المركبات باتجاه واحد فقط. ",
        "كل شارع تجوز فيه حركة المركبات بالاتجاهين.",
        "كل شارع تجوز فيه حركة المركبات غير الميكانيكية باتجاه واحد فقط."
      ],
      id: 592
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1678. ما هو واجب التمهل حسب القانون والذي يسري على السائق؟",
      numQues: "1678",
      correctAnswer: "تخفيف سرعة المركبة - وحتى التوقف - في كل حالة يُتوقع فيها خطر.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "تخفيف سرعة السير قبل الدخول إلى طريق سريعة.",
        "تخفيف السرعة إلى سرعة معقولة قبل بداية منحدر طويل.",
        "تخفيف سرعة السير إذا كانت المركبة مليئة تماماً بالركاب. ",
        "تخفيف سرعة المركبة - وحتى التوقف - في كل حالة يُتوقع فيها خطر."
      ],
      id: 593
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0261. متى يجوز استعمال 'مصباح الرجوع إلى الخلف'؟",
      numQues: "0261",
      correctAnswer: "عند الرجوع إلى الخلف وعند تعشيق الغيار الخلفي فقط.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "عندما تكون الرؤية مشوشة لأي سبب كان.",
        "في حالة الضباب أو عند هطول الأمطار الغزيرة.",
        "عند الوقوف في مكان وقوف مسقوف.",
        "عند الرجوع إلى الخلف وعند تعشيق الغيار الخلفي فقط."
      ],
      id: 594
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0499. ما معنى الإشارة؟",
      numQues: "0499",
      correctAnswer: "لا يجوز لمركبة تجارية يزيد وزنها الإجمالي المسموح به عن 12 طن أن تتجاوز.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3499.jpg",
      choices: [
        "يجوز لمركبة تجارية وزنها الإجمالي المسموح به 14 طن على الأقل أن تتجاوز أو أن تعبر عن مركبة ميكانيكية تسير على أكثر من عجلتين.",
        "لا يجوز لمركبة تجارية يزيد وزنها الإجمالي المسموح به عن 4 طن، أن تتجاوز (مسموح تجاوز دراجة نارية).",
        "لا يجوز لأية مركبة يزيد وزنها الإجمالي المسموح به عن 8 طن، أن تتجاوز أو أن تعبر عن مركبة ميكانيكية.",
        "لا يجوز لمركبة تجارية يزيد وزنها الإجمالي المسموح به عن 12 طن أن تتجاوز."
      ],
      id: 595
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»"
      ],
      title: "0783. في أية حالة يُسمح لمركبة ركاب خصوصية أن تستدير إلى اليمين ليس من المسلك الأيمن؟",
      numQues: "0783",
      correctAnswer: "الاستدارة مسموحة للمركبات التي تزيد سرعتها عن المركبات الموجودة في المسلك الأيمن.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "مسموح عندما تكون حركة السير في الطريق خفيفة جداً.",
        "في الشارع الذي فيه أكثر من مسلك واحد موسوم (مؤشر) للاستدارة إلى اليمين.",
        "لا توجد حالة كهذه، القانون يسمح فقط للمركبة الثقيلة والطويلة بأن تستدير إلى اليمين ليس من المسلك الأيمن.",
        "الاستدارة مسموحة للمركبات التي تزيد سرعتها عن المركبات الموجودة في المسلك الأيمن."
      ],
      id: 596
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1530. عند الدخول في منعطفات وعند السير فيها، على سائق المركبة:",
      numQues: "1530",
      correctAnswer: "أن يبقى في منتصف الشارع ليضمن ثبات المركبة.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "أن يزيد من السرعة عند الدخول ويتمهل في وسط المنعطف.",
        "أن يخفف من سرعة السير.",
        "أن يزيد من السرعة لكي يضمن استدارة سهلة.",
        "أن يبقى في منتصف الشارع ليضمن ثبات المركبة."
      ],
      id: 597
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1071. لماذا يجب ملاءمة وضع جلوس السائق قبل البدء بسياقة المركبة؟",
      numQues: "1071",
      correctAnswer: "من اجل منع آلام في الأرجل والمتسببة من جراء الجلوس المتواصل في مقعد السائق.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "لا توجد حاجة لأية ملاءمة، ملاءمة الجلوس المريح مطلوبة فقط للنساء الحوامل.",
        "من اجل السيطرة جيداً على وسائل التشغيل في المركبة ولتحسين مدى الرؤية.",
        "من اجل الوصول بسهولة أكثر لجهاز الراديو أو للهاتف الخيلوي أثناء السياقة.",
        "من اجل منع آلام في الأرجل والمتسببة من جراء الجلوس المتواصل في مقعد السائق."
      ],
      id: 598
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1036. ما معنى الإشارة؟",
      numQues: "1036",
      correctAnswer: "نهاية المنطقة التي يُمنع فيها وقوف المركبات التجارية.",
      pubDate: "10-11-2011 08:22:50",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31036.jpg",
      choices: [
        "نهاية منطقة طرق بلدية.",
        "نهاية المكان أو المقطع الذي يُسمح فيه الوقوف على الشارع أو على الرصيف.",
        "نهاية منطقة طرق ليست بلدية.",
        "نهاية المنطقة التي يُمنع فيها وقوف المركبات التجارية."
      ],
      id: 599
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "0994. ما هو إقفال العجلات في المركبة؟",
      numQues: "0994",
      correctAnswer: "تثبيت جهاز على احد عجلات المركبة من اجل منع تحركها عند وقوفها في منحدر شديد جداً.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "إقفال احد عجلات المركبة من قِبل السلطة المختصة وفقاً لأحكام القانون.",
        "توقف دوران عجلات المركبة أثناء السير بسبب فرملة قوية ومتواصلة.",
        "منع دوران عجل المركبة عند فك البراغي التي تمسكه.",
        "تثبيت جهاز على احد عجلات المركبة من اجل منع تحركها عند وقوفها في منحدر شديد جداً."
      ],
      id: 600
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1169. لمن يتوجه سائق الصالون العمومي عندما يُصاب العداد في مركبته بخلل؟",
      numQues: "1169",
      correctAnswer: "لمقدم خدمة معتمد لتصليح العداد.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "لسلطة الترخيص.",
        "لصاحب الصالون العمومي.",
        "لكراج مناسب.",
        "لمقدم خدمة معتمد لتصليح العداد."
      ],
      id: 601
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1322. أية مركبة ميكانيكية يجوز لها نقل حاوية (كونتينر)؟",
      numQues: "1322",
      correctAnswer: "مركبة تجارية وزنها الإجمالي المسموح به أكثر من 15000كغم - في طريق ليست بلدية فقط.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "مركبة العمل المرخصة لنقل حاويات. ",
        "مركبة ميكانيكية تجارية وزنها الإجمالي المسموح به 16000كغم أو أكثر.",
        "مركبة تجارية وزنها الإجمالي المسموح به 15000كغم - في طريق بلدية فقط.",
        "مركبة تجارية وزنها الإجمالي المسموح به أكثر من 15000كغم - في طريق ليست بلدية فقط."
      ],
      id: 602
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1685. إذا انقضت مدة السنتين 'للسائق الجديد' ، لا تصدر له رخصة سواقة عادية إذا أُدين بمخالفة:",
      numQues: "1685",
      correctAnswer: "سياقة مركبة ميكانيكية مع شهادة تأمين مؤقتة.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "السير بسرعة زائدة عن السرعة المسموح بها في القانون.",
        "عدم وضع لافتة 'سائق جديد' على الزجاج الخلفي للمركبة.",
        "عدم التوقف في مكان نُصبت فيه إشارة تحذير 'مكان خطر'.",
        "سياقة مركبة ميكانيكية مع شهادة تأمين مؤقتة."
      ],
      id: 603
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0853. كيف يمكن تقليل مشكلة مسافات التوقف في نطاق أضواء المركبة عند السير في الليل؟",
      numQues: "0853",
      correctAnswer: "بواسطة استعمال ضوء الضباب الخلفي والذي يقوي نور الضوء.",
      pubDate: "10-11-2011 08:22:50",
      img: "",
      choices: [
        "بواسطة مسلاط (كشاف) إضافي لتحديد العوائق في الطريق.",
        "بواسطة ملاءمة سرعة السير لمدى الرؤية في كل وقت.",
        "بواسطة إضاءة الضوء العالي الذي ينير لمسافة ، والسير بسرعة عالية مناسبة.",
        "بواسطة استعمال ضوء الضباب الخلفي والذي يقوي نور الضوء."
      ],
      id: 604
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0363. ما هو المشترك بين الإشارتين اللتين أمامك؟",
      numQues: "0363",
      correctAnswer: "تُنصب الإشارة رقم: 101 دائماً قبل مكان نصب الإشارة رقم: 144 .",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3363.jpg",
      choices: [
        "تُنصب الإشارة رقم: 144 دائماً قبل مكان نصب الإشارة رقم: 101 .",
        "الإشارتان تابعتان لمجموعة إشارات الاستعلامات ويُحذران من وضع الشارع.",
        "توصي كلاهما السائق بأن يخفف من سرعة سيره ويزيد من انتباهه.",
        "تُنصب الإشارة رقم: 101 دائماً قبل مكان نصب الإشارة رقم: 144 ."
      ],
      id: 605
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0886. في مركبة هجين:",
      numQues: "0886",
      correctAnswer: "تتآكل الإطارات أكثر من المركبة العادية بسبب المحرك الثاني.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "استهلاك الوقود أكثر من مركبة عادية بسبب المحرك الثاني.",
        "استهلاك الوقود اقل من مركبة عادية.",
        "الفرملة أصعب بسبب المحرك الثاني.",
        "تتآكل الإطارات أكثر من المركبة العادية بسبب المحرك الثاني."
      ],
      id: 606
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0880. إذا أُغلق مسلك سيرك من قِبل المركبة الفضية الواقفة وقوفاً مزدوجاً (مؤشر عليها بدائرة)، ماذا يجب عليك أن تعمل؟",
      numQues: "0880",
      correctAnswer: "توقف خلف المركبة الفضية وانتظر وصول شرطي أو مفتش.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3880.jpg",
      choices: [
        "تمهل ودع المركبة القادمة من الجهة المقابلة بأن تمر بدون إعاقة قبل أن تتجاوز الوقوف المزدوج.",
        "أعطِ إشارة للمركبة القادمة من الجهة المقابلة بواسطة مصابيح المقدمة وانحرف إلى المسلك المعاكس – بسرعة قبل أن تصل.",
        "تجاوز المركبة الفضية في المسافة الناتجة بينها وبين المركبة القادمة من الجهة المقابلة.",
        "توقف خلف المركبة الفضية وانتظر وصول شرطي أو مفتش."
      ],
      id: 607
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1352. يجب تثبيت لوحات عاكسة لغايات السلامة على الجانب الخلفي للمقطورة أو للمستندة، بناءً على ذلك أية جملة من الجمل التالية صحيحة؟",
      numQues: "1352",
      correctAnswer: "في المركبة التي يبلغ عرضها أكثر من 150سم يجب تركيب لوحتين بحيث يكون الإطار بلون احمر والباقي باللون الأصفر.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "في المركبة التي يبلغ عرضها أكثر من 200سم، يجب تركيب ثلاثة لوحات حمراء/صفراء.",
        "تثبيت اللوحات يجب أن يكون فقط حسب طلب سلطة الترخيص ووفقاً لتعليمات كبير الفاحصين.",
        "يجب تثبيت لوحة واحدة بحجم 30سم×60سم في مركز الجانب الخلفي. ",
        "في المركبة التي يبلغ عرضها أكثر من 150سم يجب تركيب لوحتين بحيث يكون الإطار بلون احمر والباقي باللون الأصفر."
      ],
      id: 608
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1521. ما هو الطول الإجمالي الأقصى المسموح به لمركبة شاحنة تجر مقطورة؟",
      numQues: "1521",
      correctAnswer: "14م.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "18.75م.",
        "16م.",
        "12.75م.",
        "14م."
      ],
      id: 609
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1194. ما هي العملية التي يجب على السائق القيام بها قبل بدء السير في الباص؟",
      numQues: "1194",
      correctAnswer: "تشغيل الغماز الذي باتجاه الشارع.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "تشغيل الباص وتشغيل الغماز الأيمن.",
        "إيقاف عمل المحرك وتشغيل الغماز الأيسر.",
        "إطفاء جهاز الراديو للتمكين من التركيز الأقصى.",
        "تشغيل الغماز الذي باتجاه الشارع."
      ],
      id: 610
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0687. عند إيقاف مركبة يجب استعمال فرامل الوقوف (الهاندبريك):",
      numQues: "0687",
      correctAnswer: "دائماً.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "فقط عند إيقاف مركبة في منحدر شديد.",
        "فقط في شارع رطب (مبلول).",
        "فقط عند إيقاف مركبة في صعود.",
        "دائماً."
      ],
      id: 611
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0823. ممنوع البدء بالتجاوز بدون التأكد:",
      numQues: "0823",
      correctAnswer: "هل هو مسموح؟ هل يمكن إكماله بأمان دون أي شك؟",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "هل يوجد حاشية بجانب الشارع؟",
        "هل يُغطي التأمين الإصابة والضرر إذا وقع حادث طرق؟",
        "ما هي غرامة مخالفة التجاوز الممنوع؟",
        "هل هو مسموح؟ هل يمكن إكماله بأمان دون أي شك؟"
      ],
      id: 612
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1167. تعرفة السفر رقم '1' في عداد الصالون العمومي هي:",
      numQues: "1167",
      correctAnswer: "تعرفة النهار من الساعة 05:30 ولغاية الساعة 21:00 .",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "تعرفة النهار من الساعة 05:30 ولغاية الساعة 22:00 .",
        "تعرفة النهار من الساعة 07:30 ولغاية الساعة 20:00 .",
        "تعرفة النهار من الساعة 06:30 ولغاية الساعة 21:00 .",
        "تعرفة النهار من الساعة 05:30 ولغاية الساعة 21:00 ."
      ],
      id: 613
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0895. حسب الصورة التي أمامك، ما الذي أدى إلى التشويش في مدى الرؤية؟",
      numQues: "0895",
      correctAnswer: "الضباب هو المسبب في التشويش في مدى الرؤية.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3895.jpg",
      choices: [
        "التشويش الظاهر في الصورة لا يمكن منعه ولا توجد أهمية لماذا تسبب.",
        "التشويش في مدى الرؤية تسبب نتيجة لبهر النظر من مركبة أخرى تسير في المقابل.",
        "التشويش تسبب من المسافة الصغيرة أكثر من اللازم بين المركبات.",
        "الضباب هو المسبب في التشويش في مدى الرؤية."
      ],
      id: 614
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1003. كيف يعمل جهاز مراقبة الثبات الالكتروني 'إي.إس.بي' (E.S.P) في الحالات الخطرة للسياقة؟",
      numQues: "1003",
      correctAnswer: "يفحص ضغط الهواء في الإطارات ويُشغل فرامل اليد من اجل تخفيف سرعة المركبة.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "يتحكم في قوة المحرك فقط.",
        "يتحكم في عجلة المقود.",
        "يُشغل الفرامل على كل عجل على انفراد ويتحكم في قوة المحرك.",
        "يفحص ضغط الهواء في الإطارات ويُشغل فرامل اليد من اجل تخفيف سرعة المركبة."
      ],
      id: 615
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1794. الوزن الإجمالي لباص صغير (أوتوبوس زعير):",
      numQues: "1794",
      correctAnswer: "لا يجب أن يكون أكثر من 6000كغم.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "غير محدد في القانون.",
        "لا يجب أن يكون أكثر من 4000كغم.",
        "لا يجب أن يكون أكثر من 5000كغم.",
        "لا يجب أن يكون أكثر من 6000كغم."
      ],
      id: 616
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0904. المركبة القادمة من الجهة المقابلة (1) بدأت تستدير إلى اليسار، ما هو رد فعلك؟",
      numQues: "0904",
      correctAnswer: "ابقَ على السرعة الأصلية واعبر عن المركبة التي استدارت (1).",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3904.jpg",
      choices: [
        "تمهل واستعد للتوقف ودع المركبة البيضاء (1)، الموجودة في المفترق، تكمل الاستدارة.",
        "استعمل الزامور لتنبيه السائق واستمر بنفس السرعة في مسلكك. ",
        "استدر إلى اليمين أو إلى اليسار لكي تتجنب حادث.",
        "ابقَ على السرعة الأصلية واعبر عن المركبة التي استدارت (1)."
      ],
      id: 617
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1019. ماذا يتوجب عليك فحصه عندما لا تضيء لامبة في مصابيح المركبة؟",
      numQues: "1019",
      correctAnswer: "صلاحية مفتاح تشغيل الأضواء.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "سلامة عدسة المصباح.",
        "صلاحية اللامبة وصلاحية الفيوز الموصل لها.",
        "الجهد الكهربائي للبطارية.",
        "صلاحية مفتاح تشغيل الأضواء."
      ],
      id: 618
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0517. ما هو الطول الإجمالي المسموح به في القانون للباص الذي يظهر في الصورة؟",
      numQues: "0517",
      correctAnswer: "13.5م",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3517.jpg",
      choices: [
        "18.5م",
        "11م",
        "12م",
        "13.5م"
      ],
      id: 619
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0109. ماذا يجب عليك فحصه قبل بدء الاستدارة إلى اليمين؟",
      numQues: "0109",
      correctAnswer: "أن لا تكون هناك مركبة تسير من جهتي اليسرى.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "أن لا تكون هناك مركبة تسير من جهتي اليمنى.",
        "توجيه صحيح للمرآة اليسرى.",
        "أن لا تكون هناك أية مركبة واقفة في الجهة اليسرى للطريق.",
        "أن لا تكون هناك مركبة تسير من جهتي اليسرى."
      ],
      id: 620
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0352. في أية مركبات يجب أن توجد مطفأة حريق؟",
      numQues: "0352",
      correctAnswer: "في كل مركبة ركاب خصوصية.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "في كل مركبة وزنها الإجمالي لغاية 3500كغم",
        "في كل مركبة ميكانيكية ما عدا المركبة الخصوصية والتراكتور والدراجة النارية ذات العجلتين وذات الثلاث عجلات.",
        "في التراكتور.",
        "في كل مركبة ركاب خصوصية."
      ],
      id: 621
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1757. في مقطع شارع باتجاهين فيه مسلك واحد في كل اتجاه، ويفصل بين المسلكين خط أبيض فاصل متواصل مزدوج:",
      numQues: "1757",
      correctAnswer: "ممنوع التوقف والوقوف حتى على حاشية الطريق.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "مسموح التوقف للباص فقط.",
        "لا يوجد تحديد على التوقف والوقوف إلا إذا نُصبت إشارة مناسبة.",
        "مسموح التوقف والوقوف بموازاة الرصيف فقط.",
        "ممنوع التوقف والوقوف حتى على حاشية الطريق."
      ],
      id: 622
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0193. هل يجوز توقف أو وقوف مركبة على الشارع أو على حاشية طريق داخل المدن؟",
      numQues: "0193",
      correctAnswer: "مسموح دائماً.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3896.jpg",
      choices: [
        "مسموح، إذا لم يكن هناك أي منع في القانون أو في إشارة وإذا لا يؤدي ذلك إلى إعاقة حركة السير. ",
        "ممنوع الوقوف على حاشية الطريق في جميع الأحوال.",
        "مسموح بشرط أن تكون المركبة تحت المراقبة.",
        "مسموح دائماً."
      ],
      id: 623
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1613. يُمنع نقل راكب أضافي في الدراجة النارية إلا إذا:",
      numQues: "1613",
      correctAnswer: "ذُكر ذلك في شهادة التأمين.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "ذُكر ذلك في رخصة المركبة.",
        "تم منح إذن بذلك من مستورد المركبة.",
        "تم منح إذن بذلك من منتج المركبة.",
        "ذُكر ذلك في شهادة التأمين."
      ],
      id: 624
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1658. ما هو الجلوس الصحيح لراكب إضافي على الدراجة النارية؟",
      numQues: "1658",
      correctAnswer: "يجلس الراكب على مقعد منتظم وقدماه مرتكزتان على ساندات الرجلين على جانبي الدراجة النارية وماسكاً بالمقبض المخصص أو بالسائق.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "يجلس الراكب خلف السائق منحنياً إلى الأمام ويمسك بخزان الوقود.",
        "يجلس الراكب على مقعد منتظم والجسم منتصب إلى الخلف ويمسك الحمالة المثبتة في القسم الخلفي من الدراجة النارية.",
        "يجلس الراكب أمام السائق والجسم منحنياً إلى الأمام ويمسك بخزان الوقود أو بمقود الدراجة (الكيدون).",
        "يجلس الراكب على مقعد منتظم وقدماه مرتكزتان على ساندات الرجلين على جانبي الدراجة النارية وماسكاً بالمقبض المخصص أو بالسائق."
      ],
      id: 625
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0698. هل يجب عليك إعطاء حق الأولوية لراكب الدراجة الهوائية؟",
      numQues: "0698",
      correctAnswer: "كلا، لا يُعطى حق الأولوية للدراجات الهوائية.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3698.jpg",
      choices: [
        "كلا، لأن حق الأولوية للمركبة التي تواصل سيرها بخط مستقيم.",
        "كلا، المركبة غير الميكانيكية تعطي حق الأولوية للمركبة الميكانيكية.",
        "نعم، لأن راكب الدراجة الهوائية (1) قادم من اليمين.",
        "كلا، لا يُعطى حق الأولوية للدراجات الهوائية."
      ],
      id: 626
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0728. أية مركبة من بين الثلاث مركبات غير موجودة في المسلك الصحيح حسب الإشارة؟",
      numQues: "0728",
      correctAnswer: "المركبات الثلاث تسير حسب القانون.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3728.jpg",
      choices: [
        "مركبة إطفاء الحريق (2).",
        "المركبة التجارية (التندر) الزرقاء (3).",
        "المركبة ذات اللون الفاتح (الخصوصية) (1).",
        "المركبات الثلاث تسير حسب القانون."
      ],
      id: 627
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0436. ما معنى الإشارة ؟",
      numQues: "0436",
      correctAnswer: "أمامك طريق بدون مخرج، ممنوع الدخول إلى هذه الطريق.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3436.jpg",
      choices: [
        "مفترق تفرع طرق له ثلاثة اذرع، مسموح الاستدارة إلى الطريق الجانبية.",
        "هناك واجب بالتوقف في جميع الأحوال وإعطاء حق الأولوية لحركة السير المندمجة من اليمين ومن اليسار.",
        "أمامك اندماج مع شارع من يسارك، أعطِ حق الأولوية ولا تستدر إلى اليسار.",
        "أمامك طريق بدون مخرج، ممنوع الدخول إلى هذه الطريق."
      ],
      id: 628
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1196. هل يجب على سائق الباص في خط الخدمة أن ينقل كل راكب؟",
      numQues: "1196",
      correctAnswer: "نعم، فقط في ساعات النهار.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "كلا، بشرط أن يشرح سبب الرفض.",
        "نعم، إذا لم يكن هناك أي تحديد قانوني آخر.",
        "كلا، أما إذا رفض الراكب التعريف على شخصيته فمسموح رفض نقله.",
        "نعم، فقط في ساعات النهار."
      ],
      id: 629
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0893. سائق يقترب من ممر للمشاة موسوم (مؤشر) على الشارع وعلى الممر لا يوجد مشاة، لذلك على السائق:",
      numQues: "0893",
      correctAnswer: "الإسراع والعبور قبل أن يصل المشاة.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "التمهل والتأكد من عدم وجود مشاة على وشك العبور.",
        "استعمال الزامور والإسراع وعبور ممر المشاة بسرعة.",
        "عبور ممر المشاة بسرعة ولا توجد ضرورة للتمهل.",
        "الإسراع والعبور قبل أن يصل المشاة."
      ],
      id: 630
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0870. ملاءمة صحيحة لمقعد السائق:",
      numQues: "0870",
      correctAnswer: "هي عملية مهمة يجب عملها عند كل صيانة دورية للمركبة.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "تُمكن من الرؤية المريحة للطريق وسياقة سهلة ومريحة وغير متعبة.",
        "تتم من قبل منتج المركبة أثناء إنتاجها ولا توجد ضرورة بملاءمة إضافية للمقعد.",
        "ملاءمة مقعد السائق تمكن إلغاء 'المساحة الميتة' عند الرجوع إلى الخلف.",
        "هي عملية مهمة يجب عملها عند كل صيانة دورية للمركبة."
      ],
      id: 631
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0871. ما الإجراء المهم الذي يجب اتخاذه قبل الضغط على دعسة الفرامل عند كل تمهل أو توقف؟",
      numQues: "0871",
      correctAnswer: "الضغط على دعسة الكلاتش من اجل تقليل استهلاك وقود المحرك.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "إعطاء الإشارة وإدارة المقود نحو حاشية الطريق لمنع التصادم من الخلف.",
        "رفع الرجل عن دعسة الوقود والانتقال إلى غيار أوطأ.",
        "إلقاء نظرة في المرايا للتأكد من عدم وجود مركبة في الخلف. ",
        "الضغط على دعسة الكلاتش من اجل تقليل استهلاك وقود المحرك."
      ],
      id: 632
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1055. كيف يتصرف سائق المركبة عندما يكتشف أثناء السير وجود خلل في سلامة المقود أو الفرامل؟",
      numQues: "1055",
      correctAnswer: "يستمر بالسير بحذر حتى الكراج القريب.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "يحدد مصدر المشكلة ويحاول التغلب عليها أثناء السير.",
        "إذا كان مصدر الخلل في جهاز الإشعال أو الوقود - يتوقف عن السير، وإذا لم يكن كذلك – يستمر بالسير.",
        "يتوقف فوراً عن سياقة المركبة.",
        "يستمر بالسير بحذر حتى الكراج القريب."
      ],
      id: 633
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1484. أثناء التجاوز أو المرور عن مركبة أخرى:",
      numQues: "1484",
      correctAnswer: "يجب السير بنفس سرعة المركبة التي نتجاوزها. ",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "يجب السير بسرعة 10كم/ساعة اقل من سرعة المركبة التي نتجاوزها.",
        "يُمنع السير بسرعة تزيد عن السرعة القصوى المسموح بها.",
        "مسموح تجاوز السرعة القصوى المسموح بها للحظة – إذا اقتضت الحاجة.",
        "يجب السير بنفس سرعة المركبة التي نتجاوزها. "
      ],
      id: 634
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1664. لا يسوق احد تراكتور أُلحقت به مجرورة وزنها الإجمالي أكثر من 4000كغم:",
      numQues: "1664",
      correctAnswer: "إلا بعد انقضاء 3 أشهر من تاريخ صدور رخصة سياقة التراكتور له.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "إلا بعد انقضاء 6 أشهر من تاريخ صدور رخصة سياقة التراكتور له.",
        "إلا بعد انقضاء سنة من تاريخ صدور رخصة سياقة التراكتور له.",
        "فقط بعد أن أنهى بنجاح دورة استكمالية في السياقة الصحيحة.",
        "إلا بعد انقضاء 3 أشهر من تاريخ صدور رخصة سياقة التراكتور له."
      ],
      id: 635
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1618. ماذا تسبب فرملة قوية أثناء الانعطاف بالدراجة النارية؟",
      numQues: "1618",
      correctAnswer: "سرعة أعلى للدراجة النارية.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "تزحلق العجلة الأمامية.",
        "تزحلق العجلة الخلفية.",
        "ارتفاع العجلة الأمامية في الهواء.",
        "سرعة أعلى للدراجة النارية."
      ],
      id: 636
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1198. أية أماكن معدة للمعاقين في باص يعمل على خط خدمة؟",
      numQues: "1198",
      correctAnswer: "المقعدين في الصف الثاني من جهة السائق اليمنى.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "جميع المقاعد في المقعد الطويل الخلفي في الباص.",
        "المكان المجاور لمخرج الباص.",
        "مكان واحد أو اثنين موسومين (معلمين) والمجاورين لمدخل الباص.",
        "المقعدين في الصف الثاني من جهة السائق اليمنى."
      ],
      id: 637
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0460. كيف يجب التصرف من مكان نصب الإشارة ولغاية ما بعد خط السكة؟",
      numQues: "0460",
      correctAnswer: "التمهل، والتأكد من إمكانية عبور خط السكة بالسير المتواصل وبدون تأخير. لا تتوقف على السكة. ",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3459.jpg",
      choices: [
        "اعبر خط السكة بسرعة.",
        "تمهل وقف قبل السكة إلى أن يعبر القطار.",
        "قف وانتظر أوامر الشخص الموجه بواسطة إشارة أو علم.",
        "التمهل، والتأكد من إمكانية عبور خط السكة بالسير المتواصل وبدون تأخير. لا تتوقف على السكة. "
      ],
      id: 638
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0773. تم وسم (تأشير) أربعة أمكنة وقوف متواصلة للمعاقين في شارع هرتسل، وجميع هذه الأمكنة خالية الآن:",
      numQues: "0773",
      correctAnswer: "لمركبة لا تحمل لاصق وقوف كما في الإشارة يسمح وقوفها في موقف المعاقين للحظة إذا بقي السائق في المركبة أثناء الوقوف",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3216.jpg",
      choices: [
        "لمركبة لا تحمل لاصق وقوف كما في الإشارة لا يجوز لها الوقوف في مكان وقوف المعاقين حتى وإن كانت الأمكنة المعدة للمعاقين خالية جميعها. ",
        "لمركبة لا تحمل لاصق وقوف كما في الإشارة يُسمح وقوفها لوقت قصير في موقف المعاقين بشرط أن يترك رقم هاتف للاتصال في أي وقت.. ",
        "لمركبة لا تحمل لاصق وقوف كما في الإشارة يسمح وقوفها في موقف المعاقين طالما كان نصف الأمكنة المعدة للمعاقين خالية.",
        "لمركبة لا تحمل لاصق وقوف كما في الإشارة يسمح وقوفها في موقف المعاقين للحظة إذا بقي السائق في المركبة أثناء الوقوف"
      ],
      id: 639
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0132. أكمل الجملة – عند اقترابك من مكان عبور المشاة:",
      numQues: "0132",
      correctAnswer: "مسموح لك التجاوز في شارع باتجاهين.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3132.jpg",
      choices: [
        "مسموح لك التجاوز إذا لم يكن هناك مشاة على مكان عبور المشاة.",
        "لا تتجاوز ولا تحاول تجاوز مركبة أخرى موجودة قبل مكان العبور.",
        "مسموح لك التجاوز قبل مكان عبور المشاة في طريق داخل المدن فقط.",
        "مسموح لك التجاوز في شارع باتجاهين."
      ],
      id: 640
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0699. أنت تسوق المركبة رقم (3)، لمن تُعطي حق الأولوية؟",
      numQues: "0699",
      correctAnswer: "لراكب الدراجة النارية (1) ولراكب الدراجة الهوائية (2).",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3699.jpg",
      choices: [
        "لا لأحد، لك حق الأولوية في الطريق المستقيمة (3).",
        "لراكب الدراجة النارية فقط (1).",
        "لراكب الدراجة الهوائية فقط (2).",
        "لراكب الدراجة النارية (1) ولراكب الدراجة الهوائية (2)."
      ],
      id: 641
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1239. هل يجوز لسائق الصالون العمومي التدخين أثناء السير ؟",
      numQues: "1239",
      correctAnswer: "نعم، في سفرة خاصة فقط.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "كلا.",
        "نعم، بشرط أن يوافق جميع الركاب على ذلك.",
        "نعم، بشرط أن لا يعمل مكيف الهواء والنوافذ مفتوحة.",
        "نعم، في سفرة خاصة فقط."
      ],
      id: 642
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0006. يجوز لضابط الشرطة سحب رخصة السياقة لمدة 30 يوماً:",
      numQues: "0006",
      correctAnswer: "إذا ارتكب السائق مخالفة انتهاء سريان مفعول رخصة سياقته قبل 10 أيام أو أكثر. ",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "إذا صدرت مذكرة اعتقال لصاحب المركبة.",
        "إذا ارتكب السائق مخالفة التسبب في خطر لأحد المشاة على ممر المشاة.",
        "إذا ارتكب السائق مخالفة السماح لمن يجلس بجانبه بعدم استعمال حزام الأمان.",
        "إذا ارتكب السائق مخالفة انتهاء سريان مفعول رخصة سياقته قبل 10 أيام أو أكثر. "
      ],
      id: 643
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1735. أنت تقترب من مفترق بدون إشارات، وتنوي الاستدارة إلى اليمين، ومن أمامك تقترب مركبة من المفترق، كيف تتصرف؟",
      numQues: "1735",
      correctAnswer: "توقف وأعطِ حق الأولوية للمركبة المقتربة.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "توقف في جميع الحالات.",
        "تستمر بالسير بحذر وتستدير إلى اليمين في المفترق.",
        "تمهل ، وإذا اقتضت الضرورة توقف لكي تعطي حق الأولوية.",
        "توقف وأعطِ حق الأولوية للمركبة المقتربة."
      ],
      id: 644
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1436. يُمنع إيقاف مركبة ووقوفها في الطريق إذا كان عرض المركبة أكثر من:",
      numQues: "1436",
      correctAnswer: "2.25م.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "4.80م.",
        "2.50م.",
        "2.10م.",
        "2.25م."
      ],
      id: 645
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0631. ما معنى الإشارة؟",
      numQues: "0631",
      correctAnswer: "ممنوع الوقوف على مسافة تزيد عن 30سم من الرصيف.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3631.jpg",
      choices: [
        "نهاية منطقة السرعة 30كم/ساعة.",
        "منطقة تباطؤ حركة السير( منطقة تمهل).",
        "ممنوع السير بسرعة تقل عن 30كم/ساعة.",
        "ممنوع الوقوف على مسافة تزيد عن 30سم من الرصيف."
      ],
      id: 646
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0772. من اجل إكمال التجاوز بأمان، على من يقوم بالتجاوز:",
      numQues: "0772",
      correctAnswer: "أن يبدأ بالتجاوز فقط إذا كانت الطريق خالية لمسافة كافية وأن يتأكد أثناء التجاوز بأن الطريق خالية.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "أن يتجاوز فقط إذا كانت هناك إشارة تسمح بالتجاوز.",
        "أن يتجاوز دائماً بسرعة منخفضة وبصبر.",
        "أن يتجاوز بسرعة تزيد عن السرعة المسموحة من اجل إخلاء الشارع.",
        "أن يبدأ بالتجاوز فقط إذا كانت الطريق خالية لمسافة كافية وأن يتأكد أثناء التجاوز بأن الطريق خالية."
      ],
      id: 647
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0528. ماذا تعني الإشارة؟",
      numQues: "0528",
      correctAnswer: "مسموح دخول المركبة المستعملة في تلك الساعة في تعليم السياقة.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3528.jpg",
      choices: [
        "ممنوع الدخول للسائقين الجدد.",
        "مسموح فقط دخول مركبة تسير على عجلتين والمستعملة في تعليم السياقة فيها.",
        "منطقة يمنع فيها دخول المركبة المستعملة في تلك الساعة في تعليم السياقة.",
        "مسموح دخول المركبة المستعملة في تلك الساعة في تعليم السياقة."
      ],
      id: 648
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0009. ما هي عقوبة من يسوق مركبة بالرغم من أن رخصة سياقته مسحوبة؟",
      numQues: "0009",
      correctAnswer: "لغاية 3 سنوات سجن، إضافة إلى أية عقوبات أخرى.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "6 سنوات سجن فعلي إضافة إلى سنتين مع وقف التنفيذ.",
        "غرامة مالية مقدارها 80,000 شيكل.",
        "يُعفى من العقوبة إذا ابرز رخصة سياقة سارية المفعول خلال 7 أيام.",
        "لغاية 3 سنوات سجن، إضافة إلى أية عقوبات أخرى."
      ],
      id: 649
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0900. أية مركبة من الظاهرتين في الصورة واقفة بشكلٍ غير صحيح؟",
      numQues: "0900",
      correctAnswer: "كلاهما غير واقفتين حسب المطلوب في القانون.",
      pubDate: "10-11-2011 08:22:51",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3900.jpg",
      choices: [
        "المركبة الواقفة وممر المشاة خلفها.",
        "المركبة الواقفة وممر المشاة أمامها.",
        "المركبتان واقفتان حسب القانون.",
        "كلاهما غير واقفتين حسب المطلوب في القانون."
      ],
      id: 650
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0096. ما هي شروط نقل راكب في التراكتورون إضافة إلى السائق ؟",
      numQues: "0096",
      correctAnswer: "بدون شروط وبدون تحديد.",
      pubDate: "10-11-2011 08:22:51",
      img: "",
      choices: [
        "بشرط أن يكون عمر السائق 21 سنة أو أكثر.",
        "إذا كان هناك إذن من سلطة الترخيص بذلك ومسجل في رخصة المركبة.",
        "في التراكتورون الزراعي فقط.",
        "بدون شروط وبدون تحديد."
      ],
      id: 651
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1160. من يُعفى من أجرة السفر في الصالون العمومي في خط خدمة؟",
      numQues: "1160",
      correctAnswer: "لا يُعفى أي شخص، لكن يدفع كل ثلاثة أولاد ثمن بطاقة واحدة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "كل ولد عمره اقل من خمس سنوات، معفى من الدفع.",
        "ولد واحد لم يتم الخامسة من عمره وبصحبة شخص بالغ.",
        "لا يُعفى أي شخص، الإعفاء يُمنح للسفر في الباصات فقط.",
        "لا يُعفى أي شخص، لكن يدفع كل ثلاثة أولاد ثمن بطاقة واحدة."
      ],
      id: 652
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1049. انحراف غير إرادي (سحب) للمقود لجهة معينة أثناء السياقة، ممكن أن يكون سببه:",
      numQues: "1049",
      correctAnswer: "خلل في محرك المركبة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "ضغط هواء منخفض في احد العجلات الأمامية.",
        "خلل في جهاز الفرامل فقط.",
        "ضغط هواء منخفض في العجلتين الخلفيتين.",
        "خلل في محرك المركبة."
      ],
      id: 653
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0254. في أية حالات يجب على سائق المركبة الميكانيكية 'خفت الأضواء'؟",
      numQues: "0254",
      correctAnswer: "إذا كانت المركبة التي تسير خلفه تستدير إلى اليمين.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "إذا كان يسير في منحدر شديد وطويل.",
        "إذا كان يسير نحو مركبة أخرى تسير في نفس الطريق أو في طريق مجاورة.",
        "إذا كانت المركبة المقابلة تستدير إلى اليمين.",
        "إذا كانت المركبة التي تسير خلفه تستدير إلى اليمين."
      ],
      id: 654
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1814. 123",
      numQues: "814 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [],
      id: 655
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0898. أنت تسوق المركبة المقتربة من خلف راكب الدراجة الهوائية الذي في الصورة، ما هو الخطر المتوقع من راكب الدراجة الهوائية ؟",
      numQues: "0898",
      correctAnswer: "لا يوجد خطر، اعبر بسرعة عن راكب الدراجة الهوائية.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3898.jpg",
      choices: [
        "راكب الدراجة الهوائية يستعمل الرصيف، لذلك لا تُشكل الدراجة الهوائية أي خطر.",
        "قد ينزل راكب الدراجة الهوائية إلى الشارع أو يتعثر ويقع على الشارع.",
        "راكب الدراجة الهوائية هو شخص بالغ ولا يوجد أي خطر متوقع منه.",
        "لا يوجد خطر، اعبر بسرعة عن راكب الدراجة الهوائية."
      ],
      id: 656
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1742. الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) مسموحة:",
      numQues: "1742",
      correctAnswer: "فقط في مفترق بدون إشارة ضوئية (رمزور).",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "فقط في مفترق مع إشارة ضوئية (رمزور).",
        "من أي مسلك إلا إذا كانت هناك إشارة تمنع ذلك.",
        "إذا كان هناك خط ابيض متواصل.",
        "فقط في مفترق بدون إشارة ضوئية (رمزور)."
      ],
      id: 657
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0710. كيف تتصرف (مركبة رقم 3) في المفترق الذي أمامك؟",
      numQues: "0710",
      correctAnswer: "من يصل المفترق أولاً يدخله.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3710.jpg",
      choices: [
        "لك (3) حق الأولوية بالنسبة للمركبات الأخرى.",
        "أعطِ حق الأولوية للمركبة الحمراء (2)",
        "أعطِ حق الأولوية لراكب الدراجة النارية (1) . ",
        "من يصل المفترق أولاً يدخله."
      ],
      id: 658
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1349. ما هي 'المركبة التجارية':",
      numQues: "1349",
      correctAnswer: "كل مركبة تنقل ركاب أو أية حمولة كانت.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "كل مركبة تنقل أية حمولة كانت.",
        "المركبة المستعملة في نقل البضائع وأيضاً في نقل الركاب بالأجرة.",
        "المركبة المستعملة أو المعدة للاستعمال في نقل البضائع مقابل أجرة أو لعمل صاحب المركبة.",
        "كل مركبة تنقل ركاب أو أية حمولة كانت."
      ],
      id: 659
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1294. يجوز للشرطي أن يوقف مركبة من اجل الفحص بسبب:",
      numQues: "1294",
      correctAnswer: "انحراف غير مسيطر عليه للمركبة عن مسلكها.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "رغبته بالتأكد من أن استهلاك الوقود في المركبة يتلاءم مع بيانات منتج المركبة.",
        "مستوى تلوث الهواء المنبعث من محرك المركبة.",
        "رغبته بالتأكد من أن استهلاك الزيت في المركبة يتلاءم مع بيانات منتج المركبة.",
        "انحراف غير مسيطر عليه للمركبة عن مسلكها."
      ],
      id: 660
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1690. ماذا يجب على السائق فحصه بعد عبوره حفرة ماء عميقة في الشارع؟",
      numQues: "1690",
      correctAnswer: "إذا كان جهاز الإنارة يعمل كالمطلوب.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "سلامة عمل محرك المركبة.",
        "لا توجد ضرورة لأي فحص كان.",
        "إذا كان جهاز الفرامل يعمل كالمطلوب.",
        "إذا كان جهاز الإنارة يعمل كالمطلوب."
      ],
      id: 661
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0854. كيف يمكن تقليل مشكلة بهر النظر من المركبة القادمة من الجهة المقابلة؟",
      numQues: "0854",
      correctAnswer: "بواسطة التعيير الصحيح لمصابيح المقدمة وإضاءة الضوء المتقطع للسائق المقابل.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "بواسطة توجيه المرايا الداخلية لوضع 'الليل'.",
        "بواسطة تشغيل ماسحات الزجاج (المسحات).",
        "بواسطة الامتناع عن النظر إلى الضوء الذي يبهر النظر وبواسطة التمهل والسير على يمين الطريق.",
        "بواسطة التعيير الصحيح لمصابيح المقدمة وإضاءة الضوء المتقطع للسائق المقابل."
      ],
      id: 662
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0100. هل هناك واجب باستخدام حزام الأمان في تراكتور حمولة ؟",
      numQues: "0100",
      correctAnswer: "كلا، لا يوجد واجب باستخدام حزام الأمان.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "نعم، لكن الواجب مفروض على السائق وعلى الركاب في طريق ترابية فقط.",
        "نعم، هناك واجب على السائق وعلى جميع الركاب في جميع الطرق.",
        "نعم، هناك واجب على السائق وعلى جميع الركاب في طريق ليست بلدية فقط.",
        "كلا، لا يوجد واجب باستخدام حزام الأمان."
      ],
      id: 663
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0952. حسب ما يظهر في الصورة، هناك ظروف سياقة صعبة، ما هي هذه الظروف؟",
      numQues: "0952",
      correctAnswer: "الشارع رطب (مبلول) والرؤية غير واضحة وازدحام في حركة السير.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3952.jpg",
      choices: [
        "من الصعب مشاهدة الإشارات بسبب الحالة الجوية.",
        "لا توجد أية مشكلة، فضغط حركة السير الموجود في المفترق لا يلزمنا بالانتباه أكثر من اللازم.",
        "هناك كاميرا مثبته في المفترق، لذلك سوف يتم ضبط من يعبر بالضوء الأحمر.",
        "الشارع رطب (مبلول) والرؤية غير واضحة وازدحام في حركة السير."
      ],
      id: 664
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1472. يُسمح بوقوف باص يعمل على خط خدمة، ليس لأجل اصعاد/إنزال الركاب:",
      numQues: "1472",
      correctAnswer: "في كل مكان، حسب طلب الركاب.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "في كل موقف عمومي.",
        "حسب المسجل في رخصة الخط، إذا تم تحديد ذلك من قِبل 'السلطة'.",
        "في كل محطة باص.",
        "في كل مكان، حسب طلب الركاب."
      ],
      id: 665
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0300. ما هو حكم سائق مركبة يرفض بأن يُفحص 'فحص ثمل' (فحص نسبة الكحول في الدم) حسب طلب الشرطي؟",
      numQues: "0300",
      correctAnswer: "يُعتبر وكأنه ساق في حالة ثمل (سكران).",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "حرمانه فعلياً من حيازة رخصة السياقة لمدة سنتين على الأقل وسحب مع وقف التنفيذ إلى الأبد.",
        "يُشترط استمرار حيازته الرخصة بإجراء فحص الثمل.",
        "حرمانه فعلياً من حيازة رخصة السياقة لمدة 5 سنوات على الأقل.",
        "يُعتبر وكأنه ساق في حالة ثمل (سكران)."
      ],
      id: 666
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0619. يجب على من يسوق 'مركبة سياحية' أن يكون صاحب رخصة سياقة من نوع:",
      numQues: "0619",
      correctAnswer: "C1 أو B .",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "B أو C .",
        "D1 أو D .",
        "A أو B .",
        "C1 أو B ."
      ],
      id: 667
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1279. حسب القانون، المستندة (التي هي قسم من 'المركبة المترابطة':",
      numQues: "1279",
      correctAnswer: "ملزمة بشريطين عاكسين مسجل عليهما 'حافظ على مسافة'.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "ملزمة بلاصقات وأيضاً بشريطين على الجانب الخلفي للمستندة.",
        "ملزمة بلاصقات على الجانب الخلفي للمستندة.",
        "ملزمة بشريطين على الجانب الخلفي للمستندة. ",
        "ملزمة بشريطين عاكسين مسجل عليهما 'حافظ على مسافة'."
      ],
      id: 668
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1065. ما هو جهاز التوجيه ( شاشه التوجيه لأماكن ) 'جي.بي.أس' (GPS) في المركبة؟",
      numQues: "1065",
      correctAnswer: "جهاز يقيس استهلاك الوقود في المركبة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "جهاز يفحص صلاحية الأجهزة المحوسبة في المركبة.",
        "جهاز يزود معلومات عن مكان تواجد المركبة ويساعد السائق في الوصول إلى هدفه.",
        "جهاز ثانوي داخل جهاز المقود والذي يزيد من المقود.",
        "جهاز يقيس استهلاك الوقود في المركبة."
      ],
      id: 669
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1353. كيف توسم (تؤشر) مركبة تجارية وزنها الإجمالي أكثر من 7500كغم؟",
      numQues: "1353",
      correctAnswer: "بأربعة خطوط عاكسة، 2 عموديين و 2 أفقيين.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "بخطين عاكسين على الطمبون الخلفي.",
        "بلوحتين عاكستين من الخلف.",
        "لا يوجد واجب بالوسم (بالتأشير) بعاكس للمركبة التي لا يوجد لها جانب خلفي.",
        "بأربعة خطوط عاكسة، 2 عموديين و 2 أفقيين."
      ],
      id: 670
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0764. متى يُسمح بالوقوف على يسار الشارع؟",
      numQues: "0764",
      correctAnswer: "في كل شارع، بشرط أن يتم الانحراف إلى اليسار بحذر.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "فقط في شارع باتجاه واحد بشرط أن لا يكون قسماً من طريق مقسمة بواسطة مساحة فاصلة.",
        "في كل طريق بلدية.",
        "في كل شارع باتجاه واحد.",
        "في كل شارع، بشرط أن يتم الانحراف إلى اليسار بحذر."
      ],
      id: 671
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1736. على من تقع المسؤولية عن مركبة واقفة في مكان يُمنع فيه الوقوف؟",
      numQues: "1736",
      correctAnswer: "على الأخير الذي خرج من المركبة الواقفة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "على شركة التأجير إذا كانت المركبة مستأجرة منها.",
        "على صاحب المركبة المسجل في رخصة المركبة، إلا إذا اثبت انه لم يكن السائق ويذكر من كان يسوقها وارتكب المخالفة.",
        "على صاحب المركبة المسجل في رخصة المركبة، وليس مهماً من ساق المركبة حين ارتكاب المخالفة.",
        "على الأخير الذي خرج من المركبة الواقفة."
      ],
      id: 672
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0287. يسري واجب تشغيل مخفف السرعة، في المنحدر، في الحالات التالية:",
      numQues: "0287",
      correctAnswer: "إذا نُصبت في الطريق شاخصة تُحذر من خطر التزحلق.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "إذا كانت المركبة مجهزة بمخفف سرعة وفي الطريق المنصوب فيها شاخصة تُحذر من منحدر خطر.",
        "إذا رُكب في المركبة مخفف سرعة فيسري واجب استعماله في كل سفرة حتى في الطريق المستوية.",
        "إذا كانت نسبة الانحدار أكثر من 6% وطول المنحدر أكثر من كيلومتر واحد.",
        "إذا نُصبت في الطريق شاخصة تُحذر من خطر التزحلق."
      ],
      id: 673
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1173. ما هو عدد الركاب الأقصى المسموح لسائق صالون عمومي نقله في الصالون العمومي؟",
      numQues: "1173",
      correctAnswer: "12، إضافةً إلى سائق الصالون العمومي.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "15 ما عدا السائق.",
        "عدد الركاب المذكور في رخصة المركبة.",
        "لا يوجد تحديد على عدد الركاب الذين يجوز له نقلهم.",
        "12، إضافةً إلى سائق الصالون العمومي."
      ],
      id: 674
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0917. كيف تتصرف حسب الصورة؟",
      numQues: "0917",
      correctAnswer: "استعمل الزامور بشدة لتنبيه الماشي من اجل أن يخلي الشارع بسرعة واستمر بالسير كالمعتاد.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3917.jpg",
      choices: [
        "تمهل واستعد للتوقف ودع الماشي يخلي الشارع بدون أي خطر.",
        "اسرع واجتز الماشي.",
        "الماشي لا يعبر على ممر المشاة، أشر له بأية طريقة لكي يخلي الشارع بسرعة.",
        "استعمل الزامور بشدة لتنبيه الماشي من اجل أن يخلي الشارع بسرعة واستمر بالسير كالمعتاد."
      ],
      id: 675
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1625. هل المجرورة الزراعية ملزمة بمثلث تحذير؟",
      numQues: "1625",
      correctAnswer: "فقط المجرورة الصغيرة ذات وزن إجمالي لغاية 500كغم.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "فقط المجرورة ذات وزن إجمالي لغاية 4000كغم.",
        "كلا.",
        "نعم.",
        "فقط المجرورة الصغيرة ذات وزن إجمالي لغاية 500كغم."
      ],
      id: 676
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0023. ما هو 'ممر المشاة' :",
      numQues: "0023",
      correctAnswer: "قسم من الشارع مؤشر ومُعد لعبور المشاة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "قسم من حاشية الطريق ووُسم بأنه معد لعبور المشاة.",
        "قسم من الرصيف ووُسم بأنه معد لعبور المشاة.",
        "قسم من الطريق معد لعبور المشاة بما في ذلك الرصيف.",
        "قسم من الشارع مؤشر ومُعد لعبور المشاة."
      ],
      id: 677
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0828. أنت تسير في شارع باتجاه واحد وفيه مسلكان، وتحاول تجاوز مركبة تسير أمامك، الخطر الأساسي في الانحراف إلى اليسار هو:",
      numQues: "0828",
      correctAnswer: "عرقلة المركبة التي تسير في المسلك الأيسر.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "عرقلة المركبة التي تسير خلفك في نفس مسلكك.",
        "يمكن أن تأتي من المسلك الذي على اليسار مركبة تسير بالاتجاه المعاكس.",
        "اختراق الخط الفاصل المتواصل.",
        "عرقلة المركبة التي تسير في المسلك الأيسر."
      ],
      id: 678
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0468. ما معنى الإشارة؟",
      numQues: "0468",
      correctAnswer: "أمامك مكان لعبور المشاة.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3468.jpg",
      choices: [
        "سبيل للمشاة.",
        "أولاد بالقرب من المكان.",
        "مكان عبور للأولاد فقط.",
        "أمامك مكان لعبور المشاة."
      ],
      id: 679
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1775. لمن الصلاحية في سحب رخصة سياقة؟",
      numQues: "1775",
      correctAnswer: "لسلطة الترخيص وللمحكمة ولشرطة إسرائيل.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "للمحكمة ولشرطة إسرائيل فقط.",
        "للمحكمة ولشرطة إسرائيل وللمؤسسة الطبية للسلامة على الطرق.",
        "لسلطة الترخيص وللمحكمة فقط.",
        "لسلطة الترخيص وللمحكمة ولشرطة إسرائيل."
      ],
      id: 680
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0331. لمن يجوز سياقة 'مركبة امن' أو 'مركبة تخليص (ونش)'؟",
      numQues: "0331",
      correctAnswer: "من حصل على إذن من كبير مفوضي الاطفائية.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "من حصل على تصريح بذلك من سلطة الترخيص.",
        "من حصل على رخصة من وزارة الدفاع.",
        "من حصل على إذن من وزارة الصحة.",
        "من حصل على إذن من كبير مفوضي الاطفائية."
      ],
      id: 681
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0944. كيف تتصرف حسب الظاهر في الصورة؟",
      numQues: "0944",
      correctAnswer: "انتقل إلى المسلك الأيسر لأن المسلك الأيمن سوف ينتهي بعد مسافة قصيرة.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3944.jpg",
      choices: [
        "تابع السير العادي وانتبه للمركبات الأخرى التي في اتجاه سيرك.",
        "تمهل ودع المركبات يعبروا عن يسارك بسرعة للاندماج في المسلك الأيسر.",
        "سر في المسلك الأيمن واستعد للانتقال إلى المسلك الأيسر عندما يزداد عدد المسالك.",
        "انتقل إلى المسلك الأيسر لأن المسلك الأيمن سوف ينتهي بعد مسافة قصيرة."
      ],
      id: 682
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0714. أنت تقود المركبة رقم (2)،كيف تتصرف في هذا الوضع؟",
      numQues: "0714",
      correctAnswer: "استمر في سيرك (2) - أنت تسير في طريق رئيسية.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3714.jpg",
      choices: [
        "ادخل المفترق مع المركبة الحمراء سويةً.",
        "استمر في السير كالمعتاد - المركبة الحمراء (1) تستدير إلى اليسار لذلك عليه إعطاؤك حق الأولوية.",
        "أعطِ حق الأولوية للمركبة الحمراء (1).",
        "استمر في سيرك (2) - أنت تسير في طريق رئيسية."
      ],
      id: 683
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0053. كيف يجب الاحتفاظ بوثائق السائق وبوثائق المركبة أثناء السياقة؟",
      numQues: "0053",
      correctAnswer: "يجب أن تكون في حالة نظيفة وقابلة للقراءة في أي وقت وفي المركبة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "لا توجد أحكام واضحة في القانون.",
        "يكفي أن تكون نظيفة من أية بقعة، مع صورة واضحة.",
        "يجب الاحتفاظ بها في البيت، في حالة نظيفة وقابلة للقراءة.",
        "يجب أن تكون في حالة نظيفة وقابلة للقراءة في أي وقت وفي المركبة."
      ],
      id: 684
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1774. متى يُسمح بإضاءة مصابيح الضباب؟",
      numQues: "1774",
      correctAnswer: "فقط في الشتاء.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "فقط عند هطول الأمطار الغزيرة وفي الضباب أو عند تساقط الثلوج.",
        "فقط في ساعات الظلام.",
        "عندما يعتقد السائق بأنه من الجيد إضاءة مصابيح الضباب.",
        "فقط في الشتاء."
      ],
      id: 685
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1455. من مُلزم برخصة ناقل؟",
      numQues: "1455",
      correctAnswer: "كل من يقدم خدمة نقل في مركبة تجارية وزنها الإجمالي 10000كغم أو أكثر.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "كل من يقدم خدمة نقل في مركبة تجارية وزنها الإجمالي 8000كغم أو اقل.",
        "كل مركبة تجارية.",
        "كل من يملك أكثر من خمس مركبات مستعملة لنقل الركاب.",
        "كل من يقدم خدمة نقل في مركبة تجارية وزنها الإجمالي 10000كغم أو أكثر."
      ],
      id: 686
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0672. كيف تتصرف عندما يضيء الضوء الأصفر المتقطع في الإشارة الضوئية (الرمزور)؟",
      numQues: "0672",
      correctAnswer: "توقف دائماً قبل ممر المشاة، حتى ولو لم يكن احد على الممر.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3672.jpg",
      choices: [
        "تقدم بحذر ومكن الماشي من عبور الشارع بأمان.",
        "تجاهل الإشارة الضوئية (الرمزور) فهي مخصصة للمشاة فقط.",
        "توقف ولا تواصل السير حتى ينطفئ الضوء الأصفر المتقطع في الإشارة الضوئية (الرمزور). ",
        "توقف دائماً قبل ممر المشاة، حتى ولو لم يكن احد على الممر."
      ],
      id: 687
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1778. عند إجراء فحص الترخيص السنوي (التست) للمركبة، يُسجل في مؤسسة الترخيص (دينامومتر ) :",
      numQues: "1778",
      correctAnswer: "عدد أحزمة الأمان في المركبة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "عدد مساند الرأس في المركبة.",
        "عدد المخالفات التي تم ارتكابها في المركبة.",
        "عدد الكيلومترات الذي سارته المركبة والظاهر في مقياس الكيلومترات في المركبة.",
        "عدد أحزمة الأمان في المركبة."
      ],
      id: 688
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0434. ما معنى الإشارة؟",
      numQues: "0434",
      correctAnswer: "مفترق تقاطع طرق أمامك.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3434.jpg",
      choices: [
        "أنت تقترب من اندماج طريق جانبية من اليمين (ممنوع الاستدارة إلى الطريق الجانبية) وعلى من يسر فيها أن يعطيك حق الأولوية.",
        "أعطِ حق الأولوية لحركة السير المندمجة من اليمين.",
        "اندماج شارع فيه حق الأولوية مع طريق جانبية من اليمين (مسموح الاستدارة إلى الطريق الجانبية).",
        "مفترق تقاطع طرق أمامك."
      ],
      id: 689
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0367. أية إشارة تُحذر من مفترق أمامك نُصبت فيه إشارات ضوئية (رمزورات)؟",
      numQues: "0367",
      correctAnswer: "122",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3367.jpg",
      choices: [
        "114",
        "702",
        "705",
        "122"
      ],
      id: 690
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0543. هل يُسمح بتنفيذ استدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليمين في المكان الذي نُصبت فيه الإشارة؟",
      numQues: "0543",
      correctAnswer: "مسموح في ساعات النهار فقط.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3539.jpg",
      choices: [
        "ممنوع.",
        "مسموح ما لم تكن هناك إشارة أخرى تمنع ذلك. ",
        "مسموح حتى ولو نُصبت إشارة تمنع ذلك.",
        "مسموح في ساعات النهار فقط."
      ],
      id: 691
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1707. عندما تسير خلف شاحنة كبيرة:",
      numQues: "1707",
      correctAnswer: "إذا نُصبت إشارة 'خطر شامل'، تكون المسافة التي تحافظ عليها من الشاحنة ثلاثة أضعاف المسافة المذكورة في القانون – بسبب حجم المركبة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "حافظ على مسافة تُمكن من التوقف الآمن – القانون يُلزم بمسافة دنيا تقطعها المركبة في ثانية واحدة. ",
        "يجب أن تكون المسافة التي تحافظ عليها من الشاحنة ضعف المسافة المذكورة في القانون – بسبب حجم المركبة.",
        "حافظ على مسافة صغيرة على قدر الإمكان من المركبة التي أمامك.",
        "إذا نُصبت إشارة 'خطر شامل'، تكون المسافة التي تحافظ عليها من الشاحنة ثلاثة أضعاف المسافة المذكورة في القانون – بسبب حجم المركبة."
      ],
      id: 692
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»"
      ],
      title: "0243. كم مركبة يُسمج بجرها في نفس الوقت بواسطة مركبة ميكانيكية؟",
      numQues: "0243",
      correctAnswer: "مركبتان، إلا إذا سمحت سلطة الترخيص بغير ذلك.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "مركبتان بشرط أن لا يزيد طولهما الإجمالي عن 15,50م.",
        "مركبة واحدة فقط ولا توجد إمكانية بالسماح بأكثر من واحدة.",
        "مركبة واحدة، إلا إذا سمحت سلطة الترخيص بغير ذلك.",
        "مركبتان، إلا إذا سمحت سلطة الترخيص بغير ذلك."
      ],
      id: 693
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0084. أين تسير المركبات في طريق مقسمة بواسطة مساحة فاصلة؟",
      numQues: "0084",
      correctAnswer: "على يسار المساحة الفاصلة.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3084.jpg",
      choices: [
        "في المسلك الأيسر - في شارع فيه ثلاثة مسالك.",
        "في شارع باتجاهين - على الجهة اليسرى للشارع.",
        "على يمين المساحة الفاصلة - إلا إذا دلت إشارة على غير ذلك.",
        "على يسار المساحة الفاصلة."
      ],
      id: 694
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0209. هل يجوز إيقاف مركبة على الشارع المُقسم بواسطة خط فاصل متواصل وفيه مسلك واحد فقط في كل اتجاه؟",
      numQues: "0209",
      correctAnswer: "مسموح إذا كان عرض المسلك أكثر من 2,5م.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "مسموح في طريق داخل المدن فقط.",
        "مسموح فقط في 'وقت الإنارة'.",
        "ممنوع منعاً باتاً.",
        "مسموح إذا كان عرض المسلك أكثر من 2,5م."
      ],
      id: 695
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1564. عند السفر في الليل والمركبة التي أمامك لا تخفض الضوء العالي وتُبهر نظرك:",
      numQues: "1564",
      correctAnswer: "استمر بالسير بالضوء الواطئ وبسرعتك السابقة وفي نفس مسلك السير وبنفس السرعة.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "زد من سرعة سيرك من اجل تقليل زمن بهر النظر.",
        "تمهل، وابقَ على اليمين على قدر الإمكان – لا تنظر إلى داخل الأضواء.",
        "استعمل الضوء العالي لكي تتغلب على بهر النظر من المركبة المقابلة.",
        "استمر بالسير بالضوء الواطئ وبسرعتك السابقة وفي نفس مسلك السير وبنفس السرعة."
      ],
      id: 696
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1048. أي جهاز في المركبة من شأنه أن يتسبب في تآكل غير موحد للإطارات الأمامية في المركبة؟",
      numQues: "1048",
      correctAnswer: "جهاز تكييف الهواء.",
      pubDate: "10-11-2011 08:22:52",
      img: "",
      choices: [
        "جهاز الكهرباء.",
        "جهاز الفرامل.",
        "جهاز المقود.",
        "جهاز تكييف الهواء."
      ],
      id: 697
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0643. ما معنى الإشارة على سطح الطريق (خط اصفر)؟",
      numQues: "0643",
      correctAnswer: "مسموح الوقوف في المنطقة التي على يمين الخط - في الطريق السريعة.",
      pubDate: "10-11-2011 08:22:52",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3643.jpg",
      choices: [
        "ممنوع السير بين الخطوط الصفراء.",
        "خط يدل على حدود حافة الشارع في المكان الذي لا توجد فيه أحجار حافة.",
        "مسموح الوقوف في المنطقة التي على يسار الخط في - الطريق السريعة.",
        "مسموح الوقوف في المنطقة التي على يمين الخط - في الطريق السريعة."
      ],
      id: 698
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1045. ما هي وظيفة الفرملة المساعدة (الهاندبريك) في المركبة؟",
      numQues: "1045",
      correctAnswer: "لضمان عدم تحرك المركبة من مكانها أو عدم تدحرجها أثناء الوقوف.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "لزيادة قوة الفرملة للفرامل.",
        "التأكد من التوقف قبل الضوء الأحمر في الإشارة الضوئية (الرمزور).",
        "استعمالها يقلل من تآكل فرامل الخدمة (بريك الرجل).",
        "لضمان عدم تحرك المركبة من مكانها أو عدم تدحرجها أثناء الوقوف."
      ],
      id: 699
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1145. هل يجب أن تكون حمالة إسعاف في كل باص؟",
      numQues: "1145",
      correctAnswer: "كلا، فقط في الباص الذي يسير في سفرة سياحية أو نزهة. ",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "كلا، فقط في الباص الذي يسير في سفرة ليست بلدية.",
        "كلا، فقط في الباص الذي يسير في سفرة بلدية.",
        "كلا، فقط في كل باص صغير ينقل لغاية 20 راكب.",
        "كلا، فقط في الباص الذي يسير في سفرة سياحية أو نزهة. "
      ],
      id: 700
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0732. عند دخولك في المركبة، ماذا يتوجب عليك عمله أولاً قبل البدء بالسير؟",
      numQues: "0732",
      correctAnswer: "ملاءمة المقعد الذي بجانب السائق من اجل تمكين الراكب من الدخول بسهولة من اليمين.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "التأكد بأن فرامل اليد (الهاندبريك) مسحوبة وتوجيه مقعد السائق.",
        "تشغيل المحرك وملاءمة المقعد لسياقة آمنة.",
        "التأكد أن بحوزتك مفاتيح إضافية (سبير) للمركبة.",
        "ملاءمة المقعد الذي بجانب السائق من اجل تمكين الراكب من الدخول بسهولة من اليمين."
      ],
      id: 701
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0302. 'لا تُعتبر البيرة مشروب روحي':",
      numQues: "0302",
      correctAnswer: "غير صحيح، تأثير البيرة كغيرها من المشروبات الروحية الأخرى. ",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "صحيح، تُعتبر البيرة كمشروب روحي غير أنها لا تؤثر على السياقة إطلاقاً. ",
        "صحيح، لكن تأثير البيرة لا يشبه تأثير أي مشروب روحي آخر. ",
        "صحيح، لا تُعتبر البيرة كمشروب روحي.",
        "غير صحيح، تأثير البيرة كغيرها من المشروبات الروحية الأخرى. "
      ],
      id: 702
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0613. يتم إصعاد التلاميذ وإنزالهم من الباص المُعد لنقل التلاميذ:",
      numQues: "0613",
      correctAnswer: "من الباب الخلفي فقط.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "من الباب الأمامي الأيمن ومن الباب الخلفي.",
        "يكون دائماً بعيداً عن الرصيف.",
        "من الباب الأمامي الأيمن فقط.",
        "من الباب الخلفي فقط."
      ],
      id: 703
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1199. من المسؤول عن دخول وعن خروج الركاب من الباص؟",
      numQues: "1199",
      correctAnswer: "صاحب المركبة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "صاحب الخط.",
        "منظم الحركة.",
        "سائق الباص.",
        "صاحب المركبة."
      ],
      id: 704
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1534. كيف يتصرف سائق المركبة عندما تكون هناك رياح جانبية شديدة؟",
      numQues: "1534",
      correctAnswer: "يجب الامتناع عن السواقة في الطرق التي فيها رياح جانبية أو التوقف على الحاشية إلى أن تسكن الرياح.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "يضيء مصابيح الضباب ويستمر بالسير العادي - وخصوصاً في مركبة لها مساحة جانبية كبيرة.",
        "يزيد من سرعة السير لكي يتأثر من الرياح الجانبية لأقصر وقتٍ ممكن.",
        "يتمهل ويلائم سرعة سيرة لقدرته على السيطرة على المركبة – وخصوصاً في مركبة لها جانب مساحته كبيرة.",
        "يجب الامتناع عن السواقة في الطرق التي فيها رياح جانبية أو التوقف على الحاشية إلى أن تسكن الرياح."
      ],
      id: 705
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0508. ما معنى الإشارة؟",
      numQues: "0508",
      correctAnswer: "ممنوع دخول جميع المركبات التي يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3508.jpg",
      choices: [
        "مسموح دخول المركبات الميكانيكية التجارية والتي يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة.",
        "الدخول ممنوع فقط لمركبة ميكانيكية تجارية يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة.",
        "الدخول ممنوع فقط لمركبة عمومية يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة.",
        "ممنوع دخول جميع المركبات التي يزيد وزنها الإجمالي المسموح به عن الوزن المسجل في الإشارة."
      ],
      id: 706
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1458. على سائق الباص الصغير العمومي (أوتوبوس زعير) المُلزم باستعمال نظارات أو أدوات بصرية:",
      numQues: "1458",
      correctAnswer: "أن تكون لديه في محطة الباص نظارات أو عدسات لاصقة إضافية.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "أن يتأكد أثناء السياقة بأنه يستعمل النظارات أو العدسات اللاصقة – في ساعات الليل على الأقل.",
        "أن تكون بحوزته أثناء السياقة نظارات أو عدسات لاصقة إضافية.",
        "أن يتأكد أثناء السياقة بأنه يستعمل النظارات أو العدسات اللاصقة – في ساعات النهار على الأقل.",
        "أن تكون لديه في محطة الباص نظارات أو عدسات لاصقة إضافية."
      ],
      id: 707
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0221. كيف يتم إيقاف مركبة على الشارع؟",
      numQues: "0221",
      correctAnswer: "بشكلٍ عامودي لحافة الشارع.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "موازية لحافة الشارع وحسب التأشير.",
        "لا يوجد تحديد على كيفية إيقاف مركبة على الشارع.",
        "بشكل زاوية لا تزيد عن 30 درجة من حافة الرصيف.",
        "بشكلٍ عامودي لحافة الشارع."
      ],
      id: 708
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1289. الصيانة المنتظمة للمركبة حسب تعليمات منتج المركبة:",
      numQues: "1289",
      correctAnswer: "ضرورية فقط عند السفر كثيراً في المركبة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "تلغي الحاجة إلى امتحان الترخيص السنوي (التست).",
        "تقلل من استهلاك الوقود ومن استهلاك المركبة.",
        "غير مطلوبة على الإطلاق في المركبات الحديثة.",
        "ضرورية فقط عند السفر كثيراً في المركبة."
      ],
      id: 709
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0892. ما هي الأخطار الواجب أخذها بعين الاعتبار في الشارع الذي أمامك؟",
      numQues: "0892",
      correctAnswer: "يقوم شرطي المرور بتسجيل مخالفات للسائقين الذين أوقفوا مركباتهم على يمين الشارع.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3892.jpg",
      choices: [
        "لا يوجد أي خطر في الشارع الذي أمامك.",
        "لا تُمكن المركبات الواقفة بجانب بعضها البعض من عبور المشاة.",
        "ظهور مشاة أو أولاد بين المركبات الواقفة.",
        "يقوم شرطي المرور بتسجيل مخالفات للسائقين الذين أوقفوا مركباتهم على يمين الشارع."
      ],
      id: 710
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0756. أنت تسوق في شارع فيه مسلكان في اتجاه سيرك:",
      numQues: "0756",
      correctAnswer: "لا توجد أهمية في أي مسلك تسير طالما لا يوجد خطر على حركة السير.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "مسموح السير في المسلك الأيمن أو الأيسر حسب نوع المركبة.",
        "عليك السير في المسلك الأيمن إلا إذا إ تجاوزت مركبة أو استدرت إلى اليسار.",
        "مسموح دائماً السير في المسلك الأيسر فقط.",
        "لا توجد أهمية في أي مسلك تسير طالما لا يوجد خطر على حركة السير."
      ],
      id: 711
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1705. آنت تسوق مركبة خلف مركبة أخرى، كيف تمتنع عن الاصطدام بها؟",
      numQues: "1705",
      correctAnswer: "حافظ على مسافة كافية من المركبة التي أمامك.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "قم دائماً بتشغيل أضواء الطوارئ (الأربعة غمازات).",
        "لا يمكن منع مثل هذا الاصطدام إذا فرملت المركبة الأمامية فرملة فجائية وحادة. ",
        "سر دائماً ومصابيح المقدمة مضاءة.",
        "حافظ على مسافة كافية من المركبة التي أمامك."
      ],
      id: 712
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1264. هل يُسمح لصالون عمومي وزنه الإجمالي 2500كغم الوقوف في حدود هذه الإشارة؟",
      numQues: "1264",
      correctAnswer: "نعم بين الساعات 21:00 لغاية 05:30 أيام عُطَل الأعياد فقط.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3627.jpg",
      choices: [
        "نعم.",
        "كلا.",
        "نعم، فقط في نهاية كل أسبوع.",
        "نعم بين الساعات 21:00 لغاية 05:30 أيام عُطَل الأعياد فقط."
      ],
      id: 713
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0310. ما هو السبب في اختلاف الإشارتين اللتان أمامك بشكلهما الموحد عن باقي الإشارات؟",
      numQues: "0310",
      correctAnswer: "لأن الإشارتين أكثر أهمية من باقي الإشارات.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3310.jpg",
      choices: [
        "لكي تبرزا وتلفتا انتباه السائقين بشكلٍ اكبر.",
        "لكي يتمكن المشاة من تمييز الإشارات المنصوبة بعكس اتجاه سيرهم.",
        "لأن الإشارتين اقل أهمية من باقي الإشارات.",
        "لأن الإشارتين أكثر أهمية من باقي الإشارات."
      ],
      id: 714
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0850. كيف نمنع تزحلق المركبة على الطريق؟",
      numQues: "0850",
      correctAnswer: "بواسطة الضغط بشدة وبشكلٍ متواصل على دعسة الفرامل.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "السير بسرعة معقولة والاستعمال الصحيح والمراقب للفرامل.",
        "بواسطة مسك المقود بشدة بكلتا اليدين وبواسطة السير بسرعة مشابهة لسرعة المركبات الأخرى في الطريق.",
        "بواسطة إدارة المقود إلى اليمين لتثبيت المركبة.",
        "بواسطة الضغط بشدة وبشكلٍ متواصل على دعسة الفرامل."
      ],
      id: 715
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0810. ما هي 'مسافة التوقف' للمركبة؟",
      numQues: "0810",
      correctAnswer: "المسافة التي تقطعها المركبة من اللحظة التي يبدأ فيها رد فعل السائق للخطر لغاية اللحظة التي يضغط فيها على دعسة الفرامل في المركبة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "المسافة التي تقطعها المركبة من اللحظة التي يشاهد فيها سائق المركبة الخطر الذي أمامه ورد فعله له ولغاية توقف المركبة.",
        "المسافة اللازمة للتوقف في سرعة معينة.",
        "المسافة التي تقطعها المركبة من بداية الفرملة ولغاية توقف المركبة.",
        "المسافة التي تقطعها المركبة من اللحظة التي يبدأ فيها رد فعل السائق للخطر لغاية اللحظة التي يضغط فيها على دعسة الفرامل في المركبة."
      ],
      id: 716
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1098. لماذا يستعمل ناقل القوة 'بي.تي.أو' (PTO) في التراكتور؟",
      numQues: "1098",
      correctAnswer: "لتشغيل أجهزة ومعدات إضافية تُشغل بواسطة التراكتور.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "لتشغيل المحور الأمامي في التراكتورات ذوات الدفع المزدوج.",
        "لجر معدات خاصة تحتاج إلى مساندة ذكية وسلسة. ",
        "لتشغيل مضخة زيت الجهاز الهيدراولي.",
        "لتشغيل أجهزة ومعدات إضافية تُشغل بواسطة التراكتور."
      ],
      id: 717
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0733. ما هو ترتيب العمليات التي على السائق عملها قبل التمهل؟",
      numQues: "0733",
      correctAnswer: "إدارة الرأس إلى الخلف والضغط على الفرامل للتمهل وإلقاء نظرة في المرايا في النهاية.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "النظر في المرايا ورفع الرجل عن دعسة الوقود واستعمال الفرامل أو الغيارات.",
        "الإشارة إلى السائق الخلفي باليد والنظر في المرايا لرؤية رد فعله والتمهل.",
        "الضغط بشدة على دعسة الفرامل من اجل إشعار السائق الخلفي على بدء التمهل.",
        "إدارة الرأس إلى الخلف والضغط على الفرامل للتمهل وإلقاء نظرة في المرايا في النهاية."
      ],
      id: 718
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0350. شارع باتجاه واحد هو:",
      numQues: "0350",
      correctAnswer: "طريق بدون مخرج.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "شارع حركة السير فيه مسموحة باتجاه واحد لجميع أنواع المركبات وبالاتجاه المعاكس للمركبات العمومية فقط.",
        "طريق فيها مسلك واحد فقط.",
        "شارع حركة السير فيه مسموحة باتجاه واحد فقط.",
        "طريق بدون مخرج."
      ],
      id: 719
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0073. هل يجوز سياقة مركبة غير صالحة للسير؟",
      numQues: "0073",
      correctAnswer: "مسموح، إذا كان الخلل في جهاز الإنارة فقط.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "مسموح، إذا كان الخلل ليس في جهاز الفرامل.",
        "مسموح، إذا كان الخلل في جهاز القيادة فقط.",
        "ممنوع سياقة مركبة غير صالحة للسير والتي لا يمكن السيطرة عليها بالكامل.",
        "مسموح، إذا كان الخلل في جهاز الإنارة فقط."
      ],
      id: 720
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1726. العمر الأدنى للحصول على رخصة سياقة مركبة عمومية هو:",
      numQues: "1726",
      correctAnswer: "23 سنة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "21 سنة.",
        "20 سنة.",
        "22 سنة.",
        "23 سنة."
      ],
      id: 721
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1318. أنت تسوق في شارع باتجاه واحد وفي المسلك الأيسر، السائق في المسلك الأيمن الذي أمامك تمهل بسبب ماشي بدأ بالعبور من اليمين إلى اليسار وأنت قريب من ممر المشاة، لذلك:",
      numQues: "1318",
      correctAnswer: "تمهل ومكن الماشي من إكمال عبوره.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "استعمل الزامور ونبه الماشي واعبر بسرعة قبله.",
        "أسرع واعبر ممر المشاة بسرعة قبل قدوم الماشي.",
        "استمر بالسير كالمعتاد: على الماشي أن يتأكد بأن لا يعرضك للخطر وأن لا يعيقك.",
        "تمهل ومكن الماشي من إكمال عبوره."
      ],
      id: 722
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0617. ما معنى الإشارة؟",
      numQues: "0617",
      correctAnswer: "سبيل للدراجات الهوائية فقط.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3577.jpg",
      choices: [
        "مسلك خاص للدراجات النارية وللدراجات الهوائية فقط.",
        "أيها السائق انتبه ! دراجات هوائية في الطريق.",
        "ممنوع دخول الدراجات الهوائية.",
        "سبيل للدراجات الهوائية فقط."
      ],
      id: 723
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1122. هل يُسمح بإيقاف باص معد لنقل 16 راكب أو اقل في مكان وقوف لمركبات من نوع آخر؟",
      numQues: "1122",
      correctAnswer: "مسموح ولكن فقط بواسطة بطاقة وقوف خاصة للمركبات العمومية.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "ممنوع.",
        "مسموح فقط في المحطة المركزية التي تُشغل خط الخدمة.",
        "مسموح، إذا لم تُنصب إشارة تشير إلى غير ذلك.",
        "مسموح ولكن فقط بواسطة بطاقة وقوف خاصة للمركبات العمومية."
      ],
      id: 724
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1329. متى يجب الحصول على إذن 'ضابط الشرطة' لنقل حمولة مرتفعة؟",
      numQues: "1329",
      correctAnswer: "في مركبة وزنها 1.5 طن وارتفاع حمولتها أكثر من 2.50م. ",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "في مركبة تجارية وزنها أكثر من 4 طن.",
        "في مركبة تجارية وزنها الإجمالي المسموح به لغاية 15000كغم وارتفاع حمولتها عن سطح الطريق أكثر عن 4م.",
        "في مركبة تجارية وزنها الإجمالي المسموح به أكثر من 15000كغم وارتفاع حمولتها عن الطريق أكثر من 4.80م.",
        "في مركبة وزنها 1.5 طن وارتفاع حمولتها أكثر من 2.50م. "
      ],
      id: 725
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0077. متى يجب على السائق استعمال نظارات أو عدسات لاصقة ؟",
      numQues: "0077",
      correctAnswer: "إذا ذُكر في رخصة سياقته بأن عليه استعمالها أثناء السياقة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "فقط عندما يسوق في الليل وبشرط أن يكون هذا الواجب مسجلاً في رخصة سياقته.",
        "فقط عندما يسوق في وقت الإنارة وبشرط أن يكون هذا الواجب مسجلاً في رخصة سياقته.",
        "عندما يسوق في الساعات التي تكون فيها الرؤية محدودة أو عند بهر النظر.",
        "إذا ذُكر في رخصة سياقته بأن عليه استعمالها أثناء السياقة."
      ],
      id: 726
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0106. بأية شروط يُسمح بالانحراف عن خط السير؟",
      numQues: "0106",
      correctAnswer: "ممنوع الانحراف عن خط السير منعاً باتاً.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3106.jpg",
      choices: [
        "أن لا يُسبب ذلك خطر أو عرقلة لعابري الطريق.",
        "الانحراف مسموح فقط في الشارع الذي لا توجد فيه حركة سير مركبات.",
        "عند السياقة بسرعة بطيئة وتنفيذ انحراف حاد.",
        "ممنوع الانحراف عن خط السير منعاً باتاً."
      ],
      id: 727
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0455. ماذا تعني الإشارة ؟",
      numQues: "0455",
      correctAnswer: "عندما ترى أضواء القطار، توقف على مسافة 20م قبل خط السكة ولا تحاول التجاوز.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3453.jpg",
      choices: [
        "زد السرعة واعبر خط القطار بالسرعة الممكنة وأكمل التجاوز بعد الملتقى.",
        "ممنوع التجاوز من مكان نصب الإشارة ولغاية ما بعد ملتقى سكة الحديد.",
        "قف على مسافة متر واحد على الأقل من السكة لكي تفحص إذا كانت هناك مركبة أخرى لا تحاول اجتيازك.",
        "عندما ترى أضواء القطار، توقف على مسافة 20م قبل خط السكة ولا تحاول التجاوز."
      ],
      id: 728
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1446. عرف 'الطول الإجمالي':",
      numQues: "1446",
      correctAnswer: "المسافة بين طرفي الشاصي– الطرف الأمامي والطرف الخلفي.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "المسافة بين مركز المحور الخلفي الأقصى وبين مركز المحور الأمامي الأقصى.",
        "المسافة بين أقصى نقطة من مقدمة المركبة وبين أقصى نقطة من مؤخرتها.",
        "الطول الإجمالي للمركبة بين الطمبون الخلفي وبين مركز العجل الأمامي.",
        "المسافة بين طرفي الشاصي– الطرف الأمامي والطرف الخلفي."
      ],
      id: 729
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1063. عند إيقاف المركبة، يجب استعمال الفرامل المساعدة (الهاندبريك):",
      numQues: "1063",
      correctAnswer: "فقط في الشارع الرطب (المبلول).",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "دائماً.",
        "فقط عند وقوف المركبة في صعود.",
        "فقط عند وقوف المركبة في منحدر شديد.",
        "فقط في الشارع الرطب (المبلول)."
      ],
      id: 730
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0945. كيف تتصرف حسب الشاخصات الظاهرة أمامك؟",
      numQues: "0945",
      correctAnswer: "سر بشكلٍ عادي، نصب هذه الإشارات مخالف للقانون، فمن الواضح أنها لا تلزمك.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3945.jpg",
      choices: [
        "الإشارة الأخيرة هي التي تقرر، سر بسرعة 90كم/ساعة.",
        "استمر بالسير كالمعتاد وتذكر بأنه يُمنع السير بسرعة تقل عن ما هو مسجل في الإشارة.",
        "تمهل وابقَ على اليمين قبل الدخول إلى المنعطف.",
        "سر بشكلٍ عادي، نصب هذه الإشارات مخالف للقانون، فمن الواضح أنها لا تلزمك."
      ],
      id: 731
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1791. خطر تزحلق المركبة إلى الأمام يكون بالأخص:",
      numQues: "1791",
      correctAnswer: "عندما تمطر لأول مرة أو إذا كان هناك وحل أو زيت على الشارع.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "في وقت الضباب.",
        "في شارع ضيق وصعود حاد.",
        "في شارع جاف وساخن.",
        "عندما تمطر لأول مرة أو إذا كان هناك وحل أو زيت على الشارع."
      ],
      id: 732
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1102. متى يجب تشغيل قفل الباككس في التراكتور؟",
      numQues: "1102",
      correctAnswer: "عندما يتزحلق عجل واحد على سطح الطريق ولا يتقدم التراكتور.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "عندما يتوجب تنفيذ استدارة حادة في المكان وبسرعة عالية.",
        "عند جر أداة وزنها كبير أو عند سحب أداة تُصعب الوضع على التراكتور.",
        "عندما يتوجب تنفيذ استدارة حادة بسرعة منخفضة جداً.",
        "عندما يتزحلق عجل واحد على سطح الطريق ولا يتقدم التراكتور."
      ],
      id: 733
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0645. كيف يجب الاستمرار بالسير حسب الوسم (التأشير)؟",
      numQues: "0645",
      correctAnswer: "مسموح السير إلى اليسار فقط.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3644.jpg",
      choices: [
        "مسموح الاستدارة إلى اليسار من أي مسلك.",
        "مسموح السير إلى الأمام أو إلى اليسار.",
        "مسموح السير إلى اليمين فقط.",
        "مسموح السير إلى اليسار فقط."
      ],
      id: 734
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1415. ما هو 'الصندوق المتغير' (حسب أنظمة المرور)؟",
      numQues: "1415",
      correctAnswer: "منشأة تُستعمل في نقل السوائل، والتي يمكن إزالتها عن شاصي المركبة وتركها مع حمولتها أو بدونها.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "صندوق أو مسطحات تحميل معدة للتحميل والتنزيل لاستبدال الحمولات.",
        "صندوق مصنوع من الخشب ومُعد لنقل الحمضيات السائبة، والذي يمكن استبداله بصندوق آخر. ",
        "حاوية أو صندوق أو أية وسيلة أخرى لنقل البضائع، والمصممة للتحميل والتنزيل بواسطة 'رافعة متحركة'.",
        "منشأة تُستعمل في نقل السوائل، والتي يمكن إزالتها عن شاصي المركبة وتركها مع حمولتها أو بدونها."
      ],
      id: 735
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0218. ما هي العمليات التي يجب أن يقوم بها السائق بعد أن أوقف مركبته؟",
      numQues: "0218",
      correctAnswer: "إيقاف عمل المحرك ووضع مثلث تحذير وإقفال أبواب المركبة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "إيقاف عمل المحرك وإخراج المفتاح من لقمة التشغيل (السويتش) واستخدام فرامل الوقوف (الهاندبريك).",
        "وضع لاصقة الوقوف على الزجاج الأمامي من الجهة اليسرى في مكان ظاهر لعيني مفتش البلدية.",
        "إخراج المفتاح من لقمة التشغيل (السويتش) ووضع مثلث تحذير واستخدام فرامل الوقوف (الهاندبريك).",
        "إيقاف عمل المحرك ووضع مثلث تحذير وإقفال أبواب المركبة."
      ],
      id: 736
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1499. ماذا يجب على السائق التأكد منه قبل رفع المركبة لتغيير عجل؟",
      numQues: "1499",
      correctAnswer: "ضمان عدم تحرك المركبة من مكانها بجميع الوسائل المتيسرة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "أن الفرامل المساعدة (الهاندبريك) مرفوعة لغاية إنزال العجل وأن تكون محررة عند تركيب العجل الجديد. ",
        "أن الفرامل المساعدة (الهاندبريك) محررة ولغاية إنزال العجل وأن تكون مرفوعة عند تركيب العجل الجديد.",
        "أن الفرامل المساعدة (الهاندبريك) محررة ومحلولة، والمركبة بغيار واطئ طيلة زمن التغيير.",
        "ضمان عدم تحرك المركبة من مكانها بجميع الوسائل المتيسرة."
      ],
      id: 737
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1523. على سائق المركبة الذي يصل إلى جسر ضيق:",
      numQues: "1523",
      correctAnswer: "أن يعبر الجسر بالسرعة القصوى لكي يُمكن المركبة القادمة من الجهة المعاكسة من عبوره بدون تأخير.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "أن يتمهل عند اقترابه من الجسر وعند مروره عليه.",
        "أن يزيد من سرعته عند اقترابه من الجسر ويسير ببطء على الجسر – لزيادة الأمان.",
        "أن يتوقف قبل الجسر لأسباب تتعلق بالسلامة وبعدها يعبر الجسر بسرعة.",
        "أن يعبر الجسر بالسرعة القصوى لكي يُمكن المركبة القادمة من الجهة المعاكسة من عبوره بدون تأخير."
      ],
      id: 738
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0532. يسري مفعول الإشارة لغاية:",
      numQues: "0532",
      correctAnswer: "المفترق القريب المنصوب فيه إشارة ضوئية (رمزور) أو لغاية نهاية السكة الحديد فقط.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3531.jpg",
      choices: [
        "المفترق القريب أو لغاية نهاية السكة الحديد.",
        "محطة الباص القريبة.",
        "بداية طريق سريعة والمؤشر عليها بواسطة إشارة.",
        "المفترق القريب المنصوب فيه إشارة ضوئية (رمزور) أو لغاية نهاية السكة الحديد فقط."
      ],
      id: 739
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0005. هل يجوز للشرطي احتجاز سائق ارتكب مخالفة أمام عينيه بدون أمر اعتقال ؟",
      numQues: "0005",
      correctAnswer: "يجوز له فقط إذا ارتكب السائق مخالفة عرضت عابري الطريق للخطر الفعلي.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "لا يجوز له احتجاز سائق في أية حالة كانت.",
        "يجوز له بقرار من قاضي فقط.",
        "يجوز له إذا لم يقم السائق بإعطاء اسمه وعنوانه أو انه لم يبرز رخصته كما هو مطلوب.",
        "يجوز له فقط إذا ارتكب السائق مخالفة عرضت عابري الطريق للخطر الفعلي."
      ],
      id: 740
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0743. من اجل الانتقال بالغيار من وضع الوقوف (P) إلى وضع السير (R) أو (D)، في مركبة ذات صندوق غيارات أوتوماتكية:",
      numQues: "0743",
      correctAnswer: "يجب الضغط على دعسة الفرامل وعلى زر التشغيل في عصا الغيارات وتعشيق عصا الغيارات حسب وضع السير.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "يجب الضغط على دعسة الكلاتش وتعشيق عصا الغيارات.",
        "يجب الضغط على دعسة الفرامل حيث يحدث التعشيق بشكلٍ أوتوماتيكي.",
        "يجب الضغط على مفتاح (زر) التشغيل حيث يحدث التعشيق بشكلٍ أوتوماتيكي.",
        "يجب الضغط على دعسة الفرامل وعلى زر التشغيل في عصا الغيارات وتعشيق عصا الغيارات حسب وضع السير."
      ],
      id: 741
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»"
      ],
      title: "1470. ما هي الخطورة المتوقعة من سياقة مركبة موصولة أو مترابطة في شارع ملس (ناعم)؟",
      numQues: "1470",
      correctAnswer: "يتوقف عمل فرملة تخفيف السرعة.",
      pubDate: "10-11-2011 08:22:53",
      img: "",
      choices: [
        "لا تختلف المركبة الموصولة أو المركبة المترابطة عن أية مركبة أخرى ولا يكمن أي خطر كان.",
        "الدخول في وضع ״د״ (زاوية 90 درجة)، وهو وضع تكون فيه الزاوية كبيرة بين المستندة والساندة أو بين المقطورة والقاطرة من جراء التزحلق.",
        "فقدان قوة المحرك من جراء تزحلق مركبة طويلة.",
        "يتوقف عمل فرملة تخفيف السرعة."
      ],
      id: 742
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0197. هل يُسمح بإيقاف أو وقوف أو توقف مركبة في 'طريق سريعة'؟",
      numQues: "0197",
      correctAnswer: "مسموح، بشرط أن يكون عرض حاشية الطريق كافياً.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3147.jpg",
      choices: [
        "ممنوع ، ما عدا المركبات التي تسير على عجلتين.",
        "ممنوع، ما عدا المركبات العمومية.",
        "ممنوع إلا إذا كانت هناك إشارة تدل على غير ذلك.",
        "مسموح، بشرط أن يكون عرض حاشية الطريق كافياً."
      ],
      id: 743
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0422. إذا نُصبت الإشارة في الطريق التي أمامك، هل تُلزمك بإعطاء حق الأولوية؟",
      numQues: "0422",
      correctAnswer: "نعم، في المفترق المنصوبة فيه الإشارة، يُعطى حق الأولوية للمركبات القادمة من اليمين فقط.",
      pubDate: "10-11-2011 08:22:53",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3420.jpg",
      choices: [
        "كلا، فقط قواعد إعطاء حق الأولوية المنصوص عليها في القانون أو الإشارات المنصوبة في المفترق هي التي تحدد إعطاء حق الأولوية.",
        "كلا، في المفترق المنصوبة فيه الإشارة، يُعطى حق الأولوية للمركبات العمومية فقط.",
        "نعم، في المفترق المنصوبة فيه الإشارة، حق الأولوية للمركبة التي تواصل سيرها إلى الأمام.",
        "نعم، في المفترق المنصوبة فيه الإشارة، يُعطى حق الأولوية للمركبات القادمة من اليمين فقط."
      ],
      id: 744
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0969. ابتدأ سائق المركبة البيضاء بالاندماج في حركة السير، كيف تتصرف؟",
      numQues: "0969",
      correctAnswer: "خفف من سرعة سيرك، من شأنه أن يندفع إلى مسلكك.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3968.jpg",
      choices: [
        "أعطِ إشارة وانتقل إلى المسلك الأيسر.",
        "زد من سرعة سيرك.",
        "استعمل الزامور لسائق المركبة الواقفة.",
        "خفف من سرعة سيرك، من شأنه أن يندفع إلى مسلكك."
      ],
      id: 745
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1020. ماذا يمكن أن يكون السبب في ضوء متقطع سريع في لمبة إعطاء الإشارة (الغماز) التي في لوحة الساعات (التابلو) في كابينة السائق؟",
      numQues: "1020",
      correctAnswer: "تنتج هذه الظاهرة عن خلل في لوحة الساعات (التابلو).",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "جهد البطارية منخفض.",
        "مفتاح الغماز ليست في مكانها الصحيح.",
        "إحدى لامبات إعطاء الإشارة (الغماز) لا تعمل أو أنها غير صالحة.",
        "تنتج هذه الظاهرة عن خلل في لوحة الساعات (التابلو)."
      ],
      id: 746
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1536. يقترب سائق مركبة من ممر المشاة والسائق الذي أمامه توقف قبل ممر المشاة، لذلك:",
      numQues: "1536",
      correctAnswer: "يُمنع من تجاوز المركبة التي توقفت قبل الممر.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "يُسمح له بالتجاوز فقط إذا كانت هناك إشارة ضوئية على ممر المشاة.",
        "يُسمح له بتجاوز المركبة التي توقفت قبل الممر، بشرط أن يتجاوز بحذر.",
        "يُسمح لسائق المركبة تجاوز المركبة التي توقفت، لكن هذا ممنوع في وقت الإنارة. ",
        "يُمنع من تجاوز المركبة التي توقفت قبل الممر."
      ],
      id: 747
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0550. ما معنى الإشارة؟",
      numQues: "0550",
      correctAnswer: "لك حق الأولوية في الدوار الذي أمامك، اعبر الدوار من يمينه.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3550.jpg",
      choices: [
        "في المفترق الذي أمامك، مسموح فقط الاستدارة إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس).",
        "أعط حق الأولوية لحركة السير التي تقطع طريقك في الدوار واعبر الدوار من جهته اليمنى.",
        "اعبر المكان المؤشر بالإشارة من جهته اليسرى فقط.",
        "لك حق الأولوية في الدوار الذي أمامك، اعبر الدوار من يمينه."
      ],
      id: 748
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1313. ما هو الارتفاع الكلي الأقصى (عن سطح الطريق) للحمولة التي من اجل نقلها يجب الحصول على إذن من ضابط الشرطة؟",
      numQues: "1313",
      correctAnswer: "أكثر من 4.20م.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "أكثر من 4.00م.",
        "أكثر من 4.80م.",
        "أكثر من 3.80م.",
        "أكثر من 4.20م."
      ],
      id: 749
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0174. كيف تتصرف عند خروجك من ساحات أو من طريق وصول إلى بيت وتنوي الدخول إلى طريق أو عبورها؟",
      numQues: "0174",
      correctAnswer: "يجب عليك إعطاء حق الأولوية، فقط للمركبات القادمة من الجهة اليمنى.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "أعطِ حق الأولوية للمركبات التي تقترب من الشارع الذي تنوي دخوله.",
        "عند الخروج كما ذُكر تكون قواعد إعطاء حق الأولوية مشابهة للقواعد المتبعة في المفترق.",
        "أعطِ حق الأولوية للمركبات التي تبتعد عن الشارع الذي تنوي دخوله.",
        "يجب عليك إعطاء حق الأولوية، فقط للمركبات القادمة من الجهة اليمنى."
      ],
      id: 750
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1471. ما هي السرعة القصوى المسموح بها في طريق ليست بلدية بدون مساحة فاصلة مبنية، لمركبة تجارية وزنها الإجمالي المسموح به لغاية 3.5طن (إذا لم تُنصب إشارة تدل على خلاف ذلك)؟",
      numQues: "1471",
      correctAnswer: "70كم/ساعة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "90كم/ساعة.",
        "60كم/ساعة.",
        "80كم/ساعة.",
        "70كم/ساعة."
      ],
      id: 751
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1288. تقليل استهلاك الوقود في المركبة ممكن:",
      numQues: "1288",
      correctAnswer: "بواسطة السياقة بسرعة عالية على قدر الإمكان والتقليل من زيادة الوزن في المركبة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "السياقة بسرعة بطيئة على قدر الإمكان والتقليل من زيادة الوزن في المركبة والسير بغيار نيوترال في المنحدرات. ",
        "بواسطة السياقة المعتدلة والسياقة بالسرعة المسموحة والسياقة بأوطأ غيار.",
        "بواسطة السياقة المعتدلة دون تجاوز السرعة القصوى المسموح بها والحرص على ضغط هواء صحيح في الإطارات. ",
        "بواسطة السياقة بسرعة عالية على قدر الإمكان والتقليل من زيادة الوزن في المركبة."
      ],
      id: 752
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1737. أشِر إلى الجملة الصحيحة:",
      numQues: "1737",
      correctAnswer: "مسموح وقوف مركبة على ممر المشاة في طريق ليست بلدية فقط.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "ممنوع وقوف مركبة في حدود 20م قبل ممر المشاة و 20م بعده. ",
        "ممنوع وقوف مركبة على ممر المشاة وفي حدود 12م قبله.",
        "ممنوع وقوف مركبة على ممر المشاة وفي حدود 20م قبله.",
        "مسموح وقوف مركبة على ممر المشاة في طريق ليست بلدية فقط."
      ],
      id: 753
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1041. كيف نقلل من استهلاك الوقود في المركبة؟",
      numQues: "1041",
      correctAnswer: "نزيد على قدر الإمكان من التسريع الشديد للمحرك.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "نملأ في المركبة وقود نسبة الاوكتان فيه اقل من المطلوب.",
        "نحرص على السير بأوطأ غيار.",
        "نلائم الغيار لوضع الطريق ونمتنع عن التسريع الشديد للمحرك.",
        "نزيد على قدر الإمكان من التسريع الشديد للمحرك."
      ],
      id: 754
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0373. عند دخول طريق نُصبت على مدخلها الإشارة رقم: 618، أية إشارة تظهر عند الدخول من الجهة الأخرى لنفس الطريق؟",
      numQues: "0373",
      correctAnswer: "307",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3373.jpg",
      choices: [
        "308",
        "402",
        "401",
        "307"
      ],
      id: 755
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0899. كيف تتصرف في حالة دخول الشاحنة التي في الصورة إلى مسلك سيرك؟",
      numQues: "0899",
      correctAnswer: "عليك البقاء في المسلك الأيسر وزيادة السرعة.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3899.jpg",
      choices: [
        "يجب تمكينها من الدخول إلى المسلك بدون إزعاج.",
        "عليك الانتقال إلى المسلك الأيمن من اجل مواصلة سيرك.",
        "عليك زيادة سرعة سيرك ولا تدعها تدخل.",
        "عليك البقاء في المسلك الأيسر وزيادة السرعة."
      ],
      id: 756
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0897. سائق مركبة يستدير إلى اليمين وهناك مشاة يقطعون مسلك سيره على ممر المشاة، ماذا يجب عليه أن يعمل:",
      numQues: "0897",
      correctAnswer: "يتمهل، وحتى يوقف مركبته، ويدع المشاة يعبرون على ممر المشاة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "يستعمل الزامور لتنبيه المشاة ويواصل سيره إلى داخل المفترق.",
        "يواصل سيره إلى داخل المفترق بدون أية علاقة بالمشاة.",
        "يتابع السائق سيره لأن أفضلية العبور للمركبات في المفترقات، لذلك على المشاة الانتظار.",
        "يتمهل، وحتى يوقف مركبته، ويدع المشاة يعبرون على ممر المشاة."
      ],
      id: 757
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0306. هل يجوز للشرطي أن يطلب من سائق المركبة إجراء فحص دم للتأكد من وجود كحول أو مخدرات في دمه؟",
      numQues: "0306",
      correctAnswer: "كلا، لا يجوز للشرطي أن يطلب أي فحص دون أمر من المحكمة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "نعم، يجوز للشرطي أن يطلب فحص دم إذا كان لديه اشتباه معقول بأن السائق يسوق تحت تأثير الكحول أو المخدرات.",
        "كلا، لا يجوز للشرطي أن يطلب أي فحص من السائق في جميع الأحوال والأوقات.",
        "كلا، لا يجوز للشرطي أن يطلب فحص دم لتحديد نسبة الكحول أو المخدرات.",
        "كلا، لا يجوز للشرطي أن يطلب أي فحص دون أمر من المحكمة."
      ],
      id: 758
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1187. ما هو 'الزوتوبوس'؟",
      numQues: "1187",
      correctAnswer: "صالون عمومي يتراوح وزنه بين 2200كغم ولغاية 3,500كغم والمسموح له بنقل لغاية 10 ركاب.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "باص عمومي صغير وزنه لغاية 2000كغم.",
        "باص خصوصي يسير على خط خدمة.",
        "صالون عمومي كبير وزنه 6000كغم.",
        "صالون عمومي يتراوح وزنه بين 2200كغم ولغاية 3,500كغم والمسموح له بنقل لغاية 10 ركاب."
      ],
      id: 759
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0971. كيف يجب عليك التصرف في أوضاع الطريق التي أمامك؟",
      numQues: "0971",
      correctAnswer: "السياقة مع مصابيح الضباب بسبب الظل على الشارع.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3971.jpg",
      choices: [
        "السير بالقرب من الخط الأبيض من اجل الاستدارة بسهولة.",
        "استعمال الزامور بسبب مدى الرؤية المسدود في المنعطف.",
        "السير بغيار واطئ مع المحافظة على يمين الشارع على قدر الإمكان.",
        "السياقة مع مصابيح الضباب بسبب الظل على الشارع."
      ],
      id: 760
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0279. متى لا يوجد واجب تبليغ مركز الشرطة عن إصابة مركبة أو ممتلكات بضرر عند عدم وجود أصحابها وقت إلحاق الضرر؟",
      numQues: "0279",
      correctAnswer: "إذا صادف وجود شرطي في مكان الحادث وتم إبلاغه بتفاصيل الحادث.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "إذا تم تبليغ شركة التأمين عن الحادث في الموعد والزمن المحددين في القانون.",
        "إذا كانت الإصابة خفيفة والضرر الذي تسبب للمركبة أو للممتلكات ليس جسيماً.",
        "إذا تم استدعاء مخمن مركبات، معتمد لهذا الغرض، من قِبل الشرطة. ",
        "إذا صادف وجود شرطي في مكان الحادث وتم إبلاغه بتفاصيل الحادث."
      ],
      id: 761
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0448. كيف تتصرف حسب الإشارة ؟",
      numQues: "0448",
      correctAnswer: "استعد لإمكانية الفرملة أو الانحراف أو التوقف بسبب الحجارة المتدحرجة.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3448.jpg",
      choices: [
        "انتقل إلى الغيار الواطئ، بسبب الانحدار الخطر.",
        "زد من السرعة لكي لا تتضرر من الحجارة المتدحرجة.",
        "توقف وسر في طريق أخرى (بديلة).",
        "استعد لإمكانية الفرملة أو الانحراف أو التوقف بسبب الحجارة المتدحرجة."
      ],
      id: 762
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0194. السائق الذي يسير في منحدر طويل في طريق ليست بلدية:",
      numQues: "0194",
      correctAnswer: "عليه السير بالغيار النيوترال.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "عليه الفرملة كل بضعة ثواني من أن لا يسير بسرعة أكثر من اللازم.",
        "عليه تعشيق غيار عالي من اجل إكمال المنحدر في زمن قصير.",
        "عليه تعشيق غيار واطئ حسب انحدار الطريق.",
        "عليه السير بالغيار النيوترال."
      ],
      id: 763
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1417. على السائق بعد أن يعبر مقطع طريق مغمور بالمياه:",
      numQues: "1417",
      correctAnswer: "مواصلة السير كالمعتاد، لأنه لا توجد علاقة بين المياه ونجاعة الفرامل. ",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "أن يفرمل فرملة فجائية قوية ويتأكد إذا كانت الفرامل تتجاوب.",
        "أن يتوقف بجانب الطريق وينتظر لحين أن يجف جهاز الفرامل تماماً.",
        "أن يسير بسرعة بطيئة جداً ويضغط بشكلٍ خفيف وبالتناوب على دعسة الفرامل إلى أن يحصل على فرملة طبيعية.",
        "مواصلة السير كالمعتاد، لأنه لا توجد علاقة بين المياه ونجاعة الفرامل. "
      ],
      id: 764
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0503. ما معنى الإشارة؟",
      numQues: "0503",
      correctAnswer: "ممنوع دخول الدراجات النارية.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3503.jpg",
      choices: [
        "ممنوع دخول جميع المركبات الميكانيكية.",
        "ممنوع دخول الدراجات الهوائية.",
        "مسموح دخول الدراجات النارية.",
        "ممنوع دخول الدراجات النارية."
      ],
      id: 765
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0067. هل يجب إطاعة مفتش بلدية والذي أُعتمد (أهل) لهذا الغرض، حتى ولو كان الأمر أو الإشارة مخالفين لإشارات السير؟",
      numQues: "0067",
      correctAnswer: "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'ممنوع الدخول'.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "نعم، الإطاعة واجبة، وبحذر شديد.",
        "كلا، لا يوجد واجب بالإطاعة.",
        "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'قف'.",
        "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'ممنوع الدخول'."
      ],
      id: 766
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0879. ما على سائق المركبة عمله عندما ينوي الاستدارة يميناً؟",
      numQues: "0879",
      correctAnswer: "يستعمل سائق المركبة الزامور ويواصل استدارته دون أية اعتبارات إضافية، واجب الحذر يسري على راكب الدراجة.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3879.jpg",
      choices: [
        "يجب على سائق المركبة تخطيط استدارته حسب القانون بدون إعارة الاهتمام لراكب الدراجة الهوائية.",
        "على سائق المركبة إيقاف مركبته قبل الاستدارة وينتظر إلى أن يعطيه راكب الدراجة الهوائية إشارة بأن يعبر.",
        "يأخذ بعين الاعتبار إمكانية تواجد راكب الدراجة الهوائية على يمينه أثناء الاستدارة، ويتخذ التدابير اللازمة لمنع إصابته.",
        "يستعمل سائق المركبة الزامور ويواصل استدارته دون أية اعتبارات إضافية، واجب الحذر يسري على راكب الدراجة."
      ],
      id: 767
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1034. متى وكيف نفحص كمية الزيت في المحرك؟",
      numQues: "1034",
      correctAnswer: "لا توجد أية ضرورة لفحص مستوى الزيت في المحرك.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "لا توجد أهمية لكيفية فحص الزيت في المحرك ولوقت فحصه.",
        "عندما يكون المحرك بارداً ومطفأ وعلى سطح مستوي.",
        "عندما يكون المحرك يعمل وساخن وعلى مسطح مستوي.",
        "لا توجد أية ضرورة لفحص مستوى الزيت في المحرك."
      ],
      id: 768
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0430. ما معنى الإشارة؟",
      numQues: "0430",
      correctAnswer: "دوار حركة سير أمامك.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3430.jpg",
      choices: [
        "على السائقين الذين يسيرون داخل الدوار إعطاؤك حق الأولوية عند دخولك الدوار.",
        "لا يوجد حق أولوية في الدوار القريب.",
        "اعبر الدوار من جهته اليسرى.",
        "دوار حركة سير أمامك."
      ],
      id: 769
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0044. قمت بإيقاف مركبتك بجانب الرصيف على يمين شارع في طريق بلدية:",
      numQues: "0044",
      correctAnswer: "عليك إضاءة مصابيح الوقوف إذا لم تكن هناك إضاءة في الشارع.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "عليك قبل الخروج منها التأكد بأن خروجك لا يزعج أي عابر طريق.",
        "عليك التأكد بأن المسافة بين المركبة والرصيف لا تزيد عن متر واحد.",
        "عليك التأكد بأن الراكب في المقعد الخلفي من اليسار قد خرج من المركبة إلى الشارع بحذر شديد.",
        "عليك إضاءة مصابيح الوقوف إذا لم تكن هناك إضاءة في الشارع."
      ],
      id: 770
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1039. ما هي أخطار السير في مركبة فيها تسرب من جهاز العادم التابع لمحرك المركبة؟",
      numQues: "1039",
      correctAnswer: "ضرر بالمركبات المجاورة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "لا يوجد خطر من السير في مركبة فيها تسرب من جهاز العادم.",
        "دخول الغازات المحروقة إلى كابينة الركاب والتسبب في الدوخان.",
        "سخونة المحرك.",
        "ضرر بالمركبات المجاورة."
      ],
      id: 771
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1684. كيف يجب استعمال السترة العاكسة إذا تعطلت المركبة في طريق ليست بلدية وقام السائق بإيقافها على الحاشية اليمنى وبدون وجود رصيف؟",
      numQues: "1684",
      correctAnswer: "جميع الإجابات صحيحة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "يُعفى السائق الذي يخرج من المركبة من واجب ارتداء السترة إذا قام راكب من ركاب المركبة بارتداء السترة وخرج من المركبة قبل السائق.",
        "على السائق الذي ينوي الخروج من المركبة ارتداء السترة العاكسة عند خروجه من المركبة.",
        "إذا وُجد في المركبة سترتان، يُسمح لشخصين بالخروج مرتدين السترة العاكسة.",
        "جميع الإجابات صحيحة."
      ],
      id: 772
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0421. كيف يجب التصرف في مقطع طريق نُصبت في الإشارة؟",
      numQues: "0421",
      correctAnswer: "اعبر المفترق بسرعة مع الانتباه للمركبات المقتربة إلى المفترق من اليمين.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3420.jpg",
      choices: [
        "تمهل وأعطِ حق الأولوية للمركبات القادمة من اليمين فقط.",
        "تمهل وتصرف حسب قواعد إعطاء حق الأولوية أو حسب الإشارات المنصوبة في المفترق.",
        "توقف قبل المفترق في جميع الأحوال واعبر عندما يكون المفترق خالي.",
        "اعبر المفترق بسرعة مع الانتباه للمركبات المقتربة إلى المفترق من اليمين."
      ],
      id: 773
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1650. يُمنع نقل راكب أضافي في التراكتور إلا إذا:",
      numQues: "1650",
      correctAnswer: "مُنح إذن بذلك من مستورد المركبة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "ذُكر ذلك في رخصة المركبة.",
        "ذُكر ذلك في شهادة التأمين.",
        "ذُكر ذلك في رخصة السياقة.",
        "مُنح إذن بذلك من مستورد المركبة."
      ],
      id: 774
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0814. ينبغي المحافظة على مسافة من المركبة التي تسير أمامك:",
      numQues: "0814",
      correctAnswer: "لمنع إصابة مقدمة أو خلف المركبة عند توقف أو تمهل المركبة التي أمامك.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "في السرعات العالية فقط وفي جو عاصف.",
        "فقط عندما يكون سائق المركبة تعباً جداً وردود فعله ليست سريعة كفاية لتلبية الحاجة.",
        "من اجل السياقة في المسلك الصحيح وبالسرعة الصحيحة.",
        "لمنع إصابة مقدمة أو خلف المركبة عند توقف أو تمهل المركبة التي أمامك."
      ],
      id: 775
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1291. قدرة السيطرة على المركبة من اجل منع حادث:",
      numQues: "1291",
      correctAnswer: "أكثر كلما كانت سرعة السفر أبطأ.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "تتحسن كلما زادت السرعة.",
        "تعتمد على حجم الإطارات.",
        "لا تعتمد على السرعة إطلاقاً.",
        "أكثر كلما كانت سرعة السفر أبطأ."
      ],
      id: 776
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1721. يستعمل سائق المركبة الفرملة المساعدة (الهاندبريك):",
      numQues: "1721",
      correctAnswer: "فقط لمساعدة السائق في بداية السير في صعود حاد.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "لضمان عدم تحرك المركبة.",
        "لزيادة قوة الفرملة لفرملة الخدمة (بريك الرجل).",
        "فقط إذا كان سائق جديد وليس لديه خبرة.",
        "فقط لمساعدة السائق في بداية السير في صعود حاد."
      ],
      id: 777
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0483. ما معنى الإشارة؟",
      numQues: "0483",
      correctAnswer: "بعد 2500م يبدأ منحدر شديد.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3483.jpg",
      choices: [
        "هناك صعود يبدأ الآن وعلى مقطع طوله 2500م.",
        "بعد 2500م يبدأ صعود خطر",
        "من هنا وعلى مقطع طوله 2500م هناك منحدر شديد.",
        "بعد 2500م يبدأ منحدر شديد."
      ],
      id: 778
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0178. كيف تتصرف عند خروجك من ساحات أو من محطة وقود أو من طريق وصول إلى بيت؟",
      numQues: "0178",
      correctAnswer: "عليك إعطاء حق الأولوية للمركبات القادمة من الجهة اليسرى فقط.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "أعطِ حق الأولوية للمركبات القريبة في الشارع الذي تنوي الدخول إليه وللمشاة على الرصيف.",
        "عند الخروج كما ذُكر، تكون قواعد إعطاء حق الأولوية مشابهة للقواعد المتبعة في المفترق.",
        "عليك إعطاء حق الأولوية للمركبات القادمة من الجهة اليمنى فقط.",
        "عليك إعطاء حق الأولوية للمركبات القادمة من الجهة اليسرى فقط."
      ],
      id: 779
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1577. متى يجب إضاءة المصابيح الأمامية في الدراجة النارية؟",
      numQues: "1577",
      correctAnswer: "فقط عند السياقة في أية طريق في الليل.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "عند السياقة في النهار وفي الليل وفي كل طريق وطيلة أيام السنة.",
        "فقط عند السياقة في وقت الإنارة.",
        "عند السياقة في أية طريق طيلة أيام السنة وفي ساعات النهار فقط.",
        "فقط عند السياقة في أية طريق في الليل."
      ],
      id: 780
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0693. أين تقف عندما يضيء الضوء الأحمر في الإشارة الضوئية (الرمزور) المنصوبة في المفترق الذي أمامك؟",
      numQues: "0693",
      correctAnswer: "بعد خط التوقف، وإذا لم يوجد خط توقف فتوقف قبل خط المفترق.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3190.jpg",
      choices: [
        "توقف دائماً في مكان فيه أفضل مدى للرؤية.",
        "قبل خط التوقف، وإذا رُسم ممر مشاة ، توقف قبل ممر المشاة وإذا لم يكن هناك خط توقف أو ممر مشاة فبجانب الإشارة القريبة منك.",
        "بعد ممر المشاة، وإذا لم يوجد ممر مشاة، ففي مكان فيه أفضل مدى للرؤية. ",
        "بعد خط التوقف، وإذا لم يوجد خط توقف فتوقف قبل خط المفترق."
      ],
      id: 781
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0097. هل يجب اعتمار (لبس) خوذة عند سياقة تراكتورون ؟",
      numQues: "0097",
      correctAnswer: "نعم، يجب على السائق وعلى كل راكب لبس خوذة أثناء السياقة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "يجب لبس خوذة إذا لم يكن للتراكتورون إطار أمان.",
        "كلا، لا يوجد واجب لبس الخوذة.",
        "يجب لبس الخوذة على الشارع فقط.",
        "نعم، يجب على السائق وعلى كل راكب لبس خوذة أثناء السياقة."
      ],
      id: 782
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0986. كيف نحصل على الفرملة، في جهاز الفرامل في المركبة؟",
      numQues: "0986",
      correctAnswer: "ينتج احتكاك بين ديسك الفرملة وبين بطانة الفرملة.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3986.jpg",
      choices: [
        "الفرملة تتسبب من جراء دوران المحرك باتجاه عكسي للاتجاه العادي له.",
        "الفرملة تتسبب من جراء الضغط الحاصل بين المحرك وبين الكلاتش.",
        "فرملة العجلات الأمامية فقط.",
        "ينتج احتكاك بين ديسك الفرملة وبين بطانة الفرملة."
      ],
      id: 783
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0336. هل يجوز لسلطة الترخيص استدعاء صاحب رخصة سياقة لدورة استكمالية في السياقة؟",
      numQues: "0336",
      correctAnswer: "نعم، يجوز لها فقط خلال سنتين من تاريخ حصوله على رخصة السياقة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "كلا، لا يجوز لها عمل ذلك.",
        "كلا، شرطة إسرائيل هي التي تأمر باستدعاء صاحب رخصة لدورة استكمالية.",
        "نعم، يجوز لها حسب القانون.",
        "نعم، يجوز لها فقط خلال سنتين من تاريخ حصوله على رخصة السياقة."
      ],
      id: 784
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0928. أية مخالفة تم ارتكابها في الصورة التي أمامك على افتراض أن المركبات صالحة للسير؟",
      numQues: "0928",
      correctAnswer: "الوقوف والتوقف بين مسلكين.",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3928.jpg",
      choices: [
        "الوقوف والتوقف على مساحة فاصلة وإعاقة حركة السير.",
        "عدم السير في المسلك المخصص لاتجاه السير. ",
        "عدم الوقوف بموازاة المساحة الفاصلة.",
        "الوقوف والتوقف بين مسلكين."
      ],
      id: 785
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0070. هل يجوز لسائق يحمل رخصة سياقة سارية المفعول لنوع معين من المركبات، أن يسوق أية مركبة من نفس النوع؟",
      numQues: "0070",
      correctAnswer: "نعم، بشرط أن تكون بحوزته شهادة من الشرطة على إلمامه بتشغيل المركبة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "نعم، بشرط أن يكون السائق ملماً بتشغيلها واستعمالها.",
        "نعم، يستطيع صاحب رخصة سياقة سارية المفعول سياقة أية مركبة بدون أي شرط.",
        "نعم، بشرط أن لا تكون قد سُجلت بحقه مخالفات سير.",
        "نعم، بشرط أن تكون بحوزته شهادة من الشرطة على إلمامه بتشغيل المركبة."
      ],
      id: 786
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1278. أية إشارة تُحذر سائق المركبة بأنه يقترب من نفق؟",
      numQues: "1278",
      correctAnswer: "138",
      pubDate: "10-11-2011 08:22:54",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31278.jpg",
      choices: [
        "127 פ.",
        "633",
        "634",
        "138"
      ],
      id: 787
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1777. هل يُسمح بتصليح مركبة في الطريق؟",
      numQues: "1777",
      correctAnswer: "فقط إذا كان التصليح يتعلق بجهاز الكهرباء.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "مسموح التصليح البسيط، بشرط أن لا يسبب ذلك عدم الراحة لعابري الطريق وأن لا تقف المركبة في المكان أكثر من 24 ساعة.",
        "مسموح تصليح مركبة في الطريق، غير انه لا يجوز إيقافها في المكان أكثر من 12 ساعة.",
        "فقط إذا كان المكان قريباً من كراج.",
        "فقط إذا كان التصليح يتعلق بجهاز الكهرباء."
      ],
      id: 788
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0276. ما هي التفاصيل التي يجب أن يعطيها السائق الذي له دخل في حادث أسفر عن إصابة أشخاص؟",
      numQues: "0276",
      correctAnswer: "لا توجد ضرورة بإعطاء أية تفاصيل إذا كانت لوحات أرقام المركبة كاملة وقابلة للقراءة.",
      pubDate: "10-11-2011 08:22:54",
      img: "",
      choices: [
        "اسمه ورقم هويته ورقم هاتفه.",
        "رقم رخصة سياقته ورقم تسجيل المركبة فقط.",
        "اسمه وعنوانه ورقم رخصة سياقته ورقم تسجيل المركبة واسم صاحبها.",
        "لا توجد ضرورة بإعطاء أية تفاصيل إذا كانت لوحات أرقام المركبة كاملة وقابلة للقراءة."
      ],
      id: 789
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1027. ضغط هواء أكثر من اللازم في الإطارات:",
      numQues: "1027",
      correctAnswer: "يُسبب في تآكل غير موحد للإطارات وتقصير عمر الإطار.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "يُصعب على السائق إدارة المقود.",
        "يُسبب في إطالة عمر الإطار وتقليل استهلاك الوقود.",
        "يُسبب في تلف سريع لعجلة المقود (الستيرينج).",
        "يُسبب في تآكل غير موحد للإطارات وتقصير عمر الإطار."
      ],
      id: 790
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1709. السياقة في الظلام وفي الضوء العالي:",
      numQues: "1709",
      correctAnswer: "لا تسبب إزعاج للسائقين الآخرين.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "من شأنها أن تسبب ضرر في شبكة الإنارة في المركبة وبالأخص لمصابيح المقدمة.",
        "يوصى بها ومرغوبة وهي غير ممنوعة في القانون على الإطلاق.",
        "من شأنها بهر نظر السائقين الآخرين.",
        "لا تسبب إزعاج للسائقين الآخرين."
      ],
      id: 791
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0637. كيف يجب التصرف عندما يكون هذا الوسم (التأشير) مُعلَم على سطح الشارع؟",
      numQues: "0637",
      correctAnswer: "مسموح التجاوز عن يسار الخط الفاصل المتواصل المزدوج بحذر شديد.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3636.jpg",
      choices: [
        "ممنوع الاستدارة إلى اليمين في الشارع.",
        "ممنوع التوقف في هذا المقطع، ما عدا حواشي الطريق.",
        "يجب السير في الجانب الأيمن من الخط الفاصل المتواصل المزدوج وعدم اختراقه.",
        "مسموح التجاوز عن يسار الخط الفاصل المتواصل المزدوج بحذر شديد."
      ],
      id: 792
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0861. ماذا يجب أن نرى في المرايا العاكسة (الجانبية) الخارجية للمركبة؟",
      numQues: "0861",
      correctAnswer: "أية مركبة متواجدة على يمين المركبة، وهي في حالة سير.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "الحافة الجانبية للمركبة والطريق من جانبي المركبة.",
        "العجل الخلفي والمساحة التي أمامه.",
        "أية مركبة متواجدة على الجانب الأيسر للمركبة وأيضاً المشاة.",
        "أية مركبة متواجدة على يمين المركبة، وهي في حالة سير."
      ],
      id: 793
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0030. من هو 'عابر الطريق' :",
      numQues: "0030",
      correctAnswer: "من يستعمل الطريق للوقوف أو للركض فقط.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "من يستعمل الطريق لغرض السفر في مركبة ميكانيكية فقط.",
        "من يستعمل الطريق للسفر أو للمشي أو للوقوف أو لأي غرضٍ آخر.",
        "من يستعمل الطريق للركوب على دراجة هوائية فقط.",
        "من يستعمل الطريق للوقوف أو للركض فقط."
      ],
      id: 794
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1640. ما هو الخطر المتوقع لسائق مركبة تسير على عجلتين عند مروره بين صفوف المركبات التي تسير قبل المفترق؟",
      numQues: "1640",
      correctAnswer: "الإصابة من قِبل مركبة تنحرف بشكلٍ فجائي عن المسلك باتجاه المسافة بين المسلكين التي تتقدم فيها المركبة التي تسير على عجلتين.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "الخطر هو أنه في رأس الصف وفي مقدمة المفترق لا يوجد مكان كافي بسبب كثرة المركبات التي تسير على عجلتين.",
        "يخيف سائقي المركبات العصبيين على أية حال.",
        "لا يوجد أي خطر متوقع، هناك دائماً حيز كافي يُمكن من مرور مركبة تسير على عجلتين بصورة مريحة وآمنة.",
        "الإصابة من قِبل مركبة تنحرف بشكلٍ فجائي عن المسلك باتجاه المسافة بين المسلكين التي تتقدم فيها المركبة التي تسير على عجلتين."
      ],
      id: 795
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0587. ما معنى الإشارة؟",
      numQues: "0587",
      correctAnswer: "شارع من اليمين بدون مخرج.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3556.jpg",
      choices: [
        "أعطِ حق الأولوية للمركبة القادمة من الجهة المقابلة والتي تستدير إلى اليمين.",
        "خروج مركبات من الموقف على يمين الشارع.",
        "أعطِ حق الأولوية عندما تستدير إلى اليمين.",
        "شارع من اليمين بدون مخرج."
      ],
      id: 796
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0568. ما معنى الإشارة؟",
      numQues: "0568",
      correctAnswer: "نهاية الطريق السريعة.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3568.jpg",
      choices: [
        "طريق سريعة بدون طرق تحويل.",
        "الدخول إلى طريق سريعة.",
        "اندماج مائل مع الطريق السريعة.",
        "نهاية الطريق السريعة."
      ],
      id: 797
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1124. أية مركبة يجوز استخدامها في نقل التلاميذ؟",
      numQues: "1124",
      correctAnswer: "فقط المركبة المعرفة كباص عمومي.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "كل مركبة عمومية أو كل مركبة خصوصية.",
        "كل مركبة خصوصية أو تجارية فيها 8 مقاعد على الأقل.",
        "المركبة التي صادقت عليها سلطة الترخيص وسُجل الإذن بذلك في رخصة المركبة.",
        "فقط المركبة المعرفة كباص عمومي."
      ],
      id: 798
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1026. يُسبب ضغط هواء اقل من اللازم في الإطارات في:",
      numQues: "1026",
      correctAnswer: "تلف سريع لصندوق الغيارات.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "تلف سريع لعجلة المقود (الستيرينج).",
        "فقط ضوضاء شديدة في السرعات العالية.",
        "تلف سريع للإطارات وعدم توازن المركبة.",
        "تلف سريع لصندوق الغيارات."
      ],
      id: 799
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0537. ما معنى الإشارة؟",
      numQues: "0537",
      correctAnswer: "توقف للحظة وتابع طريقك.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3537.jpg",
      choices: [
        "أعطِ حق الأولوية لحركة السير في الطريق القاطعة أمامك عند تنفيذ أشغال في الطريق. ",
        "قف! طالما الإشارة منصوبة أمامك (إشارة متنقلة). ",
        "توقف وأعطِ حق الأولوية لحركة السير في الطريق القاطعة أمامك.",
        "توقف للحظة وتابع طريقك."
      ],
      id: 800
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1013. ما هي أهمية مساند الرأس في مقاعد المركبة عند وقوع حادث من الخلف؟",
      numQues: "1013",
      correctAnswer: "تمنع بهر النظر من الخلف.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "تقلل من تأرجح الرأس إلى الأمام والى الخلف .",
        "مُعدة لوقاية رأس الراكب من شظايا الزجاج عند وقوع حادث. ",
        "تستطيع منع آلام الظهر والرقبة في السفرات الطويلة.",
        "تمنع بهر النظر من الخلف."
      ],
      id: 801
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«D»"
      ],
      title: "1274. ماذا يجب على سائق الباص أن يفحص قبل أن يحرك الباص؟",
      numQues: "1274",
      correctAnswer: "فحص أمتعة الركاب بواسطة كاشف المعادن.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "فحص مستوى الزيت في جهاز المقود.",
        "إذا كان لديه تذاكر سفر مناسبة.",
        "إذا كان هناك عابري طريق في 'المساحات الميتة'.",
        "فحص أمتعة الركاب بواسطة كاشف المعادن."
      ],
      id: 802
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1679. كيف تحافظ على توازن المركبة عندما تصل إلى التواء في الشارع؟",
      numQues: "1679",
      correctAnswer: "عليك تعشيق الغيار العالي.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "عليك زيادة السرعة قبل الدخول إلى الالتواء. ",
        "عليك التمهل قبل الدخول إلى الالتواء وزيادة السرعة قليلاُ عند الخروج منه.",
        "عليك الانتقال إلى غيار النيوترال.",
        "عليك تعشيق الغيار العالي."
      ],
      id: 803
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1306. ما هو الطول الأقصى المسوح به لشاحنة ذات محورين؟",
      numQues: "1306",
      correctAnswer: "15.30م.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "12.00م.",
        "11.00م.",
        "11.30م.",
        "15.30م."
      ],
      id: 804
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0902. في منعطف حاد خفف سرعة سير المركبة:",
      numQues: "0902",
      correctAnswer: "أثناء السير في المنعطف.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3902.jpg",
      choices: [
        "عند الخروج من المنعطف.",
        "فوراً بعد الدخول في المنعطف.",
        "قبل الدخول إلى المنعطف.",
        "أثناء السير في المنعطف."
      ],
      id: 805
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0094. أين يجوز للتراكتورون أن يسير ؟",
      numQues: "0094",
      correctAnswer: "على الطريق السريعة فقط.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3094.jpg",
      choices: [
        "على الطرق الترابية وأيضاً على شارع ضمن حدود قرية تعاونية أو كيبوتس.",
        "فقط على الرصيف في قرية تعاونية أو كيبوتس.",
        "فقط على الشارع وفقط في طريق بلدية.",
        "على الطريق السريعة فقط."
      ],
      id: 806
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0485. كيف تتصرف حسب الإشارة؟",
      numQues: "0485",
      correctAnswer: "تمهل بسبب الأشغال في الطريق.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3484.jpg",
      choices: [
        "تمهل أمامك شارع مشوش.",
        "تمهل واعبر خطوط التباطؤ (المطبات) بحذر.",
        "تمهل واستعد لعبور عوائق في الطريق.",
        "تمهل بسبب الأشغال في الطريق."
      ],
      id: 807
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1643. ما هي الأدوات والملابس الأساسية الصحيحة لركوب الدراجة النارية اليومي الآمن؟",
      numQues: "1643",
      correctAnswer: "خوذة نصف وسروال قماش طويل وأحذية وقفازات وسترة ركوب أساسية وحزام ظهر.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "خوذة (قبعة واقية) كاملة وحسب المواصفات وسروال مصنوع من قماش قاسي وأحذية عالية وقفازات وسترة ركوب أساسية.",
        "خوذة كاملة ونظارات واقية وسروال وصندل وسترة ركوب أساسية مع حاميات لجسم الراكب.",
        "خوذة نصف ونظارات واقية وسروال وأحذية وسترة ركوب أساسية فيها حاميات للكتفين والمفاصل.",
        "خوذة نصف وسروال قماش طويل وأحذية وقفازات وسترة ركوب أساسية وحزام ظهر."
      ],
      id: 808
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1505. هل يُسمح بنقل حاوية عندما لا تكون جميع الأقفال الدوارة مقفلة؟",
      numQues: "1505",
      correctAnswer: "ممنوع .",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "مسموح فقط عند تحميل حاوية (كونتينر) قصيرة.",
        "مسموح – إذا صدر إذن من ضابط الشرطة.",
        "مسموح، فقط عند نقل حاوية (كونتينر) طولها 40 قدم.",
        "ممنوع ."
      ],
      id: 809
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0592. ما معنى الإشارة؟",
      numQues: "0592",
      correctAnswer: "حركة السير المؤشرة بالسهم الأصفر مسموحة للمواصلات العمومية فقط.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3560.jpg",
      choices: [
        "سر إلى الأمام فقط، ممنوع تنفيذ أية استدارة.",
        "لك حق الأولوية في الطريق الضيقة.",
        "أعطِ حق الأولوية في الطريق الضيقة والمنحدرة للمركبة الميكانيكية القادمة من الاتجاه المعاكس.",
        "حركة السير المؤشرة بالسهم الأصفر مسموحة للمواصلات العمومية فقط."
      ],
      id: 810
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0919. كيف يكون رد فعلك للدلائل الظاهرة في الصورة؟",
      numQues: "0919",
      correctAnswer: "استعمال الزامور بشدة وبشكل متواصل لتجنب إصابة الباب المفتوح بضرر.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3919.jpg",
      choices: [
        "الانحراف يساراً وزيادة السرعة من اجل تجنب إصابة الركاب الذين سيخرجون من المركبة.",
        "واصل سيرك كالمعتاد دون إعارة أي انتباه للباب المفتوح، يسري واجب الحذر على السائق الذي يخرج من المركبة.",
        "تمهل واستعد للتوقف من اجل تجنب إصابة الباب المفتوح أو الشخص الخارج من المركبة.",
        "استعمال الزامور بشدة وبشكل متواصل لتجنب إصابة الباب المفتوح بضرر."
      ],
      id: 811
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0565. هل يجوز لمركبة بطيئة أن تسير في طريق نُصبت فيها الإشارة ؟",
      numQues: "0565",
      correctAnswer: "نعم وبسرعة 55كم/ساعة على الأكثر.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3564.jpg",
      choices: [
        "نعم وبسرعة 55كم/ساعة على الأقل.",
        "نعم، في الطريق السريعة فقط.",
        "كلا.",
        "نعم وبسرعة 55كم/ساعة على الأكثر."
      ],
      id: 812
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0774. ما هو الخطر الأساسي عند الاقتراب من المفترق في شارع رطب؟",
      numQues: "0774",
      correctAnswer: "لا يوجد أي خطر للمركبات في شارع رطب.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3774.jpg",
      choices: [
        "من شأن المركبة أن تتزحلق داخل مساحة المفترق بسبب الشارع الرطب",
        "هناك مشاة أكثر في الشارع أيام الشتاء.",
        "من غير الممكن رؤية وسم (تأشير) الشارع في شارع رطب.",
        "لا يوجد أي خطر للمركبات في شارع رطب."
      ],
      id: 813
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0479. عندما تتجاوزك مركبة وفجأةً قدمت مركبة من الجهة المقابلة، عليك:",
      numQues: "0479",
      correctAnswer: "الانحراف إلى اليمين على قدر الإمكان وعدم زيادة سرعتك.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "استعمال الزامور كإشارة تنبيه من اجل تحذير السائق المتجاوز.",
        "التوقف توقفاً فورياً وتاماً في المسلك الأيمن.",
        "زيادة سرعة سيرك كي تخرج من منطقة الخطر.",
        "الانحراف إلى اليمين على قدر الإمكان وعدم زيادة سرعتك."
      ],
      id: 814
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»"
      ],
      title: "0333. ما هو العمر الأدنى (اقل عمر) المطلوب للحصول على رخصة سياقة من الدرجة B ؟",
      numQues: "0333",
      correctAnswer: "16 سنة.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "17 سنة.",
        "17,5 سنة. ",
        "16 سنة بموافقة الوالدين.",
        "16 سنة."
      ],
      id: 815
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0581. ما معنى الإشارة؟",
      numQues: "0581",
      correctAnswer: "سبيل لراكبي الدراجات الهوائية فقط، ممنوع مرور المشاة.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3581.jpg",
      choices: [
        "سبيلان منفصلان للدراجات الهوائية وللمشاة فقط.",
        "شارع مفتوح للدراجات الهوائية والمشاة.",
        "مكان عبور راكبي الدراجات الهوائية والمشاة.",
        "سبيل لراكبي الدراجات الهوائية فقط، ممنوع مرور المشاة."
      ],
      id: 816
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1569. أية إشارة تحذر من وجود حيوانات على الطريق؟",
      numQues: "1569",
      correctAnswer: "146",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31569.jpg",
      choices: [
        "411",
        "414",
        "635",
        "146"
      ],
      id: 817
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1671. لأية مستندة في الصورة هناك ثلاثة محاور؟",
      numQues: "1671",
      correctAnswer: "15",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31671.jpg",
      choices: [
        "17",
        "14",
        "16",
        "15"
      ],
      id: 818
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0418. ما معنى الإشارة؟",
      numQues: "0418",
      correctAnswer: "تحديد ارتفاع للمركبة، ممنوع دخول مركبة يزيد ارتفاعها مع حمولتها عن الارتفاع المسجل في الإشارة.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3418.jpg",
      choices: [
        "شارع ضيق ومنخفض.",
        "الدخول إلى نفق.",
        "أمامك حاجز.",
        "تحديد ارتفاع للمركبة، ممنوع دخول مركبة يزيد ارتفاعها مع حمولتها عن الارتفاع المسجل في الإشارة."
      ],
      id: 819
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1179. ما هي 'السفرة السياحية' في الصالون العمومي؟",
      numQues: "1179",
      correctAnswer: "سفرة في خدمة وزارة الدفاع.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "سفرة في الصالون العمومي عندما يكون تحت تصرف طالب السفرة من اجل السياحة أو التجوال أو النزهة.",
        "فقط السفرة على خط خدمة.",
        "سفرة في خدمة وزارة السياحة ووزارة الرياضة مع بعض.",
        "سفرة في خدمة وزارة الدفاع."
      ],
      id: 820
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1118. متى يُمنع الباص من عبور سكة حديد؟",
      numQues: "1118",
      correctAnswer: "إذا نُصبت قبل السكة إشارة 'قف'. ",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "إذا نُصبت قبل السكة إشارة 'أعطِ حق الأولوية'.",
        "إذا كانت هناك إشارة تحذير تشير إلى ملتقى سكة حديد.",
        "عندما لا تكون الطريق المؤدية إلى الملتقى معبدة بالإسفلت أو الباطون من مسافة 20م على الأقل.",
        "إذا نُصبت قبل السكة إشارة 'قف'. "
      ],
      id: 821
    },
    {
      category: "قوانين المرور",
      type: [
        "«C1»"
      ],
      title: "1527. ما هو الارتفاع الإجمالي الأقصى المسموح به عند التحميل على مركبة تجارية وزنها الإجمالي المسموح به من 3501 لغاية 8000كغم؟",
      numQues: "1527",
      correctAnswer: "4.00م. ",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "2.50م. ",
        "3.50م. ",
        "3.00م. ",
        "4.00م. "
      ],
      id: 822
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0547. عندما تُنصب الإشارة في المفترق الذي أمامك:",
      numQues: "0547",
      correctAnswer: "هناك صعود شديد أمامك.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3545.jpg",
      choices: [
        "مسموح السير بشكلٍ مستقيم إلى الأمام من المسلك الأيسر فقط.",
        "الشارع الذي بعد المفترق هو شارع باتجاه واحد.",
        "مسموح السير إلى الأمام بشكل مستقيم فقط.",
        "هناك صعود شديد أمامك."
      ],
      id: 823
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0635. ما معنى الوسم (التأشير) على عرض الطريق؟",
      numQues: "0635",
      correctAnswer: "خط توقف قبل المفترق.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3635.jpg",
      choices: [
        "مكان عبور راكبي الدراجات الهوائية.",
        "مسلك للمواصلات العمومية.",
        "شارع باتجاه واحد.",
        "خط توقف قبل المفترق."
      ],
      id: 824
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0213. هل يجوز إيقاف مركبة مقابل محطة باص؟",
      numQues: "0213",
      correctAnswer: "ممنوع منعاً باتاً.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "مسموح بشرط أن يكون عرض الشارع 20م على الأقل.",
        "مسموح بشرط أن يكون عرض الشارع 12م أو أكثر.",
        "مسموح فقط في ساعات النهار من اجل إصعاد الركاب.",
        "ممنوع منعاً باتاً."
      ],
      id: 825
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0431. كيف تتصرف حسب الإشارة ؟",
      numQues: "0431",
      correctAnswer: "انتبه لحركة السير القادمة من اليمين في الدوار.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3430.jpg",
      choices: [
        "تمهل قبل الدوار واستعد لإمكانية التوقف.",
        "توقف قبل الدخول إلى الدوار واعبر الدوار بسرعة.",
        "ادخل الدوار بحذر لأن لك حق الأولوية.",
        "انتبه لحركة السير القادمة من اليمين في الدوار."
      ],
      id: 826
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0093. كم مرة يتقطع الضوء الأخضر في إشارة ضوئية (رمزور) سليمة قبل أن يتحول إلى أصفر؟",
      numQues: "0093",
      correctAnswer: "ذلك يعتمد على ضغط حركة السير.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3093.jpg",
      choices: [
        "مرة واحدة.",
        "أربع مرات.",
        "ثلاث مرات.",
        "ذلك يعتمد على ضغط حركة السير."
      ],
      id: 827
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0953. كيف يجب عليك التصرف حسب الوضع المبين في الصورة؟",
      numQues: "0953",
      correctAnswer: "أضئ الضوء العالي وابقَ في وسط الشارع وبذلك تستطيع مشاهدتك المركبة القادمة من الجهة المقابلة.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3953.jpg",
      choices: [
        "اخفض الأضواء وابقَ على اليمين وخفف من سرعة سيرك حتى إمكانية التوقف.",
        "أضئ الضوء العالي لكي يُمكنك من زيادة مدى الرؤية لأطول مسافة.",
        "استعمل الأربعة غمازات لكي تلفت انتباه سائق المركبة القادمة من الجهة المعاكسة.",
        "أضئ الضوء العالي وابقَ في وسط الشارع وبذلك تستطيع مشاهدتك المركبة القادمة من الجهة المقابلة."
      ],
      id: 828
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0569. ما معنى الإشارة؟",
      numQues: "0569",
      correctAnswer: "محطة نقل ركاب، ممنوع التوقف والوقوف لأية مركبة أخرى.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3215.jpg",
      choices: [
        "محطة خط خدمة للصالون العمومي (سيرفيس) وللباصات في السفريات الخاصة.",
        "محطة صالون عمومي(تاكسيات)،ممنوع توقف ووقوف مركبة أخرى إلا لإنزال الركاب.",
        "ممنوع توقف أو وقوف أية مركبة في حدود 20م.",
        "محطة نقل ركاب، ممنوع التوقف والوقوف لأية مركبة أخرى."
      ],
      id: 829
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0059. هل أوامر الإشارة الضوئية (الرمزور) مفضلة على أوامر أية إشارة تأمر بإعطاء حق الأولوية؟",
      numQues: "0059",
      correctAnswer: "نعم، أوامر الإشارة الضوئية (الرمزور) ما عدا الضوء الأصفر المتقطع مفضلة على أوامر أية إشارة أخرى.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "أحياناً. الأفضلية في إطاعة أوامر الإشارة الضوئية (الرمزور) تسري فقط في طريق داخل المدن.",
        "كلا، أوامر الإشارة الضوئية (الرمزور) وأوامر إشارات السير متساوية في نظر القانون.",
        "كلا، غير أن إشارة 'قف' مفضلة على أوامر الضوء الأخضر في الإشارة الضوئية (الرمزور) في نفس اتجاه السير.",
        "نعم، أوامر الإشارة الضوئية (الرمزور) ما عدا الضوء الأصفر المتقطع مفضلة على أوامر أية إشارة أخرى."
      ],
      id: 830
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1147. من يجب أن يفحص سلامة الفرامل والمقود والأضواء والزامور وماسحات الزجاج وعمل فتح الأبواب وإغلاقها في الباص؟",
      numQues: "1147",
      correctAnswer: "مؤسسة الترخيص، في الفحص السنوي (التست).",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "السائق – على الأقل مرة كل ستة اشهر.",
        "السائق قبل كل سفرة.",
        "ضابط السلامة، مرة كل نصف سنة.",
        "مؤسسة الترخيص، في الفحص السنوي (التست)."
      ],
      id: 831
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0956. كيف تتصرف في باقي الطريق؟",
      numQues: "0956",
      correctAnswer: "عدد المسالك آخذ في التناقص، ابقَ في مسلك سيرك.",
      pubDate: "10-11-2011 08:22:55",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3956.jpg",
      choices: [
        "عدد المسالك آخذ في الازدياد، اختر المسلك الأيسر وتابع سيرك فيه.",
        "عدد المسالك آخذ في التناقص، انتقل إلى المسلك الأيمن وتابع سيرك على يمين الشارع.",
        "عدد المسالك آخذ في الازدياد، اختر المسلك الأوسط وتابع سيرك فيه.",
        "عدد المسالك آخذ في التناقص، ابقَ في مسلك سيرك."
      ],
      id: 832
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0235. في أية مركبات يجب على السائق والركاب استعمال حزام الأمان؟",
      numQues: "0235",
      correctAnswer: "في كل مركبة تسير على أكثر من عجلتين وتنقل ركاب.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "في كل مركبة يوجد فيها أحزمة أمان.",
        "في المركبات الخصوصية فقط.",
        "الركاب والسائق في مركبة لا يزيد وزنها الإجمالي المسموح به عن 3500كغم فقط. ",
        "في كل مركبة تسير على أكثر من عجلتين وتنقل ركاب."
      ],
      id: 833
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1666. ما هو الفحص المهم الذي يجب أن يجريه راكب الدراجة النارية قبل الدخول إلى المفترق:",
      numQues: "1666",
      correctAnswer: "عدم وجود حركة سير في المفترق والتي من شأنها أن تعرضه للخطر.",
      pubDate: "10-11-2011 08:22:55",
      img: "",
      choices: [
        "لا توجد ضرورة بإجراء أي فحص في مفترق نُصبت فيه إشارات ضوئية.",
        "التأكد من عدم وجود مركبة تسير بموازاته بنفس السرعة.",
        "احتساب الزمن الذي يحتاجه لكي يعبر المفترق بالسرعة التي دخلها فيها المفترق.",
        "عدم وجود حركة سير في المفترق والتي من شأنها أن تعرضه للخطر."
      ],
      id: 834
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0750. ما هي ميزة السياقة على يمين الشارع؟",
      numQues: "0750",
      correctAnswer: "ذلك يمنع المركبة التي تسير خلفك من تجاوزك.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "البقاء ضمن الحدود المسموحة والتي لا تزيد عن 40سم من حافة الشارع.",
        "أنت تخلق مسافة آمان بينك وبين المركبة التي تسير في الجهة المقابلة.",
        "لا توجد أية أهمية للسياقة على يمين الشارع إلا في شارع باتجاه واحد فقط.",
        "ذلك يمنع المركبة التي تسير خلفك من تجاوزك."
      ],
      id: 835
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0484. ما معنى الإشارة؟",
      numQues: "0484",
      correctAnswer: "انتبه! شارع مشوش.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3484.jpg",
      choices: [
        "انتبه! أمامك خطوط تباطؤ (مطبات) في الطريق التي أمامك.",
        "انتبه! عوائق في الطريق.",
        "انتبه! مساحات ميتة.",
        "انتبه! شارع مشوش."
      ],
      id: 836
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1481. كيف يُمكن تقليل القوة الطاردة المركزية (الطاردة عن المركز) العاملة على المركبة أثناء السير؟",
      numQues: "1481",
      correctAnswer: "بواسطة السير حسب القانون وإعطاء حق الأولوية دائماً.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "بواسطة تخفيف سرعة السير في المنعطفات والإلتوائات.",
        "بواسطة زيادة سرعة السير.",
        "لا يُمكن التقليل من هذه القوة – فهي تعتمد على حجم المركبة فقط.",
        "بواسطة السير حسب القانون وإعطاء حق الأولوية دائماً."
      ],
      id: 837
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1028. نجد المعلومات عن ضغط الهواء الصحيح في الإطارات:",
      numQues: "1028",
      correctAnswer: "في كتاب المركبة(الكتالوج) الذي يزوده منتج المركبة أو المستورد. ",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "في كراج معتمد فقط.",
        "في شركة تأمين المركبة.",
        "في رخصة المركبة.",
        "في كتاب المركبة(الكتالوج) الذي يزوده منتج المركبة أو المستورد. "
      ],
      id: 838
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1247. هل يُسمح لصالون عمومي مُعد للسفرات الخاصة بالقيام بسفرة خدمة؟",
      numQues: "1247",
      correctAnswer: "ممنوع في أية حالة من الحالات.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "مسموح، إذا كانت سفرة الصالون العمومي تنتهي بعيداً عن المحطة",
        "مسموح - عن طريق هيئة (مكتب منظم) له رخصة لنفس خط الخدمة وبإذنٍ خطي من نفس الهيئة ( المكتب).",
        "يجوز لكل صالون عمومي القيام بسفرة خدمة. ",
        "ممنوع في أية حالة من الحالات."
      ],
      id: 839
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0954. كيف تتصرف حسب الصورة التي أمامك؟",
      numQues: "0954",
      correctAnswer: "تمهل بجوار راكب الدراجة الهوائية وانحرف إلى اليسار إذا أمكن.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3942.jpg",
      choices: [
        "يجب استعمال الزامور عدة مرات عند العبور بجانب راكبي الدراجات الهوائية من اجل لفت انتباههم.",
        "زد من سرعة سيرك عند عبورك بجانب راكبي الدراجات الهوائية من اجل اختصار مدة المواجهة معهم.",
        "يجب الاستمرار بالسير بدون أي تغيير، لا يُشكل راكبو الدراجات الهوائية أية خطورة على المركبات.",
        "تمهل بجوار راكب الدراجة الهوائية وانحرف إلى اليسار إذا أمكن."
      ],
      id: 840
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0847. ما هي أسباب حدوث تزحلق المركبة على سطح الشارع؟",
      numQues: "0847",
      correctAnswer: "تعب السائق.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "فقط إطارات غير ممسوحة تتسبب في التزحلق.",
        "فرملة غير صحيحة وتواجد عوامل التزحلق على سطح الشارع.",
        "شارع ذو معامل احتكاك عالي.",
        "تعب السائق."
      ],
      id: 841
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1152. لمن خُصص المقعدان الأماميان على جانبي الممر في الباص الذي يعمل على خط خدمة بين المدن؟",
      numQues: "1152",
      correctAnswer: "لرجال الأمن.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "للمعاقين والمسنين فقط.",
        "للأشخاص في لباسهم الرسمي فقط.",
        "لأهل الأولاد لغاية عمر خمس سنوات.",
        "لرجال الأمن."
      ],
      id: 842
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»"
      ],
      title: "1461. بعد توصيل المقطورة أو المستندة بالقاطرة أو بالساندة، هل يجب فحص تجاوب الفرامل؟",
      numQues: "1461",
      correctAnswer: "نعم، توصيل المقطورة أو المستندة يلزم بفحص تجاوب الفرامل عند البدء بالسير.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "كلا، لا توجد ضرورة من فحص تجاوب الفرامل، يكفي أن هناك ضغط هواء سليم في الفرامل. ",
        "نعم، بعد توصيل المقطورة أو المستندة، يجب الذهاب إلى مؤسسة لفحص الفرامل والتأكد من سلامتها.",
        "كلا، لا توجد لدى السائق الوسائل لفحص تجاوب الفرامل. ",
        "نعم، توصيل المقطورة أو المستندة يلزم بفحص تجاوب الفرامل عند البدء بالسير."
      ],
      id: 843
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0357. في طريق باتجاهين مسدودة بواسطة مبنى أو عامود، كيف يتم تجاوز العائق؟",
      numQues: "0357",
      correctAnswer: "نعبر العائق من اليسار فقط.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "لا توجد أهمية للجهة، المهم تجاوز العائق.",
        "نعبر العائق من الجهة اليمنى إلا إذا دلت إشارة على غير ذلك.",
        "نأخذ بعين الاعتبار وضع الطريق ونتجاوز وفقاً لذلك.",
        "نعبر العائق من اليسار فقط."
      ],
      id: 844
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1141. من هو المسؤول عن القيام بفحص السلامة في الباص؟",
      numQues: "1141",
      correctAnswer: "الفحص الأمني يقوم به فقط فاحص معتمد.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "على سائق الباص القيام بفحص امني في نهاية السفرة فقط.",
        "على سائق الباص القيام بفحص امني في بداية السفرة فقط.",
        "على سائق الباص القيام بذلك قبل البدء بالسفر وفي نهاية كل سفرة.",
        "الفحص الأمني يقوم به فقط فاحص معتمد."
      ],
      id: 845
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«D»"
      ],
      title: "1370. في أية مركبة يجب أن يُركب فيها زامور للرجوع إلى الخلف؟",
      numQues: "1370",
      correctAnswer: "كل مركبة شاحنة يجب أن يكون فيها زامور.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "في مركبة تجارية ومركبة عمل وزنهما الإجمالي المسموح به أكثر من 15000كغم وفي التراكتور والباص. ",
        "في مركبة تجارية وزنها الإجمالي المسموح به أكثر من 4000كغم. ",
        "في مركبة وزنها الإجمالي المسموح به 12000كغم أو اقل.",
        "كل مركبة شاحنة يجب أن يكون فيها زامور."
      ],
      id: 846
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0385. ما معنى الشاخصة ؟",
      numQues: "0385",
      correctAnswer: "وصلت إلى نهاية مقطع السرعة الخاصة.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3385.jpg",
      choices: [
        "وصلت إلى مقطع فيه يجب على المركبة السريعة السير في المسلك الأيمن والمركبة البطيئة في المسلك الأيسر. ",
        "وصلت إلى مقطع فيه الوقوف مسموح على جانبي الشارع.",
        "وصلت إلى مقطع فيه تغيير مؤقت للسرعة القصوى المسموح بها من 50كم/ساعة إلى 30كم/ساعة.",
        "وصلت إلى نهاية مقطع السرعة الخاصة."
      ],
      id: 847
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0796. حسب الظاهر في الصورة، هل يُسمح بالاستدارة للسير في الاتجاه المعاكس (حذوة فرس)؟",
      numQues: "0796",
      correctAnswer: "مسموح، إذا كانت هناك إمكانية بإكمال الاستدارة باستدارة واحدة متواصلة.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3796.jpg",
      choices: [
        "ممنوع.",
        "مسموح بشرط أن نستدير بحذر وبدون عرقلة لحركة السير.",
        "مسموح من الجهة اليسرى للشارع.",
        "مسموح، إذا كانت هناك إمكانية بإكمال الاستدارة باستدارة واحدة متواصلة."
      ],
      id: 848
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0117. بأية شروط يُسمح بتنفيذ استدارة للسير في الاتجاه المعاكس (حذوة فرس)؟",
      numQues: "0117",
      correctAnswer: "مسموح في كل مكان لكن تُمنع المناورة في الشارع من اجل تنفيذ الاستدارة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "عندما لا يؤدي ذلك إلى عرقلة لحركة السير أو خطر على عابري الطريق ولا توجد إشارة تمنع مثل هذه الاستدارة.",
        "مسموح تنفيذ استدارة للسير في الاتجاه المعاكس فقط في شارع فيه 3 مسالك على الأقل.",
        "هذه الاستدارة مسموحة في المفترق فقط.",
        "مسموح في كل مكان لكن تُمنع المناورة في الشارع من اجل تنفيذ الاستدارة."
      ],
      id: 849
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1454. ماذا ينص 'قانون خدمات النقل' حسب القانون؟",
      numQues: "1454",
      correctAnswer: "ترتيبات نقل الحمولات إلى الميناء ومنه.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "ينص القانون بأن لا تُقدم خدمة نقل في مركبة تجارية وزنها الإجمالي 10000كغم أو أكثر بدون 'رخصة ناقل'.",
        "يُحدد القانون الوزن الإجمالي المسموح به للمركبات المستعملة في النقل.",
        "يُحدد القانون تعرفات النقل القصوى للنقل البري.",
        "ترتيبات نقل الحمولات إلى الميناء ومنه."
      ],
      id: 850
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0232. كيف تنقل في المركبة ولداً أتم 3 سنوات من عمره ولم يتم الثامنة من عمره؟",
      numQues: "0232",
      correctAnswer: "فقط في المقعد الخلفي للمركبة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "مربوط بأي حزام أمان.",
        "مربوط بحزام أمان موحد (له ثلاث نقاط).",
        "في مقعد أمان أو في مقعد مرتفع يناسب طوله ووزنه.",
        "فقط في المقعد الخلفي للمركبة."
      ],
      id: 851
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1522. كيف توسم (تؤشر) حمولة بارزة من القسم الأمامي للمركبة؟",
      numQues: "1522",
      correctAnswer: "بعلم احمر على أقصى الطرف البارز للحمولة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "بمثلث عاكس ابيض على أقصى الطرف البارز للحمولة.",
        "بمثلث عاكس احمر على أقصى الطرف البارز للحمولة. ",
        "بمصباح وعلم ابيض أو اصفر على أقصى الطرف البارز للحمولة.",
        "بعلم احمر على أقصى الطرف البارز للحمولة."
      ],
      id: 852
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1153. أين يتوقف سائق الباص في خط خدمة من اجل إصعاد أو إنزال الركاب؟",
      numQues: "1153",
      correctAnswer: "على مسافة لا تبعد أكثر من مترين من حافة الرصيف في المحطة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "في المحطات المذكورة في رخصة الخط فقط.",
        "في الطريق التي يزيد عرضها عن 12م.",
        "في مكان يُرى من قِبل عابري الطريق الآخرين من جميع الجهات.",
        "على مسافة لا تبعد أكثر من مترين من حافة الرصيف في المحطة."
      ],
      id: 853
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0506. هل يُسمح بدخول الدراجات الهوائية في الطريق التي نُصبت قبلها الإشارة؟",
      numQues: "0506",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3505.jpg",
      choices: [
        "نعم.",
        "نعم، الدخول ممنوع للشاحنات فقط.",
        "نعم، الدخول ممنوع للمركبات العمومية فقط.",
        "كلا."
      ],
      id: 854
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1579. كيف يجب إيقاف دراجة نارية مع عربة جانبية في الطريق وفي 'وقت الإنارة' وعندما لا تكون الطريق مُنارة:",
      numQues: "1579",
      correctAnswer: "عندما يكون المصباح الخلفي ومصابيح الوقوف مضاءة فيها.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "عندما يكون مصباح الوقوف مضاءً فيها.",
        "عندما يكون المصباح الأمامي أو مصباح الوقوف مضاءً فيها.",
        "عندما يكون مصباح الفرملة مضاءً فيها.",
        "عندما يكون المصباح الخلفي ومصابيح الوقوف مضاءة فيها."
      ],
      id: 855
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0130. في أية حالات يُمنع تجاوز أو محاولة تجاوز مركبة أخرى:",
      numQues: "0130",
      correctAnswer: "من مسافة 300م قبل ملتقى سكة حديد.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "عند السير في طريق صاعدة.",
        "عندما تكون الرؤية مشوشة أو عندما يكون مدى الرؤية مسدوداً أو محدوداً.",
        "في ساعات الليل.",
        "من مسافة 300م قبل ملتقى سكة حديد."
      ],
      id: 856
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0830. ما هي المركبة الهجين؟",
      numQues: "0830",
      correctAnswer: "مركبة مُركب فيها محرك كهربائي إضافة إلى المحرك العادي.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "مركبة مُركب فيها بالإضافة إلى المحرك، محرك يعمل بطاقة الشمس.",
        "مركبة مُركب فيها محركان عاديان.",
        "مركبة مُركب فيها محركان كهربائيان بدل المحرك العادي.",
        "مركبة مُركب فيها محرك كهربائي إضافة إلى المحرك العادي."
      ],
      id: 857
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1697. السياقة في الظلام تتطلب انتباهاً أكثر بكثير:",
      numQues: "1697",
      correctAnswer: "يسري واجب الحذر فقط في حالات الضباب والمطر.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "يسري واجب الحذر فقط في حالة بهر النظر.",
        "لا يوجد واجب حذر خاص في الظلام.",
        "لأن الرؤية (أن نرى ونُرى) محدودة.",
        "يسري واجب الحذر فقط في حالات الضباب والمطر."
      ],
      id: 858
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1156. حسب المتطلبات ماذا يجب أن يوجد، بين سائر الأشياء، في الباص المستخدم في نقل الركاب؟",
      numQues: "1156",
      correctAnswer: "خزان ماء للشرب وكاسات بلاستيكية.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "مضخة (طرمبة) لنفخ العجلات.",
        "رافعة (جاك) لرفع العجل.",
        "سلة قمامة (زبالة) التي صادقت عليها السلطة، بجانب كل باب.",
        "خزان ماء للشرب وكاسات بلاستيكية."
      ],
      id: 859
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0518. أنت تقترب من مفترق عندما بدأ الضوء الأخضر بالتقطع في الإشارة الضوئية (الرمزور):",
      numQues: "0518",
      correctAnswer: "هذا يعني بأن الإشارة الضوئية (الرمزور) أصيبت بخلل وعليك التصرف حسب الإشارات المنصوبة في المكان.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3093.jpg",
      choices: [
        "الضوء الأخضر المتقطع مثل الضوء الأخضر العادي، لا حاجة إلى إعارة اهتمام خاص له. ",
        "هذا يعني بأن الضوء تغير إلى اخضر قبل لحظات وبالإمكان مواصلة السير.",
        "هذا يعنى أن الضوء الأخضر في الإشارة الضوئية (الرمزور) سوف ينتهي خلال ثلاث ثواني.",
        "هذا يعني بأن الإشارة الضوئية (الرمزور) أصيبت بخلل وعليك التصرف حسب الإشارات المنصوبة في المكان."
      ],
      id: 860
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0578. ما معنى الإشارة؟",
      numQues: "0578",
      correctAnswer: "ممنوع دخول المشاة بما في ذلك حاشية الطريق.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3578.jpg",
      choices: [
        "انتبه! مشاة بالقرب من المكان.",
        "مسموح دخول المشاة فقط.",
        "مكان ممنوع فيه ألعاب الأولاد.",
        "ممنوع دخول المشاة بما في ذلك حاشية الطريق."
      ],
      id: 861
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1021. أية لامبة تختار عندما يتوجب عليك تغيير لامبة في المركبة؟",
      numQues: "1021",
      correctAnswer: "نوع اللامبة ليس مهماً ، المهم أن تلائم قاعدة اللامبة السابقة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "أية لامبة تعادل قوتها قوة اللامبة الأصلية.",
        "أية لامبة لونها مشابه للون اللامبة الأصلية.",
        "لامبة مناسبة حسب تعليمات منتح المركبة.",
        "نوع اللامبة ليس مهماً ، المهم أن تلائم قاعدة اللامبة السابقة."
      ],
      id: 862
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1715. عند السير في طريق مشوشة، يجب:",
      numQues: "1715",
      correctAnswer: "إسناد الرجل على دعسة الكلاتش بشكلٍ دائم لضمان سير سلس.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "زيادة السرعة من اجل تجنب الاهتزازات والحفر.",
        "تخفيف سرعة السير وزيادة اليقظة.",
        "إسناد الرجل على دعسة الفرامل للاستعداد لكل طارئ.",
        "إسناد الرجل على دعسة الكلاتش بشكلٍ دائم لضمان سير سلس."
      ],
      id: 863
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0048. عرِّف 'المركبة الميكانيكية' :",
      numQues: "0048",
      correctAnswer: "كل مركبة تسير على عجلتين على الأقل .",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "فقط مركبة تسير بقوة محرك بنزين.",
        "فقط مركبة تسير بقوة محرك ديزل.",
        "مركبة تسير بقوة ميكانيكية بأي شكلٍ من الأشكال.",
        "كل مركبة تسير على عجلتين على الأقل ."
      ],
      id: 864
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1500. أي تأمين يغطي الضرر المتسبب لمركبة شخص آخر؟",
      numQues: "1500",
      correctAnswer: "تأمين على الحياة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "تأمين ضد الحريق.",
        "تأمين المدراء.",
        "تأمين فريق ثالث.",
        "تأمين على الحياة."
      ],
      id: 865
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1062. أي جزء في المركبة يؤدي إلى توصيل أو فصل الحركة الدائرية من المحرك إلى صندوق الغيارات؟",
      numQues: "1062",
      correctAnswer: "العجلات.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "البطارية.",
        "المروحة.",
        "الكلاتش.",
        "العجلات."
      ],
      id: 866
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0022. على الراكب الذي يجلس في المقعد الخلفي لمركبة ركاب خصوصية أن يستعمل حزام الأمان، على من تقع المسؤولية إذا لم يستعمل الحزام أثناء السير؟",
      numQues: "0022",
      correctAnswer: "على الراكب فقط.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "على السائق وعلى الراكب.",
        "على السائق فقط.",
        "على صاحب المركبة.",
        "على الراكب فقط."
      ],
      id: 867
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1326. إذا أردت نقل حاوية (كونتينر) على مقطورة، كم يجب أن يكون الوزن الإجمالي المسموح به للمقطورة لكي تنقل عليها حاوية؟",
      numQues: "1326",
      correctAnswer: "15000كغم على الاقل.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "12000كغم على الاقل.",
        "14000كغم على الاقل.",
        "10000كغم على الاقل.",
        "15000كغم على الاقل."
      ],
      id: 868
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0794. ما هي الأخطار أثناء الاستدارة للسير في الاتجاه المعاكس (حذوة فرس)؟",
      numQues: "0794",
      correctAnswer: "التسبب في فرملة فجائية للمركبة التي تقترب في الشارع.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3794.jpg",
      choices: [
        "خطر التصادم مع المركبات القادمة من الجهة المقابلة أو من الخلف.",
        "جميع الإجابات صحيحة.",
        "التسبب في عرقلة للمركبة التي تصل من الخلف أو من الأمام.",
        "التسبب في فرملة فجائية للمركبة التي تقترب في الشارع."
      ],
      id: 869
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1242. خلال أية فترة يجب القيام بتعيير العداد في الصالون العمومي، إذا تم تغيير قياس الإطارات أو حجم أجزاء في أجهزة الحركة؟",
      numQues: "1242",
      correctAnswer: "خلال 48 ساعة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "ليس أكثر من نصف سنة قبل موعد تعيير العداد الدوري.",
        "24 ساعة.",
        "أسبوع من تاريخ إنهاء التصليح.",
        "خلال 48 ساعة."
      ],
      id: 870
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1316. متى يجب عليك تشغيل مصباح يبعث بنور اصفر متقطع فوق كابينة السائق؟",
      numQues: "1316",
      correctAnswer: "عندما تسوق مركبة تنقل حمولة اكبر من عرض المركبة.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "عندما تسوق مركبة تزيد حمولتها المسموح بها عن 15000كغم.",
        "إذا كان طول الحمولة أو طول المركبة يزيد عن 20م.",
        "عندما تسوق مركبة موصولة.",
        "عندما تسوق مركبة تنقل حمولة اكبر من عرض المركبة."
      ],
      id: 871
    },
    {
      category: "معرفة المركبة",
      type: [
        "«A»"
      ],
      title: "1629. إذا شعر السائق بأن فرملة الرجل لا تفرمل الدراجة النارية أثناء السير فعليه:",
      numQues: "1629",
      correctAnswer: "التوجه إلى محطة الوقود القريبة وزيادة ضغط الهواء في العجلات.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "التوقف عن السير في الدراجة النارية فوراً.",
        "إخراج قليلاً من الهواء من العجلات للتغلب على الخلل.",
        "استبدال العجلة الأمامية بالخلفية والخلفية بالأمامية.",
        "التوجه إلى محطة الوقود القريبة وزيادة ضغط الهواء في العجلات."
      ],
      id: 872
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1321. ما معنى الإشارة؟",
      numQues: "1321",
      correctAnswer: "مصباح يضيء بضوء برتقالي متقطع يُحذر من الاقتراب من ملتقى سكة حديد.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31321.jpg",
      choices: [
        "مصباح يضيء بضوء برتقالي ثابت (غير متقطع) يُحذر من الاقتراب من اندماج طرق.",
        "مصباح يضيء بضوء برتقالي ثابت (غير متقطع) عندما تتعطل الإشارة الضوئية.",
        "مصباح يضيء بضوء برتقالي متقطع في موقع أشغال على الشارع.",
        "مصباح يضيء بضوء برتقالي متقطع يُحذر من الاقتراب من ملتقى سكة حديد."
      ],
      id: 873
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0446. كيف تتصرف حسب الإشارة ؟",
      numQues: "0446",
      correctAnswer: "تابع السير المعتاد، لك حق الأولوية في منطقة العبور.",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3445.jpg",
      choices: [
        "توقف وأعطِ حق الأولوية للقطار الخفيف.",
        "تمهل واحرص على تنفيذ قواعد إعطاء حق الأولوية في منطقة العبور.",
        "عليك السياقة بحذر ولا تعبر خط القطار الخفيف.",
        "تابع السير المعتاد، لك حق الأولوية في منطقة العبور."
      ],
      id: 874
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0066. هل يجب إطاعة أوامر شرطي من الشرطة العسكرية، حتى ولو كان الأمر أو الإشارة مخالفين لإشارات السير؟",
      numQues: "0066",
      correctAnswer: "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'ممنوع الدخول'.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "كلا، لا يوجد واجب بالإطاعة.",
        "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'قف'.",
        "نعم، الإطاعة واجبة، وبحذر شديد.",
        "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'ممنوع الدخول'."
      ],
      id: 875
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1127. هل يجوز لباص مرخص لنقل 20 راكب أو أكثر أن يقف على الرصيف في حدود إشارة تسمح بالوقوف على الرصيف؟",
      numQues: "1127",
      correctAnswer: "يجوز، بشرط أن يتواجد في الباص ركاب.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "كلا.",
        "يجوز، بشرط أن لا يتواجد في الباص ركاب.",
        "نعم.",
        "يجوز، بشرط أن يتواجد في الباص ركاب."
      ],
      id: 876
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0078. كيف يجب التصرف في شارع مختلط (موحد) ؟",
      numQues: "0078",
      correctAnswer: "على السائق تمكين المشاة والأولاد من الاستمرار في ما يقومون به دون تعريضهم للخطر.",
      pubDate: "10-11-2011 08:22:56",
      img: "",
      choices: [
        "على السائق استعمال الزامور لتنبيه المشاة على دخول المركبة للشارع.",
        "على السائق الامتناع عن الدخول إلى شارع مختلط أثناء لعب الأولاد.",
        "على السائق أن يسير دائماً بغيار واطئ ولا يسير إلى الخلف على الإطلاق.",
        "على السائق تمكين المشاة والأولاد من الاستمرار في ما يقومون به دون تعريضهم للخطر."
      ],
      id: 877
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0647. ما معنى الإشارة على سطح الطريق؟",
      numQues: "0647",
      correctAnswer: "خط وقوف (مكان وقوف للمركبات أو للحيوانات).",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3647.jpg",
      choices: [
        "خط توقف - مكان توقف المركبة عندما يجب التوقف.",
        "خط انتظار (في مكان لم تُنصب فيه إشارة).",
        "مكان لوقوف المركبات أمامك.",
        "خط وقوف (مكان وقوف للمركبات أو للحيوانات)."
      ],
      id: 878
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0394. بعد أية إشارة من الإشارات التالية يُمنع التجاوز (لمسافة حوالي 100م)؟",
      numQues: "0394",
      correctAnswer: "135",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3394.jpg",
      choices: [
        "130",
        "307",
        "132",
        "135"
      ],
      id: 879
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0365. أية إشارة تُحذر من ملتقى تفرع طرق إلى اليمين؟",
      numQues: "0365",
      correctAnswer: "205",
      pubDate: "10-11-2011 08:22:56",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3365.jpg",
      choices: [
        "119",
        "208",
        "115",
        "205"
      ],
      id: 880
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0364. لا تُجدد رخصة سياقة لسائق جديد كرخصة سياقة عادية إذا أُدين في المحكمة بمخالفة:",
      numQues: "0364",
      correctAnswer: "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "عدم التوقف على خط التوقف القريب من الإشارة الضوئية (الرمزور)",
        "عدم إطاعة الضوء الأحمر في الإشارة الضوئية (الرمزور) أو عدم إعطاء حق الأولوية.",
        "عدم وضع لافتة 'سائق جديد' على الزجاج الخلفي للمركبة.",
        "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول."
      ],
      id: 881
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0487. كيف تتصرف حسب الإشارة؟",
      numQues: "0487",
      correctAnswer: "أضئ الأضواء وابقَ على يمين الطريق.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3486.jpg",
      choices: [
        "تمهل، هناك إمكانية الالتقاء مع حركة مركبات زراعية ثقيلة وبطيئة. ",
        "استعمل الزامور بشكلٍ متواصل لتنبيه سائقي التراكتورات.",
        "أعطِ حق الأولوية للمركبات الزراعية في الطريق السريعة.",
        "أضئ الأضواء وابقَ على يمين الطريق."
      ],
      id: 882
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1260. هل يُسمح بدخول صالون عمومي بدون ركاب في طريق نُصبت فيها هذه الإشارة؟",
      numQues: "1260",
      correctAnswer: "كلا، لأنه لا يوجد فيه عدد الركاب الملزم بالإشارة.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3531.jpg",
      choices: [
        "كلا، لأن الصالون العمومي بدون ركاب لا يُستخدم كصالون عمومي.",
        "نعم، لأن الإشارة تسمح بالسير لجميع المركبات.",
        "نعم.",
        "كلا، لأنه لا يوجد فيه عدد الركاب الملزم بالإشارة."
      ],
      id: 883
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1132. كم مرة يتطلب فحص الفرامل للمركبة العمومية وفقاً للقانون؟",
      numQues: "1132",
      correctAnswer: "على الأقل مرة كل ستة أشهر، في كراج معتمد.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "على الأقل مرة كل 12 شهر، في كراج مرخص.",
        "على الأقل مرة واحدة في الشتاء، في كراج معتمد.",
        "على الأقل مرة واحدة في الصيف، في كراج معتمد.",
        "على الأقل مرة كل ستة أشهر، في كراج معتمد."
      ],
      id: 884
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0948. ما هي المشكلة في الصورة؟",
      numQues: "0948",
      correctAnswer: "وجود الورود في المحطة يسبب في أن يطيب البقاء للركاب ولا يسبب أية مشكلة.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3948.jpg",
      choices: [
        "تحجب الورود الموجودة في المحطة مدى الرؤية للركاب المنتظرين فيها.",
        "بسبب المركبة الواقفة،لا يستطيع الباص الدخول إلى خليجه في الشارع وهذا يتسبب في إعاقة حركة السير عند توقفه.",
        "يُسبب وجود بائع الورود بقاء الباص في المحطة لمدة أطول من اللازم.",
        "وجود الورود في المحطة يسبب في أن يطيب البقاء للركاب ولا يسبب أية مشكلة."
      ],
      id: 885
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0553. ماذا تعني الإشارة؟",
      numQues: "0553",
      correctAnswer: "مسموح الوقوف بالاتجاه المعاكس لحركة السير أيضاً.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3550.jpg",
      choices: [
        "على السائق الاستدارة على شكل حذوة فرس.",
        "دوار سير أمامك.",
        "نافورة تعمل.",
        "مسموح الوقوف بالاتجاه المعاكس لحركة السير أيضاً."
      ],
      id: 886
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0556. ما معنى الإشارة؟",
      numQues: "0556",
      correctAnswer: "لك حق الأولوية في الطريق القاطعة.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3556.jpg",
      choices: [
        "طريق للمركبات الميكانيكية فقط.",
        "شارع إلى اليمين بدون مخرج.",
        "مدخل خاص لمدارس أو رياض أطفال.",
        "لك حق الأولوية في الطريق القاطعة."
      ],
      id: 887
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1106. كيف تحرر ضغط الزيت الهيدراولي قبل فصل أنابيب تزويد الأجهزة والمعدات الأخرى؟",
      numQues: "1106",
      correctAnswer: "تفتح حنفيات التصريف لبضعة ثواني، لأن هذه هي وظيفتها.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "تنتظر بضعة دقائق والمحرك مطفأ وبعدها فقط تفصل الأنابيب.",
        "توصل ممر تفريغ الضغط الذي بين خط الإمداد وخط الراجع.",
        "تُشغل (أيدي) روافع التشغيل في جميع الاتجاهات عندما يكون المحرك مطفأ.",
        "تفتح حنفيات التصريف لبضعة ثواني، لأن هذه هي وظيفتها."
      ],
      id: 888
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0425. هل الإشارة المنصوبة في الطريق التي أمامك تُحدد قواعد إعطاء حق الأولوية؟",
      numQues: "0425",
      correctAnswer: "كلا، قواعد إعطاء حق الأولوية المنصوص عليها في القانون أو الشاخصات المنصوبة في المفترق هي التي تحدد واجب إعطاء حق الأولوية.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3423.jpg",
      choices: [
        "كلا، قواعد إعطاء حق الأولوية تحددها وطأة حركة السير.",
        "نعم، في المفترق المنصوبة فيه الإشارة، يُعطى حق الأولوية للمركبات العمومية فقط.",
        "نعم، في المفترق المنصوبة فيه الإشارة، يُعطى حق الأولوية للمركبات التي تواصل سيرها إلى الأمام فقط.",
        "كلا، قواعد إعطاء حق الأولوية المنصوص عليها في القانون أو الشاخصات المنصوبة في المفترق هي التي تحدد واجب إعطاء حق الأولوية."
      ],
      id: 889
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0337. ماذا يتوجب على السائق عمله عندما يطرأ تغيير على حالته الصحية؟",
      numQues: "0337",
      correctAnswer: "يجب تبليغ سلطة الترخيص خلال 20 يوماً.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "أن يبلغ عن ذلك لسلطة الترخيص.",
        "يجب تبليغ وزارة الصحة فوراً.",
        "يقوم بتبليغ سلطة الترخيص فقط إذا كان التغيير سببه حادث طرق.",
        "يجب تبليغ سلطة الترخيص خلال 20 يوماً."
      ],
      id: 890
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1767. أية مركبة يُسمح لها بالعبور عن مركبة أخرى من جهتها اليمنى؟",
      numQues: "1767",
      correctAnswer: "فقط إذا كان عرض الشارع أكثر من 12م.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "فقط المركبة البطيئة - في طريق بلدية.",
        "لمركبة التي تسير في المسلك المُعد للمواصلات العمومية.",
        "فقط للدراجات النارية إذا كان عرض الشارع أكثر من 6م.",
        "فقط إذا كان عرض الشارع أكثر من 12م."
      ],
      id: 891
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1379. ما هو 'ممر المشاة':",
      numQues: "1379",
      correctAnswer: "مكان عبور تلاميذ المدارس.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "كل مكان في الشارع اعتاد المشاة المرور به.",
        "قسم من الشارع مُعد بموجب وسم (تأشير) أو إشارة لعبور المشاة.",
        "جسر فوق سطح الشارع أو نفق مُعد لمرور المشاة.",
        "مكان عبور تلاميذ المدارس."
      ],
      id: 892
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1480. متى تعمل على المركبة القوة الطاردة المركزية (الطاردة عن المركز) ؟",
      numQues: "1480",
      correctAnswer: "عند السير بشكلٍ مستقيم في المنحدرات الشديدة.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "عند السير بشكلٍ مستقيم في الصعود الشديد.",
        "عند السير بخط مستقيم حتى وان كان الشارع أفقي.",
        "عندما تسير المركبة في منعطفات أو في استدارات.",
        "عند السير بشكلٍ مستقيم في المنحدرات الشديدة."
      ],
      id: 893
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1776. هل يُسمح بالسير على مساحة فاصلة؟",
      numQues: "1776",
      correctAnswer: "مسموح، بشرط أن يكون السير بحذر وبطيئاً.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "ممنوع.",
        "مسموح، فقط من اجل عبورها.",
        "مسموح، إذا كانت المساحة الفاصلة معبدة.",
        "مسموح، بشرط أن يكون السير بحذر وبطيئاً."
      ],
      id: 894
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0144. حسب ما يظهر في الصورة، عليك واجب:",
      numQues: "0144",
      correctAnswer: "استعمال الزامور.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3144.jpg",
      choices: [
        "التمهل.",
        "التوقف.",
        "الإسراع.",
        "استعمال الزامور."
      ],
      id: 895
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0740. كيف تسوق مركبة ذات صندوق غيارات أوتوماتكية في منحدر شديد وطويل؟",
      numQues: "0740",
      correctAnswer: "تمهل بالتناوب بمساعدة فرامل الرجل وانتقل إلى غيار واطئ حسب انحدار الطريق.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "انتقل إلى غيار عالي حسب انحدار الطريق واضغط بشكل متواصل على فرامل الرجل لتستمر في التمهل.",
        "في منحدر شديد وطويل أوقف المركبة وانتقل إلى غيار ملائم واستمر في السير.",
        "في منحدر شديد وطويل استعمل جهاز الفرامل فقط بدون أن تلائم الغيار.",
        "تمهل بالتناوب بمساعدة فرامل الرجل وانتقل إلى غيار واطئ حسب انحدار الطريق."
      ],
      id: 896
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0626. على سائق المركبة أن يخفف من سرعة سيره:",
      numQues: "0626",
      correctAnswer: "عندما يسوق في منحدر شديد أو طويل.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "عندما يتجاوز مركبة أخرى في شارع باتجاهين.",
        "عندما يصل إلى بداية صعود شديد.",
        "عندما يتجاوز مركبة أخرى في شارع باتجاه واحد.",
        "عندما يسوق في منحدر شديد أو طويل."
      ],
      id: 897
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0210. هل يجوز إيقاف مركبة بجانب مركبة أخرى واقفة بجانب الطريق؟",
      numQues: "0210",
      correctAnswer: "مسموح 'وقت الإنارة' فقط.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3210.jpg",
      choices: [
        "مسموح في طريق داخل المدن فقط.",
        "ممنوع منعاً باتاً.",
        "مسموح إذا كان المسلك اعرض من 2,5م.",
        "مسموح 'وقت الإنارة' فقط."
      ],
      id: 898
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0885. كم هو عدد المركبات التي أمامك حسب العلامات التي تشير إلى ذلك.",
      numQues: "0885",
      correctAnswer: "حسب الصورة، تسير أمامك المركبة الفضية فقط.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3885.jpg",
      choices: [
        "العلامات الدالة في الصورة لا تدل على عدد المركبات التي في الأمام.",
        "لا يمكن أن نعرف حسب الصورة كم عدد المركبات التي أمامك.",
        "مركبتان أمامك -بالإضافة إلى المركبة الفضية هناك ظل آخر أمامها.",
        "حسب الصورة، تسير أمامك المركبة الفضية فقط."
      ],
      id: 899
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1399. ما هو 'السبيل'؟",
      numQues: "1399",
      correctAnswer: "قسم من الطريق المُعد للمشاة فقط.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "قسم من الطريق المُعد لسير الدراجات الهوائية فقط.",
        "طريق سواءً كانت معبدة أو غير معبدة والمعدة للمركبات التي تسير على عجلتين فقط.",
        "طريق أو قسم من طريق خلاف الشارع خُصص لنوع معين من عابري الطريق.",
        "قسم من الطريق المُعد للمشاة فقط."
      ],
      id: 900
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1663. كيف نعبر عن عائق في الطريق عند ركوب الدراجة النارية؟",
      numQues: "1663",
      correctAnswer: "نتمهل قبل العائق.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "نفرمل بتعشيق الغيار النيوترال إلى ما بعد عبور العائق.",
        "لا نفرمل ونستمر بالسير كالمعتاد.",
        "نزيد السرعة ونعبر العائق بسرعة.",
        "نتمهل قبل العائق."
      ],
      id: 901
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1348. أية إشارة معناها 'طريق سريعة'؟",
      numQues: "1348",
      correctAnswer: "اشارة 216.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31348.jpg",
      choices: [
        "اشارة 219.",
        "اشارة 218.",
        "اشارة 217.",
        "اشارة 216."
      ],
      id: 902
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1486. ما هي السرعة القصوى المسموح بها لمركبة ركاب خصوصية في طريق بلدية (إذا لم تُنصب إشارة تدل على خلاف ذلك)؟",
      numQues: "1486",
      correctAnswer: "40كم/ساعة.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "60كم/ساعة.",
        "70كم/ساعة.",
        "50كم/ساعة.",
        "40كم/ساعة."
      ],
      id: 903
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1603. لماذا يجب الامتناع عن سياقة الدراجة النارية في وسط المسلك، ما عدا الأسباب المنصوصة في القانون؟",
      numQues: "1603",
      correctAnswer: "لأنه يجب المحافظة على اليسار والأخذ بعين الاعتبار راكبي الدراجات الآخرين. ",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "لا يوجد أي مانع من السير في وسط شارع باتجاهين أو في وسط المسلك الموسوم (المؤشر) في الشارع.",
        "لأن سائقي المركبات لا يحبون سير الدراجات النارية في وسط المسلك، الأمر الذي يُعرض راكب الدراجة النارية للخطر.",
        "لأن مركز المسلك هو المنطقة الأكثر قذارة والأكثر تلويثاً بالزيوت في الشارع.",
        "لأنه يجب المحافظة على اليسار والأخذ بعين الاعتبار راكبي الدراجات الآخرين. "
      ],
      id: 904
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0632. ما معنى الإشارة؟",
      numQues: "0632",
      correctAnswer: "ممنوع السير بسرعة تقل عن 30كم/ساعة.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3632.jpg",
      choices: [
        "بداية منطقة السرعة 30كم/ساعة.",
        "نهاية منطقة تباطؤ حركة السير.",
        "السرعة القصوى المسموح بها هي 30كم/ساعة.",
        "ممنوع السير بسرعة تقل عن 30كم/ساعة."
      ],
      id: 905
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1799. أي نوع مركبة نرى في الصورة وما هو طولها الإجمالي المسموح به في القانون؟",
      numQues: "1799",
      correctAnswer: "مركبة مترابطة، لها كابينة سائق فوق المحرك وطولها الإجمالي الأقصى المسموح به هو 16.50م .",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31799.jpg",
      choices: [
        "مركبة موصولة، لها كابينة سائق فوق المحرك وطولها الإجمالي الأقصى المسموح به هو 16.50م .",
        "مركبة موصولة، لها كابينة سائق فوق المحرك وطولها الإجمالي الأقصى المسموح به هو 17.60م .",
        "مركبة مترابطة، لها كابينة سائق فوق المحرك وطولها الإجمالي الأقصى المسموح به هو 17.60م .",
        "مركبة مترابطة، لها كابينة سائق فوق المحرك وطولها الإجمالي الأقصى المسموح به هو 16.50م ."
      ],
      id: 906
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0184. بماذا تأمر الإشارة؟",
      numQues: "0184",
      correctAnswer: "قف للحظة، افحص وضع حركة السير وتابع سيرك.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3184.jpg",
      choices: [
        "قف وأعطِ حق الأولوية.",
        "أعطِ حق الأولوية (لا توجد ضرورة بالتوقف).",
        "تمهل وأعطِ حق الأولوية.",
        "قف للحظة، افحص وضع حركة السير وتابع سيرك."
      ],
      id: 907
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1410. هل هناك واجب بوسم (تأشير) الحمولة البارزة من المركبة التي تسير في الطريق؟",
      numQues: "1410",
      correctAnswer: "نعم، هناك واجب بوسم (تأشير) الحمولة البارزة من المركبة دائماً.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "نعم، يجب وسم (تأشير) المركبة التي تبرز حمولتها من الأمام فقط.",
        "كلا، يجب وسم (تأشير) الحمولة البارزة من المركبة من قسمها الخلفي أو الأمامي، فقط إذا كان بروز الحمولة يزيد عن 150سم من المركبة.",
        "نعم، يجب وسم (تأشير) الحمولة البارزة من المركبة فقط في وقت الإنارة.",
        "نعم، هناك واجب بوسم (تأشير) الحمولة البارزة من المركبة دائماً."
      ],
      id: 908
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1447. أي نوع مركبات يُمنع من تجاوز مركبة متجاوزة؟",
      numQues: "1447",
      correctAnswer: "مركبة ميكانيكية وزنها الإجمالي أكثر 4000كغم.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "دراجة نارية.",
        "مركبة تجارية ومركبة عمل وزنهما الإجمالي المسموح به 3500كغم أو اقل. ",
        "مركبة تجارية ومركبة عمل والباص ماعدا الباص الصغير وزنهما الإجمالي المسموح به أكثر من 3500كغم .",
        "مركبة ميكانيكية وزنها الإجمالي أكثر 4000كغم."
      ],
      id: 909
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1200. اشر إلى الجملة الصحيحة بخصوص نقل ركاب يحملون سلاح مشحون:",
      numQues: "1200",
      correctAnswer: "مسموح نقل جندي يحمل سلاحاً مشحوناً فقط عندما يكون بلباسه الرسمي.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "مسموح فقط نقل شرطي في مهمة ويحمل سلاحاً مشحوناً.",
        "ممنوع نقل ركاب يحملون سلاح مشحون، ما عدا من يكون في مهمة رسمية تقتضي حمل السلاح المشحون في تلك اللحظة.",
        "ممنوع منعاً باتاً إدخال سلاح مشحون في الباص.",
        "مسموح نقل جندي يحمل سلاحاً مشحوناً فقط عندما يكون بلباسه الرسمي."
      ],
      id: 910
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0845. أية قوة من قوى الطبيعة تسعى إلى دفع المركبة خارج الانعطاف أثناء السياقة؟",
      numQues: "0845",
      correctAnswer: "القصور الذاتي (قوة الاستمرارية).",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "قوة الجاذبية.",
        "القوة الطاردة المركزية (الطاردة عن المركز).",
        "لا تعمل أية قوة من قوى الطبيعة على المركبة في المنعطفات.",
        "القصور الذاتي (قوة الاستمرارية)."
      ],
      id: 911
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1128. ما هو عدد الركاب الأقصى المسموح بنقلهم في مركبة صحراوية؟",
      numQues: "1128",
      correctAnswer: "ثمانية ركاب على الأقل",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "حسب المذكور في رخصة السواقة.",
        "حسب المذكور في رخصة المركبة.",
        "حسب المذكور في شهادة التأمين.",
        "ثمانية ركاب على الأقل"
      ],
      id: 912
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0734. أين يجب أن تُحفظ السترة العاكسة في المركبة (ما عدا الدراجة النارية)؟",
      numQues: "0734",
      correctAnswer: "في صندوق الحمولة للمركبة.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "في كابينة السائق في المركبة.",
        "بجانب العجلة الاحتياطية (السبير).",
        "في غرفة محرك المركبة.",
        "في صندوق الحمولة للمركبة."
      ],
      id: 913
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1608. كيف تؤثر مصابيح المقدمة غير النظيفة على سائق المركبة في الليل؟",
      numQues: "1608",
      correctAnswer: "تزيد من مدى الرؤية لديه.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "مصابيح المقدمة غير النظيفة لا تؤثر على الإطلاق على السائق أثناء السياقة.",
        "تضر بمدى الرؤية لديه.",
        "تسبب في بهر النظر الذاتي للسائق.",
        "تزيد من مدى الرؤية لديه."
      ],
      id: 914
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0521. ما هي السرعة القصوى المسموح بها لمركبة ركا ب خصوصي في منطقة نُصبت فيها الإشارة (إذا لم تكن هناك إشارة أخرى تشير إلى غير ذلك)؟",
      numQues: "0521",
      correctAnswer: "60كم/ساعة.",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3519.jpg",
      choices: [
        "50كم/ساعة.",
        "لا يوجد تحديد سرعة.",
        "30كم/ساعة. ",
        "60كم/ساعة."
      ],
      id: 915
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0050. في أية حالات يُسمح بحمل صور الشهادات في المركبة بدلاً عن شهادات المركبة الأصلية ؟",
      numQues: "0050",
      correctAnswer: "مسموح فقط إذا كانت المركبة مسجلة على اسم شركة وصادق على صحة سريان الوثائق على التصاوير ضابط السلامة بتوقيعه وختمه.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "لا يجوز في أي حال من الأحوال، يجب أن توجد في المركبة الشهادات الأصلية في كل وقت.",
        "يجوز فقط لشركة لنقل المركبات بأن يكون بحوزتها صور الرخص.",
        "مسموح بشرط أن تكون المركبة مسجلة على اسم شخص وصور الوثائق مطابقة للأصل حسب توقيع صاحب المركبة.",
        "مسموح فقط إذا كانت المركبة مسجلة على اسم شركة وصادق على صحة سريان الوثائق على التصاوير ضابط السلامة بتوقيعه وختمه."
      ],
      id: 916
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0054. أين يجب أن توضع لافتة 'سائق جديد' في المركبة ؟",
      numQues: "0054",
      correctAnswer: "على النافذة الجانبية اليسرى للمركبة في جوانبها العليا بحيث يتسنى رؤيتها من قِبل آخر من جهتها اليسرى.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "على النافذة الخلفية للمركبة، في جوانبها السفلى بحيث يتسنى للسائق الذي يسير خلفها من رؤيتها .",
        "في وسط النافذة الخلفية للمركبة، في جوانبها العليا، بحيث يتسنى رؤيتها من قِبل سائق آخر قادم من أية جهة. ",
        "على النافذة الجانبية اليمنى للمركبة في جوانبها السفلى بحيث يتسنى رؤيتها من قِبل آخر من جهتها اليمنى.",
        "على النافذة الجانبية اليسرى للمركبة في جوانبها العليا بحيث يتسنى رؤيتها من قِبل آخر من جهتها اليسرى."
      ],
      id: 917
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1770. خلاطة الباطون هي:",
      numQues: "1770",
      correctAnswer: "لا يوجد تعريف لمركبة الباطون.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "مركبة معدة لغرض معين.",
        "مركبة شحن.",
        "مركبة ميدان.",
        "لا يوجد تعريف لمركبة الباطون."
      ],
      id: 918
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0405. أية إشارة تظهر بعد الإشارة رقم: 705 ؟",
      numQues: "0405",
      correctAnswer: "703",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3405.jpg",
      choices: [
        "122",
        "701",
        "702",
        "703"
      ],
      id: 919
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0377. أية إشارة تحذير تُنصب عادةً قبل الإشارة رقم: 302 ؟",
      numQues: "0377",
      correctAnswer: "150",
      pubDate: "10-11-2011 08:22:57",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3377.jpg",
      choices: [
        "301",
        "139",
        "135",
        "150"
      ],
      id: 920
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0010. عرِّف 'الطريق' حسب القانون :",
      numQues: "0010",
      correctAnswer: "كل سكة حديد أو شارع أو زقاق أو ميدان أو ممر أو جسر أو أي مكان مفتوح يحق للجمهور المرور فيه.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "لا يوجد تعريف للطريق في القانون.",
        "كل مكان يحق للجمهور المرور فيه، ما عدا الشوارع البلدية.",
        "فقط الشوارع المعبدة بالإسفلت أو الباطون.",
        "كل سكة حديد أو شارع أو زقاق أو ميدان أو ممر أو جسر أو أي مكان مفتوح يحق للجمهور المرور فيه."
      ],
      id: 921
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1185. ما هي قواعد نقل أولاد في صالون عمومي يعمل على خط خدمة؟",
      numQues: "1185",
      correctAnswer: "ولد لغاية 5 سنوات يسافر مع شخص بالغ ويدفع 25% من التعرفة حسب التسعيرة رقم (1).",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "ليس أكثر من ولدين لم يتما الخامسة من عمرهما، السفر بدون أجرة، ويجلسان على ركبتي بالغين يدفعون الأجرة كاملة.",
        "ولدين مع شخص بالغ ويدفعان أجرة راكب واحد.",
        "كل ولدين يدفعان 25% من التعرفة حسب التسعيرة رقم (2). ",
        "ولد لغاية 5 سنوات يسافر مع شخص بالغ ويدفع 25% من التعرفة حسب التسعيرة رقم (1)."
      ],
      id: 922
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1421. هل يُسمح بنقل حاوية (كونتينر) في مركبة غير مجهزة بجهاز أقفال دوارة؟",
      numQues: "1421",
      correctAnswer: "كلا، يُمنع نقل حاوية (كونتينر) في مركبة غير مجهزة بجهاز أقفال دوارة.",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "نعم، مسموح نقل حاوية (كونتينر) في كل مركبة مجهزة بجانب أمامي مرتفع. ",
        "نعم، فقط بإذن من سلطة الترخيص.",
        "نعم، مسموح نقل حاوية (كونتينر) في كل مركبة مجهزة بكوابل تمكن من تثبيت الحاوية على المركبة بأمان.",
        "كلا، يُمنع نقل حاوية (كونتينر) في مركبة غير مجهزة بجهاز أقفال دوارة."
      ],
      id: 923
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0299. هل يجب على السائق إجراء 'فحص الزفير' (فحص بواسطة النفخ) حسب طلب الشرطي؟",
      numQues: "0299",
      correctAnswer: "نعم، وإلا يُعتبر وكأنه ساق في حالة ثمل (سكران). ",
      pubDate: "10-11-2011 08:22:57",
      img: "",
      choices: [
        "نعم، فقط بعد خروجه من البار فقط.",
        "نعم، بعد منتصف الليل فقط.",
        "كلا، غير ملزم.",
        "نعم، وإلا يُعتبر وكأنه ساق في حالة ثمل (سكران). "
      ],
      id: 924
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1584. ما هو عدد الركاب المسموح بركوبهم على الدراجة النارية ذات العجلتين وعلى الدراجة النارية ذات الثلاث عجلات، إضافة إلى سائقها؟",
      numQues: "1584",
      correctAnswer: "عدد الركاب المذكور في رخصة السياقة.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "بعدد المقاعد الملائمة لركوب راكب إضافي.",
        "عدد الركاب المسجل في تأمين الدراجة النارية.",
        "عدد الركاب الذي سمحت به سلطة الترخيص في رخصة المركبة.",
        "عدد الركاب المذكور في رخصة السياقة."
      ],
      id: 925
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1683. أين يجب الاحتفاظ بالسترة العاكسة في المركبة؟",
      numQues: "1683",
      correctAnswer: "لا يشير القانون إلى مكان الاحتفاظ بها.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "في كابينة السائق ما عدا في الدراجة النارية.",
        "فقط على ساندة رأس مقعد السائق.",
        "في صندوق الحمولة في المركبة.",
        "لا يشير القانون إلى مكان الاحتفاظ بها."
      ],
      id: 926
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1478. لا يجوز لأحد أن ينقل أو أن يسمح لغيره بنقل حاوية (كونتينر) في مركبته إلا إذا:",
      numQues: "1478",
      correctAnswer: "كان للمركبة عجلتان احتياطيتان (عجلتان سبير).",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "رُكب في المركبة محرك قوته 150 حصان على الأقل.",
        "كان الوزن الإجمالي المسموح به للمركبة 14000كغم على الأقل. ",
        "ذُكر في رخصة المركبة بأن المركبة مرخصة لنقل حاويات (كونتينرات).",
        "كان للمركبة عجلتان احتياطيتان (عجلتان سبير)."
      ],
      id: 927
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0910. كيف تتصرف على ضوء الوضع في الصورة؟",
      numQues: "0910",
      correctAnswer: "استمر في سيرك المعتاد، الأولاد أصحاب المسؤولية ولا يقطعون الشارع عند مشاهدتهم مركبة تقترب منهم.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3910.jpg",
      choices: [
        "انظر في المرايا وتمهل وتابع حركة الأولاد على جانبي الشارع وتوقف عند الضرورة لتجنب الأذى.",
        "زد من سرعتك واستعمل الزامور لإبعاد الأولاد عن الشارع لكي لا تصيبهم بأذى.",
        "استمر بالسير العادي: لا يوجد ممر للمشاة موسوم (مؤشر) على الشارع ولم تُنصب إشارة تدل على شارع مختلط (موحد). ",
        "استمر في سيرك المعتاد، الأولاد أصحاب المسؤولية ولا يقطعون الشارع عند مشاهدتهم مركبة تقترب منهم."
      ],
      id: 928
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0007. يجوز لضابط الشرطة سحب رخصة السياقة لمدة 60 يوماً؟",
      numQues: "0007",
      correctAnswer: "إذا تم ضبط السائق بالسير بسرعة تزيد عن السرعة القصوى المسموح بها.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "إذا كان للسائق دخل في حادث طرق أسفر عن إصابة شخص أو ضرر بمال وهناك شك معقول بتوجيه تهمة إليه.",
        "إذا ارتكب السائق مخالفة مرور بدون التسبب في وقوع حادث طرق.",
        "إذا ارتكب السائق مخالفة مرور أسفرت عن مقتل شخص.",
        "إذا تم ضبط السائق بالسير بسرعة تزيد عن السرعة القصوى المسموح بها."
      ],
      id: 929
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0033. عرِّف 'خط التوقف' :",
      numQues: "0033",
      correctAnswer: "خط على عرض الشارع أو على عرض قسم منه يشير إلى حدود توقف المركبات.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "خط على طول الشارع يشير إلى المكان الذي تقف عنده المركبة فقط في المفترقات التي فيها إشارات ضوئية.",
        "خط مفترق على طول الشارع أو على قسم من طوله يشير إلى المكان الذي تقف عنده المركبة بالقرب من الرصيف.",
        "خط على طول الشارع يشير إلى الحد الذي تقف عنده المركبة قبل ملتقى سكة حديد.",
        "خط على عرض الشارع أو على عرض قسم منه يشير إلى حدود توقف المركبات."
      ],
      id: 930
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0751. أنت تقترب من نفق مؤشر بإشارة سير وتريد تجاوز مركبة بطيئة تسير أمامك:",
      numQues: "0751",
      correctAnswer: "ممنوع التجاوز أو محاولة التجاوز في حدود 50م قبل النفق وبعده وفي داخل النفق",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3616.jpg",
      choices: [
        "ممنوع التجاوز أو محاولة التجاوز في حدود 250م قبل النفق. ",
        "ممنوع التجاوز أو محاولة التجاوز في حدود 100م قبل النفق. ",
        "مسموح التجاوز وحتى في داخل النفق إذا كانت هناك إضاءة كافية.",
        "ممنوع التجاوز أو محاولة التجاوز في حدود 50م قبل النفق وبعده وفي داخل النفق"
      ],
      id: 931
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1495. أية شروط يجب أن تتوفر من اجل نقل مواد خطرة؟",
      numQues: "1495",
      correctAnswer: "يجب أن يكون لدى السائق إذن مناسب وأن تكون المركبة حديثة (عمر المركبة ليس أكثر من أربع سنوات).",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "يجب أن تكون لدى السائق وللمركبة تصاريح مناسبة من قِبل سلطة الترخيص لنقل مواد خطرة.",
        "يجب أن يُصادق على النقل من قِبل وزارة الأمن الداخلي.",
        "يجب أن يكون للمركبة التي تنقل مادة خطرة محرك بنزين. ",
        "يجب أن يكون لدى السائق إذن مناسب وأن تكون المركبة حديثة (عمر المركبة ليس أكثر من أربع سنوات)."
      ],
      id: 932
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0777. لمن يُسمح بالسير على حواشي الطريق؟",
      numQues: "0777",
      correctAnswer: "يُسمح فقط للمركبة الخصوصية وللدراجة النارية بالسير على حواشي الطريق من اجل إعطاء حق الأولوية للباصات.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "لمركبة غير ميكانيكية وأيضاً لتراكتور ولمركبة بطيئة.",
        "يُسمح فقط للصالون العمومي (التاكسي) من اجل تجاوز المركبات الواقفة في المفترق.",
        "ممنوع لأي شخص استعمال حواشي الطريق.",
        "يُسمح فقط للمركبة الخصوصية وللدراجة النارية بالسير على حواشي الطريق من اجل إعطاء حق الأولوية للباصات."
      ],
      id: 933
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0806. ما هو تأثير السرعة العالية عند وقوع حادث طرق؟",
      numQues: "0806",
      correctAnswer: "ذلك يقصر كثيراً من زمن رد الفعل لدى السائق ويحسن السلامة.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "لا يوجد أي تأثير للسرعة العالية على نتيجة الحادث.",
        "تتسبب في قوة اصطدام اكبر وفي ضرر وإصابة اخطر.",
        "ذلك يطيل وقت رد الفعل وبذلك يحسن السلامة.",
        "ذلك يقصر كثيراً من زمن رد الفعل لدى السائق ويحسن السلامة."
      ],
      id: 934
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0249. عندما تسير خلف 'مركبة أمن'، عليك:",
      numQues: "0249",
      correctAnswer: "المحافظة على مسافة100م على الأقل من خلفها.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "المحافظة على مسافة150م على الأقل من خلفها.",
        "المحافظة على مسافة50م على الأقل من خلفها.",
        "المحافظة على مسافة2000م على الأقل من خلفها.",
        "المحافظة على مسافة100م على الأقل من خلفها."
      ],
      id: 935
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0055. ما هي المدة التي يجب على السائق الجديد السياقة فيها مع لافتة 'سائق جديد' ؟",
      numQues: "0055",
      correctAnswer: "9 أشهر.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "6 أشهر.",
        "سنتين وطالما هو سائق جديد.",
        "3 أشهر.",
        "9 أشهر."
      ],
      id: 936
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0072. هل يجوز سياقة مركبة فوراً بعد تناول أدوية لها تأثير على القدرة في السياقة ؟",
      numQues: "0072",
      correctAnswer: "مسموح لأن الأدوية لا تؤثر على مستوى السياقة.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "مسموح إذا كان تأثير الدواء يضر لمدة طويلة.",
        "ممنوع، إلا بعد انقضاء 4 ساعات على تناول الدواء.",
        "ممنوع.",
        "مسموح لأن الأدوية لا تؤثر على مستوى السياقة."
      ],
      id: 937
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1565. كيف يتصرف السائق عندما يطول زمن ملء خزانات جهاز الفرامل بالهواء؟",
      numQues: "1565",
      correctAnswer: "يفحص فلتر الوقود في الجهاز ويقوم بتنظيفه إذا اقتضت الضرورة.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "يخفض سرعة دوران المحرك وبهذا يزيد من نجاعة عمل الضاغطة (الكومبرسور). ",
        "يتوجه إلى كراج مرخص لإصلاح الخلل، بعد أن امتلأت الخزانات، بالسير البطيء وبحذر.",
        "ينتظر كلما تطلب الأمر ذلك لغاية امتلاء الخزانات، ويتجاهل المشكلة. ",
        "يفحص فلتر الوقود في الجهاز ويقوم بتنظيفه إذا اقتضت الضرورة."
      ],
      id: 938
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1043. ما هو الخطر من تعبئه خزان الوقود والمحرك يعمل ؟",
      numQues: "1043",
      correctAnswer: "يزيد المحرك الذي يعمل أثناء تعبئة الوقود من استهلاك الوقود.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "من شأن السخونة الزائدة للمحرك إشعال الوقود.",
        "لا يوجد أي خطر من إبقاء المحرك يعمل أثناء ملء المركبة بالوقود.",
        "اشتعال بخار الوقود بواسطة شرارة.",
        "يزيد المحرك الذي يعمل أثناء تعبئة الوقود من استهلاك الوقود."
      ],
      id: 939
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0951. أوقفت المركبة بجانب الرصيف على يمين الشارع في طريق بلدية:",
      numQues: "0951",
      correctAnswer: "عليك التأكد بأن الراكب في المقعد الخلفي من اليسار قد خرج من المركبة إلى الشارع بحذر شديد.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "عليك التأكد قبل الخروج من المركبة بأن خروجك لا يعرقل ولا يعرض للخطر أي شخص من من عابري الطريق.",
        "عليك إضاءة مصابيح الوقوف إذا لم تكن هناك إنارة في الشارع.",
        "عليك التأكد بأن المسافة بين المركبة وبين الرصيف لا تزيد عن متر واحد.",
        "عليك التأكد بأن الراكب في المقعد الخلفي من اليسار قد خرج من المركبة إلى الشارع بحذر شديد."
      ],
      id: 940
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0975. كيف تتصرف عند اقترابك من مكان كما هو مبين في الصورة؟",
      numQues: "0975",
      correctAnswer: "استعمل الزامور لتنبيه الواقفين بجانب المركبة، ووضح لهم أن في نيتك مواصلة السير بدون إزعاج.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3975.jpg",
      choices: [
        "توقف على يمين الطريق وانتظر لغاية قدوم فرق الإنقاذ.",
        "تمهل وانزل إلى الحاشية اليمنى، لغاية خلو المسلك المعاكس. ",
        "تمهل حتى إمكانية التوقف بسبب المشاة، وأعطِ حق الأولوية لحركة السير القادمة من الجهة المقابلة.",
        "استعمل الزامور لتنبيه الواقفين بجانب المركبة، ووضح لهم أن في نيتك مواصلة السير بدون إزعاج."
      ],
      id: 941
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1248. ما هي أجرة نقل عربة معاق في الصالون العمومي؟",
      numQues: "1248",
      correctAnswer: "مراقب النقل على الطرق يقرر شروط نقل عربة معاق وأجرة نقلها.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "يسمح بنقل عربة معاق ولكن يدفع نصف أجرة السفر في خط خدمة.",
        "ممنوع جباية أجرة إضافية عن نقل عربة معاق – لكن يحق للسائق أن يرفض نقل أكثر من عربة واحدة.",
        "محطة الخدمة تقرر شروط نقل عربة معاق وأجرة نقلها.",
        "مراقب النقل على الطرق يقرر شروط نقل عربة معاق وأجرة نقلها."
      ],
      id: 942
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1134. هل يُسمح لسائق باص عمومي الامتناع عن نقل راكب صعد إلى الباص إذا نفذت التذاكر لدى السائق على نفس الخط؟",
      numQues: "1134",
      correctAnswer: "نعم، لا يوجد واجب على السائق بنقل الراكب.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "كلا، على السائق نقل الراكب فقط في مقطع الطريق الذي يوجد له تذاكر فيه.",
        "كلا،على السائق نقل الراكب.",
        "نعم، يُمنع صعود الراكب إلى الباص.",
        "نعم، لا يوجد واجب على السائق بنقل الراكب."
      ],
      id: 943
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0445. ما معنى الإشارة ؟",
      numQues: "0445",
      correctAnswer: "انتبه! ملتقى سكة حديد.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3445.jpg",
      choices: [
        "انتبه! باص كهربائي أمامك.",
        "محطة قطار ركاب.",
        "انتبه! قطار محلي يعبر من الاتجاهين في الطريق.",
        "انتبه! ملتقى سكة حديد."
      ],
      id: 944
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0721. في الصورة التي أمامك:",
      numQues: "0721",
      correctAnswer: "عليك إعطاء حق الأولوية للمركبة الحمراء (1) التي تسير على الدوار.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3721.jpg",
      choices: [
        "لك حق الأولوية في دائماً (2).",
        "على سائق المركبة الحمراء (1) إعطاؤك حق الأولوية.",
        "لك حق الأولوية دائماً (2) لأنك قادم من اليمين.",
        "عليك إعطاء حق الأولوية للمركبة الحمراء (1) التي تسير على الدوار."
      ],
      id: 945
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0370. أمامك الإشارة رقم: 126 ، أية إشارة تُنصب في الطريق التي تندمج معها؟",
      numQues: "0370",
      correctAnswer: "115",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3370.jpg",
      choices: [
        "123",
        "301",
        "310",
        "115"
      ],
      id: 946
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1504. كيف نقوم بتثبيت حاوية (كونتينر) على مسطح التحميل في المركبة؟",
      numQues: "1504",
      correctAnswer: "بمساعدة سلسلتين مستقلتين كل واحدة منهما موصولة بمسطح التحميل.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "بمساعدة أجهزة 'الأقفال الدوارة' في المركبة فقط.",
        "بمساعدة كوابل من الفولاذ إذا لم تكن هناك أجهزة 'أقفال دوارة'.",
        "بمساعدة جوانب مسطح التحميل.",
        "بمساعدة سلسلتين مستقلتين كل واحدة منهما موصولة بمسطح التحميل."
      ],
      id: 947
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0248. كيف يتصرف السائق عندما يُشاهد 'مركبة امن'؟",
      numQues: "0248",
      correctAnswer: "يتمهل ويتوجه بمركبته إلى اليمين قريب لحافة الشارع ويتابع سيره كالمعتاد.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "يصعد على الرصيف ويتوقف هناك.",
        "يسير خلف مركبة الأمن ويحافظ على مسافة ثانيتين منه بشكلٍ ثابت.",
        "يتوجه بمركبته إلى اقرب ما يكون لحافة الشارع اليمنى، يعطي حق الأولوية 'لمركبة الأمن' ويتوقف بعيداً عن المفترق.",
        "يتمهل ويتوجه بمركبته إلى اليمين قريب لحافة الشارع ويتابع سيره كالمعتاد."
      ],
      id: 948
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0195. أية مركبة يجوز لها الوقوف على حاشية طريق ليست بلدية والمؤشر عليها كطريق رئيسية؟",
      numQues: "0195",
      correctAnswer: "قاطرة ومقطورة وساندة ومستندة لا يزيد عرضهم عن 3م.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "مركبة عمل أو تراكتور.",
        "المركبات التي تعمل في تنفيذ إشغال عامة والمركبات التابعة لجيش الدفاع الإسرائيلي - عند تأدية مهامها. ",
        "المركبات التي تعمل في بيع الخضراوات والفواكه لعابري الطريق.",
        "قاطرة ومقطورة وساندة ومستندة لا يزيد عرضهم عن 3م."
      ],
      id: 949
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1298. مصابيح المقدمة غير المُعَيَرة:",
      numQues: "1298",
      correctAnswer: "لا تنير الطريق حسب المطلوب في القانون.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "تسبب في بهر النظر الذاتي للسائق في الظلام.",
        "تزيد من يقظة السائق وبالأخص في الليل.",
        "لا تؤثر على السياقة في الظلام إيجاباً أو سلباً.",
        "لا تنير الطريق حسب المطلوب في القانون."
      ],
      id: 950
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1219. ما معنى الاشارة؟",
      numQues: "1219",
      correctAnswer: "يجوز لك زيادة السرعة، لأنك وصلت إلى نهاية النفق.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31219.jpg",
      choices: [
        "معبر ضيق مؤقت في الطريق التي أمامك.",
        "انتبه، قناة كبيرة امامك.",
        "نفق في الطريق التي أمامك.",
        "يجوز لك زيادة السرعة، لأنك وصلت إلى نهاية النفق."
      ],
      id: 951
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0313. 'شرب الكحول يشوش القدرة على ملائمة حركة أعضاء الجسم '، صحيح أم غير صحيح؟",
      numQues: "0313",
      correctAnswer: "غير صحيح، لا توجد علاقة بين شرب الكحول وبين القدرة على رد الفعل عند السائق.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "غير صحيح، الكحول تُحسن المعنوية.",
        "صحيح.",
        "غير صحيح، تُحسن الكحول من القدرة على التركيز.",
        "غير صحيح، لا توجد علاقة بين شرب الكحول وبين القدرة على رد الفعل عند السائق."
      ],
      id: 952
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0108. في المفترق الذي أمامك نُصبت إشارات سير وموسوم (مؤشر) كما في الرسم تماماً، ما هي الطريقة الصحيحة للاستدارة إلى اليمين من الشارع 'ب' إلى الشارع 'ج'؟",
      numQues: "0108",
      correctAnswer: "من المسلك '7' أو من المسلك '8' – إلى المسلك '6' أو إلى المسلك '5'.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3108.jpg",
      choices: [
        "من المسلك '7' – إلى المسلك '6' فقط.",
        "من المسلك '7' – إلى المسلك '6' أو إلى المسلك '5'.",
        "من المسلك '8' – إلى المسلك '6'.",
        "من المسلك '7' أو من المسلك '8' – إلى المسلك '6' أو إلى المسلك '5'."
      ],
      id: 953
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0169. كيف ينبغي أن نتصرف عندما نسوق خلف مركبة تعطي إشارة بواسطة الغماز؟",
      numQues: "0169",
      correctAnswer: "مواصلة السير دون تخفيف السرعة، المشكلة هي مشكلة معطي الإشارة. ",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "نأخذ يمين الشارع.",
        "مواصلة السير مع زيادة سرعة السير لتقصير زمن التصادم.",
        "علينا تمكين سائق المركبة التي أمامنا بتنفيذ العمل الذي قام بإعطاء الإشارة من اجله، والتمهل وحتى الوقوف عند الضرورة.",
        "مواصلة السير دون تخفيف السرعة، المشكلة هي مشكلة معطي الإشارة. "
      ],
      id: 954
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0165. متى وفي أي مكان يجب استعمال الغماز؟",
      numQues: "0165",
      correctAnswer: "تُعطى الإشارة بواسطة الغماز فقط في حالة وجود عابري طريق بالقرب من المكان. ",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "تُعطى الإشارة فقط قبل الاستدارة إلى اليمين أو إلى اليسار.",
        "في المكان والزمان بحيث يستطيع عابري الطريق الآخرين مشاهدة الإشارة المعطاة.",
        "تُعطى الإشارة بواسطة الغماز من مسافة 150م قبل الاستدارة. ",
        "تُعطى الإشارة بواسطة الغماز فقط في حالة وجود عابري طريق بالقرب من المكان. "
      ],
      id: 955
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0475. ما معنى الإشارة؟",
      numQues: "0475",
      correctAnswer: "انتبه! منحدر خطر.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3475.jpg",
      choices: [
        "مكان خطر لم تُحدد له إشارة خاصة.",
        "أعطِ حق الأولوية لكل مركبة في الطريق.",
        "انتبه ، آلة تصوير (كاميرا) سرعة أمامك.",
        "انتبه! منحدر خطر."
      ],
      id: 956
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1335. ما هو الارتفاع الأقصى لحمولة (عن سطح الطريق) والتي يجوز نقلها في مركبة تجارية وزنها الإجمالي لغاية 8000كغم؟",
      numQues: "1335",
      correctAnswer: "3.5م.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "3م.",
        "2.5م.",
        "4م.",
        "3.5م."
      ],
      id: 957
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0341. بأية شروط تصادق سلطة الترخيص على تسجيل نقل ملكية مركبة؟",
      numQues: "0341",
      correctAnswer: "بعد تلقي شهادة من مُسجل الرهونات بأنه لا يوجد على المركبة أي حجز أو رهن فقط.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "بعد أن قام البائع بالدفع وإبراز شهادة من مسجل الرهونات.",
        "بعد أن قام شاري المركبة بدفع الرسم المحدد في القانون بما في ذلك الأرنونة على مكان الوقوف.",
        "بعد أن ثبت للسلطة بأن جميع الرسوم والضرائب قد دُفعت وتمت إزالة أي حجز أو رهن ولا يوجد أي قيد آخر.",
        "بعد تلقي شهادة من مُسجل الرهونات بأنه لا يوجد على المركبة أي حجز أو رهن فقط."
      ],
      id: 958
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1138. ماذا ينص القانون بالنسبة لبيع التذاكر أو إرجاع بقية المبلغ من قِبل سائق مركبة عمومية ؟",
      numQues: "1138",
      correctAnswer: "مسموح بيع التذاكر أو إرجاع بقية المبلغ أثناء سير الباص.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "مسموح بيع التذاكر أو إرجاع بقية المبلغ - فقط إذا كان لدى السائق جهاز أوتوماتيكي لبيع التذاكر.",
        "ممنوع بيع التذاكر أو إرجاع بقية المبلغ أثناء سير الباص أو الصالون العمومي.",
        "مسموح إرجاع بقية المبلغ للركاب أثناء سير المركبات.",
        "مسموح بيع التذاكر أو إرجاع بقية المبلغ أثناء سير الباص."
      ],
      id: 959
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1501. لا يجب أن يقل عمق الأخاديد (الفرزات) في الإطار (الذي فيه ضغط هواء)، والملامس للطريق، عن:",
      numQues: "1501",
      correctAnswer: "2ملم، ما عدا العجل الاحتياطي (السبير).",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31501.jpg",
      choices: [
        "2ملم، بما في ذلك العجل الاحتياطي (السبير).",
        "2سم، ما عدا العجل الاحتياطي (السبير). ",
        "2سم، بما في ذلك العجل الاحتياطي (السبير). ",
        "2ملم، ما عدا العجل الاحتياطي (السبير)."
      ],
      id: 960
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1361. أية مركبة ملزمة بتركيب سلاسل أو كوابل ومصابيح في 'وقت الإنارة'؟",
      numQues: "1361",
      correctAnswer: "مركبة طولها الإجمالي أكثر من 20م وعرضها أكثر من 3 أمتار.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "المركبة التي تبرز فيها الحمولات الطويلة عن مسطح التحميل.",
        "كل مركبة تنقل حمولة بارزة وملزمة بإذن من ضابط الشرطة.",
        "مقطورة أو مستندة عرضها أكثر من 120سم والمعدة لنقل الحمولات الطويلة والتي لا توجد فيها أرضية أو جوانب.",
        "مركبة طولها الإجمالي أكثر من 20م وعرضها أكثر من 3 أمتار."
      ],
      id: 961
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0151. ما هي السرعة القصوى المسموح بها لسياقة مركبة ركاب خصوصية في طريق خارج المدن فيها مساحة فاصلة مبنية على امتدادها (إذا لم تنصب إشارة تأمر بغير ذلك)؟",
      numQues: "0151",
      correctAnswer: "100كم/ساعة.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3139.jpg",
      choices: [
        "110كم/ساعة.",
        "80كم/ساعة.",
        "90كم/ساعة.",
        "100كم/ساعة."
      ],
      id: 962
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1716. يُمنع نقل راكب إضافي في تراكتور حمولة، إلا إذا:",
      numQues: "1716",
      correctAnswer: "ذُكر ذلك في رخصة التراكتور.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "ذُكر ذلك في رخصة السياقة.",
        "ذُكر ذلك في شهادة التأمين.",
        "صدر إذن بذلك من مستورد المركبة.",
        "ذُكر ذلك في رخصة التراكتور."
      ],
      id: 963
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0922. كيف يتصرف سائق مركبة عندما يتوقف باص ينقل أولاداً من اجل اصعاد الأولاد أو إنزالهم؟",
      numQues: "0922",
      correctAnswer: "يقف دائماً خلف الباص إلى أن يواصل الباص سيره.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3922.jpg",
      choices: [
        "يتجاوز الباص كالمعتاد حسب جميع مراحل التجاوز المتبعة.",
        "يتمهل حتى إمكانية التوقف ويعبر ببطء عن الباص.",
        "يستعمل الزامور بشكلٍ متواصل ويقوم بالتجاوز مثل التجاوز العادي.",
        "يقف دائماً خلف الباص إلى أن يواصل الباص سيره."
      ],
      id: 964
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0934. ما هي الخطورة المباشرة في مقطع الطريق التي أمامك؟",
      numQues: "0934",
      correctAnswer: "لا يجوز لك التوقف على يمين الشارع.",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3933.jpg",
      choices: [
        "ظهور مركبة في المساحة المحجوبة عن عينيك والتي تسير في مسلك سيرك.",
        "سخونة المحرك الشديدة بسبب الصعود الشديد.",
        "يمنعك الخط الفاصل من التجاوز أو الاستدارة.",
        "لا يجوز لك التوقف على يمين الشارع."
      ],
      id: 965
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0770. كيف يتعامل السائق مع كثرة العمليات التي يجب أن يقوم بها عند اقترابه من مفترق؟",
      numQues: "0770",
      correctAnswer: "يحذر مستعملي الطريق الآخرين عن اقترابه من المفترق (بواسطة استعمال الزامور والإشارة بواسطة الأضواء).",
      pubDate: "10-11-2011 08:22:58",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3770.jpg",
      choices: [
        "التمهل قبل المفترق وملاحظة ما يجري من حوله وعدم الانشغال في أية عملية غير السياقة.",
        "يزيد من السرعة من اجل تقصير مدة عبور المفترق.",
        "يتجاهل مستعملي الطريق الآخرين – بالأخص مستعمليه الصغار.",
        "يحذر مستعملي الطريق الآخرين عن اقترابه من المفترق (بواسطة استعمال الزامور والإشارة بواسطة الأضواء)."
      ],
      id: 966
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1494. لمن يجوز نقل مواد خطرة؟",
      numQues: "1494",
      correctAnswer: "فقط من تم تأهيله لهذا الغرض وحصل على إذنٍ من وزارة المواصلات.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "كل من تم تأهيله لهذا الغرض وحصل على إذنٍ من الجهة التي أهلته.",
        "كل من يجوز له سياقة مركبة وزنها الإجمالي المسموح به أكثر من 12000كغم.",
        "من أنهى بنجاح دورة لسياقة مركبات ثقيلة.",
        "فقط من تم تأهيله لهذا الغرض وحصل على إذنٍ من وزارة المواصلات."
      ],
      id: 967
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1254. من يُحدد أجرة السفر عن سفرة خاصة في الصالون العمومي؟",
      numQues: "1254",
      correctAnswer: "النقابة القطرية لسائقي مركبات الصالون العمومي.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "وزير المالية – بأمرٍ خاص.",
        "وزير المواصلات.",
        "وزير الصناعة والتجارة والاستخدام.",
        "النقابة القطرية لسائقي مركبات الصالون العمومي."
      ],
      id: 968
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1763. هل الإشارة المتنقلة مع عضو في دوريات الحذر على الطرق تُلزم السائق على الشارع بإطاعتها؟",
      numQues: "1763",
      correctAnswer: "كلا، الإشارة غير ملزمة، وهي في إطار التوصية فقط.",
      pubDate: "10-11-2011 08:22:58",
      img: "",
      choices: [
        "كلا، لأنه لم يصادق عليها من قِبل دائرة الترخيص.",
        "نعم، هذه إشارة قانونية وعلى السائق إطاعتها.",
        "كلا، لأن قياساتها اصغر من قياسات الإشارات العادية.",
        "كلا، الإشارة غير ملزمة، وهي في إطار التوصية فقط."
      ],
      id: 969
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0609. ماذا تعني أحجار الحافة المدهونة باللون الأحمر والأصفر؟",
      numQues: "0609",
      correctAnswer: "الوقوف مسموح بواسطة بطاقات وقوف.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3609.jpg",
      choices: [
        "ممنوع أي توقف، ما عدا أنواع المركبات التي سُمح بتوقفها بواسطة إشارة.",
        "مسموح وقوف المركبات العمومية بدون قيود.",
        "وسم (تعليم) للتأكيد ولإظهار الأرصفة ذوات الارتفاعات المختلفة. ",
        "الوقوف مسموح بواسطة بطاقات وقوف."
      ],
      id: 970
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1528. كيف يجب عليك التصرف عندما تسير في شارع ضيق وفجأة قدمت مركبة أخرى من الاتجاه المعاكس:",
      numQues: "1528",
      correctAnswer: "تضيء أنوار المقدمة العالية لكي تؤشر للسائق المقابل من اجل أن يعود إلى مسلكه.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "تتمهل وتنحرف على قدر الإمكان إلى اليمين وحتى النزول عن الشارع إذا اقتضت الضرورة.",
        "تتمهل وتنحرف إلى اليمين على قدر الإمكان لكن لا تخرج عن الشارع.",
        "تستعمل الزامور وتعطي إشارة باليدين للسائق الذي انحرف كي يعود إلى مسلكه. ",
        "تضيء أنوار المقدمة العالية لكي تؤشر للسائق المقابل من اجل أن يعود إلى مسلكه."
      ],
      id: 971
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0670. ماذا تعني الإشارة؟",
      numQues: "0670",
      correctAnswer: "اندمج بحركة السير في المسلك المجاور من اليمين أو من اليسار.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3670.jpg",
      choices: [
        "مسلك مغلق، ممنوع السير في المسلك الذي نُصبت الإشارة فوقه.",
        "استدارة التواء حاد إلى اليسار أو إلى اليمين.",
        "أشغال في الشارع - سر باتجاه السهم الملائم.",
        "اندمج بحركة السير في المسلك المجاور من اليمين أو من اليسار."
      ],
      id: 972
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0285. في أية حالات يسمح بسياقة مركبة في منحدر وفي غيار النيوترال؟",
      numQues: "0285",
      correctAnswer: "ممنوع في جميع الأحوال، عند السياقة في منحدر يجب أن يكون احد الغيارات معشقاً وشغال.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "مسموح الانتقال إلى غيار النيوترال في كل طريق ليست بلدية وفيها منحدرات معتدلة الانحدار وذلك من اجل التوفير في الوقود.",
        "مسموح الانتقال إلى غيار النيوترال في المنحدر، في المركبة العمومية والباص والصالون العمومي في طريق ليست بلدية فقط.",
        "يجوز الانتقال إلى غيار النيوترال في منحدر معتدل الانحدار والذي لا يوجد فيه خطر سخونة الفرامل وذلك من اجل التوفير في الوقود.",
        "ممنوع في جميع الأحوال، عند السياقة في منحدر يجب أن يكون احد الغيارات معشقاً وشغال."
      ],
      id: 973
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1788. هل يجوز لسلطة الترخيص (مكتب الترخيص) تعطيل تجديد رخصة سياقة لصاحب رخصة ملزم بدفع غرامة؟",
      numQues: "1788",
      correctAnswer: "نعم، يجوز لها التعطيل بسبب كل غرامة فُرضت من قِبل جهة حكومية.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "نعم، يجوز لسلطة الترخيص التعطيل بشرط أن تشمل الغرامة أيضاً تسجيل نقاط حسب طريقة النقاط في المرور.",
        "كلا، لا يجوز لسلطة الترخيص تعطيل تجديد رخصة سياقة بدون موافقة صاحب رخصة السياقة.",
        "نعم، بشرط أن تكون الغرامة قد فُرضت بسبب مخالفة سير.",
        "نعم، يجوز لها التعطيل بسبب كل غرامة فُرضت من قِبل جهة حكومية."
      ],
      id: 974
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0688. يجب أن تكون الإطارات المركبة على نفس المحور في المركبة:",
      numQues: "0688",
      correctAnswer: "لها نفس اللون.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "من نفس المنتج.",
        "من نفس تاريخ الإنتاج دائماً.",
        "لها نفس القياس وحسب أوامر منتج المركبة.",
        "لها نفس اللون."
      ],
      id: 975
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0101. في الرسم الذي أمامك نرى طريق عريضة، بأي رقم موسوم (مؤشر) المسلك في الرسم؟",
      numQues: "0101",
      correctAnswer: "6",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3082.jpg",
      choices: [
        "4",
        "3",
        "7",
        "6"
      ],
      id: 976
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0786. ما هو المشترك بين هذه الإشارات؟",
      numQues: "0786",
      correctAnswer: "منصوبة فقط في طريق سريعة.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3786.jpg",
      choices: [
        "منصوبة فقط في مواقع أشغال.",
        "منصوبة فقط في طريق بلدية.",
        "منصوبة فقط في طريق ليست بلدية.",
        "منصوبة فقط في طريق سريعة."
      ],
      id: 977
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1070. تقوم رخصة خط لتشغيل باص بتنظيم:",
      numQues: "1070",
      correctAnswer: "تفاصيل الباص وحجمه.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "فقط مجرى الخط المسجل فيه الباص.",
        "فقط سعر السفرة في خط الخدمة.",
        "الخدمة في الخط.",
        "تفاصيل الباص وحجمه."
      ],
      id: 978
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1740. هل يُسمح بدفع مركبة دون تشغيل محركها إلى شارع يُمنع دخول المركبات فيه؟",
      numQues: "1740",
      correctAnswer: "مسموح، لكن يجب الصعود على الرصيف.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "مسموح، عندما يعمل المحرك والغيار في وضع نيوترال.",
        "مسموح، عندما لا يعمل المحرك.",
        "كلا، ممنوع تسييرها حتى ولو بالدفع، وحُكم الدافع كحُكم سائق المركبة.",
        "مسموح، لكن يجب الصعود على الرصيف."
      ],
      id: 979
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0131. هل يُسمح بمجاوزة أو بمحاولة تجاوز مركبة أخرى في حدود 100م قبل خط سكة حديد؟",
      numQues: "0131",
      correctAnswer: "مسموح، إذا كانت المركبة المنوي تجاوزها تراكتور.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "ممنوع منعاً باتاً.",
        "مسموح إذا كانت المركبة المنوي تجاوزها دراجة نارية.",
        "مسموح، عندما لا يُرى القطار أو يُسمع. ",
        "مسموح، إذا كانت المركبة المنوي تجاوزها تراكتور."
      ],
      id: 980
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0223. ما هي المسافة القصوى من الرصيف المسموح بها عند إيقاف مركبة بموازاة حافة الشارع؟",
      numQues: "0223",
      correctAnswer: "70سم.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "40سم",
        "50سم.",
        "60سم.",
        "70سم."
      ],
      id: 981
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0408. كيف تتصرف إذا نُصبت الإشارة الظاهرة في الصورة في الطريق التي أمامك؟",
      numQues: "0408",
      correctAnswer: "زد من سرعة سيرك وبذلك تمنع اهتزازات المركبة.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3407.jpg",
      choices: [
        "أطع أوامر عمال الأشغال العامة.",
        "تمهل ولائم السرعة لوضع الطريق ولا تتجاهل الشارع المشوش. ",
        "سر بالغيار الواطئ أنت تسوق في طريق جبلية.",
        "زد من سرعة سيرك وبذلك تمنع اهتزازات المركبة."
      ],
      id: 982
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1688. إذا انقضت مدة السنتين 'للسائق الجديد' ، لا تصدر رخصة سواقة عادية 'لسائق جديد' إذا أُدين بمخالفة في المحكمة:",
      numQues: "1688",
      correctAnswer: "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31688.jpg",
      choices: [
        "عدم وضع لافتة 'سائق جديد' على الزجاج الخلفي للمركبة.",
        "عدم التوقف في مكان نُصبت فيه الإشارة 'أحجار متدحرجة'.",
        "التجاوز خلافاً للقانون.",
        "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول."
      ],
      id: 983
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0081. في أي نوع شارع يجب استعمال الجهة اليمنى القصوى منه ؟",
      numQues: "0081",
      correctAnswer: "فقط في شارع لا يقع داخل المدن.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3079.jpg",
      choices: [
        "فقط في شارع باتجاهين.",
        "فقط في شارع باتجاه واحد فقط.",
        "في كل شارع.",
        "فقط في شارع لا يقع داخل المدن."
      ],
      id: 984
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0790. إذا قام شرطي بتحرير مخالفة لك على 'الانحراف عن المسلك' ولا يوجد في الشارع أي وسم (تأشير) للمسالك، هل الشرطي محق؟",
      numQues: "0790",
      correctAnswer: "كلا، إذا كان المسلك غير موسوم (مؤشر) فيمكن السير في أي قسم من الشارع.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "نعم، 'المسلك' يمكن أن يكون موسوم (مؤشر) أو غير موسوم.",
        "كلا، لا يمكن 'الانحراف' عن مسلك غير موسم (مؤشر).",
        "كلا، يسمح القانون بالانحراف عن المسلك بدون أي تحديد.",
        "كلا، إذا كان المسلك غير موسوم (مؤشر) فيمكن السير في أي قسم من الشارع."
      ],
      id: 985
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0181. كيف تتصرف عند اقترابك من مفترق نُصبت قبله إشارة تأمر بالوقوف؟",
      numQues: "0181",
      correctAnswer: "قف وأعطِ حق الأولوية للمركبة التي تدخل أو التي تقترب من المفترق من شارع آخر.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3181.jpg",
      choices: [
        "عليك التوقف فقط إذا أمر شرطي بذلك.",
        "عليك التوقف فقط عندما تسير مركبات من اليمين في الطريق القاطعة.",
        "أعطِ حق الأولوية للمركبة (الأخرى) التي تدخل أو تقترب من المفترق من شارع آخر.",
        "قف وأعطِ حق الأولوية للمركبة التي تدخل أو التي تقترب من المفترق من شارع آخر."
      ],
      id: 986
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1475. ما هي المستندة حسب القانون:",
      numQues: "1475",
      correctAnswer: "مركبة ميكانيكية معدة حسب مبناها للجر بواسطة مركبة أخرى.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "أية مقطورة كانت يمكن أن يستند قسمها الخلفي على ساندة.",
        "مقطورة ميكانيكية مبنية بشكلٍ يستند قسمها الأمامي على قاطرة.",
        "مقطورة مبنية بشكلٍ يستند قسمها الأمامي على ساندة.",
        "مركبة ميكانيكية معدة حسب مبناها للجر بواسطة مركبة أخرى."
      ],
      id: 987
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1710. هل يُسمح بالصعود والسير على الرصيف بمركبة خصوصية من اجل تجاوز عائق وُجد على الطريق؟",
      numQues: "1710",
      correctAnswer: "نعم، مسموح تجاوز العائق بواسطة السير على الرصيف.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "كلا، ممنوع السير على الرصيف من اجل تجاوز عائق.",
        "نعم، مسموح الصعود والسير على الرصيف وبحذر شديد وفي الغيار الأول.",
        "نعم، مسموح الصعود على الرصيف في تراكتور، إذا كان الشارع مشوشاً جداً.",
        "نعم، مسموح تجاوز العائق بواسطة السير على الرصيف."
      ],
      id: 988
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1798. أين يسري واجب تخفيف سرعة المركبة؟",
      numQues: "1798",
      correctAnswer: "في منطقة التروي (تخفيف السرعة) لحركة السير.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "عند السير في طريق ليست بلدية فيها مساحة فاصلة مبنية.",
        "عند السير في طريق ليست بلدية.",
        "عند السير في طرق رئيسية.",
        "في منطقة التروي (تخفيف السرعة) لحركة السير."
      ],
      id: 989
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1197. ما هي الجملة الصحيحة بالنسبة لواجب النقل وأجرة السفر في المركبة العمومية؟",
      numQues: "1197",
      correctAnswer: "مسموح تلقي أجرة أكثر من الأجرة المحددة لتلك السفرة –إذا كان السائق تعباً. ",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "هناك واجب باصعاد كل راكب مستعد لدفع أجرة السفر.",
        "هناك واجب باصعاد كل راكب ويُسمح بتلقي أجرة أكثر من الأجرة المحددة – بموافقة الراكب.",
        "لا يوجد واجب بنقل كل راكب، ويُمنع تلقي أجرة أكثر من الأجرة المحددة لتلك السفرة. ",
        "مسموح تلقي أجرة أكثر من الأجرة المحددة لتلك السفرة –إذا كان السائق تعباً. "
      ],
      id: 990
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1611. لماذا تقل السيطرة على الدراجة النارية عند الدخول في منعطف؟",
      numQues: "1611",
      correctAnswer: "لأن تماسك الإطار مع الشارع يتغير عندما يقوم السائق بتمييل الدراجة النارية.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "لأن مكان راكب الدراجة النارية منخفض أكثر من المعتاد.",
        "لأنه يجب الإسراع بالدراجة النارية طيلة وقت الانعطاف.",
        "لأن الدراجة النارية في وضع تباطؤ طيلة كل وقت الانعطاف.",
        "لأن تماسك الإطار مع الشارع يتغير عندما يقوم السائق بتمييل الدراجة النارية."
      ],
      id: 991
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1115. ما هو عدد الركاب الأقصى المسموح بنقلهم في الباص الصغير (أوتوبوس زعير)؟",
      numQues: "1115",
      correctAnswer: "20 راكباً ما عدا السائق.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "بقدر عدد أحزمة الأمان في المركبة.",
        "كعدد المقاعد في المركبة. ",
        "كما هو مذكور في رخصة المركبة.",
        "20 راكباً ما عدا السائق."
      ],
      id: 992
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0817. ما هو تأثير المحافظة على مسافة من المركبة التي أمامك أثناء السياقة، على استهلاك الوقود واستهلاك المركبة؟",
      numQues: "0817",
      correctAnswer: "كلما كانت المسافة من المركبة التي في الأمام اصغر، يقل اهتراء الفرامل ويقل استهلاك الوقود.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "المحافظة على مسافة مناسبة من المركبة التي أمامك متعلقة بالاستعمال الدائم للفرامل، وبذلك تسبب في اهتراء سريع للفرامل.",
        "المحافظة على مسافة مناسبة ضرورية فقط من اجل منع الحوادث، ولا يوجد لها تأثير على استهلاك المركبة أو على استهلاك الوقود.",
        "المحافظة على مسافة مناسبة تقلل من اهتراء الفرامل وتقلل من استهلاك الوقود للمحرك.",
        "كلما كانت المسافة من المركبة التي في الأمام اصغر، يقل اهتراء الفرامل ويقل استهلاك الوقود."
      ],
      id: 993
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0268. لا يجوز 'لسائق جديد' لم يتم 21 سنة من عمره أن ينقل في المركبة:",
      numQues: "0268",
      correctAnswer: "أكثر من ثلاثة ركاب، بالإضافة إليه، إلا إذا جلس مرافق بجانبه.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "أكثر من راكبين اثنين، بالإضافة إليه، إلا إذا جلس مرافق بجانبه في المقعد الأمامي.",
        "أكثر من أربعة ركاب، بالإضافة إليه، إلا إذا جلس مرافق بجانبه.",
        "أكثر من راكب واحد فقط.",
        "أكثر من ثلاثة ركاب، بالإضافة إليه، إلا إذا جلس مرافق بجانبه."
      ],
      id: 994
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1545. ما هي 'المقطورة' حسب القانون:",
      numQues: "1545",
      correctAnswer: "مركبة تعطلت في الطريق وتم جرها بواسطة مركبة أخرى لتخليصها.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "مركبة ميكانيكية معد حسب مبناها للجر بواسطة مركبة ميكانيكية خلفها.",
        "مقطورة ميكانيكية مبنية بشكلٍ يستند قسمها الأمامي على ساندة.",
        "مركبة غير ميكانيكية معد للجر بواسطة مركبة ميكانيكية خلفها.",
        "مركبة تعطلت في الطريق وتم جرها بواسطة مركبة أخرى لتخليصها."
      ],
      id: 995
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0469. كيف تتصرف حسب الإشارة؟",
      numQues: "0469",
      correctAnswer: "قف ودع الأولاد الذين يعبرون من إكمال عبورهم لممر المشاة.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3468.jpg",
      choices: [
        "استمر بالسير حتى ولو كان هناك مشاة يعبرون.",
        "قف دائماً ودع الأولاد وكبار السن يصلون إلى ممر المشاة وعبوره بأمان. ",
        "تمهل وانتبه إذا كان هناك مشاة يعبرون ممر المشاة الذي أمامك.",
        "قف ودع الأولاد الذين يعبرون من إكمال عبورهم لممر المشاة."
      ],
      id: 996
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0715. كيف تسوق (مركبة رقم 2) في المفترق الذي أمامك؟",
      numQues: "0715",
      correctAnswer: "توقف (2) قبل الدخول إلى المفترق وتفحص وضع حركة السير والإشارات.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3715.jpg",
      choices: [
        "أعطِ حق الأولوية للمركبة الصفراء (1) لأنها قادمة من اليمين.",
        "انتظر ودع المركبة الصفراء (1) تعبر قبلك.",
        "استمر في سيرك بحذر، مع المحافظة على اتصال بصري مع المركبة الصفراء (1)، عليه إعطاؤك حق الأولوية.",
        "توقف (2) قبل الدخول إلى المفترق وتفحص وضع حركة السير والإشارات."
      ],
      id: 997
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0881. كيف يتصرف سائق المركبة الخارج من طريق ترابية وينوي الدخول إلى الطريق المعبدة؟",
      numQues: "0881",
      correctAnswer: "يدخل إلى الطريق المعبدة: المركبة الخارجة من طريق ترابية لها الأفضلية على المركبات التي تسير في الطريق المعبدة.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3881.jpg",
      choices: [
        "يدع حركة السير القادمة من يمينه بأن تواصل طريقها دون إعاقة، ويدخل الطريق.",
        "يُمكِن المركبات التي تسير في الطريق المعبدة عن يمينه وعن يساره بأن تواصل طريقها دون إعاقة من طرفه، وحينها يدخل إلى الطريق.",
        "يستعمل الزامور ويعطي إشارة بالضوء المتقطع ويدخل إلى الطريق المعبدة.",
        "يدخل إلى الطريق المعبدة: المركبة الخارجة من طريق ترابية لها الأفضلية على المركبات التي تسير في الطريق المعبدة."
      ],
      id: 998
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0472. كيف تتصرف حسب الإشارة؟",
      numQues: "0472",
      correctAnswer: "استعمل الزامور بصورة متواصلة قبل الإشارة.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3471.jpg",
      choices: [
        "تمهل وكن مستعداً للفرملة أو الانحراف بسبب المشاة الموجودين في الجوار.",
        "أعطِ حق الأولوية لحركة السير القادمة من الاتجاه المعاكس.",
        "زد من سرعة السير واعبر المكان بسرعة.",
        "استعمل الزامور بصورة متواصلة قبل الإشارة."
      ],
      id: 999
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0366. وسائل الإصلاح الإدارية التي تفرضها سلطة الترخيص حسب طريقة النقاط:",
      numQues: "0366",
      correctAnswer: "هذه توصيات فقط، حسب طريقة النقاط، المحكمة فقط مخولة بفرض وسائل الإصلاح.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "تأتي بالإضافة إلى كل عقوبة أخرى فرضتها المحكمة على سائق المركبة بسبب مخالفة مرور.",
        "لا تشمل سحب رخصة السياقة (فقط ضابط الشرطة يجوز له سحب رخصة السياقة).",
        "إذا لم يكن هناك مكان للإدانة على مخالفة مرور.",
        "هذه توصيات فقط، حسب طريقة النقاط، المحكمة فقط مخولة بفرض وسائل الإصلاح."
      ],
      id: 1000
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0396. أية إشارة من الإشارات التالية لا ينهيها المفترق القريب؟",
      numQues: "0396",
      correctAnswer: "504",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3396.jpg",
      choices: [
        "426",
        "432",
        "424",
        "504"
      ],
      id: 1001
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1280. يجري إصعاد التلاميذ إلى الباص المعد لنقل التلاميذ وإنزالهم منه:",
      numQues: "1280",
      correctAnswer: "من الباب الأمامي الأيمن فقط.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "من الباب الأمامي ومن الباب والخلفي.",
        "من الباب الخلفي فقط.",
        "الاصعاد – من الباب الأمامي، الإنزال – من الباب الخلفي.",
        "من الباب الأمامي الأيمن فقط."
      ],
      id: 1002
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0125. هل يجوز لك العبور عن مركبة أخرى من جهتها اليمنى؟",
      numQues: "0125",
      correctAnswer: "نعم، عندما تسير بسرعة أعلى من المركبة الأخرى. ",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "نعم،عندما تسير المركبة الأخرى ببطء. ",
        "نعم، عندما تعطي المركبة الأخرى، التي تسير أمامك، إشارة إلى اليمين. ",
        "نعم، عندما تسير في مسلك للمواصلات العمومية. ",
        "نعم، عندما تسير بسرعة أعلى من المركبة الأخرى. "
      ],
      id: 1003
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1756. إذا نُصبت إشارة على مسافة 100م قبل ملتقى سكة حديد وأمامك تسير مركبة بطيئة:",
      numQues: "1756",
      correctAnswer: "مسموح تجاوز المركبة فقط إذا كانت السرعة لا تزيد عن 35كم/ساعة.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "ممنوع تجاوز المركبة إلى ما بعد عبور الملتقى.",
        "مسموح تجاوز المركبة فقط إذا كانت الطريق من الجهة المقابلة خالية.",
        "مسموح تجاوز المركبة قبل الملتقى.",
        "مسموح تجاوز المركبة فقط إذا كانت السرعة لا تزيد عن 35كم/ساعة."
      ],
      id: 1004
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0912. حسب الإشارات، ماذا يجب أن نتوقعه؟",
      numQues: "0912",
      correctAnswer: "مكان لعبور المشاة.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3912.jpg",
      choices: [
        "ملتقى سكة حديد – بعد أن استدرنا إلى اليسار.",
        "ملتقى سكة حديد – إذا تابعنا السير إلى الأمام.",
        "الدخول إلى طريق بلدية.",
        "مكان لعبور المشاة."
      ],
      id: 1005
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1334. ما هو الارتفاع الأقصى لحمولة (عن سطح الطريق) والتي يجوز نقلها في مركبة تجارية وزنها الإجمالي لغاية 3500كغم؟",
      numQues: "1334",
      correctAnswer: "3م.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "3.5م.",
        "2.5م.",
        "4م.",
        "3م."
      ],
      id: 1006
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1381. على السائق الذي يريد إيقاف مركبته في منحدر:",
      numQues: "1381",
      correctAnswer: "أن يوجه العجلات الخلفية باتجاه الرصيف ويُعشِق غيار النيوترال.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "أن يوجه العجلات الأمامية باتجاه الرصيف ويُعشِق غيار النيوترال (N).",
        "أن يوجه العجلات الأمامية باتجاه الرصيف ويُعشق الغيار الأول.",
        "أن يوجه العجلات الأمامية باتجاه الرصيف ويُعشق الغيار الخلفي (في الاوتوماتيك- P)",
        "أن يوجه العجلات الخلفية باتجاه الرصيف ويُعشِق غيار النيوترال."
      ],
      id: 1007
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0219. كيف توقف مركبة في منحدر؟",
      numQues: "0219",
      correctAnswer: "استخدم فرامل الوقوف (الهاندبريك) ووجه العجلات الأمامية لجهة حافة الشارع وعَشِق الغيار الخلفي (ما عدا المركبة ذات الغيارات الأوتوماتيكية). ",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "استخدم فرامل الوقوف (الهاندبريك) ووجه العجلات الأمامية لجهة وسط الشارع. ",
        "وجِه العجلات الأمامية لجهة حافة الشارع وعشِق الغيار الأمامي (في مركبة ذات غيارات أوتوماتكية –P).",
        "أضئ مصابيح الوقوف ووجه العجلات الأمامية لجهة حافة الشارع وعشِق الغيار الخلفي.",
        "استخدم فرامل الوقوف (الهاندبريك) ووجه العجلات الأمامية لجهة حافة الشارع وعَشِق الغيار الخلفي (ما عدا المركبة ذات الغيارات الأوتوماتيكية). "
      ],
      id: 1008
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1270. هل يُسمح لباص عمومي صغير بدون ركاب السير في المسلك الموسوم (المؤشر) كمسلك للمواصلات العمومية؟",
      numQues: "1270",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31269.jpg",
      choices: [
        "نعم بين الساعات 21:00 لغاية 05:39 أيام عُطَل الأعياد فقط.",
        "نعم، أيام السبت والأعياد فقط.",
        "نعم.",
        "كلا."
      ],
      id: 1009
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0974. الإشارة الضوئية(الرمزور) باتجاه سيرك تضيء بالضوء الأخضر، ماذا يتوجب عليك عمله عند الاقتراب منه؟",
      numQues: "0974",
      correctAnswer: "يجب تجاهل مركبة المعاق الواقفة على اليمين – واجب الحذر بأكمله يسري عليه.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3974.jpg",
      choices: [
        "يجب الانتباه من خطر ظهور ماشي من بين المركبات الواقفة.",
        "يجب الاقتراب بحذر وعبور المفترق بسرعة",
        "يجب الانتباه التام فقط للضوء الظاهر في الإشارة الضوئية (الرمزور) فقط.",
        "يجب تجاهل مركبة المعاق الواقفة على اليمين – واجب الحذر بأكمله يسري عليه."
      ],
      id: 1010
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0571. ما معنى الإشارة؟",
      numQues: "0571",
      correctAnswer: "ممنوع توقف مركبات الصالون العمومي في هذا المكان وما بعده.",
      pubDate: "10-11-2011 08:22:59",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3571.jpg",
      choices: [
        "ممنوع التوقف والوقوف لأية مركبة.",
        "نهاية حدود محطة الصالون العمومي (التاكسي).",
        "ممنوع وقوف أية مركبة إلا من اجل إنزال الركاب.",
        "ممنوع توقف مركبات الصالون العمومي في هذا المكان وما بعده."
      ],
      id: 1011
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1502. واجب سائق مركبة تنقل حمولة بارزة ولا يمكن تجاوزها هو:",
      numQues: "1502",
      correctAnswer: "إذا كان بالإمكان - النزول ما بعد حافة الشارع وحتى التوقف على الحاشية.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "إيقاف مركبته وتوجيه حركة سير المركبات الأخرى لكي يتجاوزوه.",
        "الإشارة باليد للمسافرين خلفه أن بإمكانهم التجاوز.",
        "الاستمرار في السير بالسرعة العادية، على يمين الشارع، ممنوع النزول إلى الحاشية.",
        "إذا كان بالإمكان - النزول ما بعد حافة الشارع وحتى التوقف على الحاشية."
      ],
      id: 1012
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "0991. كيف تتصرف إذا سخنت الفرامل زيادة عن اللازم أثناء الفرملة المتواصلة ؟",
      numQues: "0991",
      correctAnswer: "استمر بالسير السريع لكي تُبرد الفرامل.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "استعمل بشكلٍ مؤقت الفرامل المساعدة (الهاندبريك).",
        "توقف ! انتظر إلى أن تبرد الفرامل.",
        "استمر بالسير العادي وقلل من استعمال الفرامل.",
        "استمر بالسير السريع لكي تُبرد الفرامل."
      ],
      id: 1013
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0011. ما هو 'وقت الإنارة' حسب القانون :",
      numQues: "0011",
      correctAnswer: "فترة الوقت التي يتوجب فيها تشغيل جهاز الإنارة في المركبة في طريق خارج المدن.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "الليل وأي وقت آخر تكون فيه الرؤية مشوشة بسبب حالة الطقس أو لأية أسباب أخرى.",
        "فقط فترة الليل من غروب الشمس وحتى شروقها.",
        "فترة الوقت التي تكون فيها الإنارة طبيعية ولا توجد حاجة لإضاءة مصابيح المركبة.",
        "فترة الوقت التي يتوجب فيها تشغيل جهاز الإنارة في المركبة في طريق خارج المدن."
      ],
      id: 1014
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1630. كيف تتجاوز مركبة أخرى عند سياقة دراجة نارية؟",
      numQues: "1630",
      correctAnswer: "عن يمين المركبة المراد مجاوزتها وقريب منها على قدر الإمكان.",
      pubDate: "10-11-2011 08:22:59",
      img: "",
      choices: [
        "بأسرع ما يمكن – حتى ولو تجاوزت السرعة القصوى المسموح بها للحظة قصيرة - إذا كان ذلك ضرورياً .",
        "عن يسار المركبة المراد مجاوزتها مع المحافظة على مسافة جانبية كبيرة على قدر الإمكان.",
        "بشكلٍ يمكن معه رؤية المركبة التي نتجاوزها بالمرآتين في كل لحظة.",
        "عن يمين المركبة المراد مجاوزتها وقريب منها على قدر الإمكان."
      ],
      id: 1015
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0253. هل يجوز سياقة مركبة ميكانيكية في طريق داخل المدن ومصابيح مقدمتها تضيء 'بالضوء العالي'؟",
      numQues: "0253",
      correctAnswer: "مسموح.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "ممنوع.",
        "مسموح فقط في النهار.",
        "ممنوع إلا إذا كانت الطريق غير مضاءة كما يجب ولا يوجد خطر بهر النظر.",
        "مسموح."
      ],
      id: 1016
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1360. في أية مركبات يجب أن توجد مطفأة حريق؟",
      numQues: "1360",
      correctAnswer: "في المركبة الميكانيكية ما عدا مركبة الركاب الخصوصية والتراكتور والدراجة النارية.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "فقط في المركبة التي تسير على عجلتين.",
        "في كل مركبة ميكانيكية.",
        "فقط في مركبة الركاب الخصوصية.",
        "في المركبة الميكانيكية ما عدا مركبة الركاب الخصوصية والتراكتور والدراجة النارية."
      ],
      id: 1017
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1406. إذا أمر شرطي سائق مركبة بإحضارها للتوزين، على من تكون نفقات التوزين إذا كان الوزن أكثر من المسموح به؟",
      numQues: "1406",
      correctAnswer: "على دولة إسرائيل.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "على سائق المركبة.",
        "على السائق، غير أن وزارة الصناعة والتجارة والاستخدام تُعيد 50% إذا كان الوزن حسب القانون.",
        "على الشرطي.",
        "على دولة إسرائيل."
      ],
      id: 1018
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0274. كيف يتصرف سائق مركبة له دخل في حادث طرق أصيب فيه شخص؟",
      numQues: "0274",
      correctAnswer: "يخلي الشارع من مركبته إذا لم يكن مذنباً في الحادث وتقع المسؤولية تباعاً على الشخص الثاني الذي له دخل في الحادث.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "يخلي الشارع من مركبته كي لا يسبب عرقلة لحركة السير في الطريق ويستدعي فرق الإنقاذ.",
        "يخلي الشارع ويقوم بتبليغ الشرطة عن الحادث.",
        "لا يُحرك مركبته إلا إذا أمر شرطي بذلك أو إذا كانت هناك ضرورة لاستعمال المركبة من اجل إخلاء المصابين.",
        "يخلي الشارع من مركبته إذا لم يكن مذنباً في الحادث وتقع المسؤولية تباعاً على الشخص الثاني الذي له دخل في الحادث."
      ],
      id: 1019
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0064. هل يجب إطاعة أوامر وإشارات شرطي من الشرطة العسكرية في لباسه الرسمي ؟",
      numQues: "0064",
      correctAnswer: "بشكلٍ عام ، كلا.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "كلا، فقط لأجل إيقاف المركبة.",
        "كلا، فقط فيما يخص إبراز رخصة السياقة.",
        "نعم، مثله مثل الشرطي المدني.",
        "بشكلٍ عام ، كلا."
      ],
      id: 1020
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1079. كيف تتصرف إذا أشارت ساعة حرارة المحرك إلى حرارة محرك أعلى من اللازم؟",
      numQues: "1079",
      correctAnswer: "تستمر بالسير بسرعة بطيئة للحصول على تهوية شديدة من اجل تبريد المحرك.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "تستمر بالسير السريع للحصول على تهوية شديدة من اجل تبريد المحرك.",
        "تتوقف وتُمكن المحرك من العمل بدورات متوسطة لكي يبرد، وإذا لم يبرد المحرك قم بإطفائه. ",
        "تطفئ المحرك وتبعد الركاب عن المكان وتطلب المساعدة.",
        "تستمر بالسير بسرعة بطيئة للحصول على تهوية شديدة من اجل تبريد المحرك."
      ],
      id: 1021
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1764. على سائق المركبة الذي يخرج من محطة وقود أن يعطي حق الأولوية:",
      numQues: "1764",
      correctAnswer: "فقط للمركبة التي تسير بسرعة كبيرة.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "فقط للمركبة القادمة من اليسار.",
        "فقط للمركبة القادمة من اليمين.",
        "لكل مركبة تقترب في الشارع ومن أي اتجاه كان.",
        "فقط للمركبة التي تسير بسرعة كبيرة."
      ],
      id: 1022
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1029. يُسبب ضغط هواء اقل من اللازم في الإطارات في:",
      numQues: "1029",
      correctAnswer: "استهلاك قليل للوقود.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "اهتراء سريع لجهاز الفرامل.",
        "مقود سهل التشغيل.",
        "سخونة الإطارات أكثر من اللازم.",
        "استهلاك قليل للوقود."
      ],
      id: 1023
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1568. هل يُسمح بإجراء تغييرات في مبنى المركبة أو نوعها ؟",
      numQues: "1568",
      correctAnswer: "يجوز لصاحب المركبة إدخال تغييرات في المركبة حسب رغبته.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "مسموح، فقط بإذنٍ مسبق وخطي من سلطة الترخيص.",
        "مسموح إذا تم إجراء التغيير من قِبل كراج معتمد.",
        "مسموح، بشرط أن يبلغ عن ذلك خطيا وبشكلٍ مسبق منتج أو وكيل المركبة.",
        "يجوز لصاحب المركبة إدخال تغييرات في المركبة حسب رغبته."
      ],
      id: 1024
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1465. هل يجب أن يكون في كل صالون عمومي جهاز لمنع إقفال العجلات (ABS)؟",
      numQues: "1465",
      correctAnswer: "كلا، فقط مركبات الصالون العمومي داخل المدن مُلزمة بذلك.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "كلا، يسري الواجب فقط على الباصات وعلى مركبات الركاب الخصوصية.",
        "كلا، يسري الواجب فقط على الباصات وعلى المركبات التجارية.",
        "نعم.",
        "كلا، فقط مركبات الصالون العمومي داخل المدن مُلزمة بذلك."
      ],
      id: 1025
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0669. ما معنى السهم الأخضر الظاهر في الإشارة الضوئية (الرمزور)؟",
      numQues: "0669",
      correctAnswer: "يجوز لك الاستمرار في السير فقط باتجاه السهم. ",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3669.jpg",
      choices: [
        "تقدم إلى الأمام أو إلى اليمين فقط.",
        "اعبر واخلي المفترق بسرعة، لأي اتجاه تنوي السفر نحوه.",
        "الاستدارة باتجاه السهم مسموحة للمركبات العمومية فقط.",
        "يجوز لك الاستمرار في السير فقط باتجاه السهم. "
      ],
      id: 1026
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0700. في المفترق الذي أمامك لا توجد فيه إشارات، ما هو ترتيب دخول المركبات التي وصلت مع بعض إلى المفترق، حسب قواعد إعطاء حق الأولوية؟",
      numQues: "0700",
      correctAnswer: "المركبة الخضراء (1)، بعدها أنت (3) وتدخل المركبة الحمراء (2) في الآخر.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3700.jpg",
      choices: [
        "تدخل أنت أولاً (3) وبعدها المركبة الحمراء (2) وتدخل المركبة الخضراء (1) الأخيرة.",
        "تدخل المركبة الخضراء (1) أولاً وبعدها تدخل المركبة الحمراء (2) وتدخل أنت في الآخر (3).",
        "الترتيب بسيط – من يصل أولاً يسير أولاً.",
        "المركبة الخضراء (1)، بعدها أنت (3) وتدخل المركبة الحمراء (2) في الآخر."
      ],
      id: 1027
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0593. ما معنى الإشارة؟",
      numQues: "0593",
      correctAnswer: "مكان عبور المشاة حوالي 150م أمامك.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3593.jpg",
      choices: [
        "أعط حق الأولوية للمشاة في المكان المؤشر فية ممر المشاة.",
        "جسر علوي للمشاة.",
        "سبيل للمشاة فقط.",
        "مكان عبور المشاة حوالي 150م أمامك."
      ],
      id: 1028
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0644. ما معنى الإشارة على سطح الطريق؟",
      numQues: "0644",
      correctAnswer: "ممنوع الاستدارة إلى اليسار من المسلك الأيسر.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3644.jpg",
      choices: [
        "مسموح السير إلى الأمام فقط.",
        "لك حق الأولوية في الطريق الضيقة بالنسبة لحركة السير القادمة من الاتجاه المعاكس.",
        "تغيير الغاية من المسلك الأيسر.",
        "ممنوع الاستدارة إلى اليسار من المسلك الأيسر."
      ],
      id: 1029
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1343. ما هي السرعة القصوى المسموح بها لمركبة عمل ولمركبة تجارية يزيد وزنها الإجمالي المسموح به عن 12000كغم؟",
      numQues: "1343",
      correctAnswer: "السرعة المسموحة لكل مركبة أخرى تسير على الشارع.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "40كم/ساعة في طريق بلدية و 80كم/ساعة في طريق ليست بلدية و 90كم/ساعة في طريق مع مساحة فاصلة.",
        "50كم/ساعة في طريق بلدية ، و 90كم/ساعة في طريق مع مساحة فاصلة مبنية.",
        "50كم/ساعة في طريق بلدية ، و 80كم/ساعة في كل طريق أخرى.",
        "السرعة المسموحة لكل مركبة أخرى تسير على الشارع."
      ],
      id: 1030
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«A»"
      ],
      title: "0498. حسب الإشارة، هل يُسمح لدراجة نارية أن تتجاوز مركبة ركاب خصوصية؟",
      numQues: "0498",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3497.jpg",
      choices: [
        "يجوز فقط إذا كان الشارع باتجاه واحد.",
        "كلا.",
        "يجوز في ساعات النهار فقط.",
        "نعم."
      ],
      id: 1031
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0857. هل الاستراحة القصيرة للانتعاش أثناء السياقة تستطيع أن تهدئ التعب؟",
      numQues: "0857",
      correctAnswer: "نعم، استراحة قصيرة تمنع التعب تماماً.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "كلا، استراحة قصيرة غير مفيدة على الإطلاق لتقليل التعب.",
        "نعم، استراحة لبضع دقائق تمكن من سياقة متواصلة لساعات عديدة.",
        "نعم - لفترة قصيرة.",
        "نعم، استراحة قصيرة تمنع التعب تماماً."
      ],
      id: 1032
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0470. أية إشارة تأتي بعد الإشارة 135 التي في الصورة؟",
      numQues: "0470",
      correctAnswer: "901",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3470.jpg",
      choices: [
        "226",
        "413",
        "306",
        "901"
      ],
      id: 1033
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1216. 'مركبة لنقل التلاميذ' هي:",
      numQues: "1216",
      correctAnswer: "كل باص مُسجل في مكتب سفريات.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "كل مركبة تنقل تلاميذ.",
        "كل باص ومركبة عمومية تعمل على خط خدمة.",
        "باص خصوصي أو مركبة عمومية تُستخدم لنقل التلاميذ.",
        "كل باص مُسجل في مكتب سفريات."
      ],
      id: 1034
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1604. كيف تسوق دراجة نارية عندما لا يكون هناك مناص وعليك عبور بقعة من الزيوت على الشارع؟",
      numQues: "1604",
      correctAnswer: "تتمهل برفق بمساعدة الفرملة الخلفية أثناء العبور كله.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "تتمهل بشدة لكن بشكلٍ متساوٍ بين الفرملة الخلفية وبين الفرملة الأمامية إلى أن تعبر المنطقة الملوثة بالزيوت.",
        "تستمر بالسير بشكلٍ مستقيم إلى الأمام، بدون فرملة وبدون تسارع واضغط على دعسة (يد) الكلاتش.",
        "تتمهل برفق بمساعدة الفرملة الأمامية أثناء العبور كله.",
        "تتمهل برفق بمساعدة الفرملة الخلفية أثناء العبور كله."
      ],
      id: 1035
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0598. ما معنى الإشارة؟",
      numQues: "0598",
      correctAnswer: "محطة انتعاش للسائقين.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3598.jpg",
      choices: [
        "محطة إسعاف أولي.",
        "محطة لمركبات الإسعاف الخاصة.",
        "موقف لمركبة إسعاف فقط.",
        "محطة انتعاش للسائقين."
      ],
      id: 1036
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0490. ما معنى الإشارة؟",
      numQues: "0490",
      correctAnswer: "شارع مغلق من الاتجاهين أمام جميع المركبات.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3490.jpg",
      choices: [
        "ممنوع الدخول إلى المسلك الموسوم (المؤشر) تحت الإشارة.",
        "ممنوع الدخول لمركبة غير ميكانيكية – (شارع باتجاه واحد).",
        "ممنوع الدخول للمركبات الميكانيكية – (شارع باتجاه واحد).",
        "شارع مغلق من الاتجاهين أمام جميع المركبات."
      ],
      id: 1037
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0464. ما معنى الإشارة؟",
      numQues: "0464",
      correctAnswer: "صعود (طلوع) خطر.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3464.jpg",
      choices: [
        "منحدر حاد.",
        "صعود (طلوع) حاد.",
        "شارع بدون مخرج.",
        "صعود (طلوع) خطر."
      ],
      id: 1038
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0726. كيف يجب عليك التصرف في بقية الطريق التي أمامك؟",
      numQues: "0726",
      correctAnswer: "سر في المسلك الأيمن فقط.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3726.jpg",
      choices: [
        "توقف تحت السهم الأخضر.",
        "بعد اللافتات يُسمح لك باستعمال جميع المسالك.",
        "سر في احد المسلكين الأيمنين.",
        "سر في المسلك الأيمن فقط."
      ],
      id: 1039
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "0293. هل يُسمح ببروز الحمولة من الأمام أو من الخلف في مركبة يزيد وزنها الإجمالي المسموح به عن 15,000كغم؟",
      numQues: "0293",
      correctAnswer: "مسموح من الخلف دون تحديد الطول.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "مسموح بشرط أن تكون الحمولة وحدة طولية واحدة على أن لا يتعدى البروز ثلث مسطح التحميل.",
        "مسموح فقط بالعرض بشرط أن توضع لافتة 'انتبه حمولة عريضة'.",
        "غير مسموح إلا بإذن من ضابط الشرطة فقط.",
        "مسموح من الخلف دون تحديد الطول."
      ],
      id: 1040
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1333. لا تصدر ولا تُجدد رخصة لمركبة تخليص وجر وزنها الإجمالي المسموح به لغاية 16.000كغم:",
      numQues: "1333",
      correctAnswer: "لا يوجد تحديد في القانون بالنسبة لتجديد رخصة مركبة كهذه.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "بعد انقضاء 8 سنوات على سنة إنتاجها.",
        "بعد انقضاء 19 سنة على سنة إنتاجها.",
        "بعد انقضاء 10 سنوات على سنة إنتاجها.",
        "لا يوجد تحديد في القانون بالنسبة لتجديد رخصة مركبة كهذه."
      ],
      id: 1041
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0315. 'شرب الكحول يزيد من زمن الانتعاش من بهر النظر'. صحيح أم غير صحيح؟",
      numQues: "0315",
      correctAnswer: "هذا صحيح بالنسبة لصغار السن فقط.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "غير صحيح.",
        "هذا صحيح بالنسبة لمستعملي النظارات فقط.",
        "صحيح.",
        "هذا صحيح بالنسبة لصغار السن فقط."
      ],
      id: 1042
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0831. ما هي الخطوات التي عليك اتخاذها قبل النزول المخطط له إلى الحاشية في طريق ليست بلدية؟",
      numQues: "0831",
      correctAnswer: "النظر، وبالأخص إلى الخلف، وإعطاء الإشارة بواسطة الغماز والتمهل باعتدال.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "ما عدا إعطاء غماز إلى اليمين في الوقت - لا توجد ضرورة بأي شيء إضافي.",
        "التمهل وإدارة المقود بشكلٍ باتجاه حاشية الطريق مع في وقتٍِ قصير على قدر الإمكان.",
        "التمهل وتشغيل الأربعة غمازات في المركبة.",
        "النظر، وبالأخص إلى الخلف، وإعطاء الإشارة بواسطة الغماز والتمهل باعتدال."
      ],
      id: 1043
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1302. على المركبة التي تنقل حمولة أن توسَم (تؤشَر) بلافتة 'انتبه حمولة عريضة':",
      numQues: "1302",
      correctAnswer: "إذا كان عرض الحمولة أكثر من 2,50م.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "إذا كان عرض الحمولة أكثر من 2,10م.",
        "إذا كان عرض الحمولة اقل من 2.40م.",
        "إذا كان عرض الحمولة أكثر من 1,80م.",
        "إذا كان عرض الحمولة أكثر من 2,50م."
      ],
      id: 1044
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1067. تُستخدم الفرملة المساعدة (الهاندبريك):",
      numQues: "1067",
      correctAnswer: "كفرملة طوارئ أيضاًَ (لكن قدرتها محدودة).",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "لمساعدة السائق عند الرجوع إلى الخلف.",
        "لتقليل تآكل جهاز الفرامل.",
        "لفرملة المركبة أثناء السير في منحدر.",
        "كفرملة طوارئ أيضاًَ (لكن قدرتها محدودة)."
      ],
      id: 1045
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0441. ما معنى الإشارة ؟",
      numQues: "0441",
      correctAnswer: "إشارة تحذير قبل محطة قطار.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3441.jpg",
      choices: [
        "ملتقى سكة حديد.",
        "ملتقى سكة حديد أكثر من خط واحد.",
        "إشارة تحذير قبل 500م من ملتقى سكة حديد.",
        "إشارة تحذير قبل محطة قطار."
      ],
      id: 1046
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1246. متى لا يسمح السائق أو بائع التذاكر صعود راكب إلى الباص؟",
      numQues: "1246",
      correctAnswer: "إذا كان الراكب ينتعل في رجليه جهاز يستعمل للتزلج أو التزحلق",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "إذا كان معه ورقة نقدية من فئة 100 شيكل جديد وأجرة السفر هي 12 شيكل جديد فقط.",
        "عندما يطلب السفر مسافة محطة واحدة فقط.",
        "إذا أراد اصعاد كلب أو أي حيوان آخر.",
        "إذا كان الراكب ينتعل في رجليه جهاز يستعمل للتزلج أو التزحلق"
      ],
      id: 1047
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0709. كيف تتصرف (مركبة رقم 3) في المفترق الذي أمامك؟",
      numQues: "0709",
      correctAnswer: "أعطِ حق الأولوية للدراجة النارية فقط (2).",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3709.jpg",
      choices: [
        "أعطِ حق الأولوية لراكب الدراجة النارية (2) وللباص الأصفر (1).",
        "أعطِ حق الأولوية للباص الأصفر فقط (1). ",
        "سر إلى الأمام بحذر وعلى سائقي المركبتين (1 و 2) إعطاؤك حق الأولوية. ",
        "أعطِ حق الأولوية للدراجة النارية فقط (2)."
      ],
      id: 1048
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0520. ماذا يميز الطريق التي تأتي بعد الإشارة المنصوبة؟",
      numQues: "0520",
      correctAnswer: "هذه الطرق تمر بكيبوتس أو بقرية زراعية فقط.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3519.jpg",
      choices: [
        "هذه الطرق توصل بين مدن رئيسية.",
        "يوجد بعدها طرق تمر بمنطقة بلدية بما في ذلك الأحياء السكنية وفيها حركة مشاة.",
        "أنت تدخل إلى منطقة فيها أشغال في الطريق.",
        "هذه الطرق تمر بكيبوتس أو بقرية زراعية فقط."
      ],
      id: 1049
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1243. في أي نوع مركبات يجب أن تعمل الإنارة الداخلية 'وقت الإنارة'؟",
      numQues: "1243",
      correctAnswer: "في كل مركبة تجارية تنقل ركاب بالأجرة.",
      pubDate: "10-11-2011 08:23:00",
      img: "",
      choices: [
        "في الباص.",
        "ليس في أي نوع مركبة: ممنوع تشغيل الإنارة الداخلية، لأن الضوء ينعكس من الزجاج الأمامي ويزعج السائق.",
        "في الصالون العمومي.",
        "في كل مركبة تجارية تنقل ركاب بالأجرة."
      ],
      id: 1050
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0629. ما هي السرعة القصوى المسموح بها في حدود ما بعد الإشارة؟",
      numQues: "0629",
      correctAnswer: "60كم/ساعة.",
      pubDate: "10-11-2011 08:23:00",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3628.jpg",
      choices: [
        "50كم/ساعة.",
        "30كم/ساعة.",
        "20كم/ساعة.",
        "60كم/ساعة."
      ],
      id: 1051
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0349. ما معنى الإشارة؟",
      numQues: "0349",
      correctAnswer: "نهاية حدود محطة الصالون العمومي.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3571.jpg",
      choices: [
        "بداية حدود محطة الصالون العمومي.",
        "محطة صالون عمومي، ممنوع الدخول إلى الشارع الذي نُصبت فيه الإشارة.",
        "محطة صالون عمومي، ممنوع توقف أو وقوف المركبات الأخرى.",
        "نهاية حدود محطة الصالون العمومي."
      ],
      id: 1052
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1642. هل يجوز لسائق دراجة نارية السير في سبيل موسوم (مؤشر) ومُعد للمشاة؟",
      numQues: "1642",
      correctAnswer: "كلا، إلا إذا كان الشارع الذي بجانبه مسدوداً من قِبل المركبات.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "نعم، إذا كان السبيل يؤدي إلى ساحة لوقوف المركبات.",
        "كلا.",
        "نعم، إذا كان السبيل خالياً من حركة المشاة.",
        "كلا، إلا إذا كان الشارع الذي بجانبه مسدوداً من قِبل المركبات."
      ],
      id: 1053
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1032. قياس الإطار المسموح بتركيبه في المركبة هو:",
      numQues: "1032",
      correctAnswer: "القياس الذي سمح به كراج معتمد لتصليح المركبات.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "القياس الذي حدده منتج المركبة وسُجل في رخصة المركبة.",
        "القياس الذي حدده منتج الإطارات.",
        "أي قياس نريده شريطة أن تكون جميع الإطارات في المركبة ذات قياس واحد.",
        "القياس الذي سمح به كراج معتمد لتصليح المركبات."
      ],
      id: 1054
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1325. أية مركبات يجب أن تكون فيها مطفأة حريق؟",
      numQues: "1325",
      correctAnswer: "في كل شاحنة وباص عمومي فقط.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "في المركبة الميكانيكية التي تسير على أكثر من عجلتين.",
        "في كل مركبة تجارية وباص عمومي وتراكتور.",
        "في كل مركبة ميكانيكية ما عدا مركبة الركاب الخصوصية والتراكتور والدراجة النارية ذات العجلتين و الثلاث عجلات.",
        "في كل شاحنة وباص عمومي فقط."
      ],
      id: 1055
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0997. لماذا يجب استعمال فرملة الوقوف (الهاندبريك) - عند الوقوف فقط؟",
      numQues: "0997",
      correctAnswer: "لأن استعمال فرملة الوقوف تزيد من حرارة المحرك.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "فرملة الوقوف (الهاندبريك) لا تعمل على جميع عجلات المركبة وقوتها ضعيفة جداً.",
        "لأن اليد أو الرافعة المشغلة لها غير مريحة في التشغيل.",
        "لأن عمرها قصير ولا يجب استنفاذها على الفرملة العادية.",
        "لأن استعمال فرملة الوقوف تزيد من حرارة المحرك."
      ],
      id: 1056
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0199. متى وأين يُمنع توقف مركبة أو وقوفها؟",
      numQues: "0199",
      correctAnswer: "إذا كانت المركبة واقفة على الجانب الأيسر في شارع باتجاه واحد داخل المدن.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "بجانب أحجار الحافة المدهونة باللون الأزرق والأبيض.",
        "إذا كانت المركبة غير مقفلة.",
        "إذا كانت المركبة تعرقل حركة السير أو تحجب إشارة سير.",
        "إذا كانت المركبة واقفة على الجانب الأيسر في شارع باتجاه واحد داخل المدن."
      ],
      id: 1057
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0603. ما معنى الإشارة؟",
      numQues: "0603",
      correctAnswer: "نقطة استراحة للسائقين.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3603.jpg",
      choices: [
        "موقع حفريات أثرية.",
        "نصب تذكاري 'للكيرن كايمت'.",
        "موقع للتخييم أو موقف ليلي.",
        "نقطة استراحة للسائقين."
      ],
      id: 1058
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0476. كيف تتصرف حسب الإشارة؟",
      numQues: "0476",
      correctAnswer: "تمهل وزد كثيراً من حذرك ، تأهب لإمكانية الحاجة إلى الفرملة الفجائية.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3475.jpg",
      choices: [
        "تمهل وانتقل إلى غيار النيوترال.",
        "أعطِ حق الأولوية للمركبات وللمشاة.",
        "اعبر مقطع الطريق بسرعة.",
        "تمهل وزد كثيراً من حذرك ، تأهب لإمكانية الحاجة إلى الفرملة الفجائية."
      ],
      id: 1059
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1139. متى يجب على سائق الباص أن يعرف عن شخصيته بواسطة بطاقة ؟",
      numQues: "1139",
      correctAnswer: "في كل وقت يُطلب منه احد ركاب الباص ذلك.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "فقط عندما يُقدم مفتش بلدية شكوى ضده. ",
        "حسب طلب شرطي فقط.",
        "عندما يطلب موظف ضريبة الدخل رؤية مخزون البطاقات لديه.",
        "في كل وقت يُطلب منه احد ركاب الباص ذلك."
      ],
      id: 1060
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1572. أية إشارة معناها سبيل أو مسلك معد للدراجات الهوائية فقط، سر باتجاه السهم؟",
      numQues: "1572",
      correctAnswer: "720",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31572.jpg",
      choices: [
        "802",
        "821",
        "804",
        "720"
      ],
      id: 1061
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1765. ما هي الطريقة الصحيحة لتوجيه مسند الرأس في المركبة؟",
      numQues: "1765",
      correctAnswer: "يجب أن تكون الحافة العليا للمسند بمستوى واحد مع الطرف العلوي لرأس السائق.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "تثبيتها في الوضع الأدنى الممكن.",
        "يجب أن تكون الحافة العليا للمسند بخط واحد للخط السفلي لرقبة السائق.",
        "يجب أن تكون الحافة السفلى للمسند بمستوى واحد مع الطرف العلوي لرأس السائق.",
        "يجب أن تكون الحافة العليا للمسند بمستوى واحد مع الطرف العلوي لرأس السائق."
      ],
      id: 1062
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0594. كيف تتصرف حسب الإشارة؟",
      numQues: "0594",
      correctAnswer: "عندما تسوق مركبة وتقترب من هذه الإشارة، تمهل دائماً وحتى قف، حسب الضرورة، ومكن المشاة من أن يكملوا عبورهم الشارع .",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3593.jpg",
      choices: [
        "استمر بسيرك واحرص على أن يخلوا المشاة لك الطريق.",
        "استعمل الزامور وحذر المشاة الذين على ممر المشاة.",
        "حذر المشاة من اقترابك بواسطة استعمال الزامور بشدة وأضئ أنوار المقدمة.",
        "عندما تسوق مركبة وتقترب من هذه الإشارة، تمهل دائماً وحتى قف، حسب الضرورة، ومكن المشاة من أن يكملوا عبورهم الشارع ."
      ],
      id: 1063
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1732. شاب عمره 17 سنة من مواليد وسكان البلاد ويطلب الحصول على رخصة سياقة، أي طبيب معتمد لفحصه من اجل الحصول على الرخصة.",
      numQues: "1732",
      correctAnswer: "الطبيب الذي يُعالج طالب رخصة السياقة لمدة ثلاث سنوات على الأقل.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "الطبيب الذي يُعالج طالب رخصة السياقة لمدة خمس سنوات على الأقل.",
        "الطبيب الذي يُعالج طالب رخصة السياقة لمدة سنة واحدة على الأقل.",
        "الطبيب الذي يُعالج طالب رخصة السياقة لمدة سنتين على الأقل.",
        "الطبيب الذي يُعالج طالب رخصة السياقة لمدة ثلاث سنوات على الأقل."
      ],
      id: 1064
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1271. هل يُسمح لصالون عمومي مع ركاب السير في المسلك الموسوم (المؤشر) كمسلك للمواصلات العمومية؟",
      numQues: "1271",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31269.jpg",
      choices: [
        "نعم، فقط في أيام السبت والأعياد.",
        "نعم، فقط في ساعات ضغط حركة السير بين الساعات 06:00 لغاية 09:00 .",
        "كلا.",
        "نعم."
      ],
      id: 1065
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1085. بماذا يساهم جهاز توازن الحركة في المحور الأمامي للتراكتور؟",
      numQues: "1085",
      correctAnswer: "بتحسين توازن التراكتور عند السير في منحدر جانبي خارجي.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "بتحسين توازن التراكتور عند السير على سطح غير مستوي.",
        "بتحسين الراحة عند السير في التراكتور على الشوارع والسبل المستوية.",
        "بتحسين توازن التراكتور عند السير على الشوارع والسبل السريعة.",
        "بتحسين توازن التراكتور عند السير في منحدر جانبي خارجي."
      ],
      id: 1066
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1427. عند نقل حمولة سائبة، ما هو الارتفاع الأقصى المسموح به للحمولة؟",
      numQues: "1427",
      correctAnswer: "لا يجوز أن يكون ارتفاع الحمولة أكثر من 480سم، ويجب أن تكون مغطاة.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "يجب أن تكون الحمولة أوطأ بمتر واحد من ارتفاع الجانب، من اجل منع تناثر الحمولة على سطح الطريق.",
        "لا توجد أهمية لارتفاع الحمولة بشرط أن تكون مغطاة حسب الأنظمة.",
        "ممنوع أن ترتفع الحمولة أو أي جزء كان منها عن الجوانب أو السلالم المثبتة حسب القانون. ",
        "لا يجوز أن يكون ارتفاع الحمولة أكثر من 480سم، ويجب أن تكون مغطاة."
      ],
      id: 1067
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1213. ما هو واجب سائق الباص عندما يصل إلى المحطة النهائية؟",
      numQues: "1213",
      correctAnswer: "لا يترك الباص إلا بعد نزول آخر راكب فقط.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "يترك الباص فوراً بعد إطفاء المحرك.",
        "يُعلن عن المحطة النهائية وحينها يجوز له ترك الباص فوراً بدون أن ينتظر.",
        "يترك الباص بشرط أن لا يطفئ مكيف الهواء.",
        "لا يترك الباص إلا بعد نزول آخر راكب فقط."
      ],
      id: 1068
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1385. ما هو الوزن الإجمالي المسموح به لمركبة تجارية ملزمة بفحص جهاز الفرامل مرة كل نصف سنة على الأقل؟",
      numQues: "1385",
      correctAnswer: "16000كغم أو أكثر.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "10000كغم أو أكثر.",
        "8000كغم أو أكثر.",
        "12000كغم أو أكثر.",
        "16000كغم أو أكثر."
      ],
      id: 1069
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0269. السائق الذي قام بتجميع 36 نقطة أو أكثر بحقه:",
      numQues: "0269",
      correctAnswer: "تسحب سلطة الترخيص رخصة سياقته لمدة 3 أشهر وتُلزمه بتقديم امتحان نظري.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "فقط يجوز للمحكمة وهي المخولة بسحب رخصة سياقته.",
        "يجوز لسلطة الترخيص أن توصي أمام المحكمة بسحب رخصة سياقته إلى الأبد.",
        "حسب طريقة النقاط فإن سلطة الترخيص غير مخولة بسحب رخصة سياقته.",
        "تسحب سلطة الترخيص رخصة سياقته لمدة 3 أشهر وتُلزمه بتقديم امتحان نظري."
      ],
      id: 1070
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1056. لمن يجوز أن يصلح خلل يتعلق بالسلامة في المركبة؟",
      numQues: "1056",
      correctAnswer: "كل سائق صاحب معرفة وخبرة في مجال ميكانيكا المركبات أو معرفة المركبة.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "كل سائق، بشرط أن يعمل حسب تعليمات المنتج.",
        "فقط صاحب مهنة مختص في كراج معتمد.",
        "كل صاحب مهنة في أي كراج لتصليح المركبات.",
        "كل سائق صاحب معرفة وخبرة في مجال ميكانيكا المركبات أو معرفة المركبة."
      ],
      id: 1071
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1442. ما هي 'المركبة المترابطة':",
      numQues: "1442",
      correctAnswer: "مركبة مثبتة على شاصي كوحدة واحدة.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "ساندة أُلحقت بها مستندة.",
        "مركبة مثبتة على شاصي من العوارض.",
        "مركبة تجر خلفها مركبة ميكانيكية.",
        "مركبة مثبتة على شاصي كوحدة واحدة."
      ],
      id: 1072
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0585. ما معنى الإشارة؟",
      numQues: "0585",
      correctAnswer: "محطة لنقل الجنود، يُسمح بتوقف المركبات العسكرية فقط.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3585.jpg",
      choices: [
        "موقف للمركبات التي تنقل جنود.",
        "محطة لنقل الجنود، للاصعاد والإنزال فقط (ممنوع الانتظار في المحطة).",
        "محطة نقل ركاب، ممنوع توقف المركبات التجارية.",
        "محطة لنقل الجنود، يُسمح بتوقف المركبات العسكرية فقط."
      ],
      id: 1073
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1087. على أي أساس يُحدد الوزن الأقصى المسموح به الذي يمكن رفعه بمساعدة اذرع الرفع الهيدراولية؟",
      numQues: "1087",
      correctAnswer: "حسب نوع السائل الهيدراولي والجهاز المرفوع.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "حسب ضغط نفخ الهواء الأقصى الذي سمح به منتج الإطارات الخلفية.",
        "حسب الوضع الميكانيكي للمحرك والمضخة والجهاز الهيدراولي في التراكتور.",
        "يُحدد الوزن حسب لوحة (صاجة) المنتج والتي تُحدد أي وزن، حسب بعد مركز ثقل الذراع من التراكتور.",
        "حسب نوع السائل الهيدراولي والجهاز المرفوع."
      ],
      id: 1074
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1420. هل يُسمح بنقل حاوية (كونتينر) تبرز من القسم الخلفي للمركبة؟",
      numQues: "1420",
      correctAnswer: "نعم، في المركبة التي لها امتداد خلفي قصير.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "نعم، فقط في مركبة لا يوجد لها أرضية أو جوانب.",
        "نعم، فقط في المركبة التي لها امتداد أمامي قصير.",
        "كلا ، لا يجوز أن تبرز الحاوية (الكونتينر) من القسم الخلفي للمركبة بأي شكلٍ من الأشكال.",
        "نعم، في المركبة التي لها امتداد خلفي قصير."
      ],
      id: 1075
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0170. عندما نعطي الإشارة بواسطة الزامور:",
      numQues: "0170",
      correctAnswer: "لا يجب أن تكون الإشارة متواصلة أو أكثر من اللازم.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "القانون يُلزم بإعطاء الإشارة بواسطة الزامور ثلاث مرات على الأقل.",
        "تعطى الإشارة بشكلٍ سريع وموحد.",
        "تعطى الإشارة بصورة طويلة ومتواصلة.",
        "لا يجب أن تكون الإشارة متواصلة أو أكثر من اللازم."
      ],
      id: 1076
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0648. كيف يجب عليك التصرف عند الاقتراب من الوسم (التأشير) على سطح الطريق؟",
      numQues: "0648",
      correctAnswer: "توقف دائماً قبل خط التوقف.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3647.jpg",
      choices: [
        "توقف فقط إذا كان الخط مرسوم قبل ملتقى سكة حديد.",
        "يجب التوقف دائماً في وقت الإنارة.",
        "توقف قبل خط التوقف إذا كان هناك واجب بالتوقف.",
        "توقف دائماً قبل خط التوقف."
      ],
      id: 1077
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0400. أية إشارة تسمح بوقوف مركبة على الرصيف ؟",
      numQues: "0400",
      correctAnswer: "435",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3400.jpg",
      choices: [
        "626",
        "432",
        "627",
        "435"
      ],
      id: 1078
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0435. كيف تتصرف حسب الإشارة ؟",
      numQues: "0435",
      correctAnswer: "أعطِ حق الأولوية للمركبات المندمجة من اليمين.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3435.jpg",
      choices: [
        "تابع سيرك وانتبه لحركة سير المركبات المندمجة من يسارك، عليهم إعطاؤك حق الأولوية.",
        "تمهل وأعط حق الأولوية للمركبات المندمجة من اليمين.",
        "انتقل إلى مسلك آخر ومكن المركبات القادمة من اليمين من الاندماج.",
        "أعطِ حق الأولوية للمركبات المندمجة من اليمين."
      ],
      id: 1079
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0782. ما هو الخطر المتوقع لسائق المركبة الذي يستدير إلى اليمين أثناء تنفيذ الاستدارة ؟",
      numQues: "0782",
      correctAnswer: "لا يوجد أي خطر لأن جميع مستعملي الطريق يعرفون القانون ويعلمون بأنه لا يجوز لهم التواجد على يمين مركبة تستدير إلى اليمين.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "لا توجد إمكانية أي خطر أثناء الاستدارة لأن القانون يسمح باستدارة مركبة تسير على عجلتين ومركبات أخرى في آنٍ واحد.",
        "أثناء الاستدارة هناك إمكانية بأن تدخل عن يمينه مركبة تسير على عجلتين.",
        "لا توجد أية مشكلة لأن المشاة وسائقي المركبات التي تسير على عجلتين لا يدخلوا من يمين المركبة التي تستدير بسبب المسافة الكبيرة.",
        "لا يوجد أي خطر لأن جميع مستعملي الطريق يعرفون القانون ويعلمون بأنه لا يجوز لهم التواجد على يمين مركبة تستدير إلى اليمين."
      ],
      id: 1080
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1784. ممنوع التجاوز في طريق شديدة الانحدار قبل قمة:",
      numQues: "1784",
      correctAnswer: "لكن التجاوز مسموح التجاوز إذا كان وزن مركبتك أكثر من 4000كغم.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "فقط إذا نُصبت إشارة 'خطر شامل'.",
        "فقط إذا نُصبت إشارة تمنع التجاوز، لكن التجاوز مسموح في النهار فقط.",
        "عندما يكون مدى الرؤية محدوداً أو مسدوداً.",
        "لكن التجاوز مسموح التجاوز إذا كان وزن مركبتك أكثر من 4000كغم."
      ],
      id: 1081
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0246. كيف تتصرف عند اقترابك من مفترق نُصبت فيه إشارة ضوئية (رمزور) تضيء بالضوء الأصفر المتقطع؟",
      numQues: "0246",
      correctAnswer: "خفف من سرعة السير وأعطِ حق الأولوية للمركبة القادمة الجهة المقابلة.",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3186.jpg",
      choices: [
        "توقف لحين ظهور الضوء الأخضر في الإشارة الضوئية (الرمزور).",
        "خفف من سرعة سيرك وتصرف حسب قواعد إعطاء حق الأولوية أو حسب الشاخصات المنصوبة في المفترق.",
        "لك حق الأولوية بالنسبة للمشاة على مكان عبور المشاة، لذلك تابع سيرك في المفترق كالمعتاد.",
        "خفف من سرعة السير وأعطِ حق الأولوية للمركبة القادمة الجهة المقابلة."
      ],
      id: 1082
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0397. إذا نُصبت على مدخل طريق الإشارة رقم: 401 ، أية إشارة تُنصب على مدخلها من الجهة الأخرى؟",
      numQues: "0397",
      correctAnswer: "402",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3397.jpg",
      choices: [
        "401",
        "307",
        "618",
        "402"
      ],
      id: 1083
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0082. في الرسم الذي أمامك نرى طريق عريضة، بأي رقم موسوم (مؤشر) الشارع الذي في الرسم؟",
      numQues: "0082",
      correctAnswer: "5",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3082.jpg",
      choices: [
        "2",
        "3",
        "1",
        "5"
      ],
      id: 1084
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "0201. هل يجوز إيقاف مركبة على الرصيف؟",
      numQues: "0201",
      correctAnswer: "مسموح على رصيف عرضه 3م أو أكثر.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "مسموح على الرصيف المبني من أحجار متكاملة.",
        "ممنوع، ما عدا في الأماكن التي تم تخصيصها وتأشيرها بواسطة إشارة. ",
        "ممنوع منعاً باتاً.",
        "مسموح على رصيف عرضه 3م أو أكثر."
      ],
      id: 1085
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "1546. ما هو واجب السائق الذي يشعر بأن قسم من الحمولة التي ينقلها قد سقط على الشارع؟",
      numQues: "1546",
      correctAnswer: "تبليغ الشرطة وأيضاً شركة التأمين والانتظار لغاية قدومهم.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        " التوقف فوراً والاهتمام بالإزالة الفورية للحمولة التي سقطت. ",
        "تبليغ الشرطة عن ذلك، يسري واجب الإزالة على البلدية أو على الأشغال العامة.",
        "تبليغ شركة التأمين.",
        "تبليغ الشرطة وأيضاً شركة التأمين والانتظار لغاية قدومهم."
      ],
      id: 1086
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1754. في المركبة المُركب فيها آلة تصوير (كاميرا) خلفية:",
      numQues: "1754",
      correctAnswer: "تكشف الكاميرا المساحة الميتة التي تكونت من حول المركبة.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "تُظهر تكشف المساحة الميتة التي تكونت أمام المركبة فقط.",
        "تكشف الكاميرا المساحة الميتة التي تكونت خلف المركبة عند السير إلى الأمام فقط.",
        "تكشف الكاميرا المساحة الميتة التي تكونت خلف المركبة.",
        "تكشف الكاميرا المساحة الميتة التي تكونت من حول المركبة."
      ],
      id: 1087
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0297. هل يجوز للشرطي الطلب من سائق المركبة أن يجري 'فحص الثمل' (نسبة الكحول)؟",
      numQues: "0297",
      correctAnswer: "كلا، لا يحق للشرطي الطلب من سائق المركبة إجراء أية فحوصات ما عدا فحص الزفير (فحص بواسطة النفخ).",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "نعم، يجوز للشرطي أن يطلب من السائق إجراء فحص الثمل (نسبة الكحول) في أي وقت.",
        "نعم، فقط إذا كان للشرطي اعتقاد معقول بأن سائق المركبة لا يتمتع بصحة جيدة.",
        "كلا، لا يحق للشرطي الطلب من سائق المركبة إجراء 'فحص الكحول' إلا بقرار من المحكمة.",
        "كلا، لا يحق للشرطي الطلب من سائق المركبة إجراء أية فحوصات ما عدا فحص الزفير (فحص بواسطة النفخ)."
      ],
      id: 1088
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1516. أين توجد اكبر 'مساحة ميتة' في مركبة شاحنة؟",
      numQues: "1516",
      correctAnswer: "في القسم الخلفي من المركبة.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "ذلك يعتمد على حجم المرايا الداخلية للمركبة، فكلما كان حجم المرآة اكبر كلما كانت المساحة الميتة من الأمام اكبر.",
        "في القسم الأيسر من المركبة.",
        "في القسم الأمامي من المركبة.",
        "في القسم الخلفي من المركبة."
      ],
      id: 1089
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1413. يُمكن نقل الرماد المتطاير أو الأسمنت السائب:",
      numQues: "1413",
      correctAnswer: "في كل مركبة تجارية.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "فقط في مركبة خاصة مجهزة بنافخ .",
        "فقط في مركبة معدة لهذا الغرض.",
        "في كل مركبة مفتوحة لنقل المساحيق السائبة.",
        "في كل مركبة تجارية."
      ],
      id: 1090
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0166. بأية وسيلة تُعطى إشارة الفرملة ؟",
      numQues: "0166",
      correctAnswer: "بواسطة إخراج اليد من النافذة اليسرى.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "بإضاءة نور الفرملة.",
        "بواسطة إخراج اليد من النافذة اليمنى.",
        "بواسطة تشغيل الأربعة غمازات.",
        "بواسطة إخراج اليد من النافذة اليسرى."
      ],
      id: 1091
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1526. لا يجب أن يكون الطول الإجمالي المسموح به لمركبة شاحنة أكثر من:",
      numQues: "1526",
      correctAnswer: "11م.",
      pubDate: "10-11-2011 08:23:01",
      img: "",
      choices: [
        "12.5م.",
        "10م.",
        "12م.",
        "11م."
      ],
      id: 1092
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0513. ما معنى الإشارة (السهم الأيسر مدهون باللون الأصفر)؟",
      numQues: "0513",
      correctAnswer: "ممنوع للمواصلات العمومية أن تعبر عن الإشارة من اليسار .",
      pubDate: "10-11-2011 08:23:01",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3513.jpg",
      choices: [
        "مسموح السير في الشارع من الجهة اليمنى للخط الأصفر الموجود على الشارع.",
        "سر باتجاه السهم الأصفر فقط.",
        "مسموح للمركبات العمومية أن تعبر الإشارة من اليسار.",
        "ممنوع للمواصلات العمومية أن تعبر عن الإشارة من اليسار ."
      ],
      id: 1093
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1745. هل الخط الفاصل الأبيض المتواصل المزدوج الموسوم (المؤشر) على الشارع يسمح بتجاوز مركبة تسير حسب القانون على حاشية الطريق؟",
      numQues: "1745",
      correctAnswer: "نعم، بشرط أن المركبة المتجاوزة هي مركبة بطيئة.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "نعم، بشرط أن لا تعبر المركبة المتجاوزة الخط المتواصل الأبيض حتى ولو بقسم من عجلاتها.",
        "كلا، ممنوع التجاوز.",
        "نعم، بشرط أن المركبة المتجاوزة هي دراجة نارية.",
        "نعم، بشرط أن المركبة المتجاوزة هي مركبة بطيئة."
      ],
      id: 1094
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0873. ملاءمة الغيار الصحيح في مركبة ذات صندوق غيارات يدوي (جير) مهمة:",
      numQues: "0873",
      correctAnswer: "فقط في المركبات القديمة.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "من اجل تحديد سرعة السير.",
        "من اجل المحافظة على عمر الإطارات.",
        "فقط في المنحدرات الحادة.",
        "فقط في المركبات القديمة."
      ],
      id: 1095
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0534. كيف يجب التصرف عند نصب الإشارة:",
      numQues: "0534",
      correctAnswer: "سر! لك حق الأولوية في المفترق الذي أمامك",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3443.jpg",
      choices: [
        "يجب تمكين المركبة في الطريق القاطعة من مواصلة سيرها بدون تغيير سرعتها أو مسلك سيرها.",
        "يجب التوقف ومواصلة السير: لك حق الأولوية في المفترق.",
        "يجب التوقف بشكلٍ تام والنظر إلى اليمين والى اليسار وفحص حركة السير المقتربة.",
        "سر! لك حق الأولوية في المفترق الذي أمامك"
      ],
      id: 1096
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1476. من شأن الرمل على سطح الشارع أن يسبب في:",
      numQues: "1476",
      correctAnswer: "زيادة الاحتكاك بين الإطارات وبين الشارع وسخونة زائدة للإطارات.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "تقليل الاحتكاك بين الإطارات وبين الشارع ولتزحلق المركبة.",
        "زيادة الاحتكاك بين الإطارات وبين الشارع وزيادة قوة الفرملة.",
        "إخفاء الإشارات واللافتات المهمة المنصوبة في الطريق.",
        "زيادة الاحتكاك بين الإطارات وبين الشارع وسخونة زائدة للإطارات."
      ],
      id: 1097
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0754. في أية حالة لا نسير في المسلك الأيمن؟",
      numQues: "0754",
      correctAnswer: "عندما تعطي المركبة الأخرى الموجودة أمامنا إشارة بأنها تريد البدء بالسير من الجانب الأيسر للشارع.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "عندما تتجاوزنا مركبة أخرى من اليسار في شارع فيه مسلكين.",
        "عندما نعبر عن مركبة أخرى من جانبها الأيمن.",
        "عندما نتجاوز مركبة.",
        "عندما تعطي المركبة الأخرى الموجودة أمامنا إشارة بأنها تريد البدء بالسير من الجانب الأيسر للشارع."
      ],
      id: 1098
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0913. متى تستطيع المركبات التي أمامك مواصلة سيرها؟",
      numQues: "0913",
      correctAnswer: "فقط عندما يفتح الحاجز كله وبعد أن ينطفئ الضوء الأحمر في الإشارة الضوئية (الرمزور).",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3913.jpg",
      choices: [
        "دائماً بعد ثلاث دقائق من الانتظار.",
        "عندما يتغير الضوء في الإشارة الضوئية (الرمزور) إلى اللون الأصفر الثابت.",
        "حالاً بعد أن يبدأ الحاجز بالارتفاع.",
        "فقط عندما يفتح الحاجز كله وبعد أن ينطفئ الضوء الأحمر في الإشارة الضوئية (الرمزور)."
      ],
      id: 1099
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1339. ما هو 'الوزن الإجمالي المسموح به':",
      numQues: "1339",
      correctAnswer: "الوزن الذاتي (الفارغ) للمركبة بإضافة وزن الحمولة التي سمحت بنقلها سلطة الترخيص في المركبة ولا يشمل وزن السائق والركاب بجانبه. ",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "الوزن الذاتي للمركبة ولا يشمل وزن الأشخاص والحمولة التي سمحت سلطة الترخيص بنقلهم في المركبة المذكورة.",
        "الوزن الإجمالي هو وزن ثابت: للشاحنة الخفيفة - 3500كغم وللشاحنة المتوسطة - 12000كغم وللشاحنة الثقيلة - 16000كغم.",
        "الوزن الذاتي (الفارغ) للمركبة بإضافة وزن الأشخاص والحمولة التي سمحت سلطة الترخيص بنقلهم في المركبة المذكورة.",
        "الوزن الذاتي (الفارغ) للمركبة بإضافة وزن الحمولة التي سمحت بنقلها سلطة الترخيص في المركبة ولا يشمل وزن السائق والركاب بجانبه. "
      ],
      id: 1100
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0309. 'يُسمح بالسياقة عند شرب مشروب من نوعٍ واحد فقط بدون خلط أنواع أخرى من المشروبات' صحيح أم لا؟",
      numQues: "0309",
      correctAnswer: "صحيح، تؤثر الكحول على السياقة، فقط عند خلط أنواع مختلفة من المشروبات.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "غير صحيح، نسبة الكحول في الدم هي التي تقرر، عند مقارنتها بالنسبة المحددة في القانون. ",
        "صحيح ، بالإمكان شرب كميات كبيرة من مشروب روحي من نوعٍ واحد دون أن يصبح الشخص ثملاً (سكران).",
        "صحيح، يجب الحرص على عدم خلط مشروبات من أنواع مختلفة قبل السياقة. ",
        "صحيح، تؤثر الكحول على السياقة، فقط عند خلط أنواع مختلفة من المشروبات."
      ],
      id: 1101
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1479. في المركبة التجارية التي يبلغ وزنها 12000كغم أو أكثر، يجب أن تكون مثبتة على جانبها الخلفي:",
      numQues: "1479",
      correctAnswer: "عاكسان أصفران مستديران بلونٍ احمر/ابيض.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "عاكسان أصفران على شكل مثلث بلونٍ احمر/ابيض.",
        "شريطان عاكسان أبيضان.",
        "لوحتان مستطيلتان بلونٍ احمر/ابيض.",
        "عاكسان أصفران مستديران بلونٍ احمر/ابيض."
      ],
      id: 1102
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0943. كيف تتصرف حسب الظاهر في الصورة؟",
      numQues: "0943",
      correctAnswer: "استعمل الزامور قبل الدخول إلى المنعطف، من المهم أن يعلم الجميع انك في الطريق.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3943.jpg",
      choices: [
        "تمهل وابقَ على اليمين- إلتوائات في الطريق التي امامك.",
        "اعبر عن جانب الإشارة بسرعة، فيه مُعدة للسائقين البطيئين.",
        "واصل سيرك كالمعتاد عندما تكون الطريق خالية.",
        "استعمل الزامور قبل الدخول إلى المنعطف، من المهم أن يعلم الجميع انك في الطريق."
      ],
      id: 1103
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1084. أي جهاز أضافي موجود في التراكتورات وغير موجود في المركبات الأخرى؟",
      numQues: "1084",
      correctAnswer: "جهاز فرامل الهواء مع جهاز الهواء المضغوط.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "جهاز مقود كهربائي-هيدراولي قياسي.",
        "جهاز هيدراولي لرفع وتشغيل الأجهزة.",
        "جهاز إقفال الباككس الهايدروستاتي.",
        "جهاز فرامل الهواء مع جهاز الهواء المضغوط."
      ],
      id: 1104
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0931. كيف تتصرف حسب الحدث الذي في الصورة (حمضيات منثورة على الشارع)؟",
      numQues: "0931",
      correctAnswer: "تمهل وسر بحذر، الحمضيات التي سقطت على الشارع تقلل من تماسك المركبة مع الشارع.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3931.jpg",
      choices: [
        "استمر بالسير كالمعتاد، لا يمكن أن تسبب الحمضيات التي على الشارع إعاقة السير، لذلك لا يتوجب عليك التمهل.",
        "استمر بالسير كالمعتاد، الحمضيات التي على الشارع تجف وتزول.",
        "استمر بالسير كالمعتاد، من شأن الحمضيات التي على الشارع أن تسبب في التزحلق عند الفرملة فقط عندما يكون الشارع رطباً (مبلول)، لذلك لا يُطلب منك التمهل.",
        "تمهل وسر بحذر، الحمضيات التي سقطت على الشارع تقلل من تماسك المركبة مع الشارع."
      ],
      id: 1105
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0052. 'طريقة النقاط لمخالفات المرور' بموجب القانون هي:",
      numQues: "0052",
      correctAnswer: "طريقة لتسجيل نقاط إلزامية للسائقين الذين أدينوا بمخالفات مرور مرة كل خمس سنوات. ",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "طريقة لتسجيل الإدانات على كل مخالفة جزائية.",
        "طريقة لتسجيل نقاط إلزامية نتيجة للإدانات بارتكاب مخالفات مرور حُدِدَت في القانون.",
        "طريقة لإرسال تقارير للمحكمة على عدم صلاحية المركبات.",
        "طريقة لتسجيل نقاط إلزامية للسائقين الذين أدينوا بمخالفات مرور مرة كل خمس سنوات. "
      ],
      id: 1106
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1262. ما معنى الإشارة المنصوبة في الطريق التي أمامك؟",
      numQues: "1262",
      correctAnswer: "مكان لإنزال واصعاد ركاب الصالون العمومي بما في ذلك انتظارهم.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3572.jpg",
      choices: [
        "مكان لإنزال واصعاد ركاب الصالون العمومي ولكن بدون انتظار.",
        "مكان يمنع فيه إنزال واصعاد ركاب الصالون العمومي.",
        "مكان لإنزال واصعاد ركاب المركبة العمومية بدون انتظار.",
        "مكان لإنزال واصعاد ركاب الصالون العمومي بما في ذلك انتظارهم."
      ],
      id: 1107
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1467. أية إشارة تمنع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار؟",
      numQues: "1467",
      correctAnswer: "212",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31467.jpg",
      choices: [
        "207.",
        "209",
        "208",
        "212"
      ],
      id: 1108
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0114. المفترق الذي أمامك عليه إشارات تماماً كما في الصورة، ما هي الطريقة الصحيحة للاستدارة من الشارع 'أ' (A) إلى الشارع 'ج' (C)؟",
      numQues: "0114",
      correctAnswer: "من المسلك '1' إلى المسلك '3'.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3114.jpg",
      choices: [
        "من المسلك '2' إلى المسلك '3'.",
        "من المسلك '2' إلى المسلك '5'.",
        "من المسلك '1' أو من المسلك '2' إلى المسلك '4'.",
        "من المسلك '1' إلى المسلك '3'."
      ],
      id: 1109
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0813. مسافة الفرملة للمركبة هي المسافة التي تقطعها المركبة:",
      numQues: "0813",
      correctAnswer: "من اللحظة التي يشاهد فيها السائق الخطر الذي أمامه ولغاية التوقف التام للمركبة.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "من اللحظة التي يضغط فيها السائق على دعسة الفرامل ولغاية التوقف التام للمركبة.",
        "من لحظة تشخيص الخطر ولغاية بداية فرملة المركبة.",
        "من اللحظة التي يشاهد فيها السائق الخطر الذي أمامه ولغاية اللحظة التي يبدأ فيها الضغط على دعسة الفرامل.",
        "من اللحظة التي يشاهد فيها السائق الخطر الذي أمامه ولغاية التوقف التام للمركبة."
      ],
      id: 1110
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0636. ما معنى الوسم (التأشير) على سطح الطريق (خط فاصل متواصل) ؟",
      numQues: "0636",
      correctAnswer: "فصل بين مسلك للمواصلات العمومية وبين المسالك الأخرى.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3636.jpg",
      choices: [
        "خط فاصل بين المركبات غير الميكانيكية وبين المركبات الميكانيكية.",
        "مساحة فاصلة في شارع باتجاه واحد.",
        "ممنوع السير على يسار الخط.",
        "فصل بين مسلك للمواصلات العمومية وبين المسالك الأخرى."
      ],
      id: 1111
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0947. ما هو التصرف المطلوب في مقطع الطريق الظاهر أمامك؟",
      numQues: "0947",
      correctAnswer: "المحافظة على نصف قطر صغير في الانعطاف وملاءمة السرعة.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3947.jpg",
      choices: [
        "زيادة نصف قطر الانعطاف لكي تحافظ على سرعة معقولة، مسموح أيضاً التجاوز.",
        "التمهل والمحافظة على يمين الشارع بسبب مدى الرؤية المحدود.",
        "زيادة السرعة عند الدخول إلى المنعطف والتمهل في داخله وعند الخروج منه.",
        "المحافظة على نصف قطر صغير في الانعطاف وملاءمة السرعة."
      ],
      id: 1112
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1686. إذا انقضت مدة السنتين 'للسائق الجديد' ، لا تصدر رخصة سواقة عادية 'لسائق جديد' إذا أُدين بمخالفة:",
      numQues: "1686",
      correctAnswer: "عدم وضع مثلث تحذير عند وقوف المركبة في الطريق من جراء إصابتها بخلل.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "سياقة مركبة ميكانيكية تحت تأثير الكحول أو المخدرات المسكرة.",
        "عدم التوقف في مفترق نُصبت فيه إشارة 'قف'.",
        "السير في مركبة ميكانيكية بدون تأمين ساري المفعول.",
        "عدم وضع مثلث تحذير عند وقوف المركبة في الطريق من جراء إصابتها بخلل."
      ],
      id: 1113
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1283. مثلث التحذير هو من الأدوات الإلزامية:",
      numQues: "1283",
      correctAnswer: "في المركبة التجارية فقط.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "في كل مركبة ميكانيكية بما في ذلك المقطورات والمستندات ما عدا الدراجة النارية.",
        "في المركبة التي تسير على عجلتين فقط.",
        "في الباصات فقط.",
        "في المركبة التجارية فقط."
      ],
      id: 1114
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1088. ماذا يحدث إذا كان الوزن على اذرع الرفع الهيدراولية الخلفية للتراكتور مرتفعاً أكثر من اللازم أو بعيداً عن التراكتور؟",
      numQues: "1088",
      correctAnswer: "ترتفع العجلات الأمامية عن الأرض.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "يتضرر الجهاز الهيدراولي بسبب الثقل.",
        "تنفجر العجلات الخلفية من ضغط الثقل.",
        "هناك خطر الضرر الشديد بالشاصي.",
        "ترتفع العجلات الأمامية عن الأرض."
      ],
      id: 1115
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1394. ما هي المسؤولية التي تقع على من يملك السيطرة على المركبة بالنسبة لساعات عمل واستراحة سائقها؟",
      numQues: "1394",
      correctAnswer: "لا يسمح من يملك السيطرة على المركبة لسائقها بسياقتها أكثر من ساعات العمل المحددة في القانون.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "من يملك السيطرة على المركبة ليس مسؤولاً عن ساعات عمل واستراحة سائقها، وتقع المسؤولية كلها على السائق.",
        "صحيح أن من يملك السيطرة على المركبة هو المسؤول، لكن يجوز لضابط السلامة لأسطول المركبة أن يغير ساعات العمل والاستراحة حسب المطلوب بدون أية علاقة بالقانون.",
        "يجوز لمن يملك السيطرة على المركبة، وبإذن من ضابط السلامة، أن يأمر سائق المركبة بسياقتها لمدة تزيد عن المسموح بها في القانون.",
        "لا يسمح من يملك السيطرة على المركبة لسائقها بسياقتها أكثر من ساعات العمل المحددة في القانون."
      ],
      id: 1116
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0035. ما هو 'الجسم الموحد' في المركبة؟",
      numQues: "0035",
      correctAnswer: "الجسم الذي فيه حاجز بين مقعد السائق وبين الركاب.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "الجسم الذي تزيد مقاييسه عن مقاييس مركبة عادية.",
        "الجسم الذي تُشكل فيه كابينة السائق وصندوق الحمولة وحدة واحدة.",
        "الجسم الذي فيه كابينة السائق منفصلة عن صندوق الحمولة.",
        "الجسم الذي فيه حاجز بين مقعد السائق وبين الركاب."
      ],
      id: 1117
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1632. هل يُسمح بسياقة دراجة نارية تم فيها إزالة كاتم الصوت عن أنبوب العادم (الاكزوست)؟",
      numQues: "1632",
      correctAnswer: "مسموح - فقط في طريق ليست بلدية.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "مسموح - فقط في طريق سريعة.",
        "مسموح.",
        "ممنوع.",
        "مسموح - فقط في طريق ليست بلدية."
      ],
      id: 1118
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1078. ما معنى الإشارة؟",
      numQues: "1078",
      correctAnswer: "توجيه مسبق لأهداف قبل مفترق في طريق سريعة",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31078.jpg",
      choices: [
        "توجيه مسبق لأهداف قبل محول طرق داخل المدن.",
        "توجيه مسبق للخروج من أهداف في طريق بلدية.",
        "توجيه مسبق لأهداف قبل المفترق في طريق ليست بلدية.",
        "توجيه مسبق لأهداف قبل مفترق في طريق سريعة"
      ],
      id: 1119
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1648. أين يوصى بوضع حمولة على الدراجة النارية لكي يكون لها اقل قدر من التأثير على التوازن؟",
      numQues: "1648",
      correctAnswer: "قريباً من الطرف الخلفي للدراجة النارية وفي المكان الأكثر ارتفاعاً.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "قريباً من الطرف الخلفي للدراجة النارية وفي المكان الأكثر انخفاضاً بحيث لا تبرز الحمولة من أقصى مؤخرة المركبة. ",
        "قريباً من الطرف الأمامي للدراجة النارية وفي المكان الأكثر ارتفاعاً.",
        "قريباً من وسط الدراجة النارية وفي الموقع الأكثر انخفاضاً بحيث لا تبرز الحمولة من أقصى المقدمة أو المؤخرة.",
        "قريباً من الطرف الخلفي للدراجة النارية وفي المكان الأكثر ارتفاعاً."
      ],
      id: 1120
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1760. أية إشارة من الإشارات التالية تُنصب فوق مسلك وتشير إلى وجهات خارج المدينة عندما تكون منصوبة؟",
      numQues: "1760",
      correctAnswer: "615",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31760.jpg",
      choices: [
        "613",
        "617",
        "616",
        "615"
      ],
      id: 1121
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0941. ما هي السرعة القصوى المسموح بها لك (مركبة ركاب خصوصية) بعد أن عبرت عن الشاخصات التي أمامك؟",
      numQues: "0941",
      correctAnswer: "90كم/ساعة.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3941.jpg",
      choices: [
        "70كم/ساعة.",
        "110كم/ساعة.",
        "50كم/ساعة.",
        "90كم/ساعة."
      ],
      id: 1122
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0865. ما هي الطريقة الصحيحة لفحص الطريق عند الاندماج في حركة السير مع بدء السفر؟",
      numQues: "0865",
      correctAnswer: "النظر بعيداً على قدر الإمكان إلى الأمام.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "البحث عن اللافتات التي توجهنا إلى هدفنا.",
        "النظر في المرآة الداخلية والتأكد من عدم وجود مركبات خلفنا.",
        "النظر في المرايا وإدارة الرأس للجهة التي ننوي السير فيها.",
        "النظر بعيداً على قدر الإمكان إلى الأمام."
      ],
      id: 1123
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1154. من هو المسؤول عن تركيب لافتات خط السفر داخل الباص في خط خدمة؟",
      numQues: "1154",
      correctAnswer: "السائق وصاحب رخصة الخط.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "مستخدمو المصلحة.",
        "صاحب رخصة الخط.",
        "سائق الباص.",
        "السائق وصاحب رخصة الخط."
      ],
      id: 1124
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1456. لأية مدة تصدر رخصة ناقل؟",
      numQues: "1456",
      correctAnswer: "لسنة واحدة.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "تعتمد المدة على نوع الحمولة.",
        "لغاية تجديد رخصة المركبة.",
        "لخمس سنوات.",
        "لسنة واحدة."
      ],
      id: 1125
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1193. هل يُعفى سائق الصالون العمومي من واجب استعمال حزام الأمان أثناء السير؟",
      numQues: "1193",
      correctAnswer: "نعم، لكن الإعفاء يسري في طريق خارج المدن فقط.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "نعم، بشرط أن تكون هناك إشارة تدل على ذلك.",
        "نعم، لكن الإعفاء يسري في طريق بلدية فقط بدون أية علاقة بعدد الركاب في الصالون العمومي.",
        "نعم، فقط في طريق بلدية، عندما يكون هناك ركاب في الصالون العمومي.",
        "نعم، لكن الإعفاء يسري في طريق خارج المدن فقط."
      ],
      id: 1126
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0722. عندما تضطر مركبة للتوقف في طريق ليست بلدية ويريد السائق أو راكب الخروج منها:",
      numQues: "0722",
      correctAnswer: "على السائق أن يرتدي سترة عند خروجه من المركبة فقط إذا كانت في الطريق مركبات أخرى.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "واجب ارتداء السترة يقع على السائق فقط وليس على أي شخص آخر يخرج من المركبة.",
        "لا يوجد هناك أي واجب كان، واجب ارتداء السترة مفروض في الطريق البلدية فقط.",
        "على من يخرج أولاً من المركبة أن يرتدي سترة عاكسة حسب المواصفات عند خروجه من المركبة أو النزول منها.",
        "على السائق أن يرتدي سترة عند خروجه من المركبة فقط إذا كانت في الطريق مركبات أخرى."
      ],
      id: 1127
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1401. هل يُسمح بسياقة مركبة عندما لا يلامس احد عجلات المقطورة أو المستندة الشارع (بسبب طريقة توصيل أو تحميل المركبة)؟",
      numQues: "1401",
      correctAnswer: "لا يُسمح بسياقة مركبة عندما لا يلامس احد عجلات المقطورة أو المستندة الشارع.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "نعم، مسموح سياقة مركبة إذا كانت الساندة عالية جداً والعجلات الأمامية للمستندة مرفوعة.",
        "نعم يسمح بسياقة المركبة، غير أن ذلك مشروط بإذن من ضابط الشرطة وبمرافقة مناسبة.",
        "نعم – عند تحميل حمولة ثقيلة على الامتداد الخلفي.",
        "لا يُسمح بسياقة مركبة عندما لا يلامس احد عجلات المقطورة أو المستندة الشارع."
      ],
      id: 1128
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1008. لماذا يُمنع تركيب إضافات قاسية وبارزة في كابينة الركاب؟",
      numQues: "1008",
      correctAnswer: "لأن من شأن هذه ألإضافات، عند وقوع حادث، أن تصيب بأذى الركاب والسائق.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "لأنها تشوش ثبات المركبة.",
        "من اجل منع المس بمدى الرؤية للركاب أثناء الرجوع إلى الخلف.",
        "من اجل منع إمكانية الضرر بإطارات المركبة.",
        "لأن من شأن هذه ألإضافات، عند وقوع حادث، أن تصيب بأذى الركاب والسائق."
      ],
      id: 1129
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1396. متى يجب تشغيل مخفف السرعة في منحدر:",
      numQues: "1396",
      correctAnswer: "إذا كانت نسبة الانحدار في المنحدر أكثر من 6% وطول المنحدر أكثر من كيلومتر واحد.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "إذا نُصبت إشارة تُحذر من منحدر شديد.",
        "فقط إذا ذُكرت نسبة الانحدار على إشارة تحذير قبل المنحدر الشديد.",
        "في كل منحدر في الشارع.",
        "إذا كانت نسبة الانحدار في المنحدر أكثر من 6% وطول المنحدر أكثر من كيلومتر واحد."
      ],
      id: 1130
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1441. كيف يتصرف سائق مركبة تنقل حمولة بارزة وبسبب وضع الطريق لا توجد إمكانية بتجاوزه؟",
      numQues: "1441",
      correctAnswer: "يسير حتى خليج الوقوف القريب أو حتى خليج محطة الباص، ويتوقف هناك من اجل تمكين المركبات من تجاوزه.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "ينحرف بمركبته إلى يمين الشارع على قدر الإمكان ولا ينزل إلى حاشية الطريق لأن وزن المركبة من شأنه أن يسبب في انهيار الحاشية.",
        "يخفف من سرعة سيره وإذا اقتضت الضرورة ينزل إلى حاشية الطريق وحتى التوقف ويُمكن المركبات من خلفه بتجاوزه بأمان.",
        "يُشغل أربعة غمازات الطوارئ ويستمر بالسير على يمين الشارع.",
        "يسير حتى خليج الوقوف القريب أو حتى خليج محطة الباص، ويتوقف هناك من اجل تمكين المركبات من تجاوزه."
      ],
      id: 1131
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1762. إذا توقفت مركبة قبل ملتقى سكة حديد:",
      numQues: "1762",
      correctAnswer: "ممنوع تجاوزها.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "مسموح تجاوزها إذا كان عرض الشارع يزيد عن 6م.",
        "مسموح تجاوزها إذا كان لسكة الحديد حاجز.",
        "مسموح تجاوزها إذا لم يكن هناك خط فاصل متواصل.",
        "ممنوع تجاوزها."
      ],
      id: 1132
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0324. متى يسري على السائق واجب تشغيل مخفف السرعة المُركب في المركبة؟",
      numQues: "0324",
      correctAnswer: "عند السير في مقطع طريق نُصبت قبله إشارة تُحذر من التواء حاد.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "عند السير في مقطع طريق نُصبت قبله إشارة تُحذر من منعطف حاد.",
        "عند السير في مقطع طريق نُصبت قبله إشارة تُحذر من التزحلق الخطر.",
        "عند السير في مقطع طريق نُصبت قبله إشارة تُحذر من منحدر خطر.",
        "عند السير في مقطع طريق نُصبت قبله إشارة تُحذر من التواء حاد."
      ],
      id: 1133
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0437. كيف تتصرف حسب الإشارة ؟",
      numQues: "0437",
      correctAnswer: "أعطِ حق الأولوية في الاندماج واندمج بحذر مع حركة السير في الطريق التي على يسارك.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3436.jpg",
      choices: [
        "أنت تسير في مسلك تسارع، اندمج بسرعة مع انسياب حركة المركبات التي تسير في الطريق التي تدخلها.",
        "زد من سرعتك، على المركبات في الطريق التي تدخلها إعطائك حق الأولوية.",
        "أعطِ حق الأولوية للمركبات في الطريق القاطعة من كلا الاتجاهين.",
        "أعطِ حق الأولوية في الاندماج واندمج بحذر مع حركة السير في الطريق التي على يسارك."
      ],
      id: 1134
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0884. كيف تؤثر المسافة بين المركبات على عملية التجاوز؟",
      numQues: "0884",
      correctAnswer: "لا يوجد تأثير للمسافة بين المركبات على السلامة في التجاوز.",
      pubDate: "10-11-2011 08:23:02",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3884.jpg",
      choices: [
        "المسافة الصغيرة تقلل من مدى الرؤية وتزيد الخطر في التجاوز.",
        "كلما اقتربنا من المركبة التي أمامنا كلما كانت مسافة التجاوز اقصر وأكثر أماناً.",
        "كلما اقتربنا من المركبة التي أمامنا كلما كان الانحراف أثناء التجاوز أكثر أماناً.",
        "لا يوجد تأثير للمسافة بين المركبات على السلامة في التجاوز."
      ],
      id: 1135
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1628. هل يجوز لسائق التراكتور عبور (قطع) الرصيف؟",
      numQues: "1628",
      correctAnswer: "نعم، من اجل إنزال راكب.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "نعم، من اجل أخذ راكب.",
        "نعم، من اجل الدخول إلى ساحة أو كراج.",
        "نعم، من اجل تجاوز عائق في الطريق.",
        "نعم، من اجل إنزال راكب."
      ],
      id: 1136
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1785. ممنوع التجاوز قبل ممر المشاة:",
      numQues: "1785",
      correctAnswer: "في كل وقت وفي كل طريق.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "فقط في شارع داخل المدن وفيه مسلكان، أما في باقي الشوارع فيسمح بالتجاوز.",
        "فقط إذا نُصبت إشارة 'مكان لعبور المشاة أمامك'.",
        "فقط إذا كانت هناك إشارة زرقاء تشير إلى 'مكان عبور المشاة'.",
        "في كل وقت وفي كل طريق."
      ],
      id: 1137
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1188. هل يُعتبر إنزال ركاب من مركبة عمومية كتوقف؟",
      numQues: "1188",
      correctAnswer: "نعم، يُعتبر كتوقف.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "كلا، يُعتبر كوقوف.",
        "يُعتبر في البداية كتوقف وبعدها كوقوف.",
        "كلا، لا يُعتبر كتوقف.",
        "نعم، يُعتبر كتوقف."
      ],
      id: 1138
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0091. يجوز لمن بحوزته رخصة سياقة من الدرجة B أن يسوق أيضاً:",
      numQues: "0091",
      correctAnswer: "كل مركبة طبية خاصة دون أي تحديد في وزن المركبة الإجمالي المسموح به.",
      pubDate: "10-11-2011 08:23:02",
      img: "",
      choices: [
        "مركبة معاق ذُكر في رخصتها بأنها مركبة طبية خاصة ووزنها الإجمالي المسموح به لغاية 4000 كغم.",
        "مركبة معاق ذُكر في رخصتها بأنها مركبة طبية خاصة ووزنها الإجمالي المسموح به لا يزيد عن 2500 كغم.",
        "كل مركبة لا يزيد وزنها الإجمالي المسموح به عن 5000 كغم.",
        "كل مركبة طبية خاصة دون أي تحديد في وزن المركبة الإجمالي المسموح به."
      ],
      id: 1139
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0765. المحافظة على مسافة من المركبة التي أمامك أثناء السياقة، تؤثر على استهلاك الوقود واستهلاك المركبة، صحيح أم لا؟",
      numQues: "0765",
      correctAnswer: "صحيح، تمنع المحافظة على مسافة اهتراء الفرامل والاستهلاك الزائد للوقود، واللذان ينتجان عن الإسراع والفرملة المتتاليين.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "غير صحيح، تتسبب المحافظة على مسافة من المركبة التي أمامك في اهتراء الفرامل.",
        "غير صحيح، ملاءمة المسافة بواسطة استعمال الفرامل ودعسة الوقود ضرورية لزيادة اليقظة عند السائق.",
        "غير صحيح، لا تؤثر على استهلاك المركبة أو على استهلاك الوقود.",
        "صحيح، تمنع المحافظة على مسافة اهتراء الفرامل والاستهلاك الزائد للوقود، واللذان ينتجان عن الإسراع والفرملة المتتاليين."
      ],
      id: 1140
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0583. ما معنى الإشارة؟",
      numQues: "0583",
      correctAnswer: "موقف للمركبات.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3583.jpg",
      choices: [
        "ممنوع توقف المركبات إلا من اجل إنزال الركاب واصعادهم. ",
        "موقف للمركبات غير الميكانيكية فقط.",
        "محطة نقل جنود، لاصعاد وإنزال الركاب فقط.",
        "موقف للمركبات."
      ],
      id: 1141
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0355. حسب أية إشارة سير يجب التوقف دائماً؟",
      numQues: "0355",
      correctAnswer: "102",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3355.jpg",
      choices: [
        "301",
        "124",
        "302",
        "102"
      ],
      id: 1142
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0932. ما هي ألمخاطر على المركبة التجارية (التندر) الخضراء التي تنوي الاستدارة إلى اليمين، حسب الظاهر في الصورة؟",
      numQues: "0932",
      correctAnswer: "تنوي الدراجة النارية السير إلى الأمام، لذلك لا يوجد أي خطر عند استدارة التندر يميناً.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3932.jpg",
      choices: [
        "على سائق المركبة التجارية (التندر) أن يسير بحذر شديد لأن هناك مركبة أخرى في حالة سير على يمينه في المساحة الميتة.",
        "يجوز للمركبة التجارية (التندر) الاستدارة يميناً حتى وإن كانت الدراجة النارية على يمينة لأن القانون لا يمنع ذلك.",
        "المسلك الموجودة فيه المركبة التجارية (التندر) غير مُعد للاستدارة يميناً.",
        "تنوي الدراجة النارية السير إلى الأمام، لذلك لا يوجد أي خطر عند استدارة التندر يميناً."
      ],
      id: 1143
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1037. متى يجب تغيير مطفأة الحريق في المركبة؟",
      numQues: "1037",
      correctAnswer: "كل ثاني ترخيص سنوي (تست)، أي كل سنتين.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "إذا تم استعمالها كلياً أو جزئياً، أو إذا كان مقياس الضغط فيها يشير إلى ضغط داخلي منخفض.",
        "كل سنة قبل فحص الترخيص السنوي (التست) للمركبة.",
        "عندما لا نسمع حركة المادة داخل المطفأة.",
        "كل ثاني ترخيص سنوي (تست)، أي كل سنتين."
      ],
      id: 1144
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0803. متى تزيد السرعة المعقولة عن السرعة القصوى المسموح بها؟",
      numQues: "0803",
      correctAnswer: "عند تجاوز مركبة واقفة بجانب الطريق.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "ولا في أية حالة، هذه الحالة غير قانونية.",
        "أثناء تجاوز مركبة تسير في الطريق.",
        "عند تجاوز مركبة تسير بالسرعة القصوى المسموح بها.",
        "عند تجاوز مركبة واقفة بجانب الطريق."
      ],
      id: 1145
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0462. أية إشارة تُنصب في المفترق بعد أن عبرت عن الإشارة 139 التي في الصورة؟",
      numQues: "0462",
      correctAnswer: "307",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3462.jpg",
      choices: [
        "301",
        "302",
        "303",
        "307"
      ],
      id: 1146
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1806. أي إشارة معناها موقع تعبئة ( شحن بطارية) مركبة كهربائية؟",
      numQues: "806 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [],
      id: 1147
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1598. عندما تكون الرؤية غير واضحة؟",
      numQues: "1598",
      correctAnswer: "خفف من سرعة سيرك وحافظ على مسافة اكبر من المعتاد من المركبة التي في الأمام.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "التصق بالمركبة التي تسير أمامك لكي تساعدك أضواؤه.",
        "سر بالسرعة المعتادة لكن ابقَ يقظاً واضغط طيلة الوقت على دعسة الفرامل من اجل التوقف في حالة الطوارئ.",
        "حافظ على يمين الطريق وزد من سرعة المركبة لغاية أن تتضح الرؤية.",
        "خفف من سرعة سيرك وحافظ على مسافة اكبر من المعتاد من المركبة التي في الأمام."
      ],
      id: 1148
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0233. كيف تنقل في المركبة ولداً لم يتم السنة من عمره؟",
      numQues: "0233",
      correctAnswer: "على ركبتي راكب يزيد عمره عن 21 سنة.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "في مقعد أمان للأطفال وفقط في المقعد الخلفي للمركبة.",
        "في مقعد أمان بحيث يكون ظهر المقعد موجهاً نحو مقدمة المركبة.",
        "في المقعد الأمامي فقط وبرفقة راكب بالغ.",
        "على ركبتي راكب يزيد عمره عن 21 سنة."
      ],
      id: 1149
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1337. متى يجب تشغيل مصباح يضيء بضوء اصفر متقطع فوق كابينة السائق في الشاحنة؟",
      numQues: "1337",
      correctAnswer: "عند نقل أجهزة مستنفذة.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "إذا كان عرض الحمولة يزيد عن 3م.",
        "عندما يكون عرض الحمولة ثلاثة أمتار أو اقل.",
        "عندما يكون عرض الحمولة أكثر من 2.80م.",
        "عند نقل أجهزة مستنفذة."
      ],
      id: 1150
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1101. عندما تُذكر 'سرعة تشغيل قياسية' لناقل القوة (PTO)، ماذا يُقصد بذلك؟",
      numQues: "1101",
      correctAnswer: "سرعة دوران مخرج ناقل القوة في الدقيقة والدراي شافط الخاص به.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "سرعة الدوران في الدقيقة التي يدور فيها العامود الخارج من صندوق الغيارات. ",
        "سرعة دوران مضخة الزيت في الدقيقة والتي تحرك ناقل القوة.",
        "سرعة دوران المحرك نفسه في الدقيقة (الخارجة إلى الفلاي ويل)",
        "سرعة دوران مخرج ناقل القوة في الدقيقة والدراي شافط الخاص به."
      ],
      id: 1151
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1729. أية إشارة تظهر بعد الإشارة 716 ؟",
      numQues: "1729",
      correctAnswer: "709",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31729.jpg",
      choices: [
        "708",
        "710",
        "711",
        "709"
      ],
      id: 1152
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1656. ماذا يجب أن نفحص عند شراء إطار جديد للمركبة؟",
      numQues: "1656",
      correctAnswer: "فقط إذا كان شكل نعل الإطار (وجه الإطار) الجديد مشابه لشكل نعل الإطار القديم.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "فقط إذا كان قياس الإطار الجديد مشابه لقياس الإطار القديم.",
        "فقط إذا كان قياس ضغط الهواء المطلوب في الإطار الجديد مشابه لقياس ضغط الهواء في الإطار القديم.",
        "تاريخ إنتاج الإطار من اجل التأكد بأن عمر الإطار ليس أقدم من اللازم (أكثر من ست سنوات).",
        "فقط إذا كان شكل نعل الإطار (وجه الإطار) الجديد مشابه لشكل نعل الإطار القديم."
      ],
      id: 1153
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0449. ما معنى الإشارة؟",
      numQues: "0449",
      correctAnswer: "أمامك ملتقى سكة حديد (حوالي 100م قبل الملتقى).",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3449.jpg",
      choices: [
        "أمامك ملتقى سكة حديد (حوالي 150م قبل الملتقى).",
        "أمامك ملتقى سكة حديد (حوالي 30م قبل الملتقى).",
        "أمامك ملتقى سكة حديد (حوالي 300م قبل الملتقى).",
        "أمامك ملتقى سكة حديد (حوالي 100م قبل الملتقى)."
      ],
      id: 1154
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0795. اختر الجملة الصحيحة: القانون يمنع سائق مركبة الاستدارة بها إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس):",
      numQues: "0795",
      correctAnswer: "عندما تُنصب إشارة تمنع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس).",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "في مكان لا تُرى منه من قِبل سائق آخر يقترب من أية جهة.",
        "جميع الإجابات صحيحة.",
        "عندما يقترب من قمة انحدار أو من التواء في الطريق.",
        "عندما تُنصب إشارة تمنع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس)."
      ],
      id: 1155
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1261. هل يُسمح بدخول باص صغير (أوتوبوس زعير) بدون ركاب في طريق نُصبت فيها هذه الإشارة؟",
      numQues: "1261",
      correctAnswer: "كلا، لأن الباص الصغير بدون ركاب لا يُعتبر باص.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3531.jpg",
      choices: [
        "نعم.",
        "كلا، لأنه لا يوجد فيه عدد الركاب الملزم بالإشارة.",
        "نعم، لأن السير مسموح لجميع المركبات.",
        "كلا، لأن الباص الصغير بدون ركاب لا يُعتبر باص."
      ],
      id: 1156
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1255. أية إضافة تُضاف عن سفرة خدمة في صالون عمومي بين الساعات 23:31 – 04:59 ؟",
      numQues: "1255",
      correctAnswer: "50%",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "25%",
        "0.125",
        "0.18",
        "50%"
      ],
      id: 1157
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0542. ما معنى الإشارة؟",
      numQues: "0542",
      correctAnswer: "سر فقط إلى اليسار، ممنوع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس).",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3541.jpg",
      choices: [
        "سر إلى اليسار واستدر من أمام الإشارة.",
        "الدخول إلى شارع باتجاه واحد. ",
        "استدر إلى اليسار من خلف الإشارة.",
        "سر فقط إلى اليسار، ممنوع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس)."
      ],
      id: 1158
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1411. كيف توسم (تؤشر) الحمولة البارزة من القسم الخلفي أو الأمامي للمركبة؟",
      numQues: "1411",
      correctAnswer: "إذا برزت الحمولة من القسم الأمامي أو الخلفي للمركبة وكان بروزها يزيد عن 15سم، يجب وسمها (تأثيرها) بمثلثين أحمرين عاكسين من كل جهة.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "لا يوجد واجب بوسم (تأشير) الحمولة البارزة من القسم الأمامي للمركبة، وإذا برزت الحمولة من الخلف فتوسم (تؤشر) بمثلث احمر عاكس.",
        "في القسم الأمامي من المركبة توسم (تؤشر) الحمولة بمثلث عاكس باللون الأبيض، وفي القسم الخلفي توسم (تؤشر) بمثلث عاكس ابيض مع إطار احمر عاكس.",
        "في القسم الأمامي من المركبة توسم (تؤشر) الحمولة بمثلث احمر، وفي القسم الخلفي توسم (تؤشر) الحمولة بمثلث ابيض.",
        "إذا برزت الحمولة من القسم الأمامي أو الخلفي للمركبة وكان بروزها يزيد عن 15سم، يجب وسمها (تأثيرها) بمثلثين أحمرين عاكسين من كل جهة."
      ],
      id: 1159
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0599. إلى ماذا ترمز الإشارة؟",
      numQues: "0599",
      correctAnswer: "محطة إسعاف أولي.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3599.jpg",
      choices: [
        "فندق خمسة نجوم.",
        "ملجأ عجزة.",
        "مستشفى.",
        "محطة إسعاف أولي."
      ],
      id: 1160
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0129. بأية شروط يُسمح بتجاوز مركبة أخرى:",
      numQues: "0129",
      correctAnswer: "فقط إذا كانت المركبة التي نتجاوزها دراجة نارية.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "فقط إذا اشر سائق المركبة المنوي تجاوزها لسائق المركبة المتجاوزة.",
        "عندما تكون الطريق خالية ويتم التجاوز بأمان دون إعاقة أو إزعاج المركبة الأخرى.",
        "فقط إذا كانت المركبة المنوي تجاوزها مركبة بطيئة.",
        "فقط إذا كانت المركبة التي نتجاوزها دراجة نارية."
      ],
      id: 1161
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0816. ما هو تأثير المحافظة على مسافة على مدى الرؤية لدى السائق؟",
      numQues: "0816",
      correctAnswer: "تؤثر المحافظة على مسافة على مدى الرؤية في السير بسرعات عالية فقط وفي جو عاصف فقط.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "لا توجد علاقة على الإطلاق بين المحافظة على مسافة وبين مدى الرؤية لدى سائق المركبة.",
        "كلما حافظنا على مسافة اكبر من المركبة التي أمامنا يزداد مدى الرؤية.",
        "تؤثر المسافة على مدى الرؤية أثناء السياقة في حالة الازدحام في حركة السير فقط.",
        "تؤثر المحافظة على مسافة على مدى الرؤية في السير بسرعات عالية فقط وفي جو عاصف فقط."
      ],
      id: 1162
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1014. أي جزء في المركبة يقلل من تأرجح الرأس إلى الخلف أثناء الاصطدام؟",
      numQues: "1014",
      correctAnswer: "حزام الأمان.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "وسادة الهواء.",
        "المصد (الطمبون) الخلفي.",
        "ساندة الرأس في مقاعد المركبة.",
        "حزام الأمان."
      ],
      id: 1163
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1596. ما هو الشيء الخاص في تشغيل فرامل الدراجة النارية؟",
      numQues: "1596",
      correctAnswer: "لا يمكن فرملة كل عجلة في الدراجة النارية على انفراد.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "تشغيل الفرامل في الدراجة النارية أكثر أماناً لأنها تتم فقط بواسطة اليدين.",
        "يمكن تشغيل الفرملة الخلفية والفرملة الأمامية على انفراد.",
        "يمكن فرملة الدراجة النارية في المكان في أية سرعة كانت.",
        "لا يمكن فرملة كل عجلة في الدراجة النارية على انفراد."
      ],
      id: 1164
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0804. ما هي أخطار السياقة بسرعات عالية؟",
      numQues: "0804",
      correctAnswer: "لا يوجد خطر من السواقة بسرعات عالية.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "تقليل إمكانية إيقاف المركبة في الوقت المناسب من اجل منع حادث وحتى فقدان السيطرة على المركبة. ",
        "ضرر شديد لإطارات المركبة الأمامية ولجهاز المقود.",
        "استهلاك سريع لمحرك المركبة.",
        "لا يوجد خطر من السواقة بسرعات عالية."
      ],
      id: 1165
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0348. هل يجب أن يكون مقياس السرعة (السبيدومتر) بحالة سليمة في المركبة؟",
      numQues: "0348",
      correctAnswer: "نعم ، في جميع الأوقات.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3139.jpg",
      choices: [
        "كلا، حسب رغبة السائق.",
        "كلا، لا يوجد واجب بأن يكون بحالة سليمة، يكفي السير بسرعة مسموحة.",
        "ليس دائماً، فقط في المركبة المُركب فيها تاكوغراف.",
        "نعم ، في جميع الأوقات."
      ],
      id: 1166
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1450. هل تسري الواجبات والممنوعيات التي تسري على مركبة تجارية تسري أيضاً على مركبة شاحنة؟",
      numQues: "1450",
      correctAnswer: "نعم، الواجبات والممنوعيات التي تسري على مركبة تجارية تسري أيضاً على مركبة شاحنة، ما عدا واجب ربط أحزمة الأمان. ",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "كلا، الواجبات والممنوعيات اللذان يسريان على المركبة التجارية يسريان فقط على مركبة شاحنة موحدة.",
        "كلا، حكم المركبة التجارية هو غير حكم المركبة الشاحنة، فإن الواجبات والممنوعيات التي تسري على إحداهما لا تسري على الأخرى. ",
        "نعم، الواجب أو المنع اللذان يسريان على المركبة التجارية يسريان أيضاً على المركبة الشاحنة.",
        "نعم، الواجبات والممنوعيات التي تسري على مركبة تجارية تسري أيضاً على مركبة شاحنة، ما عدا واجب ربط أحزمة الأمان. "
      ],
      id: 1167
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1809. أي إشارة معناها موقع تعبئة ( شحن بطارية) مركبة كهربائية؟",
      numQues: "809 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [],
      id: 1168
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0822. متى يجوز تجاوز أكثر من مركبة واحدة في عملية تجاوز واحدة؟",
      numQues: "0822",
      correctAnswer: "مسموح – فقط في شارع مستوي وافقي وممنوع في أي شارع آخر.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "إذا لم يكن هناك منع للتجاوز وهناك مسافة كافية في مسلك التجاوز لإكمال مثل هذا التجاوز بدون خطر.",
        "مسموح – فقط عندما نتجاوز مركبات صغيرة وممنوع عندما نتجاوز مركبات كبيرة.",
        "لا يجوز مطلقاً: يلزم القانون بتجاوز مركبة واحدة عند كل تجاوز والعودة مرة أخرى للمسلك الأيمن.",
        "مسموح – فقط في شارع مستوي وافقي وممنوع في أي شارع آخر."
      ],
      id: 1169
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1354. ما هي المسافة المطلوبة بين كابينة السائق في الساندة وبين الجانب الأمامي للمستندة في مركبة من نوع 'ساندة'؟",
      numQues: "1354",
      correctAnswer: "لا يجب أن تكون المسافة بين المستندة والساندة أكثر من 150سم.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "يجب أن تمكن المسافة من الحركة الحرة لأنابيب الهواء في جهاز الفرامل، وليس أكثر من 50سم.",
        "المسافة التي تمكن كلاهما من الحركة في أي اتجاه بدون أن يلامس احدهما الآخر، وتُمكن أيضاً من الحركة الحرة للتوصيلات عند الاستدارة القصوى. ",
        "تعتمد المسافة على طول الساندة وعلى مكان العجلة الخامسة (الصينية) وليس اقل من 400سم.",
        "لا يجب أن تكون المسافة بين المستندة والساندة أكثر من 150سم."
      ],
      id: 1170
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1140. أية أدوات يجب أن تكون في الباص الذي ينقل ركاب في خط داخل المدن؟",
      numQues: "1140",
      correctAnswer: "أدوات الإسعاف الأولي.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "حقيبة إسعاف أولي وأجهزة إنقاذ.",
        "حقيبة إسعاف أولي وحمالة.",
        "حمالة وخزان ماء.",
        "أدوات الإسعاف الأولي."
      ],
      id: 1171
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0327. في أية حالات لا يستطيع السائق الحصول على رخصة سياقة أو تجديدها؟",
      numQues: "0327",
      correctAnswer: "إذا كان الشخص من دولة لا توجد فيها قوانين سير مقبولة.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "إذا حُرم من الحصول على رخصة سياقة أو تبين أن لديه خلل في صحته يُشكل خطورة عليه أو على الآخرين.",
        "إذا كان طالب رخصة السياقة لا يعرف الكتابة والقراءة.",
        "إذا قضى عقوبة السجن لمدة سنة بسبب السياقة في حالة ثمل (سكران) قبل تقديم الطلب للحصول على الرخصة.",
        "إذا كان الشخص من دولة لا توجد فيها قوانين سير مقبولة."
      ],
      id: 1172
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1429. حسب ما حُدد في القانون، هل توجد أهمية للحمولة وترتيبها على المركبة؟",
      numQues: "1429",
      correctAnswer: "لا توجد أهمية لذلك بشرط أن لا يكون الوزن الإجمالي أكثر من المسموح به.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "نعم، يجب التأكد من مكان الحمولة وتثبيتها على المركبة بشكل يمنع سقوطها من المركبة.",
        "فقط لا يجب أن يكون الوزن على المحاور الخلفية أكثر من الوزن المُحدد في أنظمة المرور.",
        "مسموح أن يكون الوزن على المحاور أكثر من الوزن الذي حدده منتج المركبة أو الأنظمة، لغاية 20%..",
        "لا توجد أهمية لذلك بشرط أن لا يكون الوزن الإجمالي أكثر من المسموح به."
      ],
      id: 1173
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1204. أية إشارة تعني عدد الكيلومترات في الطريق؟",
      numQues: "1204",
      correctAnswer: "612",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31204.jpg",
      choices: [
        "630",
        "629",
        "611",
        "612"
      ],
      id: 1174
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1612. كيف تؤثر المنعطفات والاستدارات على قدرة الفرملة في الدراجة النارية؟",
      numQues: "1612",
      correctAnswer: "عند السير في منعطف أو استدارة يتضاعف زمن رد الفعل.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "أثناء الانعطاف أو الاستدارة يمكن الفرملة بالفرملة الخلفية لذلك تضعف الفرملة.",
        "لا يوجد أي تأثير للمنعطف أو الاستدارة على قوة الفرملة في الدراجة النارية.",
        "تُلزم بتخفيف السرعة قبل المنعطف أو الاستدارة والفرملة برقة متناهية.",
        "عند السير في منعطف أو استدارة يتضاعف زمن رد الفعل."
      ],
      id: 1175
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0985. ما هي الجملة الصحيحة بالنسبة لما نراه في الصورة؟",
      numQues: "0985",
      correctAnswer: "الوسم (التأشير) على سطح الشارع غير واضح بما فيه الكفاية.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3985.jpg",
      choices: [
        "سائق الصهريج (التنك) يسير بعيداً عن الحواشي الرخوة وبذلك يُجنب نفسه الخطر.",
        "سائق الصهريج (التنك) يسير بشكلٍ صحيح في وسط الشارع، من اجل أن يُحسِن رؤية المركبات القادمة من الجهة المقابلة.",
        "سائق الصهريج (التنك) لا يحافظ على يمين الشارع.",
        "الوسم (التأشير) على سطح الشارع غير واضح بما فيه الكفاية."
      ],
      id: 1176
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0255. في أية حالات يجب على سائق المركبة الميكانيكية 'خفت' أضواء المركبة؟",
      numQues: "0255",
      correctAnswer: "إذا كان يسير خلف مركبة أخرى ويضيء 'ضوء الضباب' و 'الضوء العالي' مع بعض.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "إذا كان يسير خلف مركبة أخرى ونور الضوء العالي يضيء القسم الخلفي للمركبة التي تسير أمامه.",
        "فقط إذا كان يسير في نفق.",
        "عندما تضاء في المركبة 'مصابيح الضباب' أيضاً.",
        "إذا كان يسير خلف مركبة أخرى ويضيء 'ضوء الضباب' و 'الضوء العالي' مع بعض."
      ],
      id: 1177
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1727. من بحوزته رخصة سواقة من الدرجة 'B'، يجوز له أن يسوق:",
      numQues: "1727",
      correctAnswer: "كل مركبة ميكانيكية وزنها الإجمالي لغاية 6000كغم.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3091.jpg",
      choices: [
        "أي باص وزنه الإجمالي المسموح به لغاية 3500كغم. ",
        "باص صغير عمومي وزنه الإجمالي المسموح به لغاية 3500كغم.",
        "باص صغير خصوصي وزنه الإجمالي المسموح به لغاية 3500كغم.",
        "كل مركبة ميكانيكية وزنها الإجمالي لغاية 6000كغم."
      ],
      id: 1178
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1387. ما هي الإشارة التي معناها: حاجز قبل ملتقى سكة حديد؟",
      numQues: "1387",
      correctAnswer: "511",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31387.jpg",
      choices: [
        "403",
        "404",
        "113",
        "511"
      ],
      id: 1179
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1751. الإشارة الضوئية تضيء بالضوء الأخضر لكن المفترق مسدود بالمركبات:",
      numQues: "1751",
      correctAnswer: "ممنوع الدخول إلى المفترق عندما يكون مسدوداً.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "يجب الدخول إلى المفترق حسب ما يأمر به الضوء الأخضر.",
        "مسموح الدخول إلى المفترق في جميع الأحوال.",
        "يجب الدخول إلى المفترق وعبوره بالسرعة الممكنة.",
        "ممنوع الدخول إلى المفترق عندما يكون مسدوداً."
      ],
      id: 1180
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1435. ما هو واجب سائق مركبة وزنها الإجمالي أكثر من 3500كغم عند إيقاف مركبة في 'وقت الإنارة' وفي طريق ليست بلدية؟",
      numQues: "1435",
      correctAnswer: "تشغيل الأربعة غمازات وإضاءة مصابيح العرض.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "وضع مثلث تحذير وتشغيل الغماز الأيمن.",
        "وضع مثلث تحذير دائماً ووضع مصباح متنقل أيضاً أو تشغيل الأربعة غمازات (مصابيح الطوارئ). ",
        "تشغيل الأربعة غمازات ووضع مصباح متنقل.",
        "تشغيل الأربعة غمازات وإضاءة مصابيح العرض."
      ],
      id: 1181
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1228. هل يجوز لكل سائق صالون عمومي أن يقوم بسفرة سياحية؟",
      numQues: "1228",
      correctAnswer: "نعم، بشرط أن يكون مسجلاً في مكتب للسفريات.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "نعم، يجوز لكل سائق صالون عمومي.",
        "نعم، بشرط أن يكون بحوزته إذن من وزارة السياحة.",
        "نعم، يجوز لكل سائق صالون عمومي مسجل في محطة معروفة للصالون العمومي.",
        "نعم، بشرط أن يكون مسجلاً في مكتب للسفريات."
      ],
      id: 1182
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0712. أية مركبة يجوز لها أن تدخل أولاً إلى المفترق؟",
      numQues: "0712",
      correctAnswer: "المركبة التي تستدير إلى اليسار (3).",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3712.jpg",
      choices: [
        "الباص الأصفر (1).",
        "المركبة الأقرب إلى المفترق.",
        "راكب الدراجة الهوائية (2).",
        "المركبة التي تستدير إلى اليسار (3)."
      ],
      id: 1183
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0471. ما معنى الإشارة؟",
      numQues: "0471",
      correctAnswer: "مشاة بالقرب من المكان.",
      pubDate: "10-11-2011 08:23:03",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3471.jpg",
      choices: [
        "مكان لعبور الأولاد فقط.",
        "سبيل للمشاة.",
        "أولاد بالقرب من المكان.",
        "مشاة بالقرب من المكان."
      ],
      id: 1184
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0071. في أية حالة لا يجوز للسائق سياقة أية مركبة؟",
      numQues: "0071",
      correctAnswer: "قبل تناول الدواء ولمدة 24 ساعة متواصلة بعد ذلك.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "عندما يكون في حالة صحية أو نفسية من شأنها أن تُعرض عابري الطريق للخطر.",
        "إذا لم يسترح مدة 8 ساعات على الأقل قبل البدء بالسياقة.",
        "لا توجد حالة في القانون تمنع السياقة إذا كان السائق يحمل رخصة سياقة سارية المفعول.",
        "قبل تناول الدواء ولمدة 24 ساعة متواصلة بعد ذلك."
      ],
      id: 1185
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1175. هل يجوز لصاحب صالون عمومي أو السائق تغيير أجرة السفر في الصالون العمومي؟",
      numQues: "1175",
      correctAnswer: "نعم، لغاية 15% من الأجرة المحددة.",
      pubDate: "10-11-2011 08:23:03",
      img: "",
      choices: [
        "مسموح، بإعلان مسبق قبل 26 يوماً.",
        "ممنوع.",
        "نعم، 24 ساعة قبل بدء سريان التعرفة الجديدة.",
        "نعم، لغاية 15% من الأجرة المحددة."
      ],
      id: 1186
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0426. ما معنى الإشارة؟",
      numQues: "0426",
      correctAnswer: "إشارة إرشاد، سر إلى اليمين فقط.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3426.jpg",
      choices: [
        "مفترق تفرع طرق أمامك.",
        "أعطِ حق الأولوية للمركبات في الطريق القاطعة.",
        "طريق بدون مخرج أمامك.",
        "إشارة إرشاد، سر إلى اليمين فقط."
      ],
      id: 1187
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0832. ما هو الشروط الأكثر أهمية للنزول الآمن إلى حاشية الطريق؟",
      numQues: "0832",
      correctAnswer: "إذا كانت الحاشية معبدة بالإسفلت أو الباطون.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3832.jpg",
      choices: [
        "إذا كانت الحاشية والشارع على نفس مستوى الارتفاع، والحاشية عريضة بما فيه الكفاية.",
        "الشرط الوحيد المهم هو أن يكون التوقف على الحاشية مسموحاً.",
        "إذا لم تكن هناك علامات ملونة على الحاشية.",
        "إذا كانت الحاشية معبدة بالإسفلت أو الباطون."
      ],
      id: 1188
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1459. أنت تسوق مركبة من نوع شحن ثقيل وتسير في منحدر شديد وطويل، متى يجب عليك تعشيق الغيار الواطئ المناسب؟",
      numQues: "1459",
      correctAnswer: "لا توجد ضرورة للغيار الواطئ: يجب تعشيق الغيار العالي وضبط السرعة بمساعدة مخفف السرعة من اجل زيادة الأمان.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "يجب تعشيق الغيار الواطئ عند نهاية المنحدر.",
        "لا توجد أهمية للتمهل بواسطة الغيارات وإنما يجب استعمال مخففات السرعة بشكلٍ معقول.",
        "يجب تعشيق الغيار الواطئ في بداية المنحدر.",
        "لا توجد ضرورة للغيار الواطئ: يجب تعشيق الغيار العالي وضبط السرعة بمساعدة مخفف السرعة من اجل زيادة الأمان."
      ],
      id: 1189
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0087. متى يُسمح بالسياقة على الرصيف ؟",
      numQues: "0087",
      correctAnswer: "مسموح السياقة على الرصيف عندما لا يتواجد عليه مشاة.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "مسموح السياقة على الرصيف من اجل العبور أو من اجل الدخول إلى الساحات والخروج منها. ",
        "مسموح السياقة على الرصيف عندما تكون هناك عرقلة أو انسداد في مسلك السير.",
        "ممنوع السياقة على الرصيف على الإطلاق.",
        "مسموح السياقة على الرصيف عندما لا يتواجد عليه مشاة."
      ],
      id: 1190
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0580. ما معنى الإشارة؟",
      numQues: "0580",
      correctAnswer: "مكان عبور راكبي الدراجات الهوائية والمشاة.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3580.jpg",
      choices: [
        "طريق للنزهة أمامك.",
        "سبيل للدراجات الهوائية فقط.",
        "سبيل للدراجات الهوائية وللمشاة فقط.",
        "مكان عبور راكبي الدراجات الهوائية والمشاة."
      ],
      id: 1191
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0799. ما هو الخطر الرئيسي عند الرجوع إلى الخلف؟",
      numQues: "0799",
      correctAnswer: "ضرر بجهاز المقود بسبب عملية المقود المعكوسة للقيادة العادية عند السير إلى الأمام.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "ضرر بإطارات المركبة عند الاقتراب من رصيف أو أجسام حادة.",
        "تواجد عابري طريق في حدود 'المساحات الميتة' وإصابتهم.",
        "الافتقار إلى السيطرة على سرعة سير بطيئة وموحدة بسبب التحديد في الغيارات.",
        "ضرر بجهاز المقود بسبب عملية المقود المعكوسة للقيادة العادية عند السير إلى الأمام."
      ],
      id: 1192
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0496. كيف تتصرف حسب الإشارة؟",
      numQues: "0496",
      correctAnswer: "زد من السرعة لكي تكمل المرور في مقطع الطريق في وقتٍ قصير.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3495.jpg",
      choices: [
        "تابع السير بالسرعة العادية، لك حق الأولوية.",
        "دع المركبة القادمة من الجهة المقابلة أن تعبر عنك دون أن يتأخر أو أن ينحرف عن مسلكه.",
        "امتنع عن استعمال المسلك الأيمن أثناء السير. ",
        "زد من السرعة لكي تكمل المرور في مقطع الطريق في وقتٍ قصير."
      ],
      id: 1193
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0229. هل يجوز نقل أكثر من راكب واحد بجانب السائق؟",
      numQues: "0229",
      correctAnswer: "ممنوع منعاً باتاً.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "مسموح إذا وُجد حزامي أمان بالإضافة إلى حزام السائق.",
        "مسموح إذا كان المقعد الأمامي مقعد موحد.",
        "ممنوع إلا إذا سُمح بذلك في رخصة المركبة.",
        "ممنوع منعاً باتاً."
      ],
      id: 1194
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1344. السرعة القصوى المسموح بها في طريق سريعة هي 110كم/ساعة، أي من المركبات التجارية يُمنع سيرها بهذه السرعة؟",
      numQues: "1344",
      correctAnswer: "مركبة تجارية وزنها الإجمالي المسموح به أكثر من 10000كغم.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "كل مركبة وزنها الإجمالي المسموح به أكثر من 8000كغم.",
        "كل مركبة وزنها الإجمالي المسموح به أكثر من 12000كغم.",
        "مركبة تجارية وزنها الإجمالي المسموح به أكثر من 12000كغم ومركبة عمل ومركبة تجوال ومركبة بطيئة.",
        "مركبة تجارية وزنها الإجمالي المسموح به أكثر من 10000كغم."
      ],
      id: 1195
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "0993. ماذا يمكن أن يحدث للمركبة عند إقفال العجلات؟",
      numQues: "0993",
      correctAnswer: "في المركبة الأوتوماتيكية ينطفئ المحرك.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "سخونة زائدة لمحرك المركبة.",
        "تفقد المركبة قدرتها على الفرملة.",
        "تفقد المركبة قدرتها على توجيه المقود.",
        "في المركبة الأوتوماتيكية ينطفئ المحرك."
      ],
      id: 1196
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0273. أين يُسمح بوقوف مركبة محركها يعمل بواسطة الغاز:",
      numQues: "0273",
      correctAnswer: "في المواقف المسموح فيها وقوف المركبات التي يعمل محركها بواسطة الغاز حسب تعليمات مستورد المركبة.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "في المواقف العادية المسموح فيها وقوف المركبات التي يعمل محركها بواسطة البنزين.",
        "في المواقف المسموح فيها وقوف المركبات من نوع مركبة ركاب خصوصية فقط.",
        "في المواقف المسموح فيها وقوف المركبات التي يعمل محركها بواسطة الغاز حسب تعليمات وزارة جودة البيئة.",
        "في المواقف المسموح فيها وقوف المركبات التي يعمل محركها بواسطة الغاز حسب تعليمات مستورد المركبة."
      ],
      id: 1197
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1077. ما هي عمليات السلامة التي يجب القيام بها قبل رفع المركبة بمساعدة رافعة (جاك)؟",
      numQues: "1077",
      correctAnswer: "فقط للتأكد من أن السطح الذي تقف عليه المركبة مستقيم وافقي.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "نقل عصا الغيارات إلى الغيار النيوترال وحل الهاندبريك.",
        "منع تحرك المركبة (بواسطة استعمال فرامل الوقوف (الهاندبريك) ومنع العجلات من التحرك)، وفك مبدئي لبراغي العجلات .",
        "رفع المركبة أولاً من زاوية أخرى لها لفحص سلامة الرافعة (الجاك).",
        "فقط للتأكد من أن السطح الذي تقف عليه المركبة مستقيم وافقي."
      ],
      id: 1198
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0089. أنت تسير في شارع باتجاهين وأمامك يوجد مبنى أو عمود أو مساحة مغلقة، كيف يجب أن تتصرف؟",
      numQues: "0089",
      correctAnswer: "مسموح عبور المكان من جهته اليمنى أو اليسرى.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "يجب الاستمرار بالسير حسب حجم المبنى أو العامود أو المساحة المغلقة.",
        "يجب عبور المكان من جهته اليمنى إلا إذا كانت هناك إشارة تدل على غير ذلك.",
        "يجب عبور المكان من جهته اليسرى فقط.",
        "مسموح عبور المكان من جهته اليمنى أو اليسرى."
      ],
      id: 1199
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1268. هل يُسمح لكل باص وزنه الإجمالي 4500كغم بالوقوف في حدود هذه الإشارة؟",
      numQues: "1268",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3627.jpg",
      choices: [
        "نعم بين الساعات 21:00 لغاية 05:30 أيام عُطَل الأعياد فقط.",
        "نعم.",
        "نعم، فقط في نهاية كل أسبوع.",
        "كلا."
      ],
      id: 1200
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1252. هل الأحكام في الأنظمة بالنسبة لركاب الباص تسري أيضاً على ركاب الصالون العمومي؟",
      numQues: "1252",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "نعم، لكن في سفرات الخدمة فقط.",
        "نعم.",
        "نعم، لكن في سفرة ليست بلدية فقط.",
        "كلا."
      ],
      id: 1201
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1368. كيف يُعرف القانون 'المركبة العمومية'؟",
      numQues: "1368",
      correctAnswer: "المركبة التي بملكية عمومية.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "مركبة ركاب خصوصية تمت ملاءمتها لنقل الأشخاص لقاء اجر.",
        "المركبة المستعملة أو المعدة للاستعمال في نقل الركاب مقابل اجر.",
        "كل مركبة تابعة لشركة عمومية.",
        "المركبة التي بملكية عمومية."
      ],
      id: 1202
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1136. ما هي قواعد التصرف المطلوبة من السائق وبائع التذاكر في الباص؟",
      numQues: "1136",
      correctAnswer: "عليهم التكلم بصوتٍ منخفض.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "عليهما التصرف بلياقة وأدب.",
        "عليهما مساعدة الأطفال والمسنين وضمان أماكن جلوس لهم.",
        "عليهما العمل بموجب قواعد اللياقة المتبعة في القرية التي يقطناها.",
        "عليهم التكلم بصوتٍ منخفض."
      ],
      id: 1203
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1165. هل يجب أن يُركب مكيف هواء في الصالون العمومي.",
      numQues: "1165",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "نعم.",
        "فقط في الصالون العمومي الذي يعمل على 'خط خدمة'.",
        "فقط في الصالون العمومي الذي لا يعمل على 'خط خدمة'.",
        "كلا."
      ],
      id: 1204
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1583. يُسمح بنقل راكب إضافي على الدراجة النارية إذا كان عمر سائقها:",
      numQues: "1583",
      correctAnswer: "يزيد عن 17.5 سنة.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "يزيد عن 18 سنة.",
        "لا توجد أهمية للعمر.",
        "يزيد عن 16 سنة.",
        "يزيد عن 17.5 سنة."
      ],
      id: 1205
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0911. في الصورة التي أمامك هناك وضع غير ممكن، ما هو هذا الوضع؟",
      numQues: "0911",
      correctAnswer: "يجب أن تُنصب إشارة 'أعطِ حق الأولوية' على الشارع من الجانب الأيمن.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3911.jpg",
      choices: [
        "الإشارة اليسرى تتعارض مع الإشارة اليمنى.",
        "الإشارة التي تدل على شارع باتجاه واحد يجب أن تكون منصوبة فوق الشارع.",
        "تُنصب الإشارة التي تدل على شارع باتجاه واحد على الجهة اليسرى من الشارع.",
        "يجب أن تُنصب إشارة 'أعطِ حق الأولوية' على الشارع من الجانب الأيمن."
      ],
      id: 1206
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»"
      ],
      title: "1380. هل يجوز لسلطة الترخيص إعطاء إذن باستعمال مركبة تزيد مقاييسها أو وزنها عن المحدد في الأنظمة؟",
      numQues: "1380",
      correctAnswer: "كلا، لا يجوز لسلطة الترخيص إعطاء أي إذن يخالف المحدد في الأنظمة.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "نعم، يجوز لسلطة الترخيص إعطاء مثل هذا الإذن بعد التشاور مع الأشغال العامة والشرطة.",
        "كلا، يجوز فقط لضابط شرطة برتبة مفتش أو أعلى إعطاء مثل هذا الإذن.",
        "نعم، يجوز لسلطة الترخيص إعطاء إذن كهذا في حالات معينة.",
        "كلا، لا يجوز لسلطة الترخيص إعطاء أي إذن يخالف المحدد في الأنظمة."
      ],
      id: 1207
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1473. ما هي السرعة القصوى المسموح بها (بالكم/ساعة) لمركبة شاحنة وزنها الإجمالي المسموح به أكثر من 12000كغم، في طريق بلدية؟",
      numQues: "1473",
      correctAnswer: "60 - وإذا نُصبت إشارة تسمح بالسير بسرعة أعلى، مسموح السير لغاية السرعة المذكورة في الإشارة.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "60 - حتى ولو نُصبت إشارة تسمح بالسير بسرعة أعلى. ",
        "50 - وإذا نُصبت إشارة تسمح بالسير بسرعة أعلى، مسموح السير لغاية السرعة المذكورة في الإشارة.",
        "50 - حتى ولو نُصبت إشارة تسمح بالسير بسرعة أعلى.",
        "60 - وإذا نُصبت إشارة تسمح بالسير بسرعة أعلى، مسموح السير لغاية السرعة المذكورة في الإشارة."
      ],
      id: 1208
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1463. ما هي وسائل التحذير المُركبة في كابينة سائق المركبة ذات جهاز فرامل هوائي؟",
      numQues: "1463",
      correctAnswer: "لمبة تحذير وعصا فرملة الطوارئ.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "لمبة تحذير وجرس ومقياس ضغط هواء.",
        "لمبة تحذير بلونٍ احمر في وسط لوحة المقاييس (التابلو).",
        "لامبة تحذير فقط.",
        "لمبة تحذير وعصا فرملة الطوارئ."
      ],
      id: 1209
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0068. هل الإشارة المؤقتة المنصوبة بأمر من ضابط شرطة، هي إشارة قانونية؟",
      numQues: "0068",
      correctAnswer: "نعم، هي إشارة قانونية.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "كلا، هي إشارة غير قانونية.",
        "نعم، ما عدا إشارة 'ممنوع الدخول' .",
        "نعم، ما عدا إشارة 'قف'.",
        "نعم، هي إشارة قانونية."
      ],
      id: 1210
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0512. بماذا تأمر الإشارة؟",
      numQues: "0512",
      correctAnswer: "سرعة خاصة: ممنوع السير بسرعة تزيد عن المسجل وقت الضباب أو عندما يكون الطقس مغبراً.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3512.jpg",
      choices: [
        "ممنوع السير بسرعة تزيد عن 60كم/ساعة في الليل لكن يُسمح بذلك في النهار.",
        "تحديد وزن – 60 طن.",
        "سرعة خاصة: ممنوع السير بسرعة تزيد عن عدد الكيلومترات في الساعة المسجل في الإشارة.",
        "سرعة خاصة: ممنوع السير بسرعة تزيد عن المسجل وقت الضباب أو عندما يكون الطقس مغبراً."
      ],
      id: 1211
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1482. بعد كم ساعة استراحة يجوز لسائق مركبة شاحنة وزنها الإجمالي المسموح به 10000كغم أو أكثر، أن يبدأ عمله؟",
      numQues: "1482",
      correctAnswer: "بعد استراحة 4 ساعات متواصلة.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "بعد فترة 7 ساعات متواصلة.",
        "بعد استراحة 6 ساعات متواصلة.",
        "بعد استراحة 5 ساعات متواصلة.",
        "بعد استراحة 4 ساعات متواصلة."
      ],
      id: 1212
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0942. كيف تتصرف حسب الوضع الذي أمامك؟",
      numQues: "0942",
      correctAnswer: "زد من السرعة واعبر بسرعة عن الخطر المباشر الكامن على اليمين.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3942.jpg",
      choices: [
        "تابع السير دون أي تغيير في التصرف مع استعمال الزامور للتنبيه.",
        "انتقل إلى المسلك الأيسر مع زيادة السرعة ومتابعة الدراجة الهوائية.",
        "انحرف إلى اليسار وتابع التغيير في تصرفات مستعملي الطريق الآخرين.",
        "زد من السرعة واعبر بسرعة عن الخطر المباشر الكامن على اليمين."
      ],
      id: 1213
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0231. كيف تنقل في المركبة ولداً لم يتم 3 سنوات من عمره؟",
      numQues: "0231",
      correctAnswer: "في مقعد أمان يناسب طوله ووزنه.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3046.jpg",
      choices: [
        "مربوط بحزام خصر.",
        "مربوط بأي حزام أمان مثبت في المركبة.",
        "مربوط بحزام أمان موحد (له ثلاث نقاط).",
        "في مقعد أمان يناسب طوله ووزنه."
      ],
      id: 1214
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0225. هل يُسمح بسياقة مركبة عندما يكون احد الأبواب مفتوحاً؟",
      numQues: "0225",
      correctAnswer: "مسموح عند نقل حمولة بارزة.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3225.jpg",
      choices: [
        "ممنوع منعاً باتاً.",
        "مسموح عندما لا يكون ركاب في المركبة.",
        "ممنوع إلا إذا تعطل مكيف الهواء.",
        "مسموح عند نقل حمولة بارزة."
      ],
      id: 1215
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1158. هل مسموح إقناع راكب للصعود في الصالون العمومي في مطار بن غوريون؟",
      numQues: "1158",
      correctAnswer: "مسموح فقط عن طريق المناداة في الليل.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "مسموح فقط في النهار.",
        "ممنوع.",
        "مسموح فقط بواسطة الإشارة باليد.",
        "مسموح فقط عن طريق المناداة في الليل."
      ],
      id: 1216
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1341. ما هي 'المركبة الصحراوية':",
      numQues: "1341",
      correctAnswer: "مركبة شاحنة ذات دفع أمامي وذُكر في رخصة السياقة بأنها مركبة صحراوية.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "كل مركبة خصوصية ذات دفع أمامي وخلفي وذُكر في الرخصة بأنها مركبة صحراوية.",
        "مركبة تجارية موحدة وذُكر في الرخصة بأنها مركبة صحراوية.",
        "مركبة عمومية ذات دفع أمامي وخلفي ومُركب عليها جسم حسب المواصفات وذُكر في رخصة المركبة بأنها مركبة صحراوية.",
        "مركبة شاحنة ذات دفع أمامي وذُكر في رخصة السياقة بأنها مركبة صحراوية."
      ],
      id: 1217
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0160. هل يُسمح بمواصلة السير عند ملتقى سكة حديد إذا كان الحاجز يتحرك، ينزل أو يرتفع؟",
      numQues: "0160",
      correctAnswer: "مسموح الاستمرار بالسير إذا بدأ الحاجز بالارتفاع.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3160.jpg",
      choices: [
        "مسموح الاستمرار بالسير بشرط أن نسوق بحذر.",
        "مسموح الاستمرار بالسير طالما لم يصل الحاجز إلى حده الأسفل وأُقفل.",
        "ممنوع الاستمرار بالسير طالما كان الحاجز يتحرك نحو أي اتجاهٍ كان أو إذا كان في وضع أفقي.",
        "مسموح الاستمرار بالسير إذا بدأ الحاجز بالارتفاع."
      ],
      id: 1218
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0811. ما هي مكونات مسافة التوقف؟",
      numQues: "0811",
      correctAnswer: "مجموع مسافة رد الفعل ومسافة الفرملة. ",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "معدل مسافة الفرملة ومسافة رد فعل السائق.",
        "مجموع مسافة الفرملة والمسافة لغاية المركبة التي في الأمام.",
        "مجموع مسافة القرار ومسافة التنفيذ لسائق معقول.",
        "مجموع مسافة رد الفعل ومسافة الفرملة. "
      ],
      id: 1219
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0438. هل هناك أية صلة بإعطاء حق الأولوية في الإشارة التي أمامك؟",
      numQues: "0438",
      correctAnswer: "كلا، الإشارة تابعة لمجموعة إشارات الإرشاد والتي لا تلزم بإعطاء حق الأولوية.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3436.jpg",
      choices: [
        "كلا، هذه إشارة تحذير ولا تحل محل إشارات إعطاء حق الأولوية.",
        "نعم، عليك إعطاء حق الأولوية للمركبات في الطريق التي أمامك.",
        "كلا، فقط إشارات الإرشاد تأمر بإعطاء حق الأولوية.",
        "كلا، الإشارة تابعة لمجموعة إشارات الإرشاد والتي لا تلزم بإعطاء حق الأولوية."
      ],
      id: 1220
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0143. في أية حالات يسري واجب التمهل؟",
      numQues: "0143",
      correctAnswer: "يجب التمهل فقط عندما تكون هناك حركة سير كثيفة في الشارع.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "عند التقائك أو مجاوزتك الحيوانات.",
        "يجب التمهل في طريق داخل المدن فقط.",
        "لا يوجد واجب بالتمهل، هناك واجب بالسياقة بحذر. ",
        "يجب التمهل فقط عندما تكون هناك حركة سير كثيفة في الشارع."
      ],
      id: 1221
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0320. في أية مركبات يجب أن توجد 'أحذية الأمان'؟",
      numQues: "0320",
      correctAnswer: "في كل مركبة وزنها الإجمالي المسموح به 3,500كغم أو اقل ما عدا الباص.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "فقط في مركبة وزنها الإجمالي المسموح به 4000كغم أو اقل بما في ذلك الباص. ",
        "في كل مركبة ميكانيكية وزنها الإجمالي المسموح به أكثر من 5,000كغم ما عدا الباص.",
        "في كل مركبة تجارية، مهما كان وزنها، ما عدا الباص. ",
        "في كل مركبة وزنها الإجمالي المسموح به 3,500كغم أو اقل ما عدا الباص."
      ],
      id: 1222
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1177. هل يجوز نقل حيوانات في الباص؟",
      numQues: "1177",
      correctAnswer: "مسموح بدون أي قيد.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "ممنوع ما عدا الكلب الذي يقود ضرير.",
        "مسموح، فقط في مكان جلوس.",
        "مسموح، إذا كان حجمها يمكن من وضعها على ركبتي الراكب أو الاحتفاظ بها في اليد. ",
        "مسموح بدون أي قيد."
      ],
      id: 1223
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1272. هل يُسمح لباص صغير خصوصي السير في المسلك الموسوم (المؤشر) كمسلك للمواصلات العمومية؟",
      numQues: "1272",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31269.jpg",
      choices: [
        "كلا.",
        "نعم، أيام السبت والأعياد فقط.",
        "نعم بين الساعات 21:00 لغاية 05:30 أيام عُطَل الأعياد فقط.",
        "نعم."
      ],
      id: 1224
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0536. إذا نُصبت الإشارة 'قف' في الجهة اليسرى من الشارع فقط، فهذا يعني:",
      numQues: "0536",
      correctAnswer: "أنها تسري فقط على من يستدير إلى اليسار أو من يستدير إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس).",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3184.jpg",
      choices: [
        "توقف وأعط حق الأولوية فقط لحركة السير القادمة من اليسار.",
        "توقف وأعط حق الأولوية فقط لحركة السير القادمة من اليمين.",
        "توقف وأعط حق الأولوية فقط لحركة السير المقتربة من الاتجاه المعاكس.",
        "أنها تسري فقط على من يستدير إلى اليسار أو من يستدير إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس)."
      ],
      id: 1225
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0788. أنت تقترب لمقطع طريق وأمامك نُصبت فيه الإشارة رقم 308، والمركبة القادمة من الجهة المقابلة قد دخلت من الجهة المعاكسة، كيف تتصرف؟",
      numQues: "0788",
      correctAnswer: "ادخل المقطع كالمعتاد وحاول عبور المركبة من اليسار.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3579.jpg",
      choices: [
        "استعمل الزامور بشكلٍ متواصل وادخل المقطع.",
        "انتظر حتى خروجها من المقطع وفقط بعدها تعبر.",
        "أضئ الأنوار وادخل المقطع، لك حق الأولوية.",
        "ادخل المقطع كالمعتاد وحاول عبور المركبة من اليسار."
      ],
      id: 1226
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1512. هل يُسمح لسائق دراجة نارية بالسير بجانب دراجة نارية أخرى؟",
      numQues: "1512",
      correctAnswer: "كلا، يُسمح له بتجاوز دراجة نارية أخرى أو العبور عنها.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "ممنوع منعاً باتاً.",
        "ممنوع، مسموح السير فقط بجانب مركبة ركاب خصوصية.",
        "ممنوع، مسموح السير فقط بجانب مركبة تجارية تنقل ركاب.",
        "كلا، يُسمح له بتجاوز دراجة نارية أخرى أو العبور عنها."
      ],
      id: 1227
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1120. سائق الباص الذي توقف قبل ملتقى سكة حديد حسب تعليمات إشارة 'قف' ، عليه أيضاً:",
      numQues: "1120",
      correctAnswer: "أن يستعمل الزامور ويطفئ الراديو.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "أن يفتح الباب الأمامي.",
        "أن يفتح الباب الخلفي للهرب.",
        "أن ينتظر إلى أن يمر قطار واحد على الأقل.",
        "أن يستعمل الزامور ويطفئ الراديو."
      ],
      id: 1228
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1451. ما هو 'التاكوغراف'؟",
      numQues: "1451",
      correctAnswer: "جهاز مُركب في المركبة يُسجل التفاصيل الفنية للمركبة أثناء السير ويُمكن من اكتشاف الخلل الميكانيكي.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "جهاز في المركبة وفيه قرص يبين زمن ومسافة وسرعة السير وساعات عمل السائق.",
        "جهاز يقوم بتركيبه صاحب المركبة حسب تعليمات المستورد، يسجل عدد دورات العجلات.",
        "جهاز مُركب في المركبة حسب تعليمات التي أصدرها المستورد، ويبين سرعة المركبة من اجل التوفير في الوقود.",
        "جهاز مُركب في المركبة يُسجل التفاصيل الفنية للمركبة أثناء السير ويُمكن من اكتشاف الخلل الميكانيكي."
      ],
      id: 1229
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1257. هل يُسمح بتوقف الصالون العمومي من اجل إصعاد وإنزال الركاب في حدود الإشارة التي أمامك؟",
      numQues: "1257",
      correctAnswer: "نعم، عندما تكون هناك إشارة تدل على محطة باص.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3015.jpg",
      choices: [
        "نعم، فقط في ساعات الليل.",
        "نعم، فقط في طريق بلدية بشرط عدم عرقلة حركة السير.",
        "كلا.",
        "نعم، عندما تكون هناك إشارة تدل على محطة باص."
      ],
      id: 1230
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1424. على أي بعد تسير المركبة المرافقة من المركبة التي تنقل حمولة بارزة؟",
      numQues: "1424",
      correctAnswer: "على مسافة يمكن منها المحافظة على اتصال بصري بين سائقي المركبتين في كل لحظة. ",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "تحافظ المركبة المرافقة على مسافة لا تقل عن 100م من المركبة التي تنقل الحمولة.",
        "لا يجب أن تكون المسافة بين المركبتين أكثر من 150م.",
        "من مسافة يستطيع فيها سائق المركبة التي تنقل الحمولة من رؤية المركبة المرافقة في المرايا في شارع باتجاهين.",
        "على مسافة يمكن منها المحافظة على اتصال بصري بين سائقي المركبتين في كل لحظة. "
      ],
      id: 1231
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0326. من هو المسؤول عن الحمولة في المركبة وعن ثباتها وعن التوزيع الصحيح لوزنها على المركبة؟",
      numQues: "0326",
      correctAnswer: "السائق وصاحب المركبة.",
      pubDate: "10-11-2011 08:23:04",
      img: "",
      choices: [
        "السائق ومُشغل الرافعة الشوكية (المزليج).",
        "صاحب المركبة فقط.",
        "مُشغل الرافعة الشوكية (المزليج) فقط.",
        "السائق وصاحب المركبة."
      ],
      id: 1232
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0678. ما معنى هذه الإشارة المنصوبة فوق مسلك سيرك؟",
      numQues: "0678",
      correctAnswer: "تستعمل هذا المسلك المواصلات العمومية فقط.",
      pubDate: "10-11-2011 08:23:04",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3677.jpg",
      choices: [
        "حركة السير ممنوعة للمركبة القادمة من الجهة المقابلة.",
        "ممنوع السير في هذا المسلك.",
        "مفترق تقاطع طرق أمامك.",
        "تستعمل هذا المسلك المواصلات العمومية فقط."
      ],
      id: 1233
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1376. اشرح المصطلح 'فرامل الخدمة':",
      numQues: "1376",
      correctAnswer: "جهاز فرامل يعمل على جميع عجلات المركبة ويُمكن من تخفيف سرعة المركبة أو توقفها في جميع أوضاع الطريق. ",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "جهاز فرامل يعمل في حالة الخطر فقط ويفرمل المركبة لغاية توقفها النهائي.",
        "جهاز فرملة مساعدة (هاندبريك) يعمل فقط على العجلات المثبتة على المحور الخلفي فقط، من اجل منع حادث.",
        "جهاز فرامل يخفف من سرعة المركبة في المنحدرات الشديدة جداً، ولكنه لا يُستعمل للتوقفً.",
        "جهاز فرامل يعمل على جميع عجلات المركبة ويُمكن من تخفيف سرعة المركبة أو توقفها في جميع أوضاع الطريق. "
      ],
      id: 1234
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0736. ماذا يترتب على السائق التأكد منه أولاً قبل سياقة مركبة غير مألوفة(غير معروفة) له؟",
      numQues: "0736",
      correctAnswer: "واجب السائق أن يفحص هوية صاحب المركبة للتأكد بأن المركبة غير مسروقة.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "أن يوجد أدوات العمل (العدة) والعجل الاحتياطي (السبير) في حالة سليمة ومثلث التحذير وضاغطة الهواء (الكومبرسور).",
        "أن يتأكد بأنه قد تم إجراء الصيانات الدورية للمركبة في موعدها. ",
        "أن يكون ملماً بتشغيل المركبة واستعمالها.",
        "واجب السائق أن يفحص هوية صاحب المركبة للتأكد بأن المركبة غير مسروقة."
      ],
      id: 1235
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0965. ما هي اتجاهات السير المسموحة حسب الإشارات التي في المفترق الذي أمامك؟",
      numQues: "0965",
      correctAnswer: "إلى الأمام فقط.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3796.jpg",
      choices: [
        "إلى الأمام والى اليسار.",
        "إلى الأمام واستدارة إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس).",
        "إلى الأمام والى اليمين.",
        "إلى الأمام فقط."
      ],
      id: 1236
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0781. ما هو المبدأ الأكثر أهمية الذي يوجهنا في الاستدارة إلى اليمين في المفترق؟",
      numQues: "0781",
      correctAnswer: "الاستدارة ابعد ما يمكن من الرصيف الذي على اليمين.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "يجب أن ينفذ الدخول إلى المفترق والخروج منه بقوس عريض إلى وسط الشارع.",
        "البدء وإكمال الاستدارة قريباً من حافة الشارع اليمنى.",
        "الابتعاد عن حافة الشارع اليمنى. ",
        "الاستدارة ابعد ما يمكن من الرصيف الذي على اليمين."
      ],
      id: 1237
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0973. المركبة البيضاء (1) في المفترق والمركبة الفضية (2) ينويان الدخول إلى نفس الطريق، من منهما ملزم بإعطاء حق الأولوية؟",
      numQues: "0973",
      correctAnswer: "على من يستدير أولاً أن يعطي حق الأولوية.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3973.jpg",
      choices: [
        "على من يدخل الطريق أولاً أن يعطي حق الأولوية.",
        "على المركبة الفضية التي في المفترق إعطاء حق الأولوية للمركبة البيضاء.",
        "على المركبة البيضاء إعطاء حق الأولوية.",
        "على من يستدير أولاً أن يعطي حق الأولوية."
      ],
      id: 1238
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1125. متى يجب تشغيل أجهزة تخفيف السرعة على أنواعها، الموجودة في المركبة؟",
      numQues: "1125",
      correctAnswer: "عند السفر في مقطع طريق نُصبت قبله إشارة تُحذر من تزحلق خطر.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "عند السفر في مقطع طريق نُصبت قبله إشارة تُحذر من منحدر شديد",
        "عند السفر في مقطع طريق نُصبت قبله إشارة تُحذر من منعطف حاد.",
        "عند السفر في مقطع طريق نُصبت قبله إشارة تُحذر من التواء حاد.",
        "عند السفر في مقطع طريق نُصبت قبله إشارة تُحذر من تزحلق خطر."
      ],
      id: 1239
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0307. هل يجوز للسائق بأن يرفض إجراء فحص الثمل (نسبة الكحول في الدم) حسب طلب الشرطي؟",
      numQues: "0307",
      correctAnswer: "يجوز له أن يرفض لأن الشرطي يمثل جهاز الصحة وليس القانون.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "لا يجوز للسائق أن يرفض طلب الشرطي بإجراء فحص الزفير (فحص بواسطة النفخ) أو أن يعطي عينة دم أو بول أو لعاب من اجل الفحص. ",
        "يجوز له أن يرفض إجراء الفحص لأن هذا الفحص يتعارض مع القانون الأساسي المتعلق بحقوق الإنسان وحريته.",
        "يجوز له أن يرفض بسبب قانون خصوصية الفرد.",
        "يجوز له أن يرفض لأن الشرطي يمثل جهاز الصحة وليس القانون."
      ],
      id: 1240
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0237. يجوز للمحكمة فرض العقوبات التالية على السائق الذي أُدين بمخالفة سير:",
      numQues: "0237",
      correctAnswer: "سحب رخصة السياقة والسجن وغرامة مالية وعقوبات أخرى حددها القانون.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "غرامة مالية فعلية أو السجن مع وقف التنفيذ فقط.",
        "سحب رخصة السياقة أو السجن الفعلي أو السجن مع وقف التنفيذ فقط.",
        "غرامة مالية أو السجن مع وقف التنفيذ فقط.",
        "سحب رخصة السياقة والسجن وغرامة مالية وعقوبات أخرى حددها القانون."
      ],
      id: 1241
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0753. في أية حالات لا نسير في الجانب الأيمن الأقصى للمسلك الأيمن؟",
      numQues: "0753",
      correctAnswer: "قبل دوار حركة سير.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "عند الاستدارة يساراً من شارع باتجاهين.",
        "عند الاستدارات يميناً إذا كان مسلك واحد فقط في اتجاه سيرنا",
        "عند الاقتراب من مفترق.",
        "قبل دوار حركة سير."
      ],
      id: 1242
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1780. أنت تسير في طريق ضيقة باتجاهين وموسومة (مؤشرة) بخط فاصل متواصل مزدوج يفصل بين المسلكين، وأمامك تسير عربة يجرها حصان، ولا توجد حركة سير من الجهة المقابلة، كيف تتصرف؟",
      numQues: "1780",
      correctAnswer: "تجاوز العربة حسب جميع قواعد التجاوز فقط إذا كانت الطريق المقابلة أمامك خالية.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "تجاوز العربة، حتى مع اختراق الخط الموسوم (المؤشر) كي لا تعرقل حركة السير.",
        "استمر بالسير ببطء خلف العربة.",
        "حاول تجاوز العربة من الجهة اليمنى على حاشية الطريق.",
        "تجاوز العربة حسب جميع قواعد التجاوز فقط إذا كانت الطريق المقابلة أمامك خالية."
      ],
      id: 1243
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1544. لا يجب أن يكون العرض الإجمالي المسموح به لمركبة تجارية من نوع 'جسم تبريد' أكثر من:",
      numQues: "1544",
      correctAnswer: "2.50م.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "2.55م.",
        "2.60م.",
        "3.40م.",
        "2.50م."
      ],
      id: 1244
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0572. ما معنى الإشارة؟",
      numQues: "0572",
      correctAnswer: "محطة للصالون العمومي (التاكسيات) في المطار.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3572.jpg",
      choices: [
        "مكان مُعد للصالون العمومي (التاكسي) على خط خدمة (سيرفيس) لانتظار قدوم الركاب.",
        "مكان للصالون العمومي (التاكسي) لاصعاد وإنزال الركاب فقط - بدون انتظار للركاب.",
        "مكان مُعد للصالون العمومي (التاكسي) لانتظار قدوم الركاب.",
        "محطة للصالون العمومي (التاكسيات) في المطار."
      ],
      id: 1245
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0704. أنت تقود المركبة رقم (3)، ما هو ترتيب دخول المركبات إلى المفترق الذي أمامك حسب قواعد إعطاء حق الأولوية؟",
      numQues: "0704",
      correctAnswer: "الذي يدخل أولاً إلى المفترق من يواصل سيره إلى الأمام.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3704.jpg",
      choices: [
        "المركبة الزرقاء (1)، راكب الدراجة النارية (2)، المركبة التي تسوقها أنت (3).",
        "المركبة التي تسوقها أنت (3)، راكب الدراجة النارية (2)، المركبة الزرقاء (1). ",
        "راكب الدراجة النارية (2)، المركبة الزرقاء (1)، المركبة التي تسوقها أنت (3).",
        "الذي يدخل أولاً إلى المفترق من يواصل سيره إلى الأمام."
      ],
      id: 1246
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0278. كيف يتصرف سائق مركبة تسبب في ضرر لمركبة أو لممتلكات أخرى عند عدم وجود صاحبها وقت الحادث؟",
      numQues: "0278",
      correctAnswer: "يقوم بتبليغ مركز الشرطة القريب عن الحادثة وينتظر قدوم شرطي لكي يحقق في الحادث.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "يترك تفاصيله الشخصية في مكان ظاهر للعيان ويقوم بتبليغ اقرب مركز للشرط خلال 24 ساعة.",
        "يترك مركبته في مكان الحادث ولا يحركها وينتظر قدوم فاحص الشرطة.",
        "يترك المكان بسرعة ويقوم بإعطاء تفاصيل الحادثة في وقتٍ لاحق.",
        "يقوم بتبليغ مركز الشرطة القريب عن الحادثة وينتظر قدوم شرطي لكي يحقق في الحادث."
      ],
      id: 1247
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1218. هل يُسمح بإنزال ركاب في طريق سريعة؟",
      numQues: "1218",
      correctAnswer: "مسموح لكن فقط على حاشية الطريق وفي ساعات النهار.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "مسموح في وقت الإنارة فقط.",
        "مسموح.",
        "ممنوع.",
        "مسموح لكن فقط على حاشية الطريق وفي ساعات النهار."
      ],
      id: 1248
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1338. يقاس'الارتفاع الإجمالي' للمركبة:",
      numQues: "1338",
      correctAnswer: "من سطح الطريق لغاية ارتفاع سطح كابينة السائق.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "من سطح الطريق لغاية أعلى نقطة في المركبة، مع جميع ملحقاتها وعندما لا تكون المركبة محملة.",
        "المسافة من ارتفاع أرضية الصندوق لغاية أعلى نقطة في الشاحنة.",
        "من سطح الطريق لغاية أعلى نقطة في المركبة، مع جميع ملحقاتها عندما تكون المركبة محملة.",
        "من سطح الطريق لغاية ارتفاع سطح كابينة السائق."
      ],
      id: 1249
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0387. أية إشارة تأمر بإعطاء حق الأولوية لحركة السير حول الدوار؟",
      numQues: "0387",
      correctAnswer: "301",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3387.jpg",
      choices: [
        "121",
        "303",
        "307",
        "301"
      ],
      id: 1250
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1146. ما هو المبلغ الأقصى الذي يجب على السائق إرجاع بقيته لراكب صعد إلى الباص في خط خدمة؟",
      numQues: "1146",
      correctAnswer: "أي مبلغ كان – في المحطة الأولى فقط.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "لغاية عشرة إضعاف سعر السفرة في نفس الخط. ",
        "فقط للأوراق النقدية الصغيرة من فئة 20 شيكل جديد.",
        "أي ورقة نقدية يعطيها الراكب من اجل السفر.",
        "أي مبلغ كان – في المحطة الأولى فقط."
      ],
      id: 1251
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0262. كيف يجب إيقاف مركبة وتركها واقفة على الطريق 'وقت الإنارة' إذا كان عرضها يزيد عن 210سم؟",
      numQues: "0262",
      correctAnswer: "تشغيل الأربعة غمازات واللواح ووضع مثلث تحذير.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "عندما تضيء مصابيح العرض (مصابيح الجناح) والمصباح الخلفي إلا إذا كانت الإنارة في الطريق تُمكن من مشاهدة المركبة.",
        "عندما تضيء مصابيح العرض واللواح يعمل.",
        "لا توجد أحكام في القانون بخصوص هذا الموضوع إلا لمركبة عرضها 280سم فأكثر.",
        "تشغيل الأربعة غمازات واللواح ووضع مثلث تحذير."
      ],
      id: 1252
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0196. هل يجوز إنزال أو إصعاد ركاب في 'طريق سريعة'؟",
      numQues: "0196",
      correctAnswer: "ممنوع منعاً باتاً.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3147.jpg",
      choices: [
        "مسموح فقط في ساعات النهار.",
        "مسموح، بشرط أن تكون حاشية الطريق عريضة.",
        "مسموح فقط للمركبات العمومية.",
        "ممنوع منعاً باتاً."
      ],
      id: 1253
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0746. ما هي حسنات السياقة على يمين الشارع؟",
      numQues: "0746",
      correctAnswer: "ذلك يساعد على الهرب القصير والفوري إلى حاشية الطريق في حالة الخطر.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3745.jpg",
      choices: [
        "ذلك يُمكن من تقليل مسافة رد الفعل عند الخطر الفوري.",
        "لا توجد أية حسنة للسياقة على يمين الشارع إلا في شارع باتجاه واحد فقط.",
        "ذلك يُمكن من البقاء في الحدود المسموحة والتي لا تزيد عن 40سم من حافة الشارع.",
        "ذلك يساعد على الهرب القصير والفوري إلى حاشية الطريق في حالة الخطر."
      ],
      id: 1254
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»",
        "«D»"
      ],
      title: "0738. ما هي العمليات التي يجب على السائق إجراءها قبل تحريك عصا الغيارات من اجل البدء بالسير؟",
      numQues: "0738",
      correctAnswer: "إنزال الهاندبريك من اجل فك إقفال عصا الغيارات.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "الضغط على دعسة الوقود لكي يؤدي ذلك إلى بدء السير على الفور.",
        "الضغط على دعسة فرامل الرجل من اجل منع تحرك المركبة.",
        "رفع الرجل عن دعسة الكلاتش لكي يتم الاتصال بين المحرك وصندوق الغيارات.",
        "إنزال الهاندبريك من اجل فك إقفال عصا الغيارات."
      ],
      id: 1255
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1631. متى تعود بالدراجة النارية إلى مسلك سيرك عند انتهاء التجاوز؟",
      numQues: "1631",
      correctAnswer: "بعد مرور فترة معقولة من الوقت من لحظة المرور عن المركبة التي تم تجاوزها.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "بعد الفحص في المرايا وتوجيه نظرة قصيرة إلى الخلف عن طريق الكتف الأيمن لمزيد من التأكد.",
        "بعد أن نرى المركبة التي تم تجاوزها في مرآتي الدراجة النارية.",
        "لا توجد ضرورة للعودة إلى المسلك السابق عند ركوب دراجة نارية. ",
        "بعد مرور فترة معقولة من الوقت من لحظة المرور عن المركبة التي تم تجاوزها."
      ],
      id: 1256
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1507. أية إشارة تسمح بدخول المشاة؟",
      numQues: "1507",
      correctAnswer: "226",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31507.jpg",
      choices: [
        "414",
        "كلها.",
        "413",
        "226"
      ],
      id: 1257
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0258. هل يُسمح للسائق أثناء التجاوز بالسير بسرعة أكثر من السرعة القصوى المسموح بها ؟",
      numQues: "0258",
      correctAnswer: "ممنوع.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "مسموح في طريق ليست بلدية فقط.",
        "مسموح في الطريق السريعة فقط.",
        "مسموح، عند تجاوز دراجة نارية فقط.",
        "ممنوع."
      ],
      id: 1258
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1543. هل يُسمح بالصعود على الرصيف والسير عليه لتجاوز عائق في الطريق؟",
      numQues: "1543",
      correctAnswer: "نعم، مسموح تجاوز العائق عن طريق الرصيف فقط، إذا كان ذلك أسهل.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "نعم، مسموح الصعود والسير على الرصيف بحذر شديد وبالغيار الأول.",
        "كلا، ممنوع السير على الرصيف من اجل تجاوز عائق.",
        "نعم، مسموح الصعود والسير على الرصيف، فقط للدراجات النارية.",
        "نعم، مسموح تجاوز العائق عن طريق الرصيف فقط، إذا كان ذلك أسهل."
      ],
      id: 1259
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1769. كيف يوسم (يؤشر) ممر المشاة؟",
      numQues: "1769",
      correctAnswer: "226 ,413",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31769.jpg",
      choices: [
        "306, 811 ",
        "135, 136",
        "707, 901",
        "226 ,413"
      ],
      id: 1260
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1012. ماذا يمكن أن يضر بنجاعة وبعمل أحزمة الأمان عند السير في المركبة؟",
      numQues: "1012",
      correctAnswer: "ميلان ظهر المقعد إلى الخلف بشكلٍ مبالغ فيه.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "التعب وميل السائق للنوم.",
        "السير في شارع مشوش.",
        "السياقة بلبس متعدد الطبقات وساخن زيادة عن اللزوم.",
        "ميلان ظهر المقعد إلى الخلف بشكلٍ مبالغ فيه."
      ],
      id: 1261
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0388. منطقة التروي (التمهل) في السير، هي منطقة:",
      numQues: "0388",
      correctAnswer: "فيها السرعة القصوى المسموح بها 25كم/ساعة ومؤشرة بإشارة سير..",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "فيها السرعة القصوى المسموح بها 40كم/ساعة ومؤشرة بإشارة سير..",
        "فيها السرعة القصوى المسموح بها 30كم/ساعة ومؤشرة بإشارة سير.",
        "معدة لحركة سير المركبات البطيئة فقط.",
        "فيها السرعة القصوى المسموح بها 25كم/ساعة ومؤشرة بإشارة سير.."
      ],
      id: 1262
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0929. في الصورة التي أمامك تظهر عدة عوامل في الطريق، كيف يجب أن يكون رد فعل السائق عند اقترابه من المكان؟",
      numQues: "0929",
      correctAnswer: "التمهل والسير على اليمين على قدر الإمكان.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3929.jpg",
      choices: [
        "يستمر السائق بالسير في مسلكه وبالسرعة العادية، يُشكِل المنعطف في الشارع والسرعة العالية أساس الخطر عندما يكون الشارع مشوشاً فقط.",
        "يستعمل السائق الزامور للتنبيه وينظر في المرايا ويزيد من السرعة لتقصير وقت بقائه في المنعطف.",
        "إذا لم تُنصب إشارة تُحذر من الاقتراب من منعطف، لا توجد ضرورة للتمهل، يجب متابعة السير بالسرعة العادية.",
        "التمهل والسير على اليمين على قدر الإمكان."
      ],
      id: 1263
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»"
      ],
      title: "0159. كيف تتصرف عندما تُنصب إشارة 'قف' قبل ملتقى سكة حديد؟",
      numQues: "0159",
      correctAnswer: "توقف كأي مكان نُصبت فيه إشارة 'قف' ثم تابع سيرك. ",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "هناك واجب بالتوقف في الليل، أما في النهار فلا.",
        "أوقف مركبتك وأطفئ جهاز الراديو والتلفزيون والمسجل وافتح النافذة القريبة منك.",
        "عليك واجب التوقف فقط إذا كان القطار يقترب يُرى أو يُسمع أو يُطلق إشارة تنبيه.",
        "توقف كأي مكان نُصبت فيه إشارة 'قف' ثم تابع سيرك. "
      ],
      id: 1264
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1327. من هو المسؤول عن ترتيب الحمولة على المركبة وعن ضمان سلامتها؟",
      numQues: "1327",
      correctAnswer: "السائق فقط.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "الشخص الذي يقوم بتحميل الحمولة.",
        "صاحب المركبة المسجل.",
        "مستخدِِم السائق.",
        "السائق فقط."
      ],
      id: 1265
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1366. أية مركبة ملزمة بواقيات الوحل ?",
      numQues: "1366",
      correctAnswer: "كل مركبة تستعمل لنقل حمولة سائبة.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "فقط مركبة تجارية وزنها أكثر من 4000كغم.",
        "فقط المركبة المستعملة في نقل الحمولة.",
        "كل مركبة ما عدا التراكتور والمركبة البطيئة، وكل مركبه عجلاتها الخلفية غير محمية بواسطة جناحين.",
        "كل مركبة تستعمل لنقل حمولة سائبة."
      ],
      id: 1266
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»"
      ],
      title: "0026. ما هو 'الوزن الذاتي' (الوزن الفارغ)؟",
      numQues: "0026",
      correctAnswer: "وزن المركبة بما في ذلك الحمولة والسائق.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "سعة المركبة دون الحمولة ولكن بدون السائق. ",
        "وزن المركبة دون الحمولة ودون السائق.",
        "وزن المركبة مع الحمولة ولكن بدون السائق . ",
        "وزن المركبة بما في ذلك الحمولة والسائق."
      ],
      id: 1267
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1097. هل يجوز سياقة تراكتور مع فرامل مفصولة بشكلٍ دائم؟",
      numQues: "1097",
      correctAnswer: "كلا، هذا من شأنه التسبب في سخونة وفقدان الفرامل.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "مسموح، لكن هذا يؤدي إلى تآكل غير موحد للفرملة اليمنى والفرملة اليسرى.",
        "مسموح بشرط أن تكون الرجل بين دعستي الفرامل بالضبط.",
        "كلا، هذا من شأنه التسبب في انقلاب التراكتور عند الفرملة.",
        "كلا، هذا من شأنه التسبب في سخونة وفقدان الفرامل."
      ],
      id: 1268
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1773. لماذا يكون 'المطر الأول' خطراً للسائقين:؟",
      numQues: "1773",
      correctAnswer: "'المطر الأول' لا يختلف عن المطر العادي، لذلك لا يوجد فرق في مدى الخطر.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "'المطر الأول' يسبب في أن يكون الشارع ملساً من جراء الغبار والأوساخ التي تراكمت عليه.",
        "'المطر الأول' يحسن من تماسك الإطارات مع الشارع ويسبب في تآكل سريع للإطارات.",
        "'المطر الأول' يشكل خطورة فقط بسبب الرياح التي تميل إلى حرف المركبة عن مسلكها.",
        "'المطر الأول' لا يختلف عن المطر العادي، لذلك لا يوجد فرق في مدى الخطر."
      ],
      id: 1269
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0758. ما هو المسلك:",
      numQues: "0758",
      correctAnswer: "شارع مُعد لسير المركبات الميكانيكية فقط.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "قسم من عرض الشارع يكفي لسير صف واحد من المركبات ما عدا المركبات التي تسير على عجلتين.",
        "كل وسم (تأشير) لخطين متوازيين على سطح الشارع.",
        "ممر في طريق خاصة يُمنع فيه سير المركبات.",
        "شارع مُعد لسير المركبات الميكانيكية فقط."
      ],
      id: 1270
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1082. الملحقات التي تخفف من خطورة إصابة الركاب عند وقوع حادث طرق هي:",
      numQues: "1082",
      correctAnswer: "أحزمة الأمان ووسائد الهواء ومساند الرأس.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "ساندات الرأس وجهاز التوجيه (G.P.S.).",
        "مصابيح الضباب والمقاعد الطبية.",
        "ماسحات الزجاج الخلفية وساندات الرأس.",
        "أحزمة الأمان ووسائد الهواء ومساند الرأس."
      ],
      id: 1271
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0497. ما معنى الإشارة؟",
      numQues: "0497",
      correctAnswer: "ممنوع تجاوز أو عبور مركبة عمومية فقط.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3497.jpg",
      choices: [
        "ممنوع تجاوز أو عبور مركبة غير ميكانيكية تسير على أكثر من 6 عجلات.",
        "ممنوع تجاوز أو عبور مركبة ميكانيكية تسير على أكثر من عجلتين.",
        "ممنوع تجاوز أو عبور مركبة بطيئة فقط.",
        "ممنوع تجاوز أو عبور مركبة عمومية فقط."
      ],
      id: 1272
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1551. في مركبة عمل:",
      numQues: "1551",
      correctAnswer: "ممنوع نقل حمولة أو نقل ركاب ما عدا في كابينة السائق.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "ممنوع نقل حمولة ، غير أنه يُسمح بنقل لغاية 6 ركاب في صندوق المركبة.",
        "ممنوع نقل ركاب غير أنه يُسمح بنقل حمولة.",
        "مسموح نقل ركاب ونقل حمولة.",
        "ممنوع نقل حمولة أو نقل ركاب ما عدا في كابينة السائق."
      ],
      id: 1273
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0356. أية إشارة من إشارات السير التالية تحذر السائق بالسياقة حسب وضع الشارع؟",
      numQues: "0356",
      correctAnswer: "147",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3356.jpg",
      choices: [
        "139",
        "114",
        "101",
        "147"
      ],
      id: 1274
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1550. على السائق الذي يشعر بالتعب في الليل:",
      numQues: "1550",
      correctAnswer: "أن يستمع إلى الراديو، ولكن ليس لموسيقى مهدئة.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "أن يبحث عن مكانٍ آمن للاستراحة وأن يغفو قليلاً بشكلٍ لا يعيق حركة السير.",
        "أن يفتح النافذة التي بجانبه، من اجل انسياب الهواء.",
        "أن يتناول وجبة دسمة ويمتنع عن الشرب.",
        "أن يستمع إلى الراديو، ولكن ليس لموسيقى مهدئة."
      ],
      id: 1275
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0642. كيف يجب عليك التصرف عندما توجد عن يسارك الإشارة على سطح الطريق؟",
      numQues: "0642",
      correctAnswer: "مسموح اختراق الخطوط عندما يكون الخط المتقطع على الجهة اليمنى للخط المتواصل.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3642.jpg",
      choices: [
        "تمهل واعبر إلى الجهة اليسرى للشارع.",
        "ممنوع اختراق الخط الفاصل المتواصل.",
        "يجب السير دائماً في الجانب الأيمن من الخطوط.",
        "مسموح اختراق الخطوط عندما يكون الخط المتقطع على الجهة اليمنى للخط المتواصل."
      ],
      id: 1276
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0597. ما معنى الإشارة؟",
      numQues: "0597",
      correctAnswer: "نهاية الشارع الذي فيه حق الأولوية.",
      pubDate: "10-11-2011 08:23:05",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3597.jpg",
      choices: [
        "تمهل واستعد للتوقف.",
        "أنت موجود في شارع فيه حق الأولوية.",
        "ممنوع وقوف المركبات.",
        "نهاية الشارع الذي فيه حق الأولوية."
      ],
      id: 1277
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0264. تم تصوير مركبة حسب القانون وهي ترتكب مخالفة، على من تقع مسؤولية المخالفة؟",
      numQues: "0264",
      correctAnswer: "لا أهمية للأمر ، المهم أن تُدفع المخالفة.",
      pubDate: "10-11-2011 08:23:05",
      img: "",
      choices: [
        "على صاحب المركبة إلا إذا اثبت بأن المركبة كان يسوقها شخص آخر ومن كان هذا الشخص.",
        "على من يستخدم السائق.",
        "على السائق وعلى الراكب بجانبه.",
        "لا أهمية للأمر ، المهم أن تُدفع المخالفة."
      ],
      id: 1278
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1235. هل يُسمح لسائق الباص أن يسوق وأحد أبوابه مفتوحاً؟",
      numQues: "1235",
      correctAnswer: "السير مسموح فقط عند اقتراب الباص لملتقى سكة حديد.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "السير مسموح فقط عندما يكون الباص خالياً من الركاب.",
        "السير مسموح فقط عندما لا يعمل جهاز تكييف الهواء.",
        "السير واحد الأبواب مفتوح ممنوع.",
        "السير مسموح فقط عند اقتراب الباص لملتقى سكة حديد."
      ],
      id: 1279
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1044. على السائق الحرص قبل تشغيل المحرك على:",
      numQues: "1044",
      correctAnswer: "أن لا يقف احد بجانب المركبة.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "أن تكون فرامل اليد (الهاندبريك) مرفوعة.",
        "أن هناك كمية سائل كافية لتنظيف الزجاج في الوعاء المناسب.",
        "أن تكون فرامل اليد (الهاندبريك) محلولة.",
        "أن لا يقف احد بجانب المركبة."
      ],
      id: 1280
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0576. ما معنى الإشارة؟",
      numQues: "0576",
      correctAnswer: "الدخول للدراجات الهوائية فقط.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3576.jpg",
      choices: [
        "ممنوع دخول المركبة الميكانيكية التي تسير على أربع عجلات.",
        "ممنوع دخول الدراجات الهوائية والدراجات النارية.",
        "ممنوع دخول الدراجات الهوائية.",
        "الدخول للدراجات الهوائية فقط."
      ],
      id: 1281
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1562. عندما تضيء لامبة الفرامل المساعدة (الهاندبريك) في لوحة الساعات أثناء السير فهذا يعني:",
      numQues: "1562",
      correctAnswer: "كل شيء على ما يرام، هذه لامبة مراقبة يجب أن تضيء طالما كانت فرامل اليد سليمة.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "أن الفرامل المساعدة (الهاندبريك) (مرفوع) ويجب تحريرها، لأنها تفرمل المركبة فعلاً.",
        "أن الفرامل المساعدة لا تعمل (الهاندبريك نازل) ويجب تفعيلها.",
        "أن الفرامل المساعدة (الهاندبريك) سليمة واللامبة فيها خلل ويجب استبدالها.",
        "كل شيء على ما يرام، هذه لامبة مراقبة يجب أن تضيء طالما كانت فرامل اليد سليمة."
      ],
      id: 1282
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0477. إشارة سير على شكل دائرة بصورة عامة هي:",
      numQues: "0477",
      correctAnswer: "إشارة منع وتحديد.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "إشارة تحذير.",
        "إشارة توجيه.",
        "إشارة استعلامات.",
        "إشارة منع وتحديد."
      ],
      id: 1283
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1305. ما هو الطول الأقصى المسموح به لشاحنة ذات ثلاث محاور؟",
      numQues: "1305",
      correctAnswer: "11.00م.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "15.30م.",
        "11.30م.",
        "12.00م.",
        "11.00م."
      ],
      id: 1284
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1418. ما هي 'الحاوية' (الكونتينر):",
      numQues: "1418",
      correctAnswer: "كل منشأة لا يزيد عرضها عن 300سم، ومنفصلة عن المركبة وتُستخدم لنقل البضائع وتمكن من تركها في أي مكان لتحميلها.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "خزان من المعدن له جدار مزدوج، يُستخدم لنقل السوائل ومجهز بجهاز أقفال دوارة لتثبيته على المركبة. ",
        "خزان أو صندوق يُستخدم في نقل البضائع والمُركب بشكلٍ يمكن من توصيله بجهاز أقفال دوارة ولا يزيد عرضه عن 250سم.",
        "صندوق من المعدن مغلق ومربع يُستخدم في نقل البضائع ومجهز بجهاز أقفال دوارة لتثبيته على المركبة. ",
        "كل منشأة لا يزيد عرضها عن 300سم، ومنفصلة عن المركبة وتُستخدم لنقل البضائع وتمكن من تركها في أي مكان لتحميلها."
      ],
      id: 1285
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1076. المرآة المحدبة (بانوراما) في المركبة:",
      numQues: "1076",
      correctAnswer: "من الصعب توجيهها.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "ضرورية بالأخص للسائقين ذوي القامة الطويلة.",
        "غالية جداً.",
        "لا تعكس بدقة بعد الأجسام المرئية فيها.",
        "من الصعب توجيهها."
      ],
      id: 1286
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1532. ماذا يؤثر على المسافة المطلوبة من اجل تنفيذ التجاوز؟",
      numQues: "1532",
      correctAnswer: "فقط سرعة المركبة المراد مجاوزتها، أما سرعة المركبة المراد مجاوزتها فيه مهمة ولك لا تؤثر. ",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "فقط سرعة المركبة المتجاوزة، أما سرعة المركبة المراد مجاوزتها فلا تؤثر على الإطلاق.",
        "سرعة سير المركبتين، المتجاوزة والمراد مجاوزتها.",
        "المسافة المطلوبة تعتمد فقط على السرعة القصوى المسموح بها في ذلك المقطع.",
        "فقط سرعة المركبة المراد مجاوزتها، أما سرعة المركبة المراد مجاوزتها فيه مهمة ولك لا تؤثر. "
      ],
      id: 1287
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0288. هل يُسمح بملء الوقود طالما كان المحرك يعمل في المركبة؟",
      numQues: "0288",
      correctAnswer: "ممنوع منعاً باتاً.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "مسموح إذا كانت في المركبة مطفأة حريق.",
        "مسموح عند الملء الذاتي للوقود.",
        "مسموح إذا كانت المركبة تقف بجانب محطة إطفاء حريق.",
        "ممنوع منعاً باتاً."
      ],
      id: 1288
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0564. ما معنى الإشارة؟",
      numQues: "0564",
      correctAnswer: "السرعة القصوى المسموح بها في الشارع هي 55كم/ساعة.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3564.jpg",
      choices: [
        "ممنوع السير بسرعة تقل عن السرعة المسجلة في الإشارة بالكم/ساعة. ",
        "ممنوع السير بسرعة تزيد عن السرعة المذكورة في الإشارة بالكم/ساعة.",
        "طريق للمركبات الميكانيكية التي تستطيع ويجوز لها السير بسرعة لا تقل عن السرعة المسجلة في الإشارة بالكم/ساعة.",
        "السرعة القصوى المسموح بها في الشارع هي 55كم/ساعة."
      ],
      id: 1289
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0420. ما معنى الإشارة؟",
      numQues: "0420",
      correctAnswer: "مفترق تقاطع طرق.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3420.jpg",
      choices: [
        "مكان التقاء طريق سريعة.",
        "مفترق له ثلاثة اذرع أمامك.",
        "ملتقى سكة حديد.",
        "مفترق تقاطع طرق."
      ],
      id: 1290
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1336. ينوي سائق الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليمين في مقطع شارع مستقيم، عليه أن يتأكد قبل ذلك (بموجب القانون):",
      numQues: "1336",
      correctAnswer: "من انه لا يوجد معه مادة خطرة في حمولة المركبة.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "من أن يبدأ الاستدارة من المسلك الأيسر الأقصى.",
        "من أن تتم الاستدارة في مكان ليس قبل قمة في الشارع.",
        "من أن يبدأ الاستدارة من المسلك الأيمن الأقصى.",
        "من انه لا يوجد معه مادة خطرة في حمولة المركبة."
      ],
      id: 1291
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1111. أية عملية يجب القيام بها بعد وصل الأداة إلى اذرع الرفع الهيدراولية؟",
      numQues: "1111",
      correctAnswer: "إلغاء حرية حركة الأذرع والأداة إلى الجوانب.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "إلغاء حرية حركة الأذرع والأداة إلى الأعلى والى الأسفل.",
        "تأمين الأداة الموصولة بمساعدة السلاسل تأميناً خاصاً.",
        "رفع الأداة عدة مرات إلى أعلى حد، من اجل التأكد من أن الأداة موصولة حسب الأصول.",
        "إلغاء حرية حركة الأذرع والأداة إلى الجوانب."
      ],
      id: 1292
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0227. هل يُسمح للركاب الدخول إلى المركبة أو الخروج منها من الجهة التي تواجه الشارع؟",
      numQues: "0227",
      correctAnswer: "مسموح إذا كان ذلك لا يزعج الركاب.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3227.jpg",
      choices: [
        "ممنوع، ما عدا سائقها أو ما عدا الراكب الذي يجلس بجانبه عندما تقف المركبة على يسار الطريق.",
        "ممنوع منعاً باتاً.",
        "مسموح إذا كان ذلك لا يشكل خطراً على الركاب وعلى السائق.",
        "مسموح إذا كان ذلك لا يزعج الركاب."
      ],
      id: 1293
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0582. ما معنى الإشارة؟",
      numQues: "0582",
      correctAnswer: "ممنوع دخول مركبة تنقل حمولة.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3582.jpg",
      choices: [
        "ممنوع دخول مركبة تنقل حاوية (كونتينر) بحرية.",
        "ممنوع دخول مركبة تنقل مادة خطرة.",
        "مسموح فقط الدخول للمركبات التي تنقل مادة خطرة.",
        "ممنوع دخول مركبة تنقل حمولة."
      ],
      id: 1294
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0768. متى يجب إعطاء الإشارة عندما ننوي الانحراف من اجل التجاوز؟",
      numQues: "0768",
      correctAnswer: "لا يوجد واجب بإعطاء الإشارة عندما ننوي الانحراف، إذا لم توجد مركبة أخرى بالجوار.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "يجب أولاً تغيير المسلك وبعدها نعطي الإشارة.",
        "يجب إعطاء الإشارة من مسافة 5 أمتار قبل الانحراف عن مسلك السير.",
        "يجب إعطاء الإشارة من مسافة معقولة قبل بدء الانحراف من اجل التجاوز.",
        "لا يوجد واجب بإعطاء الإشارة عندما ننوي الانحراف، إذا لم توجد مركبة أخرى بالجوار."
      ],
      id: 1295
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0725. كيف تتصرف (المركبة رقم 3) عندما تستدير إلى اليمين في المفترق الذي أمامك؟",
      numQues: "0725",
      correctAnswer: "ادخل (3) إلى وسط المفترق وبذلك تمنع المركبة الزرقاء (2) بأن تؤذي راكب الدراجة (1).",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3725.jpg",
      choices: [
        "دع راكب الدراجة الهوائية (1) يستمر في السير واستدر إلى اليمين بعده.",
        "تجاوز راكب الدراجة الهوائية (1) بسرعة وبحذر وعليه أن ينتظر.",
        "استعمل الزامور بشدة لراكب الدراجة الهوائية (1) من اجل أن يمكنك من إكمال الاستدارة إلى اليمين.",
        "ادخل (3) إلى وسط المفترق وبذلك تمنع المركبة الزرقاء (2) بأن تؤذي راكب الدراجة (1)."
      ],
      id: 1296
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1694. مصابيح المقدمة التي لم تتم معايرتها:",
      numQues: "1694",
      correctAnswer: "لا تؤثر على السياقة وعلى السيطرة على المركبة.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "لا تضيء الطريق حسب المطلوب.",
        "تزيد من يقظة السائق.",
        "تسبب في بهر النظر الذاتي للسائق.",
        "لا تؤثر على السياقة وعلى السيطرة على المركبة."
      ],
      id: 1297
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0561. عندما ترى هذه الإشارة أمامك:",
      numQues: "0561",
      correctAnswer: "أنت تدخل إلى شارع فيه مسلكان لكل اتجاه.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3560.jpg",
      choices: [
        "أنت تدخل إلى مقطع فيه حركة السير من الجهة المقابلة مسموحة للمواصلات العمومية أو مركبة أخرى سمح لها بواسطة إشارة. . ",
        "مسموح للشاحنات السير بالاتجاه المعاكس.",
        "أنت موجود في شارع باتجاه واحد، والشارع باتجاهين للمركبات التي لا يزيد وزنها عن 3500كغم.",
        "أنت تدخل إلى شارع فيه مسلكان لكل اتجاه."
      ],
      id: 1298
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1781. أنت تسير في شارع باتجاهين وعلى الشارع موسوم (مؤشر) جزيرة سير، عليك عبورها:",
      numQues: "1781",
      correctAnswer: "دائماً من جهتها اليسرى.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "من الجهة اليمنى إلا إذا وُجدت إشارة تدل على غير ذلك.",
        "دائماً من الجهة التي فيها حركة سير اقل.",
        "دائماً من الجهة التي فيها حركة سير أكثر.",
        "دائماً من جهتها اليسرى."
      ],
      id: 1299
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1800. ما هو الارتفاع الأقصى المسموح به لمركبة لنقل المركبات مع حمولتها ولها مسطحان؟",
      numQues: "1800",
      correctAnswer: "5.20م.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "4.40م.",
        "4.80م.",
        "4.50م.",
        "5.20م."
      ],
      id: 1300
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1573. أنت تسير خلف مركبة بطيئة في الشارع وعن يسارك رُسم خط فاصل متواصل ابيض مزدوج:",
      numQues: "1573",
      correctAnswer: "يُسمح لك بالتجاوز حتى عن يسار الخط المتواصل المزدوج، إلا إذا كانت هناك إشارة خاصة تمنع ذلك.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "يُسمح لك بالتجاوز بشرط أن لا تعبر الخط الفاصل المتواصل المزدوج.",
        "يُسمح لك بالتجاوز فقط إذا كانت المركبة البطيئة مركبة غير ميكانيكية.",
        "يُسمح لك بالتجاوز وعبور الخط المتواصل المزدوج إذا كانت المركبة تسير ببطء لمدة طويلة.",
        "يُسمح لك بالتجاوز حتى عن يسار الخط المتواصل المزدوج، إلا إذا كانت هناك إشارة خاصة تمنع ذلك."
      ],
      id: 1301
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0849. كيف يمكن التخفيف من تزحلق المركبة في الطريق؟",
      numQues: "0849",
      correctAnswer: "بواسطة مسك المقود بشدة بكلتا اليدين.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "بواسطة الضغط بشدة وبشكلٍ متواصل على الفرامل.",
        "بواسطة إدارة المقود بشدة يميناً ويساراً لتثبيت المركبة.",
        "بواسطة التوجيه الصحيح للمقود والاستعمال الصحيح والمراقب للفرامل.",
        "بواسطة مسك المقود بشدة بكلتا اليدين."
      ],
      id: 1302
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0530. ماذا تعني الإشارة:",
      numQues: "0530",
      correctAnswer: "نهاية المنطقة التي يمنع فيها دخول مركبة أثناء تعليم السياقة فيها.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3530.jpg",
      choices: [
        "نهاية حدود الطريق السريعة.",
        "نهاية منطقة الطرق البلدية.",
        "نهاية منطقة وقوف وتوقف المركبات.",
        "نهاية المنطقة التي يمنع فيها دخول مركبة أثناء تعليم السياقة فيها."
      ],
      id: 1303
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0600. إلى ماذا ترمز الإشارة؟",
      numQues: "0600",
      correctAnswer: "الدخول إلى محطة وقود والى مكان لتصليح المركبات.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3600.jpg",
      choices: [
        "الدخول إلى محطة وقود عسكرية ومكان للتنشط في السياقة.",
        "محطة وقود.",
        "محطة تزود بالوقود للشاحنات فقط.",
        "الدخول إلى محطة وقود والى مكان لتصليح المركبات."
      ],
      id: 1304
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0390. أية إشارة تُنصب من الجهة الثانية لمقطع نُصبت على مدخله الإشارة رقم: 308 ؟",
      numQues: "0390",
      correctAnswer: "145",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3390.jpg",
      choices: [
        "504",
        "307",
        "622",
        "145"
      ],
      id: 1305
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0685. ما معنى الإشارة؟",
      numQues: "0685",
      correctAnswer: "طريق بدون مخرج على اليمين.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3685.jpg",
      choices: [
        "مسموح السير فقط إلى اليسار",
        "مفترق تفرع طرق إلى اليسار.",
        "تقاطع طرق أمامك.",
        "طريق بدون مخرج على اليمين."
      ],
      id: 1306
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1515. ما هي 'المساحات الميتة'؟",
      numQues: "1515",
      correctAnswer: "المساحة التي خلف القسم الخلفي للمركبة فقط، والتي لا يستطيع سائق المركبة مشاهدة المركبات الأخرى فيها – لا بالنظر ولا بالمرايا ولا بأية وسيلة أخرى.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "جميع المساحات التي حول المركبة والتي لا يستطيع سائق المركبة مشاهدة تواجد عابري الطريق الآخرين فيها – لا بالنظر ولا بالمرايا.",
        "المساحة التي في مقدمة المركبة فقط، والتي يصعب فيها على سائق المركبة مشاهدة تواجد المشاة.",
        "إعاقة لمدى رؤية السائق إلى الخلف.",
        "المساحة التي خلف القسم الخلفي للمركبة فقط، والتي لا يستطيع سائق المركبة مشاهدة المركبات الأخرى فيها – لا بالنظر ولا بالمرايا ولا بأية وسيلة أخرى."
      ],
      id: 1307
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0562. ما معنى الإشارة؟",
      numQues: "0562",
      correctAnswer: "طريق للمركبات الميكانيكية فقط.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3562.jpg",
      choices: [
        "طريق للشاحنات فقط.",
        "طريق للمركبات غير الميكانيكية فقط.",
        "طريق للمركبات العمومية فقط.",
        "طريق للمركبات الميكانيكية فقط."
      ],
      id: 1308
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0638. ما معنى الإشارة؟",
      numQues: "0638",
      correctAnswer: "سبيل للدراجات الهوائية وللدراجات النارية.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3618.jpg",
      choices: [
        "ممنوع دخول الدراجات الهوائية.",
        "سبيل للدراجات الهوائية فقط.",
        "مسلك باتجاه واحد للدراجات الهوائية.",
        "سبيل للدراجات الهوائية وللدراجات النارية."
      ],
      id: 1309
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1369. بموجب القانون، لوحة الأرقام الثالثة يجب أن تكون في مركبة من نوع:",
      numQues: "1369",
      correctAnswer: "شاحنة قلاب.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "كل مركبة تجارية وتراكتور حمولة.",
        "كل مركبة تجارية وزنها الإجمالي المسموح به لغاية 3500كغم. ",
        "كل مركبة تجارية وزنها الإجمالي المسموح به لغاية 7500كغم. ",
        "شاحنة قلاب."
      ],
      id: 1310
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0836. ما هي المرحلة الأولى عند الصعود من الحاشية إلى الشارع؟",
      numQues: "0836",
      correctAnswer: "الإسراع بالمركبة لتصل إلى سرعة سير المركبات في الشارع.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "إعطاء الإشارة بواسطة جهاز إعطاء الإشارة.",
        "إدارة المقود (الستيرنج) للصعود إلى الشارع بزاوية 45 درجة.",
        "الاقتراب من الحاشية إلى حافة الشارع.",
        "الإسراع بالمركبة لتصل إلى سرعة سير المركبات في الشارع."
      ],
      id: 1311
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1245. ما هو حكم راكب لم يبرز تذكرة السفر حسب طلب المفتش أثناء السفرة؟",
      numQues: "1245",
      correctAnswer: "يجوز للمفتش إخراجه من الباص.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "لم يرتكب الراكب أية مخالفة، السائق الذي لم يتقاضى منه أجرة السفر هو الذي خالف القانون. ",
        "يدفع أجرة سفر مضاعفة.",
        "يدفع أجرة السفر وغرامة حسب نوع السفرة.",
        "يجوز للمفتش إخراجه من الباص."
      ],
      id: 1312
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0695. يسري مفعول الإشارة؟",
      numQues: "0695",
      correctAnswer: "لغاية الإشارة الضوئية (الرمزور) القريبة.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3694.jpg",
      choices: [
        "لغاية الإشارة التي تمنع دخول مركبة يزيد وزنها الإجمالي المسموح به عن 10000كغم.",
        "لغاية الإشارة التي تشير إلى نهايتها.",
        "لغاية المفترق القريب.",
        "لغاية الإشارة الضوئية (الرمزور) القريبة."
      ],
      id: 1313
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0552. ما معنى الإشارة؟",
      numQues: "0552",
      correctAnswer: "مسموح عبور المكان المؤشر من جهته اليمنى أو اليسرى.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3552.jpg",
      choices: [
        "اعبر المكان المؤشر بإشارة من جهته اليمنى.",
        "ممنوع السير إلى الأمام.",
        "ممنوع الاستدارة إلى اليمين أو إلى اليسار.",
        "مسموح عبور المكان المؤشر من جهته اليمنى أو اليسرى."
      ],
      id: 1314
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1275. ماذا يجب على السائق التأكد منه بعد صعود الركاب وقبل بدء السير في الباص؟",
      numQues: "1275",
      correctAnswer: "أن جميع الركاب جالسون في المقاعد.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "أن كل راكب دفع أجرة السفر بالكامل.",
        "أن أبواب الباص مغلقة.",
        "أن لباسه ومظهره لائقان.",
        "أن جميع الركاب جالسون في المقاعد."
      ],
      id: 1315
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0940. ما هو التصرف المطلوب من سائقي المركبات التي في الصورة؟",
      numQues: "0940",
      correctAnswer: "يتمهلوا عند الدخول إلى المنعطف الحاد ويحافظ كل واحد على السير في الجهة اليمنى القصوى للشارع.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3940.jpg",
      choices: [
        "واجب التمهل قبل الدخول إلى المنعطف مفروض على سائق المركبة الغامقة اللون فقط.",
        "على سائق المركبة البيضاء التوقف على يمين الطريق وإعطاء حق الأولوية للمركبة الغامقة اللون.",
        "على سائق المركبة الغامقة اللون التوقف على يمين الطريق وتمكين المركبة البيضاء من إكمال طريقها.",
        "يتمهلوا عند الدخول إلى المنعطف الحاد ويحافظ كل واحد على السير في الجهة اليمنى القصوى للشارع."
      ],
      id: 1316
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1225. ما هو عدد المسافرين الذي يستطيع نقلهم حامل رخصة سياقة درجة B في باص صغير خصوصي معد لنقل حتى 16 راكب ومسجل ذلك في رخصة الباص:",
      numQues: "1225",
      correctAnswer: "14 ركاب إضافة إلى السائق.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "8 ركاب إضافة إلى السائق",
        "12 راكب بما فيهم السائق.",
        "18 راكب إضافة إلى السائق.",
        "14 ركاب إضافة إلى السائق."
      ],
      id: 1317
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0641. كيف يجب التصرف في المركبة عندما تظهر الإشارة على سطح الطريق؟",
      numQues: "0641",
      correctAnswer: "يجب على سائق المركبة المؤشر عليها أن يسير على يمين الخطوط ويُمنع من اختراق الخط الفاصل المتواصل.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3641.jpg",
      choices: [
        "مسموح للمركبة المؤشر عليها اختراق الخط الفاصل المتواصل.",
        "يجب على المركبة المؤشر عليها السير في الجهة اليسرى للخط المتواصل.",
        "ممنوع اختراق الخط الفاصل من قِبل السائق، غير أنه يُسمح له بالاستدارة إلى اليسار للسير بالاتجاه المعاكس (حذوة فرس).",
        "يجب على سائق المركبة المؤشر عليها أن يسير على يمين الخطوط ويُمنع من اختراق الخط الفاصل المتواصل."
      ],
      id: 1318
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0450. كيف تتصرف حسب الإشارة ؟",
      numQues: "0450",
      correctAnswer: "تمهل واستعد لإمكانية وجوب التوقف قبل خط السكة.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3449.jpg",
      choices: [
        "توقف على مسافة مترين من خط السكة كي تفحص إذا كان القطار يقترب.",
        "زد من السرعة واقطع بسرعة خط سكة القطار.",
        "عند رؤية أضواء القطار، توقف قبل 30م من خط السكة.",
        "تمهل واستعد لإمكانية وجوب التوقف قبل خط السكة."
      ],
      id: 1319
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0298. ما هو فحص الزفير (فحص بواسطة النفخ)؟",
      numQues: "0298",
      correctAnswer: "الفحص الذي يقوم الشخص فيه بلفظ الزفير داخل جهاز يعطي معلومات عن سعة رئتي ذلك الشخص.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "فحص هواء الزفير( النفس) داخل جهاز يعطي معلومات عن نسبة تركيزالكحول في دم المفحوص.",
        "فحص جهد تُقاس بواسطته كمية الهواء الداخل إلى رئتي السائق أثناء السياقة.",
        "الفحص الذي يجريه طبيب العائلة لطالب رخصة سياقة جديد حسب طلب سلطة الترخيص.",
        "الفحص الذي يقوم الشخص فيه بلفظ الزفير داخل جهاز يعطي معلومات عن سعة رئتي ذلك الشخص."
      ],
      id: 1320
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0419. ما معنى الإشارة؟",
      numQues: "0419",
      correctAnswer: "نهاية مسلك الدراجات الهوائية.",
      pubDate: "10-11-2011 08:23:06",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3419.jpg",
      choices: [
        "مسلك باتجاه واحد للدراجات الهوائية.",
        "انتبه حركة سير دراجات هوائية تقطع الطريق.",
        "سبيل للدراجات الهوائية فقط.",
        "نهاية مسلك الدراجات الهوائية."
      ],
      id: 1321
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1730. هل يُسمح بسواقة دراجة نارية رُكب فيها اكزوست ضغط؟",
      numQues: "1730",
      correctAnswer: "مسموح، إذا تم تركيب الاكزوست من قِبل شخص معتمد.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "مسموح، في كل دراجة نارية.",
        "ممنوع منعاً باتاً.",
        "مسموح في دراجة نارية ثقيلة فقط.",
        "مسموح، إذا تم تركيب الاكزوست من قِبل شخص معتمد."
      ],
      id: 1322
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1498. لكي نفصل الاتصال بين المحرك وبين العجلات:",
      numQues: "1498",
      correctAnswer: "يجب الضغط على زر التشغيل (الستارتر).",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "يجب الضغط على دعسة الكلاتش.",
        "يجب الضغط على دعسة الفرامل وعلى دعسة الوقود.",
        "يجب إيقاف عمل المحرك.",
        "يجب الضغط على زر التشغيل (الستارتر)."
      ],
      id: 1323
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0004. لمن يجوز أن يكون 'مرافقاً' 'لسائق جديد' حتى ولو لم يكن معلم سياقة ؟",
      numQues: "0004",
      correctAnswer: "لكل من بحوزته رخصة سياقة سارية المفعول لنفس نوع المركبة وأتم الحادية والعشرين من عمره.",
      pubDate: "10-11-2011 08:23:06",
      img: "",
      choices: [
        "لمن بحوزته رخصة سياقة لنفس نوع المركبة لمدة 3 سنوات على الأقل وأتم الثلاثين من عمره، أو صاحب رخصة سياقة لمدة سنتين على الأقل وأتم الخامسة والثلاثين من عمره.",
        "لأي شخص لم تتم إدانته بمخالفة مرور خلال العامين المنصرمين.",
        "لمن بحوزته رخصة سياقة لنفس نوع المركبة لمدة 5 سنوات على الأقل وأتم الرابعة والعشرين من عمره، أو صاحب رخصة سياقة لمدة 3 سنوات على الأقل وأتم الثلاثين من عمره.",
        "لكل من بحوزته رخصة سياقة سارية المفعول لنفس نوع المركبة وأتم الحادية والعشرين من عمره."
      ],
      id: 1324
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1513. لغاية أي ارتفاع يُسمح بتحميل حمولة سائبة؟",
      numQues: "1513",
      correctAnswer: "لغاية ارتفاع جوانب صندوق الحمولة ما عدا سلالم المركبة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "لغاية ارتفاع النافذة الخلفية لكابينة السائق.",
        "لغاية ارتفاع جوانب صندوق الحمولة بما في ذلك سلالم المركبة.",
        "لغاية ارتفاع الباب الخلفي لصندوق الحمولة.",
        "لغاية ارتفاع جوانب صندوق الحمولة ما عدا سلالم المركبة."
      ],
      id: 1325
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1581. بأي شرط مسموح الركوب على دراجة نارية؟",
      numQues: "1581",
      correctAnswer: "على الراكب ارتداء خوذة (قبعة) حسب المواصفات تكون مربوطة برأسه بشكلٍ يمنع سقوطها أثناء السير.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "بشرط أن يكون لدى راكب الدراجة النارية جهاز إنقاذ في حالة وقوع حادث.",
        "بشرط أن يرتدي الراكب خوذة - مربوطة برأسه أو به. ",
        "بشرط أن يهتم راكب الدراجة النارية بأن يكون خزان الوقود مليئاً ومغلقاً قبل البدء بالسير.",
        "على الراكب ارتداء خوذة (قبعة) حسب المواصفات تكون مربوطة برأسه بشكلٍ يمنع سقوطها أثناء السير."
      ],
      id: 1326
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0095. ما هو الإشعار بعدم استعمال المركبة ('تنزيل عن الشارع') ؟",
      numQues: "0095",
      correctAnswer: "إشعار عدم استعمال المركبة الذي يُسلم للسائق من قِبل شرطي عندما يرتكب السائق أي مخالفة سير. ",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "إشعار عدم استعمال المركبة الذي يُسلم لصاحب المركبة من قِبل مدير كراج معتمد بعد أن تبين أن هناك خلل في المركبة.",
        "إشعار عدم استعمال المركبة الذي يُسلم لصاحب المركبة من قِبل فاحص سواقين عند ظهور خلل في المركبة.",
        "إشعار عدم استعمال المركبة الذي يُسلم للسائق من قِبل شرطي أو من مخمن أو فاحص مركبات بسبب خلل أو حادث للمركبة.",
        "إشعار عدم استعمال المركبة الذي يُسلم للسائق من قِبل شرطي عندما يرتكب السائق أي مخالفة سير. "
      ],
      id: 1327
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1176. هل مسموح لسائق باص التوقف ليس في المحطة من اجل إنزال مفتش التذاكر؟",
      numQues: "1176",
      correctAnswer: "مسموح في الأماكن المعدة لوقوف الباصات فقط.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "ممنوع، عليه التوقف فقط في المحطة.",
        "مسموح، في المكان المسموح به التوقف لجميع أنواع المركبات الأخرى.",
        "مسموح التوقف فقط في المحطة المذكورة في خط الخدمة.",
        "مسموح في الأماكن المعدة لوقوف الباصات فقط."
      ],
      id: 1328
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1662. من حصل على رخصة سياقة لأول مرة من الدرجة A1 أو A2 وأتم الثامنة عشرة من عمره، يُمنع من نقل ركاب ، إلا إذا كان:",
      numQues: "1662",
      correctAnswer: "صاحب رخصة سياقة كما ذُكر لمدة شهرين على الأقل.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "أنهى بنجاح دورة استكمالية في السياقة المانعة.",
        "صاحب رخصة سياقة كما ذُكر لمدة 6 أشهر على الأقل.",
        "صاحب رخصة سياقة كما ذُكر لمدة سنة الأقل.",
        "صاحب رخصة سياقة كما ذُكر لمدة شهرين على الأقل."
      ],
      id: 1329
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0303. لا يمنع القانون السياقة تحت تأثير المخدرات أو المسكرات الممنوعة:",
      numQues: "0303",
      correctAnswer: "صحيح، يمنع القانون السياقة تحت تأثير الكحول فقط.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "غير صحيح، ينص القانون بشكلٍ صريح حظر السياقة تحت تأثير كمية معينة من المخدرات أو المسكرات في الدم. ",
        "غير صحيح، يمنع القانون بشكلٍ صريح السياقة تحت تأُثير المخدرات أو المسكرات.",
        "صحيح ، لأن استعمال المخدرات أو المسكرات الممنوعة لا يمنعه القانون.",
        "صحيح، يمنع القانون السياقة تحت تأثير الكحول فقط."
      ],
      id: 1330
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0392. إذا نُصبت الإشارة 'قف' قبل ملتقى سكة حديد، فعلى سائق المركبة:",
      numQues: "0392",
      correctAnswer: "أن ينتقل إلى غيار النيوترال ويطفئ الراديو ويصيخ السمع وينظر على امتداد السكة. ",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "أن يوقف المركبة ويطفئ الراديو ويفتح نافذة المركبة التي بجانبه ويصيخ السمع وينظر على امتداد السكة.",
        "أن يطفئ الراديو ويضيء أضواء المقدمة ويصيخ السمع وينظر على امتداد السكة.",
        "أن يوقف المركبة ويوقف عمل المحرك ويطفئ الراديو ويضيء أضواء المقدمة.",
        "أن ينتقل إلى غيار النيوترال ويطفئ الراديو ويصيخ السمع وينظر على امتداد السكة. "
      ],
      id: 1331
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0896. في الصورة التي أمامك، رد فعل السائقين في الطريق للمركبة الخارجة من الموقف غير واضح، كيف يجب أن يكون رد فعل سائق الشاحنة في مثل هذا الوضع؟",
      numQues: "0896",
      correctAnswer: "يتمهل حتى إمكانية التوقف من اجل التأكد من التصرف الآمن لسائقي المركبات التي أمامه.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3896.jpg",
      choices: [
        "يوقف مركبته ويدع المركبة تواصل سيرها.",
        "يواصل سيره مع استعمال الزامور لمدة طويلة للتحذير من اقتراب الشاحنة.",
        "يواصل السير ويتجاهل المركبة الأخرى الخارجة لأن حق المرور للشاحنة.",
        "يتمهل حتى إمكانية التوقف من اجل التأكد من التصرف الآمن لسائقي المركبات التي أمامه."
      ],
      id: 1332
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1759. هل يجوز للباص الذي يسير في مسلك للمواصلات العمومية تجاوز مركبة متجاوزة؟",
      numQues: "1759",
      correctAnswer: "يجوز إذا لم يكن هناك ركاب في الباص.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "مسموح فقط في طريق ليست بلدية.",
        "يجوز فقط إذا كانت المركبة المتجاوزة مركبة شاحنة.",
        "يجوز.",
        "يجوز إذا لم يكن هناك ركاب في الباص."
      ],
      id: 1333
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0548. ما معنى الرمز؟",
      numQues: "0548",
      correctAnswer: "موقف بالاجرة للباصات فقط",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3548.jpg",
      choices: [
        "قف وسافر (أوقف مركبتك و سافر بالباص).",
        "موقف ليلي للباصات فقط.",
        "موقف لتصليح الباصات فقط.",
        "موقف بالاجرة للباصات فقط"
      ],
      id: 1334
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0290. ما هي مسؤولية صاحب المركبة بالنسبة لمخالفة ارتكبت بمركبته؟",
      numQues: "0290",
      correctAnswer: "حتى ولو سُرقت المركبة يبقى صاحب المركبة مسؤولاً عنها.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "تقع المسؤولية على صاحب المركبة ، فقط إذا كان بداخلها أثناء سياقتها من قِبل شخص آخر.",
        "لا توجد أية مسؤولية إذا لم يكن يسوق مركبته.",
        "مسؤولية مطلقة، إلا إذا اثبت من كان يسوق المركبة في ذلك الوقت. ",
        "حتى ولو سُرقت المركبة يبقى صاحب المركبة مسؤولاً عنها."
      ],
      id: 1335
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0028. متى يُسمح بتجاوز واحد مركبتين تسيران أمامك في مسلك سيرك؟",
      numQues: "0028",
      correctAnswer: "فقط عندما تجتاز مركبتين خصوصيتين.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "إذا لم يكن هناك منع للتجاوز أو عندما يكون بالإمكان إكمال التجاوز دون خطر.",
        "فقط في طريق ليست بلدية.",
        "يمنع القانون مثل هذا التجاوز على الإطلاق.",
        "فقط عندما تجتاز مركبتين خصوصيتين."
      ],
      id: 1336
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0338. متى يسري واجب وضع مثلث التحذير؟",
      numQues: "0338",
      correctAnswer: "فقط عند ترك مركبة مصابة بخلل بدون مراقبة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "فقط عند إيقاف مركبة مصابة بخلل في طريق داخل المدن.",
        "فقط عند إيقاف مركبة مصابة بخلل لمدة تزيد عن 24 ساعة.",
        "في كل حالة تستوجب إيقاف المركبة على الطريق من جراء إصابتها بخلل يمنع استمرار سيرها.",
        "فقط عند ترك مركبة مصابة بخلل بدون مراقبة."
      ],
      id: 1337
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1506. أين يتم تحميل حمولة ثقيلة في صندوق الحمولة للشاحنة؟",
      numQues: "1506",
      correctAnswer: "من المحور الخلفي باتجاه كابينة السائق.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "لا توجد أهمية لمكان الحمولة الثقيلة، بشرط أن لا تبرز من صندوق الحمولة.",
        "خلف المحور الخلفي.",
        "في القسم الأمامي من صندوق الحمولة.",
        "من المحور الخلفي باتجاه كابينة السائق."
      ],
      id: 1338
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0378. أية إشارة تحذير تُحذر بأن هناك طريق باتجاهين أمامك ؟",
      numQues: "0378",
      correctAnswer: "308",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3378.jpg",
      choices: [
        "620",
        "145",
        "618",
        "308"
      ],
      id: 1339
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0923. هل يُسمح بالتجاوز حسب الوضع الظاهر في الصورة؟",
      numQues: "0923",
      correctAnswer: "نعم، بشرط أن يرافق التجاوز استعمال الزامور للتنبيه قبل وأثناء التجاوز عن الباص.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3922.jpg",
      choices: [
        "نعم، بشرط أن نتخذ جميع وسائل الحذر اللازمة من اجل أن لا نصيب بأذى الأولاد الذين قد يعبروا الشارع.",
        "ممنوع التجاوز منعاً باتاً حتى وإذا لم ينزل أو يصعد أولاد.",
        "كلا، ممنوع تجاوز باص توقف لاصعاد أولاد.",
        "نعم، بشرط أن يرافق التجاوز استعمال الزامور للتنبيه قبل وأثناء التجاوز عن الباص."
      ],
      id: 1340
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0318. هل يُسبب شرب الكحول النعاس؟",
      numQues: "0318",
      correctAnswer: "شرب الكحول يُسبب النعاس عند السائقين الشبان فقط.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "كلا.",
        "فقط عند السياقة في النهار.",
        "نعم.",
        "شرب الكحول يُسبب النعاس عند السائقين الشبان فقط."
      ],
      id: 1341
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0968. كيف تتصرف عند اقترابك من المركبة الواقفة على حاشية الطريق (في شارع باتجاهين)؟",
      numQues: "0968",
      correctAnswer: "استعمل الزامور لسائق المركبة الواقفة وتابع سيرك كالمعتاد.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3968.jpg",
      choices: [
        "خفف من سرعة سيرك وكن مستعداً لاندماج خطر من قِبل سائق المركبة التي على اليمين.",
        "زد من سرعة سيرك.",
        "أعطِ إشارة وانتقل إلى المسلك الأيسر.",
        "استعمل الزامور لسائق المركبة الواقفة وتابع سيرك كالمعتاد."
      ],
      id: 1342
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»"
      ],
      title: "1331. في أي قسم من المستندة يتم تحميل حاوية طولها 6.10م ?",
      numQues: "1331",
      correctAnswer: "في قسمها الخلفي - فقط عندما تكون هناك أقفال دوارة مناسبة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "في قسمها الأمامي.",
        "في قسمها الخلفي – حتى وإن لم يكن هناك أقفال دوارة.",
        "لا يُسمح بنقل مثل هذه الحاوية في المستندة على الإطلاق.",
        "في قسمها الخلفي - فقط عندما تكون هناك أقفال دوارة مناسبة."
      ],
      id: 1343
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1367. أية أنواع مركبات ملزمة بالمصد السفلي (الطمبون السفلي) الخلفي الواقي من الصدمات ؟",
      numQues: "1367",
      correctAnswer: "مركبة موصولة ومركبة تجارية موحدة ومركبة مترابطة، وزنها الإجمالي أكثر من 15000كغم.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "شاحنة الامتداد الخلفي فيها يُشكل 60% من المسافة بين المحاور.",
        "الشاحنة والمقطورة والمستندة ومركبة عمل، وزنها الإجمالي المسموح به أكثر من 3500كغم.",
        "شاحنة ومقطورة ومستندة، وزنها الإجمالي 3500كغم أو اقل.",
        "مركبة موصولة ومركبة تجارية موحدة ومركبة مترابطة، وزنها الإجمالي أكثر من 15000كغم."
      ],
      id: 1344
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0046. ما هو 'مقعد الأمان' :",
      numQues: "0046",
      correctAnswer: "مقعد مُثبت في المركبة أثناء إنتاجها والمُعد لنقل أولاد لا يزيد عمرهم عن 14 سنة.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3046.jpg",
      choices: [
        "مقعد حسب المواصفات مُعد لنقل الأولاد في المركبة و يثبت في المركبة بواسطة حزام ألأمان.وله أحزمة أمان.",
        "مقعد حسب المواصفات خاص مثبت في المركبة التي تسير على عجلتين ومُعد حسب مبناه لنقل الأولاد.",
        "كل مقعد ملائم لنقل الأولاد والكهول وتتوفر فيه المواصفات التي حددتها وزارة جودة البيئة.",
        "مقعد مُثبت في المركبة أثناء إنتاجها والمُعد لنقل أولاد لا يزيد عمرهم عن 14 سنة."
      ],
      id: 1345
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0242. حسب طريقة النقاط ، إذا تجمع للسائق من 12 نقطة ولغاية 22 نقطة:",
      numQues: "0242",
      correctAnswer: "عليه التقدم لامتحان نظري (تئوريا) وتُسحب رخصة سياقته.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3242.jpg",
      choices: [
        "تُسحَب رخصة سياقته لمدة 30 يوماً.",
        "يُستدعى لتلقي إرشاد في السياقة الصحيحة ويُفرض عليه امتحان.",
        "يُلزم بفحص طبي وبامتحان نظري (تئوريا).",
        "عليه التقدم لامتحان نظري (تئوريا) وتُسحب رخصة سياقته."
      ],
      id: 1346
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1811. 12",
      numQues: "811 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [],
      id: 1347
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1110. ما هي وظيفة ذراع الرفع الوسطى (النقطة الثالثة)؟",
      numQues: "1110",
      correctAnswer: "لإلغاء حرية حركة الأذرع والأدوات المربوطة إلى الجوانب ولمنع تحركها.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "للإلغاء حرية حركة الأذرع والأداة إلى الأعلى والى الأسفل.",
        "لتأمين الأداة الموصولة بواسطة سلاسل أمان خاصة.",
        "لرفع الأداة عدة مرات إلى أعلى ارتفاع للتأكد من أن الأداة موصولة حسب الأصول.",
        "لإلغاء حرية حركة الأذرع والأدوات المربوطة إلى الجوانب ولمنع تحركها."
      ],
      id: 1348
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0588. ما معنى الإشارة؟",
      numQues: "0588",
      correctAnswer: "جسر ضيق، أعطِ حق الأولوية للمركبة القادمة من الجهة المقابلة.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3579.jpg",
      choices: [
        "حركة سير باتجاهين أمامك.",
        "لك حق الأولوية في مقطع الطريق الضيقة.",
        "ممنوع الرجوع إلى الخلف.",
        "جسر ضيق، أعطِ حق الأولوية للمركبة القادمة من الجهة المقابلة."
      ],
      id: 1349
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0480. عند السفر بالقرب من مجموعة أولاد، على سائق المركبة:",
      numQues: "0480",
      correctAnswer: "أن يستمر بالسير بالسرعة العادية بشرط أن يكون الرصيف عريضاً.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "أن يخفف من سرعة سيره وأن يكون مستعداً للتوقف وحتى التوقف عند الضرورة.",
        "أن يستمر بالسير بالسرعة العادية بشرط أن يستعمل الزامور من اجل التنبيه.",
        "أن يتوقف توقفاً تاماً طالما كان هناك أولاد بالقرب من المكان.",
        "أن يستمر بالسير بالسرعة العادية بشرط أن يكون الرصيف عريضاً."
      ],
      id: 1350
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0611. عند السير في شارع رطب(مبلول) ينتج وضع، فيه:",
      numQues: "0611",
      correctAnswer: "يشتد خطر التزحلق والانقلاب (التدهور) كلما زادت السرعة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "يمكن منع خطر التزحلق والانقلاب (التدهور) بواسطة زيادة السرعة.",
        "يمكن أن تنقلب المركبة بسبب السرعة البطيئة.",
        "تكون فيه مسافة رد الفعل أطول.",
        "يشتد خطر التزحلق والانقلاب (التدهور) كلما زادت السرعة."
      ],
      id: 1351
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1636. على سائق مركبة تجارية وزنها الإجمالي المسموح به أكثر من 6000كغم، أن يستريح 25 ساعة متواصلة، خارج العمل، كل فترة:",
      numQues: "1636",
      correctAnswer: "12 يوم على الأكثر.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "10 أيام على الأكثر.",
        "6 أيام على الأكثر.",
        "8 أيام على الأكثر.",
        "12 يوم على الأكثر."
      ],
      id: 1352
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1724. ما هي السرعة القصوى المسموح بها لباص، ليس بباص صغير (أوتوبوس زعير)، في طريق سريعة؟",
      numQues: "1724",
      correctAnswer: "100كم/ساعة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "80كم/ساعة.",
        "70كم/ساعة.",
        "90كم/ساعة.",
        "100كم/ساعة."
      ],
      id: 1353
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0701. أنت تقود المركبة رقم (3)، ما هو ترتيب دخول المركبات التي وصلت في آنٍ واحد إلى المفترق، الذي لا يوجد فيه إشارات، حسب قواعد إعطاء حق الأولوية؟",
      numQues: "0701",
      correctAnswer: "تدخل أنت أولاً (3) وشاحنة القمامة (الزبالة) ثانياً (1) وفي النهاية المركبة الخصوصية (2).",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3701.jpg",
      choices: [
        "شاحنة القمامة (الزبالة) تدخل أولاً (1) والمركبة الخصوصية ثانيا (2) وفي النهاية أنت (3).",
        "أنت تدخل أولاً (3) والمركبة الخصوصية (2) ثانياً وفي النهاية شاحنة القمامة (الزبالة) (1).",
        "تدخل المركبة الخصوصية أولاً (2) وأنت ثانياً (3) وفي النهاية شاحنة القمامة (الزبالة) (1). ",
        "تدخل أنت أولاً (3) وشاحنة القمامة (الزبالة) ثانياً (1) وفي النهاية المركبة الخصوصية (2)."
      ],
      id: 1354
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0686. ما معنى الإشارة؟",
      numQues: "0686",
      correctAnswer: "مشاة أمامك.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3416.jpg",
      choices: [
        "انتبه! شارع مشوش أمامك.",
        "أشغال في الطريق.",
        "انتبه! خطوط تباطؤ (مطبات) أمامك.",
        "مشاة أمامك."
      ],
      id: 1355
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0656. ما معنى الوسم (التأشير) على سطح الطريق؟",
      numQues: "0656",
      correctAnswer: "جزر سير (بأشكال مختلفة)، مرسومة على الشارع باللون الأبيض.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3656.jpg",
      choices: [
        "حركة سير باتجاهين أمامك.",
        "أسهم للسير عن طريق المفترق – مسموح عبور المفترق باتجاه السهم فقط.",
        "حركة سير باتجاه واحد أمامك.",
        "جزر سير (بأشكال مختلفة)، مرسومة على الشارع باللون الأبيض."
      ],
      id: 1356
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1393. بموجب أنظمة ساعات السياقة، هل تُعتبر معالجة الحمولة 'كسياقة'؟",
      numQues: "1393",
      correctAnswer: "نعم، معالجة الحمولة وترتيبها وتحميلها وتنزيلها تُعتبر من ساعات السياقة حسب القانون. ",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "نعم، ولكن ليس أكثر من ساعة في اليوم.",
        "كلا، السياقة هي فقط السياقة الفعلية وليس أية عملية أخرى تخص المركبة.",
        "كلا، كل العمليات المتعلقة بالمركبة ما عدا الاستراحات وأوقات الانتظار لا تُعتبر كسياقة.",
        "نعم، معالجة الحمولة وترتيبها وتحميلها وتنزيلها تُعتبر من ساعات السياقة حسب القانون. "
      ],
      id: 1357
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0903. ما هي الجملة الصحيحة؟",
      numQues: "0903",
      correctAnswer: "لا تعتمد على السائقين الآخرين بأن يعطوك دائماً حق الأولوية.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "سائقو الشاحنات هم سائقون مهنيون لذلك تكون السياقة حولهم آمنة.",
        "يجب الافتراض بأن السائقين الآخرين سوف يعطوك حق الأولوية دائماً عندما يلزمهم القانون ذلك.",
        "السائقون الذين يعطون الإشارة (الغماز) ينتظرون دائماً قبل أن يستديرون للجهة التي أعطوا الإشارة باتجاهها.",
        "لا تعتمد على السائقين الآخرين بأن يعطوك دائماً حق الأولوية."
      ],
      id: 1358
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0909. ما هو رد فعلك للمنظر الذي أمامك؟",
      numQues: "0909",
      correctAnswer: "استعمل الزامور للأولاد وحذرهم من اقترابك لئلا ينزلوا إلى الشارع ويتعرضوا لخطر الإصابة.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3909.jpg",
      choices: [
        "تمهل وتابع حركة الأولاد وانظر في المرايا واستعد للتوقف.",
        "استمر في سيرك، سوف لا يعبر الأولاد الطريق عند مشاهدتهم مركبة تقترب منهم.",
        "زد من سرعة سيرك واعبر عن الأولاد قبل أن يبدءوا بقطع الشارع.",
        "استعمل الزامور للأولاد وحذرهم من اقترابك لئلا ينزلوا إلى الشارع ويتعرضوا لخطر الإصابة."
      ],
      id: 1359
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1692. هل يجوز لسائق الباص الذي ) لس باص صغير) والذي لا يسافر في مسلك للمواصلات العامة أن يتجاوز مركبة تتجاوز مركبة أخرى؟",
      numQues: "1692",
      correctAnswer: "مسموح بشرط أن لا يكون هناك ركاب في الباص.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "ممنوع.",
        "مسموح بشرط أن لا يكون الوزن الإجمالي المسموح به للباص أكثر من 10000كغم.",
        "نعم، مسموح في كل طريق.",
        "مسموح بشرط أن لا يكون هناك ركاب في الباص."
      ],
      id: 1360
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1119. أية أنواع مركبات من المذكورة أدناه تُمنع من عبور سكة حديد؟",
      numQues: "1119",
      correctAnswer: "الصالون العمومي الذي ينقل أولاداً في رحلة سياحية خاصة، إذا كانت الطريق قبل السكة غير معبدة لمسافة 20م على الأقل بالإسفلت أو الباطون. ",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "المركبة التجارية التي تنقل أو معدة لنقل مواد خطرة والمركبة التي طولها 18م أو أكثر.",
        "المركبة البطيئة التي لا تزيد سرعتها القصوى عن 40كم/ساعة.",
        "المركبة التي تنقل (أو معدة لنقل) 11 راكباً أو أكثر بما فيهم السائق، إذا كانت الطريق قبل خط السكة والتي تؤدي إلى الملتقى غير معبدة لمسافة 20م على الأقل بالإسفلت أو الباطون.",
        "الصالون العمومي الذي ينقل أولاداً في رحلة سياحية خاصة، إذا كانت الطريق قبل السكة غير معبدة لمسافة 20م على الأقل بالإسفلت أو الباطون. "
      ],
      id: 1361
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0021. حدود مفترق الطرق هي:",
      numQues: "0021",
      correctAnswer: "خطوط التوقف في كل واحد من الشوارع التي تتلاقى في المفترق.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "خطوط حافات الشوارع التي تتلاقى في المفترق أو أحجار الحافة أو امتدادها الوهمي.",
        "مكان التقاء ممري مشاة أو أكثر في المفترق.",
        "مكان نصب الإشارات قبل المفترق.",
        "خطوط التوقف في كل واحد من الشوارع التي تتلاقى في المفترق."
      ],
      id: 1362
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0345. لمن يجوز أن يأمر باستدعاء مركبة للفحص الفني؟",
      numQues: "0345",
      correctAnswer: "مدير قسم المواصفات في مؤسسة المواصفات الإسرائيلية.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "مفتش البلدية أو موظف الأشغال العامة أو شرطي يحمل هوية شرطي.",
        "فاحص سلطة الترخيص وكذلك شرطي يحمل شهادة فاحص سير.",
        "كل مدير كراج مرخص لتصليح المركبات.",
        "مدير قسم المواصفات في مؤسسة المواصفات الإسرائيلية."
      ],
      id: 1363
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0439. ما معنى الإشارة ؟",
      numQues: "0439",
      correctAnswer: "انتبه خطر التزحلق.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3439.jpg",
      choices: [
        "ازدحام في حركة السير أمامك (شاخصة تضيء).",
        "انتبه أشغال في الطريق.",
        "انتبه ! حافظ على مسافة.",
        "انتبه خطر التزحلق."
      ],
      id: 1364
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1311. ماذا يتوجب على السائق عمله إذا جرى تغيير على حالته الصحية؟",
      numQues: "1311",
      correctAnswer: "إبلاغ سلطة الترخيص فقط إذا كان هناك حادث طرق.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "إبلاغ دائرة الصحة فوراً.",
        "إبلاغ سلطة الترخيص فوراً وبكتاب مسجل.",
        "إبلاغ سلطة الترخيص عن ذلك خلال 15 يوم.",
        "إبلاغ سلطة الترخيص فقط إذا كان هناك حادث طرق."
      ],
      id: 1365
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1191. هل يجب على سائق وركاب الباص الصغير العمومي استعمال أحزمة الأمان أثناء السير؟",
      numQues: "1191",
      correctAnswer: "نعم، فقط في الطريق السريعة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "نعم، فقط في طريق بلدية.",
        "نعم، فقط في طريق خارج المدن.",
        "نعم، في جميع الطرق.",
        "نعم، فقط في الطريق السريعة."
      ],
      id: 1366
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0515. ما معنى الإشارة؟",
      numQues: "0515",
      correctAnswer: "ممنوع السير بسرعة بالكم/ساعة تقل عن المسجل في الإشارة.",
      pubDate: "10-11-2011 08:23:07",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3385.jpg",
      choices: [
        "السرعة الموسومة (المؤشرة) هي السرعة القصوى المسموحة أمامك وتسري على جميع المركبات. ",
        "سرعة خاصة للمركبات البطيئة فقط.",
        "نهاية مقطع السرعة الخاصة.",
        "ممنوع السير بسرعة بالكم/ساعة تقل عن المسجل في الإشارة."
      ],
      id: 1367
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1281. يجري إصعاد أو التلاميذ إلى الباص الصغير المعد لنقل التلاميذ وإنزالهم منه:",
      numQues: "1281",
      correctAnswer: "من الباب الأمامي الأيمن فقط، عندما يكون هناك بابان في مقدمة المركبة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "من الباب الأمامي الأيمن أو من باب آخر في مقدمة المركبة.",
        "من الباب الخلفي فقط.",
        "من أي باب في المركبة.",
        "من الباب الأمامي الأيمن فقط، عندما يكون هناك بابان في مقدمة المركبة."
      ],
      id: 1368
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1412. هل يجوز لشركة لم تُرخص كمكتب للنقليات بأن تنقل مواد خطرة؟",
      numQues: "1412",
      correctAnswer: "نعم، إذا كان بحوزة سائق المركبة رخصة C+E.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "نعم، مسموح نقل المواد الخطرة في كل مركبة – حسب القواعد العادية.",
        "نعم، مسموح نقل المواد الخطرة في بشرط أن يكون للسائق أقدمية عشر سنوات في السياقة على الأقل.",
        "كلا.",
        "نعم، إذا كان بحوزة سائق المركبة رخصة C+E."
      ],
      id: 1369
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1558. كيف يتصرف سائق مركبة عند حدوث ثقب (بنشر) في إحدى عجلات المركبة أثناء السير؟",
      numQues: "1558",
      correctAnswer: "يقبض جيداً على عجلة المقود (الستيرينج) ويُفرمل المركبة بقوة.",
      pubDate: "10-11-2011 08:23:07",
      img: "",
      choices: [
        "يحرر قبضته عن عجلة المقود(الستيرينج) ويُفرمل المركبة باعتدال. ",
        "يحرر قبضته عن عجلة المقود(الستيرينج) ويُفرمل المركبة بشدة.",
        "يقبض جيداً على عجلة المقود (الستيرينج) ويُفرمل المركبة باعتدال.",
        "يقبض جيداً على عجلة المقود (الستيرينج) ويُفرمل المركبة بقوة."
      ],
      id: 1370
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1259. هل يُسمح بدخول باص بدون ركاب في طريق نُصبت فيها هذه الإشارة؟",
      numQues: "1259",
      correctAnswer: "كلا، لأنه لا يوجد فيه عدد الركاب الملزم بالإشارة.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3531.jpg",
      choices: [
        "نعم.",
        "كلا، لأن الباص بدون ركاب لا يُستخدم كباص.",
        "نعم، لأن السير مسموح لجميع المركبات.",
        "كلا، لأنه لا يوجد فيه عدد الركاب الملزم بالإشارة."
      ],
      id: 1371
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»",
        "«D»"
      ],
      title: "0080. هل يجوز لراكب الدراجة الهوائية استعمال المسلك المخصص للمواصلات العمومية ؟",
      numQues: "0080",
      correctAnswer: "كلا، استعمال هذا المسلك مسموح للمركبات العمومية فقط.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "كلا، يسمح فقط الدراجات النارية استعمال مسلك المواصلات العمومية.",
        "يجوز إذا كان المسلك في الجهة اليمنى من الشارع.",
        "يجوز لراكب الدراجة الهوائية استعمال المسلك المخصص للمواصلات العمومية فقط إذا كان المسلك الأيسر.",
        "كلا، استعمال هذا المسلك مسموح للمركبات العمومية فقط."
      ],
      id: 1372
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0024. ما هو 'ملتقى سكة حديد' :",
      numQues: "0024",
      correctAnswer: "كل مكان يجوز فيه عبور سكة الحديد. ",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "مكان يتقاطع فيه شارع مع سكة حديد في طريق سريعة فقط.",
        "مكان تتقاطع فيه طريق مع سكة حديد على مستوى واحد وجرى تأشيره بالشاخصة المقررة لذلك .",
        "مكان تتقاطع فيه طريق مع سكة حديد على مستويات مختلفة.",
        "كل مكان يجوز فيه عبور سكة الحديد. "
      ],
      id: 1373
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1114. تعريف 'الباص الخصوصي' هو:",
      numQues: "1114",
      correctAnswer: "مركبة الركاب الخصوصية التي تُعتبر باصاً.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "باص صغير عمومي.",
        "الباص الذي لا يُعتبر مركبة عمومية.",
        "كل مركبة معدة لنقل الركاب مقابل أجرة بشكلٍ خاص.",
        "مركبة الركاب الخصوصية التي تُعتبر باصاً."
      ],
      id: 1374
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0801. ما هي الطريقة الآمنة لتقليل الخطر عند الرجوع إلى الخلف؟",
      numQues: "0801",
      correctAnswer: "إنزال الركاب من المركبة عند الرجوع إلى الخلف.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "إضاءة مصابيح المركبة.",
        "المحافظة على سرعة سير عالية وإنهاء الرجوع إلى الخلف بأقصر وقت ممكن.",
        "بواسطة النظر الصحيح والمتواصل حولنا وسرعة سير بطيئة.",
        "إنزال الركاب من المركبة عند الرجوع إلى الخلف."
      ],
      id: 1375
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1276. أية إشارة لا تمنع وقوف مركبة تجارية يزيد وزنها الإجمالي المسموح به عن 10000كغم في الليل:",
      numQues: "1276",
      correctAnswer: "432",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31276.jpg",
      choices: [
        "436",
        "433",
        "435",
        "432"
      ],
      id: 1376
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0251. يجب أن تكون رخصة المركبة بحيازة:",
      numQues: "0251",
      correctAnswer: "الكراج الذي يقوم بصيانة المركبة بشكلٍ دائم.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "السائق عند سياقتها حتى ولم يكن صاحب المركبة.",
        "صاحب المركبة حتى ولم يكن سائقها.",
        "شركة التأمين المؤمنة لديها المركبة.",
        "الكراج الذي يقوم بصيانة المركبة بشكلٍ دائم."
      ],
      id: 1377
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0914. كيف يجب التصرف حسب الحدث الذي في الصورة؟",
      numQues: "0914",
      correctAnswer: "زد من سرعتك واعبر بسرعة عن يمين الكرة قبل أن يصل الولد إلى الشارع.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3914.jpg",
      choices: [
        "تمهل وانتبه واستعد للتوقف إذا اقتضت الحاجة، لأنه من الممكن أن يركض ولد بعد الكرة.",
        "استمر في السير مع استعمال الزامور على فترات قصيرة.",
        "استعمل الزامور بشدة من اجل التنبيه على اقترابك واستمر بالسير كالمعتاد.",
        "زد من سرعتك واعبر بسرعة عن يمين الكرة قبل أن يصل الولد إلى الشارع."
      ],
      id: 1378
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1691. استعمال حزام الأمان حسب الأصول:",
      numQues: "1691",
      correctAnswer: "يُقلل من إصابة المربوط بالحزام عند وقوع حادث.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "يقلل من تأرجح السائق في مقعده ويمنع وقوع حادث.",
        "يحافظ على يقظة السائق.",
        "يحافظ على جلوس مستقيم للسائق.",
        "يُقلل من إصابة المربوط بالحزام عند وقوع حادث."
      ],
      id: 1379
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1184. هل يجب إزالة العداد من صالون عمومي لا توجد بحوزة أصحابه رخصة تشغيل خط صالون عمومي؟",
      numQues: "1184",
      correctAnswer: "نعم، إذا لم يتم عمل 'تست' للمركبة ثلاثة أشهر من الموعد الذي كان عليه اجتياز التست.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "نعم، خلال 72 ساعة.",
        "نعم.",
        "لا يوجد واجب كهذا.",
        "نعم، إذا لم يتم عمل 'تست' للمركبة ثلاثة أشهر من الموعد الذي كان عليه اجتياز التست."
      ],
      id: 1380
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1723. حادث الطرق هو حدث:",
      numQues: "1723",
      correctAnswer: "غير مقصود ونتيجته إصابة شخص بما في ذلك السائق، أو ضرر بمال أو كلاهما.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31723.jpg",
      choices: [
        "يمكن للسائق منعه في جميع الأحوال.",
        "مخطط له سلفاً ونتيجته ضرر بمال وبالبنية التحتية للطريق فقط.",
        "من صفات السائقين الشبان فقط.",
        "غير مقصود ونتيجته إصابة شخص بما في ذلك السائق، أو ضرر بمال أو كلاهما."
      ],
      id: 1381
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0423. ما معنى الإشارة؟",
      numQues: "0423",
      correctAnswer: "مفترق تفرع طرق إلى اليمين.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3423.jpg",
      choices: [
        "سر إلى اليمين فقط في المفترق.",
        "إشارة تمنع الاستدارة إلى اليمين.",
        "إشارة استعلامات: مفترق تفرع إلى اليمين.",
        "مفترق تفرع طرق إلى اليمين."
      ],
      id: 1382
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0544. كيف تتصرف حسب الإشارة؟",
      numQues: "0544",
      correctAnswer: "استدر حذوة فرس إلى اليمين في المفترق القريب.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3544.jpg",
      choices: [
        "سر إلى اليسار ثم إلى اليمين.",
        "سر إلى اليمين واستدر قبل الإشارة.",
        "استدر إلى اليمين من خلف الإشارة.",
        "استدر حذوة فرس إلى اليمين في المفترق القريب."
      ],
      id: 1383
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0157. أين توقف مركبتك قبل ملتقى سكة حديد عندما يكون هناك واجب التوقف؟",
      numQues: "0157",
      correctAnswer: "توقف في مكان فيه أفضل مدى للرؤية دون أن تعيق حركة سير القطار.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "قبل الحاجز وإذا لم يكن هناك حاجز فعلى مسافة 6م قبل خط السكة القريب.",
        "بعد خط التوقف وعلى مسافة 8م قبل خط السكة القريب.",
        "قبل خط التوقف، وإذا لم يكن هناك خط توقف فقبل الحاجز وان لم يكن هناك حاجز فعلى مسافة 4م على الأقل قبل خط السكة القريب.",
        "توقف في مكان فيه أفضل مدى للرؤية دون أن تعيق حركة سير القطار."
      ],
      id: 1384
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0119. من أي مسلك يُسمح بتنفيذ استدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار؟",
      numQues: "0119",
      correctAnswer: "من اقرب مسلك إلى المساحة الفاصلة والمؤشر بسهم مستقيم (إلى الأمام).",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "من المسلك الأيسر فقط.",
        "فقط من مسلك مؤشر بسهم مستقيم (إلى الأمام) على سطح الشارع.",
        "من مسلك الاستدارة إلى اليسار أو من أي مسلك آخر لا توجد عليه أية علامة أو إشارة تمنع مثل هذه الاستدارة.",
        "من اقرب مسلك إلى المساحة الفاصلة والمؤشر بسهم مستقيم (إلى الأمام)."
      ],
      id: 1385
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0646. كيف تستدير إلى اليسار حسب الوسم (التأشير)؟",
      numQues: "0646",
      correctAnswer: "فقط من المسلك الأيمن.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3644.jpg",
      choices: [
        "ممنوع الاستدارة إلى اليسار على الإطلاق.",
        "من المسلك الأيسر في اتجاه سيرك.",
        "من أي مسلك من المسلكين المرسومين.",
        "فقط من المسلك الأيمن."
      ],
      id: 1386
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1652. ما هو الطول الإجمالي المسموح به في القانون للمركبة التي تظهر في الصورة؟",
      numQues: "1652",
      correctAnswer: "13.75م",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31652.jpg",
      choices: [
        "18.75م",
        "15.50م",
        "14.10م",
        "13.75م"
      ],
      id: 1387
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0519. ما معنى الإشارة؟",
      numQues: "0519",
      correctAnswer: "الدخول إلى منطقة طرق بلدية أو طرق بلدية.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3519.jpg",
      choices: [
        "نهاية منطقة طرق بلدية.",
        "انتبه ! مؤسسات عامة.",
        "طريق داخلية تمر بكيبوتس أو بقرية زراعية فقط.",
        "الدخول إلى منطقة طرق بلدية أو طرق بلدية."
      ],
      id: 1388
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1696. عند وصولك إلى جسر ضيق، عليك:",
      numQues: "1696",
      correctAnswer: "عبور الجسر بالسرعة القصوى دائماً من اجل إخلاء الطريق للمركبة القادمة من الجهة المقابلة.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "التوقف دائماً قبل الجسر لأسباب تتعلق بالسلامة وبعدها عبوره بسرعة. ",
        "زيادة سرعتك عند اقترابك من الجسر.",
        "التمهل عند الاقتراب من الجسر وأثناء عبورك إياه.",
        "عبور الجسر بالسرعة القصوى دائماً من اجل إخلاء الطريق للمركبة القادمة من الجهة المقابلة."
      ],
      id: 1389
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1725. 'الباص الخصوصي' هو:",
      numQues: "1725",
      correctAnswer: "باص لا يسير على خط ثابت.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "باص بملكية خاصة.",
        "الباص الذي لا يُعتبر مركبة عمومية.",
        "باص للسياحة والتجوال فقط.",
        "باص لا يسير على خط ثابت."
      ],
      id: 1390
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0608. ما معنى الإشارة؟",
      numQues: "0608",
      correctAnswer: "سوف يظهر فوراً الضوء الأحمر فقط في الإشارة الضوئية (الرمزور).",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3608.jpg",
      choices: [
        "استعد للسير عند ظهور الضوء الأخضر.",
        "أعطِ حق الأولوية للمشاة عند الاستدارة إلى اليمين.",
        "اعبر المفترق بسرعة.",
        "سوف يظهر فوراً الضوء الأحمر فقط في الإشارة الضوئية (الرمزور)."
      ],
      id: 1391
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0567. هل يُسمح بدخول الدراجات الهوائية والمشاة حسب الإشارتين؟",
      numQues: "0567",
      correctAnswer: "مسموح بشرط الحرص على الحذر الشديد.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3567.jpg",
      choices: [
        "مسموح.",
        "ممنوع.",
        "مسموح على حواشي الطريق فقط.",
        "مسموح بشرط الحرص على الحذر الشديد."
      ],
      id: 1392
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1109. هل يجب أن تكون في التراكتور غمازات من الأمام ومن الخلف؟",
      numQues: "1109",
      correctAnswer: "كلا،ليس في كل تراكتور، التراكتور الذي معظم عمله في الحقل، معفى.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "كلا،ليس في كل تراكتور، التراكتور الموصولة فيه أدوات عمل هيدراولية مُعفى. ",
        "نعم، في كل تراكتور فيه كابينة سائق.",
        "فقط في التراكتور الذي يزيد عرضه عن مترين.",
        "كلا،ليس في كل تراكتور، التراكتور الذي معظم عمله في الحقل، معفى."
      ],
      id: 1393
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1284. على سائق المركبة الذي يسير بالقرب من مجموعة أولاد:",
      numQues: "1284",
      correctAnswer: "الاستمرار بالسرعة العادية إذا كانت مجموعة الأولاد برفقة معلم أو دليل.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "يتوقف وقوفاً تاماً طالما هناك أولاد بالقرب من الشارع.",
        "الاستمرار بالسرعة العادية بشرط استعمال الزامور من مرة لأخرى من اجل التنبيه.",
        "أن يتمهل وإذا لزم الأمر أن يوقف المركبة. ",
        "الاستمرار بالسرعة العادية إذا كانت مجموعة الأولاد برفقة معلم أو دليل."
      ],
      id: 1394
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0456. ما معنى الإشارة؟",
      numQues: "0456",
      correctAnswer: "مكان ملتقى سكة حديد، خط واحد.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3456.jpg",
      choices: [
        "موقع أشغال في الشارع.",
        "مكان ملتقى سكة حديد، خطان.",
        "ملتقى تقاطع طرق أمامك.",
        "مكان ملتقى سكة حديد، خط واحد."
      ],
      id: 1395
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0927. متى يسمح باستعمال الزامور:",
      numQues: "0927",
      correctAnswer: "مسموح فقط في طريق ليست بلدية من اجل تجنب خطر. ",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "مسموح فقط في شارع داخل المدن من اجل تجنب خطر.",
        "مسموح في كل طريق للمركبات العمومية فقط من اجل تجنب خطر.",
        "مسموح من اجل تجنب خطر لا يمكن تجنبه بطريقةٍ أخرى.",
        "مسموح فقط في طريق ليست بلدية من اجل تجنب خطر. "
      ],
      id: 1396
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1437. أي نوع مركبات يُمنع وقوفها أو تركها واقفة على الطريق؟",
      numQues: "1437",
      correctAnswer: "مركبة تخليص وجر.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "مركبة غير مجهزة بجهاز إنارة.",
        "مركبة عمل.",
        "مستندة بعد فصلها عن الساندة أو مقطورة بعد فصلها عن القاطرة.",
        "مركبة تخليص وجر."
      ],
      id: 1397
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0414. ما معنى الإشارة؟",
      numQues: "0414",
      correctAnswer: "ازدحام في حركة سير أمامك.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3414.jpg",
      choices: [
        "عدد المسالك آخذ في التناقص.",
        "الشارع آخذ في الضيق من جهة اليمين.",
        "أمامك جسر ضيق.",
        "ازدحام في حركة سير أمامك."
      ],
      id: 1398
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0375. أية إشارة تُنصب في الطريق بعد الإشارة رقم: 135 ؟",
      numQues: "0375",
      correctAnswer: "226",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3375.jpg",
      choices: [
        "306",
        "136",
        "220",
        "226"
      ],
      id: 1399
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1722. السير في منحدر بالغيار النيوترال:",
      numQues: "1722",
      correctAnswer: "ممنوع وخطِر جداً.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "ليس له أي ذكر في القانون، وهو يوفر في الوقود كثيراً.",
        "مسموح لكنه خطِر.",
        "مسموح وغير خطِر.",
        "ممنوع وخطِر جداً."
      ],
      id: 1400
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1599. لماذا توجد أهمية لمدى رؤية واسع من خلال الخوذة (القبعة) ؟",
      numQues: "1599",
      correctAnswer: "لمنع التعب عند الركوب المتواصل في النهار وبالأخص في الليل.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "لتمكين الركوب على الدراجة النارية لضعيفي البصر أيضاً.",
        "يساعد مدى رؤية واسع على تحديد مسافات الأمان وسرعة السير وعلى تقصير زمن رد الفعل.",
        "من اجل زيادة السيطرة على الدراجة النارية في الطرق البلدية.",
        "لمنع التعب عند الركوب المتواصل في النهار وبالأخص في الليل."
      ],
      id: 1401
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "0894. هل يجوز لدراجة نارية أو دراجة نارية تسير على ثلاث عجلات السير بجانب دراجة نارية أخرى في نفس المسلك؟",
      numQues: "0894",
      correctAnswer: "ممنوع في جميع الأحوال وحتى أثناء التجاوز.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "مسموح فقط في طريق سريعة وفي نفس المسلك.",
        "مسموح في طريق بلدية فقط.",
        "مسموح فقط من اجل التجاوز أو العبور عن مركبة أخرى حسب القانون.",
        "ممنوع في جميع الأحوال وحتى أثناء التجاوز."
      ],
      id: 1402
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0984. كيف يجب عليك التصرف عند وصولك إلى مقطع الطريق الظاهر في الصورة؟",
      numQues: "0984",
      correctAnswer: "سر بغيار عالي، لأنك لم تصل بعد إلى الإشارة الضوئية (الرمزور).",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3984.jpg",
      choices: [
        "حافظ على يمين الشارع وادخل المنعطف بحذر، استعد للانتقال إلى غيار واطئ.",
        "تمهل إلى حد كبير وحافظ على السير في يسار الشارع.",
        "سر على يمين الشارع بدون أن تغير سرعة سيرك.",
        "سر بغيار عالي، لأنك لم تصل بعد إلى الإشارة الضوئية (الرمزور)."
      ],
      id: 1403
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1293. كيف يتصرف سائق المركبة عند وجود حفر وشقوق في الشارع؟",
      numQues: "1293",
      correctAnswer: "يستمر بالسواقة العادية.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "يزيد من سرعة السير ويسير على حاشية الطريق.",
        "يتمهل ويلائم سرعة السير لوضع الطريق.",
        "يحرص على قدر الإمكان على السير في وسط الشارع.",
        "يستمر بالسواقة العادية."
      ],
      id: 1404
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1787. أنت تقترب من مفترق والإشارة الضوئية تضيء بضوء اخضر متقطع:",
      numQues: "1787",
      correctAnswer: "إنتبه حالاً سيظهر ضوء أصفر مع ضوء أحمر.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "إنتبه حالاً سيظهر ضوء أصفر متقطع( غير ثابت).",
        " إنتبه حالاً سيظهر ضوء أصفر ثابت ( غير متقطع).",
        "إنتبه حالاً سيظهر ضوء أصفر مع ضوء أخضر ثابت.",
        "إنتبه حالاً سيظهر ضوء أصفر مع ضوء أحمر."
      ],
      id: 1405
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0380. أية إشارة من الإشارات التالية لا تسمح باستدارة إلى اليسار للسير بالاتجاه المعاكس (حذوة فرس إلى اليسار) ؟",
      numQues: "0380",
      correctAnswer: "جميع الإشارات تمنع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس). ",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3380.jpg",
      choices: [
        "205",
        "203",
        "202",
        "جميع الإشارات تمنع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس). "
      ],
      id: 1406
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1051. ضغط الهواء المطلوب في إطارات المركبة :",
      numQues: "1051",
      correctAnswer: "مسجل في شهادة التأمين.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "مسجل في بوليصة التأمين.",
        "مسجل في رخصة المركبة.",
        "مسجل على اللاصقة الملصقة في المركبة.",
        "مسجل في شهادة التأمين."
      ],
      id: 1407
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1222. متى يجب على السائق إضاءة 'العلبة' (الطربوش) في حالة 'خالي' (غير مشغول) في الصالون العمومي؟",
      numQues: "1222",
      correctAnswer: "في كل حالة لا يوجد فيها ركاب في الصالون العمومي.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "فقط في النهار وعند وجود ركاب في الصالون العمومي.",
        "فقط في الأعياد.",
        "فقط في الشتاء وعند وجود ركاب في الصالون العمومي.",
        "في كل حالة لا يوجد فيها ركاب في الصالون العمومي."
      ],
      id: 1408
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1006. كيف يجب التصرف في شارع مغمور بالمياه؟",
      numQues: "1006",
      correctAnswer: "تعشيق غيار واطئ والسير ببطء.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "تعشيق غيار عالي والسير ببطء.",
        "تعشيق غيار واطئ والسير بسرعة.",
        "تعشيق غيار عالي والسير بسرعة.",
        "تعشيق غيار واطئ والسير ببطء."
      ],
      id: 1409
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0017. ما هو 'الليل'؟",
      numQues: "0017",
      correctAnswer: "فترة الوقت التي يكون فيها ضباب كثيف.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "فترة الوقت بين غروب الشمس وبين شروقها.",
        "فترة الوقت التي تبدأ بعد ربع ساعة من غروب الشمس إلى ما قبل ربع ساعة من شروقها.",
        "فترة الوقت التي يجب فيها إضاءة مصابيح الوقوف.",
        "فترة الوقت التي يكون فيها ضباب كثيف."
      ],
      id: 1410
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0682. ما هو الوسم (التأشير) باللون الأسود والأبيض بجانب الشارع؟",
      numQues: "0682",
      correctAnswer: "مكان التوقف والوقوف قبل ملتقى سكة حديد.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3682.jpg",
      choices: [
        "مكان وقوف منظم من قِبل السلطة المحلية.",
        "الوسم (التأشير) مُعد لإظهار وجود أرصفة وجزر سير مبنية بجوار الشارع.",
        "ممنوع التوقف والوقوف.",
        "مكان التوقف والوقوف قبل ملتقى سكة حديد."
      ],
      id: 1411
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0032. عرِّف 'مفترق' :",
      numQues: "0032",
      correctAnswer: "التقاء شارعين في طريق داخل المدن بشرط أن الشارعين معبدين بالإسفلت.",
      pubDate: "10-11-2011 08:23:08",
      img: "",
      choices: [
        "المساحة المتكونة من التقاء شارعين أو أكثر.",
        "المساحة المتكونة من التقاء سكة حديد مع الشارع.",
        "المساحة المتكونة من التقاء طريقين أو أكثر على مستويات مختلفة.",
        "التقاء شارعين في طريق داخل المدن بشرط أن الشارعين معبدين بالإسفلت."
      ],
      id: 1412
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0679. كيف تتصرف عندما تشاهد الإشارة (في الصورة) والمنصوبة فوق مسلك سيرك؟",
      numQues: "0679",
      correctAnswer: "لا تدخل هذا المسلك ولا تواصل السير فيه.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3679.jpg",
      choices: [
        "تمهل قبل ملتقى سكة الحديد، واعبر سكة الحديد دون تأخير أو إعاقة.",
        "تمهل قبل ملتقى سكة الحديد، وإذا اقترب قطار- توقف.",
        "توقف قبل السكة إلى ما بعد مرور القطار.",
        "لا تدخل هذا المسلك ولا تواصل السير فيه."
      ],
      id: 1413
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0406. أية إشارة تظهر بعد الإشارة رقم: 701 ؟",
      numQues: "0406",
      correctAnswer: "122",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3405.jpg",
      choices: [
        "705",
        "703",
        "702",
        "122"
      ],
      id: 1414
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0924. كيف تتصرف حسب الظاهر في الصورة؟",
      numQues: "0924",
      correctAnswer: "الماشي لا يشاهدك، أشِر له بواسطة زامور خفيف بأنك سوف تستمر في سيرك.",
      pubDate: "10-11-2011 08:23:08",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3924.jpg",
      choices: [
        "تجاوز الماشي بحذر قبل أن يكمل عبوره.",
        "تمهل واستعد للتوقف، دع الماشي بأن يكمل عبوره الشارع بأمان.",
        "استمر بالسير كالمعتاد، شاهدك الماشي لذلك سوف يتوقف ويدعك تعبر المفترق بأمان.",
        "الماشي لا يشاهدك، أشِر له بواسطة زامور خفيف بأنك سوف تستمر في سيرك."
      ],
      id: 1415
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0826. أنت تجتاز مركبة أخرى في شارع باتجاهين وفيه مسلكين؟",
      numQues: "0826",
      correctAnswer: "أنت تخاطر بإمكانية ظهور مركبة في المسلك المعاكس.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3826.jpg",
      choices: [
        "لا تهتم: على المركبة المنوي تجاوزها تمكينك من التجاوز السهل.",
        "مثل هذا التجاوز يستغرق في اغلب الأحيان 30 ثانية.",
        "قمت بارتكاب مخالفة! يمنع القانون مثل هذا التجاوز.",
        "أنت تخاطر بإمكانية ظهور مركبة في المسلك المعاكس."
      ],
      id: 1416
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1010. في المركبة المثبت فيها وسائد هواء:",
      numQues: "1010",
      correctAnswer: "لا يجب ربط أحزمة الأمان إذا كان هناك خلل في جهاز الوسائد.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "يجب ربط أحزمة الأمان فقط إذا كان هناك خلل في جهاز الوسائد.",
        "من المهم جداً استعمال أحزمة الأمان في كل لحظة تكون في المركبة في حالة سير.",
        "لا توجد ضرورة بتثبيت أحزمة أمان.",
        "لا يجب ربط أحزمة الأمان إذا كان هناك خلل في جهاز الوسائد."
      ],
      id: 1417
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0020. 'الحمولة المسموح بها' في مركبة شاحنة هي:",
      numQues: "0020",
      correctAnswer: "وزن الحمولة والوزن الفارغ للمركبة (مع بعض).",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "وزن الحمولة الأقصى (بالكغم) التي يُسمح بتحميلها على المركبة. ",
        "الوزن الإجمالي المسموح به لمركبة شاحنة.",
        "الوزن الفارغ للمركبة بما في ذلك الماء والزيت والوقود ووزن السائق.",
        "وزن الحمولة والوزن الفارغ للمركبة (مع بعض)."
      ],
      id: 1418
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0481. يسري واجب اتخاذ وسائل الحذر:",
      numQues: "0481",
      correctAnswer: "على سائقي المركبات فقط.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "على الشخص الذي يتعلم السياقة فقط.",
        "على المشاة فقط.",
        "على كل عابر طريق.",
        "على سائقي المركبات فقط."
      ],
      id: 1419
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1519. ما معنى الإشارة؟",
      numQues: "1519",
      correctAnswer: "نهاية المكان أو المقطع المسموح فيه الوقوف.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31519.jpg",
      choices: [
        "نهاية المكان أو المقطع الذي يمنع الوقوف.",
        "نهاية المكان أو المقطع المسموح فيه الوقوف فقط للدراجات النارية.",
        "بداية مقطع للوقوف مقابل أجرة.",
        "نهاية المكان أو المقطع المسموح فيه الوقوف."
      ],
      id: 1420
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1644. هل يجب تركيب مرآة على الدراجة النارية؟",
      numQues: "1644",
      correctAnswer: "نعم، يُلزم القانون تركيب مرآة واحدة على الأقل في كل أنواع الدراجات النارية.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "نعم، فقط في دراجة نارية مع عربة جانبية.",
        "كلا، لا يوجد إلزام بأن تكون هناك مرآة فذلك يتعلق برأي السائق.",
        "فقط في دراجة نارية تسير على ثلاث عجلات.",
        "نعم، يُلزم القانون تركيب مرآة واحدة على الأقل في كل أنواع الدراجات النارية."
      ],
      id: 1421
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0494. ما معنى الإشارة؟",
      numQues: "0494",
      correctAnswer: "ممنوع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار في ساعات الظلام فقط.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3494.jpg",
      choices: [
        "الاستدارة القريبة إلى اليسار للسير في الاتجاه المعاكس حذوة فرس ممنوعة.",
        "ممنوع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار وأيضاً الاستدارة إلى اليسار.",
        "ممنوع الاستدارة إلى اليسار.",
        "ممنوع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار في ساعات الظلام فقط."
      ],
      id: 1422
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0649. ما معنى الإشارة على سطح الطريق؟",
      numQues: "0649",
      correctAnswer: "ساحة وقوف وترتيبات وقوف للدراجات الهوائية.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3649.jpg",
      choices: [
        "موقف مرخص للمركبات العمومية أمامك.",
        "مكان عبور راكبي الدراجات الهوائية.",
        "ممر للمشاة",
        "ساحة وقوف وترتيبات وقوف للدراجات الهوائية."
      ],
      id: 1423
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0250. من يتحمل مسؤولية انبعاث ضوضاء غير اعتيادية من المركبة؟",
      numQues: "0250",
      correctAnswer: "الكراج الذي يقوم بتصليح المركبة.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "سائق المركبة.",
        "صاحب المركبة.",
        "منتج المركبة.",
        "الكراج الذي يقوم بتصليح المركبة."
      ],
      id: 1424
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1638. أية إشارة تسمح لسائق المركبة أو القطار المحلي التقدم فقط إلى اليمين؟",
      numQues: "1638",
      correctAnswer: "711",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31638.jpg",
      choices: [
        "713",
        "715",
        "714",
        "711"
      ],
      id: 1425
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0797. ماذا يجب على السائق عمله قبل تنفيذ استدارة للسير في الاتجاه المعاكس (حذوة فرس) ) إلى اليسار؟",
      numQues: "0797",
      correctAnswer: "التأكد من أن الاستدارة مسموحة ولا تعرقل حركة السير.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "إعطاء الإشارة بالأربعة غمازات للتنبيه عن نيته.",
        "الالتزام بيمين الشارع الذي يستدير منه.",
        "التأكد بأنه يسير بالغيار الصحيح وبأن مصابيح المقدمة مضاءة.",
        "التأكد من أن الاستدارة مسموحة ولا تعرقل حركة السير."
      ],
      id: 1426
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1374. هناك واجب بتركيب جهاز لمنع إقفال العجلات 'أي.بي.أس.' (A.B.S) في المركبة التجارية التي يبلغ وزنها الإجمالي:",
      numQues: "1374",
      correctAnswer: "8000كغم أو اقل.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "4000كغم او اكثر.",
        "12000كغم أو أكثر.",
        "10000كغم أو اقل.",
        "8000كغم أو اقل."
      ],
      id: 1427
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0735. ما هي العناصر التي لها تأثير على سائق المركبة بالانتقال إلى غيار عالي أو واطئ؟",
      numQues: "0735",
      correctAnswer: "السرعة القصوى المسموح بها في هذا المقطع من الطريق.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "سرعة المركبة بمراعاة حركة السير ووضع الطريق ومدى الرؤية.",
        "الاعتبارات للانتقال إلى غيار عالي أو واطئ تتأثر فقط من مسافة السفر المتراكمة.",
        "عندما تسير المركبة في طريق صاعدة الاعتبارات للانتقال إلى غيار عالي أو واطئ غير موجودة.",
        "السرعة القصوى المسموح بها في هذا المقطع من الطريق."
      ],
      id: 1428
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1215. هل يُسمح بنقل مواد متفجرة أو مواد مشتعلة أخرى في الباص؟",
      numQues: "1215",
      correctAnswer: "ممنوع.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "مسموح - بدل نقل ركاب في المقعد الخلفي للباص.",
        "مسموح فقط إدخال خزانات وقود في الباص والتي عليها وقاية حسب المواصفات.",
        "مسموح إدخال مواد متفجرة أو مواد مشتعلة في الباص بشرط أن تكون عليها وقاية حسب المواصفات.",
        "ممنوع."
      ],
      id: 1429
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0148. ما هي السرعة القصوى المسموح بها عند سياقة تراكتورون؟",
      numQues: "0148",
      correctAnswer: "30كم/ساعة.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3139.jpg",
      choices: [
        "50كم/ساعة في جميع الطرق.",
        "40كم/ساعة.",
        "60كم/ساعة في طريق سريعة، و 40كم/ساعة في الطرق الأخرى.",
        "30كم/ساعة."
      ],
      id: 1430
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1093. لماذا تُثبت أثقال في مقدمة التراكتور؟",
      numQues: "1093",
      correctAnswer: "من اجل منع قفز القسم الأمامي للتراكتور أثناء السير السريع في الميدان.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "لمنع ارتفاع القسم الأمامي للتراكتور عند رفع الحمولات من الخلف.",
        "من اجل التخفيف قليلاً من الثقل على المحور الخلفي عند رفع الحمولات.",
        "من اجل تحسين جودة وسهولة السير بالتراكتور في الطرق الترابية.",
        "من اجل منع قفز القسم الأمامي للتراكتور أثناء السير السريع في الميدان."
      ],
      id: 1431
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1557. هل يجوز لشرطي وقف سير مركبة شاحنة لم يتم وسمها (تأشيرها) حسب القانون أو أن الحمولة عليها لم يتم تحميلها حسب القانون؟",
      numQues: "1557",
      correctAnswer: "كلا، لا يجوز للشرطي منع استمرار سيرها.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "كلا، يجوز فقط لشرطي مرور توبيخ صاحب المركبة وتحذيره وتحرير مخالفة له.",
        "نعم، يجوز للشرطي أن يمنع استمرار سيرها حتى يتم ترتيب الحمولة حسب القانون.",
        "نعم، فقط في طريق بلدية.",
        "كلا، لا يجوز للشرطي منع استمرار سيرها."
      ],
      id: 1432
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1378. ما هو 'مخفف السرعة':",
      numQues: "1378",
      correctAnswer: "جهاز كهربائي أو هيدراولي غير مرتبط بجهاز فرامل المركبة، ويُستخدم في تخفيف سرعة المركبة عند تشغيله.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "جهاز الكتروني يُشغل الفرامل بشكلٍ أوتوماتيكي عند السير في منحدر شديد وبالتالي يمنع سخونة وفقدان الفرامل.",
        "جهاز مُركب في المركبة يساعد على فرملة الطوارئ ويفرمل المركبة على الفور.",
        "جهاز كهربائي مُركب في جهاز الفرامل يطفئ المحرك وبالتالي يحافظ على سرعة ثابتة للمركبة في جميع الطرق.",
        "جهاز كهربائي أو هيدراولي غير مرتبط بجهاز فرامل المركبة، ويُستخدم في تخفيف سرعة المركبة عند تشغيله."
      ],
      id: 1433
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0834. أين توقف مركبتك بعد النزول إلى حاشية الطريق عند الضرورة؟",
      numQues: "0834",
      correctAnswer: "يجب أن تقف العجلتين اليمنيين على الحاشية والعجلتين اليساريتين تقفان على الشارع",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3832.jpg",
      choices: [
        "بعيداً قدر الإمكان عن حافة الشارع.",
        "على مسافة لا تزيد عن 40سم من حافة الشارع.",
        "بعد القناة المجاورة لحافة الشارع.",
        "يجب أن تقف العجلتين اليمنيين على الحاشية والعجلتين اليساريتين تقفان على الشارع"
      ],
      id: 1434
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0133. أنت تعبر مفترق فيه مسلك واحد في كل اتجاه:",
      numQues: "0133",
      correctAnswer: "مسموح التجاوز ولكن عليك إنهاء عملية التجاوز بعد المفترق.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "ممنوع التجاوز وممنوع محاولة التجاوز في حدود المفترق (ما عدا تجاوز مركبة تسير على عجلتين).",
        "مسموح تجاوز مركبة تسير على أكثر من عجلتين بحذر.",
        "مسموح تجاوز مركبة بطيئة فقط.",
        "مسموح التجاوز ولكن عليك إنهاء عملية التجاوز بعد المفترق."
      ],
      id: 1435
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1585. كيف يتم نقل راكب إضافي على الدراجة النارية :",
      numQues: "1585",
      correctAnswer: "إذا كانت قدمي الراكب على جانبي الدراجة النارية وترتكزان على ساندات القدمين.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "إذا كانت قدمي الراكب على الجانب الأيمن للدراجة النارية.",
        "يجوز للراكب الإضافي الجلوس كيفما يشاء على الدراجة النارية أثناء سيرها.",
        "إذا كانت قدمي الراكب على الجانب الأيسر للدراجة النارية.",
        "إذا كانت قدمي الراكب على جانبي الدراجة النارية وترتكزان على ساندات القدمين."
      ],
      id: 1436
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1660. لا ينقل صاحب رخصة سياقة من الدرجة A2 راكباً إضافياً على الدراجة النارية إلا إذا أتم السائق من عمره:",
      numQues: "1660",
      correctAnswer: "15 سنة.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "16 سنة.",
        "17 سنة.",
        "18 سنة.",
        "15 سنة."
      ],
      id: 1437
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0566. ما معنى الإشارة؟",
      numQues: "0566",
      correctAnswer: "طريق تحويل في الطريق السريعة التي أمامك.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3147.jpg",
      choices: [
        "جسر علوي فوق الطريق السريعة. ",
        "الدخول إلى طريق سريعة.",
        "الخروج من طريق سريعة.",
        "طريق تحويل في الطريق السريعة التي أمامك."
      ],
      id: 1438
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1174. ما هو عدد الركاب الأقصى المسموح للسائق نقله في الزوتوبوس (الصالون العمومي الكبير)؟",
      numQues: "1174",
      correctAnswer: "بعدد مقاعد الجلوس.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "حسب المذكور في رخصة المركبة وليس أكثر من عشرة ركاب.",
        "8 ركاب ما عدا السائق.",
        "6 أشخاص بالغين وولدين.",
        "بعدد مقاعد الجلوس."
      ],
      id: 1439
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0177. كيف تتصرف عند خروجك من ساحات أو من محطة وقود؟",
      numQues: "0177",
      correctAnswer: "عند الخروج من ساحات أو من محطة وقود يجب تطبيق القاعدة 'من يصل أولاً يخرج أولاً'، وعلى المشاة الانتظار.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "قف وأعطِ حق الأولوية للمشاة الذين يعبرون المفترق.",
        "تمهل وحتى قف، عند الضرورة، لتمكين المشاة من العبور بأمان.",
        "قف وأعطِ حق الأولوية للمركبات القادمة من اليسار والمقتربة من المخرج.",
        "عند الخروج من ساحات أو من محطة وقود يجب تطبيق القاعدة 'من يصل أولاً يخرج أولاً'، وعلى المشاة الانتظار."
      ],
      id: 1440
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0384. ما هو الفرق بين الإشارتين؟",
      numQues: "0384",
      correctAnswer: "تُنصب الإشارة رقم: 135في طريق ليست بلدية بينما تُنصب الإشارة رقم: 306 في طريق داخل المدن.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3384.jpg",
      choices: [
        "الإشارة رقم: 135 تُحذر من الاقتراب من مكان عبور المشاة والإشارة رقم: 306 تدل على مكان عبور المشاة.",
        "الإشارة رقم: 306 تُحذر من الاقتراب من مكان عبور المشاة والإشارة رقم: 135 تدل على مكان عبور المشاة.",
        "لا يوجد فرق بينهما.",
        "تُنصب الإشارة رقم: 135في طريق ليست بلدية بينما تُنصب الإشارة رقم: 306 في طريق داخل المدن."
      ],
      id: 1441
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0510. ما معنى الإشارة؟",
      numQues: "0510",
      correctAnswer: "ممنوع دخول أية مركبة لا يزيد ارتفاعها بالأمتار عن الرقم المذكور في الإشارة.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3418.jpg",
      choices: [
        "ممنوع دخول أية مركبة يزيد ارتفاعها مع أو بدون حمولتها عن الرقم المذكور في الإشارة.",
        "ممنوع دخول مركبة يزيد عرض حمولتها بالأمتار عن المسجل في الإشارة.",
        "مسموح دخول مركبة غير ميكانيكية يزيد ارتفاعها عن 3م.",
        "ممنوع دخول أية مركبة لا يزيد ارتفاعها بالأمتار عن الرقم المذكور في الإشارة."
      ],
      id: 1442
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0906. كيف تتصرف في الوضع الذي أمامك؟",
      numQues: "0906",
      correctAnswer: "استعمل الزامور وتجاوز عن الأولاد كما تتجاوز عن مركبة واقفة. ",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3906.jpg",
      choices: [
        "لا تزعج الأولاد، أنت تسير في شارع مختلط (موحد).",
        "انظر في المرايا وتمهل واستعد للتوقف إذا لزم الأمر.",
        "انحرف قليلاً إلى اليمين واعبر عن الأولاد بسرعتك الأصلية.",
        "استعمل الزامور وتجاوز عن الأولاد كما تتجاوز عن مركبة واقفة. "
      ],
      id: 1443
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0247. ما هي 'مركبة الأمن'؟",
      numQues: "0247",
      correctAnswer: "مركبة لإطفاء الحريق فقط.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "كل مركبة تابعة لشرطة إسرائيل.",
        "مركبة إسعاف تابعة لنجمة داود الحمراء فقط.",
        "كل مركبة إسعاف تابعة لنجمة داود الحمراء أو مركبة تابعة لشرطة إسرائيل أو لجيش الدفاع الإسرائيلي أو مركبة إطفاء حريق أو مركبة مشتركة من السلطة المحلية والشرطة أو كل مركبة أخرى صادقت عليها سلطة الترخيص عندما تبعث بإشارة بواسطة ضوء وتطلق صافرة إنذار.",
        "مركبة لإطفاء الحريق فقط."
      ],
      id: 1444
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1537. يسري واجب المرافقة بواسطة مركبة، على المركبة التجارية التي تنقل حمولة بارزة عرضها أكثر من:",
      numQues: "1537",
      correctAnswer: "2.5م.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "3م.",
        "20سم من كل جانب من جوانب صندوق المركبة.",
        "3.40م.",
        "2.5م."
      ],
      id: 1445
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0013. 'تراكتور الحمولة' هو التراكتور:",
      numQues: "0013",
      correctAnswer: "الذي يسير على 4 عجلات ولا يوجد تحديد لوزنه الإجمالي المسموح به ويتم توجيهه بواسطة مقود دراجة (كيدون).",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "الذي يسير على 3 عجلات على الأقل ولا يزيد وزنه الإجمالي المسموح به عن 12000 كغم .",
        "الذي يسير على عجلتين على الأقل ولا يزيد وزنه الإجمالي المسموح به عن 1500كغم ويتم توجيهه بواسطة مقود دراجة (كيدون).",
        "الذي يسير على 4 عجلات على الأقل ولا يزيد وزنه الإجمالي المسموح به عن 1500كغم ويتم توجيهه بواسطة المقود.",
        "الذي يسير على 4 عجلات ولا يوجد تحديد لوزنه الإجمالي المسموح به ويتم توجيهه بواسطة مقود دراجة (كيدون)."
      ],
      id: 1446
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0627. ماذا تعني الإشارة؟",
      numQues: "0627",
      correctAnswer: "ممنوع الوقوف على الرصيف.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3627.jpg",
      choices: [
        "مسموح الوقوف على الرصيف بشرط أن يكون عرض الرصيف أكثر من ستة أمتار.",
        "مسموح الوقوف على الرصيف، حسب ما هو مؤشر عليه، للمركبات التي لا يزيد وزنها الإجمالي عن 2200كغم.",
        "مسموح الوقوف على الرصيف، حسب ما هو مؤشر عليه، لجميع أنواع المركبات.",
        "ممنوع الوقوف على الرصيف."
      ],
      id: 1447
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0972. لماذا حسب رأيك تم رسم خط فاصل متواصل في الصورة؟",
      numQues: "0972",
      correctAnswer: "بسبب مدى الرؤية المحدود في الأمام.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3972.jpg",
      choices: [
        "نظراً لضيق عرض الطريق.",
        "بسبب الأشجار على جانبي الشارع.",
        "بسبب خليج توقف الباص على يمين الشارع.",
        "بسبب مدى الرؤية المحدود في الأمام."
      ],
      id: 1448
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1561. عندما يوسم (يؤشر) على الشارع على يسارك خط فاصل متواصل وعلى يساره خط متقطع:",
      numQues: "1561",
      correctAnswer: "يُسمح لك باختراق هذه الخطوط، لكن حق الأولوية للمركبة المقابلة.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "يُسمح لك باختراق هذه الخطوط، وممنوع للمركبة المقابلة اختراقها.",
        "يُسمح لك باختراق هذه الخطوط، لأن لك حق الأولوية.",
        "ممنوع أن تخترق هذه الخطوط، لكن يُسمح بذلك للمركبة القادمة من الاتجاه المعاكس إذا كانت الطريق خالية.",
        "يُسمح لك باختراق هذه الخطوط، لكن حق الأولوية للمركبة المقابلة."
      ],
      id: 1449
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0118. لا يجوز للسائق أن يستدير للسير في الاتجاه المعاكس (حذوة فرس):",
      numQues: "0118",
      correctAnswer: "إذا نُصبَت إشارة تمنع الاستدارة إلى اليسار.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "عندما يسوق مركبة يزيد طولها عن ثمانية أمتار.",
        "إذا كان في شارع باتجاهين.",
        "عندما لا يُرى من قِبل سائق مركبة أخرى تقترب من أي اتجاه كان.",
        "إذا نُصبَت إشارة تمنع الاستدارة إلى اليسار."
      ],
      id: 1450
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0204. على أية مسافة من حنفية إطفاء يُمنع إيقاف مركبة؟",
      numQues: "0204",
      correctAnswer: "في حدود 62م.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "في حدود 20م.",
        "في حدود 2م.",
        "في حدود 12م.",
        "في حدود 62م."
      ],
      id: 1451
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0453. ما معنى الإشارة؟",
      numQues: "0453",
      correctAnswer: "الاقتراب من ملتقى سكة حديد حوالي 250م قبل الملتقى.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3453.jpg",
      choices: [
        "الاقتراب من ملتقى سكة حديد حوالي 100م قبل الملتقى.",
        "عندما ترى أضواء القطار، توقف على مسافة 6م قبل خط السكة.",
        "الاقتراب من ملتقى سكة حديد حوالي 170م قبل الملتقى.",
        "الاقتراب من ملتقى سكة حديد حوالي 250م قبل الملتقى."
      ],
      id: 1452
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1207. متى يجب إضاءة الباص من الداخل؟",
      numQues: "1207",
      correctAnswer: "في وقت الإنارة – لكن يُسمح بتشغيل ضوء بجانب الباب الخلفي فقط.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "تشغيل ضوء في الممر في وقت الإنارة يعتمد على رأي السائق.",
        "في وقت الإنارة.",
        "خلال الاربع وعشرون ساعة.",
        "في وقت الإنارة – لكن يُسمح بتشغيل ضوء بجانب الباب الخلفي فقط."
      ],
      id: 1453
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0839. ما هي خصائص الطريق الجبلية؟",
      numQues: "0839",
      correctAnswer: "الطرق الجبلية غير معبدة دائماً.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3839.jpg",
      choices: [
        "شوارع عريضة وغير موسومة (مؤشرة).",
        "كثرة المشاة والحيوانات.",
        "شارع ضيق والتواءات ومنعطفات حادة وانحدارات شديدة.",
        "الطرق الجبلية غير معبدة دائماً."
      ],
      id: 1454
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0554. أنت تسوق مركبة تجارية ووصلت إلى هذه الإشارة:",
      numQues: "0554",
      correctAnswer: "اعبر من اليمين فقط – مسموح للمواصلات العمومية فقط السير من اليسار أيضاً.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3513.jpg",
      choices: [
        "سر إلى الأمام فقط.",
        "اعبر من اليمين أو من اليسار حسب اختيارك.",
        "اعبر من اليسار فقط – مسموح للمواصلات العمومية فقط السير من اليمين أيضاً.",
        "اعبر من اليمين فقط – مسموح للمواصلات العمومية فقط السير من اليسار أيضاً."
      ],
      id: 1455
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1042. كيف يمكن تقليل مدى تلوث الهواء من غازان العادم المنبعثة من المركبة؟",
      numQues: "1042",
      correctAnswer: "لا يمكن تقليل التلوث لأنه ثابت في المركبة.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "بواسطة غسل خزان الوقود في المركبة مرة في الشهر.",
        "بواسطة الصيانة المنتظمة لمحرك المركبة وسائر أجهزته.",
        "بواسطة المحافظة على نظافة محرك المركبة وعلى غرفة محرك المركبة.",
        "لا يمكن تقليل التلوث لأنه ثابت في المركبة."
      ],
      id: 1456
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1680. إذا تعطل ضوء المقدمة الواطئ في الدراجة النارية أثناء السير في الليل :",
      numQues: "1680",
      correctAnswer: "مسموح الاستمرار بالسير بسرعة بطيئة (نصف السرعة القصوى المسموح بها).",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "مسموح الاستمرار بالسير بدون الضوء الواطئ – ليس أكثر من مدة أسبوع.",
        "القانون يمنع الاستمرار بالسير.",
        "مسموح الاستمرار بالسير فقط خلف مركبة أضواءها صالحة.",
        "مسموح الاستمرار بالسير بسرعة بطيئة (نصف السرعة القصوى المسموح بها)."
      ],
      id: 1457
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0983. كيف يجب السير حسب المسجل على الإشارة؟",
      numQues: "0983",
      correctAnswer: "سر على الجانب الأيسر لمسلك سيرك، لأن الشارع ضيق وليس فيه حواشي تُستخدم كمكان للهرب وقت الخطر.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3983.jpg",
      choices: [
        "سر في وسط الشارع، لأن الشارع ضيق وليس فيه حواشي تُستخدم كمكان للهرب وقت الخطر.",
        "يجب التمهل وإبداء حذر خاص لما يجري في الشارع، الشارع ضيق وليس فيه حواشي تُستخدم كمكان للهرب وقت الخطر.",
        "يجب السياقة بالسرعة القصوى لأنها تساهم في ثبات المركبة.",
        "سر على الجانب الأيسر لمسلك سيرك، لأن الشارع ضيق وليس فيه حواشي تُستخدم كمكان للهرب وقت الخطر."
      ],
      id: 1458
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1559. عندما تُبهر الشمس نظر سائق المركبة، عليه:",
      numQues: "1559",
      correctAnswer: "تحويل نظره إلى الجانب وعدم النظر إلى الأمام لكي لا يُبهَر نظره. ",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "تجاوز المركبة التي في الأمام، لأنه يُستحسن السير في شارع خالي.",
        "الالتصاق بالمركبة التي في الأمام كي تحجب عنه أشعة الشمس.",
        "التخفيف من سرعته حسب مدى الرؤية آنذاك واستعمال حاجب الشمس. ",
        "تحويل نظره إلى الجانب وعدم النظر إلى الأمام لكي لا يُبهَر نظره. "
      ],
      id: 1459
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1230. ما هو الطول الإجمالي المسموح به لباص ذو محورين؟",
      numQues: "1230",
      correctAnswer: "15.5م والباص المفصلي 18.75م.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "لا يوجد تحديد، لكن لا يجب أن يزيد طول الامتداد الخلفي عن 3.5م.",
        "13م، والباص المفصلي 18م.",
        "13.5م.",
        "15.5م والباص المفصلي 18.75م."
      ],
      id: 1460
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0723. ما هو واجب سائق مركبة يقوم بإنزال أولاد عند نقل التلاميذ؟",
      numQues: "0723",
      correctAnswer: "ينتظر ويتأكد بأن جميع التلاميذ الذين نزلوا قد ابتعدوا عن مركبة النقل.",
      pubDate: "10-11-2011 08:23:09",
      img: "",
      choices: [
        "يتأكد بأن جميعهم نزلوا من الباب الخلفي.",
        "ينتظر لغاية وصول شرطي ليساعد التلاميذ في قطع الشارع.",
        "يسير فور نزول التلاميذ من اجل تمكينهم من قطع الشارع بأمان.",
        "ينتظر ويتأكد بأن جميع التلاميذ الذين نزلوا قد ابتعدوا عن مركبة النقل."
      ],
      id: 1461
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0442. كيف تتصرف حسب الإشارة ؟",
      numQues: "0442",
      correctAnswer: "تمهل حتى إمكانية التوقف قبل خط السكة الحديد.",
      pubDate: "10-11-2011 08:23:09",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3441.jpg",
      choices: [
        "توقف في جميع الأحوال قبل خط سكة الحديد وانظر يميناً ويساراً وتابع سيرك.",
        "استعمل الزامور عند اقترابك من خط سكة حديد وافتح النافذة وأصغ إلى ضوضاء القطار. ",
        "اعبر خط سكة الحديد بسرعة.",
        "تمهل حتى إمكانية التوقف قبل خط السكة الحديد."
      ],
      id: 1462
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "0270. لا تُجدد رخصة سياقة 'لسائق جديد' كرخصة سواقة عادية إذ أدين في المحكمة بمخالفة:",
      numQues: "0270",
      correctAnswer: "عدم التوقف في المكان الذي نُصبت فيه شاخصة 'أعط حق الأولوية لحركة السير في الطريق القاطعة'.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "سياقة مركبة ميكانيكية بدون تأمين ساري المفعول.",
        "التجاوز خلافاً للقانون.",
        "عدم وضع لافتة 'سائق جديد' على الزجاج الخلفي للمركبة.",
        "عدم التوقف في المكان الذي نُصبت فيه شاخصة 'أعط حق الأولوية لحركة السير في الطريق القاطعة'."
      ],
      id: 1463
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0883. كيف تؤثر الرياح الجانبية الشديدة على سير الشاحنة العالية؟",
      numQues: "0883",
      correctAnswer: "لا تؤثر، شاحنة بدون حمولة لا تتأثر من قوة الرياح الجانبية الشديدة التي تهب على المركبة.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3883.jpg",
      choices: [
        "لا يوجد تأثير للرياح على المركبة الثقيلة.",
        "لا تؤثر، شاحنة تنقل حمولة ثقيلة لا تتأثر على الإطلاق من الرياح الجانبية التي تهب عليها.",
        "تسعى الرياح إلى حرف الشاحنة ويضطر السائق بأن يتمهل للتغلب على قوة الرياح التي تسعى إلى إزاحته جانباً. ",
        "لا تؤثر، شاحنة بدون حمولة لا تتأثر من قوة الرياح الجانبية الشديدة التي تهب على المركبة."
      ],
      id: 1464
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1793. الباص الصغير (أوتوبوس زعير) مُعد لنقل:",
      numQues: "1793",
      correctAnswer: "لغاية 16 راكباً إضافة إلى السائق.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "8 ركاب إضافة إلى السائق.",
        "لغاية 16 راكباً بما فيهم السائق.",
        "لغاية 12 راكباً إضافة إلى السائق.",
        "لغاية 16 راكباً إضافة إلى السائق."
      ],
      id: 1465
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1434. أين يُمنع إيقاف مركبة تجارية وزنها الإجمالي المسموح به أكثر من 10000كغم؟",
      numQues: "1434",
      correctAnswer: "في كل شارع عرضه اقل من 10م.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "في شوارع باتجاهين.",
        "في منطقة يُمنع فيها إيقاف ووقوف مثل هذه المركبات بواسطة إشارة نصبتها سلطة الشاخصات المحلية.",
        "في منطقة يُمنع فيها إيقاف ووقوف مثل هذه المركبات، حسب ما هو مسجل في رخصة المركبة التجارية.",
        "في كل شارع عرضه اقل من 10م."
      ],
      id: 1466
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»"
      ],
      title: "1576. هل يُسمح لدراجة نارية بأن تجر:",
      numQues: "1576",
      correctAnswer: "مسموح.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مسموح، إذا كانت المجرورة مركبة تسير على عجلتين.",
        "مسموح فقط في ساعات الظلام وبدون تعريض أي شخص للخطر.",
        "ممنوع، يُمنع الجر بمركبة ميكانيكية ذات ثلاث عجلات أو اقل. ",
        "مسموح."
      ],
      id: 1467
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1693. قدرة السيطرة على المركبة:",
      numQues: "1693",
      correctAnswer: "تتحسن كلما زادت السرعة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "لا تعتمد على سرعة السير.",
        "تعتمد على وضع الشارع فقط ولا تعتمد على السائق أو المركبة.",
        "تكون أفضل عندما نسير بسرعة معقولة. ",
        "تتحسن كلما زادت السرعة."
      ],
      id: 1468
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0908. تخيل الحالة التي أمامك، أية إمكانية تصرف تختار؟",
      numQues: "0908",
      correctAnswer: "أولاد يلعبون في الشارع، استعمل الزامور لتنبيههم باقترابي واعبر عنهم من اليسار.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3906.jpg",
      choices: [
        "أولاد يلعبون في الشارع، علي اتخاذ جميع التدابير اللازمة لكي لا أصيبهم بأذى، وحتى أتوقف.",
        "أولاد يلعبون في الشارع، ولكي لا أزعجهم، اعبر عنهم من اليمين وبسرعة.",
        "شاهدت أولاداً يلعبون، استعمل الزامور لكي يخلوا الشارع ولا يزعجوني، لا يجوز لهم اللعب في الشارع.",
        "أولاد يلعبون في الشارع، استعمل الزامور لتنبيههم باقترابي واعبر عنهم من اليسار."
      ],
      id: 1469
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1503. تؤثر مقاومة الريح على سير المركبة:",
      numQues: "1503",
      correctAnswer: "على سرعة المركبة وعلى تآكل الإطارات.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "على اهتراء أجهزة المقود.",
        "على قدرة فرامل للمركبة.",
        "على ثبات المركبة وسرعة سيرها.",
        "على سرعة المركبة وعلى تآكل الإطارات."
      ],
      id: 1470
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1466. كلما كان مركز ثقل المركبة أعلى:",
      numQues: "1466",
      correctAnswer: "نعم , يكون من الأسهل تنفيذ استدارات في المركبة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "نعم , يقل ثبات المركبة في المنعطفات والإلتوائات.",
        "نعم , يزداد ثبات المركبة في المنعطفات.",
        "نعم , يزداد ثبات المركبة في الشارع الرطب.",
        "نعم , يكون من الأسهل تنفيذ استدارات في المركبة."
      ],
      id: 1471
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0325. ماذا يجوز للشرطي عمله إذا وجد في المركبة التجارية حمولة تفوق الوزن المسموح به؟",
      numQues: "0325",
      correctAnswer: "يأمر السائق بالعودة فوراً إلى نقطة التحميل وتفريغ كل الحمولة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "يُسلم السائق إشعار بعدم استعمال المركبة لمدة 90 يوماً.",
        "يجلب صاحب المركبة إلى دائرة الترخيص القريبة لسحب رخصته لمدة 30 يوماً.",
        "يُسلم السائق إشعار بعدم استعمال المركبة لمدة 30 يوماً.",
        "يأمر السائق بالعودة فوراً إلى نقطة التحميل وتفريغ كل الحمولة."
      ],
      id: 1472
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0824. احد الشروط المطلوبة المبررة من أجل تجاوز مركبة في حالة سير هو:",
      numQues: "0824",
      correctAnswer: "العرقلة المتسببة للمركبة المنوي تجاوزها بسبب السير البطيء للمركبة التي في الأمام.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "لا توجد شروط تبرر التجاوز.",
        "الفرق في السرعات بين المركبة المتجاوزة والمركبة المنوي تجاوزها هو أمر مهم.",
        "المركبة المنوي تجاوزها تسير بسرعة اقل من السرعة القصوى المسموح بها في القانون.",
        "العرقلة المتسببة للمركبة المنوي تجاوزها بسبب السير البطيء للمركبة التي في الأمام."
      ],
      id: 1473
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1035. هل يُسمح بتغيير الإطارات في المركبة بإطارات ذات قياس مختلف؟",
      numQues: "1035",
      correctAnswer: "ممنوع تغيير قياس الإطارات في المركبة في جميع الأحوال.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مسموح، إذا سمحت شركة التأمين بالتغيير.",
        "يُسمح بالتغيير فقط بإذنٍ مسبق من 'سلطة الترخيص' في وزارة المواصلات.",
        "مسموح، بشرط أن يتم تغيير جميع إطارات المركبة بإطارات جديدة لها قياس آخر يريده السائق.",
        "ممنوع تغيير قياس الإطارات في المركبة في جميع الأحوال."
      ],
      id: 1474
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0815. ما هي المسافة التي نحافظ عليها من المركبة التي تسير أمامنا أثناء السير؟",
      numQues: "0815",
      correctAnswer: "المسافة المطلوبة حسب القانون والتي تمكن من منع وقوع حادث في أية لحظة بمراعاة جميع المسببات.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3815.jpg",
      choices: [
        "كل مسافة تمكننا من رؤية العجلات الخلفية للمركبة التي تسير أمامنا أثناء السير.",
        "المسافة التي تمنع دخول مركبات أخرى فيها.",
        "كل مسافة تمكننا من الرؤية الجيدة لما يدور أمام المركبة التي تسير أمامنا في كل لحظة.",
        "المسافة المطلوبة حسب القانون والتي تمكن من منع وقوع حادث في أية لحظة بمراعاة جميع المسببات."
      ],
      id: 1475
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1365. أية مركبة تجارية ملزمة بجهاز تحديد السرعة؟",
      numQues: "1365",
      correctAnswer: "مركبة وزنها الإجمالي المسموح به أكثر من 12000كغم والساندة ومركبة العمل.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "كل مركبة تجارية.",
        "مركبة تجارية وزنها الإجمالي المسموح به لغاية 8000كغم.",
        "مركبة تجارية يزيد وزنها الإجمالي المسموح لغاية 10000كغم.",
        "مركبة وزنها الإجمالي المسموح به أكثر من 12000كغم والساندة ومركبة العمل."
      ],
      id: 1476
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0137. ما هي المسافة التي يجب المحافظة عليها من المركبة التي تسير أمامنا في الطريق؟",
      numQues: "0137",
      correctAnswer: "مسافة تُمكن من التوقف في كل وقت ولمنع وقوع حادث.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مسافة ثلاث ثواني على الأقل.",
        "مسافة 30م من اجل التمكن من التوقف الآمن.",
        "مسافة 40م من اجل منع وقوع حادث.",
        "مسافة تُمكن من التوقف في كل وقت ولمنع وقوع حادث."
      ],
      id: 1477
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0763. كيف نقوم بالانتقال من مسلك إلى مسلك آخر؟",
      numQues: "0763",
      correctAnswer: "ننحرف بسرعة بشكلٍ مائل وقصير وبعزم ونتأكد بأننا أعطينا الإشارة بواسطة الغماز.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "نعطي إشارة بواسطة الغماز وننحرف بشكلٍ مائل وقصير إلى المسلك المقصود. ",
        "يجري الانتقال بعد الفحص والانتباه لموقع وسرعات المركبات الأخرى الموجودة في المسلك الذي ننوي الانحراف إليه.",
        "نقترب على قدر الإمكان من المسلك المقصود، وعندما لا تسير فيه أية مركبة من خلفنا نعطي إشارة بواسطة الغماز وننحرف إلى المسلك المقصود بشكلٍ مائل وقصير.",
        "ننحرف بسرعة بشكلٍ مائل وقصير وبعزم ونتأكد بأننا أعطينا الإشارة بواسطة الغماز."
      ],
      id: 1478
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1432. إذا كانت المركبة تنقل 'مادة خطرة'، فعلى أية مسافة من مبنى للسكن أو من مبنى عام يسمح بإيقافها؟",
      numQues: "1432",
      correctAnswer: "50م على الأقل.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "300م إذا كانت هناك حمولة على المركبة، و 50م إذا لم تكن هناك حمولة على المركبة.",
        "200م على الأكثر.",
        "400م أو أكثر.",
        "50م على الأقل."
      ],
      id: 1479
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1520. هناك واجب بحيازة زوج أحذية أمان في مركبة تجارية وزنها الإجمالي المسموح به أكثر من:",
      numQues: "1520",
      correctAnswer: "4000كغم.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "5000كغم.",
        "2500كغم.",
        "3000كغم.",
        "4000كغم."
      ],
      id: 1480
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "1052. ما هي وظيفة لوحة المقاييس (الساعات في التابلو) في المركبة؟",
      numQues: "1052",
      correctAnswer: "لتزويد حماية إضافية للركاب عند الاصطدام من الأمام.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "لتنظيم أجهزة المحرك ومنع اهتراء إطارات المركبة.",
        "للتحكم في النظام الصوتي في كابينة السائق وتغيير محطات الراديو.",
        "تُمكن من مراقبة أجهزة المركبة المختلفة وتلقي معلومات منها.",
        "لتزويد حماية إضافية للركاب عند الاصطدام من الأمام."
      ],
      id: 1481
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1330. لمن يجوز أن يعطي إذن لنقل حمولة بارزة في مركبة وزنها الإجمالي المسموح به أكثر من 15000كغم؟",
      numQues: "1330",
      correctAnswer: "مدير عام قسم الأشغال العامة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "ضابط السلامة للنقل.",
        "ضابط شرطة فقط.",
        "سلطة الترخيص.",
        "مدير عام قسم الأشغال العامة."
      ],
      id: 1482
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1490. مسافة رد الفعل هي المسافة التي تقطعها المركبة:",
      numQues: "1490",
      correctAnswer: "من اللحظة التي يشغل فيها السائق الفرامل ولغاية توقف المركبة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "من اللحظة التي يحرر فيها السائق دعسة الوقود ولغاية توقف المركبة.",
        "من لحظة مشاهدة السائق للخطر ولغاية التوقف التام.",
        "من لحظة مشاهدة السائق للخطر ولغاية بداية العملية التي قرر تنفيذها.",
        "من اللحظة التي يشغل فيها السائق الفرامل ولغاية توقف المركبة."
      ],
      id: 1483
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0311. 'يبطأ شرب الكحول من قدرة رد الفعل عند سائق المركبة' ، صحيح أو غير صحيح؟",
      numQues: "0311",
      correctAnswer: "غير صحيح، الكحول تُحسن من القدرة على التركيز.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "صحيح.",
        "غير صحيح، الكحول تُحسن من المعنوية.",
        "غير صحيح، لا توجد علاقة بين شرب الكحول وبين قدرة رد الفعل عند السائق.",
        "غير صحيح، الكحول تُحسن من القدرة على التركيز."
      ],
      id: 1484
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1135. كيف يجب على السائق التصرف حسب القانون بالنسبة لجهاز راديو يعمل في الباص؟",
      numQues: "1135",
      correctAnswer: "على السائق أن يتصرف حسب طلب أغلب الركاب.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "يجب على السائق وقف تشغيل سماعات الركاب وخفض صوت الراديو حسب طلب احد الركاب.",
        "يجب على السائق إغلاق السماعات فقط في طريق بلدية، حسب طلب احد الركاب.",
        "على السائق ضبط الراديو للمحطة المطلوبة من قِبل اغلب الركاب.",
        "على السائق أن يتصرف حسب طلب أغلب الركاب."
      ],
      id: 1485
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1007. ما معنى الإشارة؟",
      numQues: "1007",
      correctAnswer: "توجيه إلى وسط المنطقة أو المدينة أو المكان.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31007.jpg",
      choices: [
        "توجيه مسبق إلى المسالك قبل مفترق، وتُنصب دائماً في الجهة اليسرى من الشارع.",
        "توجيه مسبق إلى أهداف قبل مفترق فقط، وتُنصب دائماً في الجهة اليمنى من الشارع.",
        "توجيه إلى أهداف فوق المسالك قبل محول طرق (في طريق ليست بلدية أو في طريق سريعة). ",
        "توجيه إلى وسط المنطقة أو المدينة أو المكان."
      ],
      id: 1486
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0963. في أية طريق يُسمح لمركبة ركاب خصوصية السير بسرعة 110كم/ساعة؟",
      numQues: "0963",
      correctAnswer: "في طريق سريعة.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3963.jpg",
      choices: [
        "في طريق ليست بلدية مع مساحة فاصلة مبنية.",
        "في طريق بلدية مع مساحة فاصلة مبنية.",
        "في طريق ليست بلدية.",
        "في طريق سريعة."
      ],
      id: 1487
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1212. هل هناك واجب بإطاعة تعليمات موظفي الخدمة عند السفر في الباص؟",
      numQues: "1212",
      correctAnswer: "نعم، يجب إطاعة تعليمات موظفي الخدمة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "كلا، هناك واجب بإطاعة تعليمات شرطي أو مفتش بلدية فقط.",
        "كلا، يجب إطاعة تعليمات شرطي بلباسه الرسمي فقط.",
        "كلا، لا يوجد واجب بإطاعة تعليمات موظفي الخدمة.",
        "نعم، يجب إطاعة تعليمات موظفي الخدمة."
      ],
      id: 1488
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1189. هل يجب أن يكون بحوزة سائق الباص زوج نظارات/عدسات لاصقة إضافية في المركبة؟",
      numQues: "1189",
      correctAnswer: "نعم، في طرق ليست بلدية فقط.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "نعم، في كل سفرة – إذا كان ملزماً باستعمال النظارات حسب رخصة سواقته.",
        "نعم، على من يسوق فعلاً مركبة تجارية وينقل لغاية 6 ركاب أن يكون بحوزته زوج إضافي.",
        "نعم، على كل سائق مركبة تجارية أن يكون بحوزته زوج إضافي، حتى وان لم يكن ينقل ركاب.",
        "نعم، في طرق ليست بلدية فقط."
      ],
      id: 1489
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1589. لا ينقل راكب الدراجة النارية طرد أو رزمة أو متاع:",
      numQues: "1589",
      correctAnswer: "تبرز خارج القسم الخلفي للدراجة النارية.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "تمنعه من السيطرة التامة على الدراجة النارية.",
        "تمنعه من الجلوس بشكلٍ مريح على الدراجة النارية.",
        "غير مغلفة حسب الأصول.",
        "تبرز خارج القسم الخلفي للدراجة النارية."
      ],
      id: 1490
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0851. ما هي المشاكل التي تواجه سائق المركبة في الليل؟",
      numQues: "0851",
      correctAnswer: "كثرة المركبات حوله في ساعات الليل.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مدى رؤية محدود وبهر النظر وتقدير غير صحيح للمسافات والتعب.",
        "أداء السائق غير سليم بسبب الإنارة خارج المركبة.",
        "انخفاض في قوة المحرك بسبب تشغيل جهاز الإنارة.",
        "كثرة المركبات حوله في ساعات الليل."
      ],
      id: 1491
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1812. أي إشارة معناها موقع تعبئة ( شحن بطارية) مركبة كهربائية؟",
      numQues: "812 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [],
      id: 1492
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0841. كيف نقلص إلى أدنى حد خطر فقدان الفرامل عند السياقة في طريق جبلية؟",
      numQues: "0841",
      correctAnswer: "من المستحسن استعمال الفرامل بدون استغلال قوة الفرملة لمحرك المركبة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "لا يجب تبديل الغيارات على طول الطريق الجبلية.",
        "ينبغي السياقة بالغيار الملائم (واطئ) والتقليل من استعمال الفرامل.",
        "يجب التقليل من استعمال الفرامل والبقاء بالغيار العالي.",
        "من المستحسن استعمال الفرامل بدون استغلال قوة الفرملة لمحرك المركبة."
      ],
      id: 1493
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1761. إشارة 'قف' المنصوبة على الجانب الأيمن من شارع باتجاه واحد فيه مسلكان، معناها:",
      numQues: "1761",
      correctAnswer: "توقف إذا كنت في المسلك الأيمن فقط.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "توقف إذا كنت في أي واحد من المسلكين.",
        "توقف إذا كنت تنوي الاستدارة إلى اليسار.",
        "توقف إذا كنت في المسلك الأيسر فقط.",
        "توقف إذا كنت في المسلك الأيمن فقط."
      ],
      id: 1494
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1428. ما هو الارتفاع الأقصى المسموح به للحمولة لمركبة وزنها الإجمالي المسموح به لغاية 15000كغم أو اقل، مع الحمولة التي عليها؟",
      numQues: "1428",
      correctAnswer: "ثلاثة أمتار ونصف وبشرط أن تكون وحدة واحدة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "أربعة أمتار.",
        "لغاية 4.80م.",
        "لغاية 4.40م.",
        "ثلاثة أمتار ونصف وبشرط أن تكون وحدة واحدة."
      ],
      id: 1495
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1404. أنت تسوق مركبة ركاب خصوصية وزنها الإجمالي 1520 كغم ,ما هو الوزن الإجمالي الأقصى للمجرورة التي يُسمح لك بجرها ؟",
      numQues: "1404",
      correctAnswer: "450كغم..",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "1500كغم.",
        "750كغم.",
        "2200كغم وليس أكثر من الوزن الذاتي لمركبتك.",
        "450كغم.."
      ],
      id: 1496
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1588. ما هو الخطر المتوقع عند السير بدراجة نارية وساندة الدراجة الجانبية مفتوحة؟",
      numQues: "1588",
      correctAnswer: "ذلك يسبب ضرراً للشارع وللبنى التحتية الأخرى.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "ذلك يسبب في اختلال توازن الدراجة النارية.",
        "تتآكل الساندة الجانبية وتتسبب في سقوط الدراجة النارية.",
        "تصطدم الساندة الجانبية بالشارع ومن شأنها أن تتسبب في انقلاب الدراجة النارية وراكبها.",
        "ذلك يسبب ضرراً للشارع وللبنى التحتية الأخرى."
      ],
      id: 1497
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1011. ما هو جهاز السلامة من نوع وسائد الهواء المنتفخة (SRS)؟",
      numQues: "1011",
      correctAnswer: "هو جهاز يحفظ توازن المركبة في الانعطافات الخطرة.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "هو جهاز لتخفيف الإصابات عن ركاب المركبة، بواسطة انتفاخ وسائد الهواء عند الاصطدام.",
        "هو جهاز يقوم بتبريد الفرامل أثناء فرملة الطوارئ.",
        "هو جهاز وسائد هواء خارجية تنتفخ لكي تحسن من جودة السفر.",
        "هو جهاز يحفظ توازن المركبة في الانعطافات الخطرة."
      ],
      id: 1498
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0926. كيف تتصرف حسب الظاهر في الصورة؟",
      numQues: "0926",
      correctAnswer: "استعمل الزامور بشكلٍ متواصل لتنبيه المشاة من اجل أن تتأكد بأنهم سوف يمكنوك من متابعة سيرك.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3926.jpg",
      choices: [
        "تمهل وواصل سيرك، حسب نظرة المشاة، عرفوا أن في نيتك مواصلة السير.",
        "تمهل واستعد للتوقف،مشاة يقطعون الشارع، دعهم يكملون العبور.",
        "أنهى المشاة العبور تقريباً، تابع سيرك كالمعتاد وتجاوزهم بحذر.",
        "استعمل الزامور بشكلٍ متواصل لتنبيه المشاة من اجل أن تتأكد بأنهم سوف يمكنوك من متابعة سيرك."
      ],
      id: 1499
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0289. ماذا ينص القانون بالنسبة لملء الوقود لمركبة ركاب تنقل أكثر من 11 راكباً؟",
      numQues: "0289",
      correctAnswer: "ممنوع ملء الوقود في المركبة طالما كان فيها ركاب.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مسموح الملء الذاتي للوقود.",
        "مسموح ملء الوقود بشرط أن تكون هناك مطفأة حريق بالقرب من المركبة.",
        "مسموح ملء الوقود إذا كانت المركبة تقف بجانب محطة إطفاء حريق.",
        "ممنوع ملء الوقود في المركبة طالما كان فيها ركاب."
      ],
      id: 1500
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0150. ما هي السرعة القصوى المسموح بها لمركبة ركاب خصوصية في طريق سريعة (إذا لم تنصب إشارة تأمر بسرعة أخرى)؟",
      numQues: "0150",
      correctAnswer: "110كم/ساعة.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3139.jpg",
      choices: [
        "80كم/ساعة.",
        "100كم/ساعة.",
        "90كم/ساعة.",
        "110كم/ساعة."
      ],
      id: 1501
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0164. هل يجب إعطاء الإشارة عند الانحراف عن مسلك السير إلى اليمين أو إلى اليسار؟",
      numQues: "0164",
      correctAnswer: "لا يوجد واجب بإعطاء الإشارة إذا كان الانحراف مهم ويشاهده جميع السائقين. ",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "يجب إعطاء الإشارة عند كل انحراف عن مسلك السير، ولغاية إكماله.",
        "لا يوجد واجب بإعطاء الإشارة عند الانحراف من مسلك إلى آخر.",
        "عند الانحراف غير الهام لا يوجد واجب بإعطاء الإشارة.",
        "لا يوجد واجب بإعطاء الإشارة إذا كان الانحراف مهم ويشاهده جميع السائقين. "
      ],
      id: 1502
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1422. ما هي 'الإنارة المحيطة' حسب أنظمة المرور؟",
      numQues: "1422",
      correctAnswer: "جهاز إنارة غير ثابت في المركبة وله سلاسل مثبت عليها أعلام تبعد عن بعضها البعض 50سم على الأقل.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مصابيح باللون الأخضر والمثبتة على جوانب المركبة الطويلة.",
        "جهاز إنارة ثابت على جوانب المركبة الطويلة.",
        "جهاز إنارة بواسطة مصابيح نورها اصفر مرتبة حول الحمولة البارزة، والمسافة بين كل مصباح وآخر 100سم أو اقل.",
        "جهاز إنارة غير ثابت في المركبة وله سلاسل مثبت عليها أعلام تبعد عن بعضها البعض 50سم على الأقل."
      ],
      id: 1503
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1081. أية أنواع سوائل يجب على السائق فحصها في المركبة؟",
      numQues: "1081",
      correctAnswer: "مستوى الزيت في الكلاتش ومستوى زيت المحرك.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مستوى زيت المحرك ومستوى سائل التبريد ومستوى سائل الفرامل ومستوى سائل تنظيف الزجاج.",
        "مستوى زيت المقود ومستوى الزيت في صندوق الكلاتش.",
        "مستوى سائل الفرامل وكمية الغاز في جهاز تكييف الهواء.",
        "مستوى الزيت في الكلاتش ومستوى زيت المحرك."
      ],
      id: 1504
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0440. كيف تتصرف حسب الإشارة ؟",
      numQues: "0440",
      correctAnswer: "تابع سيرك وانتبه لتصرفات المركبات من اليمين.",
      pubDate: "10-11-2011 08:23:10",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3439.jpg",
      choices: [
        "زد من السرعة وتجاوز المركبات التي تسير ببطء في الطريق.",
        "أطع أوامر العمال في الشارع وتقدم حسب الإشارات.",
        "استعد لإمكانية التمهل وانتبه لازدحام حركة السير ولائم سرعة سيرك لحركة السير ولوضع الطريق.",
        "تابع سيرك وانتبه لتصرفات المركبات من اليمين."
      ],
      id: 1505
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1796. هل يُسمح بنقل راكب على الدراجة النارية عندما تكون رِجلا (القدمين) الراكب في جانب واحد من الدراجة النارية؟",
      numQues: "1796",
      correctAnswer: "مسموح، فقط عند السير في شارع داخل المدن.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "مسموح، عندما تسير فقط.",
        "ممنوع، مسموح نقل راكب على الدراجة النارية عندما تكون كلا الرِجلين على جانبي الدراجة النارية.",
        "مسموح، فقط عند السير في شارع خارج المدن.",
        "مسموح، فقط عند السير في شارع داخل المدن."
      ],
      id: 1506
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0614. 'نقل التلاميذ' في الباص هو:",
      numQues: "0614",
      correctAnswer: "نقل أولاد لغاية عمر 16 سنة في الباص.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "نقل الأولاد إلى المدرسة أو لأية نشاطات منظمة في مركبة مُعدة لنقل التلاميذ.",
        "أي نقل مجموعة من الأولاد في الباص وحتى على خط الخدمة.",
        "أي نقل للأولاد أو للطلاب في الباص.",
        "نقل أولاد لغاية عمر 16 سنة في الباص."
      ],
      id: 1507
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1750. عندما يضيء ضوء اصفر ثابت (غير متقطع) في الإشارة الضوئية:",
      numQues: "1750",
      correctAnswer: "هذا معناه انه سيظهر حالاً الضوء الأحمر، يجب الاستعداد للتوقف أو لإخلاء المفترق الذي دخلته فوراً.",
      pubDate: "10-11-2011 08:23:10",
      img: "",
      choices: [
        "هذا معناه أنه سيظهر حالاً الضوء الأخضر المتقطع، يجب زيادة سرعة السير وإخلاء المفترق فوراً.",
        "هذا معناه أنه سيظهر حالاً الضوء الأصفر المتقطع، يجب زيادة سرعة السير وإخلاء المفترق فوراً.",
        "هذا معناه انه سيظهر حالاً الضوء الأخضر الثابت (غير متقطع) وتستطيع الاستمرار بالسير.",
        "هذا معناه انه سيظهر حالاً الضوء الأحمر، يجب الاستعداد للتوقف أو لإخلاء المفترق الذي دخلته فوراً."
      ],
      id: 1508
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0840. ما هي الأخطار المتوقعة عند السياقة في طريق جبلية؟",
      numQues: "0840",
      correctAnswer: "سخونة محرك المركبة نتيجة للاستعمال المفرط للفرامل.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "سخونة زائدة للإطارات.",
        "تحرر العجل بسبب الانحدار الشديد في الشارع.",
        "فقدان صلاحية الفرملة والتصادم وجهاً لوجه والنزول عن الشارع.",
        "سخونة محرك المركبة نتيجة للاستعمال المفرط للفرامل."
      ],
      id: 1509
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1232. هل يعتبر الباص مكاناً عاماً في نظر قانون منع التدخين في الأماكن العامة؟",
      numQues: "1232",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "فقط عندما يكون فيه أكثر من 15 راكب.",
        "نعم، فقط عندما يكون فيه أكثر من 10 ركاب.",
        "نعم.",
        "كلا."
      ],
      id: 1510
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0579. ما معنى الإشارة؟",
      numQues: "0579",
      correctAnswer: "سر باتجاه السهم الأبيض، يمنع السير في الاتجاه المعاكس للآخرين.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3579.jpg",
      choices: [
        "أعطِ حق الأولوية في الطريق الضيقة لحركة السير القادمة من الاتجاه المعاكس. ",
        "ممنوع الرجوع إلى الخلف.",
        "لك حق الأولوية في الطريق الضيقة بالنسبة لحركة السير القادمة من الاتجاه المعاكس.",
        "سر باتجاه السهم الأبيض، يمنع السير في الاتجاه المعاكس للآخرين."
      ],
      id: 1511
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1231. ما هي القاعدة بالنسبة لنقل رُزم في الباص؟",
      numQues: "1231",
      correctAnswer: "مسموح نقل رزم إذا كانت لا تعيق الركاب ولا تسبب لهم ضرر.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "مسموح نقل رزم إذا قرر صاحب الرخصة استغلال نصف الباص لنقل الحمولة.",
        "مسموح نقل رزم فيها مواد خطرة، بشرط أن تكون مغلفة جيداً وموضوعة في صندوق حمولة الباص.",
        "مسموح نقل حمولة لها علاقة بمصدر رزق المسافر.",
        "مسموح نقل رزم إذا كانت لا تعيق الركاب ولا تسبب لهم ضرر."
      ],
      id: 1512
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "0959. يُلزم القانون عند نقل راكب إضافي على الدراجة النارية:",
      numQues: "0959",
      correctAnswer: "أن يكون عمر الراكب 10 سنوات على الأقل.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "أن تستند رجلا الراكب على الساندتين اللتين على جانبي الدراجة النارية.",
        "أن يكون عمر الراكب 6 سنوات على الأقل.",
        "أن يكون عمر الراكب 12 سنة على الأقل.",
        "أن يكون عمر الراكب 10 سنوات على الأقل."
      ],
      id: 1513
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1602. كيف يؤثر دهان الوسم (التأشير) في الشارع على الدراجة النارية؟",
      numQues: "1602",
      correctAnswer: "من شأن دهان الوسم (التأشير) أن يكون أحياناً ملساً أكثر من الشارع نفسه ومن شأنه زيادة خطر التزحلق.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "الدهان الأبيض على الشارع يبهر نظر راكب الدراجة النارية ويضلله.",
        "الدهان يضر بشكلٍ ملموس بطول عمر إطارات الدراجة النارية.",
        "الدهان الأبيض يرتش في الشتاء على الدراجة النارية نفسها.",
        "من شأن دهان الوسم (التأشير) أن يكون أحياناً ملساً أكثر من الشارع نفسه ومن شأنه زيادة خطر التزحلق."
      ],
      id: 1514
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0563. هل يُسمح لدراجة هوائية بالدخول إلى طريق نُصبت على مدخلها الإشارة؟",
      numQues: "0563",
      correctAnswer: "مسموح في طريق ليست بلدية.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3562.jpg",
      choices: [
        "ممنوع.",
        "مسموح في الطريق البلدية فقط.",
        "مسموح دائماً.",
        "مسموح في طريق ليست بلدية."
      ],
      id: 1515
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1315. ما هو ارتفاع الحمولة الأقصى المسموح بنقلها في مركبة تجارية وزنها الإجمالي من 8000كغم ولغاية 15000كغم؟",
      numQues: "1315",
      correctAnswer: "3.00م.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "4.00م.",
        "3.50م.",
        "3.80م.",
        "3.00م."
      ],
      id: 1516
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1493. إذا كانت الرؤية في الطريق محدودة، على سائق المركبة:",
      numQues: "1493",
      correctAnswer: "إضاءة الضوء العالي لكي يزيد مدى الرؤية ولتحذير القادمين من الجهة المقابلة.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "التمهل في شارع باتجاهين والسير كالمعتاد في طريق باتجاه واحد.",
        "الإسراع وإضاءة أضواء الوقوف لكي يمنع الاصطدام مع المركبة التي تسير خلفه.",
        "التمهل وملاءمة السرعة لمدى الرؤية وإضاءة الأضواء الواطئة.",
        "إضاءة الضوء العالي لكي يزيد مدى الرؤية ولتحذير القادمين من الجهة المقابلة."
      ],
      id: 1517
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1130. ما هو عدد الركاب الذي يجوز لسائق الباص نقله؟",
      numQues: "1130",
      correctAnswer: "لغاية 50 راكب جالسين وأيضاً 10 واقفين.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "عدد الركاب المسجل في رخصة المركبة (إذا ذُكر عدد كهذا).",
        "لغاية 70 راكباً.",
        "لغاية 70 ولداً.",
        "لغاية 50 راكب جالسين وأيضاً 10 واقفين."
      ],
      id: 1518
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0305. هل يُقبَل 'فحص الكحول' في الدم بواسطة جهاز الزفير (فحص بواسطة النفخ) كبينة (دليل) في المحكمة؟",
      numQues: "0305",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "كلا، يُقبل فقط فحص الدم في المحكمة.",
        "كلا، يُقبل كبينة فقط فحص الكحول الذي تم إجراءه في المستشفى.",
        "كلا، يُقبل فقط فحص اللعاب كبينة (دليل) دقيقة في المحكمة.",
        "نعم."
      ],
      id: 1519
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0651. في مسلك سيرك موسوم (مرسوم) على الشارع السهم الظاهر في الإشارة، ما معنى السهم؟",
      numQues: "0651",
      correctAnswer: "يجب الاستدارة إلى اليسار من هذا المسلك في المفترق القريب.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3651.jpg",
      choices: [
        "انتقل إلى المسلك الأيسر الآن.",
        "مسموح التجاوز من اليسار.",
        "عليك الانتقال إلى المسلك الذي على اليسار.",
        "يجب الاستدارة إلى اليسار من هذا المسلك في المفترق القريب."
      ],
      id: 1520
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0842. كيف نمنع تصادماً وجهاً لوجه عند السياقة في طريق جبلية ضيقة وملتوية؟",
      numQues: "0842",
      correctAnswer: "يجب السياقة بجوار خط الوسط.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3839.jpg",
      choices: [
        "ينبغي السياقة بغيار عالي والتقليل من استعمال الفرامل لمنع فقدان صلاحية الفرامل في المركبة.",
        "نسير على أقصى يمين الشارع ونضيء الأنوار ونلائم السرعة لوضع الطريق.",
        "نتمهل ونستعمل الزامور لمدة طويلة ومستمرة قبل كل منعطف في الطريق.",
        "يجب السياقة بجوار خط الوسط."
      ],
      id: 1521
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1312. ما هو عرض الحمولة التي من اجل نقلها يجب الحصول على إذن من ضابط الشرطة؟",
      numQues: "1312",
      correctAnswer: "عرض حمولة لغاية 3.00م. ",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "عرض حمولة لغاية 3.40م. ",
        "عرض حمولة يزيد عن 3.40م. ",
        "عرض حمولة لغاية 3.20م. ",
        "عرض حمولة لغاية 3.00م. "
      ],
      id: 1522
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0171. في أية حالات يُسمح بإعطاء إشارة تنبيه بواسطة الزامور في طريق داخل المدن؟",
      numQues: "0171",
      correctAnswer: "مسموح استعمال الزامور في جميع الحالات شريطة أن يكون بشكل متواصل وموحد.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "مسموح فقط بواسطة زامور هوائي.",
        "مسموح استعمال الزامور فقط من اجل تجنب خطر لا يمكن تجنبه بطريقةٍ أخرى.",
        "مسموح استعمال الزامور في طريق داخل المدن في جميع الحالات.",
        "مسموح استعمال الزامور في جميع الحالات شريطة أن يكون بشكل متواصل وموحد."
      ],
      id: 1523
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0793. ما هي 'الاستدارة للسير في الاتجاه المعاكس' (حذوة فرس)؟",
      numQues: "0793",
      correctAnswer: "استدارة يسير فيها السائق في دوار سير فقط ويعود إلى الشارع الذي أتى منه.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "الاستدارة التي ينتج عنها أن يعود سائق المركبة للاتجاه الذي وصل منه (يستدير ويسير في الاتجاه المعاكس). ",
        "استدارة ليست بزاوية قائمة تُدعى استدارة للسير في الاتجاه المعاكس (حذوة فرس).",
        "استدارة ينفذ فيها السائق دوران 360 درجة.",
        "استدارة يسير فيها السائق في دوار سير فقط ويعود إلى الشارع الذي أتى منه."
      ],
      id: 1524
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0523. أية إشارة تسمح بالاستدارة للسير في الاتجاه المعاكس (حذوة فرس) فقط؟",
      numQues: "0523",
      correctAnswer: "210",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3523.jpg",
      choices: [
        "303",
        "209",
        "212",
        "210"
      ],
      id: 1525
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1706. متى تضيء لمبة تحذير زرقاء في لوحة الساعات (التابلو)؟",
      numQues: "1706",
      correctAnswer: "عندما تكون أضواء الوقوف مضاءة. ",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "عندما تكون الأضواء العالية مضاءة.",
        "عندما تكون الأضواء الواطئة مضاءة.",
        "عندما تكون أضواء الضباب مضاءة. ",
        "عندما تكون أضواء الوقوف مضاءة. "
      ],
      id: 1526
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0457. كيف تتصرف حسب الإشارة؟",
      numQues: "0457",
      correctAnswer: "استعد للتوقف قبل المفترق.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3456.jpg",
      choices: [
        "تمهل حتى إمكانية التوقف قبل الملتقى.",
        "إذا كانت أضواء الحاجز متقطعة، زد السرعة واعبر ملتقى تقاطع الطرق.",
        "قف قبل خط السكة في جميع الأحوال.",
        "استعد للتوقف قبل المفترق."
      ],
      id: 1527
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0862. ما هو الشيء الذي يجب علينا التأكد منه قبل البدء بسياقة المركبة؟",
      numQues: "0862",
      correctAnswer: "من أنه يوجد في المركبة لمبات وفيوزات احتياطية.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "من أن الوقود والزيوت من النوع الملائم للتشغيل الصحيح للمركبة.",
        "من أننا ملمين بتشغيلها واستعمالها.",
        "من أنه تم عمل كل عناية مطلوبة للمركبة من اجل صيانتها الدورية. ",
        "من أنه يوجد في المركبة لمبات وفيوزات احتياطية."
      ],
      id: 1528
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0878. المركبة ذات اللون الفضي (1) تخرج من الموقف بواسطة الرجوع إلى الخلف، كيف تتصرف؟",
      numQues: "0878",
      correctAnswer: "تمهل (2) واستعد للتوقف.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3878.jpg",
      choices: [
        "أغلق مسلك سير المركبة الفضية ودع المركبة الحمراء تخرج.",
        "استعمل الزامور وأعطِ ضوء متقطع من مصابيح المقدمة واستمر في سيرك.",
        "انحرف إلى المسلك المعاكس وواصل سيرك كالمعتاد.",
        "تمهل (2) واستعد للتوقف."
      ],
      id: 1529
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0662. ما معنى الوسم (التأشير) على سطح الشارع (مكان فيه خليج وأحجار حافة)؟",
      numQues: "0662",
      correctAnswer: "مكان وقوف للمركبات التي تسير على عجلتين.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3662.jpg",
      choices: [
        "مكان مسموح فيه التوقف فقط للمركبات غير الميكانيكية.",
        "التوقف مسموح لنوع معين من المركبات ، والمذكورة في الإشارة التي نُصبت في المكان.",
        "مسموح التوقف داخل المساحة الموسومة (المؤشرة) لجميع أنواع المركبات.",
        "مكان وقوف للمركبات التي تسير على عجلتين."
      ],
      id: 1530
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0625. إلى ماذا تشير الإشارة؟",
      numQues: "0625",
      correctAnswer: "مقصف (كافتيريا) أو مقهى.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3625.jpg",
      choices: [
        "مصنع لصب الزجاج.",
        "مخيم طرق.",
        "مراحيض عامة.",
        "مقصف (كافتيريا) أو مقهى."
      ],
      id: 1531
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1166. ما هي تعرفة استدعاء الطلب بموجب العداد؟",
      numQues: "1166",
      correctAnswer: "تعرفة السفر 2 في عطل الأعياد.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "تعرفة السفر 1 في عطل الأعياد.",
        "تعرفة السفر 1 بإضافة 15% في الليل.",
        "التعرفة من مكان خروج الصالون العمومي ولغاية مكان طالب السفرة.",
        "تعرفة السفر 2 في عطل الأعياد."
      ],
      id: 1532
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0138. ما هي المسافة الدنيا التي يجب عليك المحافظة عليها بينك وبين المركبة التي تسير أمامك، حسب القانون ؟",
      numQues: "0138",
      correctAnswer: "مسافة تقطعها المركبة في ثلاث ثواني على الأقل (حسب طريقة 21...، 22....23.).",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3138.jpg",
      choices: [
        "مسافة تقطعها المركبة في ثانية واحدة على الأقل.",
        "مسافة تقطعها المركبة في ثانيتين على الأقل.",
        "22م على الأقل.",
        "مسافة تقطعها المركبة في ثلاث ثواني على الأقل (حسب طريقة 21...، 22....23.)."
      ],
      id: 1533
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1363. في أية مركبة استوجب وقوفها في طريق ليست بلدية وفي 'وقت الإنارة'، يجب تشغيل مصابيح الطوارئ أو وضع مصباح يضيء بضوء اصفر متقطع؟",
      numQues: "1363",
      correctAnswer: "كل مركبة ما عدا المركبة الخصوصية والمركبة المعدة لنقل الركاب.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "كل شاحنة وزنها الإجمالي المسموح به أكثر من 12000كغم.",
        "مركبة تجارية ومركبة عمل والباص وزنها الإجمالي المسموح به أكثر من 3500كغم.",
        "مركبة تجارية وزنها الإجمالي أكثر من 3000كغم وأيضاً الباص.",
        "كل مركبة ما عدا المركبة الخصوصية والمركبة المعدة لنقل الركاب."
      ],
      id: 1534
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0061. هل هناك واجب بإطاعة أوامر شرطي اثبت شخصيته بواسطة شهادة تعيين؟",
      numQues: "0061",
      correctAnswer: "نعم، لمقتضى توجيه حركة السير في المفترق فقط.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "كلا، يجب فقط إطاعة شرطي سير عند توجيه حركة السير في المفترق.",
        "بشكلٍ عام، كلا.",
        "نعم، حتى ولو كانت الأوامر مخالفة لأحكام إشارة سير.",
        "نعم، لمقتضى توجيه حركة السير في المفترق فقط."
      ],
      id: 1535
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0691. إذا كانت الإشارات أو العلامات على سطح الطريق مدهونة باللون البرتقالي؟",
      numQues: "0691",
      correctAnswer: "تشير إلى موقع أشغال في الطريق.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "هذه إشارات أو علامات مرسومة في مقاطع طرق فيها خطر لم تُحدد له إشارة خاصة.",
        "هذه إشارات بلونٍ خاص مُعد لإظهار حالات طقس خاصة.",
        "هذه إشارات مؤقتة في طريق ليست بلدية فقط ومفعولها محدود لثلاثة أشهر.",
        "تشير إلى موقع أشغال في الطريق."
      ],
      id: 1536
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1743. إذا تم وسم (تأشير) الشارع بخط فاصل متواصل وعلى يساره خط متقطع:",
      numQues: "1743",
      correctAnswer: "ذلك غير ممكن: يظهر الخط المتقطع فقط على يمين الخط الفاصل الأبيض.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "خط متواصل مع خط متقطع على يساره هو مساحة فاصلة.",
        "مسموح عبور الخط المتواصل من اجل التجاوز فقط.",
        "ممنوع عبور الخطوط.",
        "ذلك غير ممكن: يظهر الخط المتقطع فقط على يمين الخط الفاصل الأبيض."
      ],
      id: 1537
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0584. لغاية أي مكان يسري مفعول الإشارة؟",
      numQues: "0584",
      correctAnswer: "لغاية المفترق القريب أو لغاية المكان الذي يُمنع فيه الوقوف.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3583.jpg",
      choices: [
        "لغاية الإشارة 'نهاية الطريق البلدية'.",
        "لغاية الإشارة التي تمنع الدخول.",
        "لغاية طريق التحويل القريبة.",
        "لغاية المفترق القريب أو لغاية المكان الذي يُمنع فيه الوقوف."
      ],
      id: 1538
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0950. عندما تهطل أمطار غزيرة:",
      numQues: "0950",
      correctAnswer: "مسموح إضاءة مصابيح الضباب",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "مسموح إضاءة الضوء العالي.",
        "مسموح إضاءة غمازات الطوارئ الصفراء.",
        "يجب السير بسرعة لا تزيد عن نصف السرعة القصوى المسموح بها.",
        "مسموح إضاءة مصابيح الضباب"
      ],
      id: 1539
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1712. لا تصدر ولا تُجدد رخصة مركبة لصالون عمومي:",
      numQues: "1712",
      correctAnswer: "بعد انقضاء 4 سنوات على سنة إنتاجها.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "بعد انقضاء 12 سنة على سنة إنتاجها.",
        "بعد انقضاء 8 سنوات على سنة إنتاجها.",
        "بعد انقضاء 10 سنوات على سنة إنتاجها.",
        "بعد انقضاء 4 سنوات على سنة إنتاجها."
      ],
      id: 1540
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0433. كيف تتصرف حسب الإشارة ؟",
      numQues: "0433",
      correctAnswer: "تجاهل الإشارة، هذه الإشارة تُلزم سائقي المركبات العمومية فقط.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3432.jpg",
      choices: [
        "تابع سيرك بحذر، واعمل حسب الضوء الظاهر في الإشارة الضوئية (الرمزور).",
        "زد من سرعة سيرك إذا ظهر الضوء الأصفر في الإشارة.",
        "توقف دائماً قبل المفترق المنصوبة فيه إشارات ضوئية (رمزورات).",
        "تجاهل الإشارة، هذه الإشارة تُلزم سائقي المركبات العمومية فقط."
      ],
      id: 1541
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1689. عند السير في ساعات النهار وتعطل ضوء المقدمة العالي في الدراجة النارية، فكيف يجب التصرف؟",
      numQues: "1689",
      correctAnswer: "مسموح الاستمرار بالسير فقط خلف مركبة أخرى مصابيحها صالحة.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "مسموح الاستمرار بالسير حتى حلول الظلام فقط.",
        "مسموح الاستمرار بالسير فقط في طريق بلدية مضاءة كما ينبغي وبسرعة بطيئة.",
        "يمنع القانون الاستمرار بالسير وحتى في النهار إذا لم تكن شبكة الإنارة صالحة تماماً.",
        "مسموح الاستمرار بالسير فقط خلف مركبة أخرى مصابيحها صالحة."
      ],
      id: 1542
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1766. ممنوع توقف ووقوف وإيقاف مركبة على ممر مشاة أو قبله بحدود:",
      numQues: "1766",
      correctAnswer: "20م.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "12م.",
        "24م.",
        "15م.",
        "20م."
      ],
      id: 1543
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0674. كيف تتصرف عندما تضيء أضواء حمراء متقطعة في الإشارة الضوئية (الرمزور) في الصورة ؟",
      numQues: "0674",
      correctAnswer: "توقف دائماً قبل ملتقى سكة الحديد، ولا تواصل السير طالما كانت الأضواء متقطعة.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3674.jpg",
      choices: [
        "تقدم – مسموح السير إلى الأمام إذا كانت الطريق خالية. ",
        "اعبر الملتقى بالسير البطيء.",
        "مسموح الاستمرار بالسير إلى الأمام بحذر، بعد التوقف.",
        "توقف دائماً قبل ملتقى سكة الحديد، ولا تواصل السير طالما كانت الأضواء متقطعة."
      ],
      id: 1544
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0351. 'وقت الإنارة' في القانون هو:",
      numQues: "0351",
      correctAnswer: "الليل وكل وقت آخر تكون فيه الرؤية مشوشة.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "فترة الوقت من غروب الشمس وحتى شروقها فقط.",
        "فترة الوقت من شروق الشمس وحتى غروبها.",
        "الليل وكل وقت آخر تكون فيه الرؤية جيدة.",
        "الليل وكل وقت آخر تكون فيه الرؤية مشوشة."
      ],
      id: 1545
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0760. ما هي أخطار انحرافك الفجائي من مسلك إلى مسلك في الشارع؟",
      numQues: "0760",
      correctAnswer: "خطر إصابة المركبة التي لم تراها قبل الانحراف.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "إذا كان الانحراف يعرقل كثير من السائقين.",
        "إذا استمر الانحراف فترة طويلة.",
        "إذا وصلت بسبب الانحراف إلى مسلك لا يجوز لك أن تكون فيه.",
        "خطر إصابة المركبة التي لم تراها قبل الانحراف."
      ],
      id: 1546
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1555. من اجل تجنب صدم المركبة التي توقفت فجأةً أمامك:",
      numQues: "1555",
      correctAnswer: "حاول تجاوزها لكي تبقيها في الخلف.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "ضع الرجل على دعسة فرملة الرجل بشكلٍ دائم لكي تتمكن أنت أيضاً من التوقف إذا اقتضت الضرورة.",
        "توقف فوراً عندما تشاهد نور الفرملة للمركبة التي أمامك دون أية علاقة بالبعد عنه.",
        "حافظ دائماً على مسافة كافية من المركبة التي أمامك (حسب طريقة المحافظة على مسافة 21،22...).",
        "حاول تجاوزها لكي تبقيها في الخلف."
      ],
      id: 1547
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1646. الاستعمال المتواصل لفرامل المركبة في منحدر شديد ومتواصل، من شأنه أن يسبب:",
      numQues: "1646",
      correctAnswer: "في تبريد زائد عن الحد للفرامل وفي فرملة اضعف من المطلوب.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "للاستعمال المتواصل للفرامل لا يوجد أي تأثير على الفرملة. ",
        "في سخونة الفرامل وفي فرملة قوية أكثر من المطلوب.",
        "في سخونة زائدة للفرامل وفي فرملة ضعيفة مقارنةً بالوضع الطبيعي.",
        "في تبريد زائد عن الحد للفرامل وفي فرملة اضعف من المطلوب."
      ],
      id: 1548
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0238. ما هو عدد الركاب الأقصى المسموح بنقلهم في مركبة تجارية موحدة لا يزيد وزنها الإجمالي عن3500كغم؟",
      numQues: "0238",
      correctAnswer: "كما سجل في رخصة المركبة وليس أكثر من ثمانية ركاب إضافةً إلى السائق",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "راكب واحد بجانب السائق وثلاثة ركاب في الخلف.",
        "كما ذُكر في رخصة السياقة، إذا ذُكر.",
        "راكبين بجانب السائق وأربعة ركاب في الخلف.",
        "كما سجل في رخصة المركبة وليس أكثر من ثمانية ركاب إضافةً إلى السائق"
      ],
      id: 1549
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0383. أية إشارة تُنصب بالإضافة إلى الإشارة رقم: 216؟",
      numQues: "0383",
      correctAnswer: "407",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3383.jpg",
      choices: [
        "424",
        "418",
        "218",
        "407"
      ],
      id: 1550
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "0992. ما هي وظيفة جهاز ال- 'أي.بي.أس' (ABS)؟",
      numQues: "0992",
      correctAnswer: "لتمكين السيطرة على المركبة والمقود أثناء الفرملة.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "لمنع اهتراء الإطارات.",
        "لمنع الاستعمال الزائد لفرامل المركبة.",
        "لاستعماله كفرملة إضافية وقت الخطر.",
        "لتمكين السيطرة على المركبة والمقود أثناء الفرملة."
      ],
      id: 1551
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1307. ما معنى الإشارة؟",
      numQues: "1307",
      correctAnswer: "انتبه، مكان مرخص للرماية.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31307.jpg",
      choices: [
        "مكان وقوف مرخص للمركبات العمومية.",
        "أنت تقترب لمحطة قطارات محلية.",
        "مركز المدينة أو مركز البلدة أو مركز المنطقة.",
        "انتبه، مكان مرخص للرماية."
      ],
      id: 1552
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1129. ما هي درجة الرخصة المطلوبة لسياقة باص ومركبة صحراويه يزيد وزنها الإجمالي المسموح به عن 3,500كغم.",
      numQues: "1129",
      correctAnswer: "B.",
      pubDate: "10-11-2011 08:23:11",
      img: "",
      choices: [
        "A1.",
        "D.",
        "A2.",
        "B."
      ],
      id: 1553
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0180. كيف تتصرف حسب الوضع الظاهر في الصورة التي أمامك؟",
      numQues: "0180",
      correctAnswer: "اعبر المكان بسرعة واندمج مع حركة السير.",
      pubDate: "10-11-2011 08:23:11",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3180.jpg",
      choices: [
        "أعطِ حق الأولوية لحركة السير في الشارع الذي على يسارك.",
        "تمهل من اجل إعطاء حق الأولوية للمركبة التي على اليمين.",
        "قف وأعطِ حق الأولوية.",
        "اعبر المكان بسرعة واندمج مع حركة السير."
      ],
      id: 1554
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0665. ما معنى الضوء الظاهر في الإشارة الضوئية (الرمزور)؟",
      numQues: "0665",
      correctAnswer: "يجوز لك مواصلة سيرك بعد تأكدك من خلو المفترق.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3608.jpg",
      choices: [
        "استمر في سيرك: سيظهر الضوء الأخضر حالاً.",
        "توقف – لا تستمر بالسير طالما يضيء الضوء الأحمر.",
        "زد من سرعة سيرك قبل المفترق مع الإشارات الضوئية (الرمزورات)، لكي تعبر قبل أن يتغير الضوء في الإشارة الضوئية.",
        "يجوز لك مواصلة سيرك بعد تأكدك من خلو المفترق."
      ],
      id: 1555
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0784. كيف يستدير السائق إلى اليسار من شارع باتجاهين (أ) إلى شارع باتجاه واحد (ب)؟",
      numQues: "0784",
      correctAnswer: "من المسلك (2) إلى أي مسلك (5) أو (6) أو (7).",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3784.jpg",
      choices: [
        "من المسلك (1) أو المسلك (2) إلى أي مسلك (5) أو (6) أو (7).",
        "من المسلك (1) إلى المسلك (5).",
        "من المسلك (2) إلى المسلك (5).",
        "من المسلك (2) إلى أي مسلك (5) أو (6) أو (7)."
      ],
      id: 1556
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1090. كيف يجب التصرف عند انقلاب التراكتور؟",
      numQues: "1090",
      correctAnswer: "طلب مساعدة ومحاولة حفظ توازن التراكتور أثناء انقلابه. ",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "فرملة التراكتور ومحاولة التقليل من قوة الانقلاب.",
        "مسك المقود بشدة والالتصاق به على قدر الإمكان. ",
        "القفز من التراكتور بأسرع ما يمكن عند بدء الانقلاب.",
        "طلب مساعدة ومحاولة حفظ توازن التراكتور أثناء انقلابه. "
      ],
      id: 1557
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0539. ما معنى الإشارة؟",
      numQues: "0539",
      correctAnswer: "استدارة إلى اليسار وثم إلى اليمين.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3539.jpg",
      choices: [
        "طريق ملتوية.",
        "سر إلى اليمين واستدر من أمام الإشارة.",
        "سر اليمين، واستدر من خلف الإشارة.",
        "استدارة إلى اليسار وثم إلى اليمين."
      ],
      id: 1558
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1552. هل يُسمح بالسياقة تحت تأثير مشروبات كحولية مسكرة؟",
      numQues: "1552",
      correctAnswer: "ممنوع منعاً باتاً.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "مسموح فقط بعد مناسبات عائلية وفقط لمسافة قصيرة.",
        "مسموح، إذا لم تكن هناك مواصلات عمومية في ذلك اليوم.",
        "مسموح بشرط أن لا يخلط السائق أنواع المشروبات.",
        "ممنوع منعاً باتاً."
      ],
      id: 1559
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0541. هل يُسمح بتنفيذ استدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار في المكان الذي نُصبت فيه الإشارة؟",
      numQues: "0541",
      correctAnswer: "مسموح، ما لم تكن هناك إشارة أخرى تمنع ذلك.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3541.jpg",
      choices: [
        "مسموح في جميع الأحوال حتى ولو كانت هناك إشارة تمنع الاستدارة للسير في الاتجاه المعاكس (حذوة فرس).",
        "ممنوع في جميع الأحوال.",
        "مسموح في مفترق فيه إشارات ضوئية وممنوع في مفترق لا توجد فيه إشارات ضوئية.",
        "مسموح، ما لم تكن هناك إشارة أخرى تمنع ذلك."
      ],
      id: 1560
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0316. 'شرب الكحول يؤثر سلبياً على حدة الرؤية'، صحيح أم غير صحيح؟",
      numQues: "0316",
      correctAnswer: "غير صحيح.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "صحيح في الليل فقط",
        "هذا صحيح بالنسبة لمن يستعمل النظارات فقط.",
        "صحيح.",
        "غير صحيح."
      ],
      id: 1561
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0500. ما معنى الإشارة؟",
      numQues: "0500",
      correctAnswer: "نهاية مقطع الطريق الذي يسري عليه منع التجاوز.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3386.jpg",
      choices: [
        "نهاية مقطع طريق ليست بلدية.",
        "نهاية مقطع طريق بلدية.",
        "نهاية مقطع الطريق التي يجوز فيها للشاحنات بأن تسير على حاشية الطريق.",
        "نهاية مقطع الطريق الذي يسري عليه منع التجاوز."
      ],
      id: 1562
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1100. ما هي قاعدة السلامة الأكثر أهمية عند تشغيل ناقل القوة'بي.تي.أو' (PTO) ؟",
      numQues: "1100",
      correctAnswer: "يُمنع التواجد بالقرب من الأجزاء المتحركة في التراكتور أو الأجهزة.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "يجب تشغيل ناقل القوة عندما يكون المحرك ساخناً بالفعل.",
        "يُمنع تشغيل ناقل القوة أثناء السير إلا عند الوقوف فقط. ",
        "يُمنع تشغيل ناقل القوة بدون مراقبة مُشغِل أضافي على الطريق.",
        "يُمنع التواجد بالقرب من الأجزاء المتحركة في التراكتور أو الأجهزة."
      ],
      id: 1563
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0153. في الطريق التي أمامك نُصبت الإشارة الظاهرة في الصورة، ما هو معناها؟",
      numQues: "0153",
      correctAnswer: "هذا تحديد سرعة مُعد للمركبات العمومية فقط.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3153.jpg",
      choices: [
        "ممنوع سياقة مركبة بسرعة اقل من 40كم/ساعة.",
        "ممنوع سياقة مركبة بسرعة تزيد عن 40كم/ساعة.",
        "هذا تحديد سرعة مُعد لمركبة تسير على عجلتين ولماكنة متنقلة ولعربة يد.",
        "هذا تحديد سرعة مُعد للمركبات العمومية فقط."
      ],
      id: 1564
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»"
      ],
      title: "0136. متى يجب على سائق المركبة السير على حاشية الطريق المعبدة بالإسفلت؟",
      numQues: "0136",
      correctAnswer: "إذا كان يسوق مركبة ميكانيكية تجارية يزيد وزنها الإجمالي المسموح به عن 10000كغم.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "إذا كان يسوق مركبة ميكانيكية واضطر أن يسير بسرعة بطيئة بسبب حمولتها أو بسبب انحدار الطريق.",
        "إذا كان يسوق باص يزيد وزنه الإجمالي المسموح به عن 10000كغم.",
        "ولا مرة. حسب القانون، ممنوع السير على حاشية الطريق في جميع الأحوال.",
        "إذا كان يسوق مركبة ميكانيكية تجارية يزيد وزنها الإجمالي المسموح به عن 10000كغم."
      ],
      id: 1565
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0676. ما معنى الإشارة؟",
      numQues: "0676",
      correctAnswer: "ممنوع السير في هذا المسلك.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3676.jpg",
      choices: [
        "مسموح السير في هذا المسلك في الليل فقط. ",
        "انتقل إلى المسلك الذي على اليسار.",
        "مسموح السير في هذا المسلك.",
        "ممنوع السير في هذا المسلك."
      ],
      id: 1566
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«A»",
        "«C1»"
      ],
      title: "1287. كيف يمكن التوفير في استهلاك الوقود في المركبة؟",
      numQues: "1287",
      correctAnswer: "بواسطة السياقة بغيار الواطئ وبسرعات أكثر من 120كم/ساعة بدون إسراع أو تباطؤ حادين.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "بواسطة السياقة بغيار نيوترال في المنحدرات – طالما كان الأمر ممكناً. ",
        "بواسطة السياقة بغيار واطئ وبسرعات أكثر من 90كم/ساعة.",
        "بواسطة السياقة بغيار مناسب وبسرعات معتدلة لغاية 90كم/ساعة.",
        "بواسطة السياقة بغيار الواطئ وبسرعات أكثر من 120كم/ساعة بدون إسراع أو تباطؤ حادين."
      ],
      id: 1567
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1805. أي إشارة معناها موقع تعبئة ( شحن بطارية) مركبة كهربائية؟",
      numQues: "805 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [],
      id: 1568
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1752. في شارع ضيق وعندما لا تستطيع مركبتان قادمتان من اتجاهين معاكسين المرور في نفس الوقت:",
      numQues: "1752",
      correctAnswer: "حق الأولوية للمركبة التي تنقل أكثر من 8 ركاب.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "حق الأولوية لمن يصل أولاً.",
        "حق الأولوية للمركبة السريعة.",
        "على المركبتين الانحراف إلى اليمين على قدر الإمكان وحتى النزول إلى حاشية الطريق.",
        "حق الأولوية للمركبة التي تنقل أكثر من 8 ركاب."
      ],
      id: 1569
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0374. أية إشارة تدل على مكان ملتقى سكة حديد ، خط واحد؟",
      numQues: "0374",
      correctAnswer: "134",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3371.jpg",
      choices: [
        "130",
        "133",
        "128",
        "134"
      ],
      id: 1570
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1161. هل يجوز لسائق صالون عمومي إصعاد راكب إضافي إلى الصالون العمومي، في سفرة تم طلبها من قِبل شخص آخر؟",
      numQues: "1161",
      correctAnswer: "نعم، بشرط أن يدفع الراكب الإضافي نصف أجرة السفر.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "نعم، فقط بموافقة الراكب طالب السفرة وبدون أية أجرة إضافية لغاية الوجهة المحددة.",
        "نعم، ولكن بدون أجرة.",
        "فقط في الليل حسب تحديد التعرفة (2).",
        "نعم، بشرط أن يدفع الراكب الإضافي نصف أجرة السفر."
      ],
      id: 1571
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0432. ما معنى الإشارة؟",
      numQues: "0432",
      correctAnswer: "إشارة متنقلة أمامك.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3432.jpg",
      choices: [
        "زد من السرعة من اجل إخلاء المفترق.",
        "انتبه، أمامك إشارة ضوئية (رمزور).",
        "تابع سيرك بنفس السرعة.",
        "إشارة متنقلة أمامك."
      ],
      id: 1572
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1718. مسموح الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إلى اليسار في مفترق لا يوجد فيه إشارات ضوئية (رمزورات):",
      numQues: "1718",
      correctAnswer: "فقط عند الاستدارة من الجانب الأيمن للشارع وإكمال الاستدارة بدون التوقف أثناء العملية.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "عندما لا تتسبب في عرقلة حركة السير ومدى نظر حر ولا توجد إشارة تمنع ذلك.",
        "فقط إذا كان هناك شخص آخر يوجه السائق.",
        "فقط في مركبة تسير على أكثر من عجلتين.",
        "فقط عند الاستدارة من الجانب الأيمن للشارع وإكمال الاستدارة بدون التوقف أثناء العملية."
      ],
      id: 1573
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0718. كيف تتصرف في المفترق الذي أمامك (المركبة التي أمامك ليست مركبة امن)؟",
      numQues: "0718",
      correctAnswer: "دع المركبة الكبيرة (2) تسير، حق الأولوية للمركبة الكبيرة دائماً.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3718.jpg",
      choices: [
        "ادخل (3) إلى المفترق، لك حق الأولوية في المفترق.",
        "أعطِ حق الأولوية للمركبة الخصوصية (1) وللشاحنة (2).",
        "أعطِ حق الأولوية للمركبة الخصوصية (1).",
        "دع المركبة الكبيرة (2) تسير، حق الأولوية للمركبة الكبيرة دائماً."
      ],
      id: 1574
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0038. هل يجوز نقل ركاب بالأجرة في مركبة ركاب خصوصية ؟",
      numQues: "0038",
      correctAnswer: "ممنوع.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "مسموح إذا كان للمركبة جسم حسب المواصفات مصادق عليه من سلطة الترخيص.",
        "ممنوع إلا بإذن من مصلحة الضرائب.",
        "مسموح إذا تم توقيع عقد بين السائق والراكب.",
        "ممنوع."
      ],
      id: 1575
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0228. هل يجوز النزول من المركبة أو الصعود إليها عندما تكون في حالة سير؟",
      numQues: "0228",
      correctAnswer: "مسموح أثناء النشاط الرياضي وفقط للركاب البالغين.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "ممنوع منعاً باتاً.",
        "مسموح بإذن من ضابط الشرطة.",
        "ممنوع ما عدا الحالة التي لا تُشكل خطراً.",
        "مسموح أثناء النشاط الرياضي وفقط للركاب البالغين."
      ],
      id: 1576
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1355. ما هي 'العجلة الخامسة' في مركبة من نوع 'ساندة'؟",
      numQues: "1355",
      correctAnswer: "مصطلح عامي يُقصد به عجلة المقود.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "جهاز على شكل عجلة معد لرفع كابينة السائق عند صيانة المحرك.",
        "جهاز (صحن) معد لتوصيل المستندة بالساندة.",
        "عجلة احتياطية (سبير) للاستبدال عند حدوث ثقب (بنشر).",
        "مصطلح عامي يُقصد به عجلة المقود."
      ],
      id: 1577
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0976. أية مركبة يجب أن تعطي حق الأولوية حسب الإشارة؟",
      numQues: "0976",
      correctAnswer: "المركبة التي تصل أولاً إلى مقطع الشارع الضيق.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3976.jpg",
      choices: [
        "المركبة البعيدة القادمة من الاتجاه المعاكس.",
        "المركبة القريبة.",
        "المركبة الأولى التي تصل إلى الجسر.",
        "المركبة التي تصل أولاً إلى مقطع الشارع الضيق."
      ],
      id: 1578
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0495. ما معنى الإشارة؟",
      numQues: "0495",
      correctAnswer: "تحديدات في حركة السير على يمين الطريق.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3495.jpg",
      choices: [
        "لك حق الأولوية في الطريق الضيقة.",
        "أمامك حركة سير باتجاهين.",
        "أعطِ حق الأولوية في الطريق الضيقة لحركة السير القادمة من الاتجاه المعاكس.",
        "تحديدات في حركة السير على يمين الطريق."
      ],
      id: 1579
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1209. هل مسموح التدخين في الباص؟",
      numQues: "1209",
      correctAnswer: "مسموح، في القسم الخلفي من الباص فقط.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "ممنوع، وحتى هناك واجب بوضع لافتة تأمر بمنع التدخين في الباص.",
        "مسموح، فقط عندما لا يعمل مكيف الهواء في الباص.",
        "مسموح، في حدود طرق بلدية فقط.",
        "مسموح، في القسم الخلفي من الباص فقط."
      ],
      id: 1580
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0868. ما هي حسنات النظر بعيداً إلى الأمام؟",
      numQues: "0868",
      correctAnswer: "يعطي إمكانية القيام بعمليات أخرى في آنٍ واحد مثل البحث عن عنوان في جهاز تحديد المواقع (GPS).",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "النظر بعيداً يزيد من مسافة الفرملة ويزيد من الأمان.",
        "الاتجاه إلى الأمام هو الاتجاه الوحيد المهم للسائق، لذلك يجب النظر إلى الأمام.",
        "استقبال جميع المعلومات من اجل تخطيط السير حسب وضع الطريق وتجنب المفاجآت.",
        "يعطي إمكانية القيام بعمليات أخرى في آنٍ واحد مثل البحث عن عنوان في جهاز تحديد المواقع (GPS)."
      ],
      id: 1581
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1622. بموجب القانون ، المساحة المضاءة من مصابيح مقدمة المركبة في الليل وفي جو صافي، يجب أن تكون:",
      numQues: "1622",
      correctAnswer: "بالضوء العالي – على الأقل 150م، وبالضوء الواطئ – على الأقل 60م..",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "بالضوء العالي – على الأقل 120م، وبالضوء الواطئ – على الأقل 50م..",
        "بالضوء العالي – على الأقل 100م، وبالضوء الواطئ – على الأقل 30م.",
        "مسافة أضواء المقدمة لم تُحدد في القانون وإنما هي حسب تقدير منتج المركبة.",
        "بالضوء العالي – على الأقل 150م، وبالضوء الواطئ – على الأقل 60م.."
      ],
      id: 1582
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0244. الوقوف على شكل زاوية في الشارع:",
      numQues: "0244",
      correctAnswer: "مسموح إذا كانت هناك علامة خاصة لذلك.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "ممنوع، ما عدا الدراجات النارية.",
        "ممنوع، ما عدا مركبة طولها 3,5م أو اقل.",
        "مسموح فقط في شارع عريض.",
        "مسموح إذا كانت هناك علامة خاصة لذلك."
      ],
      id: 1583
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0216. هل يجوز إيقاف مركبة في مكان نُصبت فيه الإشارة؟",
      numQues: "0216",
      correctAnswer: "ممنوع، ما عدا المركبة التي تحمل لاصقة معاق كما في الإشارة.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3216.jpg",
      choices: [
        "مسموح في ساعات النهار فقط.",
        "مسموح إذا كانت هناك أماكن وقوف كثيرة خالية.",
        "مسموح لأية تحمل لاصقة وقوف عادية أن تقف عندما يكون المكان خالياً.",
        "ممنوع، ما عدا المركبة التي تحمل لاصقة معاق كما في الإشارة."
      ],
      id: 1584
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1133. ماذا يتوجب على السائق عمله إذا تعطل احد مصباحي المقدمة في وقت الإنارة؟",
      numQues: "1133",
      correctAnswer: "يسمح القانون بالسير بسرعة بطيئة لغاية الكراج القريب.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "عليه التوقف، ممنوع الاستمرار بالسير طالما المصباح معطل.",
        "مسموح الاستمرار بالسير شريطة أن يكون ضوء الوقوف مضاءً وسليماً.",
        "ممنوع الاستمرار بالسير حتى ولو كان مصباح الضباب الأمامي سليماً ومضاءً.",
        "يسمح القانون بالسير بسرعة بطيئة لغاية الكراج القريب."
      ],
      id: 1585
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1346. درجة الرخصة المطلوبة لسياقة مركبة ميكانيكية تجارية وزنها الإجمالي المسموح به أكثر من 12000كغم هي:",
      numQues: "1346",
      correctAnswer: "C",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "D",
        "C1",
        "B",
        "C"
      ],
      id: 1586
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0612. المركبة التي تم ترخيصها لنقل الأولاد هي:",
      numQues: "0612",
      correctAnswer: "باص خصوصي أو مركبة عمومية تم ترخيصهما لنقل الأولاد.",
      pubDate: "10-11-2011 08:23:12",
      img: "",
      choices: [
        "كل باص مُسجل على اسم شركة نقليات.",
        "كل مركبة ميكانيكية تنقل أولاد.",
        "كل باص عمومي يعمل على خط خدمة.",
        "باص خصوصي أو مركبة عمومية تم ترخيصهما لنقل الأولاد."
      ],
      id: 1587
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0595. ما معنى الإشارة؟",
      numQues: "0595",
      correctAnswer: "ممنوع وقوف المركبات.",
      pubDate: "10-11-2011 08:23:12",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3595.jpg",
      choices: [
        "نهاية الشارع الذي فيه حق الأولوية.",
        "تمهل واستعد للتوقف.",
        "أنت موجود في شارع فيه حق الأولوية.",
        "ممنوع وقوف المركبات."
      ],
      id: 1588
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1009. ما هي العلاقة بين أداء وسائد الهواء وبين أحزمة الأمان في المركبة، عند وقوع حادث؟",
      numQues: "1009",
      correctAnswer: "تعمل وسادة الهواء فقط عندما لا يعمل الحزام.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "لا توجد علاقة بين أداء وسائد الهواء وبين أحزمة الأمان. ",
        "عدم ربط أحزمة الأمان من شأنه أن يتسبب في أن تُشكل الوسائد خطراً على الركاب عند انتفاخها.",
        "لا تعمل وسائد الهواء عندما لا تكون أحزمة الأمان في المركبة مستخدمة.",
        "تعمل وسادة الهواء فقط عندما لا يعمل الحزام."
      ],
      id: 1589
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0412. كيف تتصرف حسب الإشارة ؟",
      numQues: "0412",
      correctAnswer: "سر في وسط الشارع واستعمل الغماز قبل كل انعطاف.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3411.jpg",
      choices: [
        "لائم سرعة سيرك لوضع الطريق واحرص على أن تبقى على الجهة اليمنى القصوى للشارع.",
        "زد من سرعة سيرك من اجل عبور المكان في وقت قصير.",
        "تمهل واعبر إلى يسار الطريق في المنعطف يساراً.",
        "سر في وسط الشارع واستعمل الغماز قبل كل انعطاف."
      ],
      id: 1590
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1164. أين تُثبت اللوحتان اللتان تحملان تفاصيل صاحب الصالون العمومي والسائق؟",
      numQues: "1164",
      correctAnswer: "على جانبي لوحة المقاييس (التابلو).",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "على القسم الداخلي من حلوق (شمعات) الأبواب من اليمين ومن اليسار في الصالون العمومي.",
        "على الحلق بين الأبواب في الجهة اليمنى.",
        "تُثبت الاثنتان على الجهة اليمنى للوحة الساعات (التابلو) مقابل جيب القفازات (الجيبة الداخلية).",
        "على جانبي لوحة المقاييس (التابلو)."
      ],
      id: 1591
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1241. أية مركبة ملزمة بأجهزة إنقاذ؟",
      numQues: "1241",
      correctAnswer: "مركبة تجوال وباص يعمل على خط خدمة بين المدن فقط.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "كل باص وكل مركبة تجوال ملزمين بأجهزة إنقاذ.",
        "باص في سفرة سياحية فقط.",
        "صالون عمومي ومركبة صحراوية فقط.",
        "مركبة تجوال وباص يعمل على خط خدمة بين المدن فقط."
      ],
      id: 1592
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1553. لا يجب أن تزيد المسافة المسموح بها بين عجلات المركبة القريبة من حافة الشارع وبين حافة الشارع عند الوقوف أو التوقف أو الإيقاف عن:",
      numQues: "1553",
      correctAnswer: "60سم.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "80سم.",
        "50سم.",
        "40سم.",
        "60سم."
      ],
      id: 1593
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0206. هل يجوز إيقاف مركبة بعد مكان عبور المشاة؟",
      numQues: "0206",
      correctAnswer: "ممنوع.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "ممنوع بحدود 12م بعد ممر العبور.",
        "مسموح.",
        "مسموح في الليل فقط.",
        "ممنوع."
      ],
      id: 1594
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1017. تُساهم السياقة الصحيحة والمعتدلة والمحافظة على ضغط هواء صحيح في الإطارات:",
      numQues: "1017",
      correctAnswer: "في زيادة استهلاك زيت المحرك.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "في تحسين أداء المركبة أثناء الحادث.",
        "في إطالة عمر الإطارات.",
        "في زيادة استهلاك وقود المحرك.",
        "في زيادة استهلاك زيت المحرك."
      ],
      id: 1595
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0042. عرِّف 'السبيل' :",
      numQues: "0042",
      correctAnswer: "قسم من الطريق تم وسمه من قِبل 'شركة سبل إسرائيل'.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "قسم من عرض الطريق مُعد للمشاة فقط.",
        "طريق أو قسم من الطريق، ما عدا الشارع، خُصص لنوع من عابري الطريق",
        "قسم من طول الطريق مُعد لسير الدراجات النارية فقط.",
        "قسم من الطريق تم وسمه من قِبل 'شركة سبل إسرائيل'."
      ],
      id: 1596
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0818. بماذا تتميز السياقة مع المحافظة على مسافة ملائمة من المركبة التي تسير في الأمام؟",
      numQues: "0818",
      correctAnswer: "السير الذي يستوجب ملاءمة المسافة مراراً وتكراراً في كل لحظة حسب وضع المنطقة، وتتعب السائق.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "مثل هذه السياقة تشجع السائقين الآخرين على الدخول في المسافة المحافظ عليها من الأمام.",
        "سياقة هادئة أكثر وبضغط اقل ولا تسبب التعب وتمنع الأخطار.",
        "لا يوجد أي تأثير للمحافظة على مسافة على طبيعة السياقة.",
        "السير الذي يستوجب ملاءمة المسافة مراراً وتكراراً في كل لحظة حسب وضع المنطقة، وتتعب السائق."
      ],
      id: 1597
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0211. متى يُسمح بإيقاف مركبة على جسر أو داخل نفق؟",
      numQues: "0211",
      correctAnswer: "مسموح في النهار فقط.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3211.jpg",
      choices: [
        "مسموح إذا كان في الشارع مسلكان أو أكثر. ",
        "ممنوع في 'وقت الإنارة' فقط.",
        "ممنوع منعاً باتاً.",
        "مسموح في النهار فقط."
      ],
      id: 1598
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1328. من هو المسؤول عن سلامة جهاز تحديد السرعة المُركَب في المركبة؟",
      numQues: "1328",
      correctAnswer: "أصحاب المركبة المسجلين في رخصتها فقط.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "صاحب مكتب النقليات.",
        "السائق وصاحب المركبة.",
        "صاحب الحمولة المنقولة.",
        "أصحاب المركبة المسجلين في رخصتها فقط."
      ],
      id: 1599
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1162. هل يجب على سائق الصالون العمومي مساعدة الراكب في تحميل وتنزيل أمتعته إلى ومن الصالون العمومي؟",
      numQues: "1162",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "فقط إذا دفع المسافر عن خدمة التحميل والتنزيل.",
        "فقط في سفرة من مطار بن غوريون.",
        "نعم، إذا لزم الأمر.",
        "كلا."
      ],
      id: 1600
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»"
      ],
      title: "1514. الجر بدون مسمار الأمان المخصص لذلك وبدون سلاسل الأمان، يؤدي إلى:",
      numQues: "1514",
      correctAnswer: "كسر مسمار الجر.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "إمكانية ربط أسرع وأكثر أماناً للمجرورة.",
        "اهتراء زائد في عريش التوصيل.",
        "انفصال المقطورة عن القاطرة.",
        "كسر مسمار الجر."
      ],
      id: 1601
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1639. ما هو الخطر المتوقع لسائق مركبة تسير على عجلتين عند مروره بين صفوف المركبات الواقفة قبل المفترق؟",
      numQues: "1639",
      correctAnswer: "لا يوجد أي خطر متوقع، هناك دائماً حيز كافي يُمكن من مرور مركبة تسير على عجلتين بصورة مريحة وآمنة.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "الخطر هو أنه في مقدمة المفترق لا يتبقى له مكان بسبب كثرة المركبات التي تسير على عجلتين.",
        "من شأنه إصابة المشاة الذين يعبرون الشارع ليس عن طريق ممر مشاة منظم.",
        "يقذف سائقو المركبات بأعقاب السجائر من النافذة، وهذه من شأنها أن تضر به.",
        "لا يوجد أي خطر متوقع، هناك دائماً حيز كافي يُمكن من مرور مركبة تسير على عجلتين بصورة مريحة وآمنة."
      ],
      id: 1602
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1205. احد المتطلبات بالنسبة للأجهزة التي يجب أن تكون في المركبة المرخصة بنقل التلاميذ هو:",
      numQues: "1205",
      correctAnswer: "تركيب مصابيح تبعث بنور متقطع يتم تشغيلها عند كل توقف للمركبة.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "تركيب مصابيح تبعث بنور متقطع يتم تشغيلها في كال حالة تُشغل فيها مصابيح الطوارئ.",
        "تركيب مصابيح تبعث بنور متقطع والتي يجب أن تعمل عند نقل التلاميذ.",
        "تركيب مصابيح تبعث بنور خاص متقطع من الأمام ومن الخلف وتعمل عند فتح الأبواب.",
        "تركيب مصابيح تبعث بنور متقطع يتم تشغيلها عند كل توقف للمركبة."
      ],
      id: 1603
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0014. عرِّف 'تراكتورون' :",
      numQues: "0014",
      correctAnswer: "مركبة تسير على 4 عجلات على الأقل، وتكون طريقة الجلوس عليها بشكلٍ تكون فيه رجلا السائق على جانبي المقعد، ويتم توجيهها بواسطة مقود دراجة (كيدون).",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "مركبة تسير على عجلتين على الأقل، وتكون طريقة الجلوس عليها بشكلٍ تكون فيه رجلا السائق على جانبي المقعد، ويتم توجيهها بواسطة مقود دراجة (كيدون).",
        "مركبة تسير على 4 عجلات على الأقل، ويتم توجيهها بواسطة مقود.",
        "مركبة تسير على 4 عجلات على الأقل، وتكون طريقة الجلوس عليها بشكلٍ تكون فيه رجلا السائق على جانب واحد للمقعد، ويتم توجيهها بواسطة المقود.",
        "مركبة تسير على 4 عجلات على الأقل، وتكون طريقة الجلوس عليها بشكلٍ تكون فيه رجلا السائق على جانبي المقعد، ويتم توجيهها بواسطة مقود دراجة (كيدون)."
      ],
      id: 1604
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»"
      ],
      title: "0079. على أي قسم من الطريق يجوز لمركبة ركاب خصوصية أن تسير ؟",
      numQues: "0079",
      correctAnswer: "على الشارع وعلى المساحة الفاصلة، في كل وقت.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3079.jpg",
      choices: [
        "على أي قسم كان من الطريق.",
        "على حاشية الطريق وعلى المساحة الفاصلة أثناء الازدحام في حركة السير.",
        "على الشارع فقط - حيثما وُجِد شارع.",
        "على الشارع وعلى المساحة الفاصلة، في كل وقت."
      ],
      id: 1605
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0557. إذا كان الشارع مقسماً بواسطة خط فاصل متقطع؟",
      numQues: "0557",
      correctAnswer: "مسموح أن تتجاوز عندما تكون الطريق خالية.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3557.jpg",
      choices: [
        "ممنوع أن تتجاوز حتى المكان الذي يُصبح فيه الخط متواصلاً.",
        "مسموح أن تتجاوز مركبة بطيئة فقط.",
        "ممنوع أن تتجاوز حتى المكان الذي نُصبت فيه الإشارة 'نهاية منع التجاوز'.",
        "مسموح أن تتجاوز عندما تكون الطريق خالية."
      ],
      id: 1606
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«A»"
      ],
      title: "0505. هل يُسمح بدخول دراجة نارية عندما تُنصب هذه الإشارة في الطريق أمامك؟",
      numQues: "0505",
      correctAnswer: "نعم، مسموح الدخول لجميع المركبات الميكانيكية في الطريق التي أمامك.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3505.jpg",
      choices: [
        "نعم.",
        "كلا.",
        "نعم، الدخول ممنوع للدراجات النارية التي تسير على ثلاث عجلات فقط.",
        "نعم، مسموح الدخول لجميع المركبات الميكانيكية في الطريق التي أمامك."
      ],
      id: 1607
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0075. هل يجوز إنزال إحدى اليدين عن المقود أو عن مقود الدراجة (الكيدون) أثناء السياقة؟",
      numQues: "0075",
      correctAnswer: "ممنوع في جميع الحالات.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "ممنوع إلا من اجل تغيير غيار أو إعطاء إشارة بواسطة الغماز أو لضمان انتظام سير المركبة.",
        "مسموح فقط من اجل ضبط جهاز الراديو أو تشغيل الولاعة.",
        "مسموح من اجل استعمال الهاتف النقال (البلفون).",
        "ممنوع في جميع الحالات."
      ],
      id: 1608
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1667. رخصة سياقة من الدرجة2 A تمكن من سياقة:",
      numQues: "1667",
      correctAnswer: "دراجة نارية تزيد قوة محركها عن 39 كيلو واط (52 حصان).",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "دراجة نارية بدون تحديد في قوة المحرك.",
        "دراجة نارية قوة محركها لغاية 11 كيلو واط (14.6 حصان).",
        "دراجة نارية تزيد قوة محركها عن 25 كيلو واط (33 حصان).",
        "دراجة نارية تزيد قوة محركها عن 39 كيلو واط (52 حصان)."
      ],
      id: 1609
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0291. ما هو حكم شخص يقوم بتسيير مركبه بقوه جسمه؟",
      numQues: "0291",
      correctAnswer: "لمن لا يحمل رخصة سياقة، مسموح تسيير تراكتورون فقط بالقوة الجسمية.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "لمن لا يحمل رخصة سياقة، مسموح تسيير مركبة تسير على عجلتين فقط بالقوة الجسمية.",
        "لمن لا يحمل رخصة سياقة، مسموح تسيير مركبة ركاب خصوصية فقط بالقوة الجسمية.",
        "حكمه كحكم سائق المركبة.",
        "لمن لا يحمل رخصة سياقة، مسموح تسيير تراكتورون فقط بالقوة الجسمية."
      ],
      id: 1610
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0002. ما هي الشروط الواجب توفرها لسياقة مركبة ميكانيكية؟",
      numQues: "0002",
      correctAnswer: "الشروط المحددة عند اجتياز المركبة فحص الترخيص السنوي (التست).",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "الشروط المسجلة في تعليمات المنتج الموجودة في دليل المركبة.",
        "يجب أن تكون بحوزة سائق المركبة رخصة سياقة سارية المفعول لنفس نوع المركبة.",
        "إذا كان سائق المركبة مسجلاً كصاحبها أو يملك السيطرة عليها.",
        "الشروط المحددة عند اجتياز المركبة فحص الترخيص السنوي (التست)."
      ],
      id: 1611
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0867. ما هي شروط السير بخط مستقيم بدون انحراف؟",
      numQues: "0867",
      correctAnswer: "إلقاء نظرات نحو الخط الفاصل والمحافظة على مسافة ثابتة منه. ",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "متابعة متواصلة أثناء السير للخط الأصفر المجاور للشارع.",
        "التركيز على الهدف الأكثر بعداً الذي يمكن الوصول إليه بواسطة النظر.",
        "المحافظة على يمين الطريق مع المحافظة على مسافة ثابتة من الخط الأصفر الذي على اليمين.",
        "إلقاء نظرات نحو الخط الفاصل والمحافظة على مسافة ثابتة منه. "
      ],
      id: 1612
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1701. تكون خطورة التزحلق في شارع رطب اكبر:",
      numQues: "1701",
      correctAnswer: "اكبر كلما سرنا بسرعة أبطأ.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "اكبر كلما سرنا بسرعة أكثر.",
        "خطر التزحلق في شارع رطب مشابه لخطر التزحلق في شارع جاف.",
        "اكبر كلما كانت الإطارات احدث.",
        "اكبر كلما سرنا بسرعة أبطأ."
      ],
      id: 1613
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1746. حاشية الطريق غير مُعدة لسير المركبات، ما عدا:",
      numQues: "1746",
      correctAnswer: "المركبة الخصوصية والدراجة النارية - من اجل إعطاء حق الأولوية للباصات.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "الصالون العمومي - من اجل تجاوز المركبات.",
        "لا يوجد استثناء: ممنوع أن تسير أية مركبة على حاشية الطريق.",
        "مركبة غير ميكانيكية وتراكتور ومركبة بطيئة، واللواتي يعرقلن حركة السير من الخلف.",
        "المركبة الخصوصية والدراجة النارية - من اجل إعطاء حق الأولوية للباصات."
      ],
      id: 1614
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0877. ماذا يستوجب دائماً الرجوع إلى الخلف؟",
      numQues: "0877",
      correctAnswer: "السير بالغيار الواطئ حسب وضع الطريق في منحدر شديد.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "تشغيل الطنان (المزمزم) الخارجي للرجوع إلى الخلف في جميع أنواع المركبات بما في ذلك المركبات الخصوصية.",
        "استخدام شخص موجِه في مكان ظاهر لعيني السائق فقط.",
        "الانتباه واتخاذ التدابير لمنع الخطر أو الإصابة أو الإزعاج أو الإعاقة.",
        "السير بالغيار الواطئ حسب وضع الطريق في منحدر شديد."
      ],
      id: 1615
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0167. إذا أُصيب جهاز إعطاء الإشارة (الغماز) الكهربائي بخلل هل يُسمح بإعطاء الإشارة بشكلٍ آخر ؟",
      numQues: "0167",
      correctAnswer: "مسموح إعطاء الإشارة باليد - في الجو اللطيف فقط.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "يجب إعطاء الإشارة باليد في هذه الظروف. ",
        "ممنوع، يجب إعطاء الإشارة بواسطة الغماز.",
        "مسموح إعطاء الإشارة باليد - في الليل فقط.",
        "مسموح إعطاء الإشارة باليد - في الجو اللطيف فقط."
      ],
      id: 1616
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1634. العوامل الرئيسية التي تؤثر على مقدرة راكب الدراجة النارية عند محاولته تجنب حمولة سقطت من المركبة التي تسير أمامه، هي:",
      numQues: "1634",
      correctAnswer: "وضع الدراجة النارية الميكانيكي.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "صلاحية الفرامل وصلاحية الإطارات.",
        "ضغط هواء ضعف المطلوب في إطارات الدراجة النارية.",
        "المحافظة على مسافة والمحافظة على مدى رؤية واسع في كل لحظة.",
        "وضع الدراجة النارية الميكانيكي."
      ],
      id: 1617
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0946. ما هو التصرف المطلوب في مقطع الطريق الظاهر أمامك؟",
      numQues: "0946",
      correctAnswer: "زد من نصف قطر الانعطاف لكي تحافظ على سرعة معقولة.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3946.jpg",
      choices: [
        "حافظ على نصف قطر صغير في الانعطاف ولائم السرعة لنصف قطر كهذا.",
        "تمهل قبل الدخول إلى المنعطف وزد من السرعة باعتدال عند الخروج منه.",
        "زد من السرعة عند الدخول إلى المنعطف وتمهل في داخله وعند الخروج منه.",
        "زد من نصف قطر الانعطاف لكي تحافظ على سرعة معقولة."
      ],
      id: 1618
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0488. ما معنى الإشارة؟",
      numQues: "0488",
      correctAnswer: "أعطِ حق الأولوية لراكبي الدراجات النارية.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3419.jpg",
      choices: [
        "حركة سير دراجات هوائية تقطع في الطريق التي أمامك",
        "سبيل لراكبي الدراجات الهوائية.",
        "انتبه! مركبات ميكانيكية تسير على عجلتين.",
        "أعطِ حق الأولوية لراكبي الدراجات النارية."
      ],
      id: 1619
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1023. إذا انكسرت في المركبة عدسة مصباح (زجاجة الضوء) المقدمة، فماذا ينتج عن ذلك؟",
      numQues: "1023",
      correctAnswer: "تفريغ سريع للبطارية.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "تبريد زائد للامبة المصباح.",
        "تركيز غير سليم لنور الضوء وإزعاج السائقين الآخرين.",
        "بهر نظر سائق المركبة نفسه.",
        "تفريغ سريع للبطارية."
      ],
      id: 1620
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0145. متى يجوز تنفيذ الفرملة الفجائية؟",
      numQues: "0145",
      correctAnswer: "عند السير بسرعة لا تلائم وضع المنطقة.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "بعد إعطاء إشارة استغاثة للمركبة التي خلفك فقط.",
        "عندما تكون الطريق مشوشة.",
        "لمنع وقوع حادث طرق لا يمكن تجنبه بطريقة أخرى.",
        "عند السير بسرعة لا تلائم وضع المنطقة."
      ],
      id: 1621
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0185. كيف تتصرف حسب ما هو ظاهر في الصورة؟",
      numQues: "0185",
      correctAnswer: "قف قبل المفترق ولا تدخل المفترق.",
      pubDate: "10-11-2011 08:23:13",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3185.jpg",
      choices: [
        "قف قبل المفترق وتابع سيرك بدون إعاقة.",
        "أعطِ حق الأولوية لحركة السير في الطريق القاطعة.",
        "لا توجد ضرورة بإطاعة أوامر الإشارة الضوئية وإنما لأوامر الإشارات.",
        "قف قبل المفترق ولا تدخل المفترق."
      ],
      id: 1622
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1362. واجب وجود أحذية الامان:",
      numQues: "1362",
      correctAnswer: "في كل مركبة ميكانيكية وزنها الإجمالي المسموح به أكثر من 5000كغم ما.",
      pubDate: "10-11-2011 08:23:13",
      img: "",
      choices: [
        "في كل مركبة ميكانيكية وزنها الإجمالي المسموح به أكثر من 4000كغم ما عدا الباص والمركبة التجارية الموحدة.",
        "فقط في المركبة من نوع قاطرة أو ساندة والمركبة الموصولة فقط.",
        "في كل مركبة ميكانيكية وزنها الإجمالي المسموح به أكثر من 5000كغم ما عدا الباص.",
        "في كل مركبة ميكانيكية وزنها الإجمالي المسموح به أكثر من 5000كغم ما."
      ],
      id: 1623
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1377. اشرح المصطلح 'فرملة مستقلة' (فرملة منفردة):",
      numQues: "1377",
      correctAnswer: "الجهاز الذي يُشغله السائق عند تخفيف السرعة في منحدر شديد وطويل.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "جهاز يشغل جهاز الفرامل بشكلٍ مستقل عندما ينخفض ضغط الهواء في جهاز الفرامل إلى ما دون الضغط المطلوب.",
        "منشأة في جهاز الفرامل تُشغل الفرملة على كل عجل بشكلٍ مستقل عند التزحلق.",
        "منشأة تتسبب في أن يقوم جهاز الفرامل بتشغيل كل عجل بشكلٍ مستقل. ",
        "الجهاز الذي يُشغله السائق عند تخفيف السرعة في منحدر شديد وطويل."
      ],
      id: 1624
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "0990. كيف تُشخص السخونة الزائدة في الفرامل؟",
      numQues: "0990",
      correctAnswer: "من ضعف الفرملة ورائحة المادة المحترقة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "تضيء لامبة ضغط زيت المحرك.",
        "من الاهتزازات غير الطبيعية للمركبة.",
        "يفقد المحرك قدرته على السحب.",
        "من ضعف الفرملة ورائحة المادة المحترقة."
      ],
      id: 1625
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0335. هل يجوز لسلطة الترخيص سحب رخصة سياقة أو تعليقها لصاحب رخصة سياقة؟",
      numQues: "0335",
      correctAnswer: "كلا، يجوز فقط للمحكمة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "نعم، يجوز لسلطة الترخيص أن تسحب رخصة حسب رغبتها لأي سببٍ كان.",
        "كلا، يجوز فقط لشرطة إسرائيل.",
        "نعم، يجوز لسلطة الترخيص أن تفعل ذلك لأسباب تتعلق بالمقدرة على السياقة أو الحالة الصحية.",
        "كلا، يجوز فقط للمحكمة."
      ],
      id: 1626
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1157. في أي وضع يكون العداد في الصالون العمومي عندما يكون شاغراً (غير مشغول) لنقل الركاب؟",
      numQues: "1157",
      correctAnswer: "في وضع 'شاغر' (غير مشغول) وغير مضاء.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "في وضع 'شاغر' (غير مشغول) ومضاء.",
        "في وضع 'مشغول' ومضاء.",
        "في وضع 'مشغول' وغير مضاء.",
        "في وضع 'شاغر' (غير مشغول) وغير مضاء."
      ],
      id: 1627
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1391. بأي رقم موسومة (مؤشرة) 'المسافة بين المحاور' في المركبة الظاهرة في الصورة؟",
      numQues: "1391",
      correctAnswer: "7",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31391.jpg",
      choices: [
        "16",
        "14",
        "3",
        "7"
      ],
      id: 1628
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0410. كيف تتصرف حسب الإشارة ؟",
      numQues: "0410",
      correctAnswer: "سر كالمعتاد لا توجد أية أهمية لسرعة الدخول إلى المنعطف أو الخروج منه.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3409.jpg",
      choices: [
        "تمهل قبل الدخول إلى المنعطف وزد من السرعة بالتدريج عند الخروج.",
        "استعمل الزامور قبل الدخول إلى المنعطف.",
        "ادخل المنعطف بسرعة عالية واخرج منه ببطء.",
        "سر كالمعتاد لا توجد أية أهمية لسرعة الدخول إلى المنعطف أو الخروج منه."
      ],
      id: 1629
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0161. في أية حالات يسري واجب التوقف قبل ملتقى سكة حديد؟",
      numQues: "0161",
      correctAnswer: "إذا نُصبت إشارة 'ملتقى سكة حديد'.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "إذا نُصبت إشارة 'أعطِ حق الأولوية لحركة السير القاطعة'.",
        "إذا كان القطار يقترب يُرى أو يُسمع أو يُطلق إشارة تنبيه.",
        "لا يوجد واجب بالتوقف، إنما يجب التقدير إذا كان هناك لزوم بالتوقف إذا كان القطار يُرى أو يُسمع. ",
        "إذا نُصبت إشارة 'ملتقى سكة حديد'."
      ],
      id: 1630
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1651. هل يجوز لصاحب دراجة نارية تركيب بدل الإطارات الأصلية إطارات ذات قياس مختلف؟",
      numQues: "1651",
      correctAnswer: "يجوز، لكن التغيير يجب أن يكون ليس أكثر من 10% من القياس المسجل في رخصة المركبة – أكثر أو اقل.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "يجوز، من شأن ذلك أن يوفر في الوقود.",
        "لا يجوز له، إلا إذا حصل على إذنٍ مسبق بذلك من سلطة الترخيص.",
        "يجوز - فقط لصاحب دراجة نارية ذات ثلاث عجلات أو لصاحب دراجة نارية مع عربة جانبية.",
        "يجوز، لكن التغيير يجب أن يكون ليس أكثر من 10% من القياس المسجل في رخصة المركبة – أكثر أو اقل."
      ],
      id: 1631
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0859. ما هي العمليات الأولى التي على السائق القيام بها بعد دخوله إلى المركبة، وقبل بدء السفر؟",
      numQues: "0859",
      correctAnswer: "ملاءمة المقعد والمقود والمرايا ومسند الرأس.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "التشغيل وتسخين المركبة.",
        "ربط أحزمة الأمان.",
        "فحص وضع عصا الغيارات.",
        "ملاءمة المقعد والمقود والمرايا ومسند الرأس."
      ],
      id: 1632
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1060. بعد السير في حفرة ماء عميقة وتبلل الفرامل، على السائق:",
      numQues: "1060",
      correctAnswer: "أن يسير ببطء شديد إلى أن تجف الفرامل وتعود تعمل كالمعتاد.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "أن يسير بسرعة من اجل تجفيف الفرامل.",
        "أن يجر المركبة إلى الكراج القريب.",
        "أن لا يعمل شيئاً، لا توجد علاقة بين الماء وبين جهاز الفرامل.",
        "أن يسير ببطء شديد إلى أن تجف الفرامل وتعود تعمل كالمعتاد."
      ],
      id: 1633
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1105. ما هو الشيء الذي يجب التأكد منه قبل فصل أنابيب الزيت الهيدراولي من الجهاز أو قبل فصل المعدات الأخرى الموصولة بالتراكتور؟",
      numQues: "1105",
      correctAnswer: "التأكد من أن التوصيلات سليمة تماماً.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "التأكد من أنها موصولة بصورة صحيحة.",
        "التأكد من عدم وجود ضغط زيت فيها على الإطلاق.",
        "التأكد إذا كان هناك تسريبات من التوصيلات.",
        "التأكد من أن التوصيلات سليمة تماماً."
      ],
      id: 1634
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0283. لأية فترة زمنية مسموح إبقاء مركبة أصابها خلل في الطريق أو في مكان عام؟",
      numQues: "0283",
      correctAnswer: "طيلة فترة تصليحها بشرط أن لا تزيد المدة عن 72 ساعة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "يجب إزالتها بأسرع وقت ممكن بما لا يزيد عن 48 ساعة.",
        "لغاية قدوم مركبة التخليص بشرط أن لا تزيد المدة عن أسبوع.",
        "يجب إزالتها بأسرع وقت ممكن بما لا يزيد عن 24 ساعة.",
        "طيلة فترة تصليحها بشرط أن لا تزيد المدة عن 72 ساعة."
      ],
      id: 1635
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1258. هل يُسمح بدخول الباص المستعمل في تعليم السياقة عندما تُنصب الإشارة التي أمامك؟",
      numQues: "1258",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3528.jpg",
      choices: [
        "كلا، ما عدا باص تابع لشركة باصات فازت بالتصريح.",
        "كلا.",
        "نعم، ما عدا المركبة التي يزيد وزنها الإجمالي عن 10000كغم.",
        "نعم."
      ],
      id: 1636
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0668. كيف تتصرف إذا كان الضوء الأصفر في الإشارة الضوئية (الرمزور) متقطعاً؟",
      numQues: "0668",
      correctAnswer: "تقدم بحذر وتصرف حسب الإشارات المنصوبة في المفترق.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3186.jpg",
      choices: [
        "تجاهل الإشارة الضوئية (الرمزور) وتابع سيرك – كل شيء على ما يرام.",
        "توقف داخل المفترق وانتظر الضوء الأخضر.",
        "توقف في مكان التوقف المقبول وانتظر الضوء الأخضر.",
        "تقدم بحذر وتصرف حسب الإشارات المنصوبة في المفترق."
      ],
      id: 1637
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "0321. ما هو الطول الإجمالي المسموح به لمركبة تجارية يزيد وزنها الإجمالي عن 12,000كغم؟",
      numQues: "0321",
      correctAnswer: "10,00م.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "12م.",
        "11م.",
        "11,70م.",
        "10,00م."
      ],
      id: 1638
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1419. في أية مركبة يُسمح بنقل حاوية (كونتينر) يزيد طولها عن 610سم؟",
      numQues: "1419",
      correctAnswer: "في مركبة وزنها الإجمالي المسموح به 19000كغم أو أكثر.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "في مستندة فقط وحسب ما هو مسجل في رخصة المركبة.",
        "في مقطورة أو في مستندة وزنها الإجمالي المسموح به 14000كغم أو اقل.",
        "في مركبة تجارية يزيد وزنها الإجمالي المسموح به 10000كغم أو أكثر.",
        "في مركبة وزنها الإجمالي المسموح به 19000كغم أو أكثر."
      ],
      id: 1639
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0757. هل يجوز إيقاف مركبة تنقل مادة خطرة ويزيد وزنها الإجمالي عن 3500كغم في طريق داخل المدن؟",
      numQues: "0757",
      correctAnswer: "ممنوع منعاً باتاً إيقاف مركبة كهذه في طريق داخل المدن.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "مسموح بشرط عدم التدخين بالقرب منها.",
        "مسموح فقط عندما تكون الصهاريج (التنكات) خالية.",
        "مسموح فقط على مسافة تزيد عن 400م من مبنى عام أو مبنى للسكن.",
        "ممنوع منعاً باتاً إيقاف مركبة كهذه في طريق داخل المدن."
      ],
      id: 1640
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1024. لأي ضغط يجب نفخ العجل الاحتياطي (السبير) في المركبة؟",
      numQues: "1024",
      correctAnswer: "لمعدل ضغط الهواء في عجلات المركبة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "لا توجد أهمية لمقدار ضغط الهواء في العجل الاحتياطي (السبير).",
        "لضغط يساوي اقل ضغط في عجلات المركبة.",
        "للضغط الذي قررة المنتج.",
        "لمعدل ضغط الهواء في عجلات المركبة."
      ],
      id: 1641
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1720. هل يُسمح بالسياقة تحت تأثير العقاقير (الأدوية) المهدئة؟",
      numQues: "1720",
      correctAnswer: "مسموح، وهذا ممتاز لذوي الأعصاب المشدودة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "نعم، لا تؤثر العقاقير (الأدوية) المهدئة سلبياً على السياقة.",
        "ممنوع ، إلا إذا ذُكر غير ذلك بشكلٍ واضح في الوصفة الطبية (الروشيته) للدواء.",
        "نعم، إذا أكل السائق والدواء يهدئ أعصابه.",
        "مسموح، وهذا ممتاز لذوي الأعصاب المشدودة."
      ],
      id: 1642
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1150. هل يُسمح بإدخال كراسي لجلوس الركاب للباص أو للتاكسي إضافة إلى المقاعد الثابتة فيهما؟",
      numQues: "1150",
      correctAnswer: "مسموح، فقط عند السفر إلى شاطئ البحر.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "ممنوع.",
        "مسموح، فقط إذا كانت الكراسي منجدة.",
        "مسموح، بشرط أن تكون موصولة لجسم المركبة بواسطة براغي.",
        "مسموح، فقط عند السفر إلى شاطئ البحر."
      ],
      id: 1643
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0362. أية إشارة تُنصب أو تؤشر بعد الإشارة 144؟",
      numQues: "0362",
      correctAnswer: "821",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3362.jpg",
      choices: [
        "513",
        "101",
        "806",
        "821"
      ],
      id: 1644
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1310. ما هو الوزن الإجمالي المسموح به لمستندة ذات محورين أو أكثر لنقل حاوية؟",
      numQues: "1310",
      correctAnswer: "ليس أكثر من 28000كغم.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "لا يفل عن 25000كغم.",
        "لا يقل عن 29000كغم.",
        "لا يقل عن 30000كغم.",
        "ليس أكثر من 28000كغم."
      ],
      id: 1645
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1301. لا يجب أن يزيد عرض شاحنة (ما عدا مركبة مع جسم تبريد) عن:",
      numQues: "1301",
      correctAnswer: "2,55م.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "2,10م.",
        "3,50م.",
        "2,80م.",
        "2,55م."
      ],
      id: 1646
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0820. ما هي الطريقة المجربة والموصى بها للمحافظة على مسافة ملائمة من المركبة التي تسير أمامنا؟",
      numQues: "0820",
      correctAnswer: "تقدير المسافة المعقولة بيننا وبين المركبة التي تسير أمامنا.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "طريقة عد 'الثانيتين'.",
        "طريقة طول المركبات وسعة المحرك.",
        "بذل الجهد على قدر الإمكان بالسياقة مثل السائقين في المسالك المجاورة من اليمين ومن اليسار.",
        "تقدير المسافة المعقولة بيننا وبين المركبة التي تسير أمامنا."
      ],
      id: 1647
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1126. هل يجوز إيقاف باص معد لنقل 20 راكب أو أكثر في مكان وقوف مُعد للمركبات الخصوصية؟",
      numQues: "1126",
      correctAnswer: "يجوز في المحطات المعدة لاصعاد وإنزال الركاب.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "يجوز فقط بواسطة بطاقة وقوف.",
        "لا يجوز.",
        "يجوز إذا لا يُشكل الباص إزعاج لحركة السير.",
        "يجوز في المحطات المعدة لاصعاد وإنزال الركاب."
      ],
      id: 1648
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0214. هل يجوز إيقاف مركبة بجانب حاجز لوقاية المارة؟",
      numQues: "0214",
      correctAnswer: "مسموح في حدود مدرسة ابتدائية فقط.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3214.jpg",
      choices: [
        "مسموح في حدود مدرسة ثانوية فقط.",
        "ممنوع إلا إذا نُصبت إشارة تدل على غير ذلك.",
        "مسموح في طريق داخل المدن.",
        "مسموح في حدود مدرسة ابتدائية فقط."
      ],
      id: 1649
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0977. كيف تتصرف في مقطع الطريق التي أمامك؟",
      numQues: "0977",
      correctAnswer: "استمر بالسير كالمعتاد واستعمل الزامور بشكلٍ متواصل بضعة مرات قبل عبورك خط الحاوية.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3977.jpg",
      choices: [
        "توقف قبل الحاوية لئلا يعبر المشاة بعد الحاوية.",
        "زد من سرعة سيرك لتجنب إمكانية تواجد مشاة يعبرون بعد الحاوية.",
        "تمهل واستعد للتوقف، حاوية القمامة (الزبالة) تحجب مدى الرؤية من اليمين، وذلك يستوجب التمهل.",
        "استمر بالسير كالمعتاد واستعمل الزامور بشكلٍ متواصل بضعة مرات قبل عبورك خط الحاوية."
      ],
      id: 1650
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0179. كيف تتصرف عند اقترابك من المفترق الظاهر في الصورة؟",
      numQues: "0179",
      correctAnswer: "اعبر المكان بسرعة.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3179.jpg",
      choices: [
        "أسرع دائماً عند الدخول إلى المفترق من اجل عدم إعاقة حركة السير.",
        "تمهل وحتى قف عند الضرورة من اجل إعطاء حق الأولوية.",
        "توقف في جميع الحالات.",
        "اعبر المكان بسرعة."
      ],
      id: 1651
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»"
      ],
      title: "1574. ما هي السرعة القصوى المسموح بها عند سياقة تراكتور حمولة في طريق ليست بلدية ؟",
      numQues: "1574",
      correctAnswer: "50كم/ساعة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "حسب وضع الطريق والإشارات.",
        "حسب تعليمات منتج التراكتور.",
        "40كم/ساعة.",
        "50كم/ساعة."
      ],
      id: 1652
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0417. كيف تتصرف حسب الإشارة ؟",
      numQues: "0417",
      correctAnswer: "سر بحذر، شارع مشوش أمامك.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3416.jpg",
      choices: [
        "اعبر المكان بسرعة دون التسبب بعرقلة لعابري الطريق.",
        "تمهل وامتثل لأوامر العمال وأطع جميع الإشارات في موقع الأشغال.",
        "عليك الحصول على إذن بالسفر من المتعهد المنفذ.",
        "سر بحذر، شارع مشوش أمامك."
      ],
      id: 1653
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1053. نُصبت في الطريق الإشارة 405، وفي هذه الطريق هناك دراجة نارية تتجاوز مركبة خصوصية:",
      numQues: "1053",
      correctAnswer: "حسب الإشارة لا يجوز على الإطلاق التجاوز أثناء السير.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3505.jpg",
      choices: [
        "حسب الإشارة لا يجوز للمركبة الخصوصية تجاوز دراجة نارية.",
        "حسب الإشارة يمنع كلاهما من التواجد في هذه الطريق.",
        "حسب الإشارة لا يجوز للدراجة النارية تجاوز مركبة خصوصية.",
        "حسب الإشارة لا يجوز على الإطلاق التجاوز أثناء السير."
      ],
      id: 1654
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0120. بأية شروط يُسمح بالرجوع إلى الخلف؟",
      numQues: "0120",
      correctAnswer: "فقط إذا كانت المركبة مجاورة للرصيف.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "فقط بشرط أن يقف خلف المركبة شخص موجه يستطيع السائق رؤيته.",
        "الرجوع إلى الخلف غير مسموح على الإطلاق.",
        "عند الضرورة , بشرط عدم التسبب في خطر أو إصابة أو عرقلة أو إزعاج لعابري الطريق الآخرين",
        "فقط إذا كانت المركبة مجاورة للرصيف."
      ],
      id: 1655
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1509. كيف نتغلب على مشكلة التعب أثناء السياقة؟",
      numQues: "1509",
      correctAnswer: "بواسطة نشاط جسماني الذي يزيل التعب لساعات عديدة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "بواسطة السياقة بسرعة بطيئة حتى زوال التعب.",
        "بواسطة استراحة قصيرة ووجبة دسمة اللتان تزيلان التعب لفترة طويلة، لزيادة الأمان. ",
        "بواسطة استراحة كافية قبل بدء السياقة والتوقف طويلاً للاستراحة خلال ساعات السياقة.",
        "بواسطة نشاط جسماني الذي يزيل التعب لساعات عديدة."
      ],
      id: 1656
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0294. لمن يُسمح بالوقوف في محطة باص خلاف الباص نفسه؟",
      numQues: "0294",
      correctAnswer: "لجميع أنواع المركبات في ساعات الليل، حسب المسجل في الإشارة المنصوبة في محطة الباص.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "للمركبات الخصوصية، فقط أيام السبت والأعياد، حسب المسجل في الإشارة المنصوبة في محطة الباص.",
        "للمركبات الخصوصية في ساعات الليل، حسب المسجل في الإشارة المنصوبة في محطة الباص. ",
        "للدراجات النارية فقط أيام السبت والأعياد، حسب المسجل في الإشارة المنصوبة في محطة الباص.",
        "لجميع أنواع المركبات في ساعات الليل، حسب المسجل في الإشارة المنصوبة في محطة الباص."
      ],
      id: 1657
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0761. ماذا يتطلب للقيام بالانتقال بين المسالك بدون إعاقة أو خطر؟",
      numQues: "0761",
      correctAnswer: "يجب فقط التأكد من إعطاء الإشارة بواسطة الغماز عند الانتقال.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "يجب القيام بالتواصل مع السائقين الآخرين وإعطاء الإشارة قبل ثلاثة كيلومترات من الانتقال.",
        "إعطاء الإشارة من مسافة ووقت كافيان وفحص المحيط في جميع الاتجاهات وإلقاء نظرة في المرآة قبل بدء الانتقال.",
        "يجب إعطاء الإشارة بواسطة الغماز وبمصابيح المقدمة أثناء الانتقال.",
        "يجب فقط التأكد من إعطاء الإشارة بواسطة الغماز عند الانتقال."
      ],
      id: 1658
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0443. بماذا تُلزم الإشارة ؟",
      numQues: "0443",
      correctAnswer: "بإعطاء حق الأولوية لحركة السير في الطريق القاطعة أمامك.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3443.jpg",
      choices: [
        "عليك إعطاء حق الأولوية للمركبات القادمة من اليمين فقط.",
        "على السائقين في الطريق القاطعة إعطاؤك حق الأولوية.",
        "بالتوقف واخذ حق الأولوية من حركة السير في الطريق القاطعة.",
        "بإعطاء حق الأولوية لحركة السير في الطريق القاطعة أمامك."
      ],
      id: 1659
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1655. كيف يؤثر الواقي الأمامي الشفاف للخوذة(ألقبعة) على ركوب الدراجة النارية في الظلام؟",
      numQues: "1655",
      correctAnswer: "إذا كان هذا الواقي مخدوشاً أو متسخاً، تنكسر أشعة الضوء ويمس بشكلٍ ملحوظ بجودة الرؤية في الظلام.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "الركوب على مركبة تسير على عجلتين بدون واقي شفاف في الخوذة، يساهم دائماً في جودة الرؤية في الظلام.",
        "يثير الواقي أعصاب راكب الدراجة النارية – حتى ولو لم يعترف راكبها بذلك.",
        "إذا كان الواقي الشفاف في الخوذة مخدوشاً أو متسخاً ، يُسهل في ركوب الدراجة النارية في الظلام.",
        "إذا كان هذا الواقي مخدوشاً أو متسخاً، تنكسر أشعة الضوء ويمس بشكلٍ ملحوظ بجودة الرؤية في الظلام."
      ],
      id: 1660
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1444. عند السير في شارع باتجاهين وعندما تكون الرؤية مشوشة:",
      numQues: "1444",
      correctAnswer: "مسموح التجاوز إلا إذا كانت هناك إشارة تمنع التجاوز.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "يجب استعمال الزامور أثناء التجاوز من اجل تنبيه المركبة التي نتجاوزها.",
        "ممنوع التجاوز.",
        "يجب إضاءة مصابيح الوقوف أثناء التجاوز.",
        "مسموح التجاوز إلا إذا كانت هناك إشارة تمنع التجاوز."
      ],
      id: 1661
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0835. ما هي الخطوات المسبقة التي يجب على سائق المركبة إتمامها أثناء الصعود من حاشية الطريق إلى الشارع؟",
      numQues: "0835",
      correctAnswer: "الانحراف بالمركبة بشكلٍ مائل وتشغيل أضواء الطوارئ في المركبة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "فحص وضع حركة السير في الشارع وإعطاء الإشارة المناسبة والصعود المعتدل.",
        "الصعود بشكلٍ مائل إلى الشارع في اقصر وقت ممكن.",
        "إعطاء الإشارة المناسبة والصعود في اقصر وقت ممكن.",
        "الانحراف بالمركبة بشكلٍ مائل وتشغيل أضواء الطوارئ في المركبة."
      ],
      id: 1662
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0749. كيف تؤثر سياقتك على يمين الشارع على مدى الرؤية لدى السائقين الآخرين؟",
      numQues: "0749",
      correctAnswer: "لا توجد أية علاقة بين المحافظة على اليمين ومدى الرؤية.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "لا يوجد أي تأثير على مدى الرؤية: مدى الرؤية المريح يتوفر فقط عن طريق المحافظة على ضعف المسافة المطلوبة.",
        "لا توجد أية علاقة بين السير على يمين الطريق وبين مدى الرؤية.",
        "السير على يمين الشارع يُحسن من مدى الرؤية",
        "لا توجد أية علاقة بين المحافظة على اليمين ومدى الرؤية."
      ],
      id: 1663
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0029. عرِّف 'المحور' في المركبة:",
      numQues: "0029",
      correctAnswer: "محور يُحول الحركة الدائرية من صندوق الغيارات إلى المحرك.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "محور أو مجموعة محاور على عرض المركبة المُرَكب عليها العجلات.",
        "العارضة الخلفية في المركبة والموصل فيها العجلة الاحتياطية للمركبة.",
        "القسم الأمامي من المركبة مُعد لامتصاص أضرار التصادم عند السير بسرعة منخفضة.",
        "محور يُحول الحركة الدائرية من صندوق الغيارات إلى المحرك."
      ],
      id: 1664
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1548. عندما تخرج إلى الشارع من طريق ترابية:",
      numQues: "1548",
      correctAnswer: "أعطِ حق الأولوية للمركبات القادمة من الجهة اليمنى وسافر بسلام، على القادمين من اليسار إعطاؤك حق الأولوية.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "أعطِ حق الأولوية للمركبات في الشارع المعبد.",
        "لا يوجد واجب بإعطاء حق الأولوية، ذلك يعتمد على الرغبة الطيبة للذي يخرج من الطريق الترابية.",
        "أعطِ حق الأولوية للمركبات التي على الشارع فقط إذا كان الشارع باتجاهين.",
        "أعطِ حق الأولوية للمركبات القادمة من الجهة اليمنى وسافر بسلام، على القادمين من اليسار إعطاؤك حق الأولوية."
      ],
      id: 1665
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1142. ما هي السرعة القصوى المسموح بها (بالكم/ساعة) لباص غير الباص الصغير (إلا إذا ذُكر غير ذلك في إشارة)؟",
      numQues: "1142",
      correctAnswer: "في طريق بلدية 50كم/ساعة وفي طريق غير بلدية 80كم/ساعة وفي طريق غير بلدية مع مساحة فاصلة مبنية 90كم/ساعة وفي طريق سريعة 100كم/ساعة.",
      pubDate: "10-11-2011 08:23:14",
      img: "",
      choices: [
        "في طريق بلدية 50كم/ساعة وفي طريق غير بلدية 80كم/ساعة وفي طريق غير بلدية مع مساحة فاصلة مبنية 80كم/ساعة وفي طريق سريعة 100كم/ساعة.",
        "في طريق بلدية 40كم/ساعة وفي طريق غير بلدية 80كم/ساعة وفي طريق غير بلدية مع مساحة فاصلة مبنية 90كم/ساعة وفي طريق سريعة 110كم/ساعة.",
        "في طريق بلدية 50كم/ساعة وفي طريق غير بلدية 70كم/ساعة وفي طريق غير بلدية مع مساحة فاصلة مبنية 90كم/ساعة وفي طريق سريعة 90كم/ساعة.",
        "في طريق بلدية 50كم/ساعة وفي طريق غير بلدية 80كم/ساعة وفي طريق غير بلدية مع مساحة فاصلة مبنية 90كم/ساعة وفي طريق سريعة 100كم/ساعة."
      ],
      id: 1666
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0386. ما معنى الإشارة ؟",
      numQues: "0386",
      correctAnswer: "لا يجوز لمركبة ركاب خصوصية تجاوز شاحنة.",
      pubDate: "10-11-2011 08:23:14",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3386.jpg",
      choices: [
        "ممنوع تجاوز باص.",
        "نهاية مقطع الطريق التي يسري عليها منع التجاوز.",
        "لا يجوز للشاحنات تجاوز مركبة ركاب خصوصية.",
        "لا يجوز لمركبة ركاب خصوصية تجاوز شاحنة."
      ],
      id: 1667
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0658. ما هو مفهوم الوسم (التأشير) الأحمر والأبيض بالتناوب على أحجار الحافة؟",
      numQues: "0658",
      correctAnswer: "مسموح التوقف ويُمنع الوقوف على طول المقطع الموسوم (المؤشر) باللون الأحمر والأبيض.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3658.jpg",
      choices: [
        "ممنوع التوقف أو الوقوف في الشارع بجانب أحجار الحافة، ما عدا الصالون العمومي عند إصعاد وإنزال الركاب.",
        "مكان وقوف منظم بواسطة بطاقات وقوف.",
        "الوسم (التأشير) مُعد لإظهار المساحات الفاصلة وجزر السير ولا يوجد فيه أي تحديد.",
        "مسموح التوقف ويُمنع الوقوف على طول المقطع الموسوم (المؤشر) باللون الأحمر والأبيض."
      ],
      id: 1668
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0183. أين تقف حسب الظاهر في الصورة؟",
      numQues: "0183",
      correctAnswer: "قبل العامود التي نُصبت عليه الإشارة.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3183.jpg",
      choices: [
        "قبل مكان عبور المشاة في جميع الحالات.",
        "على الأقل 10م قبل المفترق.",
        "في مكان تستطيع منه رؤية حركة السير في الطريق القاطعة.",
        "قبل العامود التي نُصبت عليه الإشارة."
      ],
      id: 1669
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0755. في أية حالات نسير في مركبة ركاب خصوصية ليس في المسلك الأيمن؟",
      numQues: "0755",
      correctAnswer: "عندما يكون المسلك الأيمن مخصص لنوع معين من مستعملي الطريق (على سبيل المثال مسلك للمواصلات العمومية).",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "عندما نعبر عن مركبة أخرى من جانبها الأيمن.",
        "عندما تتجاوزنا مركبة أخرى من اليسار.",
        "عندما تعطي المركبة الأخرى الموجودة على يسار الشارع إشارة بأنها تريد البدء بالسير.",
        "عندما يكون المسلك الأيمن مخصص لنوع معين من مستعملي الطريق (على سبيل المثال مسلك للمواصلات العمومية)."
      ],
      id: 1670
    },
    {
      category: "قوانين المرور",
      type: [],
      title: "1810. asd",
      numQues: "810 ",
      correctAnswer: "1",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [],
      id: 1671
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0533. ما معنى الإشارة؟",
      numQues: "0533",
      correctAnswer: "قف و أعط حق الأولوية للمركبة القادمة من الإتجاه المعاكس .",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3443.jpg",
      choices: [
        "خطر شامل.",
        "أعط حق الأولوية لكل مركبة تقترب الى المفترق.",
        "أعط حق الأولوية لحركة السير في الطريق القاطعة أمامك.",
        "قف و أعط حق الأولوية للمركبة القادمة من الإتجاه المعاكس ."
      ],
      id: 1672
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0663. ما معنى الوسم (التأشير) على سطح الشارع؟",
      numQues: "0663",
      correctAnswer: "مكان وقوف للمركبات – مسموح الوقوف فقط حسب العلامات.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3663.jpg",
      choices: [
        "منطقة ممنوع وقوف المركبات فيها.",
        "أماكن توقف للمركبات غير الميكانيكية فقط.",
        "أماكن وقوف وتوقف للمركبات التي تسير على عجلتين .",
        "مكان وقوف للمركبات – مسموح الوقوف فقط حسب العلامات."
      ],
      id: 1673
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0492. ما معنى الاشارات؟",
      numQues: "0492",
      correctAnswer: "ممنوع الاستدارة إلى اليسار للمركبات العمومية فقط.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3492.jpg",
      choices: [
        "ممنوع الاستدارة إلى اليسار والاستدارة إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس).",
        "الاستدارة القريبة إلى اليسار أو الاستدارة القريبة إلى اليمين – ممنوعة على التوالي.",
        "ممنوع الاستدارة إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس) فقط.",
        "ممنوع الاستدارة إلى اليسار للمركبات العمومية فقط."
      ],
      id: 1674
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0292. ما هو الارتفاع الأقصى المسموح به عن سطح الطريق لنقل حمولة في مركبة وزنها الإجمالي من 8000كغم ولغاية 15000كغم.",
      numQues: "0292",
      correctAnswer: "3م.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "4م. ",
        "4,80م.",
        "لا يوجد تحديد للارتفاع.",
        "3م."
      ],
      id: 1675
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«A»"
      ],
      title: "0502. هل يُسمح بدخول دراجة نارية لمقطع الطريق التي نُصبت فيه الإشارة؟",
      numQues: "0502",
      correctAnswer: "نعم، بشرط أن لا تكون لها عربة جانبية.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3501.jpg",
      choices: [
        "ممنوع الدخول منعاً باتاً.",
        "الدخول مسموح في طريق باتجاهين فقط.",
        "ممنوع الدخول في الطريق السريعة فقط.",
        "نعم، بشرط أن لا تكون لها عربة جانبية."
      ],
      id: 1676
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1201. هل يُسمح بتحميل الحقائب في كابينة الركاب في الباص؟",
      numQues: "1201",
      correctAnswer: "مسموح، فقط إذا لم يكن هناك مكان في صندوق حمولة الباص.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "ممنوع - بدون أي رأي لمستخدمي الخدمة.",
        "نعم، هناك واجب بتحميل الحقائب في كابينة الركاب.",
        "نعم، وحسب رأي السائق وفقط في مكان يُمكن من مرور الركاب بحرية ولا يُسبب إعاقة.",
        "مسموح، فقط إذا لم يكن هناك مكان في صندوق حمولة الباص."
      ],
      id: 1677
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1677. متى يسري على السائق واجب إعطاء الإشارة؟",
      numQues: "1677",
      correctAnswer: "عندما يقترب السائق من ملتقى سكة حديد مع حاجز.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "عندما يصل السائق إلى منحدر شديد.",
        "عندما يصل السائق إلى صعود طويل.",
        "عندما ينوي السائق الانحراف عن مسلك سيره.",
        "عندما يقترب السائق من ملتقى سكة حديد مع حاجز."
      ],
      id: 1678
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1672. أي نوع مركبة نرى في الصورة وما هو طولها الأقصى المسموح به في القانون؟",
      numQues: "1672",
      correctAnswer: "مركبة مترابطة، لها كابينة سائق خلف المحرك، والطول الإجمالي الأقصى المسموح به هو 17.60م.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31672.jpg",
      choices: [
        "مركبة موصولة، لها كابينة سائق خلف المحرك، والطول الإجمالي الأقصى المسموح به هو 17.60م.",
        "مركبة مترابطة، لها كابينة سائق خلف المحرك، والطول الإجمالي الأقصى المسموح به هو 16.50م.",
        "مركبة موصولة، لها كابينة سائق خلف المحرك، والطول الإجمالي الأقصى المسموح به هو 16.50م.",
        "مركبة مترابطة، لها كابينة سائق خلف المحرك، والطول الإجمالي الأقصى المسموح به هو 17.60م."
      ],
      id: 1679
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»"
      ],
      title: "1795. هل يجوز لسائق مركبة (عدا مركبة العجزة الكهربائية) بالسير على طول الرصيف؟",
      numQues: "1795",
      correctAnswer: "يجوز، فقط إذا كان يسوق مركبة مع مجرور.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "يجوز، فقط إذا كان يسوق مركبة غير ميكانيكية.",
        "يجوز، بشرط انه يعمل في تنظيف الرصيف أثناء سيره.",
        "يجوز، فقط إذا كان يسوق دراجة نارية.",
        "يجوز، فقط إذا كان يسوق مركبة مع مجرور."
      ],
      id: 1680
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0212. في أية حدود من محطة باص يُمنع إيقاف مركبة؟",
      numQues: "0212",
      correctAnswer: "في حدود 20م قبل إشارة محطة الباص فقط.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "في حدود 20م قبل إشارة محطة باص ولغاية 20م بعد الإشارة، إلا إذا دلت إشارة على غير ذلك.",
        "في حدود 12م قبل إشارة محطة باص، ولغاية 12م بعد الإشارة، إلا إذا دلت علامة على غير ذلك.",
        "في حدود 20م بعد إشارة محطة الباص فقط.",
        "في حدود 20م قبل إشارة محطة الباص فقط."
      ],
      id: 1681
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0330. أية مجرورة يستطيع جرها صاحب رخصة سياقة من الدرجة B في مركبة سُمح لها بالجر؟",
      numQues: "0330",
      correctAnswer: "لا يجوز لصاحب رخصة كما ذُكر بجر أية مجرورة على الإطلاق.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "مجرورة لا يزيد وزنها الإجمالي المسموح به عن 1500كغم.",
        "مجرورة يزيد وزنها الإجمالي المسموح به عن 1500كغم.",
        "مجرورة لا يزيد وزنها الإجمالي المسموح به عن 2000كغم.",
        "لا يجوز لصاحب رخصة كما ذُكر بجر أية مجرورة على الإطلاق."
      ],
      id: 1682
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0065. هل يجب إطاعة أوامر شرطي، حتى ولو كان الأمر أو الإشارة مخالفين لإشارات السير؟",
      numQues: "0065",
      correctAnswer: "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'ممنوع الدخول'.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "نعم، الإطاعة واجبة، وبحذر شديد.",
        "كلا، لا يوجد واجب بالإطاعة.",
        "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'قف'.",
        "نعم، ما عدا الأمر الذي يتنافى مع أحكام الإشارة 'ممنوع الدخول'."
      ],
      id: 1683
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1460. ما هي أخطار تغيير الغيارات أثناء السياقة عند سياقة مركبة ثقيلة في منحدر شديد؟",
      numQues: "1460",
      correctAnswer: "لا توجد خطورة من تغيير الغيارات ولا توجد أهمية لغيار معشق، طالما كان احد الغيارات معشقاً.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "هناك خطر من أن لا يتم تعشيق الغيار وتبقى المركبة في الغيار النيوترال.",
        "لا توجد خطورة من جراء تغيير الغيارات في منحدر شديد.",
        "لا يوجد خطر، تغيير الغيار الواطئ إلى غيار عالي في منحدر شديد يمكن من زيادة سرعة المركبة.",
        "لا توجد خطورة من تغيير الغيارات ولا توجد أهمية لغيار معشق، طالما كان احد الغيارات معشقاً."
      ],
      id: 1684
    },
    {
      category: "إشارات المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»"
      ],
      title: "0359. أية إشارة سير تحدد دخول مركبة مع أو بدون حمولة مرتفعة؟",
      numQues: "0359",
      correctAnswer: "416",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3359.jpg",
      choices: [
        "150",
        "417",
        "145",
        "416"
      ],
      id: 1685
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0382. أية إشارة تأمر بعبور مكان موسوم (مؤشر) من جهته اليسرى فقط؟",
      numQues: "0382",
      correctAnswer: "215",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3382.jpg",
      choices: [
        "213",
        "214",
        "123",
        "215"
      ],
      id: 1686
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1665. لا ينقل سائق التراكتور راكباً إضافياً على التراكتور:",
      numQues: "1665",
      correctAnswer: "إلا بعد أن اجتاز بنجاح امتحان نظري في طريقة النقاط في المرور.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "إلا بعد انقضاء سنة من تاريخ صدور رخصة سياقة التراكتور له.",
        "إلا بعد انقضاء 3 أشهر من تاريخ صدور رخصة سياقة التراكتور له.",
        "إلا بعد انقضاء 6 أشهر من تاريخ صدور رخصة سياقة التراكتور له.",
        "إلا بعد أن اجتاز بنجاح امتحان نظري في طريقة النقاط في المرور."
      ],
      id: 1687
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0222. بأية شروط يجوز إيقاف مركبة ليس بشكلٍ موازي للرصيف (وقوف بشكل زاوية)؟",
      numQues: "0222",
      correctAnswer: "مسموح في طريق داخل المدن فقط.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "إذا كانت هناك علامة على الشارع وحسب العلامة.",
        "مسموح في طريق داخل المدن وفقط في نهاية كل أسبوع.",
        "ممنوع في جميع الأحوال.",
        "مسموح في طريق داخل المدن فقط."
      ],
      id: 1688
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0785. ما معنى الإشارة؟",
      numQues: "0785",
      correctAnswer: "مسلك خاص مُعد للمواصلات العمومية فقط.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3785.jpg",
      choices: [
        "اعبر العائق من الجهة اليمنى.",
        "سر إلى اليمين فقط.",
        "انتقل إلى المسلك المجاور الأيمن عندما تسمح حالة حركة السير بذلك.",
        "مسلك خاص مُعد للمواصلات العمومية فقط."
      ],
      id: 1689
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1086. كيف يتصرف سائق تراكتور مجهز 'بكفة' عند إيقاف التراكتور؟",
      numQues: "1086",
      correctAnswer: "يقوم بإنزال الكفة حتى الأرض.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "يتأكد بأن الكفة مرفوعة كي لا يصطدم بها.",
        "يُبقي الكفة على ارتفاع المقود لكي يتوازن التراكتور.",
        "لا توجد أهمية لوضع الكفة ولا توجد تعليمات خاصة بشأنها.",
        "يقوم بإنزال الكفة حتى الأرض."
      ],
      id: 1690
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0930. ما هو الشيء الذي عليك التأكد منه، بين سائر الأمور، قبل أن ترفع المركبة لتغيير عجل؟",
      numQues: "0930",
      correctAnswer: "أن يكون الهاندبريك محلولاً طيلة فترة تغيير العجلات.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "أن تضمن عدم تحرك المركبة من مكانها.",
        "أن يستمر محرك المركبة في العمل في الغيار النيوترال.",
        "أن يكون الهاندبريك محلولاً حتى فك العجل وتركيب عجل جديد.",
        "أن يكون الهاندبريك محلولاً طيلة فترة تغيير العجلات."
      ],
      id: 1691
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1226. لمن يجوز تصليح أو معايرة عداد الصالون العمومي؟",
      numQues: "1226",
      correctAnswer: "فقط منتج العداد مخول بتصليح العداد.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "منتج المركبة فقط.",
        "للشخص الذي صادقت عليه السلطة كمقدم خدمة معتمد. ",
        "كهربائي معتمد.",
        "فقط منتج العداد مخول بتصليح العداد."
      ],
      id: 1692
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1578. أجهزة السيطرة على المركبة هي:",
      numQues: "1578",
      correctAnswer: "الفرامل والمقود وتكييف الهواء.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "الفرامل والمقود وأجهزة الصوت.",
        "الفرامل والمقود وأجهزة التسارع.",
        "المقود والتسارع وتكييف الهواء.",
        "الفرامل والمقود وتكييف الهواء."
      ],
      id: 1693
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0684. كيف يتصرف سائق المركبة المقترب من الإشارة؟",
      numQues: "0684",
      correctAnswer: "يتمهل في المكان الذي تجري فيه أشغال في الطريق ويستمر بسيره.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3684.jpg",
      choices: [
        "يتمهل قبل المفترق ويستمر بسيره فقط بالاتجاهات المؤشرة بالأسهم.",
        "يتوقف قبل الإشارة ويستدير إلى اليمين أو إلى اليسار.",
        "يتجاوز الإشارة عن يمينها أو عن يسارها ويستمر إلى الأمام.",
        "يتمهل في المكان الذي تجري فيه أشغال في الطريق ويستمر بسيره."
      ],
      id: 1694
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1744. ما هو جهاز مراقبة التوازن (الثبات) الالكتروني في المركبة إي.إس.بي (E.S.P):",
      numQues: "1744",
      correctAnswer: "جهاز يمنع إقفال عجلات المركبة عند الفرملة الفجائية، وبهذا تتم المحافظة على عمل مقود المركبة.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "جهاز يمنع إمكانية حدوث خلل في جهاز فرامل المركبة.",
        "جهاز يمنع إمكانية حدوث خلل في جهاز مقود المركبة.",
        "جهاز يصحح أخطاء السائق عند الفرملة يمنع التزحلق ويساعد على زيادة توازن المركبة.",
        "جهاز يمنع إقفال عجلات المركبة عند الفرملة الفجائية، وبهذا تتم المحافظة على عمل مقود المركبة."
      ],
      id: 1695
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1713. كيف يتصرف السائق إذا كانت لمبة مراقبة جهاز الفرامل في لوحة الساعات (التابلو) مضاءة؟",
      numQues: "1713",
      correctAnswer: "ينتظر لغاية الصيانة الموسمية للمركبة، وحينها فقط يفحص هذه المشكلة.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "يتوقف ولا يستمر بسيره في المركبة.",
        "يسير بسرعة بطيئة حتى الكراج – ليس أكثر من 10كم/ساعة.",
        "يتجاهل الأمر ويستمر بسيره العادي، لمبة المراقبة ليست إثباتا على أي خلل كان.",
        "ينتظر لغاية الصيانة الموسمية للمركبة، وحينها فقط يفحص هذه المشكلة."
      ],
      id: 1696
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1004. أي جهاز يساعد في حفظ توازن المركبة عند التزحلق وخطر الانقلاب؟",
      numQues: "1004",
      correctAnswer: "جهاز إعطاء الإشارة.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "جهاز مراقبة الثبات 'إي.إس.بي' (E.S.P).",
        "جهاز مراقبة السرعة.",
        "جهاز مراقبة استهلاك الوقود في المركبة.",
        "جهاز إعطاء الإشارة."
      ],
      id: 1697
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0607. ما معنى الإشارة؟",
      numQues: "0607",
      correctAnswer: "تحديد حركة السير في المسالك أمامك.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3607.jpg",
      choices: [
        "ممنوع السير إلى الأمام للمركبة العمومية.",
        "ممنوع لمن يسير في المسلك الأيمن الانحراف إلى مسلك آخر.",
        "أمامك شارع باتجاه واحد.",
        "تحديد حركة السير في المسالك أمامك."
      ],
      id: 1698
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0673. ما معنى الإشارة الضوئية (ضوء احمر متقطع بالتناوب)؟",
      numQues: "0673",
      correctAnswer: "استعد للتوقف قبل المفترق الذي فيه إشارات ضوئية (رمزور).",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3673.jpg",
      choices: [
        "توقف قبل المفترق الذي فيه إشارات ضوئية (رمزورات).",
        "إشارة ضوئية خاصة (رمزور خاص) قبل ملتقى سكة حديد: توقف قبل الملتقى ولا تستمر في طريقك طالما كان الضوء الأحمر متقطعاً.",
        "زد من سرعة السير قبل الملتقى.",
        "استعد للتوقف قبل المفترق الذي فيه إشارات ضوئية (رمزور)."
      ],
      id: 1699
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0652. ما هو المفهوم عندما يُرسم خط اصفر مستقيم إلى الأمام؟",
      numQues: "0652",
      correctAnswer: "مسموح السير إلى الأمام لأية مركبة، لكن يجب إعطاء حق الأولوية للباصات.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3652.jpg",
      choices: [
        "يجوز فقط للمركبة العمومية الاستمرار بالسير إلى الأمام في المفترق القريب.",
        "يجوز لجميع المركبات التي تنقل ستة ركاب على الأقل الاستمرار بالسير إلى الأمام.",
        "مسموح للمركبات الخصوصية بالسير إلى الأمام وبحذر.",
        "مسموح السير إلى الأمام لأية مركبة، لكن يجب إعطاء حق الأولوية للباصات."
      ],
      id: 1700
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0570. إذا نُصبت هذه الإشارة؟",
      numQues: "0570",
      correctAnswer: "ممنوع إنزال ركاب في حدود الإشارة.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3215.jpg",
      choices: [
        "مسموح إصعاد ما لا يزيد عن ستة ركاب في كل صالون عمومي.",
        "مسموح لأية مركبة التوقف من اجل إنزال الركاب فقط.",
        "مسموح لأية مركبة بالوقوف وانتظار الركاب.",
        "ممنوع إنزال ركاب في حدود الإشارة."
      ],
      id: 1701
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1237. ما معنى الإشارة؟",
      numQues: "1237",
      correctAnswer: "بعد 2500م يبدأ صعود شديد.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31237.jpg",
      choices: [
        "منحدر شديد يبدأ على بعد حوالي 2500م أمامك.",
        "نهاية مقطع منحدر طوله 2500م.",
        "منحدر شديد طوله 2500م يبدأ الآن.",
        "بعد 2500م يبدأ صعود شديد."
      ],
      id: 1702
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0001. على من يقع واجب معرفة قوانين السير والعمل بموجبها ؟",
      numQues: "0001",
      correctAnswer: "على المشاة فقط.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "على من يقود مركبة فقط.",
        "على كل من يستعمل الطريق.",
        "على السائقين المهنيين فقط.",
        "على المشاة فقط."
      ],
      id: 1703
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0747. حسب القانون، عندما تقف قبل المفترق بالضوء الأحمر وهناك مركبة امن تستعمل صافرة الإنذار (السيرينا) وتُشغل أضواء متقطعة من خلفك:",
      numQues: "0747",
      correctAnswer: "يجب عليك الصعود على الرصيف من اجل إخلاء الطريق لمركبة الأمن.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "يجب عليك الدخول إلى المفترق بالضوء الأحمر.",
        "لا يجوز لك الدخول إلى المفترق بالضوء الأحمر.",
        "مسموح لك الدخول إلى المفترق بالضوء الأحمر. ",
        "يجب عليك الصعود على الرصيف من اجل إخلاء الطريق لمركبة الأمن."
      ],
      id: 1704
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0882. هل يجوز، حسب ما يظهر في الصورة، الانحراف إلى المسلك المعاكس؟",
      numQues: "0882",
      correctAnswer: "نعم، النظر في المرآة يجيز الانحراف إلى المسلك المعاكس، لأنه لا يوجد احد يسير في الخلف.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3882.jpg",
      choices: [
        "ممنوع بسبب وجود الخط الفاصل المتواصل المزدوج على سطح الشارع.",
        "نعم، تشغيل الغماز يلغي ضرورة النظر في المرآة.",
        "نعم، السائق نظر بالفعل في المرآة ولم يصل احد من خلفه.",
        "نعم، النظر في المرآة يجيز الانحراف إلى المسلك المعاكس، لأنه لا يوجد احد يسير في الخلف."
      ],
      id: 1705
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0416. ما معنى الإشارة؟",
      numQues: "0416",
      correctAnswer: "أشغال تابعة للآثار أمامك.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3416.jpg",
      choices: [
        "انتبه خطوط تباطؤ (مطبات) أمامك.",
        "أشغال في الطريق.",
        "انتبه حجارة متدحرجة.",
        "أشغال تابعة للآثار أمامك."
      ],
      id: 1706
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0605. ما معنى الإشارة؟",
      numQues: "0605",
      correctAnswer: "المسافة بالكيلومترات لغاية الشارع القريب.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3605.jpg",
      choices: [
        "رقم يشير إلى طريق سريعة.",
        "المسافة بالكيلومترات لغاية المفترق القريب.",
        "رقم يشير إلى طريق إقليمية.",
        "المسافة بالكيلومترات لغاية الشارع القريب."
      ],
      id: 1707
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«1»"
      ],
      title: "1094. وظيفة قفل الدفرنسيال (الباككس) في التراكتور هي:",
      numQues: "1094",
      correctAnswer: "المساعدة على المحافظة على الاتجاه عند السير في طريق مستقيمة.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "المساعدة أثناء فرملة الطوارئ.",
        "المساعدة على التخلص من التغريز أو من تزحلق احد العجلات.",
        "منع تزحلق التراكتور عند الانعطاف الحاد.",
        "المساعدة على المحافظة على الاتجاه عند السير في طريق مستقيمة."
      ],
      id: 1708
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1623. كيف نخلق حيز أمان ناجع من الأمام ومن الخلف ومن الجوانب عند ركوب الدراجة النارية مع شركاء إضافيين؟",
      numQues: "1623",
      correctAnswer: "بواسطة البقاء على يمين الشارع أو المسلك والسير بسرعة موحدة طيلة الوقت .",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "بواسطة التواجد في وسط الطريق والسفر بسرعة.",
        "بواسطة اختيار مسلك وسرعة سير ومكان بصورة صحيحة وتكييفهم للشركاء ولوضع حركة السير من حولنا.",
        "بواسطة التأشير للمركبات الأخرى بأن تبتعد.",
        "بواسطة البقاء على يمين الشارع أو المسلك والسير بسرعة موحدة طيلة الوقت ."
      ],
      id: 1709
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0459. ما معنى الإشارة؟",
      numQues: "0459",
      correctAnswer: "آنت تقترب من محطة قطارات.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3459.jpg",
      choices: [
        "مكان ملتقى واحد لسكة حديد، حركة القطارات بالاتجاهين.",
        "مكان ملتقى سكة حديد، أكثر من خط واحد.",
        "انتبه! حاجز قطار.",
        "آنت تقترب من محطة قطارات."
      ],
      id: 1710
    },
    {
      category: "إشارات المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "0694. ما معنى الإشارة؟",
      numQues: "0694",
      correctAnswer: "ممنوع وقوف مركبة تجارية يزيد وزنها الإجمالي المسموح به عن 10000كغم في المنطقة التي نُصبت الإشارة على مدخلها.",
      pubDate: "10-11-2011 08:23:15",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3694.jpg",
      choices: [
        "ممنوع وقوف مركبة تجارية يزيد وزنها الإجمالي المسموح به عن 4000كغم في المنطقة التي نُصبت الإشارة على مدخلها.",
        "ممنوع وقوف أية مركبة تجارية في المنطقة التي نُصبت الإشارة على مدخلها.",
        "ممنوع وقوف مركبة تجارية يزيد وزنها الإجمالي المسموح به عن 8000كغم فقط.",
        "ممنوع وقوف مركبة تجارية يزيد وزنها الإجمالي المسموح به عن 10000كغم في المنطقة التي نُصبت الإشارة على مدخلها."
      ],
      id: 1711
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0444. السرعة المعقولة في طريق سريعة هي:",
      numQues: "0444",
      correctAnswer: "سرعة يقررها السائق بشرط أن لا تزيد عن السرعة القصوى المسموح بها.",
      pubDate: "10-11-2011 08:23:15",
      img: "",
      choices: [
        "ليس اقل من السرعة القصوى المسموح بها، في جميع الأحوال",
        "السرعة التي تأخذ بعين الاعتبار وضع حركة السير ولا تزيد عن السرعة القصوى المسموح بها في هذه الطريق.",
        "السرعة التي تعطيك مدى سير أقصى، بشرط أن لا تزيد عن السرعة القصوى المسموح بها. ",
        "سرعة يقررها السائق بشرط أن لا تزيد عن السرعة القصوى المسموح بها."
      ],
      id: 1712
    },
    {
      category: "إشارات المرور",
      type: [
        "«D»"
      ],
      title: "1267. هل يُسمح لباص صغير خصوصي وزنه الإجمالي 2700كغم بالوقوف في حدود هذه الإشارة؟",
      numQues: "1267",
      correctAnswer: "كلا.",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3627.jpg",
      choices: [
        "نعم.",
        "نعم بين الساعات 21:00 لغاية 05:30 أيام عُطَل الأعياد فقط.",
        "فقط في نهاية كل أسبوع.",
        "كلا."
      ],
      id: 1713
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0606. ما هو شكل إشارات التحذير؟",
      numQues: "0606",
      correctAnswer: "مربع أو مستطيل.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "بشكلٍ عام مثلث رأسه إلى أسفل.",
        "بشكلٍ عام مثلث رأسه إلى أعلى.",
        "دائرة غالباً.",
        "مربع أو مستطيل."
      ],
      id: 1714
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»",
        "«C»",
        "«C1»"
      ],
      title: "1433. كيف يجب إيقاف مركبة تجارية وزنها الإجمالي المسموح به أكثر من 5000كغم، في صعود وفي شارع فيه أحجار حافة؟",
      numQues: "1433",
      correctAnswer: "يجب توجيه عجلات المركبة نحو أحجار الحافة ووضع أحذية الأمان خلف العجلات الخلفية.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "يجب توجيه العجلات الأمامية نحو مركز الشارع وتعشيق الغيار الأمامي ووضع أحذية الأمان خلف العجلات الخلفية.",
        "يجب توجيه عجلات المركبة نحو مركز الشارع وتعشيق الغيار الخلفي ووضع أحذية الأمان خلف العجلات الخلفية.",
        "يجب فرملة عجلات المركبة بشكلٍ صحيح ووضع أحذية الأمان خلف عجلات المركبة وترك المركبة بغيار نيوترال.",
        "يجب توجيه عجلات المركبة نحو أحجار الحافة ووضع أحذية الأمان خلف العجلات الخلفية."
      ],
      id: 1715
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1183. أنت تسوق مركبة ركاب خصوصية وتقترب خلف راكب دراجة هوائية يسير على يمين الشارع:",
      numQues: "1183",
      correctAnswer: "يُستحسن استعمال الزامور قبل وصولك إليه وأيضاً عندما تتجاوزه لكي تنبهه.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "يُستحسن العبور عنه بسرعة، لكي لا تؤثر عليه هبة الريح. ",
        "يُستحسن العبور عن يساره، بعيداً على قدر الامكان.",
        "يُستحسن العبور عنه ببطء وعندما تكون قريباً منه.",
        "يُستحسن استعمال الزامور قبل وصولك إليه وأيضاً عندما تتجاوزه لكي تنبهه."
      ],
      id: 1716
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«D»"
      ],
      title: "1277. ما هي الأخطار المتوقعة من الفرملة الفجائية عند سواقة باص؟",
      numQues: "1277",
      correctAnswer: "سخونة الفرامل زيادة عن اللازم.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "إصابة ركاب الباص.",
        "التزحلق والانقلاب في الطرق الصاعدة.",
        "الضرر من مركبة واقفة.",
        "سخونة الفرامل زيادة عن اللازم."
      ],
      id: 1717
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1211. يجوز لمركبة معاق (عليها لاصقة مشلول بالأرجل) أن تسير في المسلك المعد للمواصلات العمومية):",
      numQues: "1211",
      correctAnswer: "فقط عندما يكون المعاق نفسه سائق المركبة.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "من اجل السفر إلى الكراج فقط.",
        "وحتى وان كان يسوق المركبة شخص يرافق المعاق.",
        "حتى وان لم يكن المعاق في المركبة.",
        "فقط عندما يكون المعاق نفسه سائق المركبة."
      ],
      id: 1718
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0589. كيف تتصرف حسب الإشارة؟",
      numQues: "0589",
      correctAnswer: "استمر في سيرك، لك حق الأولوية ولا يجب عليك التمهل.",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3579.jpg",
      choices: [
        "تمهل وافحص إذا كانت المركبة القادمة من الجهة المقابلة تعطيك حق الأولوية حسب الأصول.",
        "توقف ودع المركبة القادمة من الجهة المقابلة تواصل سيرها.",
        "استعمل الزامور وأشر للمركبة القادمة من الجهة المقابلة بأنك تنوي إعطائها حق الأولوية.",
        "استمر في سيرك، لك حق الأولوية ولا يجب عليك التمهل."
      ],
      id: 1719
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0139. ما هي ' السرعة المعقولة '؟",
      numQues: "0139",
      correctAnswer: "أية سرعة كانت بشرط أن يسيطر السائق سيطرة تامة على المركبة.",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3139.jpg",
      choices: [
        "السرعة المعقولة التي تمكن السائق من السيطرة على المركبة مع اخذ جميع الظروف والإشارات بعين الاعتبار.",
        "في شارع معبد – 80كم/ساعة، في طريق ترابية 40كم/ساعة",
        "السرعة القصوى التي تستطيع المركبة الوصول إليها في الظروف القائمة.",
        "أية سرعة كانت بشرط أن يسيطر السائق سيطرة تامة على المركبة."
      ],
      id: 1720
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0540. كيف تتصرف حسب الإشارة؟",
      numQues: "0540",
      correctAnswer: "سر إلى اليسار – استدر من خلف الإشارة. سهم بلون اصفر يشير إلى اتجاه السير للمركبات البطيئة فقط.",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3540.jpg",
      choices: [
        "سر إلى اليسار – استدر من خلف الإشارة. سهم بلون اصفر يشير إلى اتجاه السير لمركبات الركاب الخصوصية فقط.",
        "سر إلى اليمين واستدر من أمام الإشارة.",
        "سر إلى اليسار واستدر من خلف الإشارة.",
        "سر إلى اليسار – استدر من خلف الإشارة. سهم بلون اصفر يشير إلى اتجاه السير للمركبات البطيئة فقط."
      ],
      id: 1721
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1220. 'نقل تلاميذ' في الباص هو:",
      numQues: "1220",
      correctAnswer: "أي نقل للأولاد أو نقل للطلاب.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "نقل أولاد للمدرسة أو لنشاط منظم لها ما عدا على خط خدمة.",
        "نقل أولاد عمرهم لغاية 16 سنة.",
        "أي نقل للأولاد في الباص وحتى على خط خدمة.",
        "أي نقل للأولاد أو نقل للطلاب."
      ],
      id: 1722
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0762. ما هي الطريقة الصحيحة للانتقال من مسلك إلى مسلك آخر؟",
      numQues: "0762",
      correctAnswer: "يُنفذ الانتقال بين المسالك على مرحلتين: مرحلة الانحراف وبعدها التواصل مع السائقين الآخرين.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "الفحص والنظر في المرايا وفحص المسلك المنوي الانتقال إليه وتأمين إمكانية الانتقال ثم الانحراف المعتدل (بشكلٍ مائل) من مسلك إلى مسلك.",
        "يجب أن يُنفذ الانتقال بشكلٍ مائل وقصير جداً وفي وقت قصير على قدر الإمكان. ",
        "يُنفذ الانتقال بين المسالك على مرحلتين: مرحلة الانحراف وبعدها مرحلة الإشارة باليد.",
        "يُنفذ الانتقال بين المسالك على مرحلتين: مرحلة الانحراف وبعدها التواصل مع السائقين الآخرين."
      ],
      id: 1723
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1308. ما معنى 'الحمولة المسموح بها' بالنسبة لمركبة من نوع شحن؟",
      numQues: "1308",
      correctAnswer: "الوزن الإجمالي المسموح به للمركبة.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "الوزن الذاتي (الفارغ) للمركبة.",
        "الوزن الأقصى في الكغم الذي يُسمح بتحميله على المركبة.",
        "وزن المركبة مع وزن الحمولة.",
        "الوزن الإجمالي المسموح به للمركبة."
      ],
      id: 1724
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0737. كيف نؤمن مركبة واقفة مجهزة بصندوق غيارات أوتوماتكية ا؟",
      numQues: "0737",
      correctAnswer: "ننقل عصا الغيارات إلى غيار الوقوف (P) ونستعمل فرامل الوقوف (هاندبريك).",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "ننقل عصا الغيارات إلى الغيار الأول (1) ونستعمل فرامل الوقوف (هاند بريك). ",
        "ننقل عصا الغيارات إلى غيار الرجوع إلى الخلف (R) ونستعمل فرامل الوقوف (هاند بر يك).",
        "ننقل عصا الغيارات إلى غيار النيوترال (N) ونستعمل فرامل الوقوف (هاند بريك).",
        "ننقل عصا الغيارات إلى غيار الوقوف (P) ونستعمل فرامل الوقوف (هاندبريك)."
      ],
      id: 1725
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0039. ما هو تعريف 'مركبة قديمة' بالنسبة لمركبة ركاب خصوصية؟",
      numQues: "0039",
      correctAnswer: "مركبة لا تتوفر فيها شروط المواصفات الإسرائيلية الملزمة.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "مركبة ركاب خصوصية مضى على سنة إنتاجها 19 سنة.",
        "مركبة ركاب خصوصية مضى على سنة إنتاجها 15 سنة.",
        "لا يشمل تعريف 'المركبة القديمة' مركبة الركاب الخصوصية.",
        "مركبة لا تتوفر فيها شروط المواصفات الإسرائيلية الملزمة."
      ],
      id: 1726
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0083. 'المساحة الفاصلة' هي:",
      numQues: "0083",
      correctAnswer: "مساحة مُعدة للهرب وقت الخطر وتم التأشير عليها لهذا الغرض بواسطة إشارة خاصة مُعدة لذلك.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "مساحة يُمنع الوقوف عليها إلا إذا سمحت إشارة بذلك فقط.",
        "مساحة مُعدة للوقوف عليها في طريق داخل المدن.",
        "مساحة مُعدة لوقوف المركبات التي تسير على عجلتين في طريق داخل المدن ، دون الحاجة إلى إشارة خاصة.",
        "مساحة مُعدة للهرب وقت الخطر وتم التأشير عليها لهذا الغرض بواسطة إشارة خاصة مُعدة لذلك."
      ],
      id: 1727
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1609. ما هي العوامل الأساسية التي تؤثر على قدرة راكب الدراجة النارية في اكتشاف العوائق في الطريق؟",
      numQues: "1609",
      correctAnswer: "الحالة الميكانيكية للدراجة النارية.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "مهارة راكب الدراجة النارية وكيفية جلوسه.",
        "حالة حركة السير حول الدراجة النارية.",
        "سلامة الفرامل والإطارات.",
        "الحالة الميكانيكية للدراجة النارية."
      ],
      id: 1728
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0843. كيف يتسبب تزحلق المركبة على سطح الشارع؟",
      numQues: "0843",
      correctAnswer: "عندما يكون هناك اهتراء سريع في الكلاتش أو في صندوق الغيارات.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "محرك المركبة متهرئ ولا يستطيع تثبيت المركبة.",
        "بسبب الاستعمال المفرط في تبديل الغيارات.",
        "تتغلب قوة الفرملة أو القصور الذاتي على قوة تماسك الإطار مع الشارع.",
        "عندما يكون هناك اهتراء سريع في الكلاتش أو في صندوق الغيارات."
      ],
      id: 1729
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»"
      ],
      title: "1309. ما هو البروز الأقصى المسموح به لطول الحمولة من الخلف في مركبة تجارية يزيد وزنها الإجمالي المسموح به عن 15000كغم؟",
      numQues: "1309",
      correctAnswer: "ثلث طول مسطح التحميل من الأمام ومن الخلف – فقط إذا كانت الحمولة وحدة واحدة.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "ثلث طول مسطح التحميل، فقط إذا كانت الحمولة وحدة طولية واحدة.",
        "لغاية متر واحد من الأمام ومتر واحد من الخلف فقط.",
        "ثلث طول مسطح التحميل من الأمام وأيضاً من الخلف - للحمولة المقسمة إلى قسمين.",
        "ثلث طول مسطح التحميل من الأمام ومن الخلف – فقط إذا كانت الحمولة وحدة واحدة."
      ],
      id: 1730
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0226. هل يُسمح بفتح أبواب المركبة أثناء سيرها؟",
      numQues: "0226",
      correctAnswer: "ممنوع منعاً باتاً.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "مسموح، بشرط أن نسير بتمهل.",
        "مسموح عند نقل حمولة طويلة.",
        "مسموح عندما لا يكون ركاب في المركبة.",
        "ممنوع منعاً باتاً."
      ],
      id: 1731
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1400. أنت تسوق مركبة يبلغ عرضها 220سم، هل يجب عليك إضاءة مصابيح العرض (مصابيح الجناح) في 'وقت الإنارة'؟",
      numQues: "1400",
      correctAnswer: "نعم، فقط بين التواريخ 11/1 ولغاية 3/ 31 من السنة التالية.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "كلا، مصابيح العرض مُعدة للإنارة فقط إذا كانت المركبة واقفة لأي سبب كان.",
        "نعم.",
        "كلا، مصابيح العرض مُعدة للتنبيه بأن المركبة واقفة من جراء إصابتها بخلل.",
        "نعم، فقط بين التواريخ 11/1 ولغاية 3/ 31 من السنة التالية."
      ],
      id: 1732
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0697. أنت تسوق المركبة رقم (3)، لمن يجب عليك إعطاء حق الأولوية؟",
      numQues: "0697",
      correctAnswer: "للمركبة الزرقاء (1).",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3697.jpg",
      choices: [
        "للمركبة الحمراء (2) وبعدها للمركبة الزرقاء (1).",
        "ليس لأحد، على البقية إعطاؤك حق الأولوية (3).",
        "للمركبة الحمراء(2)",
        "للمركبة الزرقاء (1)."
      ],
      id: 1733
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1783. عندما تُنصب إشارة تمنع الاستدارة إلى اليسار في المفترق:",
      numQues: "1783",
      correctAnswer: "الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) مسموحة لمركبات الركاب الخصوصية فقط.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "جميع الإجابات صحيحة.",
        "مسموح الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) إذا لا يعرقل ذلك حركة السير ولا توجد إشارة أو علامة تمنع مثل هذه الاستدارة. ",
        "مسموح الاستدارة إلى اليسار للسير في الاتجاه المعاكس (حذوة فرس) فقط إذا رُسم في المسلك سهم يشير إلى اليمين.",
        "الاستدارة للسير في الاتجاه المعاكس (حذوة فرس) مسموحة لمركبات الركاب الخصوصية فقط."
      ],
      id: 1734
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1540. السرعة المعقولة هي:",
      numQues: "1540",
      correctAnswer: "السرعة الملائمة للأوضاع والظروف حتى ولو تجاوزت قليلاً السرعة القصوى المسموح بها.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "السرعة الملائمة للأوضاع والظروف ولا تتجاوز السرعة القصوى المسموح بها.",
        "السرعة التي يحث عليها الركاب للسفر بموجبها، الركاب صادقون دائماً.",
        "السرعة القصوى المسموح بها في تلك الطريق هي السرعة المعقولة في جميع الظروف.",
        "السرعة الملائمة للأوضاع والظروف حتى ولو تجاوزت قليلاً السرعة القصوى المسموح بها."
      ],
      id: 1735
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0744. عندما تسير في طريق ضيقة في منحدر ، عليك إعطاء حق الأولوية للمركبة الصاعدة في الحالات التالية:",
      numQues: "0744",
      correctAnswer: "فقط إذا كان وزن المركبة الصاعدة أكثر من 4 طن.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "فقط إذا نُصبت إشارة منحدر خطر.",
        "عند عدم وجود إمكانية المرور للمركبتين سوياً في المقطع الضيق.",
        "فقط في طريق بلدية.",
        "فقط إذا كان وزن المركبة الصاعدة أكثر من 4 طن."
      ],
      id: 1736
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0717. ما هو ترتيب دخول المركبات إلى المفترق حسب القانون؟",
      numQues: "0717",
      correctAnswer: "المركبة الحمراء (1)، مركبتك (3)، الدراجة النارية (2).",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3717.jpg",
      choices: [
        "الدراجة النارية (2)، المركبة الحمراء (1)، مركبتك (3).",
        "الدراجة النارية (2)، مركبتك (3)، المركبة الحمراء (1).",
        "المركبة الحمراء (1)، الدراجة النارية (2)، مركبتك (3).",
        "المركبة الحمراء (1)، مركبتك (3)، الدراجة النارية (2)."
      ],
      id: 1737
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1080. ما هي الفحوصات العادية التي على السائق إجراؤها في المركبة؟",
      numQues: "1080",
      correctAnswer: "فحص السوائل والزيوت وفحص ضغط الهواء في الإطارات وفحص سلامة الأضواء وماسحات الزجاج.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "فحص آخر قراءة لعدد الكيلومترات في المركبة.",
        "فحص الزجاج وفحص صندوق الحمولة وفحص سلامة الأضواء وماسحات الزجاج. ",
        "فحص وثائق المركبة.",
        "فحص السوائل والزيوت وفحص ضغط الهواء في الإطارات وفحص سلامة الأضواء وماسحات الزجاج."
      ],
      id: 1738
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1144. كم مطرقة لتحطيم الزجاج يجب أن تكون في الباص؟",
      numQues: "1144",
      correctAnswer: "يجب أن تكون مطرقة واحدة بجانب كل باب على شمعة الباب من الجهة اليسرى.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "مطرقتان على الأقل.",
        "أربع مطارق.",
        "حسب حجم الباص.",
        "يجب أن تكون مطرقة واحدة بجانب كل باب على شمعة الباب من الجهة اليسرى."
      ],
      id: 1739
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1748. ممنوع إيقاف مركبة في حدود:",
      numQues: "1748",
      correctAnswer: "15م بعد خط",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "12م قبل ممر للمشاة",
        "15م بعد المفترق.",
        "30م بعد ملتقى سكة حديد.",
        "15م بعد خط"
      ],
      id: 1740
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1356. تضيء مصابيح المقدمة في المركبة الطريق بضوء:",
      numQues: "1356",
      correctAnswer: "لونه موحد، احمر أو اصفر فاتح.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "ابيض أو اصفر فاتح، وليس بالضرورة بلونٍ موحد.",
        "لونه موحد، ابيض أو اصفر فاتح.",
        "لونه موحد، ازرق أو اصفر فاتح.",
        "لونه موحد، احمر أو اصفر فاتح."
      ],
      id: 1741
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0371. أية إشارة تُنصب قبل حوالي 300م من ملتقى سكة حديد؟",
      numQues: "0371",
      correctAnswer: "130",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3371.jpg",
      choices: [
        "128",
        "134",
        "133",
        "130"
      ],
      id: 1742
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "1050. ما هو ترتيب العمليات الصحيح لتغيير عجل في المركبة؟",
      numQues: "1050",
      correctAnswer: "فك برغيين اثنين ورفع المركبة بواسطة الجاك وفك باقي البراغي نهائياً.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "فك البراغي نهائياً ورفع المركبة بواسطة الجاك.",
        "رفع المركبة بواسطة الجاك وبعدها فك البراغي نهائياً.",
        "فك البراغي قليلاً ورفع المركبة بواسطة الجاك وفك جميع البراغي نهائياً.",
        "فك برغيين اثنين ورفع المركبة بواسطة الجاك وفك باقي البراغي نهائياً."
      ],
      id: 1743
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1488. ما معنى الإشعار بعدم استعمال المركبة (تنزيل عن الشارع)؟",
      numQues: "1488",
      correctAnswer: "مسموح السير في المركبة بدون تحديد، (إذا لم تكن هناك خطورة على سلامة السير)، ولكن ليس على الشارع.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "ممنوع السير في المركبة على الطريق، إلا إذا سُمح بالسير للكراج القريب على نموذج التنزيل.",
        "ممنوع السير في المركبة بدون إذن من شركة التأمين.",
        "مسموح السير في المركبة لغاية أسبوع من يوم تنزيلها عن الشارع.",
        "مسموح السير في المركبة بدون تحديد، (إذا لم تكن هناك خطورة على سلامة السير)، ولكن ليس على الشارع."
      ],
      id: 1744
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0168. كيف تتصرف عند إصابة جهاز إعطاء الإشارة (الغماز) بخلل؟",
      numQues: "0168",
      correctAnswer: "أعط الإشارة بيدك اليسرى، حسب ما ورد في القانون.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "لا يجوز الاستمرار بالسير.",
        "في 'وقت الإنارة' يجوز الاستمرار بالسير، وفي أي وقت آخر - ممنوع.",
        "مسموح الاستمرار بالسير حتى الكراج القريب بدون إعطاء الإشارة على الإطلاق - حتى عندما يكون هناك واجب إعطاء الإشارة. ",
        "أعط الإشارة بيدك اليسرى، حسب ما ورد في القانون."
      ],
      id: 1745
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0683. ما معنى الإشارة؟",
      numQues: "0683",
      correctAnswer: "جسر عريض أمامك.",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3683.jpg",
      choices: [
        "عرض الشارع آخذ في الازدياد.",
        "وسم (تأشير) مكان عبور ضيق أو عائق.",
        "أعمدة توجيه: طرف الطريق.",
        "جسر عريض أمامك."
      ],
      id: 1746
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0312. 'شرب الكحول يشوش عملياً القدرة على القرار ويسمح السائق لنفسه بالمخاطرة أكثر'، صحيح أم غير صحيح؟",
      numQues: "0312",
      correctAnswer: "نادراً ما يكون هذا صحيح.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "هذا صحيح فقط بالنسبة للنساء.",
        "صحيح.",
        "غير صحيح، الكحول تُحسن من القدرة على السياقة.",
        "نادراً ما يكون هذا صحيح."
      ],
      id: 1747
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0812. مسافة رد فعل السائق هي المسافة التي تقطعها المركبة:",
      numQues: "0812",
      correctAnswer: "من اللحظة التي يشاهد فيها السائق الخطر الذي أمامه لغاية اللحظة التي يبدأ فيها رد فعله على الخطر.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "من اللحظة التي يشاهد فيها السائق الخطر الذي أمامه لغاية التوقف التام للمركبة.",
        "من اللحظة التي يضغط فيها السائق على دعسة الفرامل ولغاية التوقف التام للمركبة.",
        "من بداية رد الفعل ولغاية انتهاء فرملة المركبة.",
        "من اللحظة التي يشاهد فيها السائق الخطر الذي أمامه لغاية اللحظة التي يبدأ فيها رد فعله على الخطر."
      ],
      id: 1748
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0149. متى يجب حسب القانون إجراء الفحص السنوي (التست) للمركبة؟",
      numQues: "0149",
      correctAnswer: "كل سنتين للمركبة التجارية ، وكل سنة للدراجات النارية.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "كل سنة أو أية فترة أخرى حُددت في القانون.",
        "كل سنتين لجميع أنواع المركبات.",
        "كل سنتين لجميع مركبات الركاب الخصوصية بدون تحديد عمر المركبة.",
        "كل سنتين للمركبة التجارية ، وكل سنة للدراجات النارية."
      ],
      id: 1749
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1061. لماذا يجب الامتناع عن تشغيل محرك المركبة في مكان مغلق؟",
      numQues: "1061",
      correctAnswer: "من اجل منع المحرك من أن يسخن زيادة عن اللازم بسبب نقص التهوية الكافية.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "لأنه لا يمكن تشغيل المحرك في مكان مغلق.",
        "لأن الغازات المحترقة المنبعثة من المحرك سامة للإنسان.",
        "لا توجد حاجة للامتناع عن ذلك لأنه لا توجد أهمية إذا كان المحرك يعمل في مكان مغلق أو في مكان مفتوح.",
        "من اجل منع المحرك من أن يسخن زيادة عن اللازم بسبب نقص التهوية الكافية."
      ],
      id: 1750
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0621. ما معنى الإشارة؟",
      numQues: "0621",
      correctAnswer: "مكان عبور عربات المعاقين الميكانيكية فقط.",
      pubDate: "10-11-2011 08:23:16",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3216.jpg",
      choices: [
        "موقف مخصص لمركبة معاق بحوزته لاصقة وقوف كما في الإشارة.",
        "مسموح التوقف فقط - لمركبة معاق.",
        "موقف مركبة لكل معاق.",
        "مكان عبور عربات المعاقين الميكانيكية فقط."
      ],
      id: 1751
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1547. يُسمح بالفرملة الفجائية:",
      numQues: "1547",
      correctAnswer: "إذا أراد الراكب في المركبة أو السائق النزول فجأةً من المركبة.",
      pubDate: "10-11-2011 08:23:16",
      img: "",
      choices: [
        "في حالة عدم وجود طريقة أخرى لتجنب حادث.",
        "إذا تبين للسائق بأنه اخطأ الطريق.",
        "إذا أراد السائق الاستدارة للسير في الاتجاه المعاكس (حذوة فرس).",
        "إذا أراد الراكب في المركبة أو السائق النزول فجأةً من المركبة."
      ],
      id: 1752
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0003. ما هو واجب صاحب المركبة أو من يملك السيطرة عليها؟",
      numQues: "0003",
      correctAnswer: "أن يتأكد بأن يكون في المركبة تصوير رخصة السياقة وتصوير شهادة التأمين فقط.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "أن لا يسمح بسياقتها من قِبل شخص لا يحمل رخصة سياقة سارية المفعول لنفس نوع المركبة.",
        "أن يُسجل من يسوق مركبته في دفتر سفريات المركبة.",
        "أن يسمح بسياقة مركبته لكل شخص يطلب منه ذلك.",
        "أن يتأكد بأن يكون في المركبة تصوير رخصة السياقة وتصوير شهادة التأمين فقط."
      ],
      id: 1753
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0217. ما هي العمليات التي يجب أن يقوم بها السائق بعد أن أوقف مركبته؟",
      numQues: "0217",
      correctAnswer: "أن يضع مثلث تحذير.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "أن يؤمن عدم تحرك المركبة من مكانها وعدم سيرها.",
        "أن يضع لافتة 'سوف أعود حالاً'.",
        "أن يُشغل جميع الغمازات.",
        "أن يضع مثلث تحذير."
      ],
      id: 1754
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1695. من اجل التقليل من تأثير بهر النظر عند السياقة في الظلام، من المستحسن:",
      numQues: "1695",
      correctAnswer: "بهر نظر سائق المركبة المقابلة بإعطاء نور متقطع قليلاً حسب ما نص القانون.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "إنزال حاجب الشمس.",
        "استعمال نظارات شمسية – من المستحسن غامقة.",
        "تنظيف الزجاج جيداً.",
        "بهر نظر سائق المركبة المقابلة بإعطاء نور متقطع قليلاً حسب ما نص القانون."
      ],
      id: 1755
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0393. إذا مُنع الوقوف والتوقف بجانب الطريق، أية إشارة تُنصب في المكان؟",
      numQues: "0393",
      correctAnswer: "434",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3393.jpg",
      choices: [
        "432",
        "817",
        "433",
        "434"
      ],
      id: 1756
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0314. 'شرب الكحول يشوش الرؤية المحيطة ومدى الرؤية'، صحيح أم غير صحيح؟",
      numQues: "0314",
      correctAnswer: "صحيح، لكن هذا يعتمد على نوع المركبة التي يسوقها السائق.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "غير صحيح.",
        "صحيح.",
        "هذا صحيح بالنسبة للشبان فقط.",
        "صحيح، لكن هذا يعتمد على نوع المركبة التي يسوقها السائق."
      ],
      id: 1757
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0409. ما معنى الإشارة؟",
      numQues: "0409",
      correctAnswer: "سر إلى اليسار فقط.",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3409.jpg",
      choices: [
        "مسموح الاستدارة للسير في الاتجاه المعاكس (حذوة فرس).",
        "انعطاف حاد إلى اليمين.",
        "طريق ملتوية.",
        "سر إلى اليسار فقط."
      ],
      id: 1758
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0516. أنت تقترب من مكان عبور المشاة المؤشر على الشارع:",
      numQues: "0516",
      correctAnswer: "مسموح التجاوز في شارع باتجاهين.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "ممنوع التجاوز.",
        "ممنوع التجاوز في طريق بلدية ، ومسموح التجاوز في طريق ليست بلدية.",
        "مسموح التجاوز.",
        "مسموح التجاوز في شارع باتجاهين."
      ],
      id: 1759
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0124. في أية حالة يجوز لنا عبور مركبة أخرى من جهتها اليمنى؟",
      numQues: "0124",
      correctAnswer: "إذا كانت المركبة الأخرى تسير في المسلك الأيمن وتعطي إشارة إلى اليسار.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "إذا كان سائق المركبة الأخرى ينوي الاستدارة إلى اليسار وأعطى إشارة بذلك.",
        "إذا كانت المركبة الأخرى تسير في المسلك المركزي وتعطي إشارة إلى اليمين.",
        "إذا كان هناك مسلك خالي على يمين المركبة الأخرى.",
        "إذا كانت المركبة الأخرى تسير في المسلك الأيمن وتعطي إشارة إلى اليسار."
      ],
      id: 1760
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0978. كيف يجب على سائقي المركبات، المتوقفة في المفترق، التصرف حسب الصورة؟",
      numQues: "0978",
      correctAnswer: "البدء بالسير.",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3978.jpg",
      choices: [
        "عليهم الاستعداد للسير، لأنه سوف يظهر مباشرةً الضوء الأحمر.",
        "عليهم الاستعداد للبدء بالسير عند ظهور الضوء الأخضر.",
        "عليهم الاستعداد للسير، لأنه سوف يظهر مباشرةً الضوء الأصفر.",
        "البدء بالسير."
      ],
      id: 1761
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0789. وصلت إلى مفترق غير خالي:",
      numQues: "0789",
      correctAnswer: "ادخل إلى المفترق بحذر وانتظر هناك إلى أن يخلو.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "إذا كان الضوء في الإشارة الضوئية (الرمزور) يضيء باللون الأخضر، يُسمح لك بالدخول أيضاً إلى المفترق غير الخالي.",
        "مسموح الاستدارة إلى اليسار حتى في مفترق غير خالي.",
        "توقف قبل المفترق وانتظر إلى أن يخلو المفترق.",
        "ادخل إلى المفترق بحذر وانتظر هناك إلى أن يخلو."
      ],
      id: 1762
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0981. هل حسب رأيك، مكان الشاحنة صحيح داخل المنعطف؟",
      numQues: "0981",
      correctAnswer: "نعم، في المنعطفات الحادة، ولكي نقلل من القوة الطاردة عن المركز، يجب قطع (قص) المنعطف، كما يفعل سائق الشاحنة.",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_03/he/TQ_PIC_3981.jpg",
      choices: [
        "كلا، سائق الشاحنة لا يحافظ على يمين الطريق ويُشكل خطراً حقيقياً لكل مركبة قادمة مقابله.",
        "نعم، عند عدم وجود مركبة أخرى في داخل المنعطف، يُمكن أن تتواجد في أي مكان فيه، كما يفعل سائق الشاحنة.",
        "نعم، عند السير في منعطف حاد، يجب تقصير مدة البقاء في المنعطف، لذلك مكانها صحيح.",
        "نعم، في المنعطفات الحادة، ولكي نقلل من القوة الطاردة عن المركز، يجب قطع (قص) المنعطف، كما يفعل سائق الشاحنة."
      ],
      id: 1763
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0792. هل يُسمح للسائق باختراق خط فاصل متواصل من اجل تنفيذ استدارة للسير في الاتجاه المعاكس (حذوة فرس)؟",
      numQues: "0792",
      correctAnswer: "مسموح، بشرط أن لا يعرقل حركة السير.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "ممنوع.",
        "مسموح، في إذا كان المفترق الذي أمامك مغلق.",
        "مسموح، إذا كان في الشارع مسلكان أو أكثر في كل اتجاه سير. ",
        "مسموح، بشرط أن لا يعرقل حركة السير."
      ],
      id: 1764
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0259. بأي شرط يُسمح باستعمال كشاف في الطريق؟",
      numQues: "0259",
      correctAnswer: "عندما تقوم مركبة امن بدورية على طول الجدران فقط. ",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "من اجل الأمن فقط وفي وقت الإنارة.",
        "فقط عند التوقف، بشرط أن لا يوجه الكشاف مقابل مركبة أخرى أو على طول الطريق.",
        "ممنوع استعمال الكشاف في الطريق، ما عدا مركبة إطفاء الحريق.",
        "عندما تقوم مركبة امن بدورية على طول الجدران فقط. "
      ],
      id: 1765
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1296. بأية شروط يُفضل كثيراً إضاءة الأضواء حتى في النهار؟",
      numQues: "1296",
      correctAnswer: "عندما تكون الشمس خلف السائق.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "عندما تكون الشمس مقابل السائق.",
        "عندما تكون الشمس على يسار مسلك السير.",
        "عندما تكون الشمس على يمين مسلك السير.",
        "عندما تكون الشمس خلف السائق."
      ],
      id: 1766
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0771. كيف تؤثر كثرة الإشارات المنصوبة في المفترق على رد فعل السائق؟",
      numQues: "0771",
      correctAnswer: "كثرة الإشارات تتسبب في تفكير أسرع لدى السائق في المفترق. ",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3771.jpg",
      choices: [
        "لا تؤثر كثرة الإشارات على تصرف السائق عند اقترابه من المفترق.",
        " تُسبب كثرة الإشارات دائماً في بلبلة لسائق المركبة.",
        "يضطر السائق إلى التخفيف من سرعته لكي يتمكن من مشاهدة الإشارات وفهم معناها.",
        "كثرة الإشارات تتسبب في تفكير أسرع لدى السائق في المفترق. "
      ],
      id: 1767
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0967. هناك منع في الصورة التي أمامك، ما هو؟",
      numQues: "0967",
      correctAnswer: "لا يوجد أي تحديد في الصورة.",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3967.jpg",
      choices: [
        "بسبب ضغط حركة السير ممنوع التجاوز للمركبات التجارية فقط،.",
        "مدى الرؤية المحدود يمنع التجاوز والسرعة محدودة بِ 90كم/ساعة.",
        "بسبب تحديد السرعة ممنوع التجاوز.",
        "لا يوجد أي تحديد في الصورة."
      ],
      id: 1768
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1464. ما هي العوامل التي تؤثر على توازن المركبة التجارية التي تنقل حمولة، أثناء السير في منعطف؟",
      numQues: "1464",
      correctAnswer: "سرعة المركبة ونصف قطر المنعطف وارتفاع مركز ثقل المركبة.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "وزن المركبة ووزن المحرك.",
        "سرعة المركبة ووزن المركبة فقط.",
        "نصف قطر المنعطف وطول مسافة السير في المنعطف. ",
        "سرعة المركبة ونصف قطر المنعطف وارتفاع مركز ثقل المركبة."
      ],
      id: 1769
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0043. عند رجوعك الى الخلف:",
      numQues: "0043",
      correctAnswer: "في طريق خارج المدن عليك الاستعانة بشخص يوجهك.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "عليك الاستعانة بشخص يوجهك.",
        "مسموح الاستعانة بشخص يوجهك.",
        "عليك الاستعانة بشخص يوجهك، إذا كان ذلك وقت الإنارة.",
        "في طريق خارج المدن عليك الاستعانة بشخص يوجهك."
      ],
      id: 1770
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1719. ماذا يُمكن أن يكون السبب في فقدان السيطرة على المركبة؟",
      numQues: "1719",
      correctAnswer: "السياقة بسرعة كبيرة وعدم ربط أحزمة الأمان.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "السياقة بسرعة كبيرة ومسند الرأس غير صالح.",
        "السياقة بسرعة كبيرة وعدم اليقظة وعدم معرفة أجهزة المركبة. ",
        "السياقة بسرعة معقولة وعدم معرفة أجهزة المركبة فقط.",
        "السياقة بسرعة كبيرة وعدم ربط أحزمة الأمان."
      ],
      id: 1771
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1708. وظائف الأخاديد (الفرزات) في نعل الإطار، بين سائر الأمور، هي:",
      numQues: "1708",
      correctAnswer: "لتمكين تصريف ناجع للمياه بين الإطار وبين شارع رطب (مبلول).",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31501.jpg",
      choices: [
        "لتمكين تصريف المياه التي بين الشارع وبين الإطار وللمحافظة على ضغط الهواء في الإطارات. ",
        "لتمكين تصريف المياه التي بين الشارع وبين الإطار ولمنع تآكل الإطارات.",
        "لتمكين تصريف المياه التي بين الشارع وبين الإطار ولمنع تلف المحرك.",
        "لتمكين تصريف ناجع للمياه بين الإطار وبين شارع رطب (مبلول)."
      ],
      id: 1772
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "0620. على من يسوق 'مركبة سياحية'أن يكون:",
      numQues: "0620",
      correctAnswer: "يحمل الدرجة الجامعية الأولى (B.A.) في موضوع معرفة البلاد وصاحب رخصة سياقة من درجة Dأو D1. ",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "دليل سياحي معتمد ومرخص من قِبل وزارة السياحة وصاحب رخصة سياقة من درجة Dأو D1. ",
        "سائق مركبة مرخص من قِبل وزارة المواصلات وصاحب رخصة سياقة من درجة Dأو D1.",
        "دليل سياحي معتمد ومرخص من قِبل وزارة جودة البيئة وصاحب رخصة سياقة من درجة Dأو D1. ",
        "يحمل الدرجة الجامعية الأولى (B.A.) في موضوع معرفة البلاد وصاحب رخصة سياقة من درجة Dأو D1. "
      ],
      id: 1773
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0514. يبقى سريان مفعول الشاخصتين:",
      numQues: "0514",
      correctAnswer: "لغاية الإشارة الضوئية (الرمزور) القريبة بشرط أن يضيء فيها الضوء الأخضر.",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3512.jpg",
      choices: [
        "لغاية المفترق القريب أو لغاية إشارة تُحدد سرعة أخرى أو لغاية إشارة تُحدد انتهاء مقطع السرعة الخاصة.",
        "لغاية محطة الباص القريبة.",
        "ينتهي سريان مفعولهما عند الاقتراب من منطقة ذات كثافة سكانية عالية. ",
        "لغاية الإشارة الضوئية (الرمزور) القريبة بشرط أن يضيء فيها الضوء الأخضر."
      ],
      id: 1774
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0339. مدة سريان مفعول رخصة سياقة 'لسائق جديد' هي:",
      numQues: "0339",
      correctAnswer: "5 سنوات.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "10 سنوات.",
        "سنة واحدة فقط.",
        "سنتين.",
        "5 سنوات."
      ],
      id: 1775
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C1»"
      ],
      title: "1069. أية لامبة تحذير لا تلزم بالتوقف عن السفر عندما تضيء؟",
      numQues: "1069",
      correctAnswer: "لامبة ضغط الزيت في المحرك.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "لامبة حرارة المحرك.",
        "لامبة مقياس الوقود في الخزان.",
        "لامبة الخلل في الفرامل.",
        "لامبة ضغط الزيت في المحرك."
      ],
      id: 1776
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0741. كيف تُشغل المحرك في مركبة ذات صندوق غيارات أوتوماتكية؟",
      numQues: "0741",
      correctAnswer: "تأكد من أن عصا الغيارات في وضع (R) وأن الفرملة المساعدة (الهاندبريك) محلولة.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "تأكد من أن عصا الغيارات في وضع (D) وأن الفرملة المساعدة (الهاندبريك) محلولة. ",
        "تأكد من أن الفرملة المساعدة (الهاندبريك) غير محلولة وعصا الغيارات في وضع (P) أو (N). ",
        "لا توجد أهمية لوضع الغيار، تأكد فقط بأن الفرملة المساعدة (الهاندبريك) غير محلولة. ",
        "تأكد من أن عصا الغيارات في وضع (R) وأن الفرملة المساعدة (الهاندبريك) محلولة."
      ],
      id: 1777
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0267. أي 'سائق جديد' مُلزم بمرافق عندما يسوق مركبة ركاب خصوصية؟",
      numQues: "0267",
      correctAnswer: "كل من حصل على رخصة سياقة لأول مرة لمركبة ركاب خصوصية ولا يزيد عمره عن 21 سنة . ",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "كل من حصل على رخصة سياقة لأول مرة لمركبة ركاب خصوصية ولا يزيد عمره عن 30 سنة . ",
        "كل من حصل على رخصة سياقة لأول مرة لمركبة ركاب خصوصية أو لمركبة شحن خفيف C1 . ",
        "كل من حصل على رخصة سياقة لأول مرة لمركبة ركاب خصوصية ولا يزيد عمره عن 24 سنة . ",
        "كل من حصل على رخصة سياقة لأول مرة لمركبة ركاب خصوصية ولا يزيد عمره عن 21 سنة . "
      ],
      id: 1778
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1351. بموجب القانون، المقطورة التي وزنها الإجمالي المسموح به أكثر من 4000كغم ملزمة بِ:",
      numQues: "1351",
      correctAnswer: "'لوحة أرقام إضافية' تُركب على القسم الخلفي للمقطورة.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "مقطورة بهذا الوزن غير ملزمة بلوحات أرقام.",
        "لوحات أرقام حجمها ضعف حجم لوحات الأرقام العادية.",
        "'لوحة أرقام إضافية' تُركب على القسم الأمامي للمقطورة.",
        "'لوحة أرقام إضافية' تُركب على القسم الخلفي للمقطورة."
      ],
      id: 1779
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1073. ما معنى الإشارة؟",
      numQues: "1073",
      correctAnswer: "المسافة لغاية المفترق القريب (بالكيلومترات).",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_31073.jpg",
      choices: [
        "المسافة لغاية الشارع القريب (بالكيلومترات).",
        "رقم طريق سريعة.",
        "رقم طريق رئيسية.",
        "المسافة لغاية المفترق القريب (بالكيلومترات)."
      ],
      id: 1780
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0825. اختر الجملة الصحيحة:",
      numQues: "0825",
      correctAnswer: "المحافظة على مسافة مطلوبة فقط عندما يكون السائق تعباً جداً وردود فعله لا تلبي الحاجة.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "المحافظة على مسافة تمنع الضغط والذي يؤدي إلى ضرر في البنية التحتية للطريق.",
        "المحافظة على مسافة مناسبة تمكن المركبة المجتازة الدخول في الحيز الذي في الأمام.",
        "المحافظة على مسافة مطلوبة في السرعات العالية فقط، وعندما تكون في الأمام مركبة ثقيلة أو باص.",
        "المحافظة على مسافة مطلوبة فقط عندما يكون السائق تعباً جداً وردود فعله لا تلبي الحاجة."
      ],
      id: 1781
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C1»"
      ],
      title: "0099. ما هي السرعة القصوى المسموح بها لتراكتور حمولة ؟",
      numQues: "0099",
      correctAnswer: "50كم/ساعة في طريق داخل المدن.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "70كم/ساعة.",
        "40كم/ساعة.",
        "60كم/ساعة في طريق ليست بلدية.",
        "50كم/ساعة في طريق داخل المدن."
      ],
      id: 1782
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«A»"
      ],
      title: "1606. كيف تسوق الدراجة النارية أثناء عبور بقعة زيت ملسة على الشارع؟",
      numQues: "1606",
      correctAnswer: "تزيد من سرعتك وتعبر البقعة بسرعة عالية على قدر الإمكان وبخط مستقيم.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "يجب الميل إلى الأمام لنقل وزن السائق إلى العجلة الأمامية من اجل تحسين عمل المقود.",
        "تميل إلى الخلف لنقل الوزن إلى العجلة الخلفية من اجل تحسين عمل الفرملة.",
        "تحرر مقبض (دعسة يد) الوقود والفرامل وتضغط على دعسة (يد) الكلاتش وتحافظ على خط سير مستقيم.",
        "تزيد من سرعتك وتعبر البقعة بسرعة عالية على قدر الإمكان وبخط مستقيم."
      ],
      id: 1783
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0198. كيف تؤشر مركبة اضطررت لإبقائها واقفة على الطريق؟",
      numQues: "0198",
      correctAnswer: "تضيء مصابيح المقدمة في 'وقت الإنارة'.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "تضع مصباح يبعث بضوء متقطع يمكن رؤيته من مسافة 30م.",
        "تُشغل الغمازين الأماميين.",
        "تضع مثلث تحذير يمكن رؤيته من مسافة 100م على الأقل من قِبل سائق المركبة القادمة من الخلف. ",
        "تضيء مصابيح المقدمة في 'وقت الإنارة'."
      ],
      id: 1784
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "1533. كم مركبة يُسمح بجرها بواسطة مركبة تجارية وزنها الإجمالي المسموح به أكثر من 2200كغم؟",
      numQues: "1533",
      correctAnswer: "لا يوجد تحديد بالنسبة لعدد المركبات التي يُسمح بجرها.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "مركبتين.",
        "ثلاث مركبات صغيرة.",
        "مركبة واحدة، إلا إذا سمحت سلطة الترخيص بعددٍ آخر.",
        "لا يوجد تحديد بالنسبة لعدد المركبات التي يُسمح بجرها."
      ],
      id: 1785
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C»",
        "«C1»"
      ],
      title: "0241. هل يجوز تواجد أشخاص في مركبة أثناء جرها، ما عدا سائقها؟",
      numQues: "0241",
      correctAnswer: "ممنوع.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "مسموح للأشخاص الذين كانوا في المركبة عند إصابتها بالخلل البقاء في المركبة.",
        "مسموح لشخص واحد كمرافق.",
        "مسموح بشرط أن يستخدموا حزام الأمان.",
        "ممنوع."
      ],
      id: 1786
    },
    {
      category: "السلامة على الطرق",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0319. 'شرب الكحول يؤثر على قدرة رد الفعل عند السائق' صحيح أم غير صحيح؟",
      numQues: "0319",
      correctAnswer: "صحيح، الكحول مخدر يسبب الاكتئاب.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "غير صحيح، لأن السائق يشعر بأنه غير قادر على السياقة وهو ثمل (سكران). ",
        "غير صحيح، شرب الكحول يؤثر إيجابياً.",
        "غير صحيح، الكحول ترفع المعنوية والقدرة على السياقة.",
        "صحيح، الكحول مخدر يسبب الاكتئاب."
      ],
      id: 1787
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0155. ما هو الواجب المفروض على سائق المركبة عند اقترابه من ملتقى سكة حديد؟",
      numQues: "0155",
      correctAnswer: "التوقف قبل الملتقى على مسافة متر واحد على الأقل من خط السكة.",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3155.jpg",
      choices: [
        "الاستمرار بالسير كالعادة، لا يوجد واجب بالتمهل.",
        "التمهل حتى إمكانية التوقف قبل الملتقى.",
        "التوقف وفتح نوافذ المركبة والإصغاء.",
        "التوقف قبل الملتقى على مسافة متر واحد على الأقل من خط السكة."
      ],
      id: 1788
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0987. الاستعمال الزائد لفرامل المركبة من شأنه أن يسبب:",
      numQues: "0987",
      correctAnswer: "برودة زائدة للفرامل، وبسببها - زيادة نجاعة الفرملة.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "سخونة زائدة للفرامل، وتقليل نجاعة الفرملة.",
        "لا يوجد أي خوف من الاستعمال الزائد لفرامل المركبة.",
        "انخفاض في قوة المحرك إلى حد توقف عمله.",
        "برودة زائدة للفرامل، وبسببها - زيادة نجاعة الفرملة."
      ],
      id: 1789
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«C1»"
      ],
      title: "0344. كم هو عدد لوحات الأرقام التي يجب أن تثبت في مركبة ركاب خصوصية؟",
      numQues: "0344",
      correctAnswer: "لوحة واحدة في الأمام فقط.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "لوحة واحدة في الخلف فقط.",
        "لوحتان حسب المواصفات واحدة في المقدمة والثانية في المؤخرة.",
        "عدد اللوحات الذي يقرره صاحب المركبة.",
        "لوحة واحدة في الأمام فقط."
      ],
      id: 1790
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1617. هل يجوز لسائق الدراجة النارية عبور (قطع) الرصيف؟",
      numQues: "1617",
      correctAnswer: "نعم، فقط من اجل إنزال راكب.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "نعم، من اجل الدخول إلى ساحة أو كراج.",
        "نعم، فقط من اجل أخذ راكب.",
        "نعم، فقط من اجل تجاوز عائق في الطريق.",
        "نعم، فقط من اجل إنزال راكب."
      ],
      id: 1791
    },
    {
      category: "قوانين المرور",
      type: [
        "«D»"
      ],
      title: "1181. متى يُمنع ملء الوقود في الباص؟",
      numQues: "1181",
      correctAnswer: "في محطات الوقود الخاصة.",
      pubDate: "10-11-2011 08:23:17",
      img: "",
      choices: [
        "عندما يكون فيه ركاب.",
        "في المحطات التي تزود بالوقود حتى الوقود من نوع بنزين.",
        "إذا كان الباص يعمل على خط خدمة.",
        "في محطات الوقود الخاصة."
      ],
      id: 1792
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0666. ما هو مفهوم الضوء الظاهر في الإشارة الضوئية (الرمزور)؟",
      numQues: "0666",
      correctAnswer: "يجوز لك التقدم إذا كان المفترق خالي.",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3666.jpg",
      choices: [
        "انتظر ولا تتقدم – حتى ظهور الضوء الأصفر.",
        "ابدأ بالسير عند ظهور الضوء الأصفر.",
        "تابع السير فقط عندما يبدأ الضوء بالتقطع.",
        "يجوز لك التقدم إذا كان المفترق خالي."
      ],
      id: 1793
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0172. في الرسم الذي أمامك نرى طريق عريضة، بأي رقم موسومة الطريق في الرسم؟",
      numQues: "0172",
      correctAnswer: "8",
      pubDate: "10-11-2011 08:23:17",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3082.jpg",
      choices: [
        "1",
        "3",
        "2",
        "8"
      ],
      id: 1794
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1286. في أي مكان في المركبة يجب أن تكون مطفأة الحريق؟",
      numQues: "1286",
      correctAnswer: "في مكان ظاهر للعيان يسهل الوصول إليها من اجل تشغيلها بسرعة.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "بجانب خزان الوقود في مكان مُغلق ومقفل.",
        "بجانب البطارية في مكان مُغلق ومقفل. ",
        "على سطح المركبة بشكلٍ يسهل الوصول إليها لتشغيلها بسرعة.",
        "في مكان ظاهر للعيان يسهل الوصول إليها من اجل تشغيلها بسرعة."
      ],
      id: 1795
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0162. إذا كنت تقترب من ملتقى سكة حديد وقبل وصولك إلى الملتقى هناك إشارة تنبيه، فما هو واجبك؟",
      numQues: "0162",
      correctAnswer: "تجاهل الإشارة واستمر بسيرك لأنك كنت هناك قبل الإشارة. ",
      pubDate: "10-11-2011 08:23:18",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3160.jpg",
      choices: [
        "تمهل فقط إذا كنت تُشغل إشارة تنبيه.",
        "تمهل فقط إذا كنت ترى القطار يقترب.",
        "توقف ولا تواصل سيرك.",
        "تجاهل الإشارة واستمر بسيرك لأنك كنت هناك قبل الإشارة. "
      ],
      id: 1796
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "1382. ما معنى الإشارة؟",
      numQues: "1382",
      correctAnswer: "محطة صالون عمومي، ممنوع توقف ووقوف المركبات التي ليست بصالون عمومي.",
      pubDate: "10-11-2011 08:23:18",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3571.jpg",
      choices: [
        "بداية حدود محطة باص عمومي.",
        "نهاية حدود محطة صالون عمومي (تاكسي).",
        "محطة صالون عمومي، ممنوع دخول الشارع الذي نُصبت فيه الإشارة.",
        "محطة صالون عمومي، ممنوع توقف ووقوف المركبات التي ليست بصالون عمومي."
      ],
      id: 1797
    },
    {
      category: "معرفة المركبة",
      type: [
        "«B»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0742. كيف تُنفد الانتقال إلى غيار واطئ في صعود بمركبة ذات صندوق غيارات أوتوماتكية وبدون استعمال عصا الغيارات؟",
      numQues: "0742",
      correctAnswer: "بواسطة الضغط الشديد والسريع (كيك داون) على دعسة الوقود أو تشغيل مفتاح (زر) كهربائي مُعد لذلك.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "بواسطة الضغط بالتدريج على دعسة الوقود لغاية الحصول على السرعة المطلوبة.",
        "بواسطة رفع الرجل عن دعسة الوقود بدون إعطاء وقود من اجل الحصول على السرعة المطلوبة.",
        "بواسطة الضغط بشدة على دعسة الفرامل.",
        "بواسطة الضغط الشديد والسريع (كيك داون) على دعسة الوقود أو تشغيل مفتاح (زر) كهربائي مُعد لذلك."
      ],
      id: 1798
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0413. ما معنى الإشارة؟",
      numQues: "0413",
      correctAnswer: "إشارة إرشاد، التواء حاد. ",
      pubDate: "10-11-2011 08:23:18",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3413.jpg",
      choices: [
        "أمامك منحدر خطر.",
        "طريق ملتوية.",
        "منعطف إلى اليمين وثم إلى اليسار أمامك.",
        "إشارة إرشاد، التواء حاد. "
      ],
      id: 1799
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0780. المعاق مشلول الأرجل الذي يسير بسرعة بمركبته في المدينة من اجل الفحص الطبي الذي عُين له قبل زمنٍ طويل:",
      numQues: "0780",
      correctAnswer: "يُسمح له بالسير داخل مسلك المواصلات العمومية، لكن لا يجوز له السير بسرعة تزيد عن السرعة القصوى المسموح بها.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "لا يجوز له السير داخل مسلك المواصلات العمومية ولا يجوز له السير بسرعة تزيد عن السرعة القصوى المسموح بها.",
        "يجوز له السير بسرعة تزيد عن السرعة القصوى المسموح بها فقط عندما يسير داخل مسلك للمواصلات العمومية.",
        "يُسمح له بالسير بسرعة تزيد عن السرعة القصوى المسموح بها.",
        "يُسمح له بالسير داخل مسلك المواصلات العمومية، لكن لا يجوز له السير بسرعة تزيد عن السرعة القصوى المسموح بها."
      ],
      id: 1800
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0112. المفترق الذي أمامك عليه إشارات تماماً كما في الصورة، ما هي الطريقة الصحيحة للاستدارة من الشارع 'أ' (A) إلى الشارع 'ج' (C)؟",
      numQues: "0112",
      correctAnswer: "من المسلك '1' أو من المسلك '2' إلى المسلك '5'.",
      pubDate: "10-11-2011 08:23:18",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_01/he/TQ_PIC_3112.jpg",
      choices: [
        "من المسلك '2' إلى المسلك '5'.",
        "من المسلك '1' أو من المسلك '2' إلى المسلك '6'.",
        "من المسلك '2' إلى المسلك '3'.",
        "من المسلك '1' أو من المسلك '2' إلى المسلك '5'."
      ],
      id: 1801
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0304. المركبة التي تلفظ زيت أو تبعث بدخان أكثر من المعتاد:",
      numQues: "0304",
      correctAnswer: "ممنوع نقل حمولة فيها. ",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "مسموح السير بها بسرعة منخفضة لا تزيد عن 40كم/ساعة.",
        "ممنوع سياقتها.",
        "ممنوع نقل الركاب فيها. ",
        "ممنوع نقل حمولة فيها. "
      ],
      id: 1802
    },
    {
      category: "قوانين المرور",
      type: [
        "«C»",
        "«C1»"
      ],
      title: "1407. هل يجوز لشرطي أن يأمر سائق مركبة تنقل حمولة بأن يجلب المركبة لمحطة توزين من اجل توزينها؟",
      numQues: "1407",
      correctAnswer: "نعم، لكن الشرطي يجب أن يكون شرطي مرور.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "نعم، يجوز للشرطي أن يأمر سائق مركبة تنقل حمولة بأن يجلب المركبة من اجل التوزين إلى مكان قريب على قدر الإمكان. ",
        "نعم، يجوز للشرطي التصرف بهذا الشكل فقط إذا لم يكن بحوزة السائق سند حمولة.",
        "نعم، يجوز للشرطي فعل ذلك بشرط أن لا تبعد محطة التوزين أكثر من 3كم من المكان.",
        "نعم، لكن الشرطي يجب أن يكون شرطي مرور."
      ],
      id: 1803
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0529. يسري مفعول الإشارة لغاية:",
      numQues: "0529",
      correctAnswer: "المفترق القريب أو لغاية الإشارة 'الدخول إلى منطقة طرق بلدية'.",
      pubDate: "10-11-2011 08:23:18",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3528.jpg",
      choices: [
        "المفترق القريب المنصوب فيه إشارة ضوئية (رمزور). ",
        "الإشارة التي تلغيها.",
        "إشارة الخروج من طريق بلدية.",
        "المفترق القريب أو لغاية الإشارة 'الدخول إلى منطقة طرق بلدية'."
      ],
      id: 1804
    },
    {
      category: "قوانين المرور",
      type: [
        "«1»"
      ],
      title: "1426. هل التراكتور ملزم بتركيب زامور (مزمزم) للرجوع إلى الخلف؟",
      numQues: "1426",
      correctAnswer: "نعم.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "فقط التراكتور الزراعي ملزم بذلك.",
        "كلا.",
        "فقط تراكتور وزنه الإجمالي المسموح به 1000كغم أو اقل ملزم بذلك.",
        "نعم."
      ],
      id: 1805
    },
    {
      category: "معرفة المركبة",
      type: [
        "«A»"
      ],
      title: "1728. عندما نضغط على مقبض (دعسة) الكلاتش:",
      numQues: "1728",
      correctAnswer: "ينتج اتصال بين المحرك وبين صندوق الغيارات.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "نفصل بين المحرك وبين صندوق الغيارات.",
        "تتوقف الدراجة النارية فوراً.",
        "يزداد استهلاك الوقود في المحرك.",
        "ينتج اتصال بين المحرك وبين صندوق الغيارات."
      ],
      id: 1806
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0135. كيف يتصرف سائق مركبة تتجاوزه مركبة أخرى:",
      numQues: "0135",
      correctAnswer: "يتوقف بجانب الطريق لكي يُمكِن حركة السير من تجاوزه.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "لا يوجد أي شأن لسائق المركبة التي يتم تجاوزها بالمركبة المتجاوزة، ويواصل سيره كالمعتاد. ",
        "يتجه بمركبته على قدر الإمكان إلى حافة الشارع ولا يزيد من سرعته.",
        "يواصل سيره دون تغيير سرعته ومسلك سيره.",
        "يتوقف بجانب الطريق لكي يُمكِن حركة السير من تجاوزه."
      ],
      id: 1807
    },
    {
      category: "إشارات المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0555. هذه الإشارة منصوبة أمامك، كيف تتصرف؟",
      numQues: "0555",
      correctAnswer: "أعطِ حق الأولوية لحركة السير القاطعة طريقك حول الدوار.",
      pubDate: "10-11-2011 08:23:18",
      img: "https://www.gov.il/BlobFolder/generalpage/tq_pic_02/he/TQ_PIC_3552.jpg",
      choices: [
        "مسموح عبور المكان الموسوم (المؤشر) بالإشارة من جهته اليمنى أو اليسرى.",
        "اعبر الإشارة فقط من جهتها اليسرى.",
        "اعبر الإشارة من جهتها اليمنى، يُسمح فقط للمركبات العمومية العبور من الجهة اليسرى للإشارة.",
        "أعطِ حق الأولوية لحركة السير القاطعة طريقك حول الدوار."
      ],
      id: 1808
    },
    {
      category: "قوانين المرور",
      type: [
        "«A»"
      ],
      title: "1587. هل يجوز لسائق الدراجة النارية إيقاف مركبته في محطة باص؟",
      numQues: "1587",
      correctAnswer: "ممنوع وقوف دراجة نارية في حدود ما بين 12م قبل المحطة و 15م بعدها.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "نعم، إذا أوقف الدراجة النارية على الرصيف.",
        "نعم، إذا أوقف الدراجة النارية بموازاة الرصيف.",
        "ممنوع وقوف دراجة نارية في حدود محطة باص موسومة (مؤشرة).",
        "ممنوع وقوف دراجة نارية في حدود ما بين 12م قبل المحطة و 15م بعدها."
      ],
      id: 1809
    },
    {
      category: "قوانين المرور",
      type: [
        "«B»",
        "«1»",
        "«A»",
        "«C»",
        "«C1»",
        "«D»"
      ],
      title: "0060. هل يجب إطاعة أوامر وإشارات شرطي في لباسه الرسمي؟",
      numQues: "0060",
      correctAnswer: "نعم، في توجيه حركة السير فقط.",
      pubDate: "10-11-2011 08:23:18",
      img: "",
      choices: [
        "نعم، في كل الحالات مع اتخاذ وسائل الحذر الشديد.",
        "كلا، فقط أوامر شرطي مرور.",
        "كلا، فقط إذا كان الشرطي بمهمة.",
        "نعم، في توجيه حركة السير فقط."
      ],
      id: 1810
    }
  ]
  export default dbar;
